import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DoctorMSDateTime: { input: any; output: any; }
  DoctorMSJSON: { input: any; output: any; }
  DoctorMSJSONObject: { input: any; output: any; }
  EdmDateTime: { input: any; output: any; }
  PatientMSDateTime: { input: any; output: any; }
  PatientMSJSON: { input: any; output: any; }
  PatientMSJSONObject: { input: any; output: any; }
  SaleorDate: { input: any; output: any; }
  SaleorDateTime: { input: any; output: any; }
  SaleorDecimal: { input: any; output: any; }
  SaleorGenericScalar: { input: any; output: any; }
  SaleorJSON: { input: any; output: any; }
  SaleorJSONString: { input: any; output: any; }
  SaleorMetadata: { input: any; output: any; }
  SaleorMinute: { input: any; output: any; }
  SaleorPositiveDecimal: { input: any; output: any; }
  SaleorUUID: { input: any; output: any; }
  SaleorUpload: { input: any; output: any; }
  SaleorWeightScalar: { input: any; output: any; }
  Saleor_Any: { input: any; output: any; }
  StrapiArticleBlocksDynamicZoneInput: { input: any; output: any; }
  StrapiDateTime: { input: any; output: any; }
  StrapiFaqItemsSetFaqSetDynamicZoneInput: { input: any; output: any; }
  StrapiFaqPagesNewFaqDynamicZoneInput: { input: any; output: any; }
  StrapiI18NLocaleCode: { input: any; output: any; }
  StrapiJSON: { input: any; output: any; }
  StrapiLandingBlocksDynamicZoneInput: { input: any; output: any; }
  StrapiMobileArticleBlocksDynamicZoneInput: { input: any; output: any; }
  StrapiServiceItemsSetServiceSetDynamicZoneInput: { input: any; output: any; }
  StrapiServicePageServiceSetDynamicZoneInput: { input: any; output: any; }
  StrapiUpload: { input: any; output: any; }
};

export type DoctorMSAcademicalTestimonialInput = {
  sickLeaveEnd: Scalars['DoctorMSDateTime']['input'];
  sickLeaveStart: Scalars['DoctorMSDateTime']['input'];
  testimonialGoal: Scalars['String']['input'];
};

export type DoctorMSActiveSubstance = {
  __typename?: 'DoctorMSActiveSubstance';
  activeSubstanceDose?: Maybe<Scalars['Int']['output']>;
  activeSubstanceDoseInWords?: Maybe<Array<Scalars['String']['output']>>;
  activeSubstanceDoseUnit?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSActiveSubstanceOfDrug = {
  __typename?: 'DoctorMSActiveSubstanceOfDrug';
  amountPerItem?: Maybe<Scalars['String']['output']>;
  amountPerPackage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  substanceId?: Maybe<Scalars['String']['output']>;
  unitCode?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSAdditionalRefundRight =
  | 'AZ'
  | 'BW'
  | 'C'
  | 'CN'
  | 'DN'
  | 'DZ'
  | 'IB'
  | 'IN'
  | 'IW'
  | 'PO'
  | 'S'
  | 'WP'
  | 'ZK';

export type DoctorMSAddress = {
  __typename?: 'DoctorMSAddress';
  apiDump?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<DoctorMSLocation>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type DoctorMSAnalysis = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSAnalysis';
  analysisType: Scalars['String']['output'];
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  params: Array<DoctorMSBloodParam>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSAnalyticsData = {
  __typename?: 'DoctorMSAnalyticsData';
  data: Scalars['DoctorMSJSON']['output'];
  source: DoctorMSRegistrationSource;
};

export type DoctorMSAnotherPaymentMethodInfo = {
  __typename?: 'DoctorMSAnotherPaymentMethodInfo';
  comment: Scalars['String']['output'];
};

export type DoctorMSAnotherPaymentMethodInfoInput = {
  comment: Scalars['String']['input'];
};

export type DoctorMSAnswer = {
  __typename?: 'DoctorMSAnswer';
  choice_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  initial: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type DoctorMSAppointmentStatus =
  | 'CONFIRMED'
  | 'EMPTY'
  | 'INDETERMINATE';

export type DoctorMSAssignment = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSAssignment';
  assignmentType: Scalars['String']['output'];
  createdAt: DoctorMSTime;
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  maker: DoctorMSDoctor;
  makerId?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<DoctorMSTime>;
  positions?: Maybe<Array<Maybe<DoctorMSPosition>>>;
  signatureFile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DoctorMSAssignmentStatus>;
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
  vitals: Array<DoctorMSVitalEntity>;
};

export type DoctorMSAssignmentEntity = {
  __typename?: 'DoctorMSAssignmentEntity';
  color?: Maybe<Scalars['String']['output']>;
  entrustedBudgetPriceInDecimal?: Maybe<Scalars['Float']['output']>;
  faqType: DoctorMSAssignmentFaqType;
  foreignServiceId: Scalars['String']['output'];
  icd9?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  jednCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nfzPossible: Scalars['Boolean']['output'];
  nfzPossibleForNurse: Scalars['Boolean']['output'];
  saleorProductId: Scalars['String']['output'];
  type: DoctorMSAssignmentType;
};

export type DoctorMSAssignmentFaqType =
  | 'BLOOD'
  | 'DAILY_URINE_COLLECTION'
  | 'NONE'
  | 'OGTT'
  | 'STOOL'
  | 'URINE_GENERAL'
  | 'URINE_MICROBIOLOGY';

export type DoctorMSAssignmentStatus =
  | 'DONE'
  | 'IN_PROGRESS'
  | 'NOT_DONE'
  | 'RESULTS';

export type DoctorMSAssignmentType =
  | 'IMAGE'
  | 'IMMUNIZATION'
  | 'LABORATORY'
  | 'OTHER'
  | 'QUICKTEST';

export type DoctorMSBankTransferPaymentInfo = {
  __typename?: 'DoctorMSBankTransferPaymentInfo';
  moneyTransferProofFiles: Array<Scalars['String']['output']>;
};

export type DoctorMSBankTransferPaymentInfoInput = {
  moneyTransferProofFiles: Array<Scalars['String']['input']>;
};

export type DoctorMSBaseMessage = {
  createdAt: DoctorMSTime;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  visitId: Scalars['String']['output'];
};

export type DoctorMSBaseUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  consultantInfo: Scalars['DoctorMSJSON']['output'];
  createdAt: DoctorMSTime;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  id: Scalars['String']['output'];
  lastLogin: DoctorMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: DoctorMSRealNFZStatusType;
  updatedAt: DoctorMSTime;
};

export type DoctorMSBaseVital = {
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visitId: Scalars['String']['output'];
};

export type DoctorMSBecikoweTestimonialInput = {
  dateOfFirstTrimesterVisit: Scalars['DoctorMSDateTime']['input'];
  dateOfSecondTrimesterVisit: Scalars['DoctorMSDateTime']['input'];
  dateOfThirdTrimesterVisit: Scalars['DoctorMSDateTime']['input'];
  weeksUnderMedicalCare: Scalars['Float']['input'];
};

export type DoctorMSBloodParam = {
  __typename?: 'DoctorMSBloodParam';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSCareLeaveInput = {
  address: DoctorMSStayAddressInput;
  careSince?: InputMaybe<Scalars['String']['input']>;
  careUntil?: InputMaybe<Scalars['String']['input']>;
  guardian: DoctorMSConnectionInput;
  icd10Main: DoctorMSICD10Input;
  insuredIn?: InputMaybe<DoctorMSStateInsurance>;
  payers: Array<DoctorMSPayerInputNew>;
  reason?: InputMaybe<Scalars['String']['input']>;
  visitId: Scalars['String']['input'];
};

export type DoctorMSCareleave = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSCareleave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<DoctorMSCodes>;
  createdAt: DoctorMSTime;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  icd10Main: DoctorMSICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<DoctorMSLeaveDetails>>;
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<DoctorMSPayer>;
  payers?: Maybe<Array<DoctorMSPayer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  underCarePerson?: Maybe<DoctorMSUnderCarePerson>;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
};

export type DoctorMSChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type DoctorMSChatMessageCreatedEvent = {
  __typename?: 'DoctorMSChatMessageCreatedEvent';
  message: DoctorMSChatMessageEntity;
};

export type DoctorMSChatMessageDeletedEvent = {
  __typename?: 'DoctorMSChatMessageDeletedEvent';
  message: DoctorMSChatMessageEntity;
};

export type DoctorMSChatMessageEntity = {
  __typename?: 'DoctorMSChatMessageEntity';
  assignment?: Maybe<DoctorMSAssignment>;
  author?: Maybe<DoctorMSUser>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorType: Scalars['String']['output'];
  careleave?: Maybe<DoctorMSCareleave>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DoctorMSDateTime']['output'];
  deletedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  id: Scalars['String']['output'];
  leave?: Maybe<DoctorMSLeave>;
  masterId?: Maybe<Scalars['String']['output']>;
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  prescription?: Maybe<DoctorMSPrescription>;
  referral?: Maybe<DoctorMSReferral>;
  survey?: Maybe<DoctorMSSurveyProposalEntity>;
  testimonial?: Maybe<DoctorMSTestimonial>;
  updatedAt: Scalars['DoctorMSDateTime']['output'];
  visit?: Maybe<DoctorMSVisit>;
};

export type DoctorMSChatMessageInput = {
  content: Scalars['String']['input'];
};

export type DoctorMSChatMessagesUpdateEvent = DoctorMSChatMessageCreatedEvent | DoctorMSChatMessageDeletedEvent | DoctorMSPrescriptionChatMessageDeletedEvent;

export type DoctorMSChecker = {
  __typename?: 'DoctorMSChecker';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type DoctorMSChukBodyMeasurements = {
  __typename?: 'DoctorMSChukBodyMeasurements';
  height?: Maybe<Scalars['Float']['output']>;
  waist?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type DoctorMSChukBodyMeasurementsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  waist?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type DoctorMSChukEducationInput = {
  cholesterol?: InputMaybe<Scalars['Float']['input']>;
  cholesterolHDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolLDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolNonHDL?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  glucose?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  riskScore?: InputMaybe<Scalars['Float']['input']>;
  simpFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  triglycerides?: InputMaybe<Scalars['Float']['input']>;
};

export type DoctorMSChukMeasurementsInput = {
  bodyMeasurements?: InputMaybe<DoctorMSChukBodyMeasurementsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  pressureMeasurements?: InputMaybe<Array<DoctorMSChukPressureMeasurementInput>>;
};

export type DoctorMSChukPressureMeasurement = {
  __typename?: 'DoctorMSChukPressureMeasurement';
  diastolicPressure?: Maybe<Scalars['Float']['output']>;
  pulse?: Maybe<Scalars['Float']['output']>;
  systolicPressure?: Maybe<Scalars['Float']['output']>;
};

export type DoctorMSChukPressureMeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  pulse?: InputMaybe<Scalars['Float']['input']>;
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
};

export type DoctorMSClientAppSettings = {
  __typename?: 'DoctorMSClientAppSettings';
  preferredLocation: Scalars['String']['output'];
};

export type DoctorMSClinic = {
  __typename?: 'DoctorMSClinic';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type DoctorMSClinicDetails = {
  __typename?: 'DoctorMSClinicDetails';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DoctorMSClinicInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  type: Scalars['Int']['input'];
};

export type DoctorMSCodes = {
  __typename?: 'DoctorMSCodes';
  A: Scalars['Boolean']['output'];
  B: Scalars['Boolean']['output'];
  C: Scalars['Boolean']['output'];
  D: Scalars['Boolean']['output'];
  E: Scalars['Boolean']['output'];
};

export type DoctorMSCodesInput = {
  A: Scalars['Boolean']['input'];
  B: Scalars['Boolean']['input'];
  C: Scalars['Boolean']['input'];
  D: Scalars['Boolean']['input'];
  E: Scalars['Boolean']['input'];
};

export type DoctorMSConfirmationType =
  | 'DOCUMENTATION'
  | 'EXAMINATION'
  | 'INTERVIEW';

export type DoctorMSConnectionInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  type?: InputMaybe<DoctorMSUnderCarePersonType>;
};

export type DoctorMSControlVisitInput = {
  examinationName?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<Scalars['String']['input']>;
  time: DoctorMSIpomTimeType;
  timeUnit?: InputMaybe<DoctorMSIpomTimeUnit>;
  timeValue?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSControlVisitIpom = {
  __typename?: 'DoctorMSControlVisitIpom';
  examinationName?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<Scalars['String']['output']>;
  time: DoctorMSIpomTimeType;
  timeUnit?: Maybe<DoctorMSIpomTimeUnit>;
  timeValue?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSCovidExaminationInput = {
  financingSource: DoctorMSFinancingSource;
  notMobilePatient: Scalars['Boolean']['input'];
  visitId: Scalars['String']['input'];
};

export type DoctorMSCreateDocumentInput = {
  createdAt: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  source: DoctorMSMedicalDocumentSource;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSCreateIPOMWithOperationResult = {
  __typename?: 'DoctorMSCreateIPOMWithOperationResult';
  ipomCode: Scalars['String']['output'];
};

export type DoctorMSCreateIpomInput = {
  details: DoctorMSIPOMDetailsInput;
  visitId: Scalars['String']['input'];
};

export type DoctorMSCreateProcedureInput = {
  createdOnVisitId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  type: DoctorMSProcedureType;
};

export type DoctorMSCt = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSCt';
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSCustomerComplaintPaymentInfo = {
  __typename?: 'DoctorMSCustomerComplaintPaymentInfo';
  comment: Scalars['String']['output'];
};

export type DoctorMSCustomerComplaintPaymentInfoInput = {
  comment: Scalars['String']['input'];
};

export type DoctorMSDeclaration = {
  __typename?: 'DoctorMSDeclaration';
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  genre?: Maybe<DoctorMSDeclarationGenre>;
  npwz?: Maybe<Scalars['String']['output']>;
  patientData?: Maybe<DoctorMSPatientData>;
  type?: Maybe<DoctorMSDeclarationType>;
};

export type DoctorMSDeclarationAcceptedEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSDeclarationAcceptedEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSDeclarationGenerationParams = {
  __typename?: 'DoctorMSDeclarationGenerationParams';
  anotherProviderReason?: Maybe<Scalars['String']['output']>;
  frequentFacilityChangeReason?: Maybe<DoctorMSFrequentFacilityChangeReason>;
};

export type DoctorMSDeclarationGenre =
  | 'DOCTOR'
  | 'NURSE';

export type DoctorMSDeclarationMarketingSource =
  | 'APP'
  | 'EMPTY'
  | 'EPUAP'
  | 'IKP'
  | 'PAPERFIRSTVISIT'
  | 'PAPERORGANIC'
  | 'PAPERSPECIAL';

export type DoctorMSDeclarationNoLongerValidEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSDeclarationNoLongerValidEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  reason: DoctorMSDeclarationNoLongerValidReason;
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSDeclarationNoLongerValidReason = DoctorMSFacilityChangeEvent | DoctorMSIncorrectDeclarationEvent | DoctorMSPatientDiedEvent;

export type DoctorMSDeclarationRejectedEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSDeclarationRejectedEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  exactRejectionReason: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  rejectionReason: DoctorMSDeclarationRejectionReason;
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSDeclarationRejectionReason =
  | 'NOT_INSURED';

export type DoctorMSDeclarationSource =
  | 'APP'
  | 'EPUAP'
  | 'IKP'
  | 'PAPER';

export type DoctorMSDeclarationSubmittedEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSDeclarationSubmittedEvent';
  comment: Scalars['String']['output'];
  createdAt: Scalars['DoctorMSDateTime']['output'];
  date: Scalars['DoctorMSDateTime']['output'];
  declarationGenerationParams: DoctorMSDeclarationGenerationParams;
  declarationUploadStaff?: Maybe<DoctorMSDoctor>;
  declarationUploadedBy?: Maybe<Scalars['String']['output']>;
  doctor: DoctorMSDoctor;
  filename: Scalars['String']['output'];
  files: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isElectronicallySigned: Scalars['Boolean']['output'];
  marketingSource: DoctorMSDeclarationMarketingSource;
  signature: Scalars['String']['output'];
  source: DoctorMSDeclarationSource;
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSDeclarationType =
  | 'APP'
  | 'EPUAP'
  | 'IKP'
  | 'PAPER';

export type DoctorMSDiag = {
  __typename?: 'DoctorMSDiag';
  commission?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isAvailableAsNFZ: Scalars['Boolean']['output'];
  isAvailableAsNFZForNurse: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgIds?: Maybe<Array<Scalars['String']['output']>>;
  price: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSDiagOrPacket = DoctorMSDiag | DoctorMSDiagPacket;

export type DoctorMSDiagPacket = {
  __typename?: 'DoctorMSDiagPacket';
  items: Array<DoctorMSDiag>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type DoctorMSDiagnosis = {
  __typename?: 'DoctorMSDiagnosis';
  code?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<DoctorMSDiagnosisGrade>;
};

export type DoctorMSDiagnosisGrade =
  | 'MAIN'
  | 'SUPPLEMENTARY';

export type DoctorMSDiagnosisInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<DoctorMSDiagnosisGrade>;
};

export type DoctorMSDietInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DoctorMSDietIpom = {
  __typename?: 'DoctorMSDietIpom';
  date?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DoctorMSDoctor = DoctorMSBaseUser & DoctorMSGlobal & {
  __typename?: 'DoctorMSDoctor';
  about?: Maybe<Scalars['String']['output']>;
  adultDeclarable: Scalars['Boolean']['output'];
  adultsAvailable?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  childrenAvailable?: Maybe<Scalars['Boolean']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  consultantInfo: Scalars['DoctorMSJSON']['output'];
  createdAt: DoctorMSTime;
  declaringToOrganizationId?: Maybe<Scalars['String']['output']>;
  ekgCertification: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  intercomUserHash: Scalars['String']['output'];
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastLogin: DoctorMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['DoctorMSJSON']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: DoctorMSRealNFZStatusType;
  referralCommissionSum: Scalars['Float']['output'];
  seenPosts: Array<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<DoctorMSSnippetEntity>>;
  terms?: Maybe<Array<DoctorMSTerm>>;
  updatedAt: DoctorMSTime;
};

export type DoctorMSDoctorAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSDoctorInput = {
  hiddenSnippets?: InputMaybe<Array<Scalars['String']['input']>>;
  medicalPushToken?: InputMaybe<Scalars['DoctorMSJSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  zusCert?: InputMaybe<Scalars['String']['input']>;
  zusPass?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSDoctorInterval = {
  __typename?: 'DoctorMSDoctorInterval';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type DoctorMSDoctorWithSecrets = DoctorMSBaseUser & DoctorMSGlobal & {
  __typename?: 'DoctorMSDoctorWithSecrets';
  about?: Maybe<Scalars['String']['output']>;
  adultDeclarable: Scalars['Boolean']['output'];
  adultsAvailable?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  childrenAvailable?: Maybe<Scalars['Boolean']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  consultantInfo: Scalars['DoctorMSJSON']['output'];
  createdAt: DoctorMSTime;
  declaringToOrganizationId?: Maybe<Scalars['String']['output']>;
  ekgCertification: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  intercomUserHash: Scalars['String']['output'];
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastLogin: DoctorMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['DoctorMSJSON']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: DoctorMSRealNFZStatusType;
  referralCommissionSum: Scalars['Float']['output'];
  seenPosts: Array<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  sipNumberRecording?: Maybe<Scalars['String']['output']>;
  sipUserId?: Maybe<Scalars['String']['output']>;
  sipUserIdRecording?: Maybe<Scalars['String']['output']>;
  sipUserPassword?: Maybe<Scalars['String']['output']>;
  sipUserPasswordRecording?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<DoctorMSSnippetEntity>>;
  terms?: Maybe<Array<DoctorMSTerm>>;
  updatedAt: DoctorMSTime;
};

export type DoctorMSDocumentGenerationResult = {
  __typename?: 'DoctorMSDocumentGenerationResult';
  documentId: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type DoctorMSDosagePeriod = {
  days: Scalars['Int']['input'];
  dosage: Array<Scalars['String']['input']>;
};

export type DoctorMSDrug = {
  __typename?: 'DoctorMSDrug';
  activeSubstances?: Maybe<Array<Maybe<DoctorMSActiveSubstance>>>;
  additionalPermission?: Maybe<Scalars['String']['output']>;
  boxAmount?: Maybe<Scalars['Int']['output']>;
  cost: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  drug: Scalars['String']['output'];
  drugAmount?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hourInterval?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  morePatientInfo?: Maybe<Scalars['String']['output']>;
  morePharmacistInfo?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  psychoSubstances?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use package field */
  quantity?: Maybe<Scalars['String']['output']>;
  quantityDescription?: Maybe<Scalars['String']['output']>;
  recipeId?: Maybe<Scalars['Int']['output']>;
};

export type DoctorMSDrugDetails = {
  __typename?: 'DoctorMSDrugDetails';
  activeSubstances: Array<DoctorMSActiveSubstanceOfDrug>;
  additionalRefunds: Array<DoctorMSAdditionalRefundRight>;
  box: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Boolean']['output']>;
  contraindications?: Maybe<Scalars['String']['output']>;
  dosage: Scalars['String']['output'];
  dosageDescription?: Maybe<Scalars['String']['output']>;
  drugStatus?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  effect?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hasPsychoSubstances: Scalars['Boolean']['output'];
  indications?: Maybe<Scalars['String']['output']>;
  interactions?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isWithdrawed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentLevels: Array<DoctorMSPaymentDetails>;
  precautions?: Maybe<Scalars['String']['output']>;
  pregnacyDetails: DoctorMSPregnacyDetails;
  pregnantWomenInstructions?: Maybe<Scalars['String']['output']>;
  productCharacteristics?: Maybe<Scalars['String']['output']>;
  selfAdministration?: Maybe<Scalars['Boolean']['output']>;
  use?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSDrugMaterial = {
  __typename?: 'DoctorMSDrugMaterial';
  dose: Scalars['String']['output'];
  doseInfo: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sort: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type DoctorMSDrugRecipe = {
  __typename?: 'DoctorMSDrugRecipe';
  description: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  form: Scalars['String']['output'];
  formDescription: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  materials: Array<DoctorMSDrugMaterial>;
  name: Scalars['String']['output'];
  quantityDescription: Scalars['String']['output'];
};

export type DoctorMSDrugWithPackageInput = {
  box: Scalars['String']['input'];
  boxAmount: Scalars['Int']['input'];
  dose: Scalars['String']['input'];
  dosingPeriod?: InputMaybe<Scalars['Int']['input']>;
  ean: Scalars['String']['input'];
  enableSelfOrdinationForMonths?: InputMaybe<Scalars['Float']['input']>;
  form: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payment: Scalars['String']['input'];
  periods?: InputMaybe<Array<DoctorMSDosagePeriod>>;
  psychoSubstances: Scalars['Boolean']['input'];
};

export type DoctorMSDynamicPositionData = {
  __typename?: 'DoctorMSDynamicPositionData';
  color: Scalars['String']['output'];
  material: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSEcommerce = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSEcommerce';
  createdAt: DoctorMSTime;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<DoctorMSTime>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSEkg = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSEkg';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSEkgResults = {
  __typename?: 'DoctorMSEkgResults';
  date: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type DoctorMSEmployeeBenefitPaymentMethodInfo = {
  __typename?: 'DoctorMSEmployeeBenefitPaymentMethodInfo';
  benefit: Scalars['String']['output'];
};

export type DoctorMSEmployeeBenefitPaymentMethodInfoInput = {
  benefit: Scalars['String']['input'];
};

export type DoctorMSEwusCheck = {
  __typename?: 'DoctorMSEwusCheck';
  checker?: Maybe<DoctorMSChecker>;
  date: Scalars['String']['output'];
  status: DoctorMSEwusCheckStatus;
};

export type DoctorMSEwusCheckEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSEwusCheckEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  event: DoctorMSEwusEvent;
  id: Scalars['String']['output'];
};

export type DoctorMSEwusCheckStatus =
  | 'INSURED'
  | 'SIGNED_TODAY'
  | 'UNINSURED';

export type DoctorMSEwusCheckWithDate = {
  __typename?: 'DoctorMSEwusCheckWithDate';
  date: Scalars['String']['output'];
  status: DoctorMSNFZEventType;
};

export type DoctorMSEwusEvent = DoctorMSEwusGreenEvent | DoctorMSEwusRedEvent;

export type DoctorMSEwusGreenEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSEwusGreenEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
};

export type DoctorMSEwusRedEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSEwusRedEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
};

export type DoctorMSExactInsuranceStatus = DoctorMSEwusCheckEvent | DoctorMSInsuranceContributionCertificateEvent | DoctorMSPatientInsuranceStatementEvent;

export type DoctorMSExpectedDateOfBirthInput = {
  expectedDateOfBirth: Scalars['DoctorMSDateTime']['input'];
};

export type DoctorMSFacilityChangeEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSFacilityChangeEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  info: DoctorMSFacilityChangeInfo;
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSFacilityChangeInVoivodeshipEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSFacilityChangeInVoivodeshipEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSFacilityChangeInfo = DoctorMSFacilityChangeInVoivodeshipEvent | DoctorMSFacilityChangeOutsideVoivodeshipEvent;

export type DoctorMSFacilityChangeOutsideVoivodeshipEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSFacilityChangeOutsideVoivodeshipEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  insuranceProviderInfo: Scalars['String']['output'];
  insuranceProviderInfoUrl: Scalars['String']['output'];
  nfzComment: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSFaqType =
  | 'BLOOD'
  | 'DRUGPASS'
  | 'EKG'
  | 'MEDICINE'
  | 'OGTT'
  | 'POO'
  | 'RTG'
  | 'SPIRO'
  | 'STANDARD'
  | 'URINE_CULTURE'
  | 'URINE_GENERAL'
  | 'USG'
  | 'VACCINE';

export type DoctorMSFinancingSource =
  | 'NFZ'
  | 'commercial'
  | 'public';

export type DoctorMSForceVisitInput = {
  doctorId: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  plannedStart: Scalars['DoctorMSDateTime']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  slotType: DoctorMSSlotType;
  type?: InputMaybe<DoctorMSVisitType>;
};

export type DoctorMSForceVisitInput2 = {
  doctorId: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  plannedStart: Scalars['DoctorMSDateTime']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  visitType: DoctorMSPShiftVisitType;
};

export type DoctorMSFreeTime = {
  __typename?: 'DoctorMSFreeTime';
  doctor: DoctorMSDoctor;
  doctorLanguages: Array<DoctorMSSupportedLanguage>;
  location: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  place: Scalars['String']['output'];
  slot_id: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type DoctorMSFrequentFacilityChangeReason =
  | 'ANOTHER_FACT'
  | 'ANOTHER_PROVIDER_REASON'
  | 'CHANGE_OF_ADDRESS_OF_RESIDENCE'
  | 'REACHING_ADULTHOOD_WITH_PEDIATRICIAN'
  | 'SERVICE_PROVIDER_CEASING';

export type DoctorMSFullAddress = {
  __typename?: 'DoctorMSFullAddress';
  city: Scalars['String']['output'];
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type DoctorMSGetMedicalLeavesInput = {
  pesel: Scalars['String']['input'];
};

export type DoctorMSGetZusPayersByNIPInput = {
  nip: Scalars['String']['input'];
};

export type DoctorMSGetZusPayersInput = {
  passportCode?: InputMaybe<Scalars['String']['input']>;
  pesel: Scalars['String']['input'];
};

export type DoctorMSGlobal = {
  createdAt: DoctorMSTime;
  updatedAt: DoctorMSTime;
};

export type DoctorMSHeartrate = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSHeartrate';
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSHistory = {
  __typename?: 'DoctorMSHistory';
  change: Scalars['DoctorMSJSON']['output'];
  user: DoctorMSUser;
  userId: Scalars['String']['output'];
  when: DoctorMSTime;
};

export type DoctorMSICD9Input = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSICD9IpomInput = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSICD9Main = {
  __typename?: 'DoctorMSICD9Main';
  icd9: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DoctorMSICD10Input = {
  icd10: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSICD10Main = {
  __typename?: 'DoctorMSICD10Main';
  icd10: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DoctorMSIPOMDetailsInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  controlVisits: Array<DoctorMSControlVisitInput>;
  diet?: InputMaybe<Array<DoctorMSDietInput>>;
  levelStratification: DoctorMSLevelStratification;
  medicines?: InputMaybe<Array<DoctorMSMedicineInput>>;
  nurse?: InputMaybe<Array<DoctorMSNurseInput>>;
  observations: Array<DoctorMSObservationInput>;
  otherAdvice?: InputMaybe<Scalars['String']['input']>;
  scheduledDiagnosticTests?: InputMaybe<Array<DoctorMSScheduledDiagnosticTestInput>>;
  specialistConsultations?: InputMaybe<Array<DoctorMSJmIpomVisitType>>;
  specialistVisits?: InputMaybe<Array<DoctorMSJmIpomVisitType>>;
  summary: Scalars['String']['input'];
};

export type DoctorMSImmuCalendarOutput = {
  __typename?: 'DoctorMSImmuCalendarOutput';
  name: Scalars['String']['output'];
  shouldBeDone: Scalars['Boolean']['output'];
};

export type DoctorMSInabilityToWorkInput = {
  inabilityToWorkSince: Scalars['DoctorMSDateTime']['input'];
  inabilityToWorkUntil: Scalars['DoctorMSDateTime']['input'];
};

export type DoctorMSIncorrectDeclarationEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSIncorrectDeclarationEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSInjection = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSInjection';
  closed: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  drugs: Array<DoctorMSInjectionDrug>;
  id: Scalars['String']['output'];
  injectionType: DoctorMSInjectionType;
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  patientSignatureAgreement: Scalars['String']['output'];
  patientSignatureTransport: Scalars['String']['output'];
  portions: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSInjectionDrug = {
  __typename?: 'DoctorMSInjectionDrug';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

export type DoctorMSInjectionType =
  | 'MEDICINE'
  | 'VACCINE';

export type DoctorMSInsuranceContributionCertificateEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSInsuranceContributionCertificateEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
};

export type DoctorMSInsuranceStatementData = {
  patientStatement?: InputMaybe<DoctorMSPatientInsuranceStatementData>;
  representativeStatement?: InputMaybe<DoctorMSRepresentativeInsuranceStatementData>;
};

export type DoctorMSInsuranceStatementPatientReason =
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type DoctorMSInsuranceStatementRepresentativeReason =
  | 'ART_2_UST_1_PKT_3_LIT_A'
  | 'ART_2_UST_1_PKT_3_LIT_B'
  | 'ART_2_UST_1_PKT_3_LIT_C'
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type DoctorMSInsuranceStatusEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSInsuranceStatusEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  status: DoctorMSExactInsuranceStatus;
};

export type DoctorMSIpom = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSIpom';
  assignmentType: Scalars['String']['output'];
  createdAt: DoctorMSTime;
  data: Scalars['DoctorMSJSON']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
};

export type DoctorMSIpomProcedureAssignmentInput = {
  assignmentType: Scalars['String']['input'];
  data: DoctorMSIpomProcedureDataInput;
  visitId: Scalars['String']['input'];
};

export type DoctorMSIpomProcedureDataInput = {
  cito: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
  icd9: DoctorMSICD9IpomInput;
};

/** Typ czasu IPOM */
export type DoctorMSIpomTimeType =
  /** Badanie ma być wykonane w określonym czasie po wizycie */
  | 'CZASPOWIZ'
  /** Badanie ma być przeprowadzone w określonym czasie przed wizytą */
  | 'CZASPRZEDWIZ'
  /** Działanie powinno być zakończone do określonej daty */
  | 'DOCZASU'
  /** Okresowe wykonywanie czynności */
  | 'INTERWAL'
  /** Wykonanie w możliwie najszybszym czasie */
  | 'NAJSZYB'
  /** Wykonanie w określonym czasie po zakończeniu terapii lub zdarzeniu */
  | 'POOKRCZASIE'
  /** Wykonanie po zakończeniu leczenia lub wynikach innych badań */
  | 'POWYKZLECZADAN'
  /** Badanie należy wykonać przed zaplanowaną wizytą */
  | 'PRZEDNASTWIZ';

/** Jednostka czasu IPOM */
export type DoctorMSIpomTimeUnit =
  /** Dni */
  | 'DAYS'
  /** Miesiące */
  | 'MONTHS'
  /** Tygodnie */
  | 'WEEKS'
  /** Lata */
  | 'YEARS';

export type DoctorMSIssueMedicalOrCareLeaveResult = {
  __typename?: 'DoctorMSIssueMedicalOrCareLeaveResult';
  leaves: Array<DoctorMSLeavesResult>;
  messageId: Scalars['String']['output'];
};

export type DoctorMSIssuePrescriptionInput = {
  additionalRefundRight?: InputMaybe<DoctorMSAdditionalRefundRight>;
  drugs: Array<DoctorMSDrugWithPackageInput>;
  insuredIn: DoctorMSStateInsurance;
  useSince: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type DoctorMSIssuePrescriptionWithOperationResult = {
  __typename?: 'DoctorMSIssuePrescriptionWithOperationResult';
  operationIsSafe: Scalars['Boolean']['output'];
  prescriptions: Array<DoctorMSPrescriptionResult>;
};

export type DoctorMSIssueReferralInput = {
  adviceGoal?: InputMaybe<Scalars['String']['input']>;
  clinic: DoctorMSClinicInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  examinationType?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<DoctorMSICD9Input>;
  icd10: DoctorMSICD10Input;
  insuredIn?: InputMaybe<DoctorMSStateInsurance>;
  nfzDepartment?: InputMaybe<DoctorMSNfzDepartmentInput>;
  referralType: Scalars['String']['input'];
  urgent: Scalars['Boolean']['input'];
  visitId: Scalars['String']['input'];
};

/** Rodzaje wizyt IPOM */
export type DoctorMSJmIpomVisitType =
  | 'ALERGOLOG'
  | 'DIABETOLOG'
  | 'ENDOKRYNOLOG'
  | 'KARDIOLOG'
  | 'NEFROLOG'
  | 'PULMONOLOG';

export type DoctorMSKeyValue = {
  __typename?: 'DoctorMSKeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSLabExamEcommerceSource = {
  __typename?: 'DoctorMSLabExamEcommerceSource';
  orderId: Scalars['String']['output'];
  packetInfo?: Maybe<DoctorMSLabExamPacketInfo>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSLabExamInput = {
  params: Array<DoctorMSVitalParamInput>;
  serviceId: Scalars['String']['input'];
};

export type DoctorMSLabExamPacketInfo = {
  __typename?: 'DoctorMSLabExamPacketInfo';
  discount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type DoctorMSLabExamSource =
  | 'ECOMMERCE'
  | 'PATHWAYS';

export type DoctorMSLabExamSourceInfo = {
  __typename?: 'DoctorMSLabExamSourceInfo';
  ecommerce?: Maybe<DoctorMSLabExamEcommerceSource>;
  pathwayRun?: Maybe<DoctorMSPathwayRun>;
  source: DoctorMSLabExamSource;
};

export type DoctorMSLabExamTemplate = {
  __typename?: 'DoctorMSLabExamTemplate';
  assignment: DoctorMSAssignmentEntity;
  params?: Maybe<Array<DoctorMSVitalParam>>;
};

export type DoctorMSLabExaminationPayment =
  | 'FREE'
  | 'PAID'
  | 'UNPAID';

export type DoctorMSLaboratoryExaminationCreationInput = {
  cito: Scalars['Boolean']['input'];
  createdOnVisitId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  payment: DoctorMSLabExaminationPayment;
  serviceId: Scalars['String']['input'];
};

export type DoctorMSLaboratoryExaminationEntity = {
  __typename?: 'DoctorMSLaboratoryExaminationEntity';
  assignment: Scalars['DoctorMSJSON']['output'];
  cancelled: Scalars['Boolean']['output'];
  cito: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DoctorMSDateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: DoctorMSUser;
  diag: DoctorMSAssignmentEntity;
  diagIdPosition: Scalars['Float']['output'];
  displayPayment: Scalars['String']['output'];
  executionLimit: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  paidFromEntrustedBudget: Scalars['Boolean']['output'];
  patient: DoctorMSUserEntity;
  patientId: Scalars['String']['output'];
  payment: DoctorMSLabExaminationPayment;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentLog?: Maybe<DoctorMSPaymentLogEntity>;
  paymentLogId?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  sourceInfo?: Maybe<DoctorMSLabExamSourceInfo>;
  stripeSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DoctorMSDateTime']['output'];
  visit?: Maybe<DoctorMSVisit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSLaboratoryExaminationUpdateDataInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<DoctorMSLabExaminationPayment>;
  sampleId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSLastDayOfWorkInput = {
  lastDayOfWork: Scalars['DoctorMSDateTime']['input'];
};

export type DoctorMSLeave = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSLeave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<DoctorMSCodes>;
  createdAt: DoctorMSTime;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  icd10Main: DoctorMSICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<DoctorMSLeaveDetails>>;
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<DoctorMSPayer>;
  payers?: Maybe<Array<DoctorMSPayer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  underCarePerson?: Maybe<DoctorMSUnderCarePerson>;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
};

export type DoctorMSLeaveAddress = {
  __typename?: 'DoctorMSLeaveAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type DoctorMSLeaveDetails = {
  __typename?: 'DoctorMSLeaveDetails';
  address?: Maybe<DoctorMSLeaveAddress>;
  guardian?: Maybe<DoctorMSLeaveGuardian>;
  ids: Array<Scalars['String']['output']>;
  seriesNumber: Scalars['String']['output'];
  upo: Array<Scalars['String']['output']>;
};

export type DoctorMSLeaveGuardian = {
  __typename?: 'DoctorMSLeaveGuardian';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
};

export type DoctorMSLeavesResult = {
  __typename?: 'DoctorMSLeavesResult';
  ids: Array<Scalars['String']['output']>;
  seriesNumber: Scalars['String']['output'];
  upo: Scalars['String']['output'];
};

/** Poziom stratyfikacji */
export type DoctorMSLevelStratification =
  /** Pośredni */
  | 'P'
  /** Stabilny */
  | 'S'
  /** Zagrozony niestabilnością */
  | 'Z';

export type DoctorMSLlmChatMessage = {
  __typename?: 'DoctorMSLlmChatMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type DoctorMSLocation = {
  __typename?: 'DoctorMSLocation';
  latitude: Scalars['Float']['output'];
  longtitude: Scalars['Float']['output'];
};

export type DoctorMSMeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSMedicalActInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  glycemia?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSMedicalDocumentSource =
  | 'CHAT'
  | 'CHAT_LLM'
  | 'DRIVE'
  | 'EKG'
  | 'EMAIL';

export type DoctorMSMedicalLeaveDetails = {
  __typename?: 'DoctorMSMedicalLeaveDetails';
  careSince: Scalars['String']['output'];
  careUntil: Scalars['String']['output'];
  code: Scalars['String']['output'];
  doNotSendPayerInfo: Scalars['Boolean']['output'];
  icd10: DoctorMSICD10Main;
  inabilitySince: Scalars['String']['output'];
  inabilityUntil: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
};

export type DoctorMSMedicalLeaveInput = {
  address: DoctorMSStayAddressInput;
  codes: DoctorMSCodesInput;
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  icd10Main: DoctorMSICD10Input;
  inabilitySince: Scalars['String']['input'];
  inabilityUntil: Scalars['String']['input'];
  insuredIn?: InputMaybe<DoctorMSStateInsurance>;
  leaveType: Scalars['String']['input'];
  outdatedReason?: InputMaybe<Scalars['String']['input']>;
  payers: Array<DoctorMSPayerInput>;
  recommendation: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type DoctorMSMedicalLeaveInputNew = {
  address: DoctorMSStayAddressInput;
  codes: DoctorMSCodesInput;
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  icd10Main: DoctorMSICD10Input;
  inabilitySince: Scalars['String']['input'];
  inabilityUntil: Scalars['String']['input'];
  insuredIn?: InputMaybe<DoctorMSStateInsurance>;
  leaveType: Scalars['String']['input'];
  outdatedReason?: InputMaybe<Scalars['String']['input']>;
  payers: Array<DoctorMSPayerInputNew>;
  recommendation: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type DoctorMSMedicalRecordEntity = {
  __typename?: 'DoctorMSMedicalRecordEntity';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DoctorMSDateTime']['output'];
  fileId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  source: DoctorMSMedicalDocumentSource;
  starred: Scalars['Boolean']['output'];
  tagId?: Maybe<Scalars['String']['output']>;
  tidyDocumentationResult?: Maybe<DoctorMSTidyDocumentationResultEntity>;
  tidy_status?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSMedicalServices = {
  __typename?: 'DoctorMSMedicalServices';
  primaryMedicalService?: Maybe<DoctorMSPrimaryMedicalService>;
};

export type DoctorMSMedicalTestimonialInput = {
  attachDiagnosisToTestimonial: Scalars['Boolean']['input'];
  diagnosisICD10?: InputMaybe<Scalars['String']['input']>;
  testimonialGoal: Scalars['String']['input'];
};

export type DoctorMSMedicineInput = {
  dosage: Scalars['String']['input'];
  dose?: InputMaybe<Scalars['String']['input']>;
  ean: Scalars['String']['input'];
  form?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSMedicineIpom = {
  __typename?: 'DoctorMSMedicineIpom';
  dosage: Scalars['String']['output'];
  dose?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  form?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSMedicineSubtitle = {
  __typename?: 'DoctorMSMedicineSubtitle';
  subtitle: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSMessage = DoctorMSAssignment | DoctorMSCareleave | DoctorMSIpom | DoctorMSLeave | DoctorMSPrescription | DoctorMSReferral | DoctorMSTestimonial;

export type DoctorMSMessageType =
  | 'ASSIGNMENT'
  | 'CARELEAVE'
  | 'IPOM'
  | 'LEAVE'
  | 'PRESCRIPTION'
  | 'REFERRAL'
  | 'TESTIMONIAL';

export type DoctorMSMidwifeEducationalVisit = {
  pregnacyWeek?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  visitTopics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DoctorMSNFZEventData = {
  insuranceStatement?: InputMaybe<DoctorMSInsuranceStatementData>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSNFZEventEntity = {
  __typename?: 'DoctorMSNFZEventEntity';
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  employee?: Maybe<DoctorMSStaffEntity>;
  employeeId?: Maybe<Scalars['String']['output']>;
  executionDate: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  reportingId: Scalars['Int']['output'];
  type: DoctorMSNFZEventType;
};

export type DoctorMSNFZEventInput = {
  data: Scalars['DoctorMSJSON']['input'];
  executionDate: Scalars['DoctorMSDateTime']['input'];
  organizationId: DoctorMSOrganizationIdVojevodship;
  patientId: Scalars['String']['input'];
  type: DoctorMSNFZEventType;
};

export type DoctorMSNFZEventType =
  | 'DEKLARACJA'
  | 'EWUS_CZERWONY'
  | 'EWUS_UA'
  | 'EWUS_ZIELONY'
  | 'NFZ_AKCEPTACJA'
  | 'NFZ_AKCEPTACJA_PIELEGNIARKA'
  | 'NFZ_AKCEPTACJA_POLOZNA'
  | 'NFZ_ODRZUCENIE'
  | 'NFZ_ODRZUCENIE_PIELEGNIARKA'
  | 'NFZ_ODRZUCENIE_POLOZNA'
  | 'OSWIADCZENIE'
  | 'ZASWIADCZENIE_OD_PLATNIKA_SKLADEK';

export type DoctorMSNewVisitInput = {
  patientId: Scalars['String']['input'];
  type?: InputMaybe<DoctorMSVisitType>;
};

export type DoctorMSNfzDeclarationInputDoctor = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  doctorId: Scalars['String']['input'];
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<DoctorMSFrequentFacilityChangeReason>;
  nurseId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
};

export type DoctorMSNfzDeclarationInputPatientMultiple = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<DoctorMSFrequentFacilityChangeReason>;
  generationDate?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type DoctorMSNfzDepartmentInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSNfzEventBase = {
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
};

export type DoctorMSNfzEventWithVojevodship = {
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSNfzHistoryEvent = DoctorMSDeclarationAcceptedEvent | DoctorMSDeclarationNoLongerValidEvent | DoctorMSDeclarationRejectedEvent | DoctorMSDeclarationSubmittedEvent | DoctorMSInsuranceStatusEvent | DoctorMSUnknownEvent;

export type DoctorMSNoShowNotificationAnswer = {
  __typename?: 'DoctorMSNoShowNotificationAnswer';
  value: Scalars['Boolean']['output'];
  when: Scalars['String']['output'];
};

export type DoctorMSNurseAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSNurseInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DoctorMSNurseIpom = {
  __typename?: 'DoctorMSNurseIpom';
  date?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DoctorMSOCRImageInput = {
  bottom: Scalars['Float']['input'];
  imageId: Scalars['String']['input'];
  left: Scalars['Float']['input'];
  right: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export type DoctorMSOL9TestimonialInput = {
  attachments: Array<Scalars['String']['input']>;
  canTravel: Scalars['Boolean']['input'];
  currentTreatment: Scalars['String']['input'];
  mainDiagnosisICD10: Scalars['String']['input'];
  prognosis: Scalars['String']['input'];
  secondaryDiagnosisICD10: Array<Scalars['String']['input']>;
};

export type DoctorMSObjectedNFZStatus = {
  __typename?: 'DoctorMSObjectedNFZStatus';
  availablePublicPrivateShenanigans: Array<Scalars['String']['output']>;
  canDeclare: Scalars['Boolean']['output'];
  canUsePublicVisits: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenMidwife?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  declaredIn?: Maybe<Scalars['String']['output']>;
  ewusLastCheck?: Maybe<DoctorMSEwusCheckWithDate>;
  noInsurance?: Maybe<Scalars['Boolean']['output']>;
  telezgodaAccepted: Scalars['Boolean']['output'];
  textStatus?: Maybe<Scalars['String']['output']>;
  wasDeclared: Scalars['Boolean']['output'];
  whereCanDeclare?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSObservationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DoctorMSObservationIpom = {
  __typename?: 'DoctorMSObservationIpom';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSOpeningHours = {
  __typename?: 'DoctorMSOpeningHours';
  openingType: DoctorMSOpeningType;
  /** Present only if openingType === Hours */
  ranges?: Maybe<Array<DoctorMSRange>>;
  weekday: DoctorMSWeekDay;
};

export type DoctorMSOpeningType =
  | 'Hours'
  | 'OnlineOnly'
  | 'Unavailable';

export type DoctorMSOperation = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSOperation';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materials: Array<DoctorMSOperationMaterial>;
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSOperationMaterial = {
  __typename?: 'DoctorMSOperationMaterial';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSOrdering =
  | 'ASC'
  | 'DESC';

export type DoctorMSOrganizationEntity = {
  __typename?: 'DoctorMSOrganizationEntity';
  active: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  enableNoShowMitigationChance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  p1Data?: Maybe<DoctorMSP1Data>;
  placeData?: Maybe<DoctorMSPlaceData>;
  polmedId?: Maybe<Scalars['String']['output']>;
  polmedOrganization: Scalars['Boolean']['output'];
  umxData?: Maybe<Scalars['DoctorMSJSON']['output']>;
};

export type DoctorMSOrganizationIdVojevodship =
  | 'PATIENT'
  | 'PB'
  | 'PC'
  | 'PD'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PO'
  | 'PP'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PZ';

export type DoctorMSOther = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSOther';
  createdAt: DoctorMSTime;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<DoctorMSTime>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSP1Data = {
  __typename?: 'DoctorMSP1Data';
  agreementNumber: Scalars['String']['output'];
  agreementNumberFull: Scalars['String']['output'];
  chamberId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  flatNumber: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  ksr: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nfz: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  regon: Scalars['String']['output'];
  res5: Scalars['String']['output'];
  res7: Scalars['String']['output'];
  res8: Scalars['String']['output'];
  res8Name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  unitCode: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type DoctorMSP1IpomRecord = {
  __typename?: 'DoctorMSP1IpomRecord';
  author: Scalars['String']['output'];
  ipomCode: Scalars['String']['output'];
  issueDate: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  p1Status: Scalars['String']['output'];
};

export type DoctorMSP1Prescription = {
  __typename?: 'DoctorMSP1Prescription';
  drugAmount?: Maybe<Scalars['String']['output']>;
  drugName?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageSize?: Maybe<Scalars['String']['output']>;
  prescriptionIssueStatus?: Maybe<Scalars['String']['output']>;
  prescriptionKey?: Maybe<Scalars['String']['output']>;
  prescriptionRepaymentLevel?: Maybe<Scalars['String']['output']>;
  prescriptionStatus: DoctorMSPrescriptionStatus;
  realizationDateFrom?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  typeOfDrug?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSP1PrescriptionsReturn = {
  __typename?: 'DoctorMSP1PrescriptionsReturn';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptions: Array<DoctorMSP1Prescription>;
};

export type DoctorMSPShiftVisitType =
  | 'COLLECTION'
  | 'DIETETICS'
  | 'DOCTOR_HOUSE_CALL'
  | 'DOCTOR_TELEMEDICAL_INFECTION'
  | 'EXPRESS_APPOINTMENT'
  | 'HEALTHY_CHILDREN_CHECKUP'
  | 'HEALTHY_CHILDREN_CHECKUP_AND_VACCINE'
  | 'HEALTHY_CHILDREN_PATRONAGE'
  | 'HEALTHY_CHILDREN_VACCINE'
  | 'IN_PERSON'
  | 'MIDWIFE_HOUSE_CALL'
  | 'MIDWIFE_IN_PERSON'
  | 'NURSE_HEALTHY_CHILDREN'
  | 'NURSE_HOUSE_CALL'
  | 'NURSE_IN_PERSON'
  | 'NURSE_IN_PERSON_INFECTION'
  | 'PRESCRIPTION_APPOINTMENT'
  | 'PROCEDURE'
  | 'RADIOLOGY_APPOINTMENT'
  | 'SICK_CHILDREN'
  | 'SPECIALIST'
  | 'TELEMEDICAL';

export type DoctorMSPackage = {
  __typename?: 'DoctorMSPackage';
  box: Scalars['String']['output'];
  continuation: Scalars['Boolean']['output'];
  dosage: Scalars['String']['output'];
  drugStatus?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  form: Scalars['String']['output'];
  name: Scalars['String']['output'];
  selfAdministration: Scalars['Boolean']['output'];
};

export type DoctorMSPacketInput = {
  icd9: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSPacketIpom = {
  __typename?: 'DoctorMSPacketIpom';
  icd9: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DoctorMSPaginatedVisitResponse = {
  __typename?: 'DoctorMSPaginatedVisitResponse';
  currentPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  visits: Array<DoctorMSVisit>;
};

export type DoctorMSPaginatedVisitResult = {
  __typename?: 'DoctorMSPaginatedVisitResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<DoctorMSVisit>;
  total: Scalars['Float']['output'];
};

export type DoctorMSPaginationConfigInput = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type DoctorMSPathwayInfo = {
  __typename?: 'DoctorMSPathwayInfo';
  id: Scalars['String']['output'];
  subtypeId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSPathwayRun = {
  __typename?: 'DoctorMSPathwayRun';
  pathways: Array<DoctorMSPathwayInfo>;
  runDate: Scalars['DoctorMSDateTime']['output'];
  runGroupId: Scalars['String']['output'];
};

export type DoctorMSPatient = DoctorMSBaseUser & DoctorMSGlobal & {
  __typename?: 'DoctorMSPatient';
  actionRequired?: Maybe<Scalars['String']['output']>;
  address?: Maybe<DoctorMSFullAddress>;
  analyticsData: DoctorMSAnalyticsData;
  analyticsId: Scalars['String']['output'];
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<DoctorMSClientAppSettings>;
  consultantInfo: Scalars['DoctorMSJSON']['output'];
  createdAt: DoctorMSTime;
  currentVirtualVisit?: Maybe<DoctorMSVisit>;
  deliveryAddress?: Maybe<DoctorMSAddress>;
  deviceInfo: Scalars['String']['output'];
  documents: Array<DoctorMSMedicalRecordEntity>;
  ekgResults: Array<DoctorMSEkgResults>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheckHistory: Array<DoctorMSEwusCheck>;
  files: Scalars['DoctorMSJSON']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  getUnderCarePersons: Array<DoctorMSUnderCarePerson>;
  guardians: Array<DoctorMSPatient>;
  hasPassword: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  immunizationCardComment?: Maybe<Scalars['String']['output']>;
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Int']['output'];
  ipomCode?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastChatMessage?: Maybe<DoctorMSChatMessageEntity>;
  lastLogin: DoctorMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<DoctorMSTime>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalLeaves: Array<DoctorMSMedicalLeaveDetails>;
  messages: Array<DoctorMSMessage>;
  mobileAppVersion: Scalars['String']['output'];
  nfzData: Scalars['DoctorMSJSON']['output'];
  nfzStatus: DoctorMSObjectedNFZStatus;
  notificationAgreements: Array<DoctorMSUsersNotificationAgreementsEntity>;
  oneTimeSurvey?: Maybe<Scalars['DoctorMSJSON']['output']>;
  oneTimeSurveyUpdatedAt?: Maybe<DoctorMSTime>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pastVisits: DoctorMSPaginatedVisitResult;
  patientCardNumber: Scalars['String']['output'];
  patientPublicSince?: Maybe<DoctorMSTime>;
  payers: Array<DoctorMSPayer>;
  permission: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  realNFZStatus: DoctorMSRealNFZStatusType;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralUsagesCount: Scalars['Int']['output'];
  registrationType: Scalars['DoctorMSJSON']['output'];
  regularSurvey: Scalars['DoctorMSJSON']['output'];
  relation: Scalars['String']['output'];
  remindMe: Scalars['String']['output'];
  representative: Array<Scalars['String']['output']>;
  secretData?: Maybe<DoctorMSSecretData>;
  signature: Scalars['String']['output'];
  smokeLevel?: Maybe<Scalars['Float']['output']>;
  statusUbezpieczenia?: Maybe<Scalars['Int']['output']>;
  stayAddresses: Array<DoctorMSAddress>;
  survey?: Maybe<DoctorMSSurvey>;
  surveys: Array<DoctorMSSurveyProposal>;
  tags: Array<DoctorMSPatientTag>;
  underCarePersons: Array<DoctorMSUnderCarePerson>;
  uniqueIntegerId: Scalars['Int']['output'];
  unread: Scalars['Float']['output'];
  upcomingVisits: DoctorMSPaginatedVisitResult;
  updatedAt: DoctorMSTime;
  updatesToDo: Array<Scalars['String']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  usedReferralReward: Scalars['Boolean']['output'];
  visit?: Maybe<DoctorMSVisit>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  visits: Array<DoctorMSVisit>;
  vital?: Maybe<DoctorMSVitalEntity>;
  vitals: Array<DoctorMSVital>;
  wards: Array<DoctorMSPatient>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type DoctorMSPatientpastVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<DoctorMSPaginationConfigInput>;
};


export type DoctorMSPatientupcomingVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<DoctorMSPaginationConfigInput>;
};


export type DoctorMSPatientvisitArgs = {
  id: Scalars['String']['input'];
};


export type DoctorMSPatientvisitsArgs = {
  orderByCreationDate?: InputMaybe<DoctorMSOrdering>;
  orderByPlannedStart?: InputMaybe<DoctorMSOrdering>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type DoctorMSPatientvitalArgs = {
  id: Scalars['String']['input'];
};


export type DoctorMSPatientvitalsArgs = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSPatientData = {
  __typename?: 'DoctorMSPatientData';
  address?: Maybe<DoctorMSAddress>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSPatientDeclarationHistoryEvent = DoctorMSDeclarationSubmittedEvent | DoctorMSUnknownEvent;

export type DoctorMSPatientDiedEvent = DoctorMSNfzEventWithVojevodship & {
  __typename?: 'DoctorMSPatientDiedEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  vojevodship: DoctorMSOrganizationIdVojevodship;
};

export type DoctorMSPatientInput = {
  address?: InputMaybe<DoctorMSStayAddressInput>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  immunizationCardComment?: InputMaybe<Scalars['String']['input']>;
  immunizationCardStatus?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  payers?: InputMaybe<DoctorMSPayerInput>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secretData?: InputMaybe<DoctorMSSecretDataInput>;
  stayAddresses?: InputMaybe<DoctorMSStayAddressInput>;
};

export type DoctorMSPatientInsuranceInfo = {
  __typename?: 'DoctorMSPatientInsuranceInfo';
  current?: Maybe<DoctorMSPatientInsuranceStatusEvent>;
  latestPositive?: Maybe<DoctorMSPatientInsuranceStatusEvent>;
};

export type DoctorMSPatientInsuranceStatementData = {
  reason: DoctorMSInsuranceStatementPatientReason;
};

export type DoctorMSPatientInsuranceStatementEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSPatientInsuranceStatementEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  representativePatient?: Maybe<DoctorMSPatient>;
};

export type DoctorMSPatientInsuranceStatusEvent = DoctorMSInsuranceStatusEvent | DoctorMSUnknownEvent;

export type DoctorMSPatientIpom = {
  __typename?: 'DoctorMSPatientIpom';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  controlVisits?: Maybe<Array<DoctorMSControlVisitIpom>>;
  date: Scalars['DoctorMSDateTime']['output'];
  diet?: Maybe<Array<DoctorMSDietIpom>>;
  ipomCode: Scalars['String']['output'];
  levelStratification: DoctorMSLevelStratification;
  medicines?: Maybe<Array<DoctorMSMedicineIpom>>;
  nurse?: Maybe<Array<DoctorMSNurseIpom>>;
  observations?: Maybe<Array<DoctorMSObservationIpom>>;
  otherAdvice?: Maybe<Scalars['String']['output']>;
  p1Response?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['String']['output'];
  scheduledDiagnosticTests?: Maybe<Array<DoctorMSScheduledDiagnosticTestIpom>>;
  specialistConsultations?: Maybe<Array<DoctorMSJmIpomVisitType>>;
  specialistVisits?: Maybe<Array<DoctorMSJmIpomVisitType>>;
  summary: Scalars['String']['output'];
};

export type DoctorMSPatientTag = {
  __typename?: 'DoctorMSPatientTag';
  confirmationType?: Maybe<DoctorMSConfirmationType>;
  createdAt: DoctorMSTime;
  createdBy?: Maybe<DoctorMSDoctor>;
  data: Scalars['DoctorMSJSON']['output'];
  expirationAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  history?: Maybe<Array<DoctorMSHistory>>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: DoctorMSTime;
};

export type DoctorMSPatientTagEntity = {
  __typename?: 'DoctorMSPatientTagEntity';
  confirmationType?: Maybe<DoctorMSConfirmationType>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<DoctorMSDoctor>;
  data: Scalars['DoctorMSJSON']['output'];
  expirationAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  history?: Maybe<Scalars['DoctorMSJSON']['output']>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: DoctorMSPatientTagType;
  updatedAt: Scalars['DoctorMSDateTime']['output'];
};

export type DoctorMSPatientTagInput = {
  confirmationType?: InputMaybe<DoctorMSConfirmationType>;
  data: Scalars['DoctorMSJSON']['input'];
  expirationAt?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  patientId: Scalars['String']['input'];
  type: DoctorMSPatientTagType;
};

export type DoctorMSPatientTagType =
  | 'ADDITIONAL'
  | 'ALLERGY'
  | 'CHRONIC_DISEASE'
  | 'EDM_VACCINE'
  | 'HOSPITALIZATION'
  | 'REGULAR_DRUG'
  | 'SPEC_CONSULTATIONS'
  | 'SURGICAL_PROCEDURES'
  | 'VACCINES';

export type DoctorMSPatronageVisitInput = {
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSPayer = {
  __typename?: 'DoctorMSPayer';
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  pueProfile: Scalars['String']['output'];
};

export type DoctorMSPayerInput = {
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nip: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  pueProfile?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSPayerInputNew = {
  doNotSendPayerInfo?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nip: Scalars['String']['input'];
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  pueProfile?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DoctorMSPaymentDetails = {
  __typename?: 'DoctorMSPaymentDetails';
  description: Scalars['String']['output'];
  detailedDescription: Scalars['String']['output'];
  paymentKey: Scalars['String']['output'];
  price: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSPaymentLogEntity = {
  __typename?: 'DoctorMSPaymentLogEntity';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  creator: DoctorMSDoctor;
  id: Scalars['String']['output'];
  info: DoctorMSPaymentLogEntry;
  updatedAt: Scalars['DoctorMSDateTime']['output'];
};

export type DoctorMSPaymentLogEntry = {
  __typename?: 'DoctorMSPaymentLogEntry';
  anotherPaymentMethod?: Maybe<DoctorMSAnotherPaymentMethodInfo>;
  bankTransferPayment?: Maybe<DoctorMSBankTransferPaymentInfo>;
  customerComplaint?: Maybe<DoctorMSCustomerComplaintPaymentInfo>;
  employeeBenefit?: Maybe<DoctorMSEmployeeBenefitPaymentMethodInfo>;
  posPayment?: Maybe<DoctorMSPosPaymentInfo>;
};

export type DoctorMSPaymentLogEntryInput = {
  anotherPaymentMethod?: InputMaybe<DoctorMSAnotherPaymentMethodInfoInput>;
  bankTransferPayment?: InputMaybe<DoctorMSBankTransferPaymentInfoInput>;
  customerComplaint?: InputMaybe<DoctorMSCustomerComplaintPaymentInfoInput>;
  employeeBenefit?: InputMaybe<DoctorMSEmployeeBenefitPaymentMethodInfoInput>;
  posPayment?: InputMaybe<DoctorMSPosPaymentInfoInput>;
};

export type DoctorMSPersonMinimalDataInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type DoctorMSPlaceData = {
  __typename?: 'DoctorMSPlaceData';
  city: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  isPartnerFacility?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longtitude?: Maybe<Scalars['Float']['output']>;
  openingHoursCollections: Array<DoctorMSOpeningHours>;
  openingHoursProcedures: Array<DoctorMSOpeningHours>;
  openingHoursWhole: Array<DoctorMSOpeningHours>;
  /** If not present -> it's our own place */
  partnerName?: Maybe<Scalars['String']['output']>;
  photos: Array<Scalars['String']['output']>;
  saleorSpecialistFacilityCollectionId?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

export type DoctorMSPlacematicAddress = {
  __typename?: 'DoctorMSPlacematicAddress';
  city: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSPlacematicAddressInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  municipality: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  teryt: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type DoctorMSPlacement =
  | 'NOT_APPLICABLE'
  | 'OFF_SITE'
  | 'ON_SITE';

export type DoctorMSPosPaymentInfo = {
  __typename?: 'DoctorMSPosPaymentInfo';
  paymentNumber: Scalars['String']['output'];
};

export type DoctorMSPosPaymentInfoInput = {
  paymentNumber: Scalars['String']['input'];
};

export type DoctorMSPosition = {
  __typename?: 'DoctorMSPosition';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  isNFZ?: Maybe<Scalars['Boolean']['output']>;
  positionData?: Maybe<DoctorMSDynamicPositionData>;
  price?: Maybe<Scalars['Float']['output']>;
  priceData?: Maybe<DoctorMSPriceData>;
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSPositionInput = {
  isNFZ: Scalars['Boolean']['input'];
  serviceId: Scalars['String']['input'];
};

export type DoctorMSPregnacyDetails = {
  __typename?: 'DoctorMSPregnacyDetails';
  entirePregnacy: DoctorMSKeyValue;
  firstTrimester: DoctorMSKeyValue;
  lactation: DoctorMSKeyValue;
  secondTrimester: DoctorMSKeyValue;
  thirdTrimester: DoctorMSKeyValue;
};

export type DoctorMSPrescription = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSPrescription';
  code: Scalars['String']['output'];
  createdAt: DoctorMSTime;
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  drugs: Array<DoctorMSDrug>;
  endsToWork?: Maybe<DoctorMSTime>;
  id: Scalars['String']['output'];
  insuredIn: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  options?: Maybe<DoctorMSPrescriptionOptions>;
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  prescriptionId?: Maybe<Scalars['String']['output']>;
  resourceCancelationInCezDate?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  resourceIsCompatibleWithCez?: Maybe<Scalars['Boolean']['output']>;
  startsToWork?: Maybe<DoctorMSTime>;
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
  writeup: DoctorMSTime;
};

export type DoctorMSPrescriptionCEZ = {
  __typename?: 'DoctorMSPrescriptionCEZ';
  dataWystawieniaRecepty?: Maybe<Scalars['String']['output']>;
  miejsce: Scalars['String']['output'];
  ourDoctor: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  szczegoly: Array<Scalars['String']['output']>;
  ubezpieczenie: Array<Scalars['String']['output']>;
  wystawil: Scalars['String']['output'];
};

export type DoctorMSPrescriptionCezStag = {
  __typename?: 'DoctorMSPrescriptionCezStag';
  boxAmount: Scalars['Float']['output'];
  cost: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  drug: Scalars['String']['output'];
  form: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  package: Scalars['String']['output'];
  status: DoctorMSPrescriptionStatus;
};

export type DoctorMSPrescriptionChatMessageDeletedEvent = {
  __typename?: 'DoctorMSPrescriptionChatMessageDeletedEvent';
  message: DoctorMSChatMessageEntity;
};

export type DoctorMSPrescriptionInput = {
  assignmentType: Scalars['String']['input'];
  data: Scalars['DoctorMSJSON']['input'];
  positions: Array<DoctorMSPositionInput>;
  visitId: Scalars['String']['input'];
};

export type DoctorMSPrescriptionOptions = {
  __typename?: 'DoctorMSPrescriptionOptions';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dontChange?: Maybe<Scalars['Boolean']['output']>;
  in365days?: Maybe<Scalars['Boolean']['output']>;
};

export type DoctorMSPrescriptionRequestDto = {
  __typename?: 'DoctorMSPrescriptionRequestDto';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  prescriptions: Array<DoctorMSPrescription>;
  recommendations?: Maybe<Scalars['String']['output']>;
  requestedDrugs: Array<DoctorMSRequestedDrugDto>;
  solvedOn?: Maybe<Scalars['DoctorMSDateTime']['output']>;
};

export type DoctorMSPrescriptionResult = {
  __typename?: 'DoctorMSPrescriptionResult';
  messageId: Scalars['String']['output'];
  prescriptionCode: Scalars['String']['output'];
};

export type DoctorMSPrescriptionStatus =
  | 'CANCELED'
  | 'COMPLETED'
  | 'ISSUED'
  | 'PARTIALLY_COMPLETED';

export type DoctorMSPrescriptionsPacketCezStag = {
  __typename?: 'DoctorMSPrescriptionsPacketCezStag';
  insurance: Array<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['String']['output']>;
  issuedBy: Scalars['String']['output'];
  ourDoctor: Scalars['Boolean']['output'];
  place: Scalars['String']['output'];
  prescriptions: Array<DoctorMSPrescriptionCezStag>;
  status: DoctorMSPrescriptionStatus;
};

export type DoctorMSPrescriptionsReturn = {
  __typename?: 'DoctorMSPrescriptionsReturn';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptions: Array<DoctorMSPrescriptionCEZ>;
};

export type DoctorMSPrescriptionsReturnStag = {
  __typename?: 'DoctorMSPrescriptionsReturnStag';
  lastChecked?: Maybe<Scalars['String']['output']>;
  prescriptionsPacket: DoctorMSPrescriptionsPacketCezStag;
};

export type DoctorMSPressure = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSPressure';
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  diastolic: Scalars['Int']['output'];
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  systolic: Scalars['Int']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSPriceData = {
  __typename?: 'DoctorMSPriceData';
  NFZ?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Świadczenia główne */
export type DoctorMSPrimaryMedicalService =
  /** Porada kompleksowa w opiece koordynowanej */
  | 'COMPLEX'
  /** Porada kontrolna w opiece koordynowanej */
  | 'CONTROL'
  /** Bilans zdrowia w wieku 20-59 */
  | 'HEALTH_CHECK_20_59'
  /** Bilans zdrowia w wieku 60+ */
  | 'HEALTH_CHECK_60_PLUS'
  /** Porada edukacyjna - Bilans zdrowia */
  | 'HEALTH_EDUCATION'
  /** Wizyta wstępna w opiece koordynowanej */
  | 'INITIAL'
  /** Porada pacjent-specjalista w dziedzinie alergologii */
  | 'IPOM_ALLERGOLOGY'
  /** Porada pacjent-specjalista w dziedzinie kardiologii */
  | 'IPOM_CARDIOLOGY'
  /** Porada pacjent-specjalista w dziedzinie diabetologii */
  | 'IPOM_DIABETOLOGY'
  /** Konsultacja dietetyczna w Opiece Koordynowanej */
  | 'IPOM_DIET'
  /** Porada edukacyjna - Opieka Koordynowana */
  | 'IPOM_EDUCATION'
  /** Porada pacjent-specjalista w dziedzinie endokrynologii */
  | 'IPOM_ENDOCRINOLOGY'
  /** Porada pacjent-specjalista w dziedzinie nefrologii */
  | 'IPOM_NEPHROLOGY'
  /** Porada pacjent-specjalista w dziedzinie pulmonologii */
  | 'IPOM_PULMONOLOGY'
  /** Brak */
  | 'NONE';

export type DoctorMSProcedureAnswer = {
  __typename?: 'DoctorMSProcedureAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureBandage = {
  __typename?: 'DoctorMSProcedureBandage';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureBandageInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureChukEducation = {
  __typename?: 'DoctorMSProcedureChukEducation';
  cholesterol?: Maybe<Scalars['Float']['output']>;
  cholesterolHDL?: Maybe<Scalars['Float']['output']>;
  cholesterolLDL?: Maybe<Scalars['Float']['output']>;
  cholesterolNonHDL?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  glucose?: Maybe<Scalars['Float']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  simpFiles?: Maybe<Array<Scalars['String']['output']>>;
  triglycerides?: Maybe<Scalars['Float']['output']>;
};

export type DoctorMSProcedureChukMeasurements = {
  __typename?: 'DoctorMSProcedureChukMeasurements';
  bodyMeasurements?: Maybe<DoctorMSChukBodyMeasurements>;
  comment?: Maybe<Scalars['String']['output']>;
  pressureMeasurements?: Maybe<Array<DoctorMSChukPressureMeasurement>>;
};

export type DoctorMSProcedureDataInput = {
  answers?: InputMaybe<Array<DoctorMSProcedureAnswerInput>>;
  bandage?: InputMaybe<Array<DoctorMSProcedureBandageInput>>;
  chukEducation?: InputMaybe<DoctorMSChukEducationInput>;
  chukMeasurements?: InputMaybe<DoctorMSChukMeasurementsInput>;
  disinfectant?: InputMaybe<Array<DoctorMSProcedureDisinfectantInput>>;
  doctorAdvice?: InputMaybe<DoctorMSDoctorAdviceInput>;
  doctorDiagnosis?: InputMaybe<Array<DoctorMSDiagnosisInput>>;
  dressingChange?: InputMaybe<DoctorMSProcedureDressingChangeInput>;
  drug?: InputMaybe<Array<DoctorMSProcedureDrugInput>>;
  education?: InputMaybe<DoctorMSProcedureEducationInput>;
  ekg?: InputMaybe<DoctorMSProcedureEKGInput>;
  file?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignBody?: InputMaybe<DoctorMSProcedureForeignBodyInput>;
  isEditingLocked?: InputMaybe<Scalars['Boolean']['input']>;
  measurement?: InputMaybe<Array<DoctorMSMeasurementInput>>;
  medicalAct?: InputMaybe<DoctorMSMedicalActInput>;
  medication?: InputMaybe<DoctorMSProcedureMedicationInput>;
  midwifeEducationalVisit?: InputMaybe<DoctorMSMidwifeEducationalVisit>;
  nurseAdvice?: InputMaybe<DoctorMSNurseAdviceInput>;
  observations?: InputMaybe<Scalars['String']['input']>;
  patronageVisit?: InputMaybe<DoctorMSPatronageVisitInput>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  spirometry?: InputMaybe<DoctorMSProcedureSpirometryInput>;
  stitch?: InputMaybe<DoctorMSProcedureStitchInput>;
  tool?: InputMaybe<Array<DoctorMSProcedureToolInput>>;
  tuberculosisEducation?: InputMaybe<DoctorMSTuberculosisEducationInput>;
  usg?: InputMaybe<DoctorMSUsgInput>;
  vaccine?: InputMaybe<Array<DoctorMSVaccineInput>>;
  vaccineData?: InputMaybe<DoctorMSProcedureVaccineBasicDataInput>;
};

export type DoctorMSProcedureDisinfectant = {
  __typename?: 'DoctorMSProcedureDisinfectant';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureDisinfectantInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureDressingChange = {
  __typename?: 'DoctorMSProcedureDressingChange';
  place?: Maybe<Scalars['String']['output']>;
  secretion?: Maybe<DoctorMSSecretionType>;
  type?: Maybe<Scalars['String']['output']>;
  woundClassification?: Maybe<Array<Scalars['String']['output']>>;
  woundHealingStatus?: Maybe<DoctorMSWoundHealingStatus>;
};

export type DoctorMSProcedureDressingChangeInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  secretion?: InputMaybe<DoctorMSSecretionType>;
  type?: InputMaybe<Scalars['String']['input']>;
  woundClassification?: InputMaybe<Array<Scalars['String']['input']>>;
  woundHealingStatus?: InputMaybe<DoctorMSWoundHealingStatus>;
};

export type DoctorMSProcedureDrug = {
  __typename?: 'DoctorMSProcedureDrug';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureDrugInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureEKG = {
  __typename?: 'DoctorMSProcedureEKG';
  cito?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureEKGInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureEducation = {
  __typename?: 'DoctorMSProcedureEducation';
  comment?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureEducationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  ipomEducation?: InputMaybe<Scalars['Boolean']['input']>;
  myHealthEducation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DoctorMSProcedureEntity = {
  __typename?: 'DoctorMSProcedureEntity';
  answers: Array<DoctorMSProcedureAnswer>;
  bandages: Array<DoctorMSProcedureBandage>;
  cancelled: Scalars['Boolean']['output'];
  chukEducation?: Maybe<DoctorMSProcedureChukEducation>;
  chukMeasurements?: Maybe<DoctorMSProcedureChukMeasurements>;
  createdAt: Scalars['DoctorMSDateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: DoctorMSUser;
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  disinfectants: Array<DoctorMSProcedureDisinfectant>;
  displayName: Scalars['String']['output'];
  doctorDiagnosis?: Maybe<Array<Maybe<DoctorMSDiagnosis>>>;
  dressingChange?: Maybe<DoctorMSProcedureDressingChange>;
  drugs: Array<DoctorMSProcedureDrug>;
  education?: Maybe<DoctorMSProcedureEducation>;
  ekg?: Maybe<DoctorMSProcedureEKG>;
  executionLimit: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  foreignBody?: Maybe<DoctorMSProcedureForeignBody>;
  id: Scalars['String']['output'];
  isEditingLocked: Scalars['Boolean']['output'];
  measurements: Array<DoctorMSProcedureMeasurement>;
  medicalAct?: Maybe<DoctorMSProcedureMedicalAct>;
  medication?: Maybe<DoctorMSProcedureMedication>;
  messageId?: Maybe<Scalars['String']['output']>;
  midwifeEducationalVisit?: Maybe<DoctorMSProcedureMidwifeEducationalVisit>;
  observations: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  patronageVisit?: Maybe<DoctorMSProcedureParonageVisit>;
  spirometry?: Maybe<DoctorMSProcedureSpirometry>;
  stitch?: Maybe<DoctorMSProcedureStitch>;
  tools: Array<DoctorMSProcedureTool>;
  tuberculosisEducation?: Maybe<DoctorMSProcedureTuberculosisEducation>;
  type: DoctorMSProcedureType;
  updatedAt: Scalars['DoctorMSDateTime']['output'];
  usg?: Maybe<DoctorMSProcedureUsg>;
  vaccineData?: Maybe<DoctorMSProcedureVaccineBasicData>;
  vaccines: Array<DoctorMSProcedureVaccine>;
  visit?: Maybe<DoctorMSVisit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureForeignBody = {
  __typename?: 'DoctorMSProcedureForeignBody';
  comment?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureForeignBodyInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureMeasurement = {
  __typename?: 'DoctorMSProcedureMeasurement';
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureMedicalAct = {
  __typename?: 'DoctorMSProcedureMedicalAct';
  comment?: Maybe<Scalars['String']['output']>;
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  glycemia?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureMedication = {
  __typename?: 'DoctorMSProcedureMedication';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dosing?: Maybe<Scalars['String']['output']>;
  injection?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureMedicationInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  dosing?: InputMaybe<Scalars['String']['input']>;
  injection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureMidwifeEducationalVisit = {
  __typename?: 'DoctorMSProcedureMidwifeEducationalVisit';
  pregnacyWeek?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  visitTopics?: Maybe<Array<Scalars['String']['output']>>;
};

export type DoctorMSProcedureParonageVisit = {
  __typename?: 'DoctorMSProcedureParonageVisit';
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureSchema = {
  __typename?: 'DoctorMSProcedureSchema';
  create: Scalars['DoctorMSJSON']['output'];
  edit: Scalars['DoctorMSJSON']['output'];
};

export type DoctorMSProcedureSpirometry = {
  __typename?: 'DoctorMSProcedureSpirometry';
  comments?: Maybe<Scalars['String']['output']>;
  diastolicTest?: Maybe<Scalars['Boolean']['output']>;
  examinationComments?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureSpirometryInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  diastolicTest?: InputMaybe<Scalars['Boolean']['input']>;
  examinationComments?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureStitch = {
  __typename?: 'DoctorMSProcedureStitch';
  place?: Maybe<Scalars['String']['output']>;
  woundHealingStatus?: Maybe<DoctorMSWoundHealingStatus>;
};

export type DoctorMSProcedureStitchInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  woundHealingStatus?: InputMaybe<DoctorMSWoundHealingStatus>;
};

export type DoctorMSProcedureTool = {
  __typename?: 'DoctorMSProcedureTool';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureToolInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSProcedureTuberculosisEducation = {
  __typename?: 'DoctorMSProcedureTuberculosisEducation';
  patientEducated?: Maybe<Scalars['Boolean']['output']>;
  riskGroup?: Maybe<DoctorMSTuberculosisRiskLevel>;
  score?: Maybe<Scalars['Float']['output']>;
  telemedicalConsultation?: Maybe<Scalars['Boolean']['output']>;
};

export type DoctorMSProcedureType =
  | 'BANDAGE'
  | 'CHUK_EDUCATION'
  | 'CHUK_MEASUREMENTS'
  | 'DOCTOR_ADVICE'
  | 'DRUGPASS'
  | 'EDUCATION'
  | 'EKG'
  | 'MEDICAL_ACT'
  | 'MIDWIFE_EDUCATIONAL_VISIT'
  | 'NURSE_ADVICE'
  | 'OBJECT'
  | 'PATRONAGE_VISIT'
  | 'QUALIFICATION_FOR_VACCINATION'
  | 'SPIRO'
  | 'SPIROMETRY'
  | 'STITCHES'
  | 'TUBERCULOSIS_EDUCATION'
  | 'USG'
  | 'VACCINE';

export type DoctorMSProcedureUsg = {
  __typename?: 'DoctorMSProcedureUsg';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<DoctorMSProcedureUsgReferralInfo>;
  referralId?: Maybe<Scalars['String']['output']>;
  service?: Maybe<DoctorMSAssignmentEntity>;
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureUsgReferralInfo = {
  __typename?: 'DoctorMSProcedureUsgReferralInfo';
  comment: Scalars['String']['output'];
  mainDiagnosis: Scalars['String']['output'];
  procedureName: Scalars['String']['output'];
};

export type DoctorMSProcedureVaccine = {
  __typename?: 'DoctorMSProcedureVaccine';
  dose?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureVaccineBasicData = {
  __typename?: 'DoctorMSProcedureVaccineBasicData';
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSProcedureVaccineBasicDataInput = {
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DoctorMSRTPayload = {
  jwt: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type DoctorMSRange = {
  __typename?: 'DoctorMSRange';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type DoctorMSRealNFZStatusType =
  | 'DONOTREPORT'
  | 'NOTDECLARABLE'
  | 'O'
  | 'P'
  | 'PENDING'
  | 'TODECLARE'
  | 'Z';

export type DoctorMSReferral = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSReferral';
  adviceGoal?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<DoctorMSClinicDetails>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  examinationType?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<DoctorMSICD9Main>;
  icd10?: Maybe<DoctorMSICD10Main>;
  id: Scalars['String']['output'];
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  referralDetails: DoctorMSReferralDetails;
  referralType: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  urgent?: Maybe<Scalars['Boolean']['output']>;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
  ward?: Maybe<DoctorMSWardDetails>;
};

export type DoctorMSReferralDetails = {
  __typename?: 'DoctorMSReferralDetails';
  code?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type DoctorMSRegistrationSource =
  | 'MOBILE'
  | 'WEB';

export type DoctorMSRegularDrug = {
  __typename?: 'DoctorMSRegularDrug';
  drugDetails?: Maybe<DoctorMSDrugDetails>;
  sourceTag: DoctorMSPatientTagEntity;
};

export type DoctorMSRenderedProcedure = {
  __typename?: 'DoctorMSRenderedProcedure';
  context: Scalars['DoctorMSJSON']['output'];
  create?: Maybe<Scalars['String']['output']>;
  data: Scalars['DoctorMSJSON']['output'];
  edit?: Maybe<Scalars['String']['output']>;
  print?: Maybe<Scalars['String']['output']>;
  schema: DoctorMSProcedureSchema;
  view?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSReportingEventEntity = {
  __typename?: 'DoctorMSReportingEventEntity';
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  error?: Maybe<Scalars['DoctorMSJSON']['output']>;
  meta?: Maybe<Scalars['DoctorMSJSON']['output']>;
  organizationId: Scalars['String']['output'];
  periodSymbol: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DoctorMSRepresentativeInsuranceStatementData = {
  reason: DoctorMSInsuranceStatementRepresentativeReason;
  representativePatientId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSRequestedDrugDto = {
  __typename?: 'DoctorMSRequestedDrugDto';
  details: DoctorMSDrugDetails;
  ean: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  regularDrugSourceTag?: Maybe<DoctorMSPatientTagEntity>;
  resolvedInPrescriptions?: Maybe<Array<DoctorMSPrescription>>;
};

export type DoctorMSRtg = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSRtg';
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSSMSNotifications = {
  __typename?: 'DoctorMSSMSNotifications';
  deadline: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type DoctorMSScheduledDiagnosticTestInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  icd9?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  packet?: InputMaybe<Array<DoctorMSPacketInput>>;
  time: DoctorMSIpomTimeType;
  timeName?: InputMaybe<Scalars['String']['input']>;
  timeUnit?: InputMaybe<DoctorMSIpomTimeUnit>;
  timeValue?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DoctorMSScheduledDiagnosticTestIpom = {
  __typename?: 'DoctorMSScheduledDiagnosticTestIpom';
  date?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  packet?: Maybe<Array<DoctorMSPacketIpom>>;
  time: DoctorMSIpomTimeType;
  timeName?: Maybe<Scalars['String']['output']>;
  timeUnit?: Maybe<DoctorMSIpomTimeUnit>;
  timeValue?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DoctorMSSecretData = {
  __typename?: 'DoctorMSSecretData';
  breastfeeding?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hearingdisabled?: Maybe<Scalars['Boolean']['output']>;
  nice?: Maybe<Scalars['Boolean']['output']>;
  notnice?: Maybe<Scalars['Boolean']['output']>;
  physicallydisabled?: Maybe<Scalars['Boolean']['output']>;
  pregnant?: Maybe<Scalars['Boolean']['output']>;
};

export type DoctorMSSecretDataInput = {
  breastfeeding?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hearingdisabled?: InputMaybe<Scalars['Boolean']['input']>;
  nice?: InputMaybe<Scalars['Boolean']['input']>;
  notnice?: InputMaybe<Scalars['Boolean']['input']>;
  physicallydisabled?: InputMaybe<Scalars['Boolean']['input']>;
  pregnant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DoctorMSSecretionType =
  | 'BLOODY'
  | 'PURULENT'
  | 'SEROUS';

export type DoctorMSSelectOption = {
  __typename?: 'DoctorMSSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSSelectOptionInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DoctorMSSelectedDocumentInput = {
  academicalTestimonial?: InputMaybe<DoctorMSAcademicalTestimonialInput>;
  becikoweTestimonial?: InputMaybe<DoctorMSBecikoweTestimonialInput>;
  medicalTestimonial?: InputMaybe<DoctorMSMedicalTestimonialInput>;
  ol9Testimonial?: InputMaybe<DoctorMSOL9TestimonialInput>;
  zas2Testimonial?: InputMaybe<DoctorMSZAS2TestimonialInput>;
  zas38Testimonial?: InputMaybe<DoctorMSZAS38TestimonialInput>;
};

export type DoctorMSSelfOrdinatedDrugDto = {
  __typename?: 'DoctorMSSelfOrdinatedDrugDto';
  details: DoctorMSDrugDetails;
  ean: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type DoctorMSSentNoShowNotifications = {
  __typename?: 'DoctorMSSentNoShowNotifications';
  answer?: Maybe<DoctorMSNoShowNotificationAnswer>;
  notifications: DoctorMSSentNotifications;
};

export type DoctorMSSentNotifications = {
  __typename?: 'DoctorMSSentNotifications';
  cancelled?: Maybe<Scalars['String']['output']>;
  warnings: Array<Maybe<Scalars['String']['output']>>;
};

export type DoctorMSServiceStaffEntity = {
  __typename?: 'DoctorMSServiceStaffEntity';
  colsynced?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
  saleorProductVariantId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  slots: Scalars['Float']['output'];
  staffId: Scalars['String']['output'];
};

export type DoctorMSShift = {
  id: Scalars['String']['input'];
  version: Scalars['Float']['input'];
};

export type DoctorMSShiftInput = {
  active: Scalars['Boolean']['input'];
  comment: Scalars['String']['input'];
  day: Scalars['String']['input'];
  doctorId: Scalars['String']['input'];
  hourEnd: Scalars['String']['input'];
  hourStart: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  placement: DoctorMSPlacement;
  shiftType: Scalars['String']['input'];
  slotDurationString: Scalars['String']['input'];
};

export type DoctorMSShiftOutputBase = {
  __typename?: 'DoctorMSShiftOutputBase';
  active: Scalars['Boolean']['output'];
  comment: Scalars['String']['output'];
  day: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  hourEnd: Scalars['String']['output'];
  hourStart: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  placement: DoctorMSPlacement;
  shiftType: Scalars['String']['output'];
};

export type DoctorMSShiftOutputDynamic = {
  __typename?: 'DoctorMSShiftOutputDynamic';
  active: Scalars['Boolean']['output'];
  background: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  day: Scalars['String']['output'];
  defaultSlotLength: Scalars['Int']['output'];
  doctorId: Scalars['String']['output'];
  draftData?: Maybe<DoctorMSShiftOutputBase>;
  hourEnd: Scalars['String']['output'];
  hourStart: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  placeId: Scalars['String']['output'];
  placement: DoctorMSPlacement;
  shiftType: Scalars['String']['output'];
  slotDuration: Scalars['Int']['output'];
  textColor: Scalars['String']['output'];
};


export type DoctorMSShiftOutputDynamicbackgroundArgs = {
  oldTheme?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DoctorMSShiftOutputDynamictextColorArgs = {
  oldTheme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DoctorMSShiftsOutput = {
  __typename?: 'DoctorMSShiftsOutput';
  doctorIds: Array<Scalars['String']['output']>;
  shifts: Array<DoctorMSShiftOutputDynamic>;
};

export type DoctorMSShiftsSlot = {
  from: Scalars['DoctorMSDateTime']['input'];
  shifts: Array<DoctorMSShift>;
  to: Scalars['DoctorMSDateTime']['input'];
};

export type DoctorMSSlotType =
  | 'COLLECTION'
  | 'DIETARY'
  | 'EXPRESS'
  | 'HOME'
  | 'INFECTIONS'
  | 'INFECTIONS_PRIVATE'
  | 'INFECTIONS_PUBLIC'
  | 'MIDWIFE'
  | 'NURSE_VISIT'
  | 'PERSONAL'
  | 'PROCEDURES'
  | 'SPECIALIST'
  | 'SPECIALIST_DOCTOR'
  | 'TELEMEDICAL'
  | 'TELEMEDICAL_NEW_CITIES'
  | 'TELEMEDICAL_PRIVATE'
  | 'USG';

export type DoctorMSSnippet = {
  __typename?: 'DoctorMSSnippet';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  counter: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  tags: Array<DoctorMSSelectOption>;
  type: DoctorMSSnippetType;
  visibility: DoctorMSSnippetVisibility;
};

export type DoctorMSSnippetEntity = {
  __typename?: 'DoctorMSSnippetEntity';
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  counter: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Float']['output'];
  tags: Scalars['DoctorMSJSON']['output'];
  type: DoctorMSSnippetType;
  visibility: DoctorMSSnippetVisibility;
};

export type DoctorMSSnippetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<DoctorMSSelectOptionInput>>;
  type?: InputMaybe<DoctorMSSnippetType>;
  visibility?: InputMaybe<DoctorMSSnippetVisibility>;
};

export type DoctorMSSnippetType =
  | 'CHAT'
  | 'DOCS'
  | 'USG';

export type DoctorMSSnippetVisibility =
  | 'PRIVATE'
  | 'PUBLIC';

export type DoctorMSSpiro = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSSpiro';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSStaffEntity = {
  __typename?: 'DoctorMSStaffEntity';
  avatar?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  declaringToOrganizationId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Scalars['DoctorMSJSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  history?: Maybe<DoctorMSHistory>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['DoctorMSJSON']['output']>;
  organizationId: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  sipNumberRecording?: Maybe<Scalars['String']['output']>;
  sipUserId?: Maybe<Scalars['String']['output']>;
  sipUserIdRecording?: Maybe<Scalars['String']['output']>;
  sipUserPassword?: Maybe<Scalars['String']['output']>;
  sipUserPasswordRecording?: Maybe<Scalars['String']['output']>;
  uniqueIntegerId?: Maybe<Scalars['Float']['output']>;
  unread: Scalars['Float']['output'];
  unsuccessfulAuth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
};

export type DoctorMSStateInsurance =
  | 'KRUS'
  | 'OTHER_COUNTRY'
  | 'OTHER_IN_POLAND'
  | 'ZUS';

export type DoctorMSStayAddress = {
  __typename?: 'DoctorMSStayAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type DoctorMSStayAddressInput = {
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type DoctorMSStreetPrefix =
  | 'AL'
  | 'PL'
  | 'RONDO'
  | 'SKWER'
  | 'UL';

export type DoctorMSSupportedLanguage =
  | 'EN'
  | 'PL'
  | 'RU'
  | 'UK';

export type DoctorMSSurvey = {
  __typename?: 'DoctorMSSurvey';
  height: Scalars['String']['output'];
  risks: Array<DoctorMSAnswer>;
  weight: Scalars['String']['output'];
};

export type DoctorMSSurveyProposal = {
  __typename?: 'DoctorMSSurveyProposal';
  createdAt: Scalars['String']['output'];
  data: Scalars['DoctorMSJSON']['output'];
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  schema: Scalars['DoctorMSJSON']['output'];
  updatedAt: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type DoctorMSSurveyProposalEntity = {
  __typename?: 'DoctorMSSurveyProposalEntity';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  updatedAt: Scalars['DoctorMSDateTime']['output'];
};

export type DoctorMSSurveyProposalInput = {
  formId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};

export type DoctorMSTagType =
  | 'DOCTOR'
  | 'EXAMINATION'
  | 'LOCALIZATION'
  | 'OFFICE';

export type DoctorMSTerm = {
  __typename?: 'DoctorMSTerm';
  date: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intervals: Array<DoctorMSDoctorInterval>;
  slotSize: Scalars['Int']['output'];
  tags: Array<DoctorMSTermTag>;
  type: DoctorMSTermType;
};

export type DoctorMSTermTag = {
  __typename?: 'DoctorMSTermTag';
  type: DoctorMSTagType;
  userId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSTermType =
  | 'BLOCKER'
  | 'DOCTORDAY'
  | 'DOCTORWEEK'
  | 'PLACE';

export type DoctorMSTestimonial = DoctorMSBaseMessage & DoctorMSGlobal & {
  __typename?: 'DoctorMSTestimonial';
  createdAt: DoctorMSTime;
  data: Scalars['DoctorMSJSON']['output'];
  doctor: DoctorMSDoctor;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: DoctorMSPatient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  testimonialType: Scalars['String']['output'];
  type: DoctorMSMessageType;
  updatedAt: DoctorMSTime;
  visit: DoctorMSVisit;
  visitId: Scalars['String']['output'];
};

export type DoctorMSTestimonialGenerationInput = {
  selectedDocument: DoctorMSSelectedDocumentInput;
  visitId: Scalars['String']['input'];
};

export type DoctorMSTidyDocumentationResultEntity = {
  __typename?: 'DoctorMSTidyDocumentationResultEntity';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  issuedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  medicalRecord: DoctorMSMedicalRecordEntity;
  name?: Maybe<Scalars['String']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['DoctorMSJSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSTime = {
  __typename?: 'DoctorMSTime';
  iso: Scalars['String']['output'];
  local: Scalars['String']['output'];
};

export type DoctorMSTodoEntity = {
  __typename?: 'DoctorMSTodoEntity';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  maximalDate?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  minimalDate?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  organizationId: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  plannedDate?: Maybe<Scalars['DoctorMSDateTime']['output']>;
};

export type DoctorMSTodoStatus =
  | 'DONE'
  | 'ERROR'
  | 'PREVIOUSLY_DONE'
  | 'TODO';

export type DoctorMSTokensPayload = {
  __typename?: 'DoctorMSTokensPayload';
  error?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSTuberculosisEducationInput = {
  patientEducated?: InputMaybe<Scalars['Boolean']['input']>;
  riskGroup?: InputMaybe<DoctorMSTuberculosisRiskLevel>;
  score?: InputMaybe<Scalars['Float']['input']>;
  telemedicalConsultation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DoctorMSTuberculosisRiskLevel =
  | 'HIGH'
  | 'MODERATE'
  | 'NO_RISK';

export type DoctorMSUnderCarePerson = {
  __typename?: 'DoctorMSUnderCarePerson';
  birthDate: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSUnderCarePersonType =
  | 'CHILD'
  | 'OTHER'
  | 'RELATIVE';

export type DoctorMSUnknownEvent = DoctorMSNfzEventBase & {
  __typename?: 'DoctorMSUnknownEvent';
  createdAt: Scalars['DoctorMSDateTime']['output'];
  data?: Maybe<Scalars['DoctorMSJSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DoctorMSUpdateDocumentInput = {
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSUpdateProcedureInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSUser = DoctorMSDoctor | DoctorMSPatient;

export type DoctorMSUserEntity = {
  __typename?: 'DoctorMSUserEntity';
  acCohort?: Maybe<Scalars['Float']['output']>;
  acTimestamp: Scalars['Float']['output'];
  acTimestampStart: Scalars['Float']['output'];
  address?: Maybe<DoctorMSAddress>;
  analyticsData?: Maybe<DoctorMSAnalyticsData>;
  analyticsId?: Maybe<Scalars['String']['output']>;
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  blockedTelemedicine: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<DoctorMSClientAppSettings>;
  createdAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  declarationType?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Array<DoctorMSDeclaration>>;
  deviceInfo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheck?: Maybe<DoctorMSEwusCheck>;
  ewusCheckHistory?: Maybe<DoctorMSHistory>;
  files?: Maybe<Scalars['DoctorMSJSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: DoctorMSUserGenre;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  history?: Maybe<DoctorMSHistory>;
  id: Scalars['String']['output'];
  immunizationCardComment: Scalars['String']['output'];
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Float']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<Scalars['Float']['output']>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  marketing?: Maybe<Scalars['Boolean']['output']>;
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalPushToken?: Maybe<Scalars['DoctorMSJSON']['output']>;
  mobileAppVersion?: Maybe<Scalars['String']['output']>;
  oneTimeSurvey?: Maybe<DoctorMSSurvey>;
  oneTimeSurveyUpdatedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  organizationId: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  patientPublicSince?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
  secretData?: Maybe<DoctorMSSecretData>;
  selfOrdinatedDrugs?: Maybe<Array<DoctorMSSelfOrdinatedDrugDto>>;
  signature?: Maybe<Scalars['String']['output']>;
  stateInsurance: DoctorMSStateInsurance;
  statusUbezpieczenia?: Maybe<Scalars['String']['output']>;
  stayAddresses?: Maybe<Array<DoctorMSStayAddress>>;
  uniqueIntegerId?: Maybe<Scalars['Float']['output']>;
  unread: Scalars['Float']['output'];
  unsuccessfulAuth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
};

export type DoctorMSUserGenre =
  | 'ASSISTANT'
  | 'CLINIC_MANAGER'
  | 'DOCTOR'
  | 'MODERATOR'
  | 'NURSE'
  | 'PATIENT'
  | 'STAFF';

export type DoctorMSUsersNotificationAgreementsEntity = {
  __typename?: 'DoctorMSUsersNotificationAgreementsEntity';
  agreed: Scalars['Boolean']['output'];
  createdAt: Scalars['DoctorMSDateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DoctorMSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type DoctorMSUsg = DoctorMSBaseVital & DoctorMSGlobal & {
  __typename?: 'DoctorMSUsg';
  createdAt: DoctorMSTime;
  customDate?: Maybe<DoctorMSTime>;
  delivered?: Maybe<DoctorMSTime>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<DoctorMSTime>;
  message?: Maybe<DoctorMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  type: DoctorMSVitalType;
  updatedAt: DoctorMSTime;
  visit?: Maybe<DoctorMSVisit>;
  visitId: Scalars['String']['output'];
};

export type DoctorMSUsgInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSVaccineInput = {
  dose?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorMSVisit = DoctorMSGlobal & {
  __typename?: 'DoctorMSVisit';
  additionalMedicalService?: Maybe<Array<Scalars['String']['output']>>;
  appointmentStatus: Scalars['String']['output'];
  availableImaginingOrganizationId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  children: Array<DoctorMSVisit>;
  closedByBot?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: DoctorMSTime;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUsername: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  determineIpomEligibility: Scalars['Boolean']['output'];
  diagId?: Maybe<Scalars['Int']['output']>;
  diagnosis: Array<DoctorMSDiagnosis>;
  doctor?: Maybe<DoctorMSDoctor>;
  doctorDiagnosis?: Maybe<Array<Maybe<DoctorMSDiagnosis>>>;
  doctorId?: Maybe<Scalars['String']['output']>;
  doctorInterview?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  ecommerceOrderIds: Array<Scalars['String']['output']>;
  faqRead?: Maybe<Array<DoctorMSFaqType>>;
  faqTypes: Array<DoctorMSAssignmentFaqType>;
  height?: Maybe<Scalars['Int']['output']>;
  icd10Main?: Maybe<DoctorMSICD10Main>;
  icd10Secondary?: Maybe<DoctorMSICD10Main>;
  id: Scalars['String']['output'];
  innatePriority: DoctorMSVisitPriority;
  invitationSentAt?: Maybe<DoctorMSTime>;
  invitationSentBy?: Maybe<DoctorMSDoctor>;
  isPublicVisit: Scalars['Boolean']['output'];
  laboratoryExaminations: Array<DoctorMSLaboratoryExaminationEntity>;
  leftOn?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  nurseDiagnosis?: Maybe<Array<DoctorMSDiagnosis>>;
  nursePhysicalExamination?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<DoctorMSPatient>;
  patientId: Scalars['String']['output'];
  physicalExamination?: Maybe<Scalars['String']['output']>;
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<DoctorMSTime>;
  preInterview?: Maybe<Array<DoctorMSLlmChatMessage>>;
  prescriptionRequest?: Maybe<DoctorMSPrescriptionRequestDto>;
  prescriptionRequestId?: Maybe<Scalars['String']['output']>;
  primaryMedicalService?: Maybe<DoctorMSPrimaryMedicalService>;
  procedures: Array<DoctorMSProcedureEntity>;
  rating: DoctorMSVisitsRatingEntity;
  recommendation?: Maybe<Scalars['String']['output']>;
  recommendationsMessage?: Maybe<DoctorMSChatMessageEntity>;
  recommendationsMessageId?: Maybe<Scalars['String']['output']>;
  sentNoShowNotifications?: Maybe<DoctorMSSentNoShowNotifications>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceStaff?: Maybe<DoctorMSServiceStaffEntity>;
  showOn?: Maybe<Scalars['String']['output']>;
  slotType?: Maybe<Scalars['String']['output']>;
  smokeLevel?: Maybe<Scalars['Int']['output']>;
  smsNotifications: DoctorMSSMSNotifications;
  snapshotAt?: Maybe<Scalars['String']['output']>;
  snapshotBy?: Maybe<Scalars['String']['output']>;
  source: DoctorMSVisit;
  startOn?: Maybe<Scalars['String']['output']>;
  status: DoctorMSVisitStatus;
  surveys: Array<DoctorMSSurveyProposal>;
  timeStatus: DoctorMSVisitComplexStatus;
  type?: Maybe<DoctorMSVisitType>;
  updatedAt: DoctorMSTime;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type DoctorMSVisitComplexStatus =
  | 'PAST'
  | 'UPCOMING';

export type DoctorMSVisitFilterInput = {
  additionalMedicalService?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientSearch?: InputMaybe<Scalars['String']['input']>;
  primaryMedicalService?: InputMaybe<Array<DoctorMSPrimaryMedicalService>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<DoctorMSVisitStatus>>;
  visitType?: InputMaybe<Array<DoctorMSVisitType>>;
};

export type DoctorMSVisitInput = {
  additionalMedicalService?: InputMaybe<Array<Scalars['String']['input']>>;
  appointmentStatus?: InputMaybe<DoctorMSAppointmentStatus>;
  comment?: InputMaybe<Scalars['String']['input']>;
  doctorDiagnosis?: InputMaybe<Array<InputMaybe<DoctorMSDiagnosisInput>>>;
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  icd10Main?: InputMaybe<DoctorMSICD10Input>;
  icd10Secondary?: InputMaybe<DoctorMSICD10Input>;
  innatePriority?: InputMaybe<DoctorMSVisitPriority>;
  memo?: InputMaybe<Scalars['String']['input']>;
  nurseDiagnosis?: InputMaybe<Array<InputMaybe<DoctorMSDiagnosisInput>>>;
  nursePhysicalExamination?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  prenterview?: InputMaybe<Scalars['String']['input']>;
  primaryMedicalService?: InputMaybe<DoctorMSPrimaryMedicalService>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  smokeLevel?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type DoctorMSVisitPriority =
  | 'IMMEDIATE'
  | 'INDETERMINATE'
  | 'STANDARD'
  | 'URGENT';

export type DoctorMSVisitStatus =
  | 'ARCHIVE'
  | 'DRAFT'
  | 'INPROGRESS'
  | 'SUCCESS';

export type DoctorMSVisitType =
  | 'PROCEDURE'
  | 'STANDARD'
  | 'VIRTUAL';

export type DoctorMSVisitsRatingEntity = {
  __typename?: 'DoctorMSVisitsRatingEntity';
  answers: Scalars['DoctorMSJSON']['output'];
  createdAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  updatedAt: Scalars['DoctorMSDateTime']['output'];
  userId: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type DoctorMSVital = DoctorMSAnalysis | DoctorMSCt | DoctorMSEcommerce | DoctorMSEkg | DoctorMSHeartrate | DoctorMSInjection | DoctorMSOperation | DoctorMSOther | DoctorMSPressure | DoctorMSRtg | DoctorMSSpiro | DoctorMSUsg;

export type DoctorMSVitalEntity = {
  __typename?: 'DoctorMSVitalEntity';
  analysisType?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Scalars['String']['output']>;
  diastolic?: Maybe<Scalars['String']['output']>;
  doctorId?: Maybe<Scalars['String']['output']>;
  drugs: Scalars['DoctorMSJSON']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  injectionType?: Maybe<Scalars['String']['output']>;
  measured?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  overrideFiles: Scalars['DoctorMSJSON']['output'];
  params: Scalars['DoctorMSJSON']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  positionId?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['String']['output']>;
  systolic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DoctorMSDateTime']['output']>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type DoctorMSVitalInput = {
  overrideFiles: Array<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  type: DoctorMSVitalType;
};

export type DoctorMSVitalParam = {
  __typename?: 'DoctorMSVitalParam';
  icd9: Scalars['String']['output'];
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DoctorMSVitalParamInput = {
  icd9: Scalars['String']['input'];
  max: Scalars['String']['input'];
  min: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DoctorMSVitalType =
  | 'ANALYSIS'
  | 'CT'
  | 'ECOMMERCE'
  | 'EKG'
  | 'HEARTRATE'
  | 'INJECTION'
  | 'OPERATION'
  | 'OTHER'
  | 'PRESSURE'
  | 'RTG'
  | 'SPIRO'
  | 'USG';

export type DoctorMSWardDetails = {
  __typename?: 'DoctorMSWardDetails';
  name: Scalars['String']['output'];
};

export type DoctorMSWeekDay =
  | 'Friday'
  | 'Monday'
  | 'Saturday'
  | 'Sunday'
  | 'Thursday'
  | 'Tuesday'
  | 'Wednesday';

export type DoctorMSWoundHealingStatus =
  | 'CORRECT'
  | 'UNDER_SCAB'
  | 'WITHOUT_SCAB';

export type DoctorMSZAS2TestimonialInput = {
  expectedDateOfBirth?: InputMaybe<DoctorMSExpectedDateOfBirthInput>;
  inabilityToWork?: InputMaybe<DoctorMSInabilityToWorkInput>;
  lastDayOfWork?: InputMaybe<DoctorMSLastDayOfWorkInput>;
};

export type DoctorMSZAS38TestimonialInput = {
  careSince: Scalars['DoctorMSDateTime']['input'];
  careUntil: Scalars['DoctorMSDateTime']['input'];
  children: Array<DoctorMSPersonMinimalDataInput>;
  otherParent: DoctorMSPersonMinimalDataInput;
  whyNotOtherParent: Scalars['String']['input'];
};

export type DoctorMSZusMedicalLeave = {
  __typename?: 'DoctorMSZusMedicalLeave';
  doctorFirstName: Scalars['String']['output'];
  doctorLastName: Scalars['String']['output'];
  doctorNpwz: Scalars['String']['output'];
  hospitalizationDaysCount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incapacityEndDate: Scalars['String']['output'];
  incapacityStartDate: Scalars['String']['output'];
  insuredPersonFirstName: Scalars['String']['output'];
  insuredPersonLastName: Scalars['String']['output'];
  insuredPersonPesel: Scalars['String']['output'];
  leaveIssueDate: Scalars['String']['output'];
  leaveNumber: Scalars['String']['output'];
  leaveSeries: Scalars['String']['output'];
  leaveStatus: Scalars['String']['output'];
  payerIdentifier: Scalars['String']['output'];
  payerIdentifierType: Scalars['String']['output'];
  /** 0 - brak osoby pod opieką „1” – dziecko; „2” - małżonek, rodzice, ojczym, macocha, teściowie, dziadkowie, wnuki, rodzeństwo; „3” – inne osoby */
  relationshipCode?: Maybe<Scalars['String']['output']>;
  statisticalDiseaseNumber: Scalars['String']['output'];
};

export type DoctorMSZusPayer = {
  __typename?: 'DoctorMSZusPayer';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  pueProfile: Scalars['Boolean']['output'];
};

export type EdmAdultDataInput = {
  height: Scalars['String']['input'];
  sex: EdmSex;
  weight: Scalars['String']['input'];
};

export type EdmAiChat = {
  __typename?: 'EdmAiChat';
  content?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type EdmAiChatInput = {
  question: Scalars['String']['input'];
  threadId?: InputMaybe<Scalars['String']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};

export type EdmAiChatMessage = {
  __typename?: 'EdmAiChatMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type EdmAiChatMessages = {
  __typename?: 'EdmAiChatMessages';
  messages: Array<EdmAiChatMessage>;
  threadId: Scalars['String']['output'];
};

export type EdmAiChatMessagesInput = {
  threadId: Scalars['String']['input'];
};

export type EdmCalculationInput = {
  dateOfBirth: Scalars['String']['input'];
  measuredAt: Scalars['String']['input'];
  sex: EdmSex;
  type: EdmCalculationPercentileType;
  value: Scalars['String']['input'];
};

export type EdmCalculationPercentileType =
  | 'HEAD'
  | 'HEIGHT'
  | 'WEIGHT';

export type EdmCalculationResult = {
  __typename?: 'EdmCalculationResult';
  growthStandard: EdmGrowthStandard;
  result: Scalars['Float']['output'];
};

export type EdmCalendarAvailability = {
  __typename?: 'EdmCalendarAvailability';
  dates: Array<Scalars['String']['output']>;
  medicalPeople: Array<EdmMedicalPerson>;
};

export type EdmChildrenMeasurementDataInput = {
  headCircumference: Scalars['String']['input'];
  height: Scalars['String']['input'];
  sex: EdmSex;
  weight: Scalars['String']['input'];
};

export type EdmClinic = {
  __typename?: 'EdmClinic';
  name: Scalars['String']['output'];
  type: Scalars['Float']['output'];
};

export type EdmClinicManagerVisit = {
  __typename?: 'EdmClinicManagerVisit';
  cancellationComment?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['EdmDateTime']['output']>;
  cancelledReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['EdmDateTime']['output']>;
  createdAt: Scalars['EdmDateTime']['output'];
  estimatedDurationTime: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  patient: EdmPatient;
  patientId: Scalars['String']['output'];
  patientLeftAt?: Maybe<Scalars['EdmDateTime']['output']>;
  referenceOldVisitId: Scalars['String']['output'];
  scheduledOn: Scalars['EdmDateTime']['output'];
  shiftId?: Maybe<Scalars['String']['output']>;
  staff: EdmMedicalPerson;
  staffId: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['EdmDateTime']['output']>;
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EdmCreateMedicalMeasurementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  data: EdmMeasurementDataInput;
  dateOfBirth: Scalars['String']['input'];
  measuredAt: Scalars['EdmDateTime']['input'];
  measuredBy: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};

export type EdmCreateMedicalRecordFileReferenceInput = {
  fileReferences: Array<EdmMedicalRecord>;
};

export type EdmCreateNonWorkingPeriodInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['EdmDateTime']['input'];
  endedAt: Scalars['EdmDateTime']['input'];
  leaveType: EdmLeaveType;
  staffId: Scalars['String']['input'];
  startFrom: Scalars['EdmDateTime']['input'];
};

export type EdmCreateShiftBulkInput = {
  availableDays: Array<Scalars['String']['input']>;
  dateEnded: Scalars['EdmDateTime']['input'];
  dateStartFrom: Scalars['EdmDateTime']['input'];
  shift: EdmCreateShiftInput;
};

export type EdmCreateShiftInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  day: Scalars['EdmDateTime']['input'];
  endedAt: Scalars['EdmDateTime']['input'];
  organizationId: Scalars['String']['input'];
  overrideStaffVisitDuration?: InputMaybe<EdmUpdateStaffVisitDurationInput>;
  staffId: Scalars['String']['input'];
  startFrom: Scalars['EdmDateTime']['input'];
  status: EdmMedicalAppShiftStatus;
  visitTypes: Array<EdmMedicalAppVisitType>;
  workPlace: EdmMedicalAppShiftWorkPlace;
};

export type EdmCreateSnippetInput = {
  category: Scalars['String']['input'];
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: EdmSnippetType;
  visibility: EdmSnippetVisibility;
};

export type EdmCurrentActivity = EdmInternalVisit | EdmLaboratoryExamination | EdmPolmedVisit | EdmProcedure | EdmSickLeave | EdmVoucherVisit;

export type EdmCursorInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type EdmCursorPrescription = {
  __typename?: 'EdmCursorPrescription';
  cursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<EdmPrescription>;
};

export type EdmCursorReferral = {
  __typename?: 'EdmCursorReferral';
  cursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<EdmReferral>;
};

export type EdmCursorSickLeave = {
  __typename?: 'EdmCursorSickLeave';
  cursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<EdmSickLeave>;
};

export type EdmCursorVisit = {
  __typename?: 'EdmCursorVisit';
  cursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<EdmVisitUnionType>;
};

export type EdmCursorVital = {
  __typename?: 'EdmCursorVital';
  cursor?: Maybe<Scalars['String']['output']>;
  nodes: Array<EdmVitalListItem>;
};

export type EdmDefineWorkingHoursInput = {
  expectedWorkingHours: EdmExpectedWorkingHoursInput;
  month: Scalars['EdmDateTime']['input'];
  staffId: Scalars['String']['input'];
};

export type EdmDeleteWorkingHoursInput = {
  month: Scalars['EdmDateTime']['input'];
  staffId: Scalars['String']['input'];
};

export type EdmDocumentGenerationResult = {
  __typename?: 'EdmDocumentGenerationResult';
  documentId: Scalars['String']['output'];
};

export type EdmDrug = {
  __typename?: 'EdmDrug';
  boxAmount?: Maybe<Scalars['Float']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  dose?: Maybe<Scalars['String']['output']>;
  drug?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  form?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  psychoSubstances?: Maybe<Scalars['Boolean']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
};

export type EdmDurationTimeMap = {
  __typename?: 'EdmDurationTimeMap';
  COLLECTION: Scalars['Int']['output'];
  DOCTOR_HOUSE_CALL: Scalars['Int']['output'];
  DOCTOR_TELEMEDICAL_INFECTION: Scalars['Int']['output'];
  EXPRESS_APPOINTMENT: Scalars['Int']['output'];
  HEALTHY_CHILDREN_CHECKUP: Scalars['Int']['output'];
  HEALTHY_CHILDREN_CHECKUP_AND_VACCINE: Scalars['Int']['output'];
  HEALTHY_CHILDREN_PATRONAGE: Scalars['Int']['output'];
  HEALTHY_CHILDREN_VACCINE: Scalars['Int']['output'];
  IN_PERSON: Scalars['Int']['output'];
  MIDWIFE_HOUSE_CALL: Scalars['Int']['output'];
  MIDWIFE_IN_PERSON: Scalars['Int']['output'];
  NURSE_HEALTHY_CHILDREN?: Maybe<Scalars['Int']['output']>;
  NURSE_HOUSE_CALL: Scalars['Int']['output'];
  NURSE_IN_PERSON: Scalars['Int']['output'];
  NURSE_IN_PERSON_INFECTION: Scalars['Int']['output'];
  PRESCRIPTION_APPOINTMENT: Scalars['Int']['output'];
  PROCEDURE: Scalars['Int']['output'];
  RADIOLOGY_APPOINTMENT: Scalars['Int']['output'];
  SICK_CHILDREN: Scalars['Int']['output'];
  SPECIALIST: Scalars['Int']['output'];
  TELEMEDICAL: Scalars['Int']['output'];
};

export type EdmExpectedWorkingHours = {
  __typename?: 'EdmExpectedWorkingHours';
  hours: Scalars['Float']['output'];
  minutes: Scalars['Float']['output'];
};

export type EdmExpectedWorkingHoursInput = {
  hours: Scalars['Float']['input'];
  minutes: Scalars['Float']['input'];
};

export type EdmGender =
  | 'FEMALE'
  | 'MALE'
  | 'UNKNOWN';

export type EdmGenerateDocumentationInput = {
  threadId: Scalars['String']['input'];
  triageData?: InputMaybe<Scalars['String']['input']>;
  visitId: Scalars['String']['input'];
};

export type EdmGenreType =
  | 'ASSISTANT'
  | 'CLINIC_MANAGER'
  | 'DOCTOR'
  | 'MIDWIFE'
  | 'NURSE'
  | 'RADIOLOGIST'
  | 'STAFF';

export type EdmGetAllDoctorsFromShiftsInput = {
  date: Scalars['EdmDateTime']['input'];
  organizationId: Scalars['String']['input'];
};

export type EdmGetAllNonWorkingPeriodsInput = {
  from: Scalars['EdmDateTime']['input'];
  staffIds: Array<Scalars['String']['input']>;
  to: Scalars['EdmDateTime']['input'];
};

export type EdmGetAllShiftsInput = {
  from: Scalars['EdmDateTime']['input'];
  ignoredOrganizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
  to: Scalars['EdmDateTime']['input'];
};

export type EdmGetAllSnippetsFilter = {
  showAllFilter?: Scalars['Boolean']['input'];
};

export type EdmGetAllStaffWithGenreAndWorkingHoursInput = {
  genre: Array<EdmGenreType>;
  month?: InputMaybe<Scalars['EdmDateTime']['input']>;
};

export type EdmGetVisitTypesByGenreInput = {
  genre: EdmGenreType;
};

export type EdmGrowthStandard =
  | 'OLA'
  | 'OLAF'
  | 'WHO';

export type EdmGuardian = {
  __typename?: 'EdmGuardian';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EdmIcd10 = {
  __typename?: 'EdmIcd10';
  icd10: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EdmInternalVisit = {
  __typename?: 'EdmInternalVisit';
  createdAt: Scalars['EdmDateTime']['output'];
  id: Scalars['ID']['output'];
  isPrescription: Scalars['Boolean']['output'];
  laboratoryExaminations: Array<EdmLaboratoryExamination>;
  laboratoryExaminationsForCreatedOnVisit: Array<EdmLaboratoryExamination>;
  medicalPerson?: Maybe<EdmMedicalPerson>;
  organization?: Maybe<EdmOrganization>;
  plannedStart?: Maybe<Scalars['EdmDateTime']['output']>;
  prescriptions?: Maybe<Array<EdmPrescription>>;
  procedures: Array<EdmProcedure>;
  proceduresForCratedOnVisit: Array<EdmProcedure>;
  recommendation?: Maybe<Scalars['String']['output']>;
  referrals?: Maybe<Array<EdmReferral>>;
  sickLeaves?: Maybe<Array<EdmSickLeave>>;
  slotType?: Maybe<EdmSlotType>;
  status: EdmVisitStatus;
  type?: Maybe<EdmVisitType>;
  vitals?: Maybe<Array<EdmVital>>;
};

export type EdmLaboratoryExamination = {
  __typename?: 'EdmLaboratoryExamination';
  createdAt: Scalars['EdmDateTime']['output'];
  executionLimit: Scalars['String']['output'];
  faqType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  material: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EdmLanguage =
  | 'en'
  | 'pl'
  | 'uk';

export type EdmLeaveType =
  | 'BREAK'
  | 'ILLNESS'
  | 'MEETING'
  | 'OFFICE_VENTILATION'
  | 'OVERTIME'
  | 'PAID_HOLIDAY'
  | 'UNPAID_HOLIDAY';

export type EdmMeasurement = {
  __typename?: 'EdmMeasurement';
  age: EdmMeasurementAge;
  growthStandard?: Maybe<EdmGrowthStandard>;
  id: Scalars['ID']['output'];
  measuredAt: Scalars['EdmDateTime']['output'];
  percentile?: Maybe<Scalars['Float']['output']>;
  type: EdmMeasurementType;
  value: Scalars['Float']['output'];
};

export type EdmMeasurementAge = {
  __typename?: 'EdmMeasurementAge';
  inDays: Scalars['Float']['output'];
  inMonths: Scalars['Float']['output'];
  inYears: Scalars['Float']['output'];
};

export type EdmMeasurementDataInput = {
  adultData?: InputMaybe<EdmAdultDataInput>;
  childrenData?: InputMaybe<EdmChildrenMeasurementDataInput>;
};

export type EdmMeasurementHistory = {
  __typename?: 'EdmMeasurementHistory';
  bmi: Array<EdmMeasurement>;
  headCircumference: Array<EdmMeasurement>;
  height: Array<EdmMeasurement>;
  weight: Array<EdmMeasurement>;
};

export type EdmMeasurementType =
  | 'BMI'
  | 'HEAD_CIRCUMFERENCE'
  | 'HEIGHT'
  | 'WEIGHT';

export type EdmMedicalAppShift = {
  __typename?: 'EdmMedicalAppShift';
  comment?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  createdBy: EdmMedicalPerson;
  day: Scalars['EdmDateTime']['output'];
  durationTimeMap: EdmDurationTimeMap;
  endedAt: Scalars['EdmDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  staff: EdmMedicalPerson;
  startFrom: Scalars['EdmDateTime']['output'];
  state: EdmMedicalAppShiftState;
  status: EdmMedicalAppShiftStatus;
  visitTypes: Array<EdmMedicalAppVisitType>;
  visits: Array<EdmClinicManagerVisit>;
  workPlace: EdmMedicalAppShiftWorkPlace;
};

export type EdmMedicalAppShiftState =
  | 'DELETED'
  | 'DRAFT'
  | 'PRE_DELETED'
  | 'PUBLISHED';

export type EdmMedicalAppShiftStatus =
  | 'ACCEPTING_BOTH'
  | 'ACCEPTING_NFZ'
  | 'ACCEPTING_PRIV';

export type EdmMedicalAppShiftWorkPlace =
  | 'IN_CLINIC'
  | 'IN_HOME';

export type EdmMedicalAppVisitType =
  | 'COLLECTION'
  | 'DIETETICS'
  | 'DOCTOR_HOUSE_CALL'
  | 'DOCTOR_TELEMEDICAL_INFECTION'
  | 'EXPRESS_APPOINTMENT'
  | 'HEALTHY_CHILDREN_CHECKUP'
  | 'HEALTHY_CHILDREN_CHECKUP_AND_VACCINE'
  | 'HEALTHY_CHILDREN_PATRONAGE'
  | 'HEALTHY_CHILDREN_VACCINE'
  | 'IN_PERSON'
  | 'MIDWIFE_HOUSE_CALL'
  | 'MIDWIFE_IN_PERSON'
  | 'NURSE_HEALTHY_CHILDREN'
  | 'NURSE_HOUSE_CALL'
  | 'NURSE_IN_PERSON'
  | 'NURSE_IN_PERSON_INFECTION'
  | 'PRESCRIPTION_APPOINTMENT'
  | 'PROCEDURE'
  | 'RADIOLOGY_APPOINTMENT'
  | 'SICK_CHILDREN'
  | 'SPECIALIST'
  | 'TELEMEDICAL';

export type EdmMedicalPerson = {
  __typename?: 'EdmMedicalPerson';
  acceptAdults: Scalars['Boolean']['output'];
  acceptChildren: Scalars['Boolean']['output'];
  adultDeclarable: Scalars['Boolean']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  durationVisitTypes?: Maybe<EdmVisitTimeDuration>;
  firstname?: Maybe<Scalars['String']['output']>;
  gender: EdmGender;
  genre: EdmGenreType;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<EdmPreferences>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type EdmMedicalRecord = {
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  source: EdmMedicalRecordSource;
};

export type EdmMedicalRecordSource =
  | 'CHAT'
  | 'CHAT_LLM'
  | 'DRIVE'
  | 'EKG';

export type EdmNonWorkingPeriod = {
  __typename?: 'EdmNonWorkingPeriod';
  comment?: Maybe<Scalars['String']['output']>;
  day: Scalars['EdmDateTime']['output'];
  endedAt: Scalars['EdmDateTime']['output'];
  id: Scalars['ID']['output'];
  leaveType: EdmLeaveType;
  staff: EdmMedicalPerson;
  startFrom: Scalars['EdmDateTime']['output'];
};

export type EdmOrganization = {
  __typename?: 'EdmOrganization';
  city: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  street: Scalars['String']['output'];
};

export type EdmPatient = {
  __typename?: 'EdmPatient';
  avatar?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  patientCardNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  stayAddresses?: Maybe<Array<EdmStayAddress>>;
};

export type EdmPayer = {
  __typename?: 'EdmPayer';
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nip: Scalars['String']['output'];
  passportNumber?: Maybe<Scalars['String']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  pueProfile?: Maybe<Scalars['Boolean']['output']>;
};

export type EdmPolmedVisit = {
  __typename?: 'EdmPolmedVisit';
  createdAt: Scalars['EdmDateTime']['output'];
  id: Scalars['ID']['output'];
  isPrescription: Scalars['Boolean']['output'];
  medicalPerson?: Maybe<EdmMedicalPerson>;
  organization?: Maybe<EdmOrganization>;
  plannedStart?: Maybe<Scalars['EdmDateTime']['output']>;
  serviceType?: Maybe<EdmServiceType>;
  slotType?: Maybe<EdmSlotType>;
  status: EdmVisitStatus;
  type?: Maybe<EdmVisitType>;
};

export type EdmPreferences = {
  __typename?: 'EdmPreferences';
  minAllowedChildAge?: Maybe<Scalars['Int']['output']>;
};

export type EdmPrescription = {
  __typename?: 'EdmPrescription';
  code: Scalars['String']['output'];
  createdAt: Scalars['EdmDateTime']['output'];
  drugs: Array<EdmDrug>;
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  patient: EdmPatient;
  startsToWork: Scalars['String']['output'];
  visit: EdmInternalVisit;
};

export type EdmProcedure = {
  __typename?: 'EdmProcedure';
  descriptions: Array<EdmProcedureDescriptionElement>;
  executionLimit: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: EdmProcedureType;
};

export type EdmProcedureDescriptionElement = {
  __typename?: 'EdmProcedureDescriptionElement';
  content: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type EdmProcedureType =
  | 'BANDAGE'
  | 'CHUK_EDUCATION'
  | 'CHUK_MEASUREMENTS'
  | 'DOCTOR_ADVICE'
  | 'DRUGPASS'
  | 'EDUCATION'
  | 'EKG'
  | 'MEDICAL_ACT'
  | 'MIDWIFE_EDUCATIONAL_VISIT'
  | 'NURSE_ADVICE'
  | 'OBJECT'
  | 'PATRONAGE_VISIT'
  | 'SPIRO'
  | 'SPIROMETRY'
  | 'STITCHES'
  | 'TUBERCULOSIS_EDUCATION'
  | 'USG'
  | 'VACCINE';

export type EdmPublishShiftsInput = {
  fromDate: Scalars['EdmDateTime']['input'];
  organizationId: Scalars['String']['input'];
  toDate: Scalars['EdmDateTime']['input'];
};

export type EdmRecentActivity = EdmInternalVisit | EdmPolmedVisit | EdmPrescription | EdmReferral | EdmSickLeave | EdmVitalListItem;

export type EdmReferral = {
  __typename?: 'EdmReferral';
  clinic: EdmClinic;
  createdAt: Scalars['EdmDateTime']['output'];
  icd10: EdmIcd10;
  id: Scalars['ID']['output'];
  patient: EdmPatient;
  referralCode: Scalars['String']['output'];
  referralType: Scalars['String']['output'];
  visit: EdmInternalVisit;
};

export type EdmResultResponse = {
  __typename?: 'EdmResultResponse';
  success: Scalars['Boolean']['output'];
};

export type EdmSearchMode =
  | 'DEFAULT'
  | 'FALLBACK_INFECTIONS';

export type EdmServiceType =
  | 'ALERGOLOGICZNA_ONLINE'
  | 'CHIRURGICZNA_W_GABINECIE'
  | 'CHIRURGII_NACZYNIOWEJ_W_GABINECIE'
  | 'CHIRURGII_ONKOLOGICZNEJ_W_GABINECIE'
  | 'DERMATOLOGICZNA_ONLINE'
  | 'DERMATOLOGICZNA_W_GABINECIE'
  | 'DIABETOLOGICZNA_ONLINE'
  | 'DIABETOLOGICZNA_W_GABINECIE'
  | 'DIETETYCZNA_W_GABINECIE'
  | 'ENDOKRYNOLOGICZNA_ONLINE'
  | 'ENDOKRYNOLOGICZNA_W_GABINECIE'
  | 'GASTROLOGICZNA_W_GABINECIE'
  | 'GINEKOLOGICZNA_ONLINE'
  | 'GINEKOLOGICZNA_W_GABINECIE'
  | 'HIPERTENSJOLOGICZNA_W_GABINECIE'
  | 'INTERNISTYCZNA_ONLINE'
  | 'KARDIOLOGICZNA_ONLINE'
  | 'KARDIOLOGICZNA_W_GABINECIE'
  | 'LARYNGOLOGICZNA_ONLINE'
  | 'LARYNGOLOGICZNA_W_GABINECIE'
  | 'NEFROLOGICZNA_W_GABINECIE'
  | 'NEUROLOGICZNA_ONLINE'
  | 'NEUROLOGICZNA_W_GABINECIE'
  | 'OKULISTYCZNA_ONLINE'
  | 'OKULISTYCZNA_W_GABINECIE'
  | 'ONKOLOGICZNA_W_GABINECIE'
  | 'ORTOPEDYCZNA_ONLINE'
  | 'ORTOPEDYCZNA_W_GABINECIE'
  | 'PROKTOLOGICZNA_W_GABINECIE'
  | 'PSYCHIATRYCZNA_W_GABINECIE'
  | 'PSYCHOLOGICZNA_ONLINE'
  | 'PSYCHOLOGICZNA_W_GABINECIE'
  | 'PULMUNOLOGICZNA_ONLINE'
  | 'PULMUNOLOGICZNA_W_GABINECIE'
  | 'REUMATOLOGICZNA_ONLINE'
  | 'REUMATOLOGICZNA_W_GABINECIE'
  | 'STOMATOLOGICZNA_W_GABINECIE'
  | 'UROLOGICZNA_ONLINE'
  | 'UROLOGICZNA_W_GABINECIE';

export type EdmSex =
  | 'FEMALE'
  | 'MALE';

export type EdmShift = {
  __typename?: 'EdmShift';
  id: Scalars['ID']['output'];
  staffId: Scalars['String']['output'];
  version: Scalars['Float']['output'];
};

export type EdmShiftBulk = {
  __typename?: 'EdmShiftBulk';
  erroredDays: Array<Scalars['EdmDateTime']['output']>;
  shifts: Array<EdmMedicalAppShift>;
};

export type EdmShiftSearchAvailabilityForDayInput = {
  acceptChildren: Scalars['Boolean']['input'];
  date: Scalars['EdmDateTime']['input'];
  languages: Array<Scalars['String']['input']>;
  mode?: InputMaybe<EdmSearchMode>;
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  procedureType?: InputMaybe<Scalars['String']['input']>;
  rawTriageData?: InputMaybe<Scalars['String']['input']>;
  serviceIds: Array<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
  visitType: EdmMedicalAppVisitType;
};

export type EdmShiftSearchAvailabilityInput = {
  acceptChildren: Scalars['Boolean']['input'];
  languages: Array<Scalars['String']['input']>;
  limitDays?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<EdmSearchMode>;
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  procedureType?: InputMaybe<Scalars['String']['input']>;
  rawTriageData?: InputMaybe<Scalars['String']['input']>;
  serviceIds: Array<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
  visitType: EdmMedicalAppVisitType;
};

export type EdmShiftsConfirmationInput = {
  shiftIds: Array<Scalars['String']['input']>;
};

export type EdmSickLeave = {
  __typename?: 'EdmSickLeave';
  createdAt: Scalars['EdmDateTime']['output'];
  guardian?: Maybe<EdmGuardian>;
  id: Scalars['ID']['output'];
  inabilitySince: Scalars['EdmDateTime']['output'];
  inabilityUntil: Scalars['EdmDateTime']['output'];
  patient: EdmPatient;
  payers: Array<EdmPayer>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stayAddress?: Maybe<EdmSickLeaveStayAddress>;
  visit: EdmInternalVisit;
};

export type EdmSickLeaveStayAddress = {
  __typename?: 'EdmSickLeaveStayAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type EdmSlot = {
  __typename?: 'EdmSlot';
  from: Scalars['EdmDateTime']['output'];
  shifts: Array<EdmShift>;
  to: Scalars['EdmDateTime']['output'];
  visitType: EdmMedicalAppVisitType;
};

export type EdmSlotType =
  | 'COLLECTION'
  | 'DIETARY'
  | 'EXPRESS'
  | 'HOME'
  | 'INFECTIONS'
  | 'INFECTIONS_PRIVATE'
  | 'INFECTIONS_PUBLIC'
  | 'MIDWIFE'
  | 'NURSE_VISIT'
  | 'PERSONAL'
  | 'PROCEDURES'
  | 'SPECIALIST'
  | 'SPECIALIST_DOCTOR'
  | 'TELEMEDICAL'
  | 'TELEMEDICAL_NEW_CITIES'
  | 'TELEMEDICAL_PRIVATE'
  | 'USG';

export type EdmSnippet = {
  __typename?: 'EdmSnippet';
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  counter: Scalars['Float']['output'];
  createdAt: Scalars['EdmDateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<EdmSnippetTag>;
  type: EdmSnippetType;
  updatedAt?: Maybe<Scalars['EdmDateTime']['output']>;
  visibility: EdmSnippetVisibility;
};

export type EdmSnippetTag = {
  __typename?: 'EdmSnippetTag';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EdmSnippetType =
  | 'CHAT'
  | 'DOCS'
  | 'USG';

export type EdmSnippetVisibility =
  | 'PRIVATE'
  | 'PUBLIC';

export type EdmStaffWorkingHours = {
  __typename?: 'EdmStaffWorkingHours';
  medicalPerson: EdmMedicalPerson;
  workedHours?: Maybe<EdmWorkedHours>;
};

export type EdmStayAddress = {
  __typename?: 'EdmStayAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type EdmUpdateDeclarationInput = {
  adultDeclarable: Scalars['Boolean']['input'];
  childrenDeclarable: Scalars['Boolean']['input'];
};

export type EdmUpdateMedicalMeasurementInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  data: EdmMeasurementDataInput;
};

export type EdmUpdatePreferencesInput = {
  adultsAvailable: Scalars['Boolean']['input'];
  childrenAvailable: Scalars['Boolean']['input'];
  languages: Array<EdmLanguage>;
  minAllowedChildAge?: InputMaybe<Scalars['Int']['input']>;
};

export type EdmUpdateSnippetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<EdmSnippetType>;
  visibility?: InputMaybe<EdmSnippetVisibility>;
};

export type EdmUpdateStaffVisitDurationInput = {
  COLLECTION?: InputMaybe<Scalars['Int']['input']>;
  DOCTOR_HOUSE_CALL?: InputMaybe<Scalars['Int']['input']>;
  DOCTOR_TELEMEDICAL_INFECTION?: InputMaybe<Scalars['Int']['input']>;
  EXPRESS_APPOINTMENT?: InputMaybe<Scalars['Int']['input']>;
  HEALTHY_CHILDREN_CHECKUP?: InputMaybe<Scalars['Int']['input']>;
  HEALTHY_CHILDREN_CHECKUP_AND_VACCINE?: InputMaybe<Scalars['Int']['input']>;
  HEALTHY_CHILDREN_PATRONAGE?: InputMaybe<Scalars['Int']['input']>;
  HEALTHY_CHILDREN_VACCINE?: InputMaybe<Scalars['Int']['input']>;
  IN_PERSON?: InputMaybe<Scalars['Int']['input']>;
  MIDWIFE_HOUSE_CALL?: InputMaybe<Scalars['Int']['input']>;
  MIDWIFE_IN_PERSON?: InputMaybe<Scalars['Int']['input']>;
  NURSE_HEALTHY_CHILDREN?: InputMaybe<Scalars['Int']['input']>;
  NURSE_HOUSE_CALL?: InputMaybe<Scalars['Int']['input']>;
  NURSE_IN_PERSON?: InputMaybe<Scalars['Int']['input']>;
  NURSE_IN_PERSON_INFECTION?: InputMaybe<Scalars['Int']['input']>;
  PRESCRIPTION_APPOINTMENT?: InputMaybe<Scalars['Int']['input']>;
  PROCEDURE?: InputMaybe<Scalars['Int']['input']>;
  RADIOLOGY_APPOINTMENT?: InputMaybe<Scalars['Int']['input']>;
  SPECIALIST?: InputMaybe<Scalars['Int']['input']>;
  TELEMEDICAL?: InputMaybe<Scalars['Int']['input']>;
};

export type EdmVisitStatus =
  | 'CLOSED'
  | 'PENDING'
  | 'UPCOMING';

export type EdmVisitTimeDuration = {
  __typename?: 'EdmVisitTimeDuration';
  COLLECTION?: Maybe<Scalars['Int']['output']>;
  DOCTOR_HOUSE_CALL?: Maybe<Scalars['Int']['output']>;
  DOCTOR_TELEMEDICAL_INFECTION?: Maybe<Scalars['Int']['output']>;
  EXPRESS_APPOINTMENT?: Maybe<Scalars['Int']['output']>;
  HEALTHY_CHILDREN_CHECKUP?: Maybe<Scalars['Int']['output']>;
  HEALTHY_CHILDREN_CHECKUP_AND_VACCINE?: Maybe<Scalars['Int']['output']>;
  HEALTHY_CHILDREN_PATRONAGE?: Maybe<Scalars['Int']['output']>;
  HEALTHY_CHILDREN_VACCINE?: Maybe<Scalars['Int']['output']>;
  IN_PERSON?: Maybe<Scalars['Int']['output']>;
  MIDWIFE_HOUSE_CALL?: Maybe<Scalars['Int']['output']>;
  MIDWIFE_IN_PERSON?: Maybe<Scalars['Int']['output']>;
  NURSE_HEALTHY_CHILDREN?: Maybe<Scalars['Int']['output']>;
  NURSE_HOUSE_CALL?: Maybe<Scalars['Int']['output']>;
  NURSE_IN_PERSON?: Maybe<Scalars['Int']['output']>;
  NURSE_IN_PERSON_INFECTION?: Maybe<Scalars['Int']['output']>;
  PRESCRIPTION_APPOINTMENT?: Maybe<Scalars['Int']['output']>;
  PROCEDURE?: Maybe<Scalars['Int']['output']>;
  RADIOLOGY_APPOINTMENT?: Maybe<Scalars['Int']['output']>;
  SPECIALIST?: Maybe<Scalars['Int']['output']>;
  TELEMEDICAL?: Maybe<Scalars['Int']['output']>;
};

export type EdmVisitType =
  | 'PROCEDURE'
  | 'STANDARD'
  | 'VIRTUAL';

export type EdmVisitUnionType = EdmInternalVisit | EdmPolmedVisit | EdmVoucherVisit;

export type EdmVital = {
  __typename?: 'EdmVital';
  createdAt: Scalars['EdmDateTime']['output'];
  deliveredAt?: Maybe<Scalars['EdmDateTime']['output']>;
  details?: Maybe<Array<EdmVitalDetail>>;
  fileUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  measuredAt?: Maybe<Scalars['EdmDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patient: EdmPatient;
  visit: EdmInternalVisit;
};

export type EdmVitalDetail = {
  __typename?: 'EdmVitalDetail';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EdmVitalListItem = {
  __typename?: 'EdmVitalListItem';
  createdAt: Scalars['EdmDateTime']['output'];
  plannedStart: Scalars['EdmDateTime']['output'];
  visitId?: Maybe<Scalars['String']['output']>;
  vitalNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type EdmVoucherVisit = {
  __typename?: 'EdmVoucherVisit';
  code: Scalars['String']['output'];
  createdAt: Scalars['EdmDateTime']['output'];
  customerCode: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPrescription: Scalars['Boolean']['output'];
  laboratoryExaminations: Array<EdmLaboratoryExamination>;
};

export type EdmWorkedHours = {
  __typename?: 'EdmWorkedHours';
  alreadyWorkedHours: Scalars['String']['output'];
  expectedWorkingHours?: Maybe<Scalars['String']['output']>;
  hoursToWorkLeft?: Maybe<Scalars['String']['output']>;
};

export type EdmWorkingHours = {
  __typename?: 'EdmWorkingHours';
  expectedWorkingHours: EdmExpectedWorkingHours;
  month: Scalars['EdmDateTime']['output'];
  staffId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  doctorAddDeclarationScanToNFZEvent: Scalars['String']['output'];
  doctorAddImmunizationCalendar: Scalars['Boolean']['output'];
  doctorArchiveDocument: Scalars['String']['output'];
  doctorCancelIpom: Scalars['Boolean']['output'];
  doctorChangePassword: Scalars['String']['output'];
  doctorCheckPatientEwusStatus: Scalars['String']['output'];
  doctorCleanReports: Scalars['String']['output'];
  doctorClosePatient: DoctorMSPatient;
  doctorCloseVisit: DoctorMSVisit;
  doctorCreateAssignment: Scalars['String']['output'];
  doctorCreateChatMessage: Scalars['String']['output'];
  doctorCreateCovidExamination: Scalars['String']['output'];
  doctorCreateDocument: DoctorMSMedicalRecordEntity;
  doctorCreateIPOM: DoctorMSCreateIPOMWithOperationResult;
  doctorCreateIpomAssignment: Scalars['String']['output'];
  doctorCreateLaboratoryExaminations: Array<DoctorMSLaboratoryExaminationEntity>;
  doctorCreateNFZEvent: Scalars['String']['output'];
  doctorCreatePatient: Scalars['String']['output'];
  doctorCreatePatientTag: Scalars['String']['output'];
  doctorCreateProcedure: DoctorMSProcedureEntity;
  doctorCreateProcedureNew: DoctorMSProcedureEntity;
  doctorCreateSnippet: DoctorMSSnippet;
  doctorCreateSurvey: Scalars['String']['output'];
  doctorCreateVisit: Scalars['String']['output'];
  doctorCreateVisitSlot: Scalars['String']['output'];
  doctorCreateVisitSlot2: Scalars['String']['output'];
  doctorCreateVital: Scalars['String']['output'];
  doctorDeleteChatMessage: Scalars['String']['output'];
  doctorDeleteNFZEvent: Scalars['String']['output'];
  doctorDeletePatient: Scalars['String']['output'];
  doctorDeletePatientTag: Scalars['String']['output'];
  doctorDeletePrescription: Scalars['String']['output'];
  doctorDeleteSnippet: DoctorMSSnippet;
  doctorDeleteTestimonial: Scalars['String']['output'];
  doctorDeleteVisit: DoctorMSVisit;
  doctorDeleteVisit2: DoctorMSVisit;
  doctorDeleteVisitSpecialistSlot: Scalars['String']['output'];
  doctorDeleteVital: Scalars['String']['output'];
  doctorForceCreateVisit: DoctorMSVisit;
  doctorForceCreateVisit2: DoctorMSVisit;
  doctorForceVisit: DoctorMSVisit;
  doctorForceVisit2: DoctorMSVisit;
  doctorGenerateDeclaration: DoctorMSDocumentGenerationResult;
  doctorGenerateIpomPdfDocument: DoctorMSDocumentGenerationResult;
  doctorGenerateTestimonial: DoctorMSDocumentGenerationResult;
  doctorGenerateUsgResultsDocument: DoctorMSDocumentGenerationResult;
  doctorGetContentFromImage: Scalars['String']['output'];
  /** Returns null if there is no requests, try to refresh count of requests and try again */
  doctorGetOnePrescriptionRequest?: Maybe<DoctorMSVisit>;
  doctorGetOpenPrescriptionVisits: Array<DoctorMSVisit>;
  doctorIssueCareLeave: DoctorMSIssueMedicalOrCareLeaveResult;
  doctorIssueMedicalLeave: Scalars['String']['output'];
  doctorIssueMedicalLeaveNew: DoctorMSIssueMedicalOrCareLeaveResult;
  doctorIssueNursePrescription: DoctorMSIssuePrescriptionWithOperationResult;
  doctorIssuePrescription: DoctorMSIssuePrescriptionWithOperationResult;
  doctorIssueReferral: Scalars['String']['output'];
  doctorLoadUMX: Scalars['String']['output'];
  doctorLogPayment: Scalars['String']['output'];
  doctorMakeCall: Scalars['DoctorMSJSON']['output'];
  doctorMarkPostsAsSeen: Array<Scalars['String']['output']>;
  doctorPatientLeftVisit: DoctorMSVisit;
  doctorPatientShowedUpForAVisit: DoctorMSVisit;
  doctorPublishTimeEntries: Scalars['Int']['output'];
  doctorPushNFZStatusToFirebase: Scalars['String']['output'];
  doctorPushNFZStatusesToFirebase: Array<Scalars['String']['output']>;
  doctorRefreshToken: DoctorMSTokensPayload;
  doctorRefreshVaccinations: Scalars['String']['output'];
  doctorReopenVisit: Scalars['String']['output'];
  doctorReportPrepare: Scalars['String']['output'];
  doctorRevokeAssignment: Scalars['String']['output'];
  doctorSaveHealthInsuranceStatement: Scalars['String']['output'];
  doctorSendInvitationForVisit: Scalars['String']['output'];
  doctorSendRecommendation: DoctorMSChatMessageEntity;
  doctorShowSnippet: DoctorMSDoctor;
  doctorSimulateLabExamUpload: Scalars['Boolean']['output'];
  doctorStartVisit: DoctorMSVisit;
  doctorSwiadPrepare: Scalars['String']['output'];
  doctorUnpinAllPatients: Scalars['Int']['output'];
  doctorUnpinPatient: DoctorMSPatient;
  doctorUnpinProcedure: DoctorMSProcedureEntity;
  doctorUpdateDeclarationNFZEventComment: Scalars['String']['output'];
  doctorUpdateDocument: Scalars['String']['output'];
  doctorUpdateLaboratoryExaminations: Array<Scalars['String']['output']>;
  doctorUpdateMe: Scalars['String']['output'];
  doctorUpdatePatient: Scalars['String']['output'];
  doctorUpdatePatientTag: Scalars['String']['output'];
  doctorUpdateProcedure: Scalars['String']['output'];
  doctorUpdateProcedureNew: Scalars['String']['output'];
  doctorUpdateSnippet: DoctorMSSnippet;
  doctorUpdateTodo: Scalars['Boolean']['output'];
  doctorUpdateUserAddress: DoctorMSPatient;
  doctorUpdateVisit: Scalars['String']['output'];
  doctorUpdateVisitSlot: DoctorMSVisit;
  doctorUpdateVisitSlot2: DoctorMSVisit;
  doctorUpdateVisitSlot2ForMedicalApp: DoctorMSVisit;
  doctorUpdateVisitSpecialistSlot: DoctorMSVisit;
  doctorUpdateVital: Scalars['String']['output'];
  doctorUpsertShift: Scalars['Int']['output'];
  doctorUpsertSingleProcedure: Scalars['String']['output'];
  doctorWaitingForPatient: DoctorMSPatient;
  edmCancelShiftsConfirmation: Array<EdmMedicalAppShift>;
  edmConfirmShifts: Array<EdmMedicalAppShift>;
  edmCreateMedicalMeasurement: EdmResultResponse;
  edmCreateMedicalRecordFileReference: EdmResultResponse;
  edmCreateNonWorkingPeriod: EdmNonWorkingPeriod;
  edmCreateShift: EdmMedicalAppShift;
  edmCreateShiftsBulk: EdmShiftBulk;
  edmCreateSnippet: EdmSnippet;
  /** If same staffId and month will be provide BE will update data */
  edmDefineWorkingHours: EdmWorkingHours;
  edmDeleteMedicalMeasurement: Scalars['String']['output'];
  edmDeleteNonWorkingPeriod: EdmResultResponse;
  edmDeleteShift: EdmMedicalAppShift;
  edmDeleteSnippetById: EdmResultResponse;
  edmDeleteWorkingHours: EdmResultResponse;
  edmGenerateDocumentation: EdmResultResponse;
  edmGenerateIpomDocumentation: EdmDocumentGenerationResult;
  edmGenerateVisitSummary: EdmDocumentGenerationResult;
  edmIncreaseSnippetCounter: EdmResultResponse;
  edmPublishShift: EdmMedicalAppShift;
  edmPublishShifts: Array<EdmMedicalAppShift>;
  edmUpdateDeclarations: EdmResultResponse;
  edmUpdateMedicalMeasurement: Scalars['String']['output'];
  edmUpdatePreferences: EdmResultResponse;
  edmUpdateSnippet: EdmSnippet;
  edmUpdateStaffVisitDuration: EdmVisitTimeDuration;
  patientAddChild: Scalars['String']['output'];
  patientAddDeclaration: Scalars['String']['output'];
  patientCancelPrescriptionRequest: Scalars['String']['output'];
  patientCancelSlotsReservationForFirstVisit: Scalars['String']['output'];
  patientCancelVisit: Scalars['String']['output'];
  patientCancelVisit2: Scalars['String']['output'];
  patientChangeNotificationAgreement: Scalars['String']['output'];
  patientCreateChatMessage: Scalars['String']['output'];
  patientCreateEvent: Scalars['PatientMSJSON']['output'];
  patientCreateLaboratoryExaminations: Array<PatientMSLaboratoryExaminationEntity>;
  patientCreatePaymentSessionForLabExaminations: PatientMSStripePaymentEntity;
  patientCreateProcedure: PatientMSProcedureEntity;
  patientCreateProcedureNew: PatientMSProcedureEntity;
  patientCreateSystemChatMessage: Scalars['String']['output'];
  patientCreateVisit2: PatientMSVisit;
  patientCreateVisit3: PatientMSVisit;
  patientCreateVisitFromSlotReservation: Scalars['String']['output'];
  patientDeleteChatMessage: Scalars['String']['output'];
  patientDeleteInfoBox: Scalars['Boolean']['output'];
  patientDeleteVisitSpecialistSlot: Scalars['String']['output'];
  patientGenerateInviteCodes: Scalars['String']['output'];
  patientGetAnalyticsId: Scalars['PatientMSJSON']['output'];
  patientImWaiting: Scalars['String']['output'];
  patientLogoutPatient: Scalars['Boolean']['output'];
  patientMakeComplaint: Scalars['String']['output'];
  patientMakeDiagVoucher: Scalars['String']['output'];
  patientMakePrescriptionRequest: PatientMSPrescriptionRequestDto;
  patientMarkVisitFaqAsRead: Scalars['String']['output'];
  patientPrefillVisit: Scalars['String']['output'];
  patientRateVisit: Scalars['String']['output'];
  patientRefreshToken: PatientMSTokensPayload;
  patientReserveSlotsForFirstVisit: PatientMSSlotReservationEntity;
  patientReserveSpecialistSlot: PatientMSSlotReservationEntity;
  patientSaveAnalyticsSurvey: Scalars['String']['output'];
  patientSaveHealthInsuranceStatement: Scalars['Boolean']['output'];
  patientSendNfzDeclaration: PatientMSPatient;
  patientSetPESEL: Scalars['String']['output'];
  patientSetPhone: Scalars['String']['output'];
  patientSmsInvite: Scalars['Boolean']['output'];
  patientStripeGenerate: Scalars['String']['output'];
  patientUpdateLaboratoryExaminations: Array<Scalars['String']['output']>;
  patientUpdateMeNew: PatientMSPatient;
  patientUpdateMessagePositions: Scalars['String']['output'];
  patientUpdateProcedure: Scalars['String']['output'];
  patientUpdateProcedureNew: Scalars['String']['output'];
  patientUpdateSurvey: Scalars['String']['output'];
  patientUpdateUserAddress: PatientMSPatient;
  patientUpdateVisitSlot: PatientMSVisit;
  patientUpdateVisitSlot2: PatientMSVisit;
  patientUpdateVisitSlot2ForMedicalApp: PatientMSVisit;
  patientUpdateVisitSpecialistSlot: PatientMSVisit;
  patientUseInviteCode: Scalars['String']['output'];
  /**
   * Create a new address for the customer.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorAccountAddressCreate?: Maybe<SaleorAccountAddressCreate>;
  /** Delete an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER. */
  saleorAccountAddressDelete?: Maybe<SaleorAccountAddressDelete>;
  /** Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER. */
  saleorAccountAddressUpdate?: Maybe<SaleorAccountAddressUpdate>;
  /**
   * Remove user account.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorAccountDelete?: Maybe<SaleorAccountDelete>;
  /** Register a new user. */
  saleorAccountRegister?: Maybe<SaleorAccountRegister>;
  /**
   * Sends an email with the account removal link for the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorAccountRequestDeletion?: Maybe<SaleorAccountRequestDeletion>;
  /**
   * Sets a default address for the authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorAccountSetDefaultAddress?: Maybe<SaleorAccountSetDefaultAddress>;
  /**
   * Updates the account of the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorAccountUpdate?: Maybe<SaleorAccountUpdate>;
  /**
   * Creates user address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorAddressCreate?: Maybe<SaleorAddressCreate>;
  /**
   * Deletes an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorAddressDelete?: Maybe<SaleorAddressDelete>;
  /**
   * Sets a default address for the given user.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorAddressSetDefault?: Maybe<SaleorAddressSetDefault>;
  /**
   * Updates an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorAddressUpdate?: Maybe<SaleorAddressUpdate>;
  /**
   * Activate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppActivate?: Maybe<SaleorAppActivate>;
  /** Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
  saleorAppCreate?: Maybe<SaleorAppCreate>;
  /**
   * Deactivate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppDeactivate?: Maybe<SaleorAppDeactivate>;
  /**
   * Deletes an app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppDelete?: Maybe<SaleorAppDelete>;
  /**
   * Delete failed installation.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppDeleteFailedInstallation?: Maybe<SaleorAppDeleteFailedInstallation>;
  /**
   * Fetch and validate manifest.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppFetchManifest?: Maybe<SaleorAppFetchManifest>;
  /** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
  saleorAppInstall?: Maybe<SaleorAppInstall>;
  /**
   * Retry failed installation of new app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppRetryInstall?: Maybe<SaleorAppRetryInstall>;
  /**
   * Creates a new token.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppTokenCreate?: Maybe<SaleorAppTokenCreate>;
  /**
   * Deletes an authentication token assigned to app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppTokenDelete?: Maybe<SaleorAppTokenDelete>;
  /** Verify provided app token. */
  saleorAppTokenVerify?: Maybe<SaleorAppTokenVerify>;
  /**
   * Updates an existing app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppUpdate?: Maybe<SaleorAppUpdate>;
  /**
   * Assigns storefront's navigation menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
   */
  saleorAssignNavigation?: Maybe<SaleorAssignNavigation>;
  /**
   * Add shipping zone to given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorAssignWarehouseShippingZone?: Maybe<SaleorWarehouseShippingZoneAssign>;
  /**
   * Deletes attributes.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeBulkDelete?: Maybe<SaleorAttributeBulkDelete>;
  /** Creates an attribute. */
  saleorAttributeCreate?: Maybe<SaleorAttributeCreate>;
  /**
   * Deletes an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeDelete?: Maybe<SaleorAttributeDelete>;
  /**
   * Reorder the values of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeReorderValues?: Maybe<SaleorAttributeReorderValues>;
  /**
   * Creates/updates translations for an attribute.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorAttributeTranslate?: Maybe<SaleorAttributeTranslate>;
  /**
   * Updates attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeUpdate?: Maybe<SaleorAttributeUpdate>;
  /**
   * Deletes values of attributes.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeValueBulkDelete?: Maybe<SaleorAttributeValueBulkDelete>;
  /**
   * Creates a value for an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorAttributeValueCreate?: Maybe<SaleorAttributeValueCreate>;
  /**
   * Deletes a value of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeValueDelete?: Maybe<SaleorAttributeValueDelete>;
  /**
   * Creates/updates translations for an attribute value.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorAttributeValueTranslate?: Maybe<SaleorAttributeValueTranslate>;
  /**
   * Updates value of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorAttributeValueUpdate?: Maybe<SaleorAttributeValueUpdate>;
  /**
   * Deletes categories.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCategoryBulkDelete?: Maybe<SaleorCategoryBulkDelete>;
  /**
   * Creates a new category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCategoryCreate?: Maybe<SaleorCategoryCreate>;
  /**
   * Deletes a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCategoryDelete?: Maybe<SaleorCategoryDelete>;
  /**
   * Creates/updates translations for a category.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorCategoryTranslate?: Maybe<SaleorCategoryTranslate>;
  /**
   * Updates a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCategoryUpdate?: Maybe<SaleorCategoryUpdate>;
  /**
   * Activate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  saleorChannelActivate?: Maybe<SaleorChannelActivate>;
  /**
   * Creates new channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  saleorChannelCreate?: Maybe<SaleorChannelCreate>;
  /**
   * Deactivate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  saleorChannelDeactivate?: Maybe<SaleorChannelDeactivate>;
  /**
   * Delete a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  saleorChannelDelete?: Maybe<SaleorChannelDelete>;
  /**
   * Reorder the warehouses of a channel.
   *
   * Added in Saleor 3.7.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  saleorChannelReorderWarehouses?: Maybe<SaleorChannelReorderWarehouses>;
  /**
   * Update a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   * Requires one of the following permissions when updating only orderSettings field: MANAGE_CHANNELS, MANAGE_ORDERS.
   */
  saleorChannelUpdate?: Maybe<SaleorChannelUpdate>;
  /** Adds a gift card or a voucher to a checkout. */
  saleorCheckoutAddPromoCode?: Maybe<SaleorCheckoutAddPromoCode>;
  /** Update billing address in the existing checkout. */
  saleorCheckoutBillingAddressUpdate?: Maybe<SaleorCheckoutBillingAddressUpdate>;
  /** Completes the checkout. As a result a new order is created and a payment charge is made. This action requires a successful payment before it can be performed. In case additional confirmation step as 3D secure is required confirmationNeeded flag will be set to True and no order created until payment is confirmed with second call of this mutation. */
  saleorCheckoutComplete?: Maybe<SaleorCheckoutComplete>;
  /** Create a new checkout. */
  saleorCheckoutCreate?: Maybe<SaleorCheckoutCreate>;
  /**
   * Sets the customer as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   */
  saleorCheckoutCustomerAttach?: Maybe<SaleorCheckoutCustomerAttach>;
  /**
   * Removes the user assigned as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   */
  saleorCheckoutCustomerDetach?: Maybe<SaleorCheckoutCustomerDetach>;
  /**
   * Updates the delivery method (shipping method or pick up point) of the checkout.
   *
   * Added in Saleor 3.1.
   */
  saleorCheckoutDeliveryMethodUpdate?: Maybe<SaleorCheckoutDeliveryMethodUpdate>;
  /** Updates email address in the existing checkout object. */
  saleorCheckoutEmailUpdate?: Maybe<SaleorCheckoutEmailUpdate>;
  /** Update language code in the existing checkout. */
  saleorCheckoutLanguageCodeUpdate?: Maybe<SaleorCheckoutLanguageCodeUpdate>;
  /**
   * Deletes a CheckoutLine.
   * @deprecated This field will be removed in Saleor 4.0. Use `checkoutLinesDelete` instead.
   */
  saleorCheckoutLineDelete?: Maybe<SaleorCheckoutLineDelete>;
  /** Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased. */
  saleorCheckoutLinesAdd?: Maybe<SaleorCheckoutLinesAdd>;
  /** Deletes checkout lines. */
  saleorCheckoutLinesDelete?: Maybe<SaleorCheckoutLinesDelete>;
  /** Updates checkout line in the existing checkout. */
  saleorCheckoutLinesUpdate?: Maybe<SaleorCheckoutLinesUpdate>;
  /** Create a new payment for given checkout. */
  saleorCheckoutPaymentCreate?: Maybe<SaleorCheckoutPaymentCreate>;
  /** Remove a gift card or a voucher from a checkout. */
  saleorCheckoutRemovePromoCode?: Maybe<SaleorCheckoutRemovePromoCode>;
  /** Update shipping address in the existing checkout. */
  saleorCheckoutShippingAddressUpdate?: Maybe<SaleorCheckoutShippingAddressUpdate>;
  /**
   * Updates the shipping method of the checkout.
   * @deprecated This field will be removed in Saleor 4.0. Use `checkoutDeliveryMethodUpdate` instead.
   */
  saleorCheckoutShippingMethodUpdate?: Maybe<SaleorCheckoutShippingMethodUpdate>;
  /**
   * Adds products to a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionAddProducts?: Maybe<SaleorCollectionAddProducts>;
  /**
   * Deletes collections.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionBulkDelete?: Maybe<SaleorCollectionBulkDelete>;
  /**
   * Manage collection's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionChannelListingUpdate?: Maybe<SaleorCollectionChannelListingUpdate>;
  /**
   * Creates a new collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionCreate?: Maybe<SaleorCollectionCreate>;
  /**
   * Deletes a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionDelete?: Maybe<SaleorCollectionDelete>;
  /**
   * Remove products from a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionRemoveProducts?: Maybe<SaleorCollectionRemoveProducts>;
  /**
   * Reorder the products of a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionReorderProducts?: Maybe<SaleorCollectionReorderProducts>;
  /**
   * Creates/updates translations for a collection.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorCollectionTranslate?: Maybe<SaleorCollectionTranslate>;
  /**
   * Updates a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCollectionUpdate?: Maybe<SaleorCollectionUpdate>;
  /** Confirm user account with token sent by email during registration. */
  saleorConfirmAccount?: Maybe<SaleorConfirmAccount>;
  /**
   * Confirm the email change of the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorConfirmEmailChange?: Maybe<SaleorConfirmEmailChange>;
  /**
   * Creates new warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorCreateWarehouse?: Maybe<SaleorWarehouseCreate>;
  /**
   * Deletes customers.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorCustomerBulkDelete?: Maybe<SaleorCustomerBulkDelete>;
  /**
   * Updates customers.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorCustomerBulkUpdate?: Maybe<SaleorCustomerBulkUpdate>;
  /**
   * Creates a new customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorCustomerCreate?: Maybe<SaleorCustomerCreate>;
  /**
   * Deletes a customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorCustomerDelete?: Maybe<SaleorCustomerDelete>;
  /**
   * Updates an existing customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorCustomerUpdate?: Maybe<SaleorCustomerUpdate>;
  /** Delete metadata of an object. To use it, you need to have access to the modified object. */
  saleorDeleteMetadata?: Maybe<SaleorDeleteMetadata>;
  /** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
  saleorDeletePrivateMetadata?: Maybe<SaleorDeletePrivateMetadata>;
  /**
   * Deletes selected warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDeleteWarehouse?: Maybe<SaleorWarehouseDelete>;
  /**
   * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContentCreate?: Maybe<SaleorDigitalContentCreate>;
  /**
   * Remove digital content assigned to given variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContentDelete?: Maybe<SaleorDigitalContentDelete>;
  /**
   * Update digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContentUpdate?: Maybe<SaleorDigitalContentUpdate>;
  /**
   * Generate new URL to digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContentUrlCreate?: Maybe<SaleorDigitalContentUrlCreate>;
  /**
   * Deletes draft orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrderBulkDelete?: Maybe<SaleorDraftOrderBulkDelete>;
  /**
   * Completes creating an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrderComplete?: Maybe<SaleorDraftOrderComplete>;
  /**
   * Creates a new draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrderCreate?: Maybe<SaleorDraftOrderCreate>;
  /**
   * Deletes a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrderDelete?: Maybe<SaleorDraftOrderDelete>;
  /**
   * Deletes order lines.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  saleorDraftOrderLinesBulkDelete?: Maybe<SaleorDraftOrderLinesBulkDelete>;
  /**
   * Updates a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrderUpdate?: Maybe<SaleorDraftOrderUpdate>;
  /**
   * Retries event delivery.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorEventDeliveryRetry?: Maybe<SaleorEventDeliveryRetry>;
  /**
   * Export gift cards to csv file.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorExportGiftCards?: Maybe<SaleorExportGiftCards>;
  /**
   * Export products to csv file.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorExportProducts?: Maybe<SaleorExportProducts>;
  /** Prepare external authentication URL for user by custom plugin. */
  saleorExternalAuthenticationUrl?: Maybe<SaleorExternalAuthenticationUrl>;
  /** Logout user by custom plugin. */
  saleorExternalLogout?: Maybe<SaleorExternalLogout>;
  /**
   * Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload.
   *
   * Added in Saleor 3.1.
   */
  saleorExternalNotificationTrigger?: Maybe<SaleorExternalNotificationTrigger>;
  /** Obtain external access tokens for user by custom plugin. */
  saleorExternalObtainAccessTokens?: Maybe<SaleorExternalObtainAccessTokens>;
  /** Refresh user's access by custom plugin. */
  saleorExternalRefresh?: Maybe<SaleorExternalRefresh>;
  /** Verify external authentication data by plugin. */
  saleorExternalVerify?: Maybe<SaleorExternalVerify>;
  /**
   * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  saleorFileUpload?: Maybe<SaleorFileUpload>;
  /**
   * Activate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardActivate?: Maybe<SaleorGiftCardActivate>;
  /**
   * Adds note to the gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardAddNote?: Maybe<SaleorGiftCardAddNote>;
  /**
   * Activate gift cards.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardBulkActivate?: Maybe<SaleorGiftCardBulkActivate>;
  /**
   * Create gift cards.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardBulkCreate?: Maybe<SaleorGiftCardBulkCreate>;
  /**
   * Deactivate gift cards.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardBulkDeactivate?: Maybe<SaleorGiftCardBulkDeactivate>;
  /**
   * Delete gift cards.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardBulkDelete?: Maybe<SaleorGiftCardBulkDelete>;
  /**
   * Creates a new gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardCreate?: Maybe<SaleorGiftCardCreate>;
  /**
   * Deactivate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardDeactivate?: Maybe<SaleorGiftCardDeactivate>;
  /**
   * Delete gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardDelete?: Maybe<SaleorGiftCardDelete>;
  /**
   * Resend a gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardResend?: Maybe<SaleorGiftCardResend>;
  /**
   * Update gift card settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardSettingsUpdate?: Maybe<SaleorGiftCardSettingsUpdate>;
  /**
   * Update a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardUpdate?: Maybe<SaleorGiftCardUpdate>;
  /**
   * Creates a ready to send invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceCreate?: Maybe<SaleorInvoiceCreate>;
  /**
   * Deletes an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceDelete?: Maybe<SaleorInvoiceDelete>;
  /**
   * Request an invoice for the order using plugin.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceRequest?: Maybe<SaleorInvoiceRequest>;
  /**
   * Requests deletion of an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceRequestDelete?: Maybe<SaleorInvoiceRequestDelete>;
  /**
   * Send an invoice notification to the customer.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceSendNotification?: Maybe<SaleorInvoiceSendNotification>;
  /**
   * Updates an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorInvoiceUpdate?: Maybe<SaleorInvoiceUpdate>;
  /**
   * Deletes menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuBulkDelete?: Maybe<SaleorMenuBulkDelete>;
  /**
   * Creates a new Menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuCreate?: Maybe<SaleorMenuCreate>;
  /**
   * Deletes a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuDelete?: Maybe<SaleorMenuDelete>;
  /**
   * Deletes menu items.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuItemBulkDelete?: Maybe<SaleorMenuItemBulkDelete>;
  /**
   * Creates a new menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuItemCreate?: Maybe<SaleorMenuItemCreate>;
  /**
   * Deletes a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuItemDelete?: Maybe<SaleorMenuItemDelete>;
  /**
   * Moves items of menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuItemMove?: Maybe<SaleorMenuItemMove>;
  /**
   * Creates/updates translations for a menu item.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorMenuItemTranslate?: Maybe<SaleorMenuItemTranslate>;
  /**
   * Updates a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuItemUpdate?: Maybe<SaleorMenuItemUpdate>;
  /**
   * Updates a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   */
  saleorMenuUpdate?: Maybe<SaleorMenuUpdate>;
  /**
   * Adds note to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderAddNote?: Maybe<SaleorOrderAddNote>;
  /**
   * Cancels orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderBulkCancel?: Maybe<SaleorOrderBulkCancel>;
  /**
   * Cancel an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderCancel?: Maybe<SaleorOrderCancel>;
  /**
   * Capture an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderCapture?: Maybe<SaleorOrderCapture>;
  /**
   * Confirms an unconfirmed order by changing status to unfulfilled.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderConfirm?: Maybe<SaleorOrderConfirm>;
  /**
   * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
   *
   * Added in Saleor 3.2.
   */
  saleorOrderCreateFromCheckout?: Maybe<SaleorOrderCreateFromCheckout>;
  /**
   * Adds discount to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderDiscountAdd?: Maybe<SaleorOrderDiscountAdd>;
  /**
   * Remove discount from the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderDiscountDelete?: Maybe<SaleorOrderDiscountDelete>;
  /**
   * Update discount for the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderDiscountUpdate?: Maybe<SaleorOrderDiscountUpdate>;
  /**
   * Creates new fulfillments for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfill?: Maybe<SaleorOrderFulfill>;
  /**
   * Approve existing fulfillment.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfillmentApprove?: Maybe<SaleorFulfillmentApprove>;
  /**
   * Cancels existing fulfillment and optionally restocks items.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfillmentCancel?: Maybe<SaleorFulfillmentCancel>;
  /**
   * Refund products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfillmentRefundProducts?: Maybe<SaleorFulfillmentRefundProducts>;
  /**
   * Return products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfillmentReturnProducts?: Maybe<SaleorFulfillmentReturnProducts>;
  /**
   * Updates a fulfillment for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderFulfillmentUpdateTracking?: Maybe<SaleorFulfillmentUpdateTracking>;
  /**
   * Adds granted refund to the order.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderGrantRefundCreate?: Maybe<SaleorOrderGrantRefundCreate>;
  /**
   * Updates granted refund.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderGrantRefundUpdate?: Maybe<SaleorOrderGrantRefundUpdate>;
  /**
   * Deletes an order line from an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderLineDelete?: Maybe<SaleorOrderLineDelete>;
  /**
   * Remove discount applied to the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderLineDiscountRemove?: Maybe<SaleorOrderLineDiscountRemove>;
  /**
   * Update discount for the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderLineDiscountUpdate?: Maybe<SaleorOrderLineDiscountUpdate>;
  /**
   * Updates an order line of an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderLineUpdate?: Maybe<SaleorOrderLineUpdate>;
  /**
   * Create order lines for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderLinesCreate?: Maybe<SaleorOrderLinesCreate>;
  /**
   * Mark order as manually paid.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderMarkAsPaid?: Maybe<SaleorOrderMarkAsPaid>;
  /**
   * Refund an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderRefund?: Maybe<SaleorOrderRefund>;
  /**
   * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated
   *
   * DEPRECATED: this mutation will be removed in Saleor 4.0. Use `channelUpdate` mutation instead.
   */
  saleorOrderSettingsUpdate?: Maybe<SaleorOrderSettingsUpdate>;
  /**
   * Updates an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderUpdate?: Maybe<SaleorOrderUpdate>;
  /**
   * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderUpdateShipping?: Maybe<SaleorOrderUpdateShipping>;
  /**
   * Void an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrderVoid?: Maybe<SaleorOrderVoid>;
  /**
   * Assign attributes to a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageAttributeAssign?: Maybe<SaleorPageAttributeAssign>;
  /**
   * Unassign attributes from a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageAttributeUnassign?: Maybe<SaleorPageAttributeUnassign>;
  /**
   * Deletes pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageBulkDelete?: Maybe<SaleorPageBulkDelete>;
  /**
   * Publish pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageBulkPublish?: Maybe<SaleorPageBulkPublish>;
  /**
   * Creates a new page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageCreate?: Maybe<SaleorPageCreate>;
  /**
   * Deletes a page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageDelete?: Maybe<SaleorPageDelete>;
  /**
   * Reorder page attribute values.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageReorderAttributeValues?: Maybe<SaleorPageReorderAttributeValues>;
  /**
   * Creates/updates translations for a page.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorPageTranslate?: Maybe<SaleorPageTranslate>;
  /**
   * Delete page types.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageTypeBulkDelete?: Maybe<SaleorPageTypeBulkDelete>;
  /**
   * Create a new page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageTypeCreate?: Maybe<SaleorPageTypeCreate>;
  /**
   * Delete a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageTypeDelete?: Maybe<SaleorPageTypeDelete>;
  /**
   * Reorder the attributes of a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageTypeReorderAttributes?: Maybe<SaleorPageTypeReorderAttributes>;
  /**
   * Update page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  saleorPageTypeUpdate?: Maybe<SaleorPageTypeUpdate>;
  /**
   * Updates an existing page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  saleorPageUpdate?: Maybe<SaleorPageUpdate>;
  /**
   * Change the password of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorPasswordChange?: Maybe<SaleorPasswordChange>;
  /**
   * Captures the authorized payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorPaymentCapture?: Maybe<SaleorPaymentCapture>;
  /** Check payment balance. */
  saleorPaymentCheckBalance?: Maybe<SaleorPaymentCheckBalance>;
  /**
   * Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  saleorPaymentGatewayInitialize?: Maybe<SaleorPaymentGatewayInitialize>;
  /** Initializes payment process when it is required by gateway. */
  saleorPaymentInitialize?: Maybe<SaleorPaymentInitialize>;
  /**
   * Refunds the captured payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorPaymentRefund?: Maybe<SaleorPaymentRefund>;
  /**
   * Voids the authorized payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorPaymentVoid?: Maybe<SaleorPaymentVoid>;
  /**
   * Create new permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorPermissionGroupCreate?: Maybe<SaleorPermissionGroupCreate>;
  /**
   * Delete permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorPermissionGroupDelete?: Maybe<SaleorPermissionGroupDelete>;
  /**
   * Update permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorPermissionGroupUpdate?: Maybe<SaleorPermissionGroupUpdate>;
  /**
   * Update plugin configuration.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  saleorPluginUpdate?: Maybe<SaleorPluginUpdate>;
  /**
   * Assign attributes to a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductAttributeAssign?: Maybe<SaleorProductAttributeAssign>;
  /**
   * Update attributes assigned to product variant for given product type.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductAttributeAssignmentUpdate?: Maybe<SaleorProductAttributeAssignmentUpdate>;
  /**
   * Un-assign attributes from a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductAttributeUnassign?: Maybe<SaleorProductAttributeUnassign>;
  /**
   * Creates products.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductBulkCreate?: Maybe<SaleorProductBulkCreate>;
  /**
   * Deletes products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductBulkDelete?: Maybe<SaleorProductBulkDelete>;
  /**
   * Manage product's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductChannelListingUpdate?: Maybe<SaleorProductChannelListingUpdate>;
  /**
   * Creates a new product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductCreate?: Maybe<SaleorProductCreate>;
  /**
   * Deletes a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductDelete?: Maybe<SaleorProductDelete>;
  /**
   * Deletes product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductMediaBulkDelete?: Maybe<SaleorProductMediaBulkDelete>;
  /**
   * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductMediaCreate?: Maybe<SaleorProductMediaCreate>;
  /**
   * Deletes a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductMediaDelete?: Maybe<SaleorProductMediaDelete>;
  /**
   * Changes ordering of the product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductMediaReorder?: Maybe<SaleorProductMediaReorder>;
  /**
   * Updates a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductMediaUpdate?: Maybe<SaleorProductMediaUpdate>;
  /**
   * Reorder product attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductReorderAttributeValues?: Maybe<SaleorProductReorderAttributeValues>;
  /**
   * Creates/updates translations for a product.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorProductTranslate?: Maybe<SaleorProductTranslate>;
  /**
   * Deletes product types.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductTypeBulkDelete?: Maybe<SaleorProductTypeBulkDelete>;
  /**
   * Creates a new product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductTypeCreate?: Maybe<SaleorProductTypeCreate>;
  /**
   * Deletes a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductTypeDelete?: Maybe<SaleorProductTypeDelete>;
  /**
   * Reorder the attributes of a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductTypeReorderAttributes?: Maybe<SaleorProductTypeReorderAttributes>;
  /**
   * Updates an existing product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  saleorProductTypeUpdate?: Maybe<SaleorProductTypeUpdate>;
  /**
   * Updates an existing product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductUpdate?: Maybe<SaleorProductUpdate>;
  /**
   * Creates product variants for a given product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantBulkCreate?: Maybe<SaleorProductVariantBulkCreate>;
  /**
   * Deletes product variants.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantBulkDelete?: Maybe<SaleorProductVariantBulkDelete>;
  /**
   * Update multiple product variants.
   *
   * Added in Saleor 3.11.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantBulkUpdate?: Maybe<SaleorProductVariantBulkUpdate>;
  /**
   * Manage product variant prices in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantChannelListingUpdate?: Maybe<SaleorProductVariantChannelListingUpdate>;
  /**
   * Creates a new variant for a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantCreate?: Maybe<SaleorProductVariantCreate>;
  /**
   * Deletes a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantDelete?: Maybe<SaleorProductVariantDelete>;
  /**
   * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantPreorderDeactivate?: Maybe<SaleorProductVariantPreorderDeactivate>;
  /**
   * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantReorder?: Maybe<SaleorProductVariantReorder>;
  /**
   * Reorder product variant attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantReorderAttributeValues?: Maybe<SaleorProductVariantReorderAttributeValues>;
  /**
   * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantSetDefault?: Maybe<SaleorProductVariantSetDefault>;
  /**
   * Creates stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantStocksCreate?: Maybe<SaleorProductVariantStocksCreate>;
  /**
   * Delete stocks from product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantStocksDelete?: Maybe<SaleorProductVariantStocksDelete>;
  /**
   * Update stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantStocksUpdate?: Maybe<SaleorProductVariantStocksUpdate>;
  /**
   * Creates/updates translations for a product variant.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorProductVariantTranslate?: Maybe<SaleorProductVariantTranslate>;
  /**
   * Updates an existing variant for product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorProductVariantUpdate?: Maybe<SaleorProductVariantUpdate>;
  /**
   * Request email change of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorRequestEmailChange?: Maybe<SaleorRequestEmailChange>;
  /** Sends an email with the account password modification link. */
  saleorRequestPasswordReset?: Maybe<SaleorRequestPasswordReset>;
  /**
   * Deletes sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleBulkDelete?: Maybe<SaleorSaleBulkDelete>;
  /**
   * Adds products, categories, collections to a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleCataloguesAdd?: Maybe<SaleorSaleAddCatalogues>;
  /**
   * Removes products, categories, collections from a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleCataloguesRemove?: Maybe<SaleorSaleRemoveCatalogues>;
  /**
   * Manage sale's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleChannelListingUpdate?: Maybe<SaleorSaleChannelListingUpdate>;
  /**
   * Creates a new sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleCreate?: Maybe<SaleorSaleCreate>;
  /**
   * Deletes a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleDelete?: Maybe<SaleorSaleDelete>;
  /**
   * Creates/updates translations for a sale.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorSaleTranslate?: Maybe<SaleorSaleTranslate>;
  /**
   * Updates a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSaleUpdate?: Maybe<SaleorSaleUpdate>;
  /** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
  saleorSetPassword?: Maybe<SaleorSetPassword>;
  /**
   * Manage shipping method's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingMethodChannelListingUpdate?: Maybe<SaleorShippingMethodChannelListingUpdate>;
  /**
   * Deletes shipping prices.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceBulkDelete?: Maybe<SaleorShippingPriceBulkDelete>;
  /**
   * Creates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceCreate?: Maybe<SaleorShippingPriceCreate>;
  /**
   * Deletes a shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceDelete?: Maybe<SaleorShippingPriceDelete>;
  /**
   * Exclude products from shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceExcludeProducts?: Maybe<SaleorShippingPriceExcludeProducts>;
  /**
   * Remove product from excluded list for shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceRemoveProductFromExclude?: Maybe<SaleorShippingPriceRemoveProductFromExclude>;
  /**
   * Creates/updates translations for a shipping method.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorShippingPriceTranslate?: Maybe<SaleorShippingPriceTranslate>;
  /**
   * Updates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingPriceUpdate?: Maybe<SaleorShippingPriceUpdate>;
  /**
   * Deletes shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZoneBulkDelete?: Maybe<SaleorShippingZoneBulkDelete>;
  /**
   * Creates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZoneCreate?: Maybe<SaleorShippingZoneCreate>;
  /**
   * Deletes a shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZoneDelete?: Maybe<SaleorShippingZoneDelete>;
  /**
   * Updates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZoneUpdate?: Maybe<SaleorShippingZoneUpdate>;
  /**
   * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorShopAddressUpdate?: Maybe<SaleorShopAddressUpdate>;
  /**
   * Updates site domain of the shop.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorShopDomainUpdate?: Maybe<SaleorShopDomainUpdate>;
  /**
   * Fetch tax rates.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   * @deprecated
   *
   * DEPRECATED: this mutation will be removed in Saleor 4.0.
   */
  saleorShopFetchTaxRates?: Maybe<SaleorShopFetchTaxRates>;
  /**
   * Creates/updates translations for shop settings.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorShopSettingsTranslate?: Maybe<SaleorShopSettingsTranslate>;
  /**
   * Updates shop settings.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorShopSettingsUpdate?: Maybe<SaleorShopSettingsUpdate>;
  /**
   * Deletes staff users. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorStaffBulkDelete?: Maybe<SaleorStaffBulkDelete>;
  /**
   * Creates a new staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorStaffCreate?: Maybe<SaleorStaffCreate>;
  /**
   * Deletes a staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorStaffDelete?: Maybe<SaleorStaffDelete>;
  /**
   * Creates a new staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorStaffNotificationRecipientCreate?: Maybe<SaleorStaffNotificationRecipientCreate>;
  /**
   * Delete staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorStaffNotificationRecipientDelete?: Maybe<SaleorStaffNotificationRecipientDelete>;
  /**
   * Updates a staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  saleorStaffNotificationRecipientUpdate?: Maybe<SaleorStaffNotificationRecipientUpdate>;
  /**
   * Updates an existing staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorStaffUpdate?: Maybe<SaleorStaffUpdate>;
  /**
   * Updates stocks for a given variant and warehouse.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorStockBulkUpdate?: Maybe<SaleorStockBulkUpdate>;
  /**
   * Create a tax class.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxClassCreate?: Maybe<SaleorTaxClassCreate>;
  /**
   * Delete a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxClassDelete?: Maybe<SaleorTaxClassDelete>;
  /**
   * Update a tax class.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxClassUpdate?: Maybe<SaleorTaxClassUpdate>;
  /**
   * Update tax configuration for a channel.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxConfigurationUpdate?: Maybe<SaleorTaxConfigurationUpdate>;
  /**
   * Remove all tax class rates for a specific country.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxCountryConfigurationDelete?: Maybe<SaleorTaxCountryConfigurationDelete>;
  /**
   * Update tax class rates for a specific country.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxCountryConfigurationUpdate?: Maybe<SaleorTaxCountryConfigurationUpdate>;
  /**
   * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
   *
   * Added in Saleor 3.8.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  saleorTaxExemptionManage?: Maybe<SaleorTaxExemptionManage>;
  /** Create JWT token. */
  saleorTokenCreate?: Maybe<SaleorCreateToken>;
  /** Refresh JWT token. Mutation tries to take refreshToken from the input.If it fails it will try to take refreshToken from the http-only cookie -refreshToken. csrfToken is required when refreshToken is provided as a cookie. */
  saleorTokenRefresh?: Maybe<SaleorRefreshToken>;
  /** Verify JWT token. */
  saleorTokenVerify?: Maybe<SaleorVerifyToken>;
  /**
   * Deactivate all JWT tokens of the currently authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  saleorTokensDeactivateAll?: Maybe<SaleorDeactivateAllUserTokens>;
  /**
   * Create transaction for checkout or order.
   *
   * Added in Saleor 3.4.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  saleorTransactionCreate?: Maybe<SaleorTransactionCreate>;
  /**
   * Report the event for the transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS.
   */
  saleorTransactionEventReport?: Maybe<SaleorTransactionEventReport>;
  /**
   * Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  saleorTransactionInitialize?: Maybe<SaleorTransactionInitialize>;
  /**
   * Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  saleorTransactionProcess?: Maybe<SaleorTransactionProcess>;
  /**
   * Request an action for payment transaction.
   *
   * Added in Saleor 3.4.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  saleorTransactionRequestAction?: Maybe<SaleorTransactionRequestAction>;
  /**
   * Create transaction for checkout or order.
   *
   * Added in Saleor 3.4.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS.
   */
  saleorTransactionUpdate?: Maybe<SaleorTransactionUpdate>;
  /**
   * Remove shipping zone from given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorUnassignWarehouseShippingZone?: Maybe<SaleorWarehouseShippingZoneUnassign>;
  /** Updates metadata of an object. To use it, you need to have access to the modified object. */
  saleorUpdateMetadata?: Maybe<SaleorUpdateMetadata>;
  /** Updates private metadata of an object. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
  saleorUpdatePrivateMetadata?: Maybe<SaleorUpdatePrivateMetadata>;
  /**
   * Updates given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorUpdateWarehouse?: Maybe<SaleorWarehouseUpdate>;
  /**
   * Deletes a user avatar. Only for staff members.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  saleorUserAvatarDelete?: Maybe<SaleorUserAvatarDelete>;
  /**
   * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  saleorUserAvatarUpdate?: Maybe<SaleorUserAvatarUpdate>;
  /**
   * Activate or deactivate users.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  saleorUserBulkSetActive?: Maybe<SaleorUserBulkSetActive>;
  /**
   * Assign an media to a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorVariantMediaAssign?: Maybe<SaleorVariantMediaAssign>;
  /**
   * Unassign an media from a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorVariantMediaUnassign?: Maybe<SaleorVariantMediaUnassign>;
  /**
   * Deletes vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherBulkDelete?: Maybe<SaleorVoucherBulkDelete>;
  /**
   * Adds products, categories, collections to a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherCataloguesAdd?: Maybe<SaleorVoucherAddCatalogues>;
  /**
   * Removes products, categories, collections from a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherCataloguesRemove?: Maybe<SaleorVoucherRemoveCatalogues>;
  /**
   * Manage voucher's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherChannelListingUpdate?: Maybe<SaleorVoucherChannelListingUpdate>;
  /**
   * Creates a new voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherCreate?: Maybe<SaleorVoucherCreate>;
  /**
   * Deletes a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherDelete?: Maybe<SaleorVoucherDelete>;
  /**
   * Creates/updates translations for a voucher.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorVoucherTranslate?: Maybe<SaleorVoucherTranslate>;
  /**
   * Updates a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucherUpdate?: Maybe<SaleorVoucherUpdate>;
  /**
   * Creates a new webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  saleorWebhookCreate?: Maybe<SaleorWebhookCreate>;
  /**
   * Delete a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  saleorWebhookDelete?: Maybe<SaleorWebhookDelete>;
  /**
   * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
   *
   * Added in Saleor 3.11.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  saleorWebhookDryRun?: Maybe<SaleorWebhookDryRun>;
  /**
   * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
   *
   * Added in Saleor 3.11.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  saleorWebhookTrigger?: Maybe<SaleorWebhookTrigger>;
  /**
   * Updates a webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorWebhookUpdate?: Maybe<SaleorWebhookUpdate>;
  /** Change user password. Confirm with the current password. */
  strapiChangePassword?: Maybe<StrapiUsersPermissionsLoginPayload>;
  strapiCreateArticle?: Maybe<StrapiArticleEntityResponse>;
  strapiCreateArticleLocalization?: Maybe<StrapiArticleEntityResponse>;
  strapiCreateArticleSymptom?: Maybe<StrapiArticleSymptomEntityResponse>;
  strapiCreateArticleTag?: Maybe<StrapiArticleTagEntityResponse>;
  strapiCreateClinicsCity?: Maybe<StrapiClinicsCityEntityResponse>;
  strapiCreateClinicsCityLocalization?: Maybe<StrapiClinicsCityEntityResponse>;
  strapiCreateClinicsStreet?: Maybe<StrapiClinicsStreetEntityResponse>;
  strapiCreateClinicsStreetLocalization?: Maybe<StrapiClinicsStreetEntityResponse>;
  strapiCreateCompanyOpinion?: Maybe<StrapiCompanyOpinionEntityResponse>;
  strapiCreateCompanyOpinionLocalization?: Maybe<StrapiCompanyOpinionEntityResponse>;
  strapiCreateDisease?: Maybe<StrapiDiseaseEntityResponse>;
  strapiCreateDiseaseLocalization?: Maybe<StrapiDiseaseEntityResponse>;
  strapiCreateDoctor?: Maybe<StrapiDoctorEntityResponse>;
  strapiCreateDoctorGroup?: Maybe<StrapiDoctorGroupEntityResponse>;
  strapiCreateDoctorGroupLocalization?: Maybe<StrapiDoctorGroupEntityResponse>;
  strapiCreateDoctorLocalization?: Maybe<StrapiDoctorEntityResponse>;
  strapiCreateDoctorType?: Maybe<StrapiDoctorTypeEntityResponse>;
  strapiCreateDoctorTypeLocalization?: Maybe<StrapiDoctorTypeEntityResponse>;
  strapiCreateEcommercePartnership?: Maybe<StrapiEcommercePartnershipEntityResponse>;
  strapiCreateEcommercePartnershipLocalization?: Maybe<StrapiEcommercePartnershipEntityResponse>;
  strapiCreateEcommercePromoBarLocalization?: Maybe<StrapiEcommercePromoBarEntityResponse>;
  strapiCreateEcommercePromoSectionLocalization?: Maybe<StrapiEcommercePromoSectionEntityResponse>;
  strapiCreateFaqItemsSet?: Maybe<StrapiFaqItemsSetEntityResponse>;
  strapiCreateFaqItemsSetLocalization?: Maybe<StrapiFaqItemsSetEntityResponse>;
  strapiCreateFaqPagesNew?: Maybe<StrapiFaqPagesNewEntityResponse>;
  strapiCreateFaqPagesNewLocalization?: Maybe<StrapiFaqPagesNewEntityResponse>;
  strapiCreateFaqPost?: Maybe<StrapiFaqPostEntityResponse>;
  strapiCreateFaqPostLocalization?: Maybe<StrapiFaqPostEntityResponse>;
  strapiCreateHint?: Maybe<StrapiHintEntityResponse>;
  strapiCreateHintLocalization?: Maybe<StrapiHintEntityResponse>;
  strapiCreateInfluencer?: Maybe<StrapiInfluencerEntityResponse>;
  strapiCreateInfluencerLocalization?: Maybe<StrapiInfluencerEntityResponse>;
  strapiCreateLanding?: Maybe<StrapiLandingEntityResponse>;
  strapiCreateLandingLocalization?: Maybe<StrapiLandingEntityResponse>;
  strapiCreateMobileArticle?: Maybe<StrapiMobileArticleEntityResponse>;
  strapiCreateMobileArticleLocalization?: Maybe<StrapiMobileArticleEntityResponse>;
  strapiCreatePacket?: Maybe<StrapiPacketEntityResponse>;
  strapiCreatePatientReview?: Maybe<StrapiPatientReviewEntityResponse>;
  strapiCreatePatientReviewLocalization?: Maybe<StrapiPatientReviewEntityResponse>;
  strapiCreatePomocDlaUchodzcowLocalization?: Maybe<StrapiPomocDlaUchodzcowEntityResponse>;
  strapiCreatePost?: Maybe<StrapiPostEntityResponse>;
  strapiCreatePostTag?: Maybe<StrapiPostTagEntityResponse>;
  strapiCreatePrzychodniaGhostLocalization?: Maybe<StrapiPrzychodniaGhostEntityResponse>;
  strapiCreatePrzychodniaLiveLocalization?: Maybe<StrapiPrzychodniaLiveEntityResponse>;
  strapiCreatePrzychodniaStreetLocalization?: Maybe<StrapiPrzychodniaStreetEntityResponse>;
  strapiCreatePrzychodnieLocalization?: Maybe<StrapiPrzychodnieEntityResponse>;
  strapiCreateRegistrationDataStep?: Maybe<StrapiRegistrationDataStepEntityResponse>;
  strapiCreateRegistrationDataStepLocalization?: Maybe<StrapiRegistrationDataStepEntityResponse>;
  strapiCreateRegistrationStep?: Maybe<StrapiRegistrationStepEntityResponse>;
  strapiCreateRegistrationStepLocalization?: Maybe<StrapiRegistrationStepEntityResponse>;
  strapiCreateRegistrationStepsType?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  strapiCreateRegistrationStepsTypeLocalization?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  strapiCreateServiceItem?: Maybe<StrapiServiceItemEntityResponse>;
  strapiCreateServiceItemLocalization?: Maybe<StrapiServiceItemEntityResponse>;
  strapiCreateServiceItemsSet?: Maybe<StrapiServiceItemsSetEntityResponse>;
  strapiCreateServiceItemsSetLocalization?: Maybe<StrapiServiceItemsSetEntityResponse>;
  strapiCreateServicePage?: Maybe<StrapiServicePageEntityResponse>;
  strapiCreateServicePageLocalization?: Maybe<StrapiServicePageEntityResponse>;
  strapiCreateStatute?: Maybe<StrapiStatuteEntityResponse>;
  strapiCreateStatuteClinic?: Maybe<StrapiStatuteClinicEntityResponse>;
  strapiCreateStatuteClinicLocalization?: Maybe<StrapiStatuteClinicEntityResponse>;
  strapiCreateStatuteLocalization?: Maybe<StrapiStatuteEntityResponse>;
  strapiCreateStepsLayoutContent?: Maybe<StrapiStepsLayoutContentEntityResponse>;
  strapiCreateStepsLayoutContentLocalization?: Maybe<StrapiStepsLayoutContentEntityResponse>;
  strapiCreateTranslationPacket?: Maybe<StrapiTranslationPacketEntityResponse>;
  strapiCreateUploadFile?: Maybe<StrapiUploadFileEntityResponse>;
  strapiCreateUploadFolder?: Maybe<StrapiUploadFolderEntityResponse>;
  /** Create a new role */
  strapiCreateUsersPermissionsRole?: Maybe<StrapiUsersPermissionsCreateRolePayload>;
  /** Create a new user */
  strapiCreateUsersPermissionsUser: StrapiUsersPermissionsUserEntityResponse;
  strapiCreateVaccinationType?: Maybe<StrapiVaccinationTypeEntityResponse>;
  strapiCreateVaccinationTypeLocalization?: Maybe<StrapiVaccinationTypeEntityResponse>;
  strapiCreateZespolMedycznyLocalization?: Maybe<StrapiZespolMedycznyEntityResponse>;
  strapiDeleteArticle?: Maybe<StrapiArticleEntityResponse>;
  strapiDeleteArticleSymptom?: Maybe<StrapiArticleSymptomEntityResponse>;
  strapiDeleteArticleTag?: Maybe<StrapiArticleTagEntityResponse>;
  strapiDeleteClinicsCity?: Maybe<StrapiClinicsCityEntityResponse>;
  strapiDeleteClinicsStreet?: Maybe<StrapiClinicsStreetEntityResponse>;
  strapiDeleteCompanyOpinion?: Maybe<StrapiCompanyOpinionEntityResponse>;
  strapiDeleteDisease?: Maybe<StrapiDiseaseEntityResponse>;
  strapiDeleteDoctor?: Maybe<StrapiDoctorEntityResponse>;
  strapiDeleteDoctorGroup?: Maybe<StrapiDoctorGroupEntityResponse>;
  strapiDeleteDoctorType?: Maybe<StrapiDoctorTypeEntityResponse>;
  strapiDeleteEcommercePartnership?: Maybe<StrapiEcommercePartnershipEntityResponse>;
  strapiDeleteEcommercePromoBar?: Maybe<StrapiEcommercePromoBarEntityResponse>;
  strapiDeleteEcommercePromoModal?: Maybe<StrapiEcommercePromoModalEntityResponse>;
  strapiDeleteEcommercePromoSection?: Maybe<StrapiEcommercePromoSectionEntityResponse>;
  strapiDeleteEcommerceSectionTile?: Maybe<StrapiEcommerceSectionTileEntityResponse>;
  strapiDeleteFaqItemsSet?: Maybe<StrapiFaqItemsSetEntityResponse>;
  strapiDeleteFaqPagesNew?: Maybe<StrapiFaqPagesNewEntityResponse>;
  strapiDeleteFaqPost?: Maybe<StrapiFaqPostEntityResponse>;
  strapiDeleteHint?: Maybe<StrapiHintEntityResponse>;
  strapiDeleteInfluencer?: Maybe<StrapiInfluencerEntityResponse>;
  strapiDeleteKarieraMed?: Maybe<StrapiKarieraMedEntityResponse>;
  strapiDeleteLanding?: Maybe<StrapiLandingEntityResponse>;
  strapiDeleteMobileArticle?: Maybe<StrapiMobileArticleEntityResponse>;
  strapiDeletePacket?: Maybe<StrapiPacketEntityResponse>;
  strapiDeletePatientReview?: Maybe<StrapiPatientReviewEntityResponse>;
  strapiDeletePomocDlaUchodzcow?: Maybe<StrapiPomocDlaUchodzcowEntityResponse>;
  strapiDeletePost?: Maybe<StrapiPostEntityResponse>;
  strapiDeletePostTag?: Maybe<StrapiPostTagEntityResponse>;
  strapiDeletePrzychodniaGhost?: Maybe<StrapiPrzychodniaGhostEntityResponse>;
  strapiDeletePrzychodniaLive?: Maybe<StrapiPrzychodniaLiveEntityResponse>;
  strapiDeletePrzychodniaStreet?: Maybe<StrapiPrzychodniaStreetEntityResponse>;
  strapiDeletePrzychodnie?: Maybe<StrapiPrzychodnieEntityResponse>;
  strapiDeleteRegistrationDataStep?: Maybe<StrapiRegistrationDataStepEntityResponse>;
  strapiDeleteRegistrationStep?: Maybe<StrapiRegistrationStepEntityResponse>;
  strapiDeleteRegistrationStepsType?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  strapiDeleteRejestracja?: Maybe<StrapiRejestracjaEntityResponse>;
  strapiDeleteServiceItem?: Maybe<StrapiServiceItemEntityResponse>;
  strapiDeleteServiceItemsSet?: Maybe<StrapiServiceItemsSetEntityResponse>;
  strapiDeleteServicePage?: Maybe<StrapiServicePageEntityResponse>;
  strapiDeleteStatute?: Maybe<StrapiStatuteEntityResponse>;
  strapiDeleteStatuteClinic?: Maybe<StrapiStatuteClinicEntityResponse>;
  strapiDeleteStepsLayoutContent?: Maybe<StrapiStepsLayoutContentEntityResponse>;
  strapiDeleteSzczepienia?: Maybe<StrapiSzczepieniaEntityResponse>;
  strapiDeleteTranslationPacket?: Maybe<StrapiTranslationPacketEntityResponse>;
  strapiDeleteUploadFile?: Maybe<StrapiUploadFileEntityResponse>;
  strapiDeleteUploadFolder?: Maybe<StrapiUploadFolderEntityResponse>;
  /** Delete an existing role */
  strapiDeleteUsersPermissionsRole?: Maybe<StrapiUsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  strapiDeleteUsersPermissionsUser: StrapiUsersPermissionsUserEntityResponse;
  strapiDeleteVaccinationType?: Maybe<StrapiVaccinationTypeEntityResponse>;
  strapiDeleteZespolMedyczny?: Maybe<StrapiZespolMedycznyEntityResponse>;
  /** Confirm an email users email address */
  strapiEmailConfirmation?: Maybe<StrapiUsersPermissionsLoginPayload>;
  /** Request a reset password token */
  strapiForgotPassword?: Maybe<StrapiUsersPermissionsPasswordPayload>;
  strapiLogin: StrapiUsersPermissionsLoginPayload;
  strapiMultipleUpload: Array<Maybe<StrapiUploadFileEntityResponse>>;
  /** Register a user */
  strapiRegister: StrapiUsersPermissionsLoginPayload;
  strapiRemoveFile?: Maybe<StrapiUploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  strapiResetPassword?: Maybe<StrapiUsersPermissionsLoginPayload>;
  strapiUpdateArticle?: Maybe<StrapiArticleEntityResponse>;
  strapiUpdateArticleSymptom?: Maybe<StrapiArticleSymptomEntityResponse>;
  strapiUpdateArticleTag?: Maybe<StrapiArticleTagEntityResponse>;
  strapiUpdateClinicsCity?: Maybe<StrapiClinicsCityEntityResponse>;
  strapiUpdateClinicsStreet?: Maybe<StrapiClinicsStreetEntityResponse>;
  strapiUpdateCompanyOpinion?: Maybe<StrapiCompanyOpinionEntityResponse>;
  strapiUpdateDisease?: Maybe<StrapiDiseaseEntityResponse>;
  strapiUpdateDoctor?: Maybe<StrapiDoctorEntityResponse>;
  strapiUpdateDoctorGroup?: Maybe<StrapiDoctorGroupEntityResponse>;
  strapiUpdateDoctorType?: Maybe<StrapiDoctorTypeEntityResponse>;
  strapiUpdateEcommercePartnership?: Maybe<StrapiEcommercePartnershipEntityResponse>;
  strapiUpdateEcommercePromoBar?: Maybe<StrapiEcommercePromoBarEntityResponse>;
  strapiUpdateEcommercePromoModal?: Maybe<StrapiEcommercePromoModalEntityResponse>;
  strapiUpdateEcommercePromoSection?: Maybe<StrapiEcommercePromoSectionEntityResponse>;
  strapiUpdateEcommerceSectionTile?: Maybe<StrapiEcommerceSectionTileEntityResponse>;
  strapiUpdateFaqItemsSet?: Maybe<StrapiFaqItemsSetEntityResponse>;
  strapiUpdateFaqPagesNew?: Maybe<StrapiFaqPagesNewEntityResponse>;
  strapiUpdateFaqPost?: Maybe<StrapiFaqPostEntityResponse>;
  strapiUpdateFileInfo: StrapiUploadFileEntityResponse;
  strapiUpdateHint?: Maybe<StrapiHintEntityResponse>;
  strapiUpdateInfluencer?: Maybe<StrapiInfluencerEntityResponse>;
  strapiUpdateKarieraMed?: Maybe<StrapiKarieraMedEntityResponse>;
  strapiUpdateLanding?: Maybe<StrapiLandingEntityResponse>;
  strapiUpdateMobileArticle?: Maybe<StrapiMobileArticleEntityResponse>;
  strapiUpdatePacket?: Maybe<StrapiPacketEntityResponse>;
  strapiUpdatePatientReview?: Maybe<StrapiPatientReviewEntityResponse>;
  strapiUpdatePomocDlaUchodzcow?: Maybe<StrapiPomocDlaUchodzcowEntityResponse>;
  strapiUpdatePost?: Maybe<StrapiPostEntityResponse>;
  strapiUpdatePostTag?: Maybe<StrapiPostTagEntityResponse>;
  strapiUpdatePrzychodniaGhost?: Maybe<StrapiPrzychodniaGhostEntityResponse>;
  strapiUpdatePrzychodniaLive?: Maybe<StrapiPrzychodniaLiveEntityResponse>;
  strapiUpdatePrzychodniaStreet?: Maybe<StrapiPrzychodniaStreetEntityResponse>;
  strapiUpdatePrzychodnie?: Maybe<StrapiPrzychodnieEntityResponse>;
  strapiUpdateRegistrationDataStep?: Maybe<StrapiRegistrationDataStepEntityResponse>;
  strapiUpdateRegistrationStep?: Maybe<StrapiRegistrationStepEntityResponse>;
  strapiUpdateRegistrationStepsType?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  strapiUpdateRejestracja?: Maybe<StrapiRejestracjaEntityResponse>;
  strapiUpdateServiceItem?: Maybe<StrapiServiceItemEntityResponse>;
  strapiUpdateServiceItemsSet?: Maybe<StrapiServiceItemsSetEntityResponse>;
  strapiUpdateServicePage?: Maybe<StrapiServicePageEntityResponse>;
  strapiUpdateStatute?: Maybe<StrapiStatuteEntityResponse>;
  strapiUpdateStatuteClinic?: Maybe<StrapiStatuteClinicEntityResponse>;
  strapiUpdateStepsLayoutContent?: Maybe<StrapiStepsLayoutContentEntityResponse>;
  strapiUpdateSzczepienia?: Maybe<StrapiSzczepieniaEntityResponse>;
  strapiUpdateTranslationPacket?: Maybe<StrapiTranslationPacketEntityResponse>;
  strapiUpdateUploadFile?: Maybe<StrapiUploadFileEntityResponse>;
  strapiUpdateUploadFolder?: Maybe<StrapiUploadFolderEntityResponse>;
  /** Update an existing role */
  strapiUpdateUsersPermissionsRole?: Maybe<StrapiUsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  strapiUpdateUsersPermissionsUser: StrapiUsersPermissionsUserEntityResponse;
  strapiUpdateVaccinationType?: Maybe<StrapiVaccinationTypeEntityResponse>;
  strapiUpdateZespolMedyczny?: Maybe<StrapiZespolMedycznyEntityResponse>;
  strapiUpload: StrapiUploadFileEntityResponse;
};


export type MutationdoctorAddDeclarationScanToNFZEventArgs = {
  declarationScanFileId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationdoctorAddImmunizationCalendarArgs = {
  indicies: Array<Scalars['Int']['input']>;
  patientId: Scalars['String']['input'];
};


export type MutationdoctorArchiveDocumentArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorCancelIpomArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationdoctorChangePasswordArgs = {
  input: DoctorMSChangePasswordInput;
};


export type MutationdoctorCheckPatientEwusStatusArgs = {
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationdoctorCleanReportsArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationdoctorClosePatientArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorCloseVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorCreateAssignmentArgs = {
  input: DoctorMSPrescriptionInput;
};


export type MutationdoctorCreateChatMessageArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSChatMessageInput;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationdoctorCreateCovidExaminationArgs = {
  input: DoctorMSCovidExaminationInput;
};


export type MutationdoctorCreateDocumentArgs = {
  input: DoctorMSCreateDocumentInput;
};


export type MutationdoctorCreateIPOMArgs = {
  input: DoctorMSCreateIpomInput;
};


export type MutationdoctorCreateIpomAssignmentArgs = {
  input: DoctorMSIpomProcedureAssignmentInput;
};


export type MutationdoctorCreateLaboratoryExaminationsArgs = {
  createMessageOnChat?: InputMaybe<Scalars['Boolean']['input']>;
  data: Array<DoctorMSLaboratoryExaminationCreationInput>;
};


export type MutationdoctorCreateNFZEventArgs = {
  input: DoctorMSNFZEventInput;
  representativeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdoctorCreatePatientArgs = {
  address: DoctorMSPlacematicAddressInput;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  languages: Array<DoctorMSSupportedLanguage>;
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationdoctorCreatePatientTagArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  input: DoctorMSPatientTagInput;
};


export type MutationdoctorCreateProcedureArgs = {
  data: DoctorMSCreateProcedureInput;
  dataInput: DoctorMSProcedureDataInput;
};


export type MutationdoctorCreateProcedureNewArgs = {
  data: DoctorMSCreateProcedureInput;
  dataInput: Scalars['DoctorMSJSONObject']['input'];
};


export type MutationdoctorCreateSnippetArgs = {
  input: DoctorMSSnippetInput;
};


export type MutationdoctorCreateSurveyArgs = {
  input: DoctorMSSurveyProposalInput;
};


export type MutationdoctorCreateVisitArgs = {
  input: DoctorMSNewVisitInput;
};


export type MutationdoctorCreateVisitSlotArgs = {
  patientId: Scalars['String']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  slotIds: Array<Scalars['Int']['input']>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationdoctorCreateVisitSlot2Args = {
  patientId: Scalars['String']['input'];
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  shiftVisitType: DoctorMSPShiftVisitType;
  shiftsSlot: Array<DoctorMSShiftsSlot>;
};


export type MutationdoctorCreateVitalArgs = {
  input: DoctorMSVitalInput;
  specificInput: Scalars['DoctorMSJSON']['input'];
};


export type MutationdoctorDeleteChatMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeleteNFZEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeletePatientArgs = {
  phone: Scalars['String']['input'];
};


export type MutationdoctorDeletePatientTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeletePrescriptionArgs = {
  prescriptionId: Scalars['String']['input'];
};


export type MutationdoctorDeleteSnippetArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeleteTestimonialArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeleteVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeleteVisit2Args = {
  id: Scalars['String']['input'];
};


export type MutationdoctorDeleteVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationdoctorDeleteVitalArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorForceCreateVisitArgs = {
  input: DoctorMSForceVisitInput;
  patientId: Scalars['String']['input'];
};


export type MutationdoctorForceCreateVisit2Args = {
  input: DoctorMSForceVisitInput2;
  patientId: Scalars['String']['input'];
};


export type MutationdoctorForceVisitArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSForceVisitInput;
};


export type MutationdoctorForceVisit2Args = {
  id: Scalars['String']['input'];
  input: DoctorMSForceVisitInput2;
};


export type MutationdoctorGenerateDeclarationArgs = {
  representativeId?: InputMaybe<Scalars['String']['input']>;
  request: DoctorMSNfzDeclarationInputDoctor;
};


export type MutationdoctorGenerateIpomPdfDocumentArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationdoctorGenerateTestimonialArgs = {
  request: DoctorMSTestimonialGenerationInput;
};


export type MutationdoctorGenerateUsgResultsDocumentArgs = {
  procedureId: Scalars['String']['input'];
};


export type MutationdoctorGetContentFromImageArgs = {
  input: DoctorMSOCRImageInput;
};


export type MutationdoctorGetOpenPrescriptionVisitsArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationdoctorIssueCareLeaveArgs = {
  input: DoctorMSCareLeaveInput;
};


export type MutationdoctorIssueMedicalLeaveArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSMedicalLeaveInput;
};


export type MutationdoctorIssueMedicalLeaveNewArgs = {
  input: DoctorMSMedicalLeaveInputNew;
};


export type MutationdoctorIssueNursePrescriptionArgs = {
  input: DoctorMSIssuePrescriptionInput;
};


export type MutationdoctorIssuePrescriptionArgs = {
  input: DoctorMSIssuePrescriptionInput;
};


export type MutationdoctorIssueReferralArgs = {
  input: DoctorMSIssueReferralInput;
};


export type MutationdoctorLoadUMXArgs = {
  organizationId: Scalars['String']['input'];
  umxContent: Scalars['String']['input'];
};


export type MutationdoctorLogPaymentArgs = {
  paidIds: Array<Scalars['String']['input']>;
  paymentMethod: DoctorMSPaymentLogEntryInput;
};


export type MutationdoctorMakeCallArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationdoctorMarkPostsAsSeenArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationdoctorPatientLeftVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorPatientShowedUpForAVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorPublishTimeEntriesArgs = {
  from: Scalars['String']['input'];
  place_id: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type MutationdoctorPushNFZStatusToFirebaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorRefreshTokenArgs = {
  data: DoctorMSRTPayload;
};


export type MutationdoctorRefreshVaccinationsArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationdoctorReopenVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorReportPrepareArgs = {
  declarationGenre: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  realRun: Scalars['Boolean']['input'];
};


export type MutationdoctorRevokeAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorSaveHealthInsuranceStatementArgs = {
  data: DoctorMSNFZEventData;
  executionDate?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  organizationId: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
};


export type MutationdoctorSendInvitationForVisitArgs = {
  id: Scalars['String']['input'];
  type: DoctorMSVisitType;
};


export type MutationdoctorSendRecommendationArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationdoctorShowSnippetArgs = {
  doctorId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationdoctorSimulateLabExamUploadArgs = {
  labExam: DoctorMSLabExamInput;
  visitId: Scalars['String']['input'];
};


export type MutationdoctorStartVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorSwiadPrepareArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  realRun: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};


export type MutationdoctorUnpinPatientArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorUnpinProcedureArgs = {
  id: Scalars['String']['input'];
};


export type MutationdoctorUpdateDeclarationNFZEventCommentArgs = {
  comment: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};


export type MutationdoctorUpdateDocumentArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSUpdateDocumentInput;
};


export type MutationdoctorUpdateLaboratoryExaminationsArgs = {
  data: DoctorMSLaboratoryExaminationUpdateDataInput;
  ids: Array<Scalars['String']['input']>;
};


export type MutationdoctorUpdateMeArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSDoctorInput;
};


export type MutationdoctorUpdatePatientArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSPatientInput;
};


export type MutationdoctorUpdatePatientTagArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  input: DoctorMSPatientTagInput;
};


export type MutationdoctorUpdateProcedureArgs = {
  data?: InputMaybe<DoctorMSUpdateProcedureInput>;
  dataInput?: InputMaybe<DoctorMSProcedureDataInput>;
  procedureId: Scalars['String']['input'];
};


export type MutationdoctorUpdateProcedureNewArgs = {
  data?: InputMaybe<DoctorMSUpdateProcedureInput>;
  dataInput: Scalars['DoctorMSJSONObject']['input'];
  procedureId: Scalars['String']['input'];
};


export type MutationdoctorUpdateSnippetArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSSnippetInput;
};


export type MutationdoctorUpdateTodoArgs = {
  id: Scalars['Int']['input'];
  plannedDate?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  status?: InputMaybe<DoctorMSTodoStatus>;
};


export type MutationdoctorUpdateUserAddressArgs = {
  address: DoctorMSPlacematicAddressInput;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationdoctorUpdateVisitArgs = {
  id: Scalars['String']['input'];
  input: DoctorMSVisitInput;
};


export type MutationdoctorUpdateVisitSlotArgs = {
  id: Scalars['String']['input'];
  slotIds: Array<Scalars['Int']['input']>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationdoctorUpdateVisitSlot2Args = {
  id: Scalars['String']['input'];
  shiftVisitType?: InputMaybe<DoctorMSPShiftVisitType>;
  shiftsSlot: Array<DoctorMSShiftsSlot>;
};


export type MutationdoctorUpdateVisitSlot2ForMedicalAppArgs = {
  id: Scalars['String']['input'];
  shiftsSlot: Array<DoctorMSShiftsSlot>;
  visitType: DoctorMSPShiftVisitType;
};


export type MutationdoctorUpdateVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['String']['input']>;
  slotId: Scalars['Int']['input'];
};


export type MutationdoctorUpdateVitalArgs = {
  id: Scalars['String']['input'];
  specificInput: Scalars['DoctorMSJSON']['input'];
};


export type MutationdoctorUpsertShiftArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  input: DoctorMSShiftInput;
};


export type MutationdoctorUpsertSingleProcedureArgs = {
  data: Scalars['String']['input'];
  procedureType?: InputMaybe<DoctorMSProcedureType>;
  visitId: Scalars['String']['input'];
};


export type MutationdoctorWaitingForPatientArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmCancelShiftsConfirmationArgs = {
  input: EdmShiftsConfirmationInput;
};


export type MutationedmConfirmShiftsArgs = {
  input: EdmShiftsConfirmationInput;
};


export type MutationedmCreateMedicalMeasurementArgs = {
  input: EdmCreateMedicalMeasurementInput;
};


export type MutationedmCreateMedicalRecordFileReferenceArgs = {
  input: EdmCreateMedicalRecordFileReferenceInput;
};


export type MutationedmCreateNonWorkingPeriodArgs = {
  input: EdmCreateNonWorkingPeriodInput;
};


export type MutationedmCreateShiftArgs = {
  input: EdmCreateShiftInput;
};


export type MutationedmCreateShiftsBulkArgs = {
  input: EdmCreateShiftBulkInput;
};


export type MutationedmCreateSnippetArgs = {
  input: EdmCreateSnippetInput;
};


export type MutationedmDefineWorkingHoursArgs = {
  input: EdmDefineWorkingHoursInput;
};


export type MutationedmDeleteMedicalMeasurementArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmDeleteNonWorkingPeriodArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmDeleteShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmDeleteSnippetByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmDeleteWorkingHoursArgs = {
  input: EdmDeleteWorkingHoursInput;
};


export type MutationedmGenerateDocumentationArgs = {
  input: EdmGenerateDocumentationInput;
};


export type MutationedmGenerateIpomDocumentationArgs = {
  patientId: Scalars['String']['input'];
};


export type MutationedmGenerateVisitSummaryArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationedmIncreaseSnippetCounterArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmPublishShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationedmPublishShiftsArgs = {
  input: EdmPublishShiftsInput;
};


export type MutationedmUpdateDeclarationsArgs = {
  input: EdmUpdateDeclarationInput;
  staffId: Scalars['String']['input'];
};


export type MutationedmUpdateMedicalMeasurementArgs = {
  id: Scalars['String']['input'];
  input: EdmUpdateMedicalMeasurementInput;
};


export type MutationedmUpdatePreferencesArgs = {
  input: EdmUpdatePreferencesInput;
  staffId: Scalars['String']['input'];
};


export type MutationedmUpdateSnippetArgs = {
  id: Scalars['String']['input'];
  input: EdmUpdateSnippetInput;
};


export type MutationedmUpdateStaffVisitDurationArgs = {
  input: EdmUpdateStaffVisitDurationInput;
  staffId: Scalars['String']['input'];
};


export type MutationpatientAddChildArgs = {
  address?: InputMaybe<PatientMSPlacematicAddressInput>;
  firstName: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
};


export type MutationpatientCancelPrescriptionRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationpatientCancelSlotsReservationForFirstVisitArgs = {
  reservationId: Scalars['String']['input'];
};


export type MutationpatientCancelVisitArgs = {
  id: Scalars['String']['input'];
  input: PatientMSCancelVisitInput;
};


export type MutationpatientCancelVisit2Args = {
  id: Scalars['String']['input'];
  input: PatientMSCancelVisitInput;
};


export type MutationpatientChangeNotificationAgreementArgs = {
  notificationAgreement: Scalars['Boolean']['input'];
};


export type MutationpatientCreateChatMessageArgs = {
  input: PatientMSChatMessageInput;
};


export type MutationpatientCreateEventArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  input: PatientMSCreateEventInput;
};


export type MutationpatientCreateLaboratoryExaminationsArgs = {
  data: Array<PatientMSLaboratoryExaminationCreationPatientInput>;
};


export type MutationpatientCreatePaymentSessionForLabExaminationsArgs = {
  input: PatientMSCreatePaymentSessionForLabExaminationsInput;
};


export type MutationpatientCreateProcedureArgs = {
  data: PatientMSCreateProcedureInput;
  dataInput: PatientMSProcedureDataInput;
};


export type MutationpatientCreateProcedureNewArgs = {
  data: PatientMSCreateProcedureInput;
  dataInput: Scalars['PatientMSJSONObject']['input'];
};


export type MutationpatientCreateSystemChatMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationpatientCreateVisit2Args = {
  slotIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PatientMSVisitType>;
};


export type MutationpatientCreateVisit3Args = {
  shiftVisitType: PatientMSPShiftVisitType;
  shiftsSlot: Array<PatientMSShiftsSlot>;
};


export type MutationpatientCreateVisitFromSlotReservationArgs = {
  reservationId: Scalars['String']['input'];
  specialistServiceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationpatientDeleteChatMessageArgs = {
  id: Scalars['String']['input'];
};


export type MutationpatientDeleteInfoBoxArgs = {
  id: Scalars['String']['input'];
};


export type MutationpatientDeleteVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationpatientMakeComplaintArgs = {
  complain: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type MutationpatientMakeDiagVoucherArgs = {
  visitId: Scalars['String']['input'];
};


export type MutationpatientMakePrescriptionRequestArgs = {
  drugs: Array<PatientMSDrugRequestInputDto>;
};


export type MutationpatientMarkVisitFaqAsReadArgs = {
  faqTypes: Array<PatientMSFaqType>;
  visitId: Scalars['String']['input'];
};


export type MutationpatientPrefillVisitArgs = {
  doctorDiagnosis: Array<PatientMSDiagnosisInput>;
  doctorInterview: Scalars['String']['input'];
  recommendation: Scalars['String']['input'];
  visitId: Scalars['String']['input'];
};


export type MutationpatientRateVisitArgs = {
  input: PatientMSRateVisitInput;
};


export type MutationpatientRefreshTokenArgs = {
  data: PatientMSRTPayload;
};


export type MutationpatientReserveSlotsForFirstVisitArgs = {
  physicalOrganizationId?: InputMaybe<Scalars['String']['input']>;
  visitStartTime: Scalars['PatientMSDateTime']['input'];
};


export type MutationpatientReserveSpecialistSlotArgs = {
  singleSlotMode?: InputMaybe<Scalars['Boolean']['input']>;
  slotIds: Array<Scalars['Int']['input']>;
};


export type MutationpatientSaveAnalyticsSurveyArgs = {
  data: Scalars['PatientMSJSON']['input'];
  formId: Scalars['String']['input'];
};


export type MutationpatientSaveHealthInsuranceStatementArgs = {
  data: PatientMSNFZEventData;
};


export type MutationpatientSendNfzDeclarationArgs = {
  request: PatientMSNfzDeclarationInputPatient;
};


export type MutationpatientSetPESELArgs = {
  pesel: Scalars['String']['input'];
};


export type MutationpatientSetPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationpatientSmsInviteArgs = {
  childName: Scalars['String']['input'];
  parentName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationpatientStripeGenerateArgs = {
  id: Scalars['String']['input'];
};


export type MutationpatientUpdateLaboratoryExaminationsArgs = {
  data: PatientMSLaboratoryExaminationUpdateDataInput;
  ids: Array<Scalars['String']['input']>;
};


export type MutationpatientUpdateMeNewArgs = {
  input: PatientMSUserInput;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationpatientUpdateMessagePositionsArgs = {
  id: Scalars['String']['input'];
  input: PatientMSMessagePositionsInput;
};


export type MutationpatientUpdateProcedureArgs = {
  data?: InputMaybe<PatientMSUpdateProcedureInput>;
  dataInput?: InputMaybe<PatientMSProcedureDataInput>;
  procedureId: Scalars['String']['input'];
};


export type MutationpatientUpdateProcedureNewArgs = {
  data?: InputMaybe<PatientMSUpdateProcedureInput>;
  dataInput: Scalars['PatientMSJSONObject']['input'];
  procedureId: Scalars['String']['input'];
};


export type MutationpatientUpdateSurveyArgs = {
  id: Scalars['String']['input'];
  input: PatientMSSurveyProposalPatientInput;
  silent?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationpatientUpdateUserAddressArgs = {
  address: PatientMSPlacematicAddressInput;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationpatientUpdateVisitSlotArgs = {
  id: Scalars['String']['input'];
  slotIds: Array<Scalars['Int']['input']>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationpatientUpdateVisitSlot2Args = {
  id: Scalars['String']['input'];
  shiftVisitType?: InputMaybe<PatientMSPShiftVisitType>;
  shiftsSlot: Array<PatientMSShiftsSlot>;
};


export type MutationpatientUpdateVisitSlot2ForMedicalAppArgs = {
  id: Scalars['String']['input'];
  shiftsSlot: Array<PatientMSShiftsSlot>;
  visitType: PatientMSPShiftVisitType;
};


export type MutationpatientUpdateVisitSpecialistSlotArgs = {
  id: Scalars['String']['input'];
  reservationId?: InputMaybe<Scalars['String']['input']>;
  slotId: Scalars['Int']['input'];
};


export type MutationpatientUseInviteCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationsaleorAccountAddressCreateArgs = {
  input: SaleorAddressInput;
  type?: InputMaybe<SaleorAddressTypeEnum>;
};


export type MutationsaleorAccountAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAccountAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAddressInput;
};


export type MutationsaleorAccountDeleteArgs = {
  token: Scalars['String']['input'];
};


export type MutationsaleorAccountRegisterArgs = {
  input: SaleorAccountRegisterInput;
};


export type MutationsaleorAccountRequestDeletionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type MutationsaleorAccountSetDefaultAddressArgs = {
  id: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
};


export type MutationsaleorAccountUpdateArgs = {
  input: SaleorAccountInput;
};


export type MutationsaleorAddressCreateArgs = {
  input: SaleorAddressInput;
  userId: Scalars['ID']['input'];
};


export type MutationsaleorAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAddressSetDefaultArgs = {
  addressId: Scalars['ID']['input'];
  type: SaleorAddressTypeEnum;
  userId: Scalars['ID']['input'];
};


export type MutationsaleorAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAddressInput;
};


export type MutationsaleorAppActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppCreateArgs = {
  input: SaleorAppInput;
};


export type MutationsaleorAppDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppDeleteFailedInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppFetchManifestArgs = {
  manifestUrl: Scalars['String']['input'];
};


export type MutationsaleorAppInstallArgs = {
  input: SaleorAppInstallInput;
};


export type MutationsaleorAppRetryInstallArgs = {
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppTokenCreateArgs = {
  input: SaleorAppTokenInput;
};


export type MutationsaleorAppTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorAppTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type MutationsaleorAppUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAppInput;
};


export type MutationsaleorAssignNavigationArgs = {
  menu?: InputMaybe<Scalars['ID']['input']>;
  navigationType: SaleorNavigationType;
};


export type MutationsaleorAssignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type MutationsaleorAttributeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorAttributeCreateArgs = {
  input: SaleorAttributeCreateInput;
};


export type MutationsaleorAttributeDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorAttributeReorderValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
};


export type MutationsaleorAttributeTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorAttributeUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAttributeUpdateInput;
};


export type MutationsaleorAttributeValueBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorAttributeValueCreateArgs = {
  attribute: Scalars['ID']['input'];
  input: SaleorAttributeValueCreateInput;
};


export type MutationsaleorAttributeValueDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorAttributeValueTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorAttributeValueTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorAttributeValueUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorAttributeValueUpdateInput;
};


export type MutationsaleorCategoryBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorCategoryCreateArgs = {
  input: SaleorCategoryInput;
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorCategoryTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCategoryInput;
};


export type MutationsaleorChannelActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorChannelCreateArgs = {
  input: SaleorChannelCreateInput;
};


export type MutationsaleorChannelDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorChannelDeleteArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SaleorChannelDeleteInput>;
};


export type MutationsaleorChannelReorderWarehousesArgs = {
  channelId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
};


export type MutationsaleorChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorChannelUpdateInput;
};


export type MutationsaleorCheckoutAddPromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode: Scalars['String']['input'];
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutBillingAddressUpdateArgs = {
  billingAddress: SaleorAddressInput;
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
  validationRules?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};


export type MutationsaleorCheckoutCompleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  paymentData?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  storeSource?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutCreateArgs = {
  input: SaleorCheckoutCreateInput;
};


export type MutationsaleorCheckoutCustomerAttachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutCustomerDetachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutDeliveryMethodUpdateArgs = {
  deliveryMethodId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutEmailUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutLanguageCodeUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: SaleorLanguageCodeEnum;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutLineDeleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutLinesAddArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineInput>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutLinesDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linesIds: Array<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutLinesUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<SaleorCheckoutLineUpdateInput>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutPaymentCreateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorPaymentInput;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutRemovePromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCheckoutShippingAddressUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingAddress: SaleorAddressInput;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
  validationRules?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};


export type MutationsaleorCheckoutShippingMethodUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingMethodId: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type MutationsaleorCollectionAddProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationsaleorCollectionBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorCollectionChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCollectionChannelListingUpdateInput;
};


export type MutationsaleorCollectionCreateArgs = {
  input: SaleorCollectionCreateInput;
};


export type MutationsaleorCollectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorCollectionRemoveProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationsaleorCollectionReorderProductsArgs = {
  collectionId: Scalars['ID']['input'];
  moves: Array<SaleorMoveProductInput>;
};


export type MutationsaleorCollectionTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorCollectionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCollectionInput;
};


export type MutationsaleorConfirmAccountArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationsaleorConfirmEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationsaleorCreateWarehouseArgs = {
  input: SaleorWarehouseCreateInput;
};


export type MutationsaleorCustomerBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorCustomerBulkUpdateArgs = {
  customers: Array<SaleorCustomerBulkUpdateInput>;
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
};


export type MutationsaleorCustomerCreateArgs = {
  input: SaleorUserCreateInput;
};


export type MutationsaleorCustomerDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorCustomerUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorCustomerInput;
};


export type MutationsaleorDeleteMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type MutationsaleorDeletePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type MutationsaleorDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorDigitalContentCreateArgs = {
  input: SaleorDigitalContentUploadInput;
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorDigitalContentDeleteArgs = {
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorDigitalContentUpdateArgs = {
  input: SaleorDigitalContentInput;
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorDigitalContentUrlCreateArgs = {
  input: SaleorDigitalContentUrlCreateInput;
};


export type MutationsaleorDraftOrderBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorDraftOrderCreateArgs = {
  input: SaleorDraftOrderCreateInput;
};


export type MutationsaleorDraftOrderDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorDraftOrderLinesBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorDraftOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorDraftOrderInput;
};


export type MutationsaleorEventDeliveryRetryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorExportGiftCardsArgs = {
  input: SaleorExportGiftCardsInput;
};


export type MutationsaleorExportProductsArgs = {
  input: SaleorExportProductsInput;
};


export type MutationsaleorExternalAuthenticationUrlArgs = {
  input: Scalars['SaleorJSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationsaleorExternalLogoutArgs = {
  input: Scalars['SaleorJSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationsaleorExternalNotificationTriggerArgs = {
  channel: Scalars['String']['input'];
  input: SaleorExternalNotificationTriggerInput;
  pluginId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorExternalObtainAccessTokensArgs = {
  input: Scalars['SaleorJSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationsaleorExternalRefreshArgs = {
  input: Scalars['SaleorJSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationsaleorExternalVerifyArgs = {
  input: Scalars['SaleorJSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationsaleorFileUploadArgs = {
  file: Scalars['SaleorUpload']['input'];
};


export type MutationsaleorGiftCardActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorGiftCardAddNoteArgs = {
  id: Scalars['ID']['input'];
  input: SaleorGiftCardAddNoteInput;
};


export type MutationsaleorGiftCardBulkActivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorGiftCardBulkCreateArgs = {
  input: SaleorGiftCardBulkCreateInput;
};


export type MutationsaleorGiftCardBulkDeactivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorGiftCardBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorGiftCardCreateArgs = {
  input: SaleorGiftCardCreateInput;
};


export type MutationsaleorGiftCardDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorGiftCardDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorGiftCardResendArgs = {
  input: SaleorGiftCardResendInput;
};


export type MutationsaleorGiftCardSettingsUpdateArgs = {
  input: SaleorGiftCardSettingsUpdateInput;
};


export type MutationsaleorGiftCardUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorGiftCardUpdateInput;
};


export type MutationsaleorInvoiceCreateArgs = {
  input: SaleorInvoiceCreateInput;
  orderId: Scalars['ID']['input'];
};


export type MutationsaleorInvoiceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorInvoiceRequestArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationsaleorInvoiceRequestDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorInvoiceSendNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorInvoiceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorUpdateInvoiceInput;
};


export type MutationsaleorMenuBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorMenuCreateArgs = {
  input: SaleorMenuCreateInput;
};


export type MutationsaleorMenuDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorMenuItemBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorMenuItemCreateArgs = {
  input: SaleorMenuItemCreateInput;
};


export type MutationsaleorMenuItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorMenuItemMoveArgs = {
  menu: Scalars['ID']['input'];
  moves: Array<SaleorMenuItemMoveInput>;
};


export type MutationsaleorMenuItemTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorMenuItemUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorMenuItemInput;
};


export type MutationsaleorMenuUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorMenuInput;
};


export type MutationsaleorOrderAddNoteArgs = {
  input: SaleorOrderAddNoteInput;
  order: Scalars['ID']['input'];
};


export type MutationsaleorOrderBulkCancelArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorOrderCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorOrderCaptureArgs = {
  amount: Scalars['SaleorPositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type MutationsaleorOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorOrderCreateFromCheckoutArgs = {
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  removeCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationsaleorOrderDiscountAddArgs = {
  input: SaleorOrderDiscountCommonInput;
  orderId: Scalars['ID']['input'];
};


export type MutationsaleorOrderDiscountDeleteArgs = {
  discountId: Scalars['ID']['input'];
};


export type MutationsaleorOrderDiscountUpdateArgs = {
  discountId: Scalars['ID']['input'];
  input: SaleorOrderDiscountCommonInput;
};


export type MutationsaleorOrderFulfillArgs = {
  input: SaleorOrderFulfillInput;
  order?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorOrderFulfillmentApproveArgs = {
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notifyCustomer: Scalars['Boolean']['input'];
};


export type MutationsaleorOrderFulfillmentCancelArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SaleorFulfillmentCancelInput>;
};


export type MutationsaleorOrderFulfillmentRefundProductsArgs = {
  input: SaleorOrderRefundProductsInput;
  order: Scalars['ID']['input'];
};


export type MutationsaleorOrderFulfillmentReturnProductsArgs = {
  input: SaleorOrderReturnProductsInput;
  order: Scalars['ID']['input'];
};


export type MutationsaleorOrderFulfillmentUpdateTrackingArgs = {
  id: Scalars['ID']['input'];
  input: SaleorFulfillmentUpdateTrackingInput;
};


export type MutationsaleorOrderGrantRefundCreateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderGrantRefundCreateInput;
};


export type MutationsaleorOrderGrantRefundUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderGrantRefundUpdateInput;
};


export type MutationsaleorOrderLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorOrderLineDiscountRemoveArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type MutationsaleorOrderLineDiscountUpdateArgs = {
  input: SaleorOrderDiscountCommonInput;
  orderLineId: Scalars['ID']['input'];
};


export type MutationsaleorOrderLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorOrderLineInput;
};


export type MutationsaleorOrderLinesCreateArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorOrderLineCreateInput>;
};


export type MutationsaleorOrderMarkAsPaidArgs = {
  id: Scalars['ID']['input'];
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorOrderRefundArgs = {
  amount: Scalars['SaleorPositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type MutationsaleorOrderSettingsUpdateArgs = {
  input: SaleorOrderSettingsUpdateInput;
};


export type MutationsaleorOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorOrderUpdateInput;
};


export type MutationsaleorOrderUpdateShippingArgs = {
  input: SaleorOrderUpdateShippingInput;
  order: Scalars['ID']['input'];
};


export type MutationsaleorOrderVoidArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorPageAttributeAssignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationsaleorPageAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationsaleorPageBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorPageBulkPublishArgs = {
  ids: Array<Scalars['ID']['input']>;
  isPublished: Scalars['Boolean']['input'];
};


export type MutationsaleorPageCreateArgs = {
  input: SaleorPageCreateInput;
};


export type MutationsaleorPageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorPageReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  pageId: Scalars['ID']['input'];
};


export type MutationsaleorPageTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPageTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorPageTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorPageTypeCreateArgs = {
  input: SaleorPageTypeCreateInput;
};


export type MutationsaleorPageTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorPageTypeReorderAttributesArgs = {
  moves: Array<SaleorReorderInput>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationsaleorPageTypeUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorPageTypeUpdateInput;
};


export type MutationsaleorPageUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPageInput;
};


export type MutationsaleorPasswordChangeArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorPaymentCaptureArgs = {
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type MutationsaleorPaymentCheckBalanceArgs = {
  input: SaleorPaymentCheckBalanceInput;
};


export type MutationsaleorPaymentGatewayInitializeArgs = {
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  id: Scalars['ID']['input'];
  paymentGateways?: InputMaybe<Array<SaleorPaymentGatewayToInitialize>>;
};


export type MutationsaleorPaymentInitializeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  gateway: Scalars['String']['input'];
  paymentData?: InputMaybe<Scalars['SaleorJSONString']['input']>;
};


export type MutationsaleorPaymentRefundArgs = {
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type MutationsaleorPaymentVoidArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationsaleorPermissionGroupCreateArgs = {
  input: SaleorPermissionGroupCreateInput;
};


export type MutationsaleorPermissionGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorPermissionGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorPermissionGroupUpdateInput;
};


export type MutationsaleorPluginUpdateArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input: SaleorPluginUpdateInput;
};


export type MutationsaleorProductAttributeAssignArgs = {
  operations: Array<SaleorProductAttributeAssignInput>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationsaleorProductAttributeAssignmentUpdateArgs = {
  operations: Array<SaleorProductAttributeAssignmentUpdateInput>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationsaleorProductAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationsaleorProductBulkCreateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  products: Array<SaleorProductBulkCreateInput>;
};


export type MutationsaleorProductBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorProductChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductChannelListingUpdateInput;
};


export type MutationsaleorProductCreateArgs = {
  input: SaleorProductCreateInput;
};


export type MutationsaleorProductDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorProductMediaBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorProductMediaCreateArgs = {
  input: SaleorProductMediaCreateInput;
};


export type MutationsaleorProductMediaDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorProductMediaReorderArgs = {
  mediaIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationsaleorProductMediaUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductMediaUpdateInput;
};


export type MutationsaleorProductReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  productId: Scalars['ID']['input'];
};


export type MutationsaleorProductTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorProductTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorProductTypeCreateArgs = {
  input: SaleorProductTypeInput;
};


export type MutationsaleorProductTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorProductTypeReorderAttributesArgs = {
  moves: Array<SaleorReorderInput>;
  productTypeId: Scalars['ID']['input'];
  type: SaleorProductAttributeType;
};


export type MutationsaleorProductTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorProductTypeInput;
};


export type MutationsaleorProductUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorProductInput;
};


export type MutationsaleorProductVariantBulkCreateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<SaleorProductVariantBulkCreateInput>;
};


export type MutationsaleorProductVariantBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationsaleorProductVariantBulkUpdateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<SaleorProductVariantBulkUpdateInput>;
};


export type MutationsaleorProductVariantChannelListingUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: Array<SaleorProductVariantChannelListingAddInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorProductVariantCreateArgs = {
  input: SaleorProductVariantCreateInput;
};


export type MutationsaleorProductVariantDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorProductVariantPreorderDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorProductVariantReorderArgs = {
  moves: Array<SaleorReorderInput>;
  productId: Scalars['ID']['input'];
};


export type MutationsaleorProductVariantReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<SaleorReorderInput>;
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorProductVariantSetDefaultArgs = {
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorProductVariantStocksCreateArgs = {
  stocks: Array<SaleorStockInput>;
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorProductVariantStocksDeleteArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationsaleorProductVariantStocksUpdateArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  stocks: Array<SaleorStockInput>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationsaleorProductVariantTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorProductVariantUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: SaleorProductVariantInput;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorRequestEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationsaleorRequestPasswordResetArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationsaleorSaleBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorSaleCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type MutationsaleorSaleCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type MutationsaleorSaleChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorSaleChannelListingInput;
};


export type MutationsaleorSaleCreateArgs = {
  input: SaleorSaleInput;
};


export type MutationsaleorSaleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorSaleTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorSaleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorSaleInput;
};


export type MutationsaleorSetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationsaleorShippingMethodChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingMethodChannelListingInput;
};


export type MutationsaleorShippingPriceBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorShippingPriceCreateArgs = {
  input: SaleorShippingPriceInput;
};


export type MutationsaleorShippingPriceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorShippingPriceExcludeProductsArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceExcludeProductsInput;
};


export type MutationsaleorShippingPriceRemoveProductFromExcludeArgs = {
  id: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationsaleorShippingPriceTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorShippingPriceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingPriceInput;
};


export type MutationsaleorShippingZoneBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorShippingZoneCreateArgs = {
  input: SaleorShippingZoneCreateInput;
};


export type MutationsaleorShippingZoneDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorShippingZoneUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorShippingZoneUpdateInput;
};


export type MutationsaleorShopAddressUpdateArgs = {
  input?: InputMaybe<SaleorAddressInput>;
};


export type MutationsaleorShopDomainUpdateArgs = {
  input?: InputMaybe<SaleorSiteDomainInput>;
};


export type MutationsaleorShopSettingsTranslateArgs = {
  input: SaleorShopSettingsTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorShopSettingsUpdateArgs = {
  input: SaleorShopSettingsInput;
};


export type MutationsaleorStaffBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorStaffCreateArgs = {
  input: SaleorStaffCreateInput;
};


export type MutationsaleorStaffDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorStaffNotificationRecipientCreateArgs = {
  input: SaleorStaffNotificationRecipientInput;
};


export type MutationsaleorStaffNotificationRecipientDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorStaffNotificationRecipientUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorStaffNotificationRecipientInput;
};


export type MutationsaleorStaffUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorStaffUpdateInput;
};


export type MutationsaleorStockBulkUpdateArgs = {
  errorPolicy?: InputMaybe<SaleorErrorPolicyEnum>;
  stocks: Array<SaleorStockBulkUpdateInput>;
};


export type MutationsaleorTaxClassCreateArgs = {
  input: SaleorTaxClassCreateInput;
};


export type MutationsaleorTaxClassDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorTaxClassUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTaxClassUpdateInput;
};


export type MutationsaleorTaxConfigurationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorTaxConfigurationUpdateInput;
};


export type MutationsaleorTaxCountryConfigurationDeleteArgs = {
  countryCode: SaleorCountryCode;
};


export type MutationsaleorTaxCountryConfigurationUpdateArgs = {
  countryCode: SaleorCountryCode;
  updateTaxClassRates: Array<SaleorTaxClassRateInput>;
};


export type MutationsaleorTaxExemptionManageArgs = {
  id: Scalars['ID']['input'];
  taxExemption: Scalars['Boolean']['input'];
};


export type MutationsaleorTokenCreateArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationsaleorTokenRefreshArgs = {
  csrfToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsaleorTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type MutationsaleorTransactionCreateArgs = {
  id: Scalars['ID']['input'];
  transaction: SaleorTransactionCreateInput;
  transactionEvent?: InputMaybe<SaleorTransactionEventInput>;
};


export type MutationsaleorTransactionEventReportArgs = {
  amount: Scalars['SaleorPositiveDecimal']['input'];
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  pspReference: Scalars['String']['input'];
  time?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  type: SaleorTransactionEventTypeEnum;
};


export type MutationsaleorTransactionInitializeArgs = {
  action?: InputMaybe<SaleorTransactionFlowStrategyEnum>;
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  id: Scalars['ID']['input'];
  paymentGateway: SaleorPaymentGatewayToInitialize;
};


export type MutationsaleorTransactionProcessArgs = {
  data?: InputMaybe<Scalars['SaleorJSON']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsaleorTransactionRequestActionArgs = {
  actionType: SaleorTransactionActionEnum;
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationsaleorTransactionUpdateArgs = {
  id: Scalars['ID']['input'];
  transaction?: InputMaybe<SaleorTransactionUpdateInput>;
  transactionEvent?: InputMaybe<SaleorTransactionEventInput>;
};


export type MutationsaleorUnassignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type MutationsaleorUpdateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorMetadataInput>;
};


export type MutationsaleorUpdatePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<SaleorMetadataInput>;
};


export type MutationsaleorUpdateWarehouseArgs = {
  id: Scalars['ID']['input'];
  input: SaleorWarehouseUpdateInput;
};


export type MutationsaleorUserAvatarUpdateArgs = {
  image: Scalars['SaleorUpload']['input'];
};


export type MutationsaleorUserBulkSetActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};


export type MutationsaleorVariantMediaAssignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorVariantMediaUnassignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationsaleorVoucherBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationsaleorVoucherCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type MutationsaleorVoucherCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: SaleorCatalogueInput;
};


export type MutationsaleorVoucherChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorVoucherChannelListingInput;
};


export type MutationsaleorVoucherCreateArgs = {
  input: SaleorVoucherInput;
};


export type MutationsaleorVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorVoucherTranslateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorNameTranslationInput;
  languageCode: SaleorLanguageCodeEnum;
};


export type MutationsaleorVoucherUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorVoucherInput;
};


export type MutationsaleorWebhookCreateArgs = {
  input: SaleorWebhookCreateInput;
};


export type MutationsaleorWebhookDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationsaleorWebhookDryRunArgs = {
  objectId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type MutationsaleorWebhookTriggerArgs = {
  objectId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};


export type MutationsaleorWebhookUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleorWebhookUpdateInput;
};


export type MutationstrapiChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationstrapiCreateArticleArgs = {
  data: StrapiArticleInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateArticleLocalizationArgs = {
  data?: InputMaybe<StrapiArticleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateArticleSymptomArgs = {
  data: StrapiArticleSymptomInput;
};


export type MutationstrapiCreateArticleTagArgs = {
  data: StrapiArticleTagInput;
};


export type MutationstrapiCreateClinicsCityArgs = {
  data: StrapiClinicsCityInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateClinicsCityLocalizationArgs = {
  data?: InputMaybe<StrapiClinicsCityInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateClinicsStreetArgs = {
  data: StrapiClinicsStreetInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateClinicsStreetLocalizationArgs = {
  data?: InputMaybe<StrapiClinicsStreetInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateCompanyOpinionArgs = {
  data: StrapiCompanyOpinionInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateCompanyOpinionLocalizationArgs = {
  data?: InputMaybe<StrapiCompanyOpinionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDiseaseArgs = {
  data: StrapiDiseaseInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDiseaseLocalizationArgs = {
  data?: InputMaybe<StrapiDiseaseInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorArgs = {
  data: StrapiDoctorInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorGroupArgs = {
  data: StrapiDoctorGroupInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorGroupLocalizationArgs = {
  data?: InputMaybe<StrapiDoctorGroupInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorLocalizationArgs = {
  data?: InputMaybe<StrapiDoctorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorTypeArgs = {
  data: StrapiDoctorTypeInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateDoctorTypeLocalizationArgs = {
  data?: InputMaybe<StrapiDoctorTypeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateEcommercePartnershipArgs = {
  data: StrapiEcommercePartnershipInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateEcommercePartnershipLocalizationArgs = {
  data?: InputMaybe<StrapiEcommercePartnershipInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateEcommercePromoBarLocalizationArgs = {
  data?: InputMaybe<StrapiEcommercePromoBarInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateEcommercePromoSectionLocalizationArgs = {
  data?: InputMaybe<StrapiEcommercePromoSectionInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqItemsSetArgs = {
  data: StrapiFaqItemsSetInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqItemsSetLocalizationArgs = {
  data?: InputMaybe<StrapiFaqItemsSetInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqPagesNewArgs = {
  data: StrapiFaqPagesNewInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqPagesNewLocalizationArgs = {
  data?: InputMaybe<StrapiFaqPagesNewInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqPostArgs = {
  data: StrapiFaqPostInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateFaqPostLocalizationArgs = {
  data?: InputMaybe<StrapiFaqPostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateHintArgs = {
  data: StrapiHintInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateHintLocalizationArgs = {
  data?: InputMaybe<StrapiHintInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateInfluencerArgs = {
  data: StrapiInfluencerInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateInfluencerLocalizationArgs = {
  data?: InputMaybe<StrapiInfluencerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateLandingArgs = {
  data: StrapiLandingInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateLandingLocalizationArgs = {
  data?: InputMaybe<StrapiLandingInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateMobileArticleArgs = {
  data: StrapiMobileArticleInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateMobileArticleLocalizationArgs = {
  data?: InputMaybe<StrapiMobileArticleInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePacketArgs = {
  data: StrapiPacketInput;
};


export type MutationstrapiCreatePatientReviewArgs = {
  data: StrapiPatientReviewInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePatientReviewLocalizationArgs = {
  data?: InputMaybe<StrapiPatientReviewInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePomocDlaUchodzcowLocalizationArgs = {
  data?: InputMaybe<StrapiPomocDlaUchodzcowInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePostArgs = {
  data: StrapiPostInput;
};


export type MutationstrapiCreatePostTagArgs = {
  data: StrapiPostTagInput;
};


export type MutationstrapiCreatePrzychodniaGhostLocalizationArgs = {
  data?: InputMaybe<StrapiPrzychodniaGhostInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePrzychodniaLiveLocalizationArgs = {
  data?: InputMaybe<StrapiPrzychodniaLiveInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePrzychodniaStreetLocalizationArgs = {
  data?: InputMaybe<StrapiPrzychodniaStreetInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreatePrzychodnieLocalizationArgs = {
  data?: InputMaybe<StrapiPrzychodnieInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationDataStepArgs = {
  data: StrapiRegistrationDataStepInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationDataStepLocalizationArgs = {
  data?: InputMaybe<StrapiRegistrationDataStepInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationStepArgs = {
  data: StrapiRegistrationStepInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationStepLocalizationArgs = {
  data?: InputMaybe<StrapiRegistrationStepInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationStepsTypeArgs = {
  data: StrapiRegistrationStepsTypeInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateRegistrationStepsTypeLocalizationArgs = {
  data?: InputMaybe<StrapiRegistrationStepsTypeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServiceItemArgs = {
  data: StrapiServiceItemInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServiceItemLocalizationArgs = {
  data?: InputMaybe<StrapiServiceItemInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServiceItemsSetArgs = {
  data: StrapiServiceItemsSetInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServiceItemsSetLocalizationArgs = {
  data?: InputMaybe<StrapiServiceItemsSetInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServicePageArgs = {
  data: StrapiServicePageInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateServicePageLocalizationArgs = {
  data?: InputMaybe<StrapiServicePageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStatuteArgs = {
  data: StrapiStatuteInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStatuteClinicArgs = {
  data: StrapiStatuteClinicInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStatuteClinicLocalizationArgs = {
  data?: InputMaybe<StrapiStatuteClinicInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStatuteLocalizationArgs = {
  data?: InputMaybe<StrapiStatuteInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStepsLayoutContentArgs = {
  data: StrapiStepsLayoutContentInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateStepsLayoutContentLocalizationArgs = {
  data?: InputMaybe<StrapiStepsLayoutContentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateTranslationPacketArgs = {
  data: StrapiTranslationPacketInput;
};


export type MutationstrapiCreateUploadFileArgs = {
  data: StrapiUploadFileInput;
};


export type MutationstrapiCreateUploadFolderArgs = {
  data: StrapiUploadFolderInput;
};


export type MutationstrapiCreateUsersPermissionsRoleArgs = {
  data: StrapiUsersPermissionsRoleInput;
};


export type MutationstrapiCreateUsersPermissionsUserArgs = {
  data: StrapiUsersPermissionsUserInput;
};


export type MutationstrapiCreateVaccinationTypeArgs = {
  data: StrapiVaccinationTypeInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateVaccinationTypeLocalizationArgs = {
  data?: InputMaybe<StrapiVaccinationTypeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiCreateZespolMedycznyLocalizationArgs = {
  data?: InputMaybe<StrapiZespolMedycznyInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteArticleArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteArticleSymptomArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteArticleTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteClinicsCityArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteClinicsStreetArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteCompanyOpinionArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteDiseaseArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteDoctorArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteDoctorGroupArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteDoctorTypeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteEcommercePartnershipArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteEcommercePromoBarArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteEcommercePromoSectionArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteFaqItemsSetArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteFaqPagesNewArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteFaqPostArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteHintArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteInfluencerArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteLandingArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteMobileArticleArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePacketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeletePatientReviewArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePomocDlaUchodzcowArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePostArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeletePostTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeletePrzychodniaGhostArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePrzychodniaLiveArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePrzychodniaStreetArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeletePrzychodnieArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteRegistrationDataStepArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteRegistrationStepArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteRegistrationStepsTypeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteServiceItemArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteServiceItemsSetArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteServicePageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteStatuteArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteStatuteClinicArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteStepsLayoutContentArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteTranslationPacketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiDeleteVaccinationTypeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiDeleteZespolMedycznyArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationstrapiForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationstrapiLoginArgs = {
  input: StrapiUsersPermissionsLoginInput;
};


export type MutationstrapiMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['StrapiUpload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationstrapiRegisterArgs = {
  input: StrapiUsersPermissionsRegisterInput;
};


export type MutationstrapiRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationstrapiResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationstrapiUpdateArticleArgs = {
  data: StrapiArticleInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateArticleSymptomArgs = {
  data: StrapiArticleSymptomInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateArticleTagArgs = {
  data: StrapiArticleTagInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateClinicsCityArgs = {
  data: StrapiClinicsCityInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateClinicsStreetArgs = {
  data: StrapiClinicsStreetInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateCompanyOpinionArgs = {
  data: StrapiCompanyOpinionInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateDiseaseArgs = {
  data: StrapiDiseaseInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateDoctorArgs = {
  data: StrapiDoctorInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateDoctorGroupArgs = {
  data: StrapiDoctorGroupInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateDoctorTypeArgs = {
  data: StrapiDoctorTypeInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateEcommercePartnershipArgs = {
  data: StrapiEcommercePartnershipInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateEcommercePromoBarArgs = {
  data: StrapiEcommercePromoBarInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateEcommercePromoModalArgs = {
  data: StrapiEcommercePromoModalInput;
};


export type MutationstrapiUpdateEcommercePromoSectionArgs = {
  data: StrapiEcommercePromoSectionInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateEcommerceSectionTileArgs = {
  data: StrapiEcommerceSectionTileInput;
};


export type MutationstrapiUpdateFaqItemsSetArgs = {
  data: StrapiFaqItemsSetInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateFaqPagesNewArgs = {
  data: StrapiFaqPagesNewInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateFaqPostArgs = {
  data: StrapiFaqPostInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<StrapiFileInfoInput>;
};


export type MutationstrapiUpdateHintArgs = {
  data: StrapiHintInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateInfluencerArgs = {
  data: StrapiInfluencerInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateKarieraMedArgs = {
  data: StrapiKarieraMedInput;
};


export type MutationstrapiUpdateLandingArgs = {
  data: StrapiLandingInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateMobileArticleArgs = {
  data: StrapiMobileArticleInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePacketArgs = {
  data: StrapiPacketInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdatePatientReviewArgs = {
  data: StrapiPatientReviewInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePomocDlaUchodzcowArgs = {
  data: StrapiPomocDlaUchodzcowInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePostArgs = {
  data: StrapiPostInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdatePostTagArgs = {
  data: StrapiPostTagInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdatePrzychodniaGhostArgs = {
  data: StrapiPrzychodniaGhostInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePrzychodniaLiveArgs = {
  data: StrapiPrzychodniaLiveInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePrzychodniaStreetArgs = {
  data: StrapiPrzychodniaStreetInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdatePrzychodnieArgs = {
  data: StrapiPrzychodnieInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateRegistrationDataStepArgs = {
  data: StrapiRegistrationDataStepInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateRegistrationStepArgs = {
  data: StrapiRegistrationStepInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateRegistrationStepsTypeArgs = {
  data: StrapiRegistrationStepsTypeInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateRejestracjaArgs = {
  data: StrapiRejestracjaInput;
};


export type MutationstrapiUpdateServiceItemArgs = {
  data: StrapiServiceItemInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateServiceItemsSetArgs = {
  data: StrapiServiceItemsSetInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateServicePageArgs = {
  data: StrapiServicePageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateStatuteArgs = {
  data: StrapiStatuteInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateStatuteClinicArgs = {
  data: StrapiStatuteClinicInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateStepsLayoutContentArgs = {
  data: StrapiStepsLayoutContentInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateSzczepieniaArgs = {
  data: StrapiSzczepieniaInput;
};


export type MutationstrapiUpdateTranslationPacketArgs = {
  data: StrapiTranslationPacketInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateUploadFileArgs = {
  data: StrapiUploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateUploadFolderArgs = {
  data: StrapiUploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateUsersPermissionsRoleArgs = {
  data: StrapiUsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateUsersPermissionsUserArgs = {
  data: StrapiUsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationstrapiUpdateVaccinationTypeArgs = {
  data: StrapiVaccinationTypeInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUpdateZespolMedycznyArgs = {
  data: StrapiZespolMedycznyInput;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type MutationstrapiUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['StrapiUpload']['input'];
  info?: InputMaybe<StrapiFileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type PatientMSActiveSubstance = {
  __typename?: 'PatientMSActiveSubstance';
  activeSubstanceDose?: Maybe<Scalars['Int']['output']>;
  activeSubstanceDoseInWords?: Maybe<Array<Scalars['String']['output']>>;
  activeSubstanceDoseUnit?: Maybe<Scalars['String']['output']>;
};

export type PatientMSActiveSubstanceOfDrug = {
  __typename?: 'PatientMSActiveSubstanceOfDrug';
  amountPerItem?: Maybe<Scalars['String']['output']>;
  amountPerPackage?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  substanceId?: Maybe<Scalars['String']['output']>;
  unitCode?: Maybe<Scalars['String']['output']>;
};

export type PatientMSAdditionalRefundRight =
  | 'AZ'
  | 'BW'
  | 'C'
  | 'CN'
  | 'DN'
  | 'DZ'
  | 'IB'
  | 'IN'
  | 'IW'
  | 'PO'
  | 'S'
  | 'WP'
  | 'ZK';

export type PatientMSAddress = {
  __typename?: 'PatientMSAddress';
  apiDump?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<PatientMSLocation>;
  longitude?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type PatientMSAnalysis = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSAnalysis';
  analysisType: Scalars['String']['output'];
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  params: Array<PatientMSBloodParam>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSAnalyticsData = {
  __typename?: 'PatientMSAnalyticsData';
  data: Scalars['PatientMSJSON']['output'];
  source: PatientMSRegistrationSource;
};

export type PatientMSAnalyticsDataInput = {
  data: Scalars['PatientMSJSON']['input'];
  declarationDoctorNpwz?: InputMaybe<Scalars['String']['input']>;
  declarationNurseNpwz?: InputMaybe<Scalars['String']['input']>;
  deviceAnalyticsId?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  source: PatientMSRegistrationSource;
};

export type PatientMSAnotherPaymentMethodInfo = {
  __typename?: 'PatientMSAnotherPaymentMethodInfo';
  comment: Scalars['String']['output'];
};

export type PatientMSAnswer = {
  __typename?: 'PatientMSAnswer';
  choice_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  initial: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
};

export type PatientMSAssignment = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSAssignment';
  assignmentType: Scalars['String']['output'];
  createdAt: PatientMSTime;
  data?: Maybe<Scalars['PatientMSJSON']['output']>;
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  maker: PatientMSDoctor;
  makerId?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<PatientMSTime>;
  positions?: Maybe<Array<Maybe<PatientMSPosition>>>;
  signatureFile?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PatientMSAssignmentStatus>;
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
  vitals: Array<PatientMSVitalEntity>;
};

export type PatientMSAssignmentEntity = {
  __typename?: 'PatientMSAssignmentEntity';
  color?: Maybe<Scalars['String']['output']>;
  entrustedBudgetPriceInDecimal?: Maybe<Scalars['Float']['output']>;
  faqType: PatientMSAssignmentFaqType;
  foreignServiceId: Scalars['String']['output'];
  icd9?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  jednCode?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nfzPossible: Scalars['Boolean']['output'];
  nfzPossibleForNurse: Scalars['Boolean']['output'];
  saleorProductId: Scalars['String']['output'];
  type: PatientMSAssignmentType;
};

export type PatientMSAssignmentFaqMapping = {
  __typename?: 'PatientMSAssignmentFaqMapping';
  faqType: PatientMSAssignmentFaqType;
  serviceId: Scalars['String']['output'];
};

export type PatientMSAssignmentFaqType =
  | 'BLOOD'
  | 'DAILY_URINE_COLLECTION'
  | 'NONE'
  | 'OGTT'
  | 'STOOL'
  | 'URINE_GENERAL'
  | 'URINE_MICROBIOLOGY';

export type PatientMSAssignmentStatus =
  | 'DONE'
  | 'IN_PROGRESS'
  | 'NOT_DONE'
  | 'RESULTS';

export type PatientMSAssignmentType =
  | 'IMAGE'
  | 'IMMUNIZATION'
  | 'LABORATORY'
  | 'OTHER'
  | 'QUICKTEST';

export type PatientMSBankTransferPaymentInfo = {
  __typename?: 'PatientMSBankTransferPaymentInfo';
  moneyTransferProofFiles: Array<Scalars['String']['output']>;
};

export type PatientMSBaseMessage = {
  createdAt: PatientMSTime;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  visitId: Scalars['String']['output'];
};

export type PatientMSBaseUser = {
  avatar?: Maybe<Scalars['String']['output']>;
  consultantInfo: Scalars['PatientMSJSON']['output'];
  createdAt: PatientMSTime;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: PatientMSUserGenre;
  id: Scalars['String']['output'];
  lastLogin: PatientMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: PatientMSRealNFZStatusType;
  updatedAt: PatientMSTime;
};

export type PatientMSBaseVital = {
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visitId: Scalars['String']['output'];
};

export type PatientMSBloodParam = {
  __typename?: 'PatientMSBloodParam';
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PatientMSCalendarSlot = {
  __typename?: 'PatientMSCalendarSlot';
  date: Scalars['PatientMSDateTime']['output'];
  numberOfAvailableSlots: Scalars['Float']['output'];
};

export type PatientMSCancelVisitInput = {
  reason: Scalars['String']['input'];
};

export type PatientMSCareleave = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSCareleave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<PatientMSCodes>;
  createdAt: PatientMSTime;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  icd10Main: PatientMSICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<PatientMSLeaveDetails>>;
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<PatientMSPayer>;
  payers?: Maybe<Array<PatientMSPayer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  underCarePerson?: Maybe<PatientMSUnderCarePerson>;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
};

export type PatientMSChatMessageCreatedEvent = {
  __typename?: 'PatientMSChatMessageCreatedEvent';
  message: PatientMSChatMessageEntity;
};

export type PatientMSChatMessageDeletedEvent = {
  __typename?: 'PatientMSChatMessageDeletedEvent';
  message: PatientMSChatMessageEntity;
};

export type PatientMSChatMessageEntity = {
  __typename?: 'PatientMSChatMessageEntity';
  assignment?: Maybe<PatientMSAssignment>;
  author?: Maybe<PatientMSUser>;
  authorId?: Maybe<Scalars['String']['output']>;
  authorType: Scalars['String']['output'];
  careleave?: Maybe<PatientMSCareleave>;
  content: Scalars['String']['output'];
  createdAt: Scalars['PatientMSDateTime']['output'];
  deletedAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  id: Scalars['String']['output'];
  leave?: Maybe<PatientMSLeave>;
  masterId?: Maybe<Scalars['String']['output']>;
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  prescription?: Maybe<PatientMSPrescription>;
  referral?: Maybe<PatientMSReferral>;
  survey?: Maybe<PatientMSSurveyProposalEntity>;
  testimonial?: Maybe<PatientMSTestimonial>;
  updatedAt: Scalars['PatientMSDateTime']['output'];
  visit?: Maybe<PatientMSVisit>;
};

export type PatientMSChatMessageInput = {
  content: Scalars['String']['input'];
};

export type PatientMSChatMessageRender = {
  __typename?: 'PatientMSChatMessageRender';
  id: Scalars['String']['output'];
  mdx: Scalars['String']['output'];
  props?: Maybe<Scalars['PatientMSJSON']['output']>;
};

export type PatientMSChatMessagesUpdateEvent = PatientMSChatMessageCreatedEvent | PatientMSChatMessageDeletedEvent | PatientMSPrescriptionChatMessageDeletedEvent;

export type PatientMSChecker = {
  __typename?: 'PatientMSChecker';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PatientMSChukBodyMeasurements = {
  __typename?: 'PatientMSChukBodyMeasurements';
  height?: Maybe<Scalars['Float']['output']>;
  waist?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSChukBodyMeasurementsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  waist?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type PatientMSChukEducationInput = {
  cholesterol?: InputMaybe<Scalars['Float']['input']>;
  cholesterolHDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolLDL?: InputMaybe<Scalars['Float']['input']>;
  cholesterolNonHDL?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  glucose?: InputMaybe<Scalars['Float']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  riskScore?: InputMaybe<Scalars['Float']['input']>;
  simpFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  triglycerides?: InputMaybe<Scalars['Float']['input']>;
};

export type PatientMSChukMeasurementsInput = {
  bodyMeasurements?: InputMaybe<PatientMSChukBodyMeasurementsInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  pressureMeasurements?: InputMaybe<Array<PatientMSChukPressureMeasurementInput>>;
};

export type PatientMSChukPressureMeasurement = {
  __typename?: 'PatientMSChukPressureMeasurement';
  diastolicPressure?: Maybe<Scalars['Float']['output']>;
  pulse?: Maybe<Scalars['Float']['output']>;
  systolicPressure?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSChukPressureMeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['Float']['input']>;
  pulse?: InputMaybe<Scalars['Float']['input']>;
  systolicPressure?: InputMaybe<Scalars['Float']['input']>;
};

export type PatientMSClientAppSettings = {
  __typename?: 'PatientMSClientAppSettings';
  preferredLocation: Scalars['String']['output'];
};

export type PatientMSClientAppSettingsInput = {
  preferredLocation: Scalars['String']['input'];
};

export type PatientMSClinicDetails = {
  __typename?: 'PatientMSClinicDetails';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientMSCodes = {
  __typename?: 'PatientMSCodes';
  A: Scalars['Boolean']['output'];
  B: Scalars['Boolean']['output'];
  C: Scalars['Boolean']['output'];
  D: Scalars['Boolean']['output'];
  E: Scalars['Boolean']['output'];
};

export type PatientMSConfirmationType =
  | 'DOCUMENTATION'
  | 'EXAMINATION'
  | 'INTERVIEW';

export type PatientMSCreateEventInput = {
  data?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  eventName: Scalars['String']['input'];
};

export type PatientMSCreatePaymentSessionForLabExaminationsInput = {
  labExaminationIds: Array<Scalars['String']['input']>;
};

export type PatientMSCreateProcedureInput = {
  createdOnVisitId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  type: PatientMSProcedureType;
};

export type PatientMSCt = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSCt';
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSCustomerComplaintPaymentInfo = {
  __typename?: 'PatientMSCustomerComplaintPaymentInfo';
  comment: Scalars['String']['output'];
};

export type PatientMSDeclarableType =
  | 'DOCTOR'
  | 'MIDWIFE'
  | 'NURSE';

export type PatientMSDeclaration = {
  __typename?: 'PatientMSDeclaration';
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  genre?: Maybe<PatientMSDeclarationGenre>;
  npwz?: Maybe<Scalars['String']['output']>;
  patientData?: Maybe<PatientMSPatientData>;
  type?: Maybe<PatientMSDeclarationType>;
};

export type PatientMSDeclarationGenre =
  | 'DOCTOR'
  | 'NURSE';

export type PatientMSDeclarationType =
  | 'APP'
  | 'EPUAP'
  | 'IKP'
  | 'PAPER';

export type PatientMSDiagnosis = {
  __typename?: 'PatientMSDiagnosis';
  code?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<PatientMSDiagnosisGrade>;
};

export type PatientMSDiagnosisGrade =
  | 'MAIN'
  | 'SUPPLEMENTARY';

export type PatientMSDiagnosisInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<PatientMSDiagnosisGrade>;
};

export type PatientMSDoctor = PatientMSBaseUser & PatientMSGlobal & {
  __typename?: 'PatientMSDoctor';
  about?: Maybe<Scalars['String']['output']>;
  adultDeclarable: Scalars['Boolean']['output'];
  adultsAvailable?: Maybe<Scalars['Boolean']['output']>;
  avatar: Scalars['String']['output'];
  childrenAvailable?: Maybe<Scalars['Boolean']['output']>;
  childrenDeclarable: Scalars['Boolean']['output'];
  consultantInfo: Scalars['PatientMSJSON']['output'];
  createdAt: PatientMSTime;
  declaringToOrganizationId?: Maybe<Scalars['String']['output']>;
  ekgCertification: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: PatientMSUserGenre;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  intercomUserHash: Scalars['String']['output'];
  isDeclarable?: Maybe<Scalars['Boolean']['output']>;
  lastLogin: PatientMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  medicalPushToken?: Maybe<Scalars['PatientMSJSON']['output']>;
  npwz?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  realNFZStatus: PatientMSRealNFZStatusType;
  referralCommissionSum: Scalars['Float']['output'];
  seenPosts: Array<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  sipNumber?: Maybe<Scalars['String']['output']>;
  snippets?: Maybe<Array<PatientMSSnippetEntity>>;
  terms?: Maybe<Array<PatientMSTerm>>;
  updatedAt: PatientMSTime;
};

export type PatientMSDoctorAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSDoctorInterval = {
  __typename?: 'PatientMSDoctorInterval';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type PatientMSDoctorToPatientMask = {
  __typename?: 'PatientMSDoctorToPatientMask';
  avatar?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: PatientMSUserGenre;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PatientMSDrug = {
  __typename?: 'PatientMSDrug';
  activeSubstances?: Maybe<Array<Maybe<PatientMSActiveSubstance>>>;
  additionalPermission?: Maybe<Scalars['String']['output']>;
  boxAmount?: Maybe<Scalars['Int']['output']>;
  cost: Scalars['String']['output'];
  dose: Scalars['String']['output'];
  drug: Scalars['String']['output'];
  drugAmount?: Maybe<Scalars['Float']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hourInterval?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  morePatientInfo?: Maybe<Scalars['String']['output']>;
  morePharmacistInfo?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
  psychoSubstances?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use package field */
  quantity?: Maybe<Scalars['String']['output']>;
  quantityDescription?: Maybe<Scalars['String']['output']>;
  recipeId?: Maybe<Scalars['Int']['output']>;
};

export type PatientMSDrugDetails = {
  __typename?: 'PatientMSDrugDetails';
  activeSubstances: Array<PatientMSActiveSubstanceOfDrug>;
  additionalRefunds: Array<PatientMSAdditionalRefundRight>;
  box: Scalars['String']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  composition?: Maybe<Scalars['String']['output']>;
  continuation?: Maybe<Scalars['Boolean']['output']>;
  contraindications?: Maybe<Scalars['String']['output']>;
  dosage: Scalars['String']['output'];
  dosageDescription?: Maybe<Scalars['String']['output']>;
  drugStatus?: Maybe<Scalars['String']['output']>;
  ean: Scalars['String']['output'];
  effect?: Maybe<Scalars['String']['output']>;
  form: Scalars['String']['output'];
  hasPsychoSubstances: Scalars['Boolean']['output'];
  indications?: Maybe<Scalars['String']['output']>;
  interactions?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isWithdrawed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  paymentLevels: Array<PatientMSPaymentDetails>;
  precautions?: Maybe<Scalars['String']['output']>;
  pregnacyDetails: PatientMSPregnacyDetails;
  pregnantWomenInstructions?: Maybe<Scalars['String']['output']>;
  productCharacteristics?: Maybe<Scalars['String']['output']>;
  selfAdministration?: Maybe<Scalars['Boolean']['output']>;
  use?: Maybe<Scalars['String']['output']>;
};

export type PatientMSDrugRequestInputDto = {
  ean: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
};

export type PatientMSDynamicPositionData = {
  __typename?: 'PatientMSDynamicPositionData';
  color: Scalars['String']['output'];
  material: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientMSEcommerce = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSEcommerce';
  createdAt: PatientMSTime;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<PatientMSTime>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSEkg = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSEkg';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSEkgResults = {
  __typename?: 'PatientMSEkgResults';
  date: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type PatientMSEmployeeBenefitPaymentMethodInfo = {
  __typename?: 'PatientMSEmployeeBenefitPaymentMethodInfo';
  benefit: Scalars['String']['output'];
};

export type PatientMSEwusCheck = {
  __typename?: 'PatientMSEwusCheck';
  checker?: Maybe<PatientMSChecker>;
  date: Scalars['String']['output'];
  status: PatientMSEwusCheckStatus;
};

export type PatientMSEwusCheckStatus =
  | 'INSURED'
  | 'SIGNED_TODAY'
  | 'UNINSURED';

export type PatientMSEwusCheckWithDate = {
  __typename?: 'PatientMSEwusCheckWithDate';
  date: Scalars['String']['output'];
  status: PatientMSNFZEventType;
};

export type PatientMSExaminationsPacketDto = {
  __typename?: 'PatientMSExaminationsPacketDto';
  examinations: Array<PatientMSLaboratoryExaminationDto>;
  name: Scalars['String']['output'];
  saleorProductId: Scalars['String']['output'];
};

export type PatientMSFaqType =
  | 'BLOOD'
  | 'DRUGPASS'
  | 'EKG'
  | 'MEDICINE'
  | 'OGTT'
  | 'POO'
  | 'RTG'
  | 'SPIRO'
  | 'STANDARD'
  | 'URINE_CULTURE'
  | 'URINE_GENERAL'
  | 'USG'
  | 'VACCINE';

export type PatientMSFreeTime = {
  __typename?: 'PatientMSFreeTime';
  doctor: PatientMSDoctor;
  doctorLanguages: Array<PatientMSSupportedLanguage>;
  location: Scalars['String']['output'];
  organization_id?: Maybe<Scalars['String']['output']>;
  place: Scalars['String']['output'];
  slot_id: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type PatientMSFrequentFacilityChangeReason =
  | 'ANOTHER_FACT'
  | 'ANOTHER_PROVIDER_REASON'
  | 'CHANGE_OF_ADDRESS_OF_RESIDENCE'
  | 'REACHING_ADULTHOOD_WITH_PEDIATRICIAN'
  | 'SERVICE_PROVIDER_CEASING';

export type PatientMSFullAddress = {
  __typename?: 'PatientMSFullAddress';
  city: Scalars['String']['output'];
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type PatientMSFullAddressInput = {
  city: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  municipality?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  teryt?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type PatientMSGlobal = {
  createdAt: PatientMSTime;
  updatedAt: PatientMSTime;
};

export type PatientMSHeartrate = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSHeartrate';
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSHistory = {
  __typename?: 'PatientMSHistory';
  change: Scalars['PatientMSJSON']['output'];
  user: PatientMSUser;
  userId: Scalars['String']['output'];
  when: PatientMSTime;
};

export type PatientMSICD9Main = {
  __typename?: 'PatientMSICD9Main';
  icd9: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientMSICD10Main = {
  __typename?: 'PatientMSICD10Main';
  icd10: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PatientMSInfoBoxRendered = {
  __typename?: 'PatientMSInfoBoxRendered';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: PatientMSInfoBoxType;
  view: Scalars['String']['output'];
};

export type PatientMSInfoBoxType =
  | 'TEST'
  | 'firstInvited'
  | 'info'
  | 'invitee'
  | 'secondInvited'
  | 'thirdInvited';

export type PatientMSInjection = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSInjection';
  closed: Scalars['Boolean']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  drugs: Array<PatientMSInjectionDrug>;
  id: Scalars['String']['output'];
  injectionType: PatientMSInjectionType;
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  patientSignatureAgreement: Scalars['String']['output'];
  patientSignatureTransport: Scalars['String']['output'];
  portions: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSInjectionDrug = {
  __typename?: 'PatientMSInjectionDrug';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  series: Scalars['String']['output'];
};

export type PatientMSInjectionType =
  | 'MEDICINE'
  | 'VACCINE';

export type PatientMSInsuranceStatementData = {
  patientStatement?: InputMaybe<PatientMSPatientInsuranceStatementData>;
  representativeStatement?: InputMaybe<PatientMSRepresentativeInsuranceStatementData>;
};

export type PatientMSInsuranceStatementPatientReason =
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type PatientMSInsuranceStatementRepresentativeReason =
  | 'ART_2_UST_1_PKT_3_LIT_A'
  | 'ART_2_UST_1_PKT_3_LIT_B'
  | 'ART_2_UST_1_PKT_3_LIT_C'
  | 'ART_2_UST_1_PKT_4_LIT_A'
  | 'ART_2_UST_1_PKT_4_LIT_B'
  | 'ART_54_UST_1'
  | 'ART_67_UST_4_7'
  | 'OBJECIE_UBEZPIECZENIEM_ZDROWOTNYM_W_RZECZYPOSPOLITEJ_POLSKIEJ'
  | 'UA';

export type PatientMSIpom = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSIpom';
  assignmentType: Scalars['String']['output'];
  createdAt: PatientMSTime;
  data: Scalars['PatientMSJSON']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
};

export type PatientMSKeyValue = {
  __typename?: 'PatientMSKeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PatientMSLabExamEcommerceSource = {
  __typename?: 'PatientMSLabExamEcommerceSource';
  orderId: Scalars['String']['output'];
  packetInfo?: Maybe<PatientMSLabExamPacketInfo>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSLabExamPacketInfo = {
  __typename?: 'PatientMSLabExamPacketInfo';
  discount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId: Scalars['String']['output'];
  totalPrice?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSLabExamSource =
  | 'ECOMMERCE'
  | 'PATHWAYS';

export type PatientMSLabExamSourceInfo = {
  __typename?: 'PatientMSLabExamSourceInfo';
  ecommerce?: Maybe<PatientMSLabExamEcommerceSource>;
  pathwayRun?: Maybe<PatientMSPathwayRun>;
  source: PatientMSLabExamSource;
};

export type PatientMSLabExaminationPayment =
  | 'FREE'
  | 'PAID'
  | 'UNPAID';

export type PatientMSLaboratoryExaminationCreationPatientInput = {
  serviceId: Scalars['String']['input'];
};

export type PatientMSLaboratoryExaminationDto = {
  __typename?: 'PatientMSLaboratoryExaminationDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  saleorProductId: Scalars['String']['output'];
};

export type PatientMSLaboratoryExaminationEntity = {
  __typename?: 'PatientMSLaboratoryExaminationEntity';
  assignment: Scalars['PatientMSJSON']['output'];
  cancelled: Scalars['Boolean']['output'];
  cito: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['PatientMSDateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: PatientMSUser;
  diag: PatientMSAssignmentEntity;
  diagIdPosition: Scalars['Float']['output'];
  displayPayment: Scalars['String']['output'];
  executionLimit: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  paidFromEntrustedBudget: Scalars['Boolean']['output'];
  patient: PatientMSUserEntity;
  patientId: Scalars['String']['output'];
  payment: PatientMSLabExaminationPayment;
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentLog?: Maybe<PatientMSPaymentLogEntity>;
  paymentLogId?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  sourceInfo?: Maybe<PatientMSLabExamSourceInfo>;
  stripeSessionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['PatientMSDateTime']['output'];
  visit?: Maybe<PatientMSVisit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSLaboratoryExaminationUpdateDataInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  payment?: InputMaybe<PatientMSLabExaminationPayment>;
  sampleId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSLeave = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSLeave';
  careSince?: Maybe<Scalars['String']['output']>;
  careUntil?: Maybe<Scalars['String']['output']>;
  codes?: Maybe<PatientMSCodes>;
  createdAt: PatientMSTime;
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  icd10Main: PatientMSICD10Main;
  id: Scalars['String']['output'];
  inabilitySince?: Maybe<Scalars['String']['output']>;
  inabilityUntil?: Maybe<Scalars['String']['output']>;
  insuredIn?: Maybe<Scalars['String']['output']>;
  leaveType?: Maybe<Scalars['String']['output']>;
  leaves?: Maybe<Array<PatientMSLeaveDetails>>;
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  payer?: Maybe<PatientMSPayer>;
  payers?: Maybe<Array<PatientMSPayer>>;
  reason?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['String']['output']>;
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  underCarePerson?: Maybe<PatientMSUnderCarePerson>;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
};

export type PatientMSLeaveAddress = {
  __typename?: 'PatientMSLeaveAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type PatientMSLeaveDetails = {
  __typename?: 'PatientMSLeaveDetails';
  address?: Maybe<PatientMSLeaveAddress>;
  guardian?: Maybe<PatientMSLeaveGuardian>;
  ids: Array<Scalars['String']['output']>;
  seriesNumber: Scalars['String']['output'];
  upo: Array<Scalars['String']['output']>;
};

export type PatientMSLeaveGuardian = {
  __typename?: 'PatientMSLeaveGuardian';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
};

export type PatientMSLlmChatMessage = {
  __typename?: 'PatientMSLlmChatMessage';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type PatientMSLocation = {
  __typename?: 'PatientMSLocation';
  latitude: Scalars['Float']['output'];
  longtitude: Scalars['Float']['output'];
};

export type PatientMSMeasurementInput = {
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSMedicalActInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  diastolicPressure?: InputMaybe<Scalars['String']['input']>;
  glycemia?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  pulse?: InputMaybe<Scalars['String']['input']>;
  systolicPressure?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSMedicalDocumentSource =
  | 'CHAT'
  | 'CHAT_LLM'
  | 'DRIVE'
  | 'EKG'
  | 'EMAIL';

export type PatientMSMedicalLeaveDetails = {
  __typename?: 'PatientMSMedicalLeaveDetails';
  careSince: Scalars['String']['output'];
  careUntil: Scalars['String']['output'];
  code: Scalars['String']['output'];
  doNotSendPayerInfo: Scalars['Boolean']['output'];
  icd10: PatientMSICD10Main;
  inabilitySince: Scalars['String']['output'];
  inabilityUntil: Scalars['String']['output'];
  recommendation: Scalars['String']['output'];
};

export type PatientMSMedicalRecordEntity = {
  __typename?: 'PatientMSMedicalRecordEntity';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['PatientMSDateTime']['output'];
  fileId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  source: PatientMSMedicalDocumentSource;
  starred: Scalars['Boolean']['output'];
  tagId?: Maybe<Scalars['String']['output']>;
  tidyDocumentationResult?: Maybe<PatientMSTidyDocumentationResultEntity>;
  tidy_status?: Maybe<Scalars['String']['output']>;
};

export type PatientMSMedicalService = {
  __typename?: 'PatientMSMedicalService';
  comission?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nfz: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  serviceId: Scalars['String']['output'];
};

export type PatientMSMessage = PatientMSAssignment | PatientMSCareleave | PatientMSIpom | PatientMSLeave | PatientMSPrescription | PatientMSReferral | PatientMSTestimonial;

export type PatientMSMessagePositionsInput = {
  paid: Scalars['Boolean']['input'];
  positions: Array<PatientMSPositionInput>;
};

export type PatientMSMessageType =
  | 'ASSIGNMENT'
  | 'CARELEAVE'
  | 'IPOM'
  | 'LEAVE'
  | 'PRESCRIPTION'
  | 'REFERRAL'
  | 'TESTIMONIAL';

export type PatientMSMidwifeEducationalVisit = {
  pregnacyWeek?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  visitTopics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PatientMSMobilePlatform =
  | 'ANDROID'
  | 'IOS'
  | 'WEB';

export type PatientMSNFZEventData = {
  insuranceStatement?: InputMaybe<PatientMSInsuranceStatementData>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSNFZEventType =
  | 'DEKLARACJA'
  | 'EWUS_CZERWONY'
  | 'EWUS_UA'
  | 'EWUS_ZIELONY'
  | 'NFZ_AKCEPTACJA'
  | 'NFZ_AKCEPTACJA_PIELEGNIARKA'
  | 'NFZ_AKCEPTACJA_POLOZNA'
  | 'NFZ_ODRZUCENIE'
  | 'NFZ_ODRZUCENIE_PIELEGNIARKA'
  | 'NFZ_ODRZUCENIE_POLOZNA'
  | 'OSWIADCZENIE'
  | 'ZASWIADCZENIE_OD_PLATNIKA_SKLADEK';

export type PatientMSNFZPermissions = {
  __typename?: 'PatientMSNFZPermissions';
  blockedTelemedicine: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<PatientMSDoctorToPatientMask>;
  chosenMidwife?: Maybe<PatientMSDoctorToPatientMask>;
  chosenNurse?: Maybe<PatientMSDoctorToPatientMask>;
  declaredIn?: Maybe<Scalars['String']['output']>;
  ewusToday: Scalars['Boolean']['output'];
  firstDeclarationSubtype?: Maybe<Scalars['String']['output']>;
  hasIncomingPrescriptionVisit: Scalars['Boolean']['output'];
  incomingFreeVisit?: Maybe<PatientMSVisit>;
  publicStatus: PatientMSPublicStatus;
  whereCanDeclare?: Maybe<Scalars['String']['output']>;
};

export type PatientMSNfzDeclarationInputPatient = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  doctorId?: InputMaybe<Scalars['String']['input']>;
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<PatientMSFrequentFacilityChangeReason>;
  nurseId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSNfzDeclarationInputPatientMultiple = {
  anotherProviderReason?: InputMaybe<Scalars['String']['input']>;
  electronicallySignedDocument: Scalars['Boolean']['input'];
  facilityChangeReason?: InputMaybe<PatientMSFrequentFacilityChangeReason>;
  generationDate?: InputMaybe<Scalars['PatientMSDateTime']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type PatientMSNoShowNotificationAnswer = {
  __typename?: 'PatientMSNoShowNotificationAnswer';
  value: Scalars['Boolean']['output'];
  when: Scalars['String']['output'];
};

export type PatientMSNurseAdviceInput = {
  doctorInterview?: InputMaybe<Scalars['String']['input']>;
  physicalExamination?: InputMaybe<Scalars['String']['input']>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSObjectedNFZStatus = {
  __typename?: 'PatientMSObjectedNFZStatus';
  availablePublicPrivateShenanigans: Array<Scalars['String']['output']>;
  canDeclare: Scalars['Boolean']['output'];
  canUsePublicVisits: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenMidwife?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  declaredIn?: Maybe<Scalars['String']['output']>;
  ewusLastCheck?: Maybe<PatientMSEwusCheckWithDate>;
  noInsurance?: Maybe<Scalars['Boolean']['output']>;
  telezgodaAccepted: Scalars['Boolean']['output'];
  textStatus?: Maybe<Scalars['String']['output']>;
  wasDeclared: Scalars['Boolean']['output'];
  whereCanDeclare?: Maybe<Scalars['String']['output']>;
};

export type PatientMSOpeningHours = {
  __typename?: 'PatientMSOpeningHours';
  openingType: PatientMSOpeningType;
  /** Present only if openingType === Hours */
  ranges?: Maybe<Array<PatientMSRange>>;
  weekday: PatientMSWeekDay;
};

export type PatientMSOpeningType =
  | 'Hours'
  | 'OnlineOnly'
  | 'Unavailable';

export type PatientMSOperation = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSOperation';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  materials: Array<PatientMSOperationMaterial>;
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSOperationMaterial = {
  __typename?: 'PatientMSOperationMaterial';
  date: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  series: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientMSOrderDto = {
  __typename?: 'PatientMSOrderDto';
  faqTypes: Array<PatientMSAssignmentFaqType>;
  id: Scalars['String']['output'];
  orderDate: Scalars['PatientMSDateTime']['output'];
  products: Array<PatientMSOrderProductDto>;
};

export type PatientMSOrderProductDto = PatientMSExaminationsPacketDto | PatientMSLaboratoryExaminationDto;

export type PatientMSOrdering =
  | 'ASC'
  | 'DESC';

export type PatientMSOrganizationEntity = {
  __typename?: 'PatientMSOrganizationEntity';
  active: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  enableNoShowMitigationChance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  p1Data?: Maybe<PatientMSP1Data>;
  placeData?: Maybe<PatientMSPlaceData>;
  polmedId?: Maybe<Scalars['String']['output']>;
  polmedOrganization: Scalars['Boolean']['output'];
  umxData?: Maybe<Scalars['PatientMSJSON']['output']>;
};

export type PatientMSOther = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSOther';
  createdAt: PatientMSTime;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<PatientMSTime>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSP1Data = {
  __typename?: 'PatientMSP1Data';
  agreementNumber: Scalars['String']['output'];
  agreementNumberFull: Scalars['String']['output'];
  chamberId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  flatNumber: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  ksr: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nfz: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  private: Scalars['Boolean']['output'];
  regon: Scalars['String']['output'];
  res5: Scalars['String']['output'];
  res7: Scalars['String']['output'];
  res8: Scalars['String']['output'];
  res8Name: Scalars['String']['output'];
  street: Scalars['String']['output'];
  unitCode: Scalars['String']['output'];
  unitName: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type PatientMSPShiftVisitType =
  | 'COLLECTION'
  | 'DIETETICS'
  | 'DOCTOR_HOUSE_CALL'
  | 'DOCTOR_TELEMEDICAL_INFECTION'
  | 'EXPRESS_APPOINTMENT'
  | 'HEALTHY_CHILDREN_CHECKUP'
  | 'HEALTHY_CHILDREN_CHECKUP_AND_VACCINE'
  | 'HEALTHY_CHILDREN_PATRONAGE'
  | 'HEALTHY_CHILDREN_VACCINE'
  | 'IN_PERSON'
  | 'MIDWIFE_HOUSE_CALL'
  | 'MIDWIFE_IN_PERSON'
  | 'NURSE_HEALTHY_CHILDREN'
  | 'NURSE_HOUSE_CALL'
  | 'NURSE_IN_PERSON'
  | 'NURSE_IN_PERSON_INFECTION'
  | 'PRESCRIPTION_APPOINTMENT'
  | 'PROCEDURE'
  | 'RADIOLOGY_APPOINTMENT'
  | 'SICK_CHILDREN'
  | 'SPECIALIST'
  | 'TELEMEDICAL';

export type PatientMSPaginatedVisitResult = {
  __typename?: 'PatientMSPaginatedVisitResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PatientMSVisit>;
  total: Scalars['Float']['output'];
};

export type PatientMSPaginationConfigInput = {
  skip: Scalars['Float']['input'];
  take: Scalars['Float']['input'];
};

export type PatientMSPathwayInfo = {
  __typename?: 'PatientMSPathwayInfo';
  id: Scalars['String']['output'];
  subtypeId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSPathwayRun = {
  __typename?: 'PatientMSPathwayRun';
  pathways: Array<PatientMSPathwayInfo>;
  runDate: Scalars['PatientMSDateTime']['output'];
  runGroupId: Scalars['String']['output'];
};

export type PatientMSPatient = PatientMSBaseUser & PatientMSGlobal & {
  __typename?: 'PatientMSPatient';
  actionRequired?: Maybe<Scalars['String']['output']>;
  address?: Maybe<PatientMSFullAddress>;
  analyticsData: PatientMSAnalyticsData;
  analyticsId: Scalars['String']['output'];
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar: Scalars['String']['output'];
  canBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<PatientMSClientAppSettings>;
  consultantInfo: Scalars['PatientMSJSON']['output'];
  createdAt: PatientMSTime;
  currentVirtualVisit?: Maybe<PatientMSVisit>;
  deliveryAddress?: Maybe<PatientMSAddress>;
  deviceInfo: Scalars['String']['output'];
  documents: Array<PatientMSMedicalRecordEntity>;
  ekgResults: Array<PatientMSEkgResults>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheckHistory: Array<PatientMSEwusCheck>;
  files: Scalars['PatientMSJSON']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  genre: PatientMSUserGenre;
  getUnderCarePersons: Array<PatientMSUnderCarePerson>;
  guardians: Array<PatientMSPatient>;
  hasPassword: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  immunizationCardComment?: Maybe<Scalars['String']['output']>;
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Int']['output'];
  ipomCode?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastChatMessage?: Maybe<PatientMSChatMessageEntity>;
  lastLogin: PatientMSTime;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<PatientMSTime>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalLeaves: Array<PatientMSMedicalLeaveDetails>;
  messages: Array<PatientMSMessage>;
  mobileAppVersion: Scalars['String']['output'];
  nfzData: Scalars['PatientMSJSON']['output'];
  nfzStatus: PatientMSObjectedNFZStatus;
  notificationAgreements: Array<PatientMSUsersNotificationAgreementsEntity>;
  oneTimeSurvey?: Maybe<Scalars['PatientMSJSON']['output']>;
  oneTimeSurveyUpdatedAt?: Maybe<PatientMSTime>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  passwordHash: Scalars['String']['output'];
  pastVisits: PatientMSPaginatedVisitResult;
  patientCardNumber: Scalars['String']['output'];
  patientPublicSince?: Maybe<PatientMSTime>;
  payers: Array<PatientMSPayer>;
  permission: Scalars['String']['output'];
  pesel?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  realNFZStatus: PatientMSRealNFZStatusType;
  referralCode?: Maybe<Scalars['String']['output']>;
  referralUsagesCount: Scalars['Int']['output'];
  registrationType: Scalars['PatientMSJSON']['output'];
  regularSurvey: Scalars['PatientMSJSON']['output'];
  relation: Scalars['String']['output'];
  remindMe: Scalars['String']['output'];
  representative: Array<Scalars['String']['output']>;
  secretData?: Maybe<PatientMSSecretData>;
  signature: Scalars['String']['output'];
  smokeLevel?: Maybe<Scalars['Float']['output']>;
  statusUbezpieczenia?: Maybe<Scalars['Int']['output']>;
  stayAddresses: Array<PatientMSAddress>;
  survey?: Maybe<PatientMSSurvey>;
  surveys: Array<PatientMSSurveyProposal>;
  tags: Array<PatientMSPatientTag>;
  underCarePersons: Array<PatientMSUnderCarePerson>;
  uniqueIntegerId: Scalars['Int']['output'];
  unread: Scalars['Float']['output'];
  upcomingVisits: PatientMSPaginatedVisitResult;
  updatedAt: PatientMSTime;
  updatesToDo: Array<Scalars['String']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  usedReferralReward: Scalars['Boolean']['output'];
  visit?: Maybe<PatientMSVisit>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  visits: Array<PatientMSVisit>;
  vital?: Maybe<PatientMSVitalEntity>;
  vitals: Array<PatientMSVital>;
  wards: Array<PatientMSPatient>;
  weight?: Maybe<Scalars['Float']['output']>;
};


export type PatientMSPatientpastVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PatientMSPaginationConfigInput>;
};


export type PatientMSPatientupcomingVisitsArgs = {
  ecommerceVisitsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PatientMSPaginationConfigInput>;
};


export type PatientMSPatientvisitArgs = {
  id: Scalars['String']['input'];
};


export type PatientMSPatientvisitsArgs = {
  orderByCreationDate?: InputMaybe<PatientMSOrdering>;
  orderByPlannedStart?: InputMaybe<PatientMSOrdering>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientMSPatientvitalArgs = {
  id: Scalars['String']['input'];
};


export type PatientMSPatientvitalsArgs = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSPatientData = {
  __typename?: 'PatientMSPatientData';
  address?: Maybe<PatientMSAddress>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type PatientMSPatientInsuranceStatementData = {
  reason: PatientMSInsuranceStatementPatientReason;
};

export type PatientMSPatientKind =
  | 'ADULT_PATIENT'
  | 'UNDER_18_PATIENT';

export type PatientMSPatientPolicy = {
  __typename?: 'PatientMSPatientPolicy';
  policy: Scalars['String']['output'];
  satisfied: Scalars['Boolean']['output'];
};

export type PatientMSPatientTag = {
  __typename?: 'PatientMSPatientTag';
  confirmationType?: Maybe<PatientMSConfirmationType>;
  createdAt: PatientMSTime;
  createdBy?: Maybe<PatientMSDoctor>;
  data: Scalars['PatientMSJSON']['output'];
  expirationAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  history?: Maybe<Array<PatientMSHistory>>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: PatientMSTime;
};

export type PatientMSPatientTagEntity = {
  __typename?: 'PatientMSPatientTagEntity';
  confirmationType?: Maybe<PatientMSConfirmationType>;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<PatientMSDoctor>;
  data: Scalars['PatientMSJSON']['output'];
  expirationAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  history?: Maybe<Scalars['PatientMSJSON']['output']>;
  id: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  type: PatientMSPatientTagType;
  updatedAt: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSPatientTagType =
  | 'ADDITIONAL'
  | 'ALLERGY'
  | 'CHRONIC_DISEASE'
  | 'EDM_VACCINE'
  | 'HOSPITALIZATION'
  | 'REGULAR_DRUG'
  | 'SPEC_CONSULTATIONS'
  | 'SURGICAL_PROCEDURES'
  | 'VACCINES';

export type PatientMSPatientWithTokensPayload = {
  __typename?: 'PatientMSPatientWithTokensPayload';
  patient: PatientMSPatient;
  permissions: PatientMSPermissions;
  tokens: PatientMSTokensPayload;
};

export type PatientMSPatronageVisitInput = {
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSPayer = {
  __typename?: 'PatientMSPayer';
  doNotSendPayerInfo?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nip: Scalars['String']['output'];
  passportNumber: Scalars['String']['output'];
  pesel: Scalars['String']['output'];
  pueProfile: Scalars['String']['output'];
};

export type PatientMSPaymentDetails = {
  __typename?: 'PatientMSPaymentDetails';
  description: Scalars['String']['output'];
  detailedDescription: Scalars['String']['output'];
  paymentKey: Scalars['String']['output'];
  price: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PatientMSPaymentLogEntity = {
  __typename?: 'PatientMSPaymentLogEntity';
  createdAt: Scalars['PatientMSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  creator: PatientMSDoctor;
  id: Scalars['String']['output'];
  info: PatientMSPaymentLogEntry;
  updatedAt: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSPaymentLogEntry = {
  __typename?: 'PatientMSPaymentLogEntry';
  anotherPaymentMethod?: Maybe<PatientMSAnotherPaymentMethodInfo>;
  bankTransferPayment?: Maybe<PatientMSBankTransferPaymentInfo>;
  customerComplaint?: Maybe<PatientMSCustomerComplaintPaymentInfo>;
  employeeBenefit?: Maybe<PatientMSEmployeeBenefitPaymentMethodInfo>;
  posPayment?: Maybe<PatientMSPosPaymentInfo>;
};

export type PatientMSPermissions = {
  __typename?: 'PatientMSPermissions';
  nfz: PatientMSNFZPermissions;
};

export type PatientMSPersonalRegistrationSlot = PatientMSRegistrationSlotBase & {
  __typename?: 'PatientMSPersonalRegistrationSlot';
  exactStartTime: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSPlaceData = {
  __typename?: 'PatientMSPlaceData';
  city: Scalars['String']['output'];
  houseNumber: Scalars['String']['output'];
  isPartnerFacility?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longtitude?: Maybe<Scalars['Float']['output']>;
  openingHoursCollections: Array<PatientMSOpeningHours>;
  openingHoursProcedures: Array<PatientMSOpeningHours>;
  openingHoursWhole: Array<PatientMSOpeningHours>;
  /** If not present -> it's our own place */
  partnerName?: Maybe<Scalars['String']['output']>;
  photos: Array<Scalars['String']['output']>;
  saleorSpecialistFacilityCollectionId?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

export type PatientMSPlacematicAddress = {
  __typename?: 'PatientMSPlacematicAddress';
  city: Scalars['String']['output'];
  houseNumber?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  municipality?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  teryt?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PatientMSPlacematicAddressInput = {
  city: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  municipality: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  teryt: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type PatientMSPosPaymentInfo = {
  __typename?: 'PatientMSPosPaymentInfo';
  paymentNumber: Scalars['String']['output'];
};

export type PatientMSPosition = {
  __typename?: 'PatientMSPosition';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  isNFZ?: Maybe<Scalars['Boolean']['output']>;
  positionData?: Maybe<PatientMSDynamicPositionData>;
  price?: Maybe<Scalars['Float']['output']>;
  priceData?: Maybe<PatientMSPriceData>;
  sampleId?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceName?: Maybe<Scalars['String']['output']>;
};

export type PatientMSPositionInput = {
  cancelled: Scalars['Boolean']['input'];
  sampleId?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type PatientMSPregnacyDetails = {
  __typename?: 'PatientMSPregnacyDetails';
  entirePregnacy: PatientMSKeyValue;
  firstTrimester: PatientMSKeyValue;
  lactation: PatientMSKeyValue;
  secondTrimester: PatientMSKeyValue;
  thirdTrimester: PatientMSKeyValue;
};

export type PatientMSPrescription = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSPrescription';
  code: Scalars['String']['output'];
  createdAt: PatientMSTime;
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  drugs: Array<PatientMSDrug>;
  endsToWork?: Maybe<PatientMSTime>;
  id: Scalars['String']['output'];
  insuredIn: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  options?: Maybe<PatientMSPrescriptionOptions>;
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  prescriptionId?: Maybe<Scalars['String']['output']>;
  resourceCancelationInCezDate?: Maybe<Scalars['PatientMSDateTime']['output']>;
  resourceIsCompatibleWithCez?: Maybe<Scalars['Boolean']['output']>;
  startsToWork?: Maybe<PatientMSTime>;
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
  writeup: PatientMSTime;
};

export type PatientMSPrescriptionChatMessageDeletedEvent = {
  __typename?: 'PatientMSPrescriptionChatMessageDeletedEvent';
  message: PatientMSChatMessageEntity;
};

export type PatientMSPrescriptionOptions = {
  __typename?: 'PatientMSPrescriptionOptions';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dontChange?: Maybe<Scalars['Boolean']['output']>;
  in365days?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientMSPrescriptionRequestDto = {
  __typename?: 'PatientMSPrescriptionRequestDto';
  createdAt: Scalars['PatientMSDateTime']['output'];
  id: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  prescriptions: Array<PatientMSPrescription>;
  recommendations?: Maybe<Scalars['String']['output']>;
  requestedDrugs: Array<PatientMSRequestedDrugDto>;
  solvedOn?: Maybe<Scalars['PatientMSDateTime']['output']>;
};

export type PatientMSPressure = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSPressure';
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  diastolic: Scalars['Int']['output'];
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  systolic: Scalars['Int']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSPriceData = {
  __typename?: 'PatientMSPriceData';
  NFZ?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Świadczenia główne */
export type PatientMSPrimaryMedicalService =
  /** Porada kompleksowa w opiece koordynowanej */
  | 'COMPLEX'
  /** Porada kontrolna w opiece koordynowanej */
  | 'CONTROL'
  /** Bilans zdrowia w wieku 20-59 */
  | 'HEALTH_CHECK_20_59'
  /** Bilans zdrowia w wieku 60+ */
  | 'HEALTH_CHECK_60_PLUS'
  /** Porada edukacyjna - Bilans zdrowia */
  | 'HEALTH_EDUCATION'
  /** Wizyta wstępna w opiece koordynowanej */
  | 'INITIAL'
  /** Porada pacjent-specjalista w dziedzinie alergologii */
  | 'IPOM_ALLERGOLOGY'
  /** Porada pacjent-specjalista w dziedzinie kardiologii */
  | 'IPOM_CARDIOLOGY'
  /** Porada pacjent-specjalista w dziedzinie diabetologii */
  | 'IPOM_DIABETOLOGY'
  /** Konsultacja dietetyczna w Opiece Koordynowanej */
  | 'IPOM_DIET'
  /** Porada edukacyjna - Opieka Koordynowana */
  | 'IPOM_EDUCATION'
  /** Porada pacjent-specjalista w dziedzinie endokrynologii */
  | 'IPOM_ENDOCRINOLOGY'
  /** Porada pacjent-specjalista w dziedzinie nefrologii */
  | 'IPOM_NEPHROLOGY'
  /** Porada pacjent-specjalista w dziedzinie pulmonologii */
  | 'IPOM_PULMONOLOGY'
  /** Brak */
  | 'NONE';

export type PatientMSProcedureAnswer = {
  __typename?: 'PatientMSProcedureAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureBandage = {
  __typename?: 'PatientMSProcedureBandage';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureBandageInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureChukEducation = {
  __typename?: 'PatientMSProcedureChukEducation';
  cholesterol?: Maybe<Scalars['Float']['output']>;
  cholesterolHDL?: Maybe<Scalars['Float']['output']>;
  cholesterolLDL?: Maybe<Scalars['Float']['output']>;
  cholesterolNonHDL?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  glucose?: Maybe<Scalars['Float']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Float']['output']>;
  simpFiles?: Maybe<Array<Scalars['String']['output']>>;
  triglycerides?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSProcedureChukMeasurements = {
  __typename?: 'PatientMSProcedureChukMeasurements';
  bodyMeasurements?: Maybe<PatientMSChukBodyMeasurements>;
  comment?: Maybe<Scalars['String']['output']>;
  pressureMeasurements?: Maybe<Array<PatientMSChukPressureMeasurement>>;
};

export type PatientMSProcedureDataInput = {
  answers?: InputMaybe<Array<PatientMSProcedureAnswerInput>>;
  bandage?: InputMaybe<Array<PatientMSProcedureBandageInput>>;
  chukEducation?: InputMaybe<PatientMSChukEducationInput>;
  chukMeasurements?: InputMaybe<PatientMSChukMeasurementsInput>;
  disinfectant?: InputMaybe<Array<PatientMSProcedureDisinfectantInput>>;
  doctorAdvice?: InputMaybe<PatientMSDoctorAdviceInput>;
  doctorDiagnosis?: InputMaybe<Array<PatientMSDiagnosisInput>>;
  dressingChange?: InputMaybe<PatientMSProcedureDressingChangeInput>;
  drug?: InputMaybe<Array<PatientMSProcedureDrugInput>>;
  education?: InputMaybe<PatientMSProcedureEducationInput>;
  ekg?: InputMaybe<PatientMSProcedureEKGInput>;
  file?: InputMaybe<Array<Scalars['String']['input']>>;
  foreignBody?: InputMaybe<PatientMSProcedureForeignBodyInput>;
  isEditingLocked?: InputMaybe<Scalars['Boolean']['input']>;
  measurement?: InputMaybe<Array<PatientMSMeasurementInput>>;
  medicalAct?: InputMaybe<PatientMSMedicalActInput>;
  medication?: InputMaybe<PatientMSProcedureMedicationInput>;
  midwifeEducationalVisit?: InputMaybe<PatientMSMidwifeEducationalVisit>;
  nurseAdvice?: InputMaybe<PatientMSNurseAdviceInput>;
  observations?: InputMaybe<Scalars['String']['input']>;
  patronageVisit?: InputMaybe<PatientMSPatronageVisitInput>;
  recommendation?: InputMaybe<Scalars['String']['input']>;
  spirometry?: InputMaybe<PatientMSProcedureSpirometryInput>;
  stitch?: InputMaybe<PatientMSProcedureStitchInput>;
  tool?: InputMaybe<Array<PatientMSProcedureToolInput>>;
  tuberculosisEducation?: InputMaybe<PatientMSTuberculosisEducationInput>;
  usg?: InputMaybe<PatientMSUsgInput>;
  vaccine?: InputMaybe<Array<PatientMSVaccineInput>>;
  vaccineData?: InputMaybe<PatientMSProcedureVaccineBasicDataInput>;
};

export type PatientMSProcedureDisinfectant = {
  __typename?: 'PatientMSProcedureDisinfectant';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureDisinfectantInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureDressingChange = {
  __typename?: 'PatientMSProcedureDressingChange';
  place?: Maybe<Scalars['String']['output']>;
  secretion?: Maybe<PatientMSSecretionType>;
  type?: Maybe<Scalars['String']['output']>;
  woundClassification?: Maybe<Array<Scalars['String']['output']>>;
  woundHealingStatus?: Maybe<PatientMSWoundHealingStatus>;
};

export type PatientMSProcedureDressingChangeInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  secretion?: InputMaybe<PatientMSSecretionType>;
  type?: InputMaybe<Scalars['String']['input']>;
  woundClassification?: InputMaybe<Array<Scalars['String']['input']>>;
  woundHealingStatus?: InputMaybe<PatientMSWoundHealingStatus>;
};

export type PatientMSProcedureDrug = {
  __typename?: 'PatientMSProcedureDrug';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureDrugInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureEKG = {
  __typename?: 'PatientMSProcedureEKG';
  cito?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureEKGInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureEducation = {
  __typename?: 'PatientMSProcedureEducation';
  comment?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureEducationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  ipomEducation?: InputMaybe<Scalars['Boolean']['input']>;
  myHealthEducation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientMSProcedureEntity = {
  __typename?: 'PatientMSProcedureEntity';
  answers: Array<PatientMSProcedureAnswer>;
  bandages: Array<PatientMSProcedureBandage>;
  cancelled: Scalars['Boolean']['output'];
  chukEducation?: Maybe<PatientMSProcedureChukEducation>;
  chukMeasurements?: Maybe<PatientMSProcedureChukMeasurements>;
  createdAt: Scalars['PatientMSDateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdOnVisitId?: Maybe<Scalars['String']['output']>;
  creator: PatientMSUser;
  data?: Maybe<Scalars['PatientMSJSON']['output']>;
  disinfectants: Array<PatientMSProcedureDisinfectant>;
  displayName: Scalars['String']['output'];
  doctorDiagnosis?: Maybe<Array<Maybe<PatientMSDiagnosis>>>;
  dressingChange?: Maybe<PatientMSProcedureDressingChange>;
  drugs: Array<PatientMSProcedureDrug>;
  education?: Maybe<PatientMSProcedureEducation>;
  ekg?: Maybe<PatientMSProcedureEKG>;
  executionLimit: Scalars['String']['output'];
  files?: Maybe<Array<Scalars['String']['output']>>;
  foreignBody?: Maybe<PatientMSProcedureForeignBody>;
  id: Scalars['String']['output'];
  isEditingLocked: Scalars['Boolean']['output'];
  measurements: Array<PatientMSProcedureMeasurement>;
  medicalAct?: Maybe<PatientMSProcedureMedicalAct>;
  medication?: Maybe<PatientMSProcedureMedication>;
  messageId?: Maybe<Scalars['String']['output']>;
  midwifeEducationalVisit?: Maybe<PatientMSProcedureMidwifeEducationalVisit>;
  observations: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  patronageVisit?: Maybe<PatientMSProcedureParonageVisit>;
  spirometry?: Maybe<PatientMSProcedureSpirometry>;
  stitch?: Maybe<PatientMSProcedureStitch>;
  tools: Array<PatientMSProcedureTool>;
  tuberculosisEducation?: Maybe<PatientMSProcedureTuberculosisEducation>;
  type: PatientMSProcedureType;
  updatedAt: Scalars['PatientMSDateTime']['output'];
  usg?: Maybe<PatientMSProcedureUsg>;
  vaccineData?: Maybe<PatientMSProcedureVaccineBasicData>;
  vaccines: Array<PatientMSProcedureVaccine>;
  visit?: Maybe<PatientMSVisit>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureForeignBody = {
  __typename?: 'PatientMSProcedureForeignBody';
  comment?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureForeignBodyInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureMeasurement = {
  __typename?: 'PatientMSProcedureMeasurement';
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  resultType?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureMedicalAct = {
  __typename?: 'PatientMSProcedureMedicalAct';
  comment?: Maybe<Scalars['String']['output']>;
  diastolicPressure?: Maybe<Scalars['String']['output']>;
  glycemia?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  pulse?: Maybe<Scalars['String']['output']>;
  systolicPressure?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureMedication = {
  __typename?: 'PatientMSProcedureMedication';
  cito?: Maybe<Scalars['Boolean']['output']>;
  dosing?: Maybe<Scalars['String']['output']>;
  injection?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureMedicationInput = {
  cito?: InputMaybe<Scalars['Boolean']['input']>;
  dosing?: InputMaybe<Scalars['String']['input']>;
  injection?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureMidwifeEducationalVisit = {
  __typename?: 'PatientMSProcedureMidwifeEducationalVisit';
  pregnacyWeek?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  visitTopics?: Maybe<Array<Scalars['String']['output']>>;
};

export type PatientMSProcedureParonageVisit = {
  __typename?: 'PatientMSProcedureParonageVisit';
  summary?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureSpirometry = {
  __typename?: 'PatientMSProcedureSpirometry';
  comments?: Maybe<Scalars['String']['output']>;
  diastolicTest?: Maybe<Scalars['Boolean']['output']>;
  examinationComments?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureSpirometryInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  diastolicTest?: InputMaybe<Scalars['Boolean']['input']>;
  examinationComments?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureStitch = {
  __typename?: 'PatientMSProcedureStitch';
  place?: Maybe<Scalars['String']['output']>;
  woundHealingStatus?: Maybe<PatientMSWoundHealingStatus>;
};

export type PatientMSProcedureStitchInput = {
  place?: InputMaybe<Scalars['String']['input']>;
  woundHealingStatus?: InputMaybe<PatientMSWoundHealingStatus>;
};

export type PatientMSProcedureTool = {
  __typename?: 'PatientMSProcedureTool';
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureToolInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
  used?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSProcedureTuberculosisEducation = {
  __typename?: 'PatientMSProcedureTuberculosisEducation';
  patientEducated?: Maybe<Scalars['Boolean']['output']>;
  riskGroup?: Maybe<PatientMSTuberculosisRiskLevel>;
  score?: Maybe<Scalars['Float']['output']>;
  telemedicalConsultation?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientMSProcedureType =
  | 'BANDAGE'
  | 'CHUK_EDUCATION'
  | 'CHUK_MEASUREMENTS'
  | 'DOCTOR_ADVICE'
  | 'DRUGPASS'
  | 'EDUCATION'
  | 'EKG'
  | 'MEDICAL_ACT'
  | 'MIDWIFE_EDUCATIONAL_VISIT'
  | 'NURSE_ADVICE'
  | 'OBJECT'
  | 'PATRONAGE_VISIT'
  | 'QUALIFICATION_FOR_VACCINATION'
  | 'SPIRO'
  | 'SPIROMETRY'
  | 'STITCHES'
  | 'TUBERCULOSIS_EDUCATION'
  | 'USG'
  | 'VACCINE';

export type PatientMSProcedureUsg = {
  __typename?: 'PatientMSProcedureUsg';
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<PatientMSProcedureUsgReferralInfo>;
  referralId?: Maybe<Scalars['String']['output']>;
  service?: Maybe<PatientMSAssignmentEntity>;
  serviceId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureUsgReferralInfo = {
  __typename?: 'PatientMSProcedureUsgReferralInfo';
  comment: Scalars['String']['output'];
  mainDiagnosis: Scalars['String']['output'];
  procedureName: Scalars['String']['output'];
};

export type PatientMSProcedureVaccine = {
  __typename?: 'PatientMSProcedureVaccine';
  dose?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productSeries?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureVaccineBasicData = {
  __typename?: 'PatientMSProcedureVaccineBasicData';
  comment?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PatientMSProcedureVaccineBasicDataInput = {
  comment: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PatientMSPublicStatus =
  | 'FULL_POSSIBILITIES'
  | 'NEVER_PATIENT'
  | 'NEVER_PATIENT_WITH_PERSONAL'
  | 'NO_INPERSON_VISIT'
  | 'NO_TELEAGREEMENT';

export type PatientMSRTPayload = {
  jwt: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};

export type PatientMSRange = {
  __typename?: 'PatientMSRange';
  max: Scalars['String']['output'];
  min: Scalars['String']['output'];
};

export type PatientMSRateVisitInput = {
  answers?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
  visitId: Scalars['String']['input'];
};

export type PatientMSRealNFZStatusType =
  | 'DONOTREPORT'
  | 'NOTDECLARABLE'
  | 'O'
  | 'P'
  | 'PENDING'
  | 'TODECLARE'
  | 'Z';

export type PatientMSRecommendationDisplay = {
  __typename?: 'PatientMSRecommendationDisplay';
  city?: Maybe<Scalars['String']['output']>;
  display: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nearestTerm?: Maybe<Scalars['PatientMSDateTime']['output']>;
  nfz?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSReferral = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSReferral';
  adviceGoal?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<PatientMSClinicDetails>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  examinationType?: Maybe<Scalars['String']['output']>;
  icd9?: Maybe<PatientMSICD9Main>;
  icd10?: Maybe<PatientMSICD10Main>;
  id: Scalars['String']['output'];
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  purpose?: Maybe<Scalars['String']['output']>;
  referralDetails: PatientMSReferralDetails;
  referralType: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  urgent?: Maybe<Scalars['Boolean']['output']>;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
  ward?: Maybe<PatientMSWardDetails>;
};

export type PatientMSReferralDetails = {
  __typename?: 'PatientMSReferralDetails';
  code?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

export type PatientMSRegistrationDaytime =
  | 'AFTERNOON'
  | 'EVENING'
  | 'MORNING';

export type PatientMSRegistrationSlot = PatientMSPersonalRegistrationSlot | PatientMSTelemedicalRegistrationSlot;

export type PatientMSRegistrationSlotBase = {
  exactStartTime: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSRegistrationSlots = {
  __typename?: 'PatientMSRegistrationSlots';
  daytime: PatientMSRegistrationDaytime;
  slots: Array<PatientMSRegistrationSlot>;
};

export type PatientMSRegistrationSource =
  | 'MOBILE'
  | 'WEB';

export type PatientMSRepresentativeInsuranceStatementData = {
  reason: PatientMSInsuranceStatementRepresentativeReason;
  representativePatientId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSRequestedDrugDto = {
  __typename?: 'PatientMSRequestedDrugDto';
  details: PatientMSDrugDetails;
  ean: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  regularDrugSourceTag?: Maybe<PatientMSPatientTagEntity>;
  resolvedInPrescriptions?: Maybe<Array<PatientMSPrescription>>;
};

export type PatientMSRtg = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSRtg';
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSSMSNotifications = {
  __typename?: 'PatientMSSMSNotifications';
  deadline: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type PatientMSSecretData = {
  __typename?: 'PatientMSSecretData';
  breastfeeding?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hearingdisabled?: Maybe<Scalars['Boolean']['output']>;
  nice?: Maybe<Scalars['Boolean']['output']>;
  notnice?: Maybe<Scalars['Boolean']['output']>;
  physicallydisabled?: Maybe<Scalars['Boolean']['output']>;
  pregnant?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientMSSecretionType =
  | 'BLOODY'
  | 'PURULENT'
  | 'SEROUS';

export type PatientMSSelfOrdinatedDrugDto = {
  __typename?: 'PatientMSSelfOrdinatedDrugDto';
  details: PatientMSDrugDetails;
  ean: Scalars['String']['output'];
  expirationDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type PatientMSSentNoShowNotifications = {
  __typename?: 'PatientMSSentNoShowNotifications';
  answer?: Maybe<PatientMSNoShowNotificationAnswer>;
  notifications: PatientMSSentNotifications;
};

export type PatientMSSentNotifications = {
  __typename?: 'PatientMSSentNotifications';
  cancelled?: Maybe<Scalars['String']['output']>;
  warnings: Array<Maybe<Scalars['String']['output']>>;
};

export type PatientMSServiceStaffEntity = {
  __typename?: 'PatientMSServiceStaffEntity';
  colsynced?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  organizationId: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  saleorProductId?: Maybe<Scalars['String']['output']>;
  saleorProductVariantId?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['String']['output'];
  slots: Scalars['Float']['output'];
  staffId: Scalars['String']['output'];
};

export type PatientMSSex =
  | 'FEMALE'
  | 'MALE';

export type PatientMSShift = {
  id: Scalars['String']['input'];
  version: Scalars['Float']['input'];
};

export type PatientMSShiftsSlot = {
  from: Scalars['PatientMSDateTime']['input'];
  shifts: Array<PatientMSShift>;
  to: Scalars['PatientMSDateTime']['input'];
};

export type PatientMSSlotEntity = {
  __typename?: 'PatientMSSlotEntity';
  blocked: Scalars['Int']['output'];
  doctorId: Scalars['String']['output'];
  end: Scalars['Int']['output'];
  entryId: Scalars['Int']['output'];
  filled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['String']['output'];
  polmedId?: Maybe<Scalars['Int']['output']>;
  polmedUnit?: Maybe<Scalars['Int']['output']>;
  shiftId: Scalars['Int']['output'];
  slotType: PatientMSSlotType;
  start: Scalars['Int']['output'];
  visitId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSSlotReservationEntity = {
  __typename?: 'PatientMSSlotReservationEntity';
  createdAt: Scalars['PatientMSDateTime']['output'];
  expiresAt: Scalars['PatientMSDateTime']['output'];
  id: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  reservedSlots: Array<PatientMSSlotEntity>;
};

export type PatientMSSlotType =
  | 'COLLECTION'
  | 'DIETARY'
  | 'EXPRESS'
  | 'HOME'
  | 'INFECTIONS'
  | 'INFECTIONS_PRIVATE'
  | 'INFECTIONS_PUBLIC'
  | 'MIDWIFE'
  | 'NURSE_VISIT'
  | 'PERSONAL'
  | 'PROCEDURES'
  | 'SPECIALIST'
  | 'SPECIALIST_DOCTOR'
  | 'TELEMEDICAL'
  | 'TELEMEDICAL_NEW_CITIES'
  | 'TELEMEDICAL_PRIVATE'
  | 'USG';

export type PatientMSSlotsRecInput = {
  availableInDays?: InputMaybe<Scalars['String']['input']>;
  patientPublicStatusFilter?: InputMaybe<Scalars['String']['input']>;
  patientSexFilter?: InputMaybe<PatientMSSex>;
  position: Scalars['String']['input'];
  specialistServiceId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  visitType?: InputMaybe<Scalars['String']['input']>;
  withLLM?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientMSSnippetEntity = {
  __typename?: 'PatientMSSnippetEntity';
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  counter: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Float']['output'];
  tags: Scalars['PatientMSJSON']['output'];
  type: PatientMSSnippetType;
  visibility: PatientMSSnippetVisibility;
};

export type PatientMSSnippetType =
  | 'CHAT'
  | 'DOCS'
  | 'USG';

export type PatientMSSnippetVisibility =
  | 'PRIVATE'
  | 'PUBLIC';

export type PatientMSSpiro = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSSpiro';
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  file?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSStateInsurance =
  | 'KRUS'
  | 'OTHER_COUNTRY'
  | 'OTHER_IN_POLAND'
  | 'ZUS';

export type PatientMSStayAddress = {
  __typename?: 'PatientMSStayAddress';
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  flatNumber?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type PatientMSStreetPrefix =
  | 'AL'
  | 'PL'
  | 'RONDO'
  | 'SKWER'
  | 'UL';

export type PatientMSStripePaymentEntity = {
  __typename?: 'PatientMSStripePaymentEntity';
  createdAt: Scalars['PatientMSDateTime']['output'];
  fullPrice: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceUrl: Scalars['String']['output'];
  paidAt: Scalars['PatientMSDateTime']['output'];
  status: PatientMSStripePaymentStatus;
  stripeSessionId: Scalars['String']['output'];
  updatedAt: Scalars['PatientMSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type PatientMSStripePaymentStatus =
  | 'PAID'
  | 'UNPAID';

export type PatientMSSupportedLanguage =
  | 'EN'
  | 'PL'
  | 'RU'
  | 'UK';

export type PatientMSSurvey = {
  __typename?: 'PatientMSSurvey';
  height: Scalars['String']['output'];
  risks: Array<PatientMSAnswer>;
  weight: Scalars['String']['output'];
};

export type PatientMSSurveyProposal = {
  __typename?: 'PatientMSSurveyProposal';
  createdAt: Scalars['String']['output'];
  data: Scalars['PatientMSJSON']['output'];
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  schema: Scalars['PatientMSJSON']['output'];
  updatedAt: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type PatientMSSurveyProposalEntity = {
  __typename?: 'PatientMSSurveyProposalEntity';
  createdAt: Scalars['PatientMSDateTime']['output'];
  data?: Maybe<Scalars['PatientMSJSON']['output']>;
  formId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isFilled: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  updatedAt: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSSurveyProposalPatientInput = {
  data: Scalars['PatientMSJSON']['input'];
  isFilled: Scalars['Boolean']['input'];
};

export type PatientMSTagType =
  | 'DOCTOR'
  | 'EXAMINATION'
  | 'LOCALIZATION'
  | 'OFFICE';

export type PatientMSTelemedicalRegistrationSlot = PatientMSRegistrationSlotBase & {
  __typename?: 'PatientMSTelemedicalRegistrationSlot';
  exactStartTime: Scalars['PatientMSDateTime']['output'];
  slotTimeEnd: Scalars['PatientMSDateTime']['output'];
  slotTimeStart: Scalars['PatientMSDateTime']['output'];
};

export type PatientMSTerm = {
  __typename?: 'PatientMSTerm';
  date: Scalars['String']['output'];
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intervals: Array<PatientMSDoctorInterval>;
  slotSize: Scalars['Int']['output'];
  tags: Array<PatientMSTermTag>;
  type: PatientMSTermType;
};

export type PatientMSTermTag = {
  __typename?: 'PatientMSTermTag';
  type: PatientMSTagType;
  userId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PatientMSTermType =
  | 'BLOCKER'
  | 'DOCTORDAY'
  | 'DOCTORWEEK'
  | 'PLACE';

export type PatientMSTestimonial = PatientMSBaseMessage & PatientMSGlobal & {
  __typename?: 'PatientMSTestimonial';
  createdAt: PatientMSTime;
  data: Scalars['PatientMSJSON']['output'];
  doctor: PatientMSDoctor;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patient: PatientMSPatient;
  patientId: Scalars['String']['output'];
  stripeSessionId: Scalars['String']['output'];
  testimonialType: Scalars['String']['output'];
  type: PatientMSMessageType;
  updatedAt: PatientMSTime;
  visit: PatientMSVisit;
  visitId: Scalars['String']['output'];
};

export type PatientMSTidyDocumentationResultEntity = {
  __typename?: 'PatientMSTidyDocumentationResultEntity';
  createdAt: Scalars['PatientMSDateTime']['output'];
  id: Scalars['String']['output'];
  issuedAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  medicalRecord: PatientMSMedicalRecordEntity;
  name?: Maybe<Scalars['String']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['PatientMSJSON']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PatientMSTime = {
  __typename?: 'PatientMSTime';
  iso: Scalars['String']['output'];
  local: Scalars['String']['output'];
};

export type PatientMSTokensPayload = {
  __typename?: 'PatientMSTokensPayload';
  error?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
};

export type PatientMSTuberculosisEducationInput = {
  patientEducated?: InputMaybe<Scalars['Boolean']['input']>;
  riskGroup?: InputMaybe<PatientMSTuberculosisRiskLevel>;
  score?: InputMaybe<Scalars['Float']['input']>;
  telemedicalConsultation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientMSTuberculosisRiskLevel =
  | 'HIGH'
  | 'MODERATE'
  | 'NO_RISK';

export type PatientMSUnderCarePerson = {
  __typename?: 'PatientMSUnderCarePerson';
  birthDate: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PatientMSUpdateProcedureInput = {
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSUser = PatientMSDoctor | PatientMSPatient;

export type PatientMSUserEntity = {
  __typename?: 'PatientMSUserEntity';
  acCohort?: Maybe<Scalars['Float']['output']>;
  acTimestamp: Scalars['Float']['output'];
  acTimestampStart: Scalars['Float']['output'];
  address?: Maybe<PatientMSAddress>;
  analyticsData?: Maybe<PatientMSAnalyticsData>;
  analyticsId?: Maybe<Scalars['String']['output']>;
  assistantId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  blockedTelemedicine: Scalars['Boolean']['output'];
  chosenDoctor?: Maybe<Scalars['String']['output']>;
  chosenNurse?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  clientAppSettings?: Maybe<PatientMSClientAppSettings>;
  createdAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  declarationType?: Maybe<Scalars['String']['output']>;
  declarations?: Maybe<Array<PatientMSDeclaration>>;
  deviceInfo?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  ewusCheck?: Maybe<PatientMSEwusCheck>;
  ewusCheckHistory?: Maybe<PatientMSHistory>;
  files?: Maybe<Scalars['PatientMSJSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  genre: PatientMSUserGenre;
  hiddenSnippets?: Maybe<Array<Scalars['String']['output']>>;
  history?: Maybe<PatientMSHistory>;
  id: Scalars['String']['output'];
  immunizationCardComment: Scalars['String']['output'];
  immunizationCardStatus: Scalars['String']['output'];
  immunizationStatus: Scalars['Float']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isQualifiedToCHUK: Scalars['Boolean']['output'];
  izolacja?: Maybe<Scalars['String']['output']>;
  kwarantanna?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPatientMessageBlock?: Maybe<Scalars['Float']['output']>;
  llmAgreement?: Maybe<Scalars['Boolean']['output']>;
  marketing?: Maybe<Scalars['Boolean']['output']>;
  medicalDataAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
  medicalPushToken?: Maybe<Scalars['PatientMSJSON']['output']>;
  mobileAppVersion?: Maybe<Scalars['String']['output']>;
  oneTimeSurvey?: Maybe<PatientMSSurvey>;
  oneTimeSurveyUpdatedAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  organizationId: Scalars['String']['output'];
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
  patientCardNumber?: Maybe<Scalars['String']['output']>;
  patientPublicSince?: Maybe<Scalars['PatientMSDateTime']['output']>;
  pesel?: Maybe<Scalars['String']['output']>;
  phoneMarketingAgreement?: Maybe<Scalars['Boolean']['output']>;
  pushToken?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  registrationType?: Maybe<Scalars['String']['output']>;
  secretData?: Maybe<PatientMSSecretData>;
  selfOrdinatedDrugs?: Maybe<Array<PatientMSSelfOrdinatedDrugDto>>;
  signature?: Maybe<Scalars['String']['output']>;
  stateInsurance: PatientMSStateInsurance;
  statusUbezpieczenia?: Maybe<Scalars['String']['output']>;
  stayAddresses?: Maybe<Array<PatientMSStayAddress>>;
  uniqueIntegerId?: Maybe<Scalars['Float']['output']>;
  unread: Scalars['Float']['output'];
  unsuccessfulAuth?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  usedReferralCode?: Maybe<Scalars['String']['output']>;
  visitRecordingAndAnalysisAgreement?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientMSUserGenre =
  | 'ASSISTANT'
  | 'CLINIC_MANAGER'
  | 'DOCTOR'
  | 'MODERATOR'
  | 'NURSE'
  | 'PATIENT'
  | 'STAFF';

export type PatientMSUserInput = {
  address?: InputMaybe<PatientMSFullAddressInput>;
  analyticsData?: InputMaybe<PatientMSAnalyticsDataInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  clientAppSettings?: InputMaybe<PatientMSClientAppSettingsInput>;
  declarationData?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  declarationType?: InputMaybe<Scalars['String']['input']>;
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  envelopeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  installDate?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  llmAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  marketing?: InputMaybe<Scalars['Boolean']['input']>;
  medicalDataAnalysisAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  mobileAppVersion?: InputMaybe<Scalars['String']['input']>;
  oneTimeSurvey?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  passportCountry?: InputMaybe<Scalars['String']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phoneMarketingAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  realNFZStatus?: InputMaybe<PatientMSRealNFZStatusType>;
  referral?: InputMaybe<Scalars['String']['input']>;
  registrationType?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  regularSurvey?: InputMaybe<Scalars['PatientMSJSON']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  uniqueIntegerId?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Float']['input']>;
  updates?: InputMaybe<Array<Scalars['String']['input']>>;
  usedReferralCode?: InputMaybe<Scalars['String']['input']>;
  visitRecordingAndAnalysisAgreement?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientMSUsersNotificationAgreementsEntity = {
  __typename?: 'PatientMSUsersNotificationAgreementsEntity';
  agreed: Scalars['Boolean']['output'];
  createdAt: Scalars['PatientMSDateTime']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['PatientMSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type PatientMSUsg = PatientMSBaseVital & PatientMSGlobal & {
  __typename?: 'PatientMSUsg';
  createdAt: PatientMSTime;
  customDate?: Maybe<PatientMSTime>;
  delivered?: Maybe<PatientMSTime>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  measured?: Maybe<PatientMSTime>;
  message?: Maybe<PatientMSMessage>;
  messageId: Scalars['String']['output'];
  overrideFiles?: Maybe<Array<Scalars['String']['output']>>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  type: PatientMSVitalType;
  updatedAt: PatientMSTime;
  visit?: Maybe<PatientMSVisit>;
  visitId: Scalars['String']['output'];
};

export type PatientMSUsgInput = {
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSVaccineInput = {
  dose?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productSeries?: InputMaybe<Scalars['String']['input']>;
};

export type PatientMSVisit = PatientMSGlobal & {
  __typename?: 'PatientMSVisit';
  additionalMedicalService?: Maybe<Array<Scalars['String']['output']>>;
  appointmentStatus: Scalars['String']['output'];
  availableImaginingOrganizationId: Scalars['String']['output'];
  cancelledAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  children: Array<PatientMSVisit>;
  closedByBot?: Maybe<Scalars['Boolean']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: PatientMSTime;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByUsername: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  determineIpomEligibility: Scalars['Boolean']['output'];
  diagId?: Maybe<Scalars['Int']['output']>;
  diagnosis: Array<PatientMSDiagnosis>;
  doctor?: Maybe<PatientMSDoctor>;
  doctorDiagnosis?: Maybe<Array<Maybe<PatientMSDiagnosis>>>;
  doctorId?: Maybe<Scalars['String']['output']>;
  doctorInterview?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  ecommerceOrderIds: Array<Scalars['String']['output']>;
  faqRead?: Maybe<Array<PatientMSFaqType>>;
  faqTypes: Array<PatientMSAssignmentFaqType>;
  height?: Maybe<Scalars['Int']['output']>;
  icd10Main?: Maybe<PatientMSICD10Main>;
  icd10Secondary?: Maybe<PatientMSICD10Main>;
  id: Scalars['String']['output'];
  innatePriority: PatientMSVisitPriority;
  invitationSentAt?: Maybe<PatientMSTime>;
  invitationSentBy?: Maybe<PatientMSDoctor>;
  isPublicVisit: Scalars['Boolean']['output'];
  laboratoryExaminations: Array<PatientMSLaboratoryExaminationEntity>;
  leftOn?: Maybe<Scalars['String']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  note: Scalars['String']['output'];
  nurseDiagnosis?: Maybe<Array<PatientMSDiagnosis>>;
  nursePhysicalExamination?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<PatientMSPatient>;
  patientId: Scalars['String']['output'];
  physicalExamination?: Maybe<Scalars['String']['output']>;
  plannedPlace?: Maybe<Scalars['String']['output']>;
  plannedStart?: Maybe<PatientMSTime>;
  preInterview?: Maybe<Array<PatientMSLlmChatMessage>>;
  prescriptionRequest?: Maybe<PatientMSPrescriptionRequestDto>;
  prescriptionRequestId?: Maybe<Scalars['String']['output']>;
  primaryMedicalService?: Maybe<PatientMSPrimaryMedicalService>;
  procedures: Array<PatientMSProcedureEntity>;
  rating: PatientMSVisitsRatingEntity;
  recommendation?: Maybe<Scalars['String']['output']>;
  recommendationsMessage?: Maybe<PatientMSChatMessageEntity>;
  recommendationsMessageId?: Maybe<Scalars['String']['output']>;
  sentNoShowNotifications?: Maybe<PatientMSSentNoShowNotifications>;
  serviceId?: Maybe<Scalars['String']['output']>;
  serviceStaff?: Maybe<PatientMSServiceStaffEntity>;
  showOn?: Maybe<Scalars['String']['output']>;
  slotType?: Maybe<Scalars['String']['output']>;
  smokeLevel?: Maybe<Scalars['Int']['output']>;
  smsNotifications: PatientMSSMSNotifications;
  snapshotAt?: Maybe<Scalars['String']['output']>;
  snapshotBy?: Maybe<Scalars['String']['output']>;
  source: PatientMSVisit;
  startOn?: Maybe<Scalars['String']['output']>;
  status: PatientMSVisitStatus;
  surveys: Array<PatientMSSurveyProposal>;
  timeStatus: PatientMSVisitComplexStatus;
  type?: Maybe<PatientMSVisitType>;
  updatedAt: PatientMSTime;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PatientMSVisitComplexStatus =
  | 'PAST'
  | 'UPCOMING';

export type PatientMSVisitPriority =
  | 'IMMEDIATE'
  | 'INDETERMINATE'
  | 'STANDARD'
  | 'URGENT';

export type PatientMSVisitStatus =
  | 'ARCHIVE'
  | 'DRAFT'
  | 'INPROGRESS'
  | 'SUCCESS';

export type PatientMSVisitType =
  | 'PROCEDURE'
  | 'STANDARD'
  | 'VIRTUAL';

export type PatientMSVisitsRatingEntity = {
  __typename?: 'PatientMSVisitsRatingEntity';
  answers: Scalars['PatientMSJSON']['output'];
  createdAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  formId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  updatedAt: Scalars['PatientMSDateTime']['output'];
  userId: Scalars['String']['output'];
  visitId: Scalars['String']['output'];
};

export type PatientMSVital = PatientMSAnalysis | PatientMSCt | PatientMSEcommerce | PatientMSEkg | PatientMSHeartrate | PatientMSInjection | PatientMSOperation | PatientMSOther | PatientMSPressure | PatientMSRtg | PatientMSSpiro | PatientMSUsg;

export type PatientMSVitalEntity = {
  __typename?: 'PatientMSVitalEntity';
  analysisType?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  customComment?: Maybe<Scalars['String']['output']>;
  customDate?: Maybe<Scalars['String']['output']>;
  customName?: Maybe<Scalars['String']['output']>;
  delivered?: Maybe<Scalars['String']['output']>;
  diastolic?: Maybe<Scalars['String']['output']>;
  doctorId?: Maybe<Scalars['String']['output']>;
  drugs: Scalars['PatientMSJSON']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  injectionType?: Maybe<Scalars['String']['output']>;
  measured?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  overrideFiles: Scalars['PatientMSJSON']['output'];
  params: Scalars['PatientMSJSON']['output'];
  patientId?: Maybe<Scalars['String']['output']>;
  positionId?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['String']['output']>;
  systolic?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['PatientMSDateTime']['output']>;
  visitId?: Maybe<Scalars['String']['output']>;
};

export type PatientMSVitalType =
  | 'ANALYSIS'
  | 'CT'
  | 'ECOMMERCE'
  | 'EKG'
  | 'HEARTRATE'
  | 'INJECTION'
  | 'OPERATION'
  | 'OTHER'
  | 'PRESSURE'
  | 'RTG'
  | 'SPIRO'
  | 'USG';

export type PatientMSWardDetails = {
  __typename?: 'PatientMSWardDetails';
  name: Scalars['String']['output'];
};

export type PatientMSWeekDay =
  | 'Friday'
  | 'Monday'
  | 'Saturday'
  | 'Sunday'
  | 'Thursday'
  | 'Tuesday'
  | 'Wednesday';

export type PatientMSWoundHealingStatus =
  | 'CORRECT'
  | 'UNDER_SCAB'
  | 'WITHOUT_SCAB';

export type PatientMSlabExaminationContainer = {
  __typename?: 'PatientMSlabExaminationContainer';
  labItemsToPay: Array<PatientMSLaboratoryExaminationEntity>;
  labItemsToSchedule: Array<PatientMSLaboratoryExaminationEntity>;
};

export type Query = {
  __typename?: 'Query';
  doctorAdditionalMedicalServices: Array<Scalars['String']['output']>;
  doctorArchivedVisitList: DoctorMSPaginatedVisitResponse;
  doctorAuthorizeDoctor: Scalars['String']['output'];
  doctorAuthorizeMFA: DoctorMSTokensPayload;
  doctorCalendar: Array<DoctorMSImmuCalendarOutput>;
  doctorChatMessages: Array<DoctorMSChatMessageEntity>;
  doctorCheckCEZ: Scalars['String']['output'];
  doctorCheckPatientExists: Scalars['Boolean']['output'];
  doctorClinics: Array<DoctorMSClinic>;
  doctorDiag: Array<DoctorMSDiag>;
  doctorDoctor?: Maybe<DoctorMSDoctor>;
  doctorDoctorGeneratePdf: Scalars['String']['output'];
  doctorDoctors: Array<DoctorMSDoctor>;
  doctorDraftVisits: Array<DoctorMSVisit>;
  doctorDrugRecipes: Array<DoctorMSDrugRecipe>;
  doctorFindAddress: Array<DoctorMSPlacematicAddress>;
  doctorFindAddressMultistring: Array<DoctorMSPlacematicAddress>;
  doctorGetAdditionalRefundRightsWithExplanation: Scalars['DoctorMSJSON']['output'];
  doctorGetDoctorsVisits: Array<DoctorMSVisit>;
  doctorGetDoctorsWithAvailableSlots: Array<DoctorMSDoctor>;
  doctorGetDrugDetails: DoctorMSDrugDetails;
  doctorGetIpom?: Maybe<DoctorMSPatientIpom>;
  doctorGetIpomCodes: Array<Scalars['String']['output']>;
  doctorGetIpomSpecialists: Array<Scalars['String']['output']>;
  doctorGetMessagesForPatient: Array<DoctorMSMessage>;
  doctorGetNearestNFZSlotTime?: Maybe<Scalars['String']['output']>;
  doctorGetP1Prescriptions: DoctorMSP1PrescriptionsReturn;
  doctorGetPatientDocs: Scalars['String']['output'];
  doctorGetPatientDocs2: Scalars['String']['output'];
  doctorGetPrescriptionsForPatient: Array<DoctorMSPrescription>;
  doctorGetReferralsForPatient: Array<DoctorMSReferral>;
  doctorGetSlots: Array<DoctorMSFreeTime>;
  doctorGetSlotsRecipe: Array<DoctorMSFreeTime>;
  doctorGetSpecialistSlots: Array<DoctorMSFreeTime>;
  doctorGetTemplatesForVisit: Array<DoctorMSLabExamTemplate>;
  doctorGetVisitsPerDayForDoctor: Array<DoctorMSVisit>;
  doctorGetZusMedicalLeaves: Array<DoctorMSZusMedicalLeave>;
  doctorGetZusPayers: Array<DoctorMSZusPayer>;
  doctorGetZusPayersByNIP: Array<DoctorMSZusPayer>;
  doctorGroupByChatMessage: Array<DoctorMSChatMessageEntity>;
  doctorHistoryVisits: Array<DoctorMSVisit>;
  doctorICD9: Array<Scalars['String']['output']>;
  doctorICD10: Array<Scalars['String']['output']>;
  doctorLaboratoryExaminationDiagsWithPackets: Array<DoctorMSDiagOrPacket>;
  doctorLaboratoryExaminationReport: Scalars['String']['output'];
  doctorLaboratoryExaminations: Array<DoctorMSLaboratoryExaminationEntity>;
  doctorLeaves: Array<DoctorMSLeave>;
  doctorManyProceduresRender: Array<DoctorMSRenderedProcedure>;
  doctorMe: DoctorMSDoctorWithSecrets;
  doctorMedicalServices: Array<DoctorMSMedicalServices>;
  doctorMedicineSubtitles: Array<DoctorMSMedicineSubtitle>;
  doctorMyUpcomingVisits: Array<DoctorMSVisit>;
  doctorNextPatient: Scalars['String']['output'];
  doctorNextPatients: Array<DoctorMSPatient>;
  doctorNfzEvents: Array<DoctorMSNFZEventEntity>;
  doctorNfzHistory: Array<DoctorMSNfzHistoryEvent>;
  doctorNumberOfPrescriptionRequests: Scalars['Float']['output'];
  doctorOrganizations: Array<DoctorMSOrganizationEntity>;
  doctorPackages: Array<DoctorMSPackage>;
  doctorPatient?: Maybe<DoctorMSPatient>;
  doctorPatientDeclarationHistory: Array<DoctorMSPatientDeclarationHistoryEvent>;
  doctorPatientInsuranceStatus: DoctorMSPatientInsuranceInfo;
  doctorPatients: Array<DoctorMSPatient>;
  doctorPopularLaboratoryExaminationPackets: Array<DoctorMSDiagPacket>;
  doctorPrescriptionsCEZ: DoctorMSPrescriptionsReturn;
  doctorPrescriptionsCEZStag: DoctorMSPrescriptionsReturnStag;
  doctorProcedureRender: DoctorMSRenderedProcedure;
  doctorProcedures: Array<DoctorMSProcedureEntity>;
  doctorRegularDrugs: Array<DoctorMSRegularDrug>;
  doctorReportGenerate: Scalars['String']['output'];
  doctorReports: Array<DoctorMSReportingEventEntity>;
  doctorScheduledVisits: Array<DoctorMSVisit>;
  doctorSearchIPOMs?: Maybe<Array<DoctorMSP1IpomRecord>>;
  doctorSendMfaSmsCode: Scalars['Boolean']['output'];
  doctorShiftTypes: Array<Scalars['String']['output']>;
  doctorShifts: DoctorMSShiftsOutput;
  doctorSnippetTags: Array<DoctorMSSelectOption>;
  doctorSnippets: Array<DoctorMSSnippet>;
  doctorSwiadGenerate: Scalars['String']['output'];
  doctorTodayComboTest: Scalars['Boolean']['output'];
  doctorTodos: Array<DoctorMSTodoEntity>;
  doctorUpcomingVisits: Array<DoctorMSVisit>;
  doctorValidateReferralCode: Scalars['Boolean']['output'];
  doctorValidateToken: Scalars['String']['output'];
  doctorVisit: DoctorMSVisit;
  doctorVisitsForPatients: Array<DoctorMSVisit>;
  doctorWards: Array<Scalars['String']['output']>;
  edmAsk: EdmAiChat;
  edmCalculatePercentile: EdmCalculationResult;
  edmGetAiChatMessages: EdmAiChatMessages;
  edmGetAllDoctorsFromShiftsWithPreviousMonthResolver: Array<EdmMedicalPerson>;
  edmGetAllNonWorkingPeriods: Array<EdmNonWorkingPeriod>;
  edmGetAllShifts: Array<EdmMedicalAppShift>;
  edmGetAllSnippetTags: Array<EdmSnippetTag>;
  edmGetAllSnippets: Array<EdmSnippet>;
  edmGetAllStaffWithGenreAndWorkingHours: Array<EdmStaffWorkingHours>;
  edmGetAllVisitsForDeletedShifts: Array<EdmClinicManagerVisit>;
  edmGetCurrentActivities: Array<EdmCurrentActivity>;
  edmGetDefaultVisitDuration: EdmVisitTimeDuration;
  edmGetHistoricalVisits: EdmCursorVisit;
  edmGetPatientMeasurements: EdmMeasurementHistory;
  edmGetPrescriptions: EdmCursorPrescription;
  edmGetRecentActivities: Array<EdmRecentActivity>;
  edmGetReferrals: EdmCursorReferral;
  edmGetSickLeaves: EdmCursorSickLeave;
  edmGetStaffVisitDuration: EdmVisitTimeDuration;
  edmGetUpcomingVisits: Array<EdmVisitUnionType>;
  edmGetVisitDetails: EdmVisitUnionType;
  edmGetVisitTypesByGenre: Array<EdmMedicalAppVisitType>;
  edmGetVitals: EdmCursorVital;
  edmGetVitalsByVisitId: Array<EdmVital>;
  edmSearchAvailability: EdmCalendarAvailability;
  edmSearchAvailabilityForDay: Array<EdmSlot>;
  heartbeat: Scalars['String']['output'];
  patientAgendoCheckDeclaration: Scalars['Boolean']['output'];
  patientAgendoCheckDeclarationMultiple: Scalars['Boolean']['output'];
  patientAgendoSignDeclaration: Scalars['String']['output'];
  patientAgendoSignDeclarationMultiple: Scalars['String']['output'];
  patientAssignmentIdsToSaleorProductIds: Scalars['PatientMSJSON']['output'];
  patientAuthorizePatient: Scalars['String']['output'];
  patientAuthorizePatientWithRefreshToken: PatientMSTokensPayload;
  patientAuthorizeUpdateAddressPatient: PatientMSTokensPayload;
  patientAvailableFirstRegistrationCalendarSlots: Array<PatientMSCalendarSlot>;
  patientAvailableProfiles: Array<PatientMSPatientWithTokensPayload>;
  patientChatMessages: Array<PatientMSChatMessageRender>;
  patientCheckIfUserExists: Scalars['Boolean']['output'];
  patientCheckMeInEwus: PatientMSNFZEventType;
  patientCheckSmsCode: Scalars['Boolean']['output'];
  patientCheckUserExists: Scalars['Boolean']['output'];
  patientClosestFacilities: Array<PatientMSOrganizationEntity>;
  patientDeclarable: Array<PatientMSDoctor>;
  patientDiagCoupons: Array<PatientMSVisit>;
  patientDoctorLanguages: Array<PatientMSSupportedLanguage>;
  patientDoctors: Array<PatientMSDoctor>;
  patientEcommerceOrdersToSchedule: Array<PatientMSOrderDto>;
  patientFindAddress: Array<PatientMSPlacematicAddress>;
  patientFindAddressMultistring: Array<PatientMSPlacematicAddress>;
  patientFreeSurvey: Array<Scalars['PatientMSJSON']['output']>;
  patientGetFAQsForServices: Array<PatientMSAssignmentFaqMapping>;
  patientGetFirebaseToken: Scalars['String']['output'];
  patientGetNearestNFZSlotTime?: Maybe<Scalars['String']['output']>;
  patientGetPermissions: PatientMSPermissions;
  patientGetPrescriptionRequests: Array<PatientMSPrescriptionRequestDto>;
  patientGetProcedures: Array<PatientMSProcedureEntity>;
  patientGetSlots: Array<PatientMSFreeTime>;
  patientGetSlotsRecipe: Array<PatientMSFreeTime>;
  patientGetSpecialistSlots: Array<PatientMSFreeTime>;
  patientInfoBoxRender: Array<PatientMSInfoBoxRendered>;
  patientLaboratoryExaminationsForPlanVisit: PatientMSlabExaminationContainer;
  patientLaboratoryExaminationsList: Array<PatientMSMedicalService>;
  patientLaboratoryExaminationsToSchedule: Array<PatientMSLaboratoryExaminationEntity>;
  patientMe: PatientMSPatient;
  patientMobileSaleorOrder: Scalars['String']['output'];
  patientOrganizations: Array<PatientMSOrganizationEntity>;
  patientRegistrationSlots: Array<PatientMSRegistrationSlots>;
  patientRegularDrugs: Array<PatientMSDrugDetails>;
  patientReloadNfzStatus: PatientMSObjectedNFZStatus;
  patientSaveFutureUsersData: Scalars['Boolean']['output'];
  patientSelfOrdinatedDrugs: Array<PatientMSSelfOrdinatedDrugDto>;
  patientSendSmsCode: Scalars['Boolean']['output'];
  patientServiceCategories: Array<Scalars['String']['output']>;
  patientServices: Array<Scalars['String']['output']>;
  patientSlotsRecommendations: Array<PatientMSRecommendationDisplay>;
  patientSlotsRecommendations2: Array<PatientMSRecommendationDisplay>;
  patientSlotsReservations: Array<PatientMSSlotReservationEntity>;
  patientTeleAgreement: Scalars['String']['output'];
  patientValidatePatientPolicy: PatientMSPatientPolicy;
  patientValidateReferralCode: Scalars['Boolean']['output'];
  patientVerifyIdFiles: Scalars['String']['output'];
  /** Look up an address by ID. */
  saleorAddress?: Maybe<SaleorAddress>;
  /** Returns address validation rules. */
  saleorAddressValidationRules?: Maybe<SaleorAddressValidationData>;
  /**
   * Look up an app by ID. If ID is not provided, return the currently authenticated app.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER AUTHENTICATED_APP. The authenticated app has access to its resources. Fetching different apps requires MANAGE_APPS permission.
   */
  saleorApp?: Maybe<SaleorApp>;
  /**
   * Look up an app extension by ID.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorAppExtension?: Maybe<SaleorAppExtension>;
  /**
   * List of all extensions.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorAppExtensions?: Maybe<SaleorAppExtensionCountableConnection>;
  /**
   * List of the apps.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, MANAGE_APPS.
   */
  saleorApps?: Maybe<SaleorAppCountableConnection>;
  /**
   * List of all apps installations
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  saleorAppsInstallations: Array<SaleorAppInstallation>;
  /** Look up an attribute by ID, slug or external reference. */
  saleorAttribute?: Maybe<SaleorAttribute>;
  /** List of the shop's attributes. */
  saleorAttributes?: Maybe<SaleorAttributeCountableConnection>;
  /** List of the shop's categories. */
  saleorCategories?: Maybe<SaleorCategoryCountableConnection>;
  /** Look up a category by ID or slug. */
  saleorCategory?: Maybe<SaleorCategory>;
  /** Look up a channel by ID or slug. */
  saleorChannel?: Maybe<SaleorChannel>;
  /**
   * List of all channels.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  saleorChannels?: Maybe<Array<SaleorChannel>>;
  /** Look up a checkout by token and slug of channel. */
  saleorCheckout?: Maybe<SaleorCheckout>;
  /**
   * List of checkout lines.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS.
   */
  saleorCheckoutLines?: Maybe<SaleorCheckoutLineCountableConnection>;
  /**
   * List of checkouts.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS.
   */
  saleorCheckouts?: Maybe<SaleorCheckoutCountableConnection>;
  /** Look up a collection by ID. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorCollection?: Maybe<SaleorCollection>;
  /** List of the shop's collections. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorCollections?: Maybe<SaleorCollectionCountableConnection>;
  /**
   * List of the shop's customers.
   *
   * Requires one of the following permissions: MANAGE_ORDERS, MANAGE_USERS.
   */
  saleorCustomers?: Maybe<SaleorUserCountableConnection>;
  /**
   * Look up digital content by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContent?: Maybe<SaleorDigitalContent>;
  /**
   * List of digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorDigitalContents?: Maybe<SaleorDigitalContentCountableConnection>;
  /**
   * List of draft orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorDraftOrders?: Maybe<SaleorOrderCountableConnection>;
  /**
   * Look up a export file by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorExportFile?: Maybe<SaleorExportFile>;
  /**
   * List of export files.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorExportFiles?: Maybe<SaleorExportFileCountableConnection>;
  /**
   * Look up a gift card by ID.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCard?: Maybe<SaleorGiftCard>;
  /**
   * List of gift card currencies.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardCurrencies: Array<Scalars['String']['output']>;
  /**
   * Gift card related settings from site settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardSettings: SaleorGiftCardSettings;
  /**
   * List of gift card tags.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCardTags?: Maybe<SaleorGiftCardTagCountableConnection>;
  /**
   * List of gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  saleorGiftCards?: Maybe<SaleorGiftCardCountableConnection>;
  /**
   * List of activity events to display on homepage (at the moment it only contains order-events).
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorHomepageEvents?: Maybe<SaleorOrderEventCountableConnection>;
  /** Return the currently authenticated user. */
  saleorMe?: Maybe<SaleorUser>;
  /** Look up a navigation menu by ID or name. */
  saleorMenu?: Maybe<SaleorMenu>;
  /** Look up a menu item by ID. */
  saleorMenuItem?: Maybe<SaleorMenuItem>;
  /** List of the storefronts's menu items. */
  saleorMenuItems?: Maybe<SaleorMenuItemCountableConnection>;
  /** List of the storefront's menus. */
  saleorMenus?: Maybe<SaleorMenuCountableConnection>;
  /** Look up an order by ID or external reference. */
  saleorOrder?: Maybe<SaleorOrder>;
  /**
   * Look up an order by token.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  saleorOrderByToken?: Maybe<SaleorOrder>;
  /**
   * Order related settings from site settings. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated This field will be removed in Saleor 4.0. Use the `channel` query to fetch the `orderSettings` field instead.
   */
  saleorOrderSettings?: Maybe<SaleorOrderSettings>;
  /**
   * List of orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrders?: Maybe<SaleorOrderCountableConnection>;
  /**
   * Return the total sales amount from a specific period.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorOrdersTotal?: Maybe<SaleorTaxedMoney>;
  /** Look up a page by ID or slug. */
  saleorPage?: Maybe<SaleorPage>;
  /** Look up a page type by ID. */
  saleorPageType?: Maybe<SaleorPageType>;
  /** List of the page types. */
  saleorPageTypes?: Maybe<SaleorPageTypeCountableConnection>;
  /** List of the shop's pages. */
  saleorPages?: Maybe<SaleorPageCountableConnection>;
  /**
   * Look up a payment by ID.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorPayment?: Maybe<SaleorPayment>;
  /**
   * List of payments.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  saleorPayments?: Maybe<SaleorPaymentCountableConnection>;
  /**
   * Look up permission group by ID.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorPermissionGroup?: Maybe<SaleorGroup>;
  /**
   * List of permission groups.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorPermissionGroups?: Maybe<SaleorGroupCountableConnection>;
  /**
   * Look up a plugin by ID.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  saleorPlugin?: Maybe<SaleorPlugin>;
  /**
   * List of plugins.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  saleorPlugins?: Maybe<SaleorPluginCountableConnection>;
  /** Look up a product by ID. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorProduct?: Maybe<SaleorProduct>;
  /** Look up a product type by ID. */
  saleorProductType?: Maybe<SaleorProductType>;
  /** List of the shop's product types. */
  saleorProductTypes?: Maybe<SaleorProductTypeCountableConnection>;
  /** Look up a product variant by ID or SKU. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorProductVariant?: Maybe<SaleorProductVariant>;
  /** List of product variants. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorProductVariants?: Maybe<SaleorProductVariantCountableConnection>;
  /** List of the shop's products. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  saleorProducts?: Maybe<SaleorProductCountableConnection>;
  /**
   * List of top selling products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorReportProductSales?: Maybe<SaleorProductVariantCountableConnection>;
  /**
   * Look up a sale by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSale?: Maybe<SaleorSale>;
  /**
   * List of the shop's sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorSales?: Maybe<SaleorSaleCountableConnection>;
  /**
   * Look up a shipping zone by ID.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZone?: Maybe<SaleorShippingZone>;
  /**
   * List of the shop's shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  saleorShippingZones?: Maybe<SaleorShippingZoneCountableConnection>;
  /** Return information about the shop. */
  saleorShop: SaleorShop;
  /**
   * List of the shop's staff users.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  saleorStaffUsers?: Maybe<SaleorUserCountableConnection>;
  /**
   * Look up a stock by ID
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorStock?: Maybe<SaleorStock>;
  /**
   * List of stocks.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  saleorStocks?: Maybe<SaleorStockCountableConnection>;
  /**
   * Look up a tax class.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxClass?: Maybe<SaleorTaxClass>;
  /**
   * List of tax classes.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxClasses?: Maybe<SaleorTaxClassCountableConnection>;
  /**
   * Look up a tax configuration.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxConfiguration?: Maybe<SaleorTaxConfiguration>;
  /**
   * List of tax configurations.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxConfigurations?: Maybe<SaleorTaxConfigurationCountableConnection>;
  /**
   * Tax class rates grouped by country.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxCountryConfiguration?: Maybe<SaleorTaxCountryConfiguration>;
  /**
   *
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  saleorTaxCountryConfigurations?: Maybe<Array<SaleorTaxCountryConfiguration>>;
  /** List of all tax rates available from tax gateway. */
  saleorTaxTypes?: Maybe<Array<SaleorTaxType>>;
  /**
   * Look up a transaction by ID.
   *
   * Added in Saleor 3.6.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  saleorTransaction?: Maybe<SaleorTransactionItem>;
  /**
   * Lookup a translatable item by ID.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorTranslation?: Maybe<SaleorTranslatableItem>;
  /**
   * Returns a list of all translatable items of a given kind.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  saleorTranslations?: Maybe<SaleorTranslatableItemConnection>;
  /**
   * Look up a user by ID or email address.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_USERS, MANAGE_ORDERS.
   */
  saleorUser?: Maybe<SaleorUser>;
  /**
   * Look up a voucher by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVoucher?: Maybe<SaleorVoucher>;
  /**
   * List of the shop's vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  saleorVouchers?: Maybe<SaleorVoucherCountableConnection>;
  /**
   * Look up a warehouse by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  saleorWarehouse?: Maybe<SaleorWarehouse>;
  /**
   * List of warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  saleorWarehouses?: Maybe<SaleorWarehouseCountableConnection>;
  /** Look up a webhook by ID. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  saleorWebhook?: Maybe<SaleorWebhook>;
  /**
   * List of all available webhook events.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   * @deprecated This field will be removed in Saleor 4.0. Use `WebhookEventTypeAsyncEnum` and `WebhookEventTypeSyncEnum` to get available event types.
   */
  saleorWebhookEvents?: Maybe<Array<SaleorWebhookEvent>>;
  /** Retrieve a sample payload for a given webhook event based on real data. It can be useful for some integrations where sample payload is required. */
  saleorWebhookSamplePayload?: Maybe<Scalars['SaleorJSONString']['output']>;
  saleor_entities?: Maybe<Array<Maybe<Saleor_Entity>>>;
  saleor_service?: Maybe<Saleor_Service>;
  strapiArticle?: Maybe<StrapiArticleEntityResponse>;
  strapiArticleSymptom?: Maybe<StrapiArticleSymptomEntityResponse>;
  strapiArticleSymptoms?: Maybe<StrapiArticleSymptomEntityResponseCollection>;
  strapiArticleTag?: Maybe<StrapiArticleTagEntityResponse>;
  strapiArticleTags?: Maybe<StrapiArticleTagEntityResponseCollection>;
  strapiArticles?: Maybe<StrapiArticleEntityResponseCollection>;
  strapiClinicsCities?: Maybe<StrapiClinicsCityEntityResponseCollection>;
  strapiClinicsCity?: Maybe<StrapiClinicsCityEntityResponse>;
  strapiClinicsStreet?: Maybe<StrapiClinicsStreetEntityResponse>;
  strapiClinicsStreets?: Maybe<StrapiClinicsStreetEntityResponseCollection>;
  strapiCompanyOpinion?: Maybe<StrapiCompanyOpinionEntityResponse>;
  strapiCompanyOpinions?: Maybe<StrapiCompanyOpinionEntityResponseCollection>;
  strapiDisease?: Maybe<StrapiDiseaseEntityResponse>;
  strapiDiseases?: Maybe<StrapiDiseaseEntityResponseCollection>;
  strapiDoctor?: Maybe<StrapiDoctorEntityResponse>;
  strapiDoctorGroup?: Maybe<StrapiDoctorGroupEntityResponse>;
  strapiDoctorGroups?: Maybe<StrapiDoctorGroupEntityResponseCollection>;
  strapiDoctorType?: Maybe<StrapiDoctorTypeEntityResponse>;
  strapiDoctorTypes?: Maybe<StrapiDoctorTypeEntityResponseCollection>;
  strapiDoctors?: Maybe<StrapiDoctorEntityResponseCollection>;
  strapiEcommercePartnership?: Maybe<StrapiEcommercePartnershipEntityResponse>;
  strapiEcommercePartnerships?: Maybe<StrapiEcommercePartnershipEntityResponseCollection>;
  strapiEcommercePromoBar?: Maybe<StrapiEcommercePromoBarEntityResponse>;
  strapiEcommercePromoModal?: Maybe<StrapiEcommercePromoModalEntityResponse>;
  strapiEcommercePromoSection?: Maybe<StrapiEcommercePromoSectionEntityResponse>;
  strapiEcommerceSectionTile?: Maybe<StrapiEcommerceSectionTileEntityResponse>;
  strapiFaqItemsSet?: Maybe<StrapiFaqItemsSetEntityResponse>;
  strapiFaqItemsSets?: Maybe<StrapiFaqItemsSetEntityResponseCollection>;
  strapiFaqPagesNew?: Maybe<StrapiFaqPagesNewEntityResponse>;
  strapiFaqPagesNews?: Maybe<StrapiFaqPagesNewEntityResponseCollection>;
  strapiFaqPost?: Maybe<StrapiFaqPostEntityResponse>;
  strapiFaqPosts?: Maybe<StrapiFaqPostEntityResponseCollection>;
  strapiHint?: Maybe<StrapiHintEntityResponse>;
  strapiHints?: Maybe<StrapiHintEntityResponseCollection>;
  strapiI18NLocale?: Maybe<StrapiI18NLocaleEntityResponse>;
  strapiI18NLocales?: Maybe<StrapiI18NLocaleEntityResponseCollection>;
  strapiInfluencer?: Maybe<StrapiInfluencerEntityResponse>;
  strapiInfluencers?: Maybe<StrapiInfluencerEntityResponseCollection>;
  strapiKarieraMed?: Maybe<StrapiKarieraMedEntityResponse>;
  strapiLanding?: Maybe<StrapiLandingEntityResponse>;
  strapiLandings?: Maybe<StrapiLandingEntityResponseCollection>;
  strapiMe?: Maybe<StrapiUsersPermissionsMe>;
  strapiMobileArticle?: Maybe<StrapiMobileArticleEntityResponse>;
  strapiMobileArticles?: Maybe<StrapiMobileArticleEntityResponseCollection>;
  strapiPacket?: Maybe<StrapiPacketEntityResponse>;
  strapiPackets?: Maybe<StrapiPacketEntityResponseCollection>;
  strapiPatientReview?: Maybe<StrapiPatientReviewEntityResponse>;
  strapiPatientReviews?: Maybe<StrapiPatientReviewEntityResponseCollection>;
  strapiPomocDlaUchodzcow?: Maybe<StrapiPomocDlaUchodzcowEntityResponse>;
  strapiPost?: Maybe<StrapiPostEntityResponse>;
  strapiPostTag?: Maybe<StrapiPostTagEntityResponse>;
  strapiPostTags?: Maybe<StrapiPostTagEntityResponseCollection>;
  strapiPosts?: Maybe<StrapiPostEntityResponseCollection>;
  strapiPrzychodniaGhost?: Maybe<StrapiPrzychodniaGhostEntityResponse>;
  strapiPrzychodniaLive?: Maybe<StrapiPrzychodniaLiveEntityResponse>;
  strapiPrzychodniaStreet?: Maybe<StrapiPrzychodniaStreetEntityResponse>;
  strapiPrzychodnie?: Maybe<StrapiPrzychodnieEntityResponse>;
  strapiRegistrationDataStep?: Maybe<StrapiRegistrationDataStepEntityResponse>;
  strapiRegistrationDataSteps?: Maybe<StrapiRegistrationDataStepEntityResponseCollection>;
  strapiRegistrationStep?: Maybe<StrapiRegistrationStepEntityResponse>;
  strapiRegistrationSteps?: Maybe<StrapiRegistrationStepEntityResponseCollection>;
  strapiRegistrationStepsType?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  strapiRegistrationStepsTypes?: Maybe<StrapiRegistrationStepsTypeEntityResponseCollection>;
  strapiRejestracja?: Maybe<StrapiRejestracjaEntityResponse>;
  strapiServiceItem?: Maybe<StrapiServiceItemEntityResponse>;
  strapiServiceItems?: Maybe<StrapiServiceItemEntityResponseCollection>;
  strapiServiceItemsSet?: Maybe<StrapiServiceItemsSetEntityResponse>;
  strapiServiceItemsSets?: Maybe<StrapiServiceItemsSetEntityResponseCollection>;
  strapiServicePage?: Maybe<StrapiServicePageEntityResponse>;
  strapiServicePages?: Maybe<StrapiServicePageEntityResponseCollection>;
  strapiStatute?: Maybe<StrapiStatuteEntityResponse>;
  strapiStatuteClinic?: Maybe<StrapiStatuteClinicEntityResponse>;
  strapiStatuteClinics?: Maybe<StrapiStatuteClinicEntityResponseCollection>;
  strapiStatutes?: Maybe<StrapiStatuteEntityResponseCollection>;
  strapiStepsLayoutContent?: Maybe<StrapiStepsLayoutContentEntityResponse>;
  strapiStepsLayoutContents?: Maybe<StrapiStepsLayoutContentEntityResponseCollection>;
  strapiSzczepienia?: Maybe<StrapiSzczepieniaEntityResponse>;
  strapiTranslationPacket?: Maybe<StrapiTranslationPacketEntityResponse>;
  strapiTranslationPackets?: Maybe<StrapiTranslationPacketEntityResponseCollection>;
  strapiUploadFile?: Maybe<StrapiUploadFileEntityResponse>;
  strapiUploadFiles?: Maybe<StrapiUploadFileEntityResponseCollection>;
  strapiUploadFolder?: Maybe<StrapiUploadFolderEntityResponse>;
  strapiUploadFolders?: Maybe<StrapiUploadFolderEntityResponseCollection>;
  strapiUsersPermissionsRole?: Maybe<StrapiUsersPermissionsRoleEntityResponse>;
  strapiUsersPermissionsRoles?: Maybe<StrapiUsersPermissionsRoleEntityResponseCollection>;
  strapiUsersPermissionsUser?: Maybe<StrapiUsersPermissionsUserEntityResponse>;
  strapiUsersPermissionsUsers?: Maybe<StrapiUsersPermissionsUserEntityResponseCollection>;
  strapiVaccinationType?: Maybe<StrapiVaccinationTypeEntityResponse>;
  strapiVaccinationTypes?: Maybe<StrapiVaccinationTypeEntityResponseCollection>;
  strapiZespolMedyczny?: Maybe<StrapiZespolMedycznyEntityResponse>;
  zusGetPayerData: ZusGetPayerDataResponse;
};


export type QuerydoctorAdditionalMedicalServicesArgs = {
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorArchivedVisitListArgs = {
  filters?: InputMaybe<DoctorMSVisitFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerydoctorAuthorizeDoctorArgs = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerydoctorAuthorizeMFAArgs = {
  mfaCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerydoctorCalendarArgs = {
  id: Scalars['String']['input'];
};


export type QuerydoctorChatMessagesArgs = {
  createdAtGt?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  patientId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerydoctorCheckCEZArgs = {
  visitId: Scalars['String']['input'];
};


export type QuerydoctorCheckPatientExistsArgs = {
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorDiagArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  type: DoctorMSAssignmentType;
};


export type QuerydoctorDoctorArgs = {
  id: Scalars['String']['input'];
};


export type QuerydoctorDoctorGeneratePdfArgs = {
  representativeId?: InputMaybe<Scalars['String']['input']>;
  request: Array<DoctorMSNfzDeclarationInputPatientMultiple>;
};


export type QuerydoctorDoctorsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  showBlocked?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerydoctorDraftVisitsArgs = {
  patientId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerydoctorFindAddressArgs = {
  query: Scalars['String']['input'];
  voivodeship?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorFindAddressMultistringArgs = {
  city: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetPrefix?: InputMaybe<DoctorMSStreetPrefix>;
  voivodeship: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorGetDoctorsVisitsArgs = {
  doctorId: Scalars['String']['input'];
  plannedStartGte: Scalars['DoctorMSDateTime']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  visitType: DoctorMSVisitType;
};


export type QuerydoctorGetDoctorsWithAvailableSlotsArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  type: DoctorMSSlotType;
};


export type QuerydoctorGetDrugDetailsArgs = {
  ean: Scalars['String']['input'];
};


export type QuerydoctorGetIpomArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetIpomCodesArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorGetIpomSpecialistsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetMessagesForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetP1PrescriptionsArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorGetPatientDocsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetPatientDocs2Args = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetPrescriptionsForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetReferralsForPatientArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorGetSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredLanguages?: InputMaybe<Array<DoctorMSSupportedLanguage>>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
  type: DoctorMSSlotType;
};


export type QuerydoctorGetSlotsRecipeArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  organizationIdForced?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorGetSpecialistSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  requiredLanguages?: InputMaybe<Array<DoctorMSSupportedLanguage>>;
  serviceId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerydoctorGetTemplatesForVisitArgs = {
  visitId: Scalars['String']['input'];
};


export type QuerydoctorGetVisitsPerDayForDoctorArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  forDay: Scalars['DoctorMSDateTime']['input'];
};


export type QuerydoctorGetZusMedicalLeavesArgs = {
  input: DoctorMSGetMedicalLeavesInput;
};


export type QuerydoctorGetZusPayersArgs = {
  input: DoctorMSGetZusPayersInput;
};


export type QuerydoctorGetZusPayersByNIPArgs = {
  input: DoctorMSGetZusPayersByNIPInput;
};


export type QuerydoctorGroupByChatMessageArgs = {
  authorId: Scalars['String']['input'];
  forDay: Scalars['DoctorMSDateTime']['input'];
};


export type QuerydoctorHistoryVisitsArgs = {
  patientId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerydoctorICD9Args = {
  search: Scalars['String']['input'];
};


export type QuerydoctorICD10Args = {
  search: Scalars['String']['input'];
};


export type QuerydoctorLaboratoryExaminationDiagsWithPacketsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QuerydoctorLaboratoryExaminationReportArgs = {
  end: Scalars['String']['input'];
  organizationCode: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QuerydoctorLaboratoryExaminationsArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorLeavesArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorManyProceduresRenderArgs = {
  procedureIds: Array<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorMedicineSubtitlesArgs = {
  type: DoctorMSPatientTagType;
};


export type QuerydoctorNfzEventsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorNfzHistoryArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorOrganizationsArgs = {
  showPolmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerydoctorPackagesArgs = {
  name: Scalars['String']['input'];
};


export type QuerydoctorPatientArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorPatientDeclarationHistoryArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorPatientInsuranceStatusArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorPatientsArgs = {
  fullText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
};


export type QuerydoctorPopularLaboratoryExaminationPacketsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerydoctorPrescriptionsCEZArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorPrescriptionsCEZStagArgs = {
  patientId?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorProcedureRenderArgs = {
  procedureId?: InputMaybe<Scalars['String']['input']>;
  type: DoctorMSProcedureType;
  visitId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorProceduresArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorRegularDrugsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorReportGenerateArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QuerydoctorReportsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorScheduledVisitsArgs = {
  doctorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  forDay: Scalars['DoctorMSDateTime']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorSearchIPOMsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorSendMfaSmsCodeArgs = {
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerydoctorShiftTypesArgs = {
  shiftGenre?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorShiftsArgs = {
  from: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QuerydoctorSnippetsArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QuerydoctorSwiadGenerateArgs = {
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


export type QuerydoctorTodayComboTestArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorTodosArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerydoctorUpcomingVisitsArgs = {
  patientId: Scalars['String']['input'];
};


export type QuerydoctorValidateReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type QuerydoctorVisitArgs = {
  id: Scalars['String']['input'];
};


export type QuerydoctorVisitsForPatientsArgs = {
  forDay: Scalars['DoctorMSDateTime']['input'];
  patientIds: Array<Scalars['String']['input']>;
};


export type QueryedmAskArgs = {
  input: EdmAiChatInput;
};


export type QueryedmCalculatePercentileArgs = {
  input: EdmCalculationInput;
};


export type QueryedmGetAiChatMessagesArgs = {
  input: EdmAiChatMessagesInput;
};


export type QueryedmGetAllDoctorsFromShiftsWithPreviousMonthResolverArgs = {
  input: EdmGetAllDoctorsFromShiftsInput;
};


export type QueryedmGetAllNonWorkingPeriodsArgs = {
  input: EdmGetAllNonWorkingPeriodsInput;
};


export type QueryedmGetAllShiftsArgs = {
  input: EdmGetAllShiftsInput;
};


export type QueryedmGetAllSnippetsArgs = {
  filters?: InputMaybe<EdmGetAllSnippetsFilter>;
};


export type QueryedmGetAllStaffWithGenreAndWorkingHoursArgs = {
  input: EdmGetAllStaffWithGenreAndWorkingHoursInput;
};


export type QueryedmGetAllVisitsForDeletedShiftsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryedmGetHistoricalVisitsArgs = {
  cursor?: InputMaybe<EdmCursorInput>;
};


export type QueryedmGetPatientMeasurementsArgs = {
  patientId: Scalars['String']['input'];
};


export type QueryedmGetPrescriptionsArgs = {
  cursor?: InputMaybe<EdmCursorInput>;
};


export type QueryedmGetReferralsArgs = {
  cursor?: InputMaybe<EdmCursorInput>;
};


export type QueryedmGetSickLeavesArgs = {
  cursor?: InputMaybe<EdmCursorInput>;
};


export type QueryedmGetStaffVisitDurationArgs = {
  staffId: Scalars['String']['input'];
};


export type QueryedmGetVisitDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryedmGetVisitTypesByGenreArgs = {
  input: EdmGetVisitTypesByGenreInput;
};


export type QueryedmGetVitalsArgs = {
  cursor?: InputMaybe<EdmCursorInput>;
};


export type QueryedmGetVitalsByVisitIdArgs = {
  visitId: Scalars['String']['input'];
};


export type QueryedmSearchAvailabilityArgs = {
  input: EdmShiftSearchAvailabilityInput;
};


export type QueryedmSearchAvailabilityForDayArgs = {
  input: EdmShiftSearchAvailabilityForDayInput;
};


export type QuerypatientAgendoCheckDeclarationArgs = {
  fileId: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['String']['input']>;
  subTypeAnalytics?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientAgendoCheckDeclarationMultipleArgs = {
  fileId: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['String']['input']>;
  subTypeAnalytics?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientAgendoSignDeclarationArgs = {
  errorUrl: Scalars['String']['input'];
  request: PatientMSNfzDeclarationInputPatient;
  successUrl: Scalars['String']['input'];
};


export type QuerypatientAgendoSignDeclarationMultipleArgs = {
  errorUrl: Scalars['String']['input'];
  requests: Array<PatientMSNfzDeclarationInputPatientMultiple>;
  successUrl: Scalars['String']['input'];
};


export type QuerypatientAssignmentIdsToSaleorProductIdsArgs = {
  assignmentIds: Array<Scalars['String']['input']>;
};


export type QuerypatientAuthorizePatientArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientAuthorizePatientWithRefreshTokenArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientAuthorizeUpdateAddressPatientArgs = {
  address: PatientMSPlacematicAddressInput;
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  input: PatientMSUserInput;
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientAvailableFirstRegistrationCalendarSlotsArgs = {
  physicalOrganizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientChatMessagesArgs = {
  before: Scalars['String']['input'];
};


export type QuerypatientCheckIfUserExistsArgs = {
  phone: Scalars['String']['input'];
};


export type QuerypatientCheckSmsCodeArgs = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type QuerypatientCheckUserExistsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};


export type QuerypatientClosestFacilitiesArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  onlyFromDeclarationVoivodeship?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerypatientDeclarableArgs = {
  organizationId: Scalars['String']['input'];
  patientKind?: InputMaybe<PatientMSPatientKind>;
  type?: InputMaybe<PatientMSDeclarableType>;
};


export type QuerypatientDoctorLanguagesArgs = {
  doctorId: Scalars['String']['input'];
};


export type QuerypatientEcommerceOrdersToScheduleArgs = {
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerypatientFindAddressArgs = {
  query: Scalars['String']['input'];
  voivodeship?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientFindAddressMultistringArgs = {
  city: Scalars['String']['input'];
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetPrefix?: InputMaybe<PatientMSStreetPrefix>;
  voivodeship: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientFreeSurveyArgs = {
  formId: Scalars['String']['input'];
};


export type QuerypatientGetFAQsForServicesArgs = {
  serviceIds: Array<Scalars['String']['input']>;
};


export type QuerypatientGetSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredLanguages?: InputMaybe<Array<PatientMSSupportedLanguage>>;
  slotsInRow?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
  type: PatientMSSlotType;
};


export type QuerypatientGetSlotsRecipeArgs = {
  end?: InputMaybe<Scalars['Float']['input']>;
  organizationIdForced?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientGetSpecialistSlotsArgs = {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  requiredLanguages?: InputMaybe<Array<PatientMSSupportedLanguage>>;
  serviceId: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerypatientLaboratoryExaminationsToScheduleArgs = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientMobileSaleorOrderArgs = {
  laboratoryExaminationIds: Array<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientOrganizationsArgs = {
  showPolmed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerypatientRegistrationSlotsArgs = {
  date: Scalars['PatientMSDateTime']['input'];
  physicalOrganizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientSaveFutureUsersDataArgs = {
  data: Scalars['String']['input'];
};


export type QuerypatientSendSmsCodeArgs = {
  pesel?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  platform: PatientMSMobilePlatform;
};


export type QuerypatientSlotsRecommendationsArgs = {
  input: Array<PatientMSSlotsRecInput>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientSlotsRecommendations2Args = {
  input: Array<PatientMSSlotsRecInput>;
  triageData?: InputMaybe<Scalars['String']['input']>;
};


export type QuerypatientSlotsReservationsArgs = {
  reservationIds: Array<Scalars['String']['input']>;
};


export type QuerypatientValidatePatientPolicyArgs = {
  policy: Scalars['String']['input'];
};


export type QuerypatientValidateReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};


export type QuerypatientVerifyIdFilesArgs = {
  backImageId: Scalars['String']['input'];
  frontImageId: Scalars['String']['input'];
};


export type QuerysaleorAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorAddressValidationRulesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityArea?: InputMaybe<Scalars['String']['input']>;
  countryArea?: InputMaybe<Scalars['String']['input']>;
  countryCode: SaleorCountryCode;
};


export type QuerysaleorAppArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysaleorAppExtensionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorAppExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAppExtensionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAppFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorAppSortingInput>;
};


export type QuerysaleorAttributeArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorAttributeSortingInput>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


export type QuerysaleorCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCategorySortingInput>;
};


export type QuerysaleorCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorCheckoutArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['SaleorUUID']['input']>;
};


export type QuerysaleorCheckoutLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCheckoutFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCheckoutSortingInput>;
};


export type QuerysaleorCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCollectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorCollectionSortingInput>;
};


export type QuerysaleorCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorCustomerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorUserSortingInput>;
};


export type QuerysaleorDigitalContentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorDigitalContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorOrderDraftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorOrderSortingInput>;
};


export type QuerysaleorExportFileArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorExportFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorExportFileFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorExportFileSortingInput>;
};


export type QuerysaleorGiftCardArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorGiftCardTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorGiftCardTagFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorGiftCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorGiftCardSortingInput>;
};


export type QuerysaleorHomepageEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerysaleorMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorMenuItemFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorMenuItemSortingInput>;
};


export type QuerysaleorMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorMenuFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorMenuSortingInput>;
};


export type QuerysaleorOrderArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysaleorOrderByTokenArgs = {
  token: Scalars['SaleorUUID']['input'];
};


export type QuerysaleorOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorOrderSortingInput>;
};


export type QuerysaleorOrdersTotalArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<SaleorReportingPeriod>;
};


export type QuerysaleorPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorPageTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorPageTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPageTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPageTypeSortingInput>;
};


export type QuerysaleorPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPageSortingInput>;
};


export type QuerysaleorPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPaymentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorPermissionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPermissionGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPermissionGroupSortingInput>;
};


export type QuerysaleorPluginArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorPluginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorPluginFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorPluginSortingInput>;
};


export type QuerysaleorProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductTypeSortingInput>;
};


export type QuerysaleorProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type QuerysaleorProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductVariantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductVariantSortingInput>;
};


export type QuerysaleorProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
};


export type QuerysaleorReportProductSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  period: SaleorReportingPeriod;
};


export type QuerysaleorSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerysaleorSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorSaleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorSaleSortingInput>;
};


export type QuerysaleorShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerysaleorShippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorShippingZoneFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorStaffUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorStaffUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorUserSortingInput>;
};


export type QuerysaleorStockArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorStockFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorTaxClassArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorTaxClassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorTaxClassFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorTaxClassSortingInput>;
};


export type QuerysaleorTaxConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorTaxConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorTaxConfigurationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorTaxCountryConfigurationArgs = {
  countryCode: SaleorCountryCode;
};


export type QuerysaleorTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorTranslationArgs = {
  id: Scalars['ID']['input'];
  kind: SaleorTranslatableKinds;
};


export type QuerysaleorTranslationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind: SaleorTranslatableKinds;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerysaleorUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysaleorVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerysaleorVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorVoucherFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleorVoucherSortingInput>;
};


export type QuerysaleorWarehouseArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerysaleorWarehousesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorWarehouseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorWarehouseSortingInput>;
};


export type QuerysaleorWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QuerysaleorWebhookSamplePayloadArgs = {
  eventType: SaleorWebhookSampleEventTypeEnum;
};


export type Querysaleor_entitiesArgs = {
  representations?: InputMaybe<Array<InputMaybe<Scalars['Saleor_Any']['input']>>>;
};


export type QuerystrapiArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiArticleSymptomArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiArticleSymptomsArgs = {
  filters?: InputMaybe<StrapiArticleSymptomFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiArticleTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiArticleTagsArgs = {
  filters?: InputMaybe<StrapiArticleTagFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiArticlesArgs = {
  filters?: InputMaybe<StrapiArticleFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiClinicsCitiesArgs = {
  filters?: InputMaybe<StrapiClinicsCityFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiClinicsCityArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiClinicsStreetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiClinicsStreetsArgs = {
  filters?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiCompanyOpinionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiCompanyOpinionsArgs = {
  filters?: InputMaybe<StrapiCompanyOpinionFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiDiseaseArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiDiseasesArgs = {
  filters?: InputMaybe<StrapiDiseaseFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiDoctorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiDoctorGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiDoctorGroupsArgs = {
  filters?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiDoctorTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiDoctorTypesArgs = {
  filters?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiDoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiEcommercePartnershipArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiEcommercePartnershipsArgs = {
  filters?: InputMaybe<StrapiEcommercePartnershipFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiEcommercePromoBarArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiEcommercePromoModalArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiEcommercePromoSectionArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiEcommerceSectionTileArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiFaqItemsSetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiFaqItemsSetsArgs = {
  filters?: InputMaybe<StrapiFaqItemsSetFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiFaqPagesNewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiFaqPagesNewsArgs = {
  filters?: InputMaybe<StrapiFaqPagesNewFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiFaqPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiFaqPostsArgs = {
  filters?: InputMaybe<StrapiFaqPostFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiHintArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiHintsArgs = {
  filters?: InputMaybe<StrapiHintFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiI18NLocalesArgs = {
  filters?: InputMaybe<StrapiI18NLocaleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiInfluencerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiInfluencersArgs = {
  filters?: InputMaybe<StrapiInfluencerFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiKarieraMedArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiLandingArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiLandingsArgs = {
  filters?: InputMaybe<StrapiLandingFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiMobileArticleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiMobileArticlesArgs = {
  filters?: InputMaybe<StrapiMobileArticleFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiPacketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiPacketsArgs = {
  filters?: InputMaybe<StrapiPacketFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiPatientReviewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiPatientReviewsArgs = {
  filters?: InputMaybe<StrapiPatientReviewFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiPomocDlaUchodzcowArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiPostTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiPostTagsArgs = {
  filters?: InputMaybe<StrapiPostTagFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiPostsArgs = {
  filters?: InputMaybe<StrapiPostFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiPrzychodniaGhostArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiPrzychodniaLiveArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiPrzychodniaStreetArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiPrzychodnieArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiRegistrationDataStepArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiRegistrationDataStepsArgs = {
  filters?: InputMaybe<StrapiRegistrationDataStepFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiRegistrationStepArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiRegistrationStepsArgs = {
  filters?: InputMaybe<StrapiRegistrationStepFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiRegistrationStepsTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiRegistrationStepsTypesArgs = {
  filters?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiRejestracjaArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiServiceItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiServiceItemsArgs = {
  filters?: InputMaybe<StrapiServiceItemFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiServiceItemsSetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiServiceItemsSetsArgs = {
  filters?: InputMaybe<StrapiServiceItemsSetFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiServicePageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiServicePagesArgs = {
  filters?: InputMaybe<StrapiServicePageFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiStatuteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiStatuteClinicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiStatuteClinicsArgs = {
  filters?: InputMaybe<StrapiStatuteClinicFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiStatutesArgs = {
  filters?: InputMaybe<StrapiStatuteFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiStepsLayoutContentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiStepsLayoutContentsArgs = {
  filters?: InputMaybe<StrapiStepsLayoutContentFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiSzczepieniaArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QuerystrapiTranslationPacketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiTranslationPacketsArgs = {
  filters?: InputMaybe<StrapiTranslationPacketFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiUploadFilesArgs = {
  filters?: InputMaybe<StrapiUploadFileFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiUploadFoldersArgs = {
  filters?: InputMaybe<StrapiUploadFolderFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiUsersPermissionsRolesArgs = {
  filters?: InputMaybe<StrapiUsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerystrapiUsersPermissionsUsersArgs = {
  filters?: InputMaybe<StrapiUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiVaccinationTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
};


export type QuerystrapiVaccinationTypesArgs = {
  filters?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerystrapiZespolMedycznyArgs = {
  locale?: InputMaybe<Scalars['StrapiI18NLocaleCode']['input']>;
  publicationState?: InputMaybe<StrapiPublicationState>;
};


export type QueryzusGetPayerDataArgs = {
  nip: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
};

/**
 * Create a new address for the customer.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorAccountAddressCreate = {
  __typename?: 'SaleorAccountAddressCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was created. */
  user?: Maybe<SaleorUser>;
};

/** Delete an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER. */
export type SaleorAccountAddressDelete = {
  __typename?: 'SaleorAccountAddressDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was deleted. */
  user?: Maybe<SaleorUser>;
};

/** Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER. */
export type SaleorAccountAddressUpdate = {
  __typename?: 'SaleorAccountAddressUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user object for which the address was edited. */
  user?: Maybe<SaleorUser>;
};

/**
 * Remove user account.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorAccountDelete = {
  __typename?: 'SaleorAccountDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user?: Maybe<SaleorUser>;
};

/** Represents errors in account mutations. */
export type SaleorAccountError = {
  __typename?: 'SaleorAccountError';
  /** A type of address that causes the error. */
  addressType?: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorAccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorAccountErrorCode =
  | 'ACCOUNT_NOT_CONFIRMED'
  | 'ACTIVATE_OWN_ACCOUNT'
  | 'ACTIVATE_SUPERUSER_ACCOUNT'
  | 'CHANNEL_INACTIVE'
  | 'DEACTIVATE_OWN_ACCOUNT'
  | 'DEACTIVATE_SUPERUSER_ACCOUNT'
  | 'DELETE_NON_STAFF_USER'
  | 'DELETE_OWN_ACCOUNT'
  | 'DELETE_STAFF_ACCOUNT'
  | 'DELETE_SUPERUSER_ACCOUNT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE'
  | 'INVALID'
  | 'INVALID_CREDENTIALS'
  | 'INVALID_PASSWORD'
  | 'JWT_DECODE_ERROR'
  | 'JWT_INVALID_CSRF_TOKEN'
  | 'JWT_INVALID_TOKEN'
  | 'JWT_MISSING_TOKEN'
  | 'JWT_SIGNATURE_EXPIRED'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'MISSING_CHANNEL_SLUG'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_GROUP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'PASSWORD_ENTIRELY_NUMERIC'
  | 'PASSWORD_RESET_ALREADY_REQUESTED'
  | 'PASSWORD_TOO_COMMON'
  | 'PASSWORD_TOO_SHORT'
  | 'PASSWORD_TOO_SIMILAR'
  | 'REQUIRED'
  | 'UNIQUE';

/** Fields required to update the user. */
export type SaleorAccountInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Register a new user. */
export type SaleorAccountRegister = {
  __typename?: 'SaleorAccountRegister';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Informs whether users need to confirm their email address. */
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<SaleorUser>;
};

/** Fields required to create a user. */
export type SaleorAccountRegisterInput = {
  /** Slug of a channel which will be used to notify users. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User public metadata. */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Password. */
  password: Scalars['String']['input'];
  /** Base of frontend URL that will be needed to create confirmation URL. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sends an email with the account removal link for the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorAccountRequestDeletion = {
  __typename?: 'SaleorAccountRequestDeletion';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

/**
 * Sets a default address for the authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorAccountSetDefaultAddress = {
  __typename?: 'SaleorAccountSetDefaultAddress';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user?: Maybe<SaleorUser>;
};

/**
 * Updates the account of the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorAccountUpdate = {
  __typename?: 'SaleorAccountUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user?: Maybe<SaleorUser>;
};

/** Represents user address data. */
export type SaleorAddress = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorAddress';
  city: Scalars['String']['output'];
  cityArea: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  /** Shop's default country. */
  country: SaleorCountryDisplay;
  countryArea: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Address is user's default billing address. */
  isDefaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Address is user's default shipping address. */
  isDefaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  /**
   * List of public metadata items. Can be accessed without permissions.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  /**
   * List of private metadata items. Requires staff permissions to access.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.10.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  streetAddress1: Scalars['String']['output'];
  streetAddress2: Scalars['String']['output'];
};


/** Represents user address data. */
export type SaleorAddressmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type SaleorAddressmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user address data. */
export type SaleorAddressprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type SaleorAddressprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates user address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorAddressCreate = {
  __typename?: 'SaleorAddressCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was created. */
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when new address is created.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAddressCreated = SaleorEvent & {
  __typename?: 'SaleorAddressCreated';
  /** The address the event relates to. */
  address?: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorAddressDelete = {
  __typename?: 'SaleorAddressDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user instance for which the address was deleted. */
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when address is deleted.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAddressDeleted = SaleorEvent & {
  __typename?: 'SaleorAddressDeleted';
  /** The address the event relates to. */
  address?: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** District. */
  cityArea?: InputMaybe<Scalars['String']['input']>;
  /** Company or organization. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<SaleorCountryCode>;
  /** State or province. */
  countryArea?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sets a default address for the given user.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorAddressSetDefault = {
  __typename?: 'SaleorAddressSetDefault';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user?: Maybe<SaleorUser>;
};

/** An enumeration. */
export type SaleorAddressTypeEnum =
  | 'BILLING'
  | 'SHIPPING';

/**
 * Updates an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorAddressUpdate = {
  __typename?: 'SaleorAddressUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  address?: Maybe<SaleorAddress>;
  errors: Array<SaleorAccountError>;
  /** A user object for which the address was edited. */
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when address is updated.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAddressUpdated = SaleorEvent & {
  __typename?: 'SaleorAddressUpdated';
  /** The address the event relates to. */
  address?: Maybe<SaleorAddress>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents address validation rules for a country. */
export type SaleorAddressValidationData = {
  __typename?: 'SaleorAddressValidationData';
  addressFormat: Scalars['String']['output'];
  addressLatinFormat: Scalars['String']['output'];
  allowedFields: Array<Scalars['String']['output']>;
  cityAreaChoices: Array<SaleorChoiceValue>;
  cityAreaType: Scalars['String']['output'];
  cityChoices: Array<SaleorChoiceValue>;
  cityType: Scalars['String']['output'];
  countryAreaChoices: Array<SaleorChoiceValue>;
  countryAreaType: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  postalCodeExamples: Array<Scalars['String']['output']>;
  postalCodeMatchers: Array<Scalars['String']['output']>;
  postalCodePrefix: Scalars['String']['output'];
  postalCodeType: Scalars['String']['output'];
  requiredFields: Array<Scalars['String']['output']>;
  upperFields: Array<Scalars['String']['output']>;
};

/** Represents allocation. */
export type SaleorAllocation = SaleorNode & {
  __typename?: 'SaleorAllocation';
  id: Scalars['ID']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The warehouse were items were allocated.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  warehouse: SaleorWarehouse;
};

/**
 * Determine the allocation strategy for the channel.
 *
 *     PRIORITIZE_SORTING_ORDER - allocate stocks according to the warehouses' order
 *     within the channel
 *
 *     PRIORITIZE_HIGH_STOCK - allocate stock in a warehouse with the most stock
 *
 */
export type SaleorAllocationStrategyEnum =
  | 'PRIORITIZE_HIGH_STOCK'
  | 'PRIORITIZE_SORTING_ORDER';

/** Represents app data. */
export type SaleorApp = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorApp';
  /** Description of this app. */
  aboutApp?: Maybe<Scalars['String']['output']>;
  /** JWT token used to authenticate by thridparty app. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** URL to iframe with the app. */
  appUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The App's author name.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  author?: Maybe<Scalars['String']['output']>;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated This field will be removed in Saleor 4.0. Use `appUrl` instead.
   */
  configurationUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time when the app was created. */
  created?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated This field will be removed in Saleor 4.0. Use `dataPrivacyUrl` instead.
   */
  dataPrivacy?: Maybe<Scalars['String']['output']>;
  /** URL to details about the privacy policy on the app owner page. */
  dataPrivacyUrl?: Maybe<Scalars['String']['output']>;
  /**
   * App's dashboard extensions.
   *
   * Added in Saleor 3.1.
   */
  extensions: Array<SaleorAppExtension>;
  /** Homepage of the app. */
  homepageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Determine if app will be set active or not. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * URL to manifest used during app's installation.
   *
   * Added in Saleor 3.5.
   */
  manifestUrl?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Name of the app. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of the app's permissions. */
  permissions?: Maybe<Array<SaleorPermission>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Support page for the app. */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Last 4 characters of the tokens.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  tokens?: Maybe<Array<SaleorAppToken>>;
  /** Type of the app. */
  type?: Maybe<SaleorAppTypeEnum>;
  /** Version number of the app. */
  version?: Maybe<Scalars['String']['output']>;
  /**
   * List of webhooks assigned to this app.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  webhooks?: Maybe<Array<SaleorWebhook>>;
};


/** Represents app data. */
export type SaleorAppmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type SaleorAppmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents app data. */
export type SaleorAppprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type SaleorAppprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppActivate = {
  __typename?: 'SaleorAppActivate';
  app?: Maybe<SaleorApp>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppCountableConnection = {
  __typename?: 'SaleorAppCountableConnection';
  edges: Array<SaleorAppCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorAppCountableEdge = {
  __typename?: 'SaleorAppCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorApp;
};

/** Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
export type SaleorAppCreate = {
  __typename?: 'SaleorAppCreate';
  app?: Maybe<SaleorApp>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  /** The newly created authentication token. */
  authToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAppError>;
};

/**
 * Deactivate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppDeactivate = {
  __typename?: 'SaleorAppDeactivate';
  app?: Maybe<SaleorApp>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Deletes an app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppDelete = {
  __typename?: 'SaleorAppDelete';
  app?: Maybe<SaleorApp>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Delete failed installation.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppDeleteFailedInstallation = {
  __typename?: 'SaleorAppDeleteFailedInstallation';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation?: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

/**
 * Event sent when app is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorAppDeleted = SaleorEvent & {
  __typename?: 'SaleorAppDeleted';
  /** The application the event relates to. */
  app?: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorAppError = {
  __typename?: 'SaleorAppError';
  /** The error code. */
  code: SaleorAppErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<SaleorPermissionEnum>>;
};

/** An enumeration. */
export type SaleorAppErrorCode =
  | 'FORBIDDEN'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'INVALID_MANIFEST_FORMAT'
  | 'INVALID_PERMISSION'
  | 'INVALID_STATUS'
  | 'INVALID_URL_FORMAT'
  | 'MANIFEST_URL_CANT_CONNECT'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_APP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_SALEOR_VERSION';

/** Represents app data. */
export type SaleorAppExtension = SaleorNode & {
  __typename?: 'SaleorAppExtension';
  /** JWT token used to authenticate by thridparty app extension. */
  accessToken?: Maybe<Scalars['String']['output']>;
  app: SaleorApp;
  id: Scalars['ID']['output'];
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /** Place where given extension will be mounted. */
  mount: SaleorAppExtensionMountEnum;
  /** List of the app extension's permissions. */
  permissions: Array<SaleorPermission>;
  /** Type of way how app extension will be opened. */
  target: SaleorAppExtensionTargetEnum;
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type SaleorAppExtensionCountableConnection = {
  __typename?: 'SaleorAppExtensionCountableConnection';
  edges: Array<SaleorAppExtensionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorAppExtensionCountableEdge = {
  __typename?: 'SaleorAppExtensionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAppExtension;
};

export type SaleorAppExtensionFilterInput = {
  mount?: InputMaybe<Array<SaleorAppExtensionMountEnum>>;
  target?: InputMaybe<SaleorAppExtensionTargetEnum>;
};

/** All places where app extension can be mounted. */
export type SaleorAppExtensionMountEnum =
  | 'CUSTOMER_DETAILS_MORE_ACTIONS'
  | 'CUSTOMER_OVERVIEW_CREATE'
  | 'CUSTOMER_OVERVIEW_MORE_ACTIONS'
  | 'NAVIGATION_CATALOG'
  | 'NAVIGATION_CUSTOMERS'
  | 'NAVIGATION_DISCOUNTS'
  | 'NAVIGATION_ORDERS'
  | 'NAVIGATION_PAGES'
  | 'NAVIGATION_TRANSLATIONS'
  | 'ORDER_DETAILS_MORE_ACTIONS'
  | 'ORDER_OVERVIEW_CREATE'
  | 'ORDER_OVERVIEW_MORE_ACTIONS'
  | 'PRODUCT_DETAILS_MORE_ACTIONS'
  | 'PRODUCT_OVERVIEW_CREATE'
  | 'PRODUCT_OVERVIEW_MORE_ACTIONS';

/**
 * All available ways of opening an app extension.
 *
 *     POPUP - app's extension will be mounted as a popup window
 *     APP_PAGE - redirect to app's page
 *
 */
export type SaleorAppExtensionTargetEnum =
  | 'APP_PAGE'
  | 'POPUP';

/**
 * Fetch and validate manifest.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppFetchManifest = {
  __typename?: 'SaleorAppFetchManifest';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
  manifest?: Maybe<SaleorManifest>;
};

export type SaleorAppFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SaleorAppTypeEnum>;
};

export type SaleorAppInput = {
  /** Name of the app. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<SaleorPermissionEnum>>;
};

/** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
export type SaleorAppInstall = {
  __typename?: 'SaleorAppInstall';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation?: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppInstallInput = {
  /** Determine if app will be set active or not. */
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the app to install. */
  appName?: InputMaybe<Scalars['String']['input']>;
  /** Url to app's manifest in JSON format. */
  manifestUrl?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<SaleorPermissionEnum>>;
};

/** Represents ongoing installation of app. */
export type SaleorAppInstallation = SaleorJob & SaleorNode & {
  __typename?: 'SaleorAppInstallation';
  appName: Scalars['String']['output'];
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['SaleorDateTime']['output'];
  id: Scalars['ID']['output'];
  manifestUrl: Scalars['String']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['SaleorDateTime']['output'];
};

/**
 * Event sent when new app is installed.
 *
 * Added in Saleor 3.4.
 */
export type SaleorAppInstalled = SaleorEvent & {
  __typename?: 'SaleorAppInstalled';
  /** The application the event relates to. */
  app?: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorAppManifestExtension = {
  __typename?: 'SaleorAppManifestExtension';
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /** Place where given extension will be mounted. */
  mount: SaleorAppExtensionMountEnum;
  /** List of the app extension's permissions. */
  permissions: Array<SaleorPermission>;
  /** Type of way how app extension will be opened. */
  target: SaleorAppExtensionTargetEnum;
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type SaleorAppManifestRequiredSaleorVersion = {
  __typename?: 'SaleorAppManifestRequiredSaleorVersion';
  /**
   * Required Saleor version as semver range.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  constraint: Scalars['String']['output'];
  /**
   * Informs if the Saleor version matches the required one.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  satisfied: Scalars['Boolean']['output'];
};

export type SaleorAppManifestWebhook = {
  __typename?: 'SaleorAppManifestWebhook';
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: Maybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /** The name of the webhook. */
  name: Scalars['String']['output'];
  /** Subscription query of a webhook */
  query: Scalars['String']['output'];
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: Maybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl: Scalars['String']['output'];
};

/**
 * Retry failed installation of new app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppRetryInstall = {
  __typename?: 'SaleorAppRetryInstall';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appInstallation?: Maybe<SaleorAppInstallation>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppSortField =
  /** Sort apps by creation date. */
  | 'CREATION_DATE'
  /** Sort apps by name. */
  | 'NAME';

export type SaleorAppSortingInput = {
  /** Specifies the direction in which to sort apps. */
  direction: SaleorOrderDirection;
  /** Sort apps by the selected field. */
  field: SaleorAppSortField;
};

/**
 * Event sent when app status has changed.
 *
 * Added in Saleor 3.4.
 */
export type SaleorAppStatusChanged = SaleorEvent & {
  __typename?: 'SaleorAppStatusChanged';
  /** The application the event relates to. */
  app?: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents token data. */
export type SaleorAppToken = SaleorNode & {
  __typename?: 'SaleorAppToken';
  /** Last 4 characters of the token. */
  authToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the authenticated token. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates a new token.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppTokenCreate = {
  __typename?: 'SaleorAppTokenCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appToken?: Maybe<SaleorAppToken>;
  /** The newly created authentication token. */
  authToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAppError>;
};

/**
 * Deletes an authentication token assigned to app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppTokenDelete = {
  __typename?: 'SaleorAppTokenDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  appToken?: Maybe<SaleorAppToken>;
  errors: Array<SaleorAppError>;
};

export type SaleorAppTokenInput = {
  /** ID of app. */
  app: Scalars['ID']['input'];
  /** Name of the token. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Verify provided app token. */
export type SaleorAppTokenVerify = {
  __typename?: 'SaleorAppTokenVerify';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
  /** Determine if token is valid or not. */
  valid: Scalars['Boolean']['output'];
};

/** Enum determining type of your App. */
export type SaleorAppTypeEnum =
  /** Local Saleor App. The app is fully manageable from dashboard. You can change assigned permissions, add webhooks, or authentication token */
  | 'LOCAL'
  /** Third party external App. Installation is fully automated. Saleor uses a defined App manifest to gather all required information. */
  | 'THIRDPARTY';

/**
 * Updates an existing app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorAppUpdate = {
  __typename?: 'SaleorAppUpdate';
  app?: Maybe<SaleorApp>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  appErrors: Array<SaleorAppError>;
  errors: Array<SaleorAppError>;
};

/**
 * Event sent when app is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorAppUpdated = SaleorEvent & {
  __typename?: 'SaleorAppUpdated';
  /** The application the event relates to. */
  app?: Maybe<SaleorApp>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorAreaUnitsEnum =
  | 'SQ_CM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_YD';

/**
 * Assigns storefront's navigation menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
 */
export type SaleorAssignNavigation = {
  __typename?: 'SaleorAssignNavigation';
  errors: Array<SaleorMenuError>;
  /** Assigned navigation menu. */
  menu?: Maybe<SaleorMenu>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/**
 * Represents assigned attribute to variant with variant selection attached.
 *
 * Added in Saleor 3.1.
 */
export type SaleorAssignedVariantAttribute = {
  __typename?: 'SaleorAssignedVariantAttribute';
  /** Attribute assigned to variant. */
  attribute: SaleorAttribute;
  /** Determines, whether assigned attribute is allowed for variant selection. Supported variant types for variant selection are: ['dropdown', 'boolean', 'swatch', 'numeric'] */
  variantSelection: Scalars['Boolean']['output'];
};

/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttribute = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorAttribute';
  /**
   * Whether the attribute can be displayed in the admin product list. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  availableInGrid: Scalars['Boolean']['output'];
  /** List of attribute's values. */
  choices?: Maybe<SaleorAttributeValueCountableConnection>;
  /** The entity type which can be used as a reference. */
  entityType?: Maybe<SaleorAttributeEntityTypeEnum>;
  /**
   * External ID of this attribute.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Whether the attribute can be filtered in dashboard. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  filterableInDashboard: Scalars['Boolean']['output'];
  /**
   * Whether the attribute can be filtered in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  filterableInStorefront: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: Maybe<SaleorAttributeInputTypeEnum>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Name of an attribute displayed in the interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  productTypes: SaleorProductTypeCountableConnection;
  productVariantTypes: SaleorProductTypeCountableConnection;
  /** Internal representation of an attribute name. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default). Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  storefrontSearchPosition: Scalars['Int']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation?: Maybe<SaleorAttributeTranslation>;
  /** The attribute type. */
  type?: Maybe<SaleorAttributeTypeEnum>;
  /** The unit of attribute values. */
  unit?: Maybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  valueRequired: Scalars['Boolean']['output'];
  /** Whether the attribute should be visible or not in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  visibleInStorefront: Scalars['Boolean']['output'];
  /** Flag indicating that attribute has predefined choices. */
  withChoices: Scalars['Boolean']['output'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributechoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeValueFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorAttributeChoicesSortingInput>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeproductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributeproductVariantTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type SaleorAttributetranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes attributes.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeBulkDelete = {
  __typename?: 'SaleorAttributeBulkDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeChoicesSortField =
  /** Sort attribute choice by name. */
  | 'NAME'
  /** Sort attribute choice by slug. */
  | 'SLUG';

export type SaleorAttributeChoicesSortingInput = {
  /** Specifies the direction in which to sort attribute choices. */
  direction: SaleorOrderDirection;
  /** Sort attribute choices by the selected field. */
  field: SaleorAttributeChoicesSortField;
};

export type SaleorAttributeCountableConnection = {
  __typename?: 'SaleorAttributeCountableConnection';
  edges: Array<SaleorAttributeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorAttributeCountableEdge = {
  __typename?: 'SaleorAttributeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAttribute;
};

/** Creates an attribute. */
export type SaleorAttributeCreate = {
  __typename?: 'SaleorAttributeCreate';
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeCreateInput = {
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** The entity type which can be used as a reference. */
  entityType?: InputMaybe<SaleorAttributeEntityTypeEnum>;
  /**
   * External ID of this attribute.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: InputMaybe<SaleorAttributeInputTypeEnum>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name: Scalars['String']['input'];
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The attribute type. */
  type: SaleorAttributeTypeEnum;
  /** The unit of attribute values. */
  unit?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of attribute's values. */
  values?: InputMaybe<Array<SaleorAttributeValueCreateInput>>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Event sent when new attribute is created.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeCreated = SaleorEvent & {
  __typename?: 'SaleorAttributeCreated';
  /** The attribute the event relates to. */
  attribute?: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeDelete = {
  __typename?: 'SaleorAttributeDelete';
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

/**
 * Event sent when attribute is deleted.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeDeleted = SaleorEvent & {
  __typename?: 'SaleorAttributeDeleted';
  /** The attribute the event relates to. */
  attribute?: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorAttributeEntityTypeEnum =
  | 'PAGE'
  | 'PRODUCT'
  | 'PRODUCT_VARIANT';

export type SaleorAttributeEntityTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeEntityTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeEntityTypeEnum>>;
};

export type SaleorAttributeError = {
  __typename?: 'SaleorAttributeError';
  /** The error code. */
  code: SaleorAttributeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorAttributeErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorAttributeFilterInput = {
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<SaleorAttributeTypeEnum>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorAttributeInput = {
  /** The boolean value of the attribute. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date range that the returned values should be in. In case of date/time attributes, the UTC midnight of the given date is used. */
  date?: InputMaybe<SaleorDateRangeInput>;
  /** The date/time range that the returned values should be in. */
  dateTime?: InputMaybe<SaleorDateTimeRangeInput>;
  /** Internal representation of an attribute name. */
  slug: Scalars['String']['input'];
  /** Internal representation of a value (unique per attribute). */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The range that the returned values should be in. */
  valuesRange?: InputMaybe<SaleorIntRangeInput>;
};

/** An enumeration. */
export type SaleorAttributeInputTypeEnum =
  | 'BOOLEAN'
  | 'DATE'
  | 'DATE_TIME'
  | 'DROPDOWN'
  | 'FILE'
  | 'MULTISELECT'
  | 'NUMERIC'
  | 'PLAIN_TEXT'
  | 'REFERENCE'
  | 'RICH_TEXT'
  | 'SWATCH';

export type SaleorAttributeInputTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeInputTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeInputTypeEnum>>;
};

/**
 * Reorder the values of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeReorderValues = {
  __typename?: 'SaleorAttributeReorderValues';
  /** Attribute from which values are reordered. */
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeSortField =
  /** Sort attributes based on whether they can be displayed or not in a product grid. */
  | 'AVAILABLE_IN_GRID'
  /** Sort attributes by the filterable in dashboard flag */
  | 'FILTERABLE_IN_DASHBOARD'
  /** Sort attributes by the filterable in storefront flag */
  | 'FILTERABLE_IN_STOREFRONT'
  /** Sort attributes by the variant only flag */
  | 'IS_VARIANT_ONLY'
  /** Sort attributes by name */
  | 'NAME'
  /** Sort attributes by slug */
  | 'SLUG'
  /** Sort attributes by their position in storefront */
  | 'STOREFRONT_SEARCH_POSITION'
  /** Sort attributes by the value required flag */
  | 'VALUE_REQUIRED'
  /** Sort attributes by visibility in the storefront */
  | 'VISIBLE_IN_STOREFRONT';

export type SaleorAttributeSortingInput = {
  /** Specifies the direction in which to sort attributes. */
  direction: SaleorOrderDirection;
  /** Sort attributes by the selected field. */
  field: SaleorAttributeSortField;
};

export type SaleorAttributeTranslatableContent = SaleorNode & {
  __typename?: 'SaleorAttributeTranslatableContent';
  /**
   * Custom attribute of a product.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  attribute?: Maybe<SaleorAttribute>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation?: Maybe<SaleorAttributeTranslation>;
};


export type SaleorAttributeTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeTranslate = {
  __typename?: 'SaleorAttributeTranslate';
  attribute?: Maybe<SaleorAttribute>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorAttributeTranslation = SaleorNode & {
  __typename?: 'SaleorAttributeTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name: Scalars['String']['output'];
};

/** An enumeration. */
export type SaleorAttributeTypeEnum =
  | 'PAGE_TYPE'
  | 'PRODUCT_TYPE';

export type SaleorAttributeTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorAttributeTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorAttributeTypeEnum>>;
};

/**
 * Updates attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeUpdate = {
  __typename?: 'SaleorAttributeUpdate';
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeUpdateInput = {
  /** New values to be created for this attribute. */
  addValues?: InputMaybe<Array<SaleorAttributeValueUpdateInput>>;
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * External ID of this product.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** IDs of values to be removed from this attribute. */
  removeValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The unit of attribute values. */
  unit?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Event sent when attribute is updated.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeUpdated = SaleorEvent & {
  __typename?: 'SaleorAttributeUpdated';
  /** The attribute the event relates to. */
  attribute?: Maybe<SaleorAttribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a value of an attribute. */
export type SaleorAttributeValue = SaleorNode & {
  __typename?: 'SaleorAttributeValue';
  /** Represents the boolean value of the attribute value. */
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /** Represents the date value of the attribute value. */
  date?: Maybe<Scalars['SaleorDate']['output']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * External ID of this attribute value.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Represents file URL and content type (if attribute value is a file). */
  file?: Maybe<SaleorFile>;
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: Maybe<SaleorAttributeInputTypeEnum>;
  /** Name of a value displayed in the interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the text of the attribute value, plain text without formating. */
  plainText?: Maybe<Scalars['String']['output']>;
  /** The ID of the attribute reference. */
  reference?: Maybe<Scalars['ID']['output']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** Internal representation of a value (unique per attribute). */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation?: Maybe<SaleorAttributeValueTranslation>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: Maybe<Scalars['String']['output']>;
};


/** Represents a value of an attribute. */
export type SaleorAttributeValuetranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes values of attributes.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeValueBulkDelete = {
  __typename?: 'SaleorAttributeValueBulkDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeValueCountableConnection = {
  __typename?: 'SaleorAttributeValueCountableConnection';
  edges: Array<SaleorAttributeValueCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorAttributeValueCountableEdge = {
  __typename?: 'SaleorAttributeValueCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorAttributeValue;
};

/**
 * Creates a value for an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorAttributeValueCreate = {
  __typename?: 'SaleorAttributeValueCreate';
  /** The updated attribute. */
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue?: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeValueCreateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of this attribute value.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name: Scalars['String']['input'];
  /**
   * Represents the text of the attribute value, plain text without formating.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new attribute value is created.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeValueCreated = SaleorEvent & {
  __typename?: 'SaleorAttributeValueCreated';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a value of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeValueDelete = {
  __typename?: 'SaleorAttributeValueDelete';
  /** The updated attribute. */
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue?: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

/**
 * Event sent when attribute value is deleted.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeValueDeleted = SaleorEvent & {
  __typename?: 'SaleorAttributeValueDeleted';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorAttributeValueFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorAttributeValueInput = {
  /** Represents the boolean value of the attribute value. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Represents the date value of the attribute value. */
  date?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /**
   * Attribute value ID.
   *
   * Added in Saleor 3.9.
   */
  dropdown?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /** URL of the file attribute. Every time, a new value is created. */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * List of attribute value IDs.
   *
   * Added in Saleor 3.9.
   */
  multiselect?: InputMaybe<Array<SaleorAttributeValueSelectableTypeInput>>;
  /**
   * Numeric value of an attribute.
   *
   * Added in Saleor 3.9.
   */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** Plain text content. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /** List of entity IDs that will be used as references. */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text content in JSON format. */
  richText?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * Attribute value ID.
   *
   * Added in Saleor 3.9.
   */
  swatch?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /** The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created. This field will be removed in Saleor 4.0. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents attribute value. If no ID provided, value will be resolved.
 *
 * Added in Saleor 3.9.
 */
export type SaleorAttributeValueSelectableTypeInput = {
  /** ID of an attribute value. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorAttributeValueTranslatableContent = SaleorNode & {
  __typename?: 'SaleorAttributeValueTranslatableContent';
  /**
   * Associated attribute that can be translated.
   *
   * Added in Saleor 3.9.
   */
  attribute?: Maybe<SaleorAttributeTranslatableContent>;
  /**
   * Represents a value of an attribute.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  attributeValue?: Maybe<SaleorAttributeValue>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Attribute plain text value. */
  plainText?: Maybe<Scalars['String']['output']>;
  /**
   * Attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation?: Maybe<SaleorAttributeValueTranslation>;
};


export type SaleorAttributeValueTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute value.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorAttributeValueTranslate = {
  __typename?: 'SaleorAttributeValueTranslate';
  attributeValue?: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorAttributeValueTranslation = SaleorNode & {
  __typename?: 'SaleorAttributeValueTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name: Scalars['String']['output'];
  /** Attribute plain text value. */
  plainText?: Maybe<Scalars['String']['output']>;
  /**
   * Attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['SaleorJSONString']['output']>;
};

export type SaleorAttributeValueTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Translated text. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Translated text.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: InputMaybe<Scalars['SaleorJSONString']['input']>;
};

/**
 * Updates value of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorAttributeValueUpdate = {
  __typename?: 'SaleorAttributeValueUpdate';
  /** The updated attribute. */
  attribute?: Maybe<SaleorAttribute>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  attributeErrors: Array<SaleorAttributeError>;
  attributeValue?: Maybe<SaleorAttributeValue>;
  errors: Array<SaleorAttributeError>;
};

export type SaleorAttributeValueUpdateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of this attribute value.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, plain text without formating.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when attribute value is updated.
 *
 * Added in Saleor 3.5.
 */
export type SaleorAttributeValueUpdated = SaleorEvent & {
  __typename?: 'SaleorAttributeValueUpdated';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<SaleorAttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Where filtering options.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorAttributeWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<SaleorAttributeWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<SaleorAttributeWhereInput>>;
  entityType?: InputMaybe<SaleorAttributeEntityTypeEnumFilterInput>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<SaleorAttributeInputTypeEnumFilterInput>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  name?: InputMaybe<SaleorStringFilterInput>;
  slug?: InputMaybe<SaleorStringFilterInput>;
  type?: InputMaybe<SaleorAttributeTypeEnumFilterInput>;
  unit?: InputMaybe<SaleorMeasurementUnitsEnumFilterInput>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  withChoices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorBulkAttributeValueInput = {
  /** The boolean value of an attribute to resolve. If the passed value is non-existent, it will be created. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * File content type.
   *
   * Added in Saleor 3.12.
   */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the date value of the attribute value.
   *
   * Added in Saleor 3.12.
   */
  date?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * Represents the date/time value of the attribute value.
   *
   * Added in Saleor 3.12.
   */
  dateTime?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /**
   * Attribute value ID.
   *
   * Added in Saleor 3.12.
   */
  dropdown?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /**
   * URL of the file attribute. Every time, a new value is created.
   *
   * Added in Saleor 3.12.
   */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * List of attribute value IDs.
   *
   * Added in Saleor 3.12.
   */
  multiselect?: InputMaybe<Array<SaleorAttributeValueSelectableTypeInput>>;
  /**
   * Numeric value of an attribute.
   *
   * Added in Saleor 3.12.
   */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /**
   * Plain text content.
   *
   * Added in Saleor 3.12.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * List of entity IDs that will be used as references.
   *
   * Added in Saleor 3.12.
   */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Text content in JSON format.
   *
   * Added in Saleor 3.12.
   */
  richText?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * Attribute value ID.
   *
   * Added in Saleor 3.12.
   */
  swatch?: InputMaybe<SaleorAttributeValueSelectableTypeInput>;
  /** The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created.This field will be removed in Saleor 4.0. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorBulkProductError = {
  __typename?: 'SaleorBulkProductError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type SaleorBulkStockError = {
  __typename?: 'SaleorBulkStockError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Synchronous webhook for calculating checkout/order taxes.
 *
 * Added in Saleor 3.7.
 */
export type SaleorCalculateTaxes = SaleorEvent & {
  __typename?: 'SaleorCalculateTaxes';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  taxBase: SaleorTaxableObject;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorCardInput = {
  /** Payment method nonce, a token returned by the appropriate provider's SDK. */
  code: Scalars['String']['input'];
  /** Card security code. */
  cvc?: InputMaybe<Scalars['String']['input']>;
  /** Information about currency and amount. */
  money: SaleorMoneyInput;
};

export type SaleorCatalogueInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product variant related to the discount.
   *
   * Added in Saleor 3.1.
   */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategory = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorCategory';
  /** List of ancestors of the category. */
  ancestors?: Maybe<SaleorCategoryCountableConnection>;
  backgroundImage?: Maybe<SaleorImage>;
  /** List of children of the category. */
  children?: Maybe<SaleorCategoryCountableConnection>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<SaleorCategory>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of products in the category. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  products?: Maybe<SaleorProductCountableConnection>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** Returns translated category fields for the given language code. */
  translation?: Maybe<SaleorCategoryTranslation>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryancestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategorybackgroundImageArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategorychildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategorymetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategorymetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategoryproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type SaleorCategorytranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes categories.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryBulkDelete = {
  __typename?: 'SaleorCategoryBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorCategoryCountableConnection = {
  __typename?: 'SaleorCategoryCountableConnection';
  edges: Array<SaleorCategoryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorCategoryCountableEdge = {
  __typename?: 'SaleorCategoryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCategory;
};

/**
 * Creates a new category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryCreate = {
  __typename?: 'SaleorCategoryCreate';
  category?: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when new category is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCategoryCreated = SaleorEvent & {
  __typename?: 'SaleorCategoryCreated';
  /** The category the event relates to. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryDelete = {
  __typename?: 'SaleorCategoryDelete';
  category?: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when category is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCategoryDeleted = SaleorEvent & {
  __typename?: 'SaleorCategoryDeleted';
  /** The category the event relates to. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorCategoryFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorCategoryInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['SaleorUpload']['input']>;
  /** Alt text for a product media. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Category description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * Fields required to update the category metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the category private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Category slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCategorySortField =
  /** Sort categories by name. */
  | 'NAME'
  /** Sort categories by product count. */
  | 'PRODUCT_COUNT'
  /** Sort categories by subcategory count. */
  | 'SUBCATEGORY_COUNT';

export type SaleorCategorySortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort categories. */
  direction: SaleorOrderDirection;
  /** Sort categories by the selected field. */
  field: SaleorCategorySortField;
};

export type SaleorCategoryTranslatableContent = SaleorNode & {
  __typename?: 'SaleorCategoryTranslatableContent';
  /**
   * Represents a single category of products.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  category?: Maybe<SaleorCategory>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Returns translated category fields for the given language code. */
  translation?: Maybe<SaleorCategoryTranslation>;
};


export type SaleorCategoryTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a category.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorCategoryTranslate = {
  __typename?: 'SaleorCategoryTranslate';
  category?: Maybe<SaleorCategory>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorCategoryTranslation = SaleorNode & {
  __typename?: 'SaleorCategoryTranslation';
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCategoryUpdate = {
  __typename?: 'SaleorCategoryUpdate';
  category?: Maybe<SaleorCategory>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when category is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCategoryUpdated = SaleorEvent & {
  __typename?: 'SaleorCategoryUpdated';
  /** The category the event relates to. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents channel. */
export type SaleorChannel = SaleorNode & {
  __typename?: 'SaleorChannel';
  /**
   * Shipping methods that are available for the channel.
   *
   * Added in Saleor 3.6.
   */
  availableShippingMethodsPerCountry?: Maybe<Array<SaleorShippingMethodsPerCountry>>;
  /**
   * List of shippable countries for the channel.
   *
   * Added in Saleor 3.6.
   */
  countries?: Maybe<Array<SaleorCountryDisplay>>;
  /**
   * A currency that is assigned to the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  currencyCode: Scalars['String']['output'];
  /**
   * Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  defaultCountry: SaleorCountryDisplay;
  /**
   * Whether a channel has associated orders.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  hasOrders: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Whether the channel is active.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  isActive: Scalars['Boolean']['output'];
  /**
   * Name of the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  name: Scalars['String']['output'];
  /**
   * Channel-specific order settings.
   *
   * Added in Saleor 3.12.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, MANAGE_ORDERS.
   */
  orderSettings: SaleorOrderSettings;
  /** Slug of the channel. */
  slug: Scalars['String']['output'];
  /**
   * Define the stock setting for this channel.
   *
   * Added in Saleor 3.7.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  stockSettings: SaleorStockSettings;
  /**
   * List of warehouses assigned to this channel.
   *
   * Added in Saleor 3.5.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  warehouses: Array<SaleorWarehouse>;
};


/** Represents channel. */
export type SaleorChannelavailableShippingMethodsPerCountryArgs = {
  countries?: InputMaybe<Array<SaleorCountryCode>>;
};

/**
 * Activate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelActivate = {
  __typename?: 'SaleorChannelActivate';
  /** Activated channel. */
  channel?: Maybe<SaleorChannel>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

/**
 * Creates new channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelCreate = {
  __typename?: 'SaleorChannelCreate';
  channel?: Maybe<SaleorChannel>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelCreateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of warehouses to assign to the channel.
   *
   * Added in Saleor 3.5.
   */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Currency of the channel. */
  currencyCode: Scalars['String']['input'];
  /**
   * Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided.
   *
   * Added in Saleor 3.1.
   */
  defaultCountry: SaleorCountryCode;
  /** isActive flag. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the channel. */
  name: Scalars['String']['input'];
  /**
   * The channel order settings
   *
   * Added in Saleor 3.12.
   */
  orderSettings?: InputMaybe<SaleorOrderSettingsInput>;
  /** Slug of the channel. */
  slug: Scalars['String']['input'];
  /**
   * The channel stock settings.
   *
   * Added in Saleor 3.7.
   */
  stockSettings?: InputMaybe<SaleorStockSettingsInput>;
};

/**
 * Event sent when new channel is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorChannelCreated = SaleorEvent & {
  __typename?: 'SaleorChannelCreated';
  /** The channel the event relates to. */
  channel?: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelDeactivate = {
  __typename?: 'SaleorChannelDeactivate';
  /** Deactivated channel. */
  channel?: Maybe<SaleorChannel>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

/**
 * Delete a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelDelete = {
  __typename?: 'SaleorChannelDelete';
  channel?: Maybe<SaleorChannel>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelDeleteInput = {
  /** ID of channel to migrate orders from origin channel. */
  channelId: Scalars['ID']['input'];
};

/**
 * Event sent when channel is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorChannelDeleted = SaleorEvent & {
  __typename?: 'SaleorChannelDeleted';
  /** The channel the event relates to. */
  channel?: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorChannelError = {
  __typename?: 'SaleorChannelError';
  /** The error code. */
  code: SaleorChannelErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of shipping zone IDs which causes the error. */
  shippingZones?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouses IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorChannelErrorCode =
  | 'ALREADY_EXISTS'
  | 'CHANNELS_CURRENCY_MUST_BE_THE_SAME'
  | 'CHANNEL_WITH_ORDERS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorChannelListingUpdateInput = {
  /** ID of a channel listing. */
  channelListing: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** The threshold for preorder variant in channel. */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
};

/**
 * Reorder the warehouses of a channel.
 *
 * Added in Saleor 3.7.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type SaleorChannelReorderWarehouses = {
  __typename?: 'SaleorChannelReorderWarehouses';
  /** Channel within the warehouses are reordered. */
  channel?: Maybe<SaleorChannel>;
  errors: Array<SaleorChannelError>;
};

/**
 * Event sent when channel status has changed.
 *
 * Added in Saleor 3.2.
 */
export type SaleorChannelStatusChanged = SaleorEvent & {
  __typename?: 'SaleorChannelStatusChanged';
  /** The channel the event relates to. */
  channel?: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Update a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 * Requires one of the following permissions when updating only orderSettings field: MANAGE_CHANNELS, MANAGE_ORDERS.
 */
export type SaleorChannelUpdate = {
  __typename?: 'SaleorChannelUpdate';
  channel?: Maybe<SaleorChannel>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  channelErrors: Array<SaleorChannelError>;
  errors: Array<SaleorChannelError>;
};

export type SaleorChannelUpdateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of warehouses to assign to the channel.
   *
   * Added in Saleor 3.5.
   */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided.
   *
   * Added in Saleor 3.1.
   */
  defaultCountry?: InputMaybe<SaleorCountryCode>;
  /** isActive flag. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The channel order settings
   *
   * Added in Saleor 3.12.
   */
  orderSettings?: InputMaybe<SaleorOrderSettingsInput>;
  /** List of shipping zones to unassign from the channel. */
  removeShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of warehouses to unassign from the channel.
   *
   * Added in Saleor 3.5.
   */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Slug of the channel. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The channel stock settings.
   *
   * Added in Saleor 3.7.
   */
  stockSettings?: InputMaybe<SaleorStockSettingsInput>;
};

/**
 * Event sent when channel is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorChannelUpdated = SaleorEvent & {
  __typename?: 'SaleorChannelUpdated';
  /** The channel the event relates to. */
  channel?: Maybe<SaleorChannel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Checkout object. */
export type SaleorCheckout = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorCheckout';
  /**
   * The authorize status of the checkout.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  authorizeStatus: SaleorCheckoutAuthorizeStatusEnum;
  /**
   * Collection points that can be used for this order.
   *
   * Added in Saleor 3.1.
   */
  availableCollectionPoints: Array<SaleorWarehouse>;
  /** List of available payment gateways. */
  availablePaymentGateways: Array<SaleorPaymentGateway>;
  /**
   * Shipping methods that can be used with this checkout.
   * @deprecated This field will be removed in Saleor 4.0. Use `shippingMethods` instead.
   */
  availableShippingMethods: Array<SaleorShippingMethod>;
  billingAddress?: Maybe<SaleorAddress>;
  channel: SaleorChannel;
  /**
   * The charge status of the checkout.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  chargeStatus: SaleorCheckoutChargeStatusEnum;
  created: Scalars['SaleorDateTime']['output'];
  /**
   * The delivery method selected for this checkout.
   *
   * Added in Saleor 3.1.
   */
  deliveryMethod?: Maybe<SaleorDeliveryMethod>;
  discount?: Maybe<SaleorMoney>;
  discountName?: Maybe<Scalars['String']['output']>;
  /**
   * Determines whether checkout prices should include taxes when displayed in a storefront.
   *
   * Added in Saleor 3.9.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Email of a customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** List of gift cards associated with this checkout. */
  giftCards: Array<SaleorGiftCard>;
  id: Scalars['ID']['output'];
  /** Returns True, if checkout requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** Checkout language code. */
  languageCode: SaleorLanguageCodeEnum;
  /** @deprecated This field will be removed in Saleor 4.0. Use `updatedAt` instead. */
  lastChange: Scalars['SaleorDateTime']['output'];
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<SaleorCheckoutLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  note: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['output'];
  shippingAddress?: Maybe<SaleorAddress>;
  /**
   * The shipping method related with checkout.
   * @deprecated This field will be removed in Saleor 4.0. Use `deliveryMethod` instead.
   */
  shippingMethod?: Maybe<SaleorShippingMethod>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods: Array<SaleorShippingMethod>;
  /** The price of the shipping, with all the taxes included. */
  shippingPrice: SaleorTaxedMoney;
  /**
   * Date when oldest stock reservation for this checkout expires or null if no stock is reserved.
   *
   * Added in Saleor 3.1.
   */
  stockReservationExpires?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The price of the checkout before shipping, with taxes included. */
  subtotalPrice: SaleorTaxedMoney;
  /**
   * Returns True if checkout has to be exempt from taxes.
   *
   * Added in Saleor 3.8.
   */
  taxExemption: Scalars['Boolean']['output'];
  /** The checkout's token. */
  token: Scalars['SaleorUUID']['output'];
  /**
   * The difference between the paid and the checkout total amount.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  totalBalance: SaleorMoney;
  /** The sum of the the checkout line prices, with all the taxes,shipping costs, and discounts included. */
  totalPrice: SaleorTaxedMoney;
  /**
   * List of transactions for the checkout. Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_PAYMENTS.
   *
   * Added in Saleor 3.4.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  transactions?: Maybe<Array<SaleorTransactionItem>>;
  translatedDiscountName?: Maybe<Scalars['String']['output']>;
  /**
   * Time of last modification of the given checkout.
   *
   * Added in Saleor 3.13.
   */
  updatedAt: Scalars['SaleorDateTime']['output'];
  user?: Maybe<SaleorUser>;
  voucherCode?: Maybe<Scalars['String']['output']>;
};


/** Checkout object. */
export type SaleorCheckoutmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type SaleorCheckoutmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Checkout object. */
export type SaleorCheckoutprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type SaleorCheckoutprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Adds a gift card or a voucher to a checkout. */
export type SaleorCheckoutAddPromoCode = {
  __typename?: 'SaleorCheckoutAddPromoCode';
  /** The checkout with the added gift card or voucher. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutAddressValidationRules = {
  /** Determines if an error should be raised when the provided address doesn't match the expected format. Example: using letters for postal code when the numbers are expected. */
  checkFieldsFormat?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if an error should be raised when the provided address doesn't have all the required fields. The list of required fields is dynamic and depends on the country code (use the `addressValidationRules` query to fetch them). Note: country code is mandatory for all addresses regardless of the rules provided in this input. */
  checkRequiredFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if Saleor should apply normalization on address fields. Example: converting city field to uppercase letters. */
  enableFieldsNormalization?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Determine a current authorize status for checkout.
 *
 *     We treat the checkout as fully authorized when the sum of authorized and charged
 *     funds cover the checkout.total.
 *     We treat the checkout as partially authorized when the sum of authorized and charged
 *     funds covers only part of the checkout.total
 *     We treat the checkout as not authorized when the sum of authorized and charged funds
 *     is 0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the cover funds don't cover fully the checkout's total
 *     FULL - the cover funds covers the checkout's total
 *
 */
export type SaleorCheckoutAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

/** Update billing address in the existing checkout. */
export type SaleorCheckoutBillingAddressUpdate = {
  __typename?: 'SaleorCheckoutBillingAddressUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Determine the current charge status for the checkout.
 *
 *     The checkout is considered overcharged when the sum of the transactionItem's charge
 *     amounts exceeds the value of `checkout.total`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `checkout.total`, we consider the checkout to be fully charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `checkout.total`, we treat the checkout as partially charged.
 *
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the checkout's total
 *     FULL - the funds that are charged fully cover the checkout's total
 *     OVERCHARGED - the charged funds are bigger than checkout's total
 *
 */
export type SaleorCheckoutChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/** Completes the checkout. As a result a new order is created and a payment charge is made. This action requires a successful payment before it can be performed. In case additional confirmation step as 3D secure is required confirmationNeeded flag will be set to True and no order created until payment is confirmed with second call of this mutation. */
export type SaleorCheckoutComplete = {
  __typename?: 'SaleorCheckoutComplete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  /** Confirmation data used to process additional authorization steps. */
  confirmationData?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** Set to true if payment needs to be confirmed before checkout is complete. */
  confirmationNeeded: Scalars['Boolean']['output'];
  errors: Array<SaleorCheckoutError>;
  /** Placed order. */
  order?: Maybe<SaleorOrder>;
};

export type SaleorCheckoutCountableConnection = {
  __typename?: 'SaleorCheckoutCountableConnection';
  edges: Array<SaleorCheckoutCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorCheckoutCountableEdge = {
  __typename?: 'SaleorCheckoutCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCheckout;
};

/** Create a new checkout. */
export type SaleorCheckoutCreate = {
  __typename?: 'SaleorCheckoutCreate';
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  /**
   * Whether the checkout was created or the current active one was returned. Refer to checkoutLinesAdd and checkoutLinesUpdate to merge a cart with an active checkout.
   * @deprecated This field will be removed in Saleor 4.0. Always returns `true`.
   */
  created?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutCreateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** Slug of a channel in which to create a checkout. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checkout language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<SaleorCheckoutLineInput>;
  /** The mailing address to where the checkout will be shipped. Note: the address will be ignored if the checkout doesn't contain shippable items. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /**
   * The checkout validation rules that can be changed.
   *
   * Added in Saleor 3.5.
   */
  validationRules?: InputMaybe<SaleorCheckoutValidationRules>;
};

/**
 * Event sent when new checkout is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCheckoutCreated = SaleorEvent & {
  __typename?: 'SaleorCheckoutCreated';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Sets the customer as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 */
export type SaleorCheckoutCustomerAttach = {
  __typename?: 'SaleorCheckoutCustomerAttach';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Removes the user assigned as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 */
export type SaleorCheckoutCustomerDetach = {
  __typename?: 'SaleorCheckoutCustomerDetach';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Updates the delivery method (shipping method or pick up point) of the checkout.
 *
 * Added in Saleor 3.1.
 */
export type SaleorCheckoutDeliveryMethodUpdate = {
  __typename?: 'SaleorCheckoutDeliveryMethodUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  errors: Array<SaleorCheckoutError>;
};

/** Updates email address in the existing checkout object. */
export type SaleorCheckoutEmailUpdate = {
  __typename?: 'SaleorCheckoutEmailUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutError = {
  __typename?: 'SaleorCheckoutError';
  /** A type of address that causes the error. */
  addressType?: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorCheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of varint IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorCheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FULLY_PAID'
  | 'DELIVERY_METHOD_NOT_APPLICABLE'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE_PAYMENT'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'MISSING_CHANNEL_SLUG'
  | 'NOT_FOUND'
  | 'NO_LINES'
  | 'PAYMENT_ERROR'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'QUANTITY_GREATER_THAN_LIMIT'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'SHIPPING_NOT_REQUIRED'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE'
  | 'VOUCHER_NOT_APPLICABLE'
  | 'ZERO_QUANTITY';

export type SaleorCheckoutFilterInput = {
  authorizeStatus?: InputMaybe<Array<SaleorCheckoutAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<SaleorCheckoutChargeStatusEnum>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<SaleorDateRangeInput>;
};

/**
 * Filter shipping methods for checkout.
 *
 * Added in Saleor 3.6.
 */
export type SaleorCheckoutFilterShippingMethods = SaleorEvent & {
  __typename?: 'SaleorCheckoutFilterShippingMethods';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Added in Saleor 3.6.
   */
  shippingMethods?: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when checkout is fully paid with transactions.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorCheckoutFullyPaid = SaleorEvent & {
  __typename?: 'SaleorCheckoutFullyPaid';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Update language code in the existing checkout. */
export type SaleorCheckoutLanguageCodeUpdate = {
  __typename?: 'SaleorCheckoutLanguageCodeUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Represents an item in the checkout. */
export type SaleorCheckoutLine = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorCheckoutLine';
  id: Scalars['ID']['output'];
  /**
   * List of public metadata items. Can be accessed without permissions.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * List of private metadata items. Requires staff permissions to access.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  quantity: Scalars['Int']['output'];
  /** Indicates whether the item need to be delivered. */
  requiresShipping: Scalars['Boolean']['output'];
  /** The sum of the checkout line price, taxes and discounts. */
  totalPrice: SaleorTaxedMoney;
  /** The sum of the checkout line price, without discounts. */
  undiscountedTotalPrice: SaleorMoney;
  /** The unit price of the checkout line, without discounts. */
  undiscountedUnitPrice: SaleorMoney;
  /** The unit price of the checkout line, with taxes and discounts. */
  unitPrice: SaleorTaxedMoney;
  variant: SaleorProductVariant;
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLinemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLinemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLineprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type SaleorCheckoutLineprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorCheckoutLineCountableConnection = {
  __typename?: 'SaleorCheckoutLineCountableConnection';
  edges: Array<SaleorCheckoutLineCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorCheckoutLineCountableEdge = {
  __typename?: 'SaleorCheckoutLineCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCheckoutLine;
};

/** Deletes a CheckoutLine. */
export type SaleorCheckoutLineDelete = {
  __typename?: 'SaleorCheckoutLineDelete';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutLineInput = {
  /**
   * Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.
   *
   * Added in Saleor 3.6.
   */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the object's metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used.
   *
   * Added in Saleor 3.1.
   */
  price?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['input'];
  /** ID of the product variant. */
  variantId: Scalars['ID']['input'];
};

export type SaleorCheckoutLineUpdateInput = {
  /**
   * ID of the line.
   *
   * Added in Saleor 3.6.
   */
  lineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used.
   *
   * Added in Saleor 3.1.
   */
  price?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** The number of items purchased. Optional for apps, required for any other users. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ID of the product variant.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `lineId` instead.
   */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased. */
export type SaleorCheckoutLinesAdd = {
  __typename?: 'SaleorCheckoutLinesAdd';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Deletes checkout lines. */
export type SaleorCheckoutLinesDelete = {
  __typename?: 'SaleorCheckoutLinesDelete';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  errors: Array<SaleorCheckoutError>;
};

/** Updates checkout line in the existing checkout. */
export type SaleorCheckoutLinesUpdate = {
  __typename?: 'SaleorCheckoutLinesUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/**
 * Event sent when checkout metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorCheckoutMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorCheckoutMetadataUpdated';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Create a new payment for given checkout. */
export type SaleorCheckoutPaymentCreate = {
  __typename?: 'SaleorCheckoutPaymentCreate';
  /** Related checkout object. */
  checkout?: Maybe<SaleorCheckout>;
  errors: Array<SaleorPaymentError>;
  /** A newly created payment. */
  payment?: Maybe<SaleorPayment>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/** Remove a gift card or a voucher from a checkout. */
export type SaleorCheckoutRemovePromoCode = {
  __typename?: 'SaleorCheckoutRemovePromoCode';
  /** The checkout with the removed gift card or voucher. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Update shipping address in the existing checkout. */
export type SaleorCheckoutShippingAddressUpdate = {
  __typename?: 'SaleorCheckoutShippingAddressUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

/** Updates the shipping method of the checkout. */
export type SaleorCheckoutShippingMethodUpdate = {
  __typename?: 'SaleorCheckoutShippingMethodUpdate';
  /** An updated checkout. */
  checkout?: Maybe<SaleorCheckout>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  checkoutErrors: Array<SaleorCheckoutError>;
  errors: Array<SaleorCheckoutError>;
};

export type SaleorCheckoutSortField =
  /** Sort checkouts by creation date. */
  | 'CREATION_DATE'
  /** Sort checkouts by customer. */
  | 'CUSTOMER'
  /** Sort checkouts by payment. */
  | 'PAYMENT';

export type SaleorCheckoutSortingInput = {
  /** Specifies the direction in which to sort checkouts. */
  direction: SaleorOrderDirection;
  /** Sort checkouts by the selected field. */
  field: SaleorCheckoutSortField;
};

/**
 * Event sent when checkout is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCheckoutUpdated = SaleorEvent & {
  __typename?: 'SaleorCheckoutUpdated';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorCheckoutValidationRules = {
  /** The validation rules that can be applied to provided billing address data. */
  billingAddress?: InputMaybe<SaleorCheckoutAddressValidationRules>;
  /** The validation rules that can be applied to provided shipping address data. */
  shippingAddress?: InputMaybe<SaleorCheckoutAddressValidationRules>;
};

export type SaleorChoiceValue = {
  __typename?: 'SaleorChoiceValue';
  raw?: Maybe<Scalars['String']['output']>;
  verbose?: Maybe<Scalars['String']['output']>;
};

/** Represents a collection of products. */
export type SaleorCollection = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorCollection';
  backgroundImage?: Maybe<SaleorImage>;
  /** Channel given to retrieve this collection. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of channels in which the collection is available.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings?: Maybe<Array<SaleorCollectionChannelListing>>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of products in this collection. */
  products?: Maybe<SaleorProductCountableConnection>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /** Returns translated collection fields for the given language code. */
  translation?: Maybe<SaleorCollectionTranslation>;
};


/** Represents a collection of products. */
export type SaleorCollectionbackgroundImageArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a collection of products. */
export type SaleorCollectionmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type SaleorCollectionmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type SaleorCollectionprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type SaleorCollectionprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type SaleorCollectionproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorProductOrder>;
};


/** Represents a collection of products. */
export type SaleorCollectiontranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Adds products to a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionAddProducts = {
  __typename?: 'SaleorCollectionAddProducts';
  /** Collection to which products will be added. */
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Deletes collections.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionBulkDelete = {
  __typename?: 'SaleorCollectionBulkDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorCollectionError>;
};

/** Represents collection channel listing. */
export type SaleorCollectionChannelListing = SaleorNode & {
  __typename?: 'SaleorCollectionChannelListing';
  channel: SaleorChannel;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** @deprecated This field will be removed in Saleor 4.0. Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['SaleorDate']['output']>;
  /**
   * The collection publication date.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
};

export type SaleorCollectionChannelListingError = {
  __typename?: 'SaleorCollectionChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage collection's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionChannelListingUpdate = {
  __typename?: 'SaleorCollectionChannelListingUpdate';
  /** An updated collection instance. */
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionChannelListingErrors: Array<SaleorCollectionChannelListingError>;
  errors: Array<SaleorCollectionChannelListingError>;
};

export type SaleorCollectionChannelListingUpdateInput = {
  /** List of channels to which the collection should be assigned. */
  addChannels?: InputMaybe<Array<SaleorPublishableChannelListingInput>>;
  /** List of channels from which the collection should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaleorCollectionCountableConnection = {
  __typename?: 'SaleorCollectionCountableConnection';
  edges: Array<SaleorCollectionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorCollectionCountableEdge = {
  __typename?: 'SaleorCollectionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorCollection;
};

/**
 * Creates a new collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionCreate = {
  __typename?: 'SaleorCollectionCreate';
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

export type SaleorCollectionCreateInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['SaleorUpload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** List of products to be added to the collection. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  publicationDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new collection is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionCreated = SaleorEvent & {
  __typename?: 'SaleorCollectionCreated';
  /** The collection the event relates to. */
  collection?: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new collection is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionCreatedcollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionDelete = {
  __typename?: 'SaleorCollectionDelete';
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Event sent when collection is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionDeleted = SaleorEvent & {
  __typename?: 'SaleorCollectionDeleted';
  /** The collection the event relates to. */
  collection?: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when collection is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionDeletedcollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCollectionError = {
  __typename?: 'SaleorCollectionError';
  /** The error code. */
  code: SaleorCollectionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorCollectionErrorCode =
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorCollectionFilterInput = {
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  published?: InputMaybe<SaleorCollectionPublished>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorCollectionInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['SaleorUpload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  publicationDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when collection metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorCollectionMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorCollectionMetadataUpdated';
  /** The collection the event relates to. */
  collection?: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when collection metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorCollectionMetadataUpdatedcollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorCollectionPublished =
  | 'HIDDEN'
  | 'PUBLISHED';

/**
 * Remove products from a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionRemoveProducts = {
  __typename?: 'SaleorCollectionRemoveProducts';
  /** Collection from which products will be removed. */
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Reorder the products of a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionReorderProducts = {
  __typename?: 'SaleorCollectionReorderProducts';
  /** Collection from which products are reordered. */
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

export type SaleorCollectionSortField =
  /**
   * Sort collections by availability.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'AVAILABILITY'
  /** Sort collections by name. */
  | 'NAME'
  /** Sort collections by product count. */
  | 'PRODUCT_COUNT'
  /**
   * Sort collections by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort collections by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT';

export type SaleorCollectionSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort collections. */
  direction: SaleorOrderDirection;
  /** Sort collections by the selected field. */
  field: SaleorCollectionSortField;
};

export type SaleorCollectionTranslatableContent = SaleorNode & {
  __typename?: 'SaleorCollectionTranslatableContent';
  /**
   * Represents a collection of products.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  collection?: Maybe<SaleorCollection>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Returns translated collection fields for the given language code. */
  translation?: Maybe<SaleorCollectionTranslation>;
};


export type SaleorCollectionTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a collection.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorCollectionTranslate = {
  __typename?: 'SaleorCollectionTranslate';
  collection?: Maybe<SaleorCollection>;
  errors: Array<SaleorTranslationError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorCollectionTranslation = SaleorNode & {
  __typename?: 'SaleorCollectionTranslation';
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorCollectionUpdate = {
  __typename?: 'SaleorCollectionUpdate';
  collection?: Maybe<SaleorCollection>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  collectionErrors: Array<SaleorCollectionError>;
  errors: Array<SaleorCollectionError>;
};

/**
 * Event sent when collection is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionUpdated = SaleorEvent & {
  __typename?: 'SaleorCollectionUpdated';
  /** The collection the event relates to. */
  collection?: Maybe<SaleorCollection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when collection is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCollectionUpdatedcollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Stores information about a single configuration field. */
export type SaleorConfigurationItem = {
  __typename?: 'SaleorConfigurationItem';
  /** Help text for the field. */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Label for the field. */
  label?: Maybe<Scalars['String']['output']>;
  /** Name of the field. */
  name: Scalars['String']['output'];
  /** Type of the field. */
  type?: Maybe<SaleorConfigurationTypeFieldEnum>;
  /** Current value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};

export type SaleorConfigurationItemInput = {
  /** Name of the field to update. */
  name: Scalars['String']['input'];
  /** Value of the given field to update. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export type SaleorConfigurationTypeFieldEnum =
  | 'BOOLEAN'
  | 'MULTILINE'
  | 'OUTPUT'
  | 'PASSWORD'
  | 'SECRET'
  | 'SECRETMULTILINE'
  | 'STRING';

/** Confirm user account with token sent by email during registration. */
export type SaleorConfirmAccount = {
  __typename?: 'SaleorConfirmAccount';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An activated user account. */
  user?: Maybe<SaleorUser>;
};

/**
 * Confirm the email change of the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorConfirmEmailChange = {
  __typename?: 'SaleorConfirmEmailChange';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance with a new email. */
  user?: Maybe<SaleorUser>;
};

/** An enumeration. */
export type SaleorCountryCode =
  | 'AD'
  | 'AE'
  | 'AF'
  | 'AG'
  | 'AI'
  | 'AL'
  | 'AM'
  | 'AO'
  | 'AQ'
  | 'AR'
  | 'AS'
  | 'AT'
  | 'AU'
  | 'AW'
  | 'AX'
  | 'AZ'
  | 'BA'
  | 'BB'
  | 'BD'
  | 'BE'
  | 'BF'
  | 'BG'
  | 'BH'
  | 'BI'
  | 'BJ'
  | 'BL'
  | 'BM'
  | 'BN'
  | 'BO'
  | 'BQ'
  | 'BR'
  | 'BS'
  | 'BT'
  | 'BV'
  | 'BW'
  | 'BY'
  | 'BZ'
  | 'CA'
  | 'CC'
  | 'CD'
  | 'CF'
  | 'CG'
  | 'CH'
  | 'CI'
  | 'CK'
  | 'CL'
  | 'CM'
  | 'CN'
  | 'CO'
  | 'CR'
  | 'CU'
  | 'CV'
  | 'CW'
  | 'CX'
  | 'CY'
  | 'CZ'
  | 'DE'
  | 'DJ'
  | 'DK'
  | 'DM'
  | 'DO'
  | 'DZ'
  | 'EC'
  | 'EE'
  | 'EG'
  | 'EH'
  | 'ER'
  | 'ES'
  | 'ET'
  | 'EU'
  | 'FI'
  | 'FJ'
  | 'FK'
  | 'FM'
  | 'FO'
  | 'FR'
  | 'GA'
  | 'GB'
  | 'GD'
  | 'GE'
  | 'GF'
  | 'GG'
  | 'GH'
  | 'GI'
  | 'GL'
  | 'GM'
  | 'GN'
  | 'GP'
  | 'GQ'
  | 'GR'
  | 'GS'
  | 'GT'
  | 'GU'
  | 'GW'
  | 'GY'
  | 'HK'
  | 'HM'
  | 'HN'
  | 'HR'
  | 'HT'
  | 'HU'
  | 'ID'
  | 'IE'
  | 'IL'
  | 'IM'
  | 'IN'
  | 'IO'
  | 'IQ'
  | 'IR'
  | 'IS'
  | 'IT'
  | 'JE'
  | 'JM'
  | 'JO'
  | 'JP'
  | 'KE'
  | 'KG'
  | 'KH'
  | 'KI'
  | 'KM'
  | 'KN'
  | 'KP'
  | 'KR'
  | 'KW'
  | 'KY'
  | 'KZ'
  | 'LA'
  | 'LB'
  | 'LC'
  | 'LI'
  | 'LK'
  | 'LR'
  | 'LS'
  | 'LT'
  | 'LU'
  | 'LV'
  | 'LY'
  | 'MA'
  | 'MC'
  | 'MD'
  | 'ME'
  | 'MF'
  | 'MG'
  | 'MH'
  | 'MK'
  | 'ML'
  | 'MM'
  | 'MN'
  | 'MO'
  | 'MP'
  | 'MQ'
  | 'MR'
  | 'MS'
  | 'MT'
  | 'MU'
  | 'MV'
  | 'MW'
  | 'MX'
  | 'MY'
  | 'MZ'
  | 'NA'
  | 'NC'
  | 'NE'
  | 'NF'
  | 'NG'
  | 'NI'
  | 'NL'
  | 'NO'
  | 'NP'
  | 'NR'
  | 'NU'
  | 'NZ'
  | 'OM'
  | 'PA'
  | 'PE'
  | 'PF'
  | 'PG'
  | 'PH'
  | 'PK'
  | 'PL'
  | 'PM'
  | 'PN'
  | 'PR'
  | 'PS'
  | 'PT'
  | 'PW'
  | 'PY'
  | 'QA'
  | 'RE'
  | 'RO'
  | 'RS'
  | 'RU'
  | 'RW'
  | 'SA'
  | 'SB'
  | 'SC'
  | 'SD'
  | 'SE'
  | 'SG'
  | 'SH'
  | 'SI'
  | 'SJ'
  | 'SK'
  | 'SL'
  | 'SM'
  | 'SN'
  | 'SO'
  | 'SR'
  | 'SS'
  | 'ST'
  | 'SV'
  | 'SX'
  | 'SY'
  | 'SZ'
  | 'TC'
  | 'TD'
  | 'TF'
  | 'TG'
  | 'TH'
  | 'TJ'
  | 'TK'
  | 'TL'
  | 'TM'
  | 'TN'
  | 'TO'
  | 'TR'
  | 'TT'
  | 'TV'
  | 'TW'
  | 'TZ'
  | 'UA'
  | 'UG'
  | 'UM'
  | 'US'
  | 'UY'
  | 'UZ'
  | 'VA'
  | 'VC'
  | 'VE'
  | 'VG'
  | 'VI'
  | 'VN'
  | 'VU'
  | 'WF'
  | 'WS'
  | 'YE'
  | 'YT'
  | 'ZA'
  | 'ZM'
  | 'ZW';

export type SaleorCountryDisplay = {
  __typename?: 'SaleorCountryDisplay';
  /** Country code. */
  code: Scalars['String']['output'];
  /** Country name. */
  country: Scalars['String']['output'];
  /**
   * Country tax.
   * @deprecated This field will be removed in Saleor 4.0. Use `TaxClassCountryRate` type to manage tax rates per country.
   */
  vat?: Maybe<SaleorVAT>;
};

export type SaleorCountryFilterInput = {
  /** Boolean for filtering countries by having shipping zone assigned.If 'true', return countries with shipping zone assigned.If 'false', return countries without any shipping zone assigned.If the argument is not provided (null), return all countries. */
  attachedToShippingZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorCountryRateInput = {
  /** Country in which this rate applies. */
  countryCode: SaleorCountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. */
  rate: Scalars['Float']['input'];
};

export type SaleorCountryRateUpdateInput = {
  /** Country in which this rate applies. */
  countryCode: SaleorCountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. Provide `null` to remove the particular rate. */
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** Create JWT token. */
export type SaleorCreateToken = {
  __typename?: 'SaleorCreateToken';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

export type SaleorCreditCard = {
  __typename?: 'SaleorCreditCard';
  /** Card brand. */
  brand: Scalars['String']['output'];
  /** Two-digit number representing the card’s expiration month. */
  expMonth?: Maybe<Scalars['Int']['output']>;
  /** Four-digit number representing the card’s expiration year. */
  expYear?: Maybe<Scalars['Int']['output']>;
  /** First 4 digits of the card number. */
  firstDigits?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card number. */
  lastDigits: Scalars['String']['output'];
};

/**
 * Deletes customers.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorCustomerBulkDelete = {
  __typename?: 'SaleorCustomerBulkDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAccountError>;
};

export type SaleorCustomerBulkResult = {
  __typename?: 'SaleorCustomerBulkResult';
  /** Customer data. */
  customer?: Maybe<SaleorUser>;
  /** List of errors that occurred during the update attempt. */
  errors?: Maybe<Array<SaleorCustomerBulkUpdateError>>;
};

/**
 * Updates customers.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorCustomerBulkUpdate = {
  __typename?: 'SaleorCustomerBulkUpdate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorCustomerBulkUpdateError>;
  /** List of the updated customers. */
  results: Array<SaleorCustomerBulkResult>;
};

export type SaleorCustomerBulkUpdateError = {
  __typename?: 'SaleorCustomerBulkUpdateError';
  /** The error code. */
  code: SaleorCustomerBulkUpdateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorCustomerBulkUpdateErrorCode =
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorCustomerBulkUpdateInput = {
  /** External ID of a customer to update. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of a customer to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Fields required to update a customer. */
  input: SaleorCustomerInput;
};

/**
 * Creates a new customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorCustomerCreate = {
  __typename?: 'SaleorCustomerCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when new customer user is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCustomerCreated = SaleorEvent & {
  __typename?: 'SaleorCustomerCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorCustomerDelete = {
  __typename?: 'SaleorCustomerDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user?: Maybe<SaleorUser>;
};

/** History log of the customer. */
export type SaleorCustomerEvent = SaleorNode & {
  __typename?: 'SaleorCustomerEvent';
  /** App that performed the action. */
  app?: Maybe<SaleorApp>;
  /** Number of objects concerned by the event. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['SaleorDateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** The concerned order. */
  order?: Maybe<SaleorOrder>;
  /** The concerned order line. */
  orderLine?: Maybe<SaleorOrderLine>;
  /** Customer event type. */
  type?: Maybe<SaleorCustomerEventsEnum>;
  /** User who performed the action. */
  user?: Maybe<SaleorUser>;
};

/** An enumeration. */
export type SaleorCustomerEventsEnum =
  | 'ACCOUNT_ACTIVATED'
  | 'ACCOUNT_CREATED'
  | 'ACCOUNT_DEACTIVATED'
  | 'CUSTOMER_DELETED'
  | 'DIGITAL_LINK_DOWNLOADED'
  | 'EMAIL_ASSIGNED'
  | 'EMAIL_CHANGED'
  | 'EMAIL_CHANGED_REQUEST'
  | 'NAME_ASSIGNED'
  | 'NOTE_ADDED'
  | 'NOTE_ADDED_TO_ORDER'
  | 'PASSWORD_CHANGED'
  | 'PASSWORD_RESET'
  | 'PASSWORD_RESET_LINK_SENT'
  | 'PLACED_ORDER';

export type SaleorCustomerFilterInput = {
  dateJoined?: InputMaybe<SaleorDateRangeInput>;
  /**
   * Filter by ids.
   *
   * Added in Saleor 3.8.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  numberOfOrders?: InputMaybe<SaleorIntRangeInput>;
  placedOrders?: InputMaybe<SaleorDateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorCustomerInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of the customer.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when customer user metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorCustomerMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorCustomerMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorCustomerUpdate = {
  __typename?: 'SaleorCustomerUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when customer user is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorCustomerUpdated = SaleorEvent & {
  __typename?: 'SaleorCustomerUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorDateRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['SaleorDate']['input']>;
};

export type SaleorDateTimeRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['SaleorDateTime']['input']>;
};

/**
 * Deactivate all JWT tokens of the currently authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorDeactivateAllUserTokens = {
  __typename?: 'SaleorDeactivateAllUserTokens';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

/** Delete metadata of an object. To use it, you need to have access to the modified object. */
export type SaleorDeleteMetadata = {
  __typename?: 'SaleorDeleteMetadata';
  errors: Array<SaleorMetadataError>;
  item?: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
export type SaleorDeletePrivateMetadata = {
  __typename?: 'SaleorDeletePrivateMetadata';
  errors: Array<SaleorMetadataError>;
  item?: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/**
 * Represents a delivery method chosen for the checkout. `Warehouse` type is used when checkout is marked as "click and collect" and `ShippingMethod` otherwise.
 *
 * Added in Saleor 3.1.
 */
export type SaleorDeliveryMethod = SaleorShippingMethod | SaleorWarehouse;

export type SaleorDigitalContent = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorDigitalContent';
  automaticFulfillment: Scalars['Boolean']['output'];
  contentFile: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxDownloads?: Maybe<Scalars['Int']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Product variant assigned to digital content. */
  productVariant: SaleorProductVariant;
  urlValidDays?: Maybe<Scalars['Int']['output']>;
  /** List of URLs for the digital variant. */
  urls?: Maybe<Array<SaleorDigitalContentUrl>>;
  useDefaultSettings: Scalars['Boolean']['output'];
};


export type SaleorDigitalContentmetafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorDigitalContentmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorDigitalContentprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorDigitalContentprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorDigitalContentCountableConnection = {
  __typename?: 'SaleorDigitalContentCountableConnection';
  edges: Array<SaleorDigitalContentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorDigitalContentCountableEdge = {
  __typename?: 'SaleorDigitalContentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorDigitalContent;
};

/**
 * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentCreate = {
  __typename?: 'SaleorDigitalContentCreate';
  content?: Maybe<SaleorDigitalContent>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant?: Maybe<SaleorProductVariant>;
};

/**
 * Remove digital content assigned to given variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentDelete = {
  __typename?: 'SaleorDigitalContentDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant?: Maybe<SaleorProductVariant>;
};

export type SaleorDigitalContentInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Fields required to update the digital content private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

/**
 * Update digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentUpdate = {
  __typename?: 'SaleorDigitalContentUpdate';
  content?: Maybe<SaleorDigitalContent>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  variant?: Maybe<SaleorProductVariant>;
};

export type SaleorDigitalContentUploadInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents an file in a multipart request. */
  contentFile: Scalars['SaleorUpload']['input'];
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Fields required to update the digital content private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

export type SaleorDigitalContentUrl = SaleorNode & {
  __typename?: 'SaleorDigitalContentUrl';
  content: SaleorDigitalContent;
  created: Scalars['SaleorDateTime']['output'];
  downloadNum: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** UUID of digital content. */
  token: Scalars['SaleorUUID']['output'];
  /** URL for digital content. */
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate new URL to digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorDigitalContentUrlCreate = {
  __typename?: 'SaleorDigitalContentUrlCreate';
  digitalContentUrl?: Maybe<SaleorDigitalContentUrl>;
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorDigitalContentUrlCreateInput = {
  /** Digital content ID which URL will belong to. */
  content: Scalars['ID']['input'];
};

export type SaleorDiscountError = {
  __typename?: 'SaleorDiscountError';
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorDiscountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorDiscountErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorDiscountStatusEnum =
  | 'ACTIVE'
  | 'EXPIRED'
  | 'SCHEDULED';

export type SaleorDiscountValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

/** An enumeration. */
export type SaleorDistanceUnitsEnum =
  | 'CM'
  | 'FT'
  | 'INCH'
  | 'KM'
  | 'M'
  | 'YD';

/** Represents shop's domain. */
export type SaleorDomain = {
  __typename?: 'SaleorDomain';
  /** The host name of the domain. */
  host: Scalars['String']['output'];
  /** Inform if SSL is enabled. */
  sslEnabled: Scalars['Boolean']['output'];
  /** Shop's absolute URL. */
  url: Scalars['String']['output'];
};

/**
 * Deletes draft orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderBulkDelete = {
  __typename?: 'SaleorDraftOrderBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Completes creating an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderComplete = {
  __typename?: 'SaleorDraftOrderComplete';
  errors: Array<SaleorOrderError>;
  /** Completed order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Creates a new draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderCreate = {
  __typename?: 'SaleorDraftOrderCreate';
  errors: Array<SaleorOrderError>;
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorDraftOrderCreateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount for the order. */
  discount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /**
   * External ID of this order.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Variant line input consisting of variant ID and quantity of products. */
  lines?: InputMaybe<Array<SaleorOrderLineCreateInput>>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Event sent when new draft order is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorDraftOrderCreated = SaleorEvent & {
  __typename?: 'SaleorDraftOrderCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderDelete = {
  __typename?: 'SaleorDraftOrderDelete';
  errors: Array<SaleorOrderError>;
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when draft order is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorDraftOrderDeleted = SaleorEvent & {
  __typename?: 'SaleorDraftOrderDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorDraftOrderInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** Discount amount for the order. */
  discount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /**
   * External ID of this order.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Deletes order lines.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderLinesBulkDelete = {
  __typename?: 'SaleorDraftOrderLinesBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Updates a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorDraftOrderUpdate = {
  __typename?: 'SaleorDraftOrderUpdate';
  errors: Array<SaleorOrderError>;
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when draft order is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorDraftOrderUpdated = SaleorEvent & {
  __typename?: 'SaleorDraftOrderUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorErrorPolicyEnum =
  /** Save what is possible within a single row. If there are errors in an input data row, try to save it partially and skip the invalid part. */
  | 'IGNORE_FAILED'
  /** Reject all rows if there is at least one error in any of them. */
  | 'REJECT_EVERYTHING'
  /** Reject rows with errors. */
  | 'REJECT_FAILED_ROWS';

export type SaleorEvent = {
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event delivery. */
export type SaleorEventDelivery = SaleorNode & {
  __typename?: 'SaleorEventDelivery';
  /** Event delivery attempts. */
  attempts?: Maybe<SaleorEventDeliveryAttemptCountableConnection>;
  createdAt: Scalars['SaleorDateTime']['output'];
  /** Webhook event type. */
  eventType: SaleorWebhookEventTypeEnum;
  id: Scalars['ID']['output'];
  /** Event payload. */
  payload?: Maybe<Scalars['String']['output']>;
  /** Event delivery status. */
  status: SaleorEventDeliveryStatusEnum;
};


/** Event delivery. */
export type SaleorEventDeliveryattemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorEventDeliveryAttemptSortingInput>;
};

/** Event delivery attempts. */
export type SaleorEventDeliveryAttempt = SaleorNode & {
  __typename?: 'SaleorEventDeliveryAttempt';
  /** Event delivery creation date and time. */
  createdAt: Scalars['SaleorDateTime']['output'];
  /** Delivery attempt duration. */
  duration?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Request headers for delivery attempt. */
  requestHeaders?: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response content. */
  response?: Maybe<Scalars['String']['output']>;
  /** Response headers for delivery attempt. */
  responseHeaders?: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response status code. */
  responseStatusCode?: Maybe<Scalars['Int']['output']>;
  /** Event delivery status. */
  status: SaleorEventDeliveryStatusEnum;
  /** Task id for delivery attempt. */
  taskId?: Maybe<Scalars['String']['output']>;
};

export type SaleorEventDeliveryAttemptCountableConnection = {
  __typename?: 'SaleorEventDeliveryAttemptCountableConnection';
  edges: Array<SaleorEventDeliveryAttemptCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorEventDeliveryAttemptCountableEdge = {
  __typename?: 'SaleorEventDeliveryAttemptCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorEventDeliveryAttempt;
};

export type SaleorEventDeliveryAttemptSortField =
  /** Sort event delivery attempts by created at. */
  | 'CREATED_AT';

export type SaleorEventDeliveryAttemptSortingInput = {
  /** Specifies the direction in which to sort attempts. */
  direction: SaleorOrderDirection;
  /** Sort attempts by the selected field. */
  field: SaleorEventDeliveryAttemptSortField;
};

export type SaleorEventDeliveryCountableConnection = {
  __typename?: 'SaleorEventDeliveryCountableConnection';
  edges: Array<SaleorEventDeliveryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorEventDeliveryCountableEdge = {
  __typename?: 'SaleorEventDeliveryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorEventDelivery;
};

export type SaleorEventDeliveryFilterInput = {
  eventType?: InputMaybe<SaleorWebhookEventTypeEnum>;
  status?: InputMaybe<SaleorEventDeliveryStatusEnum>;
};

/**
 * Retries event delivery.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorEventDeliveryRetry = {
  __typename?: 'SaleorEventDeliveryRetry';
  /** Event delivery. */
  delivery?: Maybe<SaleorEventDelivery>;
  errors: Array<SaleorWebhookError>;
};

export type SaleorEventDeliverySortField =
  /** Sort event deliveries by created at. */
  | 'CREATED_AT';

export type SaleorEventDeliverySortingInput = {
  /** Specifies the direction in which to sort deliveries. */
  direction: SaleorOrderDirection;
  /** Sort deliveries by the selected field. */
  field: SaleorEventDeliverySortField;
};

export type SaleorEventDeliveryStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

export type SaleorExportError = {
  __typename?: 'SaleorExportError';
  /** The error code. */
  code: SaleorExportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorExportErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** History log of export file. */
export type SaleorExportEvent = SaleorNode & {
  __typename?: 'SaleorExportEvent';
  /** App which performed the action. Requires one of the following permissions: OWNER, MANAGE_APPS. */
  app?: Maybe<SaleorApp>;
  /** Date when event happened at in ISO 8601 format. */
  date: Scalars['SaleorDateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message: Scalars['String']['output'];
  /** Export event type. */
  type: SaleorExportEventsEnum;
  /** User who performed the action. Requires one of the following permissions: OWNER, MANAGE_STAFF. */
  user?: Maybe<SaleorUser>;
};

/** An enumeration. */
export type SaleorExportEventsEnum =
  | 'EXPORTED_FILE_SENT'
  | 'EXPORT_DELETED'
  | 'EXPORT_FAILED'
  | 'EXPORT_FAILED_INFO_SENT'
  | 'EXPORT_PENDING'
  | 'EXPORT_SUCCESS';

/** Represents a job data of exported file. */
export type SaleorExportFile = SaleorJob & SaleorNode & {
  __typename?: 'SaleorExportFile';
  app?: Maybe<SaleorApp>;
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['SaleorDateTime']['output'];
  /** List of events associated with the export. */
  events?: Maybe<Array<SaleorExportEvent>>;
  id: Scalars['ID']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['SaleorDateTime']['output'];
  /** The URL of field to download. */
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<SaleorUser>;
};

export type SaleorExportFileCountableConnection = {
  __typename?: 'SaleorExportFileCountableConnection';
  edges: Array<SaleorExportFileCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorExportFileCountableEdge = {
  __typename?: 'SaleorExportFileCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorExportFile;
};

export type SaleorExportFileFilterInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<SaleorJobStatusEnum>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorExportFileSortField =
  | 'CREATED_AT'
  | 'LAST_MODIFIED_AT'
  | 'STATUS'
  | 'UPDATED_AT';

export type SaleorExportFileSortingInput = {
  /** Specifies the direction in which to sort export file. */
  direction: SaleorOrderDirection;
  /** Sort export file by the selected field. */
  field: SaleorExportFileSortField;
};

/**
 * Export gift cards to csv file.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorExportGiftCards = {
  __typename?: 'SaleorExportGiftCards';
  errors: Array<SaleorExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile?: Maybe<SaleorExportFile>;
};

export type SaleorExportGiftCardsInput = {
  /** Type of exported file. */
  fileType: SaleorFileTypesEnum;
  /** Filtering options for gift cards. */
  filter?: InputMaybe<SaleorGiftCardFilterInput>;
  /** List of gift cards IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which gift cards should be exported. */
  scope: SaleorExportScope;
};

export type SaleorExportInfoInput = {
  /** List of attribute ids witch should be exported. */
  attributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels ids which should be exported. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of product fields witch should be exported. */
  fields?: InputMaybe<Array<SaleorProductFieldEnum>>;
  /** List of warehouse ids witch should be exported. */
  warehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Export products to csv file.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorExportProducts = {
  __typename?: 'SaleorExportProducts';
  errors: Array<SaleorExportError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  exportErrors: Array<SaleorExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile?: Maybe<SaleorExportFile>;
};

export type SaleorExportProductsInput = {
  /** Input with info about fields which should be exported. */
  exportInfo?: InputMaybe<SaleorExportInfoInput>;
  /** Type of exported file. */
  fileType: SaleorFileTypesEnum;
  /** Filtering options for products. */
  filter?: InputMaybe<SaleorProductFilterInput>;
  /** List of products IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which products should be exported. */
  scope: SaleorExportScope;
};

export type SaleorExportScope =
  /** Export all products. */
  | 'ALL'
  /** Export the filtered products. */
  | 'FILTER'
  /** Export products with given ids. */
  | 'IDS';

export type SaleorExternalAuthentication = {
  __typename?: 'SaleorExternalAuthentication';
  /** ID of external authentication plugin. */
  id: Scalars['String']['output'];
  /** Name of external authentication plugin. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Prepare external authentication URL for user by custom plugin. */
export type SaleorExternalAuthenticationUrl = {
  __typename?: 'SaleorExternalAuthenticationUrl';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** The data returned by authentication plugin. */
  authenticationData?: Maybe<Scalars['SaleorJSONString']['output']>;
  errors: Array<SaleorAccountError>;
};

/** Logout user by custom plugin. */
export type SaleorExternalLogout = {
  __typename?: 'SaleorExternalLogout';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** The data returned by authentication plugin. */
  logoutData?: Maybe<Scalars['SaleorJSONString']['output']>;
};

export type SaleorExternalNotificationError = {
  __typename?: 'SaleorExternalNotificationError';
  /** The error code. */
  code: SaleorExternalNotificationErrorCodes;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorExternalNotificationErrorCodes =
  | 'CHANNEL_INACTIVE'
  | 'INVALID_MODEL_TYPE'
  | 'NOT_FOUND'
  | 'REQUIRED';

/**
 * Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload.
 *
 * Added in Saleor 3.1.
 */
export type SaleorExternalNotificationTrigger = {
  __typename?: 'SaleorExternalNotificationTrigger';
  errors: Array<SaleorExternalNotificationError>;
};

export type SaleorExternalNotificationTriggerInput = {
  /** External event type. This field is passed to a plugin as an event type. */
  externalEventType: Scalars['String']['input'];
  /** Additional payload that will be merged with the one based on the bussines object ID. */
  extraPayload?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** The list of customers or orders node IDs that will be serialized and included in the notification payload. */
  ids: Array<Scalars['ID']['input']>;
};

/** Obtain external access tokens for user by custom plugin. */
export type SaleorExternalObtainAccessTokens = {
  __typename?: 'SaleorExternalObtainAccessTokens';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

/** Refresh user's access by custom plugin. */
export type SaleorExternalRefresh = {
  __typename?: 'SaleorExternalRefresh';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

/** Verify external authentication data by plugin. */
export type SaleorExternalVerify = {
  __typename?: 'SaleorExternalVerify';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Determine if authentication data is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** User assigned to data. */
  user?: Maybe<SaleorUser>;
  /** External data. */
  verifyData?: Maybe<Scalars['SaleorJSONString']['output']>;
};

export type SaleorFile = {
  __typename?: 'SaleorFile';
  /** Content type of the file. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The URL of the file. */
  url: Scalars['String']['output'];
};

/** An enumeration. */
export type SaleorFileTypesEnum =
  | 'CSV'
  | 'XLSX';

/**
 * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
 */
export type SaleorFileUpload = {
  __typename?: 'SaleorFileUpload';
  errors: Array<SaleorUploadError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  uploadErrors: Array<SaleorUploadError>;
  uploadedFile?: Maybe<SaleorFile>;
};

/** Represents order fulfillment. */
export type SaleorFulfillment = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorFulfillment';
  created: Scalars['SaleorDateTime']['output'];
  fulfillmentOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** List of lines for the fulfillment. */
  lines?: Maybe<Array<SaleorFulfillmentLine>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  status: SaleorFulfillmentStatus;
  /** User-friendly fulfillment status. */
  statusDisplay?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
  /** Warehouse from fulfillment was fulfilled. */
  warehouse?: Maybe<SaleorWarehouse>;
};


/** Represents order fulfillment. */
export type SaleorFulfillmentmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type SaleorFulfillmentmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order fulfillment. */
export type SaleorFulfillmentprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type SaleorFulfillmentprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Approve existing fulfillment.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentApprove = {
  __typename?: 'SaleorFulfillmentApprove';
  errors: Array<SaleorOrderError>;
  /** An approved fulfillment. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was approved. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when fulfillment is approved.
 *
 * Added in Saleor 3.7.
 */
export type SaleorFulfillmentApproved = SaleorEvent & {
  __typename?: 'SaleorFulfillmentApproved';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Cancels existing fulfillment and optionally restocks items.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentCancel = {
  __typename?: 'SaleorFulfillmentCancel';
  errors: Array<SaleorOrderError>;
  /** A canceled fulfillment. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was cancelled. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorFulfillmentCancelInput = {
  /** ID of a warehouse where items will be restocked. Optional when fulfillment is in WAITING_FOR_APPROVAL state. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Event sent when fulfillment is canceled.
 *
 * Added in Saleor 3.4.
 */
export type SaleorFulfillmentCanceled = SaleorEvent & {
  __typename?: 'SaleorFulfillmentCanceled';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when new fulfillment is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorFulfillmentCreated = SaleorEvent & {
  __typename?: 'SaleorFulfillmentCreated';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents line of the fulfillment. */
export type SaleorFulfillmentLine = SaleorNode & {
  __typename?: 'SaleorFulfillmentLine';
  id: Scalars['ID']['output'];
  orderLine?: Maybe<SaleorOrderLine>;
  quantity: Scalars['Int']['output'];
};

/**
 * Event sent when fulfillment metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorFulfillmentMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorFulfillmentMetadataUpdated';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Refund products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentRefundProducts = {
  __typename?: 'SaleorFulfillmentRefundProducts';
  errors: Array<SaleorOrderError>;
  /** A refunded fulfillment. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Order which fulfillment was refunded. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Return products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentReturnProducts = {
  __typename?: 'SaleorFulfillmentReturnProducts';
  errors: Array<SaleorOrderError>;
  /** Order which fulfillment was returned. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** A replace fulfillment. */
  replaceFulfillment?: Maybe<SaleorFulfillment>;
  /** A draft order which was created for products with replace flag. */
  replaceOrder?: Maybe<SaleorOrder>;
  /** A return fulfillment. */
  returnFulfillment?: Maybe<SaleorFulfillment>;
};

/** An enumeration. */
export type SaleorFulfillmentStatus =
  | 'CANCELED'
  | 'FULFILLED'
  | 'REFUNDED'
  | 'REFUNDED_AND_RETURNED'
  | 'REPLACED'
  | 'RETURNED'
  | 'WAITING_FOR_APPROVAL';

/**
 * Updates a fulfillment for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorFulfillmentUpdateTracking = {
  __typename?: 'SaleorFulfillmentUpdateTracking';
  errors: Array<SaleorOrderError>;
  /** A fulfillment with updated tracking. */
  fulfillment?: Maybe<SaleorFulfillment>;
  /** Order for which fulfillment was updated. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorFulfillmentUpdateTrackingInput = {
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fulfillment tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Payment gateway client configuration key and value pair. */
export type SaleorGatewayConfigLine = {
  __typename?: 'SaleorGatewayConfigLine';
  /** Gateway config key. */
  field: Scalars['String']['output'];
  /** Gateway config value for key. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCard = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorGiftCard';
  /**
   * App which created the gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  app?: Maybe<SaleorApp>;
  /**
   * Slug of the channel where the gift card was bought.
   *
   * Added in Saleor 3.1.
   */
  boughtInChannel?: Maybe<Scalars['String']['output']>;
  /** Gift card code. Can be fetched by a staff member with MANAGE_GIFT_CARD when gift card wasn't yet used and by the gift card owner. */
  code: Scalars['String']['output'];
  created: Scalars['SaleorDateTime']['output'];
  /**
   * The user who bought or issued a gift card.
   *
   * Added in Saleor 3.1.
   */
  createdBy?: Maybe<SaleorUser>;
  /**
   * Email address of the user who bought or issued gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_USERS, OWNER.
   */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  currentBalance: SaleorMoney;
  /** Code in format which allows displaying in a user interface. */
  displayCode: Scalars['String']['output'];
  /**
   * End date of gift card.
   * @deprecated This field will be removed in Saleor 4.0. Use `expiryDate` field instead.
   */
  endDate?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * List of events associated with the gift card.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  events: Array<SaleorGiftCardEvent>;
  expiryDate?: Maybe<Scalars['SaleorDate']['output']>;
  id: Scalars['ID']['output'];
  initialBalance: SaleorMoney;
  isActive: Scalars['Boolean']['output'];
  /** Last 4 characters of gift card code. */
  last4CodeChars: Scalars['String']['output'];
  lastUsedOn?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * Related gift card product.
   *
   * Added in Saleor 3.1.
   */
  product?: Maybe<SaleorProduct>;
  /**
   * Start date of gift card.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  startDate?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * The gift card tag.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  tags: Array<SaleorGiftCardTag>;
  /**
   * The customer who used a gift card.
   *
   * Added in Saleor 3.1.
   */
  usedBy?: Maybe<SaleorUser>;
  /**
   * Email address of the customer who used a gift card.
   *
   * Added in Saleor 3.1.
   */
  usedByEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The customer who bought a gift card.
   * @deprecated This field will be removed in Saleor 4.0. Use `createdBy` field instead.
   */
  user?: Maybe<SaleorUser>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardeventsArgs = {
  filter?: InputMaybe<SaleorGiftCardEventFilterInput>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type SaleorGiftCardprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardActivate = {
  __typename?: 'SaleorGiftCardActivate';
  errors: Array<SaleorGiftCardError>;
  /** Activated gift card. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/**
 * Adds note to the gift card.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardAddNote = {
  __typename?: 'SaleorGiftCardAddNote';
  errors: Array<SaleorGiftCardError>;
  /** Gift card note created. */
  event?: Maybe<SaleorGiftCardEvent>;
  /** Gift card with the note added. */
  giftCard?: Maybe<SaleorGiftCard>;
};

export type SaleorGiftCardAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Activate gift cards.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardBulkActivate = {
  __typename?: 'SaleorGiftCardBulkActivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

/**
 * Create gift cards.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardBulkCreate = {
  __typename?: 'SaleorGiftCardBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
  /** List of created gift cards. */
  giftCards: Array<SaleorGiftCard>;
};

export type SaleorGiftCardBulkCreateInput = {
  /** Balance of the gift card. */
  balance: SaleorPriceInput;
  /** The number of cards to issue. */
  count: Scalars['Int']['input'];
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** Determine if gift card is active. */
  isActive: Scalars['Boolean']['input'];
  /** The gift card tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deactivate gift cards.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardBulkDeactivate = {
  __typename?: 'SaleorGiftCardBulkDeactivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

/**
 * Delete gift cards.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardBulkDelete = {
  __typename?: 'SaleorGiftCardBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardCountableConnection = {
  __typename?: 'SaleorGiftCardCountableConnection';
  edges: Array<SaleorGiftCardCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorGiftCardCountableEdge = {
  __typename?: 'SaleorGiftCardCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGiftCard;
};

/**
 * Creates a new gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardCreate = {
  __typename?: 'SaleorGiftCardCreate';
  errors: Array<SaleorGiftCardError>;
  giftCard?: Maybe<SaleorGiftCard>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardCreateInput = {
  /**
   * The gift card tags to add.
   *
   * Added in Saleor 3.1.
   */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Balance of the gift card. */
  balance: SaleorPriceInput;
  /**
   * Slug of a channel from which the email should be sent.
   *
   * Added in Saleor 3.1.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Code to use the gift card.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. The code is now auto generated.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * The gift card expiry date.
   *
   * Added in Saleor 3.1.
   */
  expiryDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * Determine if gift card is active.
   *
   * Added in Saleor 3.1.
   */
  isActive: Scalars['Boolean']['input'];
  /**
   * The gift card note from the staff member.
   *
   * Added in Saleor 3.1.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  startDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** Email of the customer to whom gift card will be sent. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new gift card is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorGiftCardCreated = SaleorEvent & {
  __typename?: 'SaleorGiftCardCreated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardDeactivate = {
  __typename?: 'SaleorGiftCardDeactivate';
  errors: Array<SaleorGiftCardError>;
  /** Deactivated gift card. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/**
 * Delete gift card.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardDelete = {
  __typename?: 'SaleorGiftCardDelete';
  errors: Array<SaleorGiftCardError>;
  giftCard?: Maybe<SaleorGiftCard>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

/**
 * Event sent when gift card is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorGiftCardDeleted = SaleorEvent & {
  __typename?: 'SaleorGiftCardDeleted';
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorGiftCardError = {
  __typename?: 'SaleorGiftCardError';
  /** The error code. */
  code: SaleorGiftCardErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of tag values that cause the error. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

/** An enumeration. */
export type SaleorGiftCardErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'EXPIRED_GIFT_CARD'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/**
 * History log of the gift card.
 *
 * Added in Saleor 3.1.
 */
export type SaleorGiftCardEvent = SaleorNode & {
  __typename?: 'SaleorGiftCardEvent';
  /** App that performed the action. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  app?: Maybe<SaleorApp>;
  /** The gift card balance. */
  balance?: Maybe<SaleorGiftCardEventBalance>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** Email of the customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** The gift card expiry date. */
  expiryDate?: Maybe<Scalars['SaleorDate']['output']>;
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** Previous gift card expiry date. */
  oldExpiryDate?: Maybe<Scalars['SaleorDate']['output']>;
  /** The list of old gift card tags. */
  oldTags?: Maybe<Array<Scalars['String']['output']>>;
  /** The order ID where gift card was used or bought. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** User-friendly number of an order where gift card was used or bought. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The list of gift card tags. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Gift card event type. */
  type?: Maybe<SaleorGiftCardEventsEnum>;
  /** User who performed the action. Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user?: Maybe<SaleorUser>;
};

export type SaleorGiftCardEventBalance = {
  __typename?: 'SaleorGiftCardEventBalance';
  /** Current balance of the gift card. */
  currentBalance: SaleorMoney;
  /** Initial balance of the gift card. */
  initialBalance?: Maybe<SaleorMoney>;
  /** Previous current balance of the gift card. */
  oldCurrentBalance?: Maybe<SaleorMoney>;
  /** Previous initial balance of the gift card. */
  oldInitialBalance?: Maybe<SaleorMoney>;
};

export type SaleorGiftCardEventFilterInput = {
  orders?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<SaleorGiftCardEventsEnum>;
};

/** An enumeration. */
export type SaleorGiftCardEventsEnum =
  | 'ACTIVATED'
  | 'BALANCE_RESET'
  | 'BOUGHT'
  | 'DEACTIVATED'
  | 'EXPIRY_DATE_UPDATED'
  | 'ISSUED'
  | 'NOTE_ADDED'
  | 'RESENT'
  | 'SENT_TO_CUSTOMER'
  | 'TAGS_UPDATED'
  | 'UPDATED'
  | 'USED_IN_ORDER';

export type SaleorGiftCardFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currentBalance?: InputMaybe<SaleorPriceRangeInput>;
  initialBalance?: InputMaybe<SaleorPriceRangeInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Event sent when gift card metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorGiftCardMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorGiftCardMetadataUpdated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Resend a gift card.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardResend = {
  __typename?: 'SaleorGiftCardResend';
  errors: Array<SaleorGiftCardError>;
  /** Gift card which has been sent. */
  giftCard?: Maybe<SaleorGiftCard>;
};

export type SaleorGiftCardResendInput = {
  /** Slug of a channel from which the email should be sent. */
  channel: Scalars['String']['input'];
  /** Email to which gift card should be send. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of a gift card to resend. */
  id: Scalars['ID']['input'];
};

/**
 * Event sent when gift card is e-mailed.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorGiftCardSent = SaleorEvent & {
  __typename?: 'SaleorGiftCardSent';
  /** Slug of a channel for which this gift card email was sent. */
  channel?: Maybe<Scalars['String']['output']>;
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** E-mail address to which gift card was sent. */
  sentToEmail?: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Gift card related settings from site settings. */
export type SaleorGiftCardSettings = {
  __typename?: 'SaleorGiftCardSettings';
  /** The gift card expiry period settings. */
  expiryPeriod?: Maybe<SaleorTimePeriod>;
  /** The gift card expiry type settings. */
  expiryType: SaleorGiftCardSettingsExpiryTypeEnum;
};

export type SaleorGiftCardSettingsError = {
  __typename?: 'SaleorGiftCardSettingsError';
  /** The error code. */
  code: SaleorGiftCardSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorGiftCardSettingsErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'REQUIRED';

/** An enumeration. */
export type SaleorGiftCardSettingsExpiryTypeEnum =
  | 'EXPIRY_PERIOD'
  | 'NEVER_EXPIRE';

/**
 * Update gift card settings.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardSettingsUpdate = {
  __typename?: 'SaleorGiftCardSettingsUpdate';
  errors: Array<SaleorGiftCardSettingsError>;
  /** Gift card settings. */
  giftCardSettings?: Maybe<SaleorGiftCardSettings>;
};

export type SaleorGiftCardSettingsUpdateInput = {
  /** Defines gift card expiry period. */
  expiryPeriod?: InputMaybe<SaleorTimePeriodInputType>;
  /** Defines gift card default expiry settings. */
  expiryType?: InputMaybe<SaleorGiftCardSettingsExpiryTypeEnum>;
};

export type SaleorGiftCardSortField =
  /**
   * Sort gift cards by created at.
   *
   * Added in Saleor 3.8.
   */
  | 'CREATED_AT'
  /** Sort gift cards by current balance. */
  | 'CURRENT_BALANCE'
  /** Sort gift cards by product. */
  | 'PRODUCT'
  /** Sort gift cards by used by. */
  | 'USED_BY';

export type SaleorGiftCardSortingInput = {
  /** Specifies the direction in which to sort gift cards. */
  direction: SaleorOrderDirection;
  /** Sort gift cards by the selected field. */
  field: SaleorGiftCardSortField;
};

/**
 * Event sent when gift card status has changed.
 *
 * Added in Saleor 3.2.
 */
export type SaleorGiftCardStatusChanged = SaleorEvent & {
  __typename?: 'SaleorGiftCardStatusChanged';
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * The gift card tag.
 *
 * Added in Saleor 3.1.
 */
export type SaleorGiftCardTag = SaleorNode & {
  __typename?: 'SaleorGiftCardTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SaleorGiftCardTagCountableConnection = {
  __typename?: 'SaleorGiftCardTagCountableConnection';
  edges: Array<SaleorGiftCardTagCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorGiftCardTagCountableEdge = {
  __typename?: 'SaleorGiftCardTagCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGiftCardTag;
};

export type SaleorGiftCardTagFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type SaleorGiftCardUpdate = {
  __typename?: 'SaleorGiftCardUpdate';
  errors: Array<SaleorGiftCardError>;
  giftCard?: Maybe<SaleorGiftCard>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  giftCardErrors: Array<SaleorGiftCardError>;
};

export type SaleorGiftCardUpdateInput = {
  /**
   * The gift card tags to add.
   *
   * Added in Saleor 3.1.
   */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The gift card balance amount.
   *
   * Added in Saleor 3.1.
   */
  balanceAmount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * The gift card expiry date.
   *
   * Added in Saleor 3.1.
   */
  expiryDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * The gift card tags to remove.
   *
   * Added in Saleor 3.1.
   */
  removeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  startDate?: InputMaybe<Scalars['SaleorDate']['input']>;
};

/**
 * Event sent when gift card is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorGiftCardUpdated = SaleorEvent & {
  __typename?: 'SaleorGiftCardUpdated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<SaleorGiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents permission group data. */
export type SaleorGroup = SaleorNode & {
  __typename?: 'SaleorGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** List of group permissions */
  permissions?: Maybe<Array<SaleorPermission>>;
  /** True, if the currently authenticated user has rights to manage a group. */
  userCanManage: Scalars['Boolean']['output'];
  /**
   * List of group users
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  users?: Maybe<Array<SaleorUser>>;
};

export type SaleorGroupCountableConnection = {
  __typename?: 'SaleorGroupCountableConnection';
  edges: Array<SaleorGroupCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorGroupCountableEdge = {
  __typename?: 'SaleorGroupCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorGroup;
};

/** Represents an image. */
export type SaleorImage = {
  __typename?: 'SaleorImage';
  /** Alt text for an image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The URL of the image. */
  url: Scalars['String']['output'];
};

export type SaleorIntRangeInput = {
  /** Value greater than or equal to. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Value less than or equal to. */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Invoice. */
export type SaleorInvoice = SaleorJob & SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorInvoice';
  createdAt: Scalars['SaleorDateTime']['output'];
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  /**
   * Order related to the invoice.
   *
   * Added in Saleor 3.10.
   */
  order?: Maybe<SaleorOrder>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  updatedAt: Scalars['SaleorDateTime']['output'];
  /** URL to download an invoice. */
  url?: Maybe<Scalars['String']['output']>;
};


/** Represents an Invoice. */
export type SaleorInvoicemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type SaleorInvoicemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an Invoice. */
export type SaleorInvoiceprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type SaleorInvoiceprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates a ready to send invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceCreate = {
  __typename?: 'SaleorInvoiceCreate';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

export type SaleorInvoiceCreateInput = {
  /** Invoice number. */
  number: Scalars['String']['input'];
  /** URL of an invoice to download. */
  url: Scalars['String']['input'];
};

/**
 * Deletes an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceDelete = {
  __typename?: 'SaleorInvoiceDelete';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/**
 * Event sent when invoice is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorInvoiceDeleted = SaleorEvent & {
  __typename?: 'SaleorInvoiceDeleted';
  /** The invoice the event relates to. */
  invoice?: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /**
   * Order related to the invoice.
   *
   * Added in Saleor 3.10.
   */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorInvoiceError = {
  __typename?: 'SaleorInvoiceError';
  /** The error code. */
  code: SaleorInvoiceErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorInvoiceErrorCode =
  | 'EMAIL_NOT_SET'
  | 'INVALID_STATUS'
  | 'NOT_FOUND'
  | 'NOT_READY'
  | 'NO_INVOICE_PLUGIN'
  | 'NUMBER_NOT_SET'
  | 'REQUIRED'
  | 'URL_NOT_SET';

/**
 * Request an invoice for the order using plugin.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceRequest = {
  __typename?: 'SaleorInvoiceRequest';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
  /** Order related to an invoice. */
  order?: Maybe<SaleorOrder>;
};

/**
 * Requests deletion of an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceRequestDelete = {
  __typename?: 'SaleorInvoiceRequestDelete';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/**
 * Event sent when invoice is requested.
 *
 * Added in Saleor 3.2.
 */
export type SaleorInvoiceRequested = SaleorEvent & {
  __typename?: 'SaleorInvoiceRequested';
  /** The invoice the event relates to. */
  invoice?: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /**
   * Order related to the invoice.
   *
   * Added in Saleor 3.10.
   */
  order: SaleorOrder;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Send an invoice notification to the customer.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceSendNotification = {
  __typename?: 'SaleorInvoiceSendNotification';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

/**
 * Event sent when invoice is sent.
 *
 * Added in Saleor 3.2.
 */
export type SaleorInvoiceSent = SaleorEvent & {
  __typename?: 'SaleorInvoiceSent';
  /** The invoice the event relates to. */
  invoice?: Maybe<SaleorInvoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /**
   * Order related to the invoice.
   *
   * Added in Saleor 3.10.
   */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorInvoiceUpdate = {
  __typename?: 'SaleorInvoiceUpdate';
  errors: Array<SaleorInvoiceError>;
  invoice?: Maybe<SaleorInvoice>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  invoiceErrors: Array<SaleorInvoiceError>;
};

export type SaleorIssuingPrincipal = SaleorApp | SaleorUser;

export type SaleorJob = {
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['SaleorDateTime']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: SaleorJobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['SaleorDateTime']['output'];
};

/** An enumeration. */
export type SaleorJobStatusEnum =
  | 'DELETED'
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

/** An enumeration. */
export type SaleorLanguageCodeEnum =
  | 'AF'
  | 'AF_NA'
  | 'AF_ZA'
  | 'AGQ'
  | 'AGQ_CM'
  | 'AK'
  | 'AK_GH'
  | 'AM'
  | 'AM_ET'
  | 'AR'
  | 'AR_AE'
  | 'AR_BH'
  | 'AR_DJ'
  | 'AR_DZ'
  | 'AR_EG'
  | 'AR_EH'
  | 'AR_ER'
  | 'AR_IL'
  | 'AR_IQ'
  | 'AR_JO'
  | 'AR_KM'
  | 'AR_KW'
  | 'AR_LB'
  | 'AR_LY'
  | 'AR_MA'
  | 'AR_MR'
  | 'AR_OM'
  | 'AR_PS'
  | 'AR_QA'
  | 'AR_SA'
  | 'AR_SD'
  | 'AR_SO'
  | 'AR_SS'
  | 'AR_SY'
  | 'AR_TD'
  | 'AR_TN'
  | 'AR_YE'
  | 'AS'
  | 'ASA'
  | 'ASA_TZ'
  | 'AST'
  | 'AST_ES'
  | 'AS_IN'
  | 'AZ'
  | 'AZ_CYRL'
  | 'AZ_CYRL_AZ'
  | 'AZ_LATN'
  | 'AZ_LATN_AZ'
  | 'BAS'
  | 'BAS_CM'
  | 'BE'
  | 'BEM'
  | 'BEM_ZM'
  | 'BEZ'
  | 'BEZ_TZ'
  | 'BE_BY'
  | 'BG'
  | 'BG_BG'
  | 'BM'
  | 'BM_ML'
  | 'BN'
  | 'BN_BD'
  | 'BN_IN'
  | 'BO'
  | 'BO_CN'
  | 'BO_IN'
  | 'BR'
  | 'BRX'
  | 'BRX_IN'
  | 'BR_FR'
  | 'BS'
  | 'BS_CYRL'
  | 'BS_CYRL_BA'
  | 'BS_LATN'
  | 'BS_LATN_BA'
  | 'CA'
  | 'CA_AD'
  | 'CA_ES'
  | 'CA_ES_VALENCIA'
  | 'CA_FR'
  | 'CA_IT'
  | 'CCP'
  | 'CCP_BD'
  | 'CCP_IN'
  | 'CE'
  | 'CEB'
  | 'CEB_PH'
  | 'CE_RU'
  | 'CGG'
  | 'CGG_UG'
  | 'CHR'
  | 'CHR_US'
  | 'CKB'
  | 'CKB_IQ'
  | 'CKB_IR'
  | 'CS'
  | 'CS_CZ'
  | 'CU'
  | 'CU_RU'
  | 'CY'
  | 'CY_GB'
  | 'DA'
  | 'DAV'
  | 'DAV_KE'
  | 'DA_DK'
  | 'DA_GL'
  | 'DE'
  | 'DE_AT'
  | 'DE_BE'
  | 'DE_CH'
  | 'DE_DE'
  | 'DE_IT'
  | 'DE_LI'
  | 'DE_LU'
  | 'DJE'
  | 'DJE_NE'
  | 'DSB'
  | 'DSB_DE'
  | 'DUA'
  | 'DUA_CM'
  | 'DYO'
  | 'DYO_SN'
  | 'DZ'
  | 'DZ_BT'
  | 'EBU'
  | 'EBU_KE'
  | 'EE'
  | 'EE_GH'
  | 'EE_TG'
  | 'EL'
  | 'EL_CY'
  | 'EL_GR'
  | 'EN'
  | 'EN_AE'
  | 'EN_AG'
  | 'EN_AI'
  | 'EN_AS'
  | 'EN_AT'
  | 'EN_AU'
  | 'EN_BB'
  | 'EN_BE'
  | 'EN_BI'
  | 'EN_BM'
  | 'EN_BS'
  | 'EN_BW'
  | 'EN_BZ'
  | 'EN_CA'
  | 'EN_CC'
  | 'EN_CH'
  | 'EN_CK'
  | 'EN_CM'
  | 'EN_CX'
  | 'EN_CY'
  | 'EN_DE'
  | 'EN_DG'
  | 'EN_DK'
  | 'EN_DM'
  | 'EN_ER'
  | 'EN_FI'
  | 'EN_FJ'
  | 'EN_FK'
  | 'EN_FM'
  | 'EN_GB'
  | 'EN_GD'
  | 'EN_GG'
  | 'EN_GH'
  | 'EN_GI'
  | 'EN_GM'
  | 'EN_GU'
  | 'EN_GY'
  | 'EN_HK'
  | 'EN_IE'
  | 'EN_IL'
  | 'EN_IM'
  | 'EN_IN'
  | 'EN_IO'
  | 'EN_JE'
  | 'EN_JM'
  | 'EN_KE'
  | 'EN_KI'
  | 'EN_KN'
  | 'EN_KY'
  | 'EN_LC'
  | 'EN_LR'
  | 'EN_LS'
  | 'EN_MG'
  | 'EN_MH'
  | 'EN_MO'
  | 'EN_MP'
  | 'EN_MS'
  | 'EN_MT'
  | 'EN_MU'
  | 'EN_MW'
  | 'EN_MY'
  | 'EN_NA'
  | 'EN_NF'
  | 'EN_NG'
  | 'EN_NL'
  | 'EN_NR'
  | 'EN_NU'
  | 'EN_NZ'
  | 'EN_PG'
  | 'EN_PH'
  | 'EN_PK'
  | 'EN_PN'
  | 'EN_PR'
  | 'EN_PW'
  | 'EN_RW'
  | 'EN_SB'
  | 'EN_SC'
  | 'EN_SD'
  | 'EN_SE'
  | 'EN_SG'
  | 'EN_SH'
  | 'EN_SI'
  | 'EN_SL'
  | 'EN_SS'
  | 'EN_SX'
  | 'EN_SZ'
  | 'EN_TC'
  | 'EN_TK'
  | 'EN_TO'
  | 'EN_TT'
  | 'EN_TV'
  | 'EN_TZ'
  | 'EN_UG'
  | 'EN_UM'
  | 'EN_US'
  | 'EN_VC'
  | 'EN_VG'
  | 'EN_VI'
  | 'EN_VU'
  | 'EN_WS'
  | 'EN_ZA'
  | 'EN_ZM'
  | 'EN_ZW'
  | 'EO'
  | 'ES'
  | 'ES_AR'
  | 'ES_BO'
  | 'ES_BR'
  | 'ES_BZ'
  | 'ES_CL'
  | 'ES_CO'
  | 'ES_CR'
  | 'ES_CU'
  | 'ES_DO'
  | 'ES_EA'
  | 'ES_EC'
  | 'ES_ES'
  | 'ES_GQ'
  | 'ES_GT'
  | 'ES_HN'
  | 'ES_IC'
  | 'ES_MX'
  | 'ES_NI'
  | 'ES_PA'
  | 'ES_PE'
  | 'ES_PH'
  | 'ES_PR'
  | 'ES_PY'
  | 'ES_SV'
  | 'ES_US'
  | 'ES_UY'
  | 'ES_VE'
  | 'ET'
  | 'ET_EE'
  | 'EU'
  | 'EU_ES'
  | 'EWO'
  | 'EWO_CM'
  | 'FA'
  | 'FA_AF'
  | 'FA_IR'
  | 'FF'
  | 'FF_ADLM'
  | 'FF_ADLM_BF'
  | 'FF_ADLM_CM'
  | 'FF_ADLM_GH'
  | 'FF_ADLM_GM'
  | 'FF_ADLM_GN'
  | 'FF_ADLM_GW'
  | 'FF_ADLM_LR'
  | 'FF_ADLM_MR'
  | 'FF_ADLM_NE'
  | 'FF_ADLM_NG'
  | 'FF_ADLM_SL'
  | 'FF_ADLM_SN'
  | 'FF_LATN'
  | 'FF_LATN_BF'
  | 'FF_LATN_CM'
  | 'FF_LATN_GH'
  | 'FF_LATN_GM'
  | 'FF_LATN_GN'
  | 'FF_LATN_GW'
  | 'FF_LATN_LR'
  | 'FF_LATN_MR'
  | 'FF_LATN_NE'
  | 'FF_LATN_NG'
  | 'FF_LATN_SL'
  | 'FF_LATN_SN'
  | 'FI'
  | 'FIL'
  | 'FIL_PH'
  | 'FI_FI'
  | 'FO'
  | 'FO_DK'
  | 'FO_FO'
  | 'FR'
  | 'FR_BE'
  | 'FR_BF'
  | 'FR_BI'
  | 'FR_BJ'
  | 'FR_BL'
  | 'FR_CA'
  | 'FR_CD'
  | 'FR_CF'
  | 'FR_CG'
  | 'FR_CH'
  | 'FR_CI'
  | 'FR_CM'
  | 'FR_DJ'
  | 'FR_DZ'
  | 'FR_FR'
  | 'FR_GA'
  | 'FR_GF'
  | 'FR_GN'
  | 'FR_GP'
  | 'FR_GQ'
  | 'FR_HT'
  | 'FR_KM'
  | 'FR_LU'
  | 'FR_MA'
  | 'FR_MC'
  | 'FR_MF'
  | 'FR_MG'
  | 'FR_ML'
  | 'FR_MQ'
  | 'FR_MR'
  | 'FR_MU'
  | 'FR_NC'
  | 'FR_NE'
  | 'FR_PF'
  | 'FR_PM'
  | 'FR_RE'
  | 'FR_RW'
  | 'FR_SC'
  | 'FR_SN'
  | 'FR_SY'
  | 'FR_TD'
  | 'FR_TG'
  | 'FR_TN'
  | 'FR_VU'
  | 'FR_WF'
  | 'FR_YT'
  | 'FUR'
  | 'FUR_IT'
  | 'FY'
  | 'FY_NL'
  | 'GA'
  | 'GA_GB'
  | 'GA_IE'
  | 'GD'
  | 'GD_GB'
  | 'GL'
  | 'GL_ES'
  | 'GSW'
  | 'GSW_CH'
  | 'GSW_FR'
  | 'GSW_LI'
  | 'GU'
  | 'GUZ'
  | 'GUZ_KE'
  | 'GU_IN'
  | 'GV'
  | 'GV_IM'
  | 'HA'
  | 'HAW'
  | 'HAW_US'
  | 'HA_GH'
  | 'HA_NE'
  | 'HA_NG'
  | 'HE'
  | 'HE_IL'
  | 'HI'
  | 'HI_IN'
  | 'HR'
  | 'HR_BA'
  | 'HR_HR'
  | 'HSB'
  | 'HSB_DE'
  | 'HU'
  | 'HU_HU'
  | 'HY'
  | 'HY_AM'
  | 'IA'
  | 'ID'
  | 'ID_ID'
  | 'IG'
  | 'IG_NG'
  | 'II'
  | 'II_CN'
  | 'IS'
  | 'IS_IS'
  | 'IT'
  | 'IT_CH'
  | 'IT_IT'
  | 'IT_SM'
  | 'IT_VA'
  | 'JA'
  | 'JA_JP'
  | 'JGO'
  | 'JGO_CM'
  | 'JMC'
  | 'JMC_TZ'
  | 'JV'
  | 'JV_ID'
  | 'KA'
  | 'KAB'
  | 'KAB_DZ'
  | 'KAM'
  | 'KAM_KE'
  | 'KA_GE'
  | 'KDE'
  | 'KDE_TZ'
  | 'KEA'
  | 'KEA_CV'
  | 'KHQ'
  | 'KHQ_ML'
  | 'KI'
  | 'KI_KE'
  | 'KK'
  | 'KKJ'
  | 'KKJ_CM'
  | 'KK_KZ'
  | 'KL'
  | 'KLN'
  | 'KLN_KE'
  | 'KL_GL'
  | 'KM'
  | 'KM_KH'
  | 'KN'
  | 'KN_IN'
  | 'KO'
  | 'KOK'
  | 'KOK_IN'
  | 'KO_KP'
  | 'KO_KR'
  | 'KS'
  | 'KSB'
  | 'KSB_TZ'
  | 'KSF'
  | 'KSF_CM'
  | 'KSH'
  | 'KSH_DE'
  | 'KS_ARAB'
  | 'KS_ARAB_IN'
  | 'KU'
  | 'KU_TR'
  | 'KW'
  | 'KW_GB'
  | 'KY'
  | 'KY_KG'
  | 'LAG'
  | 'LAG_TZ'
  | 'LB'
  | 'LB_LU'
  | 'LG'
  | 'LG_UG'
  | 'LKT'
  | 'LKT_US'
  | 'LN'
  | 'LN_AO'
  | 'LN_CD'
  | 'LN_CF'
  | 'LN_CG'
  | 'LO'
  | 'LO_LA'
  | 'LRC'
  | 'LRC_IQ'
  | 'LRC_IR'
  | 'LT'
  | 'LT_LT'
  | 'LU'
  | 'LUO'
  | 'LUO_KE'
  | 'LUY'
  | 'LUY_KE'
  | 'LU_CD'
  | 'LV'
  | 'LV_LV'
  | 'MAI'
  | 'MAI_IN'
  | 'MAS'
  | 'MAS_KE'
  | 'MAS_TZ'
  | 'MER'
  | 'MER_KE'
  | 'MFE'
  | 'MFE_MU'
  | 'MG'
  | 'MGH'
  | 'MGH_MZ'
  | 'MGO'
  | 'MGO_CM'
  | 'MG_MG'
  | 'MI'
  | 'MI_NZ'
  | 'MK'
  | 'MK_MK'
  | 'ML'
  | 'ML_IN'
  | 'MN'
  | 'MNI'
  | 'MNI_BENG'
  | 'MNI_BENG_IN'
  | 'MN_MN'
  | 'MR'
  | 'MR_IN'
  | 'MS'
  | 'MS_BN'
  | 'MS_ID'
  | 'MS_MY'
  | 'MS_SG'
  | 'MT'
  | 'MT_MT'
  | 'MUA'
  | 'MUA_CM'
  | 'MY'
  | 'MY_MM'
  | 'MZN'
  | 'MZN_IR'
  | 'NAQ'
  | 'NAQ_NA'
  | 'NB'
  | 'NB_NO'
  | 'NB_SJ'
  | 'ND'
  | 'NDS'
  | 'NDS_DE'
  | 'NDS_NL'
  | 'ND_ZW'
  | 'NE'
  | 'NE_IN'
  | 'NE_NP'
  | 'NL'
  | 'NL_AW'
  | 'NL_BE'
  | 'NL_BQ'
  | 'NL_CW'
  | 'NL_NL'
  | 'NL_SR'
  | 'NL_SX'
  | 'NMG'
  | 'NMG_CM'
  | 'NN'
  | 'NNH'
  | 'NNH_CM'
  | 'NN_NO'
  | 'NUS'
  | 'NUS_SS'
  | 'NYN'
  | 'NYN_UG'
  | 'OM'
  | 'OM_ET'
  | 'OM_KE'
  | 'OR'
  | 'OR_IN'
  | 'OS'
  | 'OS_GE'
  | 'OS_RU'
  | 'PA'
  | 'PA_ARAB'
  | 'PA_ARAB_PK'
  | 'PA_GURU'
  | 'PA_GURU_IN'
  | 'PCM'
  | 'PCM_NG'
  | 'PL'
  | 'PL_PL'
  | 'PRG'
  | 'PS'
  | 'PS_AF'
  | 'PS_PK'
  | 'PT'
  | 'PT_AO'
  | 'PT_BR'
  | 'PT_CH'
  | 'PT_CV'
  | 'PT_GQ'
  | 'PT_GW'
  | 'PT_LU'
  | 'PT_MO'
  | 'PT_MZ'
  | 'PT_PT'
  | 'PT_ST'
  | 'PT_TL'
  | 'QU'
  | 'QU_BO'
  | 'QU_EC'
  | 'QU_PE'
  | 'RM'
  | 'RM_CH'
  | 'RN'
  | 'RN_BI'
  | 'RO'
  | 'ROF'
  | 'ROF_TZ'
  | 'RO_MD'
  | 'RO_RO'
  | 'RU'
  | 'RU_BY'
  | 'RU_KG'
  | 'RU_KZ'
  | 'RU_MD'
  | 'RU_RU'
  | 'RU_UA'
  | 'RW'
  | 'RWK'
  | 'RWK_TZ'
  | 'RW_RW'
  | 'SAH'
  | 'SAH_RU'
  | 'SAQ'
  | 'SAQ_KE'
  | 'SAT'
  | 'SAT_OLCK'
  | 'SAT_OLCK_IN'
  | 'SBP'
  | 'SBP_TZ'
  | 'SD'
  | 'SD_ARAB'
  | 'SD_ARAB_PK'
  | 'SD_DEVA'
  | 'SD_DEVA_IN'
  | 'SE'
  | 'SEH'
  | 'SEH_MZ'
  | 'SES'
  | 'SES_ML'
  | 'SE_FI'
  | 'SE_NO'
  | 'SE_SE'
  | 'SG'
  | 'SG_CF'
  | 'SHI'
  | 'SHI_LATN'
  | 'SHI_LATN_MA'
  | 'SHI_TFNG'
  | 'SHI_TFNG_MA'
  | 'SI'
  | 'SI_LK'
  | 'SK'
  | 'SK_SK'
  | 'SL'
  | 'SL_SI'
  | 'SMN'
  | 'SMN_FI'
  | 'SN'
  | 'SN_ZW'
  | 'SO'
  | 'SO_DJ'
  | 'SO_ET'
  | 'SO_KE'
  | 'SO_SO'
  | 'SQ'
  | 'SQ_AL'
  | 'SQ_MK'
  | 'SQ_XK'
  | 'SR'
  | 'SR_CYRL'
  | 'SR_CYRL_BA'
  | 'SR_CYRL_ME'
  | 'SR_CYRL_RS'
  | 'SR_CYRL_XK'
  | 'SR_LATN'
  | 'SR_LATN_BA'
  | 'SR_LATN_ME'
  | 'SR_LATN_RS'
  | 'SR_LATN_XK'
  | 'SU'
  | 'SU_LATN'
  | 'SU_LATN_ID'
  | 'SV'
  | 'SV_AX'
  | 'SV_FI'
  | 'SV_SE'
  | 'SW'
  | 'SW_CD'
  | 'SW_KE'
  | 'SW_TZ'
  | 'SW_UG'
  | 'TA'
  | 'TA_IN'
  | 'TA_LK'
  | 'TA_MY'
  | 'TA_SG'
  | 'TE'
  | 'TEO'
  | 'TEO_KE'
  | 'TEO_UG'
  | 'TE_IN'
  | 'TG'
  | 'TG_TJ'
  | 'TH'
  | 'TH_TH'
  | 'TI'
  | 'TI_ER'
  | 'TI_ET'
  | 'TK'
  | 'TK_TM'
  | 'TO'
  | 'TO_TO'
  | 'TR'
  | 'TR_CY'
  | 'TR_TR'
  | 'TT'
  | 'TT_RU'
  | 'TWQ'
  | 'TWQ_NE'
  | 'TZM'
  | 'TZM_MA'
  | 'UG'
  | 'UG_CN'
  | 'UK'
  | 'UK_UA'
  | 'UR'
  | 'UR_IN'
  | 'UR_PK'
  | 'UZ'
  | 'UZ_ARAB'
  | 'UZ_ARAB_AF'
  | 'UZ_CYRL'
  | 'UZ_CYRL_UZ'
  | 'UZ_LATN'
  | 'UZ_LATN_UZ'
  | 'VAI'
  | 'VAI_LATN'
  | 'VAI_LATN_LR'
  | 'VAI_VAII'
  | 'VAI_VAII_LR'
  | 'VI'
  | 'VI_VN'
  | 'VO'
  | 'VUN'
  | 'VUN_TZ'
  | 'WAE'
  | 'WAE_CH'
  | 'WO'
  | 'WO_SN'
  | 'XH'
  | 'XH_ZA'
  | 'XOG'
  | 'XOG_UG'
  | 'YAV'
  | 'YAV_CM'
  | 'YI'
  | 'YO'
  | 'YO_BJ'
  | 'YO_NG'
  | 'YUE'
  | 'YUE_HANS'
  | 'YUE_HANS_CN'
  | 'YUE_HANT'
  | 'YUE_HANT_HK'
  | 'ZGH'
  | 'ZGH_MA'
  | 'ZH'
  | 'ZH_HANS'
  | 'ZH_HANS_CN'
  | 'ZH_HANS_HK'
  | 'ZH_HANS_MO'
  | 'ZH_HANS_SG'
  | 'ZH_HANT'
  | 'ZH_HANT_HK'
  | 'ZH_HANT_MO'
  | 'ZH_HANT_TW'
  | 'ZU'
  | 'ZU_ZA';

export type SaleorLanguageDisplay = {
  __typename?: 'SaleorLanguageDisplay';
  /** ISO 639 representation of the language name. */
  code: SaleorLanguageCodeEnum;
  /** Full name of the language. */
  language: Scalars['String']['output'];
};

export type SaleorLimitInfo = {
  __typename?: 'SaleorLimitInfo';
  /** Defines the allowed maximum resource usage, null means unlimited. */
  allowedUsage: SaleorLimits;
  /** Defines the current resource usage. */
  currentUsage: SaleorLimits;
};

export type SaleorLimits = {
  __typename?: 'SaleorLimits';
  channels?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<Scalars['Int']['output']>;
  productVariants?: Maybe<Scalars['Int']['output']>;
  staffUsers?: Maybe<Scalars['Int']['output']>;
  warehouses?: Maybe<Scalars['Int']['output']>;
};

/** The manifest definition. */
export type SaleorManifest = {
  __typename?: 'SaleorManifest';
  about?: Maybe<Scalars['String']['output']>;
  appUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The audience that will be included in all JWT tokens for the app.
   *
   * Added in Saleor 3.8.
   */
  audience?: Maybe<Scalars['String']['output']>;
  /**
   * The App's author name.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  author?: Maybe<Scalars['String']['output']>;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated This field will be removed in Saleor 4.0. Use `appUrl` instead.
   */
  configurationUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated This field will be removed in Saleor 4.0. Use `dataPrivacyUrl` instead.
   */
  dataPrivacy?: Maybe<Scalars['String']['output']>;
  dataPrivacyUrl?: Maybe<Scalars['String']['output']>;
  extensions: Array<SaleorAppManifestExtension>;
  homepageUrl?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<SaleorPermission>>;
  /**
   * Determines the app's required Saleor version as semver range.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  requiredSaleorVersion?: Maybe<SaleorAppManifestRequiredSaleorVersion>;
  supportUrl?: Maybe<Scalars['String']['output']>;
  tokenTargetUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
  /**
   * List of the app's webhooks.
   *
   * Added in Saleor 3.5.
   */
  webhooks: Array<SaleorAppManifestWebhook>;
};

export type SaleorMargin = {
  __typename?: 'SaleorMargin';
  start?: Maybe<Scalars['Int']['output']>;
  stop?: Maybe<Scalars['Int']['output']>;
};

/**
 * Determine the mark as paid strategy for the channel.
 *
 *     TRANSACTION_FLOW - new orders marked as paid will receive a
 *     `TransactionItem` object, that will cover the `order.total`.
 *
 *     PAYMENT_FLOW - new orders marked as paid will receive a
 *     `Payment` object, that will cover the `order.total`.
 *
 *
 */
export type SaleorMarkAsPaidStrategyEnum =
  | 'PAYMENT_FLOW'
  | 'TRANSACTION_FLOW';

/** An enumeration. */
export type SaleorMeasurementUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CM'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'FL_OZ'
  | 'FT'
  | 'G'
  | 'INCH'
  | 'KG'
  | 'KM'
  | 'LB'
  | 'LITER'
  | 'M'
  | 'OZ'
  | 'PINT'
  | 'QT'
  | 'SQ_CM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_YD'
  | 'TONNE'
  | 'YD';

export type SaleorMeasurementUnitsEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<SaleorMeasurementUnitsEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<SaleorMeasurementUnitsEnum>>;
};

export type SaleorMediaChoicesSortField =
  /** Sort media by ID. */
  | 'ID';

export type SaleorMediaInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['SaleorUpload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMediaSortingInput = {
  /** Specifies the direction in which to sort media. */
  direction: SaleorOrderDirection;
  /** Sort media by the selected field. */
  field: SaleorMediaChoicesSortField;
};

/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenu = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorMenu';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<SaleorMenuItem>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  slug: Scalars['String']['output'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenumetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenumetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type SaleorMenuprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuBulkDelete = {
  __typename?: 'SaleorMenuBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorMenuError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuCountableConnection = {
  __typename?: 'SaleorMenuCountableConnection';
  edges: Array<SaleorMenuCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorMenuCountableEdge = {
  __typename?: 'SaleorMenuCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorMenu;
};

/**
 * Creates a new Menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuCreate = {
  __typename?: 'SaleorMenuCreate';
  errors: Array<SaleorMenuError>;
  menu?: Maybe<SaleorMenu>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuCreateInput = {
  /** List of menu items. */
  items?: InputMaybe<Array<SaleorMenuItemInput>>;
  /** Name of the menu. */
  name: Scalars['String']['input'];
  /** Slug of the menu. Will be generated if not provided. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new menu is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuCreated = SaleorEvent & {
  __typename?: 'SaleorMenuCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new menu is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuCreatedmenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuDelete = {
  __typename?: 'SaleorMenuDelete';
  errors: Array<SaleorMenuError>;
  menu?: Maybe<SaleorMenu>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/**
 * Event sent when menu is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuDeleted = SaleorEvent & {
  __typename?: 'SaleorMenuDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when menu is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuDeletedmenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuError = {
  __typename?: 'SaleorMenuError';
  /** The error code. */
  code: SaleorMenuErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorMenuErrorCode =
  | 'CANNOT_ASSIGN_NODE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_MENU_ITEM'
  | 'NOT_FOUND'
  | 'NO_MENU_ITEM_PROVIDED'
  | 'REQUIRED'
  | 'TOO_MANY_MENU_ITEMS'
  | 'UNIQUE';

export type SaleorMenuFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorMenuInput = {
  /** Name of the menu. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the menu. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItem = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorMenuItem';
  category?: Maybe<SaleorCategory>;
  children?: Maybe<Array<SaleorMenuItem>>;
  /** A collection associated with this menu item. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collection?: Maybe<SaleorCollection>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  menu: SaleorMenu;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** A page associated with this menu item. Requires one of the following permissions to include unpublished items: MANAGE_PAGES. */
  page?: Maybe<SaleorPage>;
  parent?: Maybe<SaleorMenuItem>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Returns translated menu item fields for the given language code. */
  translation?: Maybe<SaleorMenuItemTranslation>;
  /** URL to the menu item. */
  url?: Maybe<Scalars['String']['output']>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type SaleorMenuItemtranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Deletes menu items.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuItemBulkDelete = {
  __typename?: 'SaleorMenuItemBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorMenuError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuItemCountableConnection = {
  __typename?: 'SaleorMenuItemCountableConnection';
  edges: Array<SaleorMenuItemCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorMenuItemCountableEdge = {
  __typename?: 'SaleorMenuItemCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorMenuItem;
};

/**
 * Creates a new menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuItemCreate = {
  __typename?: 'SaleorMenuItemCreate';
  errors: Array<SaleorMenuError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem?: Maybe<SaleorMenuItem>;
};

export type SaleorMenuItemCreateInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Menu to which item belongs. */
  menu: Scalars['ID']['input'];
  /** Name of the menu item. */
  name: Scalars['String']['input'];
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new menu item is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemCreated = SaleorEvent & {
  __typename?: 'SaleorMenuItemCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new menu item is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemCreatedmenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuItemDelete = {
  __typename?: 'SaleorMenuItemDelete';
  errors: Array<SaleorMenuError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem?: Maybe<SaleorMenuItem>;
};

/**
 * Event sent when menu item is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemDeleted = SaleorEvent & {
  __typename?: 'SaleorMenuItemDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when menu item is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemDeletedmenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the menu item. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Moves items of menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuItemMove = {
  __typename?: 'SaleorMenuItemMove';
  errors: Array<SaleorMenuError>;
  /** Assigned menu to move within. */
  menu?: Maybe<SaleorMenu>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

export type SaleorMenuItemMoveInput = {
  /** The menu item ID to move. */
  itemId: Scalars['ID']['input'];
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorMenuItemSortingInput = {
  /** Specifies the direction in which to sort menu items. */
  direction: SaleorOrderDirection;
  /** Sort menu items by the selected field. */
  field: SaleorMenuItemsSortField;
};

export type SaleorMenuItemTranslatableContent = SaleorNode & {
  __typename?: 'SaleorMenuItemTranslatableContent';
  id: Scalars['ID']['output'];
  /**
   * Represents a single item of the related menu. Can store categories, collection or pages.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  menuItem?: Maybe<SaleorMenuItem>;
  name: Scalars['String']['output'];
  /** Returns translated menu item fields for the given language code. */
  translation?: Maybe<SaleorMenuItemTranslation>;
};


export type SaleorMenuItemTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a menu item.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorMenuItemTranslate = {
  __typename?: 'SaleorMenuItemTranslate';
  errors: Array<SaleorTranslationError>;
  menuItem?: Maybe<SaleorMenuItem>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorMenuItemTranslation = SaleorNode & {
  __typename?: 'SaleorMenuItemTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name: Scalars['String']['output'];
};

/**
 * Updates a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuItemUpdate = {
  __typename?: 'SaleorMenuItemUpdate';
  errors: Array<SaleorMenuError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
  menuItem?: Maybe<SaleorMenuItem>;
};

/**
 * Event sent when menu item is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemUpdated = SaleorEvent & {
  __typename?: 'SaleorMenuItemUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<SaleorMenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when menu item is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuItemUpdatedmenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMenuItemsSortField =
  /** Sort menu items by name. */
  | 'NAME';

export type SaleorMenuSortField =
  /** Sort menus by items count. */
  | 'ITEMS_COUNT'
  /** Sort menus by name. */
  | 'NAME';

export type SaleorMenuSortingInput = {
  /** Specifies the direction in which to sort menus. */
  direction: SaleorOrderDirection;
  /** Sort menus by the selected field. */
  field: SaleorMenuSortField;
};

/**
 * Updates a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 */
export type SaleorMenuUpdate = {
  __typename?: 'SaleorMenuUpdate';
  errors: Array<SaleorMenuError>;
  menu?: Maybe<SaleorMenu>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  menuErrors: Array<SaleorMenuError>;
};

/**
 * Event sent when menu is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuUpdated = SaleorEvent & {
  __typename?: 'SaleorMenuUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<SaleorMenu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when menu is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorMenuUpdatedmenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMetadataError = {
  __typename?: 'SaleorMetadataError';
  /** The error code. */
  code: SaleorMetadataErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorMetadataErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'NOT_UPDATED'
  | 'REQUIRED';

export type SaleorMetadataFilter = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorMetadataInput = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value: Scalars['String']['input'];
};

export type SaleorMetadataItem = {
  __typename?: 'SaleorMetadataItem';
  /** Key of a metadata item. */
  key: Scalars['String']['output'];
  /** Value of a metadata item. */
  value: Scalars['String']['output'];
};

/** Represents amount of money in specific currency. */
export type SaleorMoney = {
  __typename?: 'SaleorMoney';
  /** Amount of money. */
  amount: Scalars['Float']['output'];
  /** Currency code. */
  currency: Scalars['String']['output'];
};

export type SaleorMoneyInput = {
  /** Amount of money. */
  amount: Scalars['SaleorPositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

/** Represents a range of amounts of money. */
export type SaleorMoneyRange = {
  __typename?: 'SaleorMoneyRange';
  /** Lower bound of a price range. */
  start?: Maybe<SaleorMoney>;
  /** Upper bound of a price range. */
  stop?: Maybe<SaleorMoney>;
};

export type SaleorMoveProductInput = {
  /** The ID of the product to move. */
  productId: Scalars['ID']['input'];
  /** The relative sorting position of the product (from -inf to +inf) starting from the first given product's actual position.1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorNameTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorNavigationType =
  /** Main storefront navigation. */
  | 'MAIN'
  /** Secondary storefront navigation. */
  | 'SECONDARY';

/** An object with an ID */
export type SaleorNode = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type SaleorObjectWithMetadata = {
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
};


export type SaleorObjectWithMetadatametafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorObjectWithMetadatametafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SaleorObjectWithMetadataprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type SaleorObjectWithMetadataprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents an order in the shop. */
export type SaleorOrder = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorOrder';
  /** List of actions that can be performed in the current state of an order. */
  actions: Array<SaleorOrderAction>;
  /**
   * The authorize status of the order.
   *
   * Added in Saleor 3.4.
   */
  authorizeStatus: SaleorOrderAuthorizeStatusEnum;
  /**
   * Collection points that can be used for this order.
   *
   * Added in Saleor 3.1.
   */
  availableCollectionPoints: Array<SaleorWarehouse>;
  /**
   * Shipping methods that can be used with this order.
   * @deprecated Use `shippingMethods`, this field will be removed in 4.0
   */
  availableShippingMethods?: Maybe<Array<SaleorShippingMethod>>;
  /** Billing address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  billingAddress?: Maybe<SaleorAddress>;
  /** Informs whether a draft order can be finalized(turned into a regular order). */
  canFinalize: Scalars['Boolean']['output'];
  channel: SaleorChannel;
  /**
   * The charge status of the order.
   *
   * Added in Saleor 3.4.
   */
  chargeStatus: SaleorOrderChargeStatusEnum;
  /**
   * ID of the checkout that the order was created from.
   *
   * Added in Saleor 3.11.
   */
  checkoutId?: Maybe<Scalars['ID']['output']>;
  collectionPointName?: Maybe<Scalars['String']['output']>;
  created: Scalars['SaleorDateTime']['output'];
  customerNote: Scalars['String']['output'];
  /**
   * The delivery method selected for this order.
   *
   * Added in Saleor 3.1.
   */
  deliveryMethod?: Maybe<SaleorDeliveryMethod>;
  /**
   * Returns applied discount.
   * @deprecated This field will be removed in Saleor 4.0. Use the `discounts` field instead.
   */
  discount?: Maybe<SaleorMoney>;
  /**
   * Discount name.
   * @deprecated This field will be removed in Saleor 4.0. Use the `discounts` field instead.
   */
  discountName?: Maybe<Scalars['String']['output']>;
  /** List of all discounts assigned to the order. */
  discounts: Array<SaleorOrderDiscount>;
  /**
   * Determines whether checkout prices should include taxes when displayed in a storefront.
   *
   * Added in Saleor 3.9.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** List of errors that occurred during order validation. */
  errors: Array<SaleorOrderError>;
  /**
   * List of events associated with the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  events: Array<SaleorOrderEvent>;
  /**
   * External ID of this order.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** List of shipments for the order. */
  fulfillments: Array<SaleorFulfillment>;
  /** List of user gift cards. */
  giftCards: Array<SaleorGiftCard>;
  /**
   * List of granted refunds.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  grantedRefunds: Array<SaleorOrderGrantedRefund>;
  id: Scalars['ID']['output'];
  /** List of order invoices. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  invoices: Array<SaleorInvoice>;
  /** Informs if an order is fully paid. */
  isPaid: Scalars['Boolean']['output'];
  /** Returns True, if order requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** @deprecated This field will be removed in Saleor 4.0. Use the `languageCodeEnum` field to fetch the language code.  */
  languageCode: Scalars['String']['output'];
  /** Order language code. */
  languageCodeEnum: SaleorLanguageCodeEnum;
  /** List of order lines. */
  lines: Array<SaleorOrderLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** User-friendly number of an order. */
  number: Scalars['String']['output'];
  /** The order origin. */
  origin: SaleorOrderOriginEnum;
  /** The ID of the order that was the base for this order. */
  original?: Maybe<Scalars['ID']['output']>;
  /** Internal payment status. */
  paymentStatus: SaleorPaymentChargeStatusEnum;
  /** User-friendly payment status. */
  paymentStatusDisplay: Scalars['String']['output'];
  /** List of payments for the order. */
  payments: Array<SaleorPayment>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shipping address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  shippingAddress?: Maybe<SaleorAddress>;
  /**
   * Shipping method for this order.
   * @deprecated This field will be removed in Saleor 4.0. Use `deliveryMethod` instead.
   */
  shippingMethod?: Maybe<SaleorShippingMethod>;
  shippingMethodName?: Maybe<Scalars['String']['output']>;
  /** Shipping methods related to this order. */
  shippingMethods: Array<SaleorShippingMethod>;
  /** Total price of shipping. */
  shippingPrice: SaleorTaxedMoney;
  /**
   * Denormalized tax class assigned to the shipping method.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  shippingTaxClass?: Maybe<SaleorTaxClass>;
  /**
   * Denormalized public metadata of the shipping method's tax class.
   *
   * Added in Saleor 3.9.
   */
  shippingTaxClassMetadata: Array<SaleorMetadataItem>;
  /**
   * Denormalized name of the tax class assigned to the shipping method.
   *
   * Added in Saleor 3.9.
   */
  shippingTaxClassName?: Maybe<Scalars['String']['output']>;
  /**
   * Denormalized private metadata of the shipping method's tax class. Requires staff permissions to access.
   *
   * Added in Saleor 3.9.
   */
  shippingTaxClassPrivateMetadata: Array<SaleorMetadataItem>;
  /** The shipping tax rate value. */
  shippingTaxRate: Scalars['Float']['output'];
  status: SaleorOrderStatus;
  /** User-friendly order status. */
  statusDisplay: Scalars['String']['output'];
  /** The sum of line prices not including shipping. */
  subtotal: SaleorTaxedMoney;
  /**
   * Returns True if order has to be exempt from taxes.
   *
   * Added in Saleor 3.8.
   */
  taxExemption: Scalars['Boolean']['output'];
  /** @deprecated This field will be removed in Saleor 4.0. Use `id` instead. */
  token: Scalars['String']['output'];
  /** Total amount of the order. */
  total: SaleorTaxedMoney;
  /**
   * Total amount of ongoing authorize requests for the order's transactions.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalAuthorizePending: SaleorMoney;
  /** Amount authorized for the order. */
  totalAuthorized: SaleorMoney;
  /** The difference between the paid and the order total amount. */
  totalBalance: SaleorMoney;
  /**
   * Total amount of ongoing cancel requests for the order's transactions.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalCancelPending: SaleorMoney;
  /**
   * Amount canceled for the order.
   *
   * Added in Saleor 3.13.
   */
  totalCanceled: SaleorMoney;
  /**
   * Amount captured for the order.
   * @deprecated This field will be removed in Saleor 4.0. Use `totalCharged` instead.
   */
  totalCaptured: SaleorMoney;
  /**
   * Total amount of ongoing charge requests for the order's transactions.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalChargePending: SaleorMoney;
  /**
   * Amount charged for the order.
   *
   * Added in Saleor 3.13.
   */
  totalCharged: SaleorMoney;
  /**
   * Total amount of granted refund.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalGrantedRefund: SaleorMoney;
  /**
   * Total amount of ongoing refund requests for the order's transactions.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRefundPending: SaleorMoney;
  /**
   * Total refund amount for the order.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  totalRefunded: SaleorMoney;
  /**
   * The difference amount between granted refund and the amounts that are pending and refunded.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRemainingGrant: SaleorMoney;
  trackingClientId: Scalars['String']['output'];
  /**
   * List of transactions for the order. Requires one of the following permissions: MANAGE_ORDERS, HANDLE_PAYMENTS.
   *
   * Added in Saleor 3.4.
   */
  transactions: Array<SaleorTransactionItem>;
  /**
   * Translated discount name.
   * @deprecated This field will be removed in Saleor 4.0. Use the `discounts` field instead.
   */
  translatedDiscountName?: Maybe<Scalars['String']['output']>;
  /** Undiscounted total amount of the order. */
  undiscountedTotal: SaleorTaxedMoney;
  updatedAt: Scalars['SaleorDateTime']['output'];
  /** User who placed the order. This field is set only for orders placed by authenticated users. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_USERS, MANAGE_ORDERS, OWNER. */
  user?: Maybe<SaleorUser>;
  /** Email address of the customer. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  userEmail?: Maybe<Scalars['String']['output']>;
  voucher?: Maybe<SaleorVoucher>;
  weight: SaleorWeight;
};


/** Represents an order in the shop. */
export type SaleorOrdermetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type SaleorOrdermetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an order in the shop. */
export type SaleorOrderprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type SaleorOrderprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorOrderAction =
  /** Represents the capture action. */
  | 'CAPTURE'
  /** Represents a mark-as-paid action. */
  | 'MARK_AS_PAID'
  /** Represents a refund action. */
  | 'REFUND'
  /** Represents a void action. */
  | 'VOID';

/**
 * Adds note to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderAddNote = {
  __typename?: 'SaleorOrderAddNote';
  errors: Array<SaleorOrderError>;
  /** Order note created. */
  event?: Maybe<SaleorOrderEvent>;
  /** Order with the note added. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Determine a current authorize status for order.
 *
 *     We treat the order as fully authorized when the sum of authorized and charged funds
 *     cover the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as partially authorized when the sum of authorized and charged
 *     funds covers only part of the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as not authorized when the sum of authorized and charged funds is
 *     0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the funds that are authorized and charged don't cover fully the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are authorized and charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type SaleorOrderAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

/**
 * Cancels orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderBulkCancel = {
  __typename?: 'SaleorOrderBulkCancel';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorOrderError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Cancel an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderCancel = {
  __typename?: 'SaleorOrderCancel';
  errors: Array<SaleorOrderError>;
  /** Canceled order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when order is canceled.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderCancelled = SaleorEvent & {
  __typename?: 'SaleorOrderCancelled';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Capture an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderCapture = {
  __typename?: 'SaleorOrderCapture';
  errors: Array<SaleorOrderError>;
  /** Captured order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Determine the current charge status for the order.
 *
 *     An order is considered overcharged when the sum of the
 *     transactionItem's charge amounts exceeds the value of
 *     `order.total` - `order.totalGrantedRefund`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `order.total` - `order.totalGrantedRefund`, we consider the order to be fully
 *     charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `order.total` - `order.totalGrantedRefund`, we treat the order as partially charged.
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     OVERCHARGED - the charged funds are bigger than the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type SaleorOrderChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/**
 * Confirms an unconfirmed order by changing status to unfulfilled.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderConfirm = {
  __typename?: 'SaleorOrderConfirm';
  errors: Array<SaleorOrderError>;
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when order is confirmed.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderConfirmed = SaleorEvent & {
  __typename?: 'SaleorOrderConfirmed';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderCountableConnection = {
  __typename?: 'SaleorOrderCountableConnection';
  edges: Array<SaleorOrderCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorOrderCountableEdge = {
  __typename?: 'SaleorOrderCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorOrder;
};

/**
 * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderCreateFromCheckout = {
  __typename?: 'SaleorOrderCreateFromCheckout';
  errors: Array<SaleorOrderCreateFromCheckoutError>;
  /** Placed order. */
  order?: Maybe<SaleorOrder>;
};

export type SaleorOrderCreateFromCheckoutError = {
  __typename?: 'SaleorOrderCreateFromCheckoutError';
  /** The error code. */
  code: SaleorOrderCreateFromCheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorOrderCreateFromCheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FOUND'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID_SHIPPING_METHOD'
  | 'NO_LINES'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'VOUCHER_NOT_APPLICABLE';

/**
 * Event sent when new order is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderCreated = SaleorEvent & {
  __typename?: 'SaleorOrderCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderDirection =
  /** Specifies an ascending sort order. */
  | 'ASC'
  /** Specifies a descending sort order. */
  | 'DESC';

/** Contains all details related to the applied discount to the order. */
export type SaleorOrderDiscount = SaleorNode & {
  __typename?: 'SaleorOrderDiscount';
  /** Returns amount of discount. */
  amount: SaleorMoney;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Explanation for the applied discount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  reason?: Maybe<Scalars['String']['output']>;
  translatedName?: Maybe<Scalars['String']['output']>;
  type: SaleorOrderDiscountType;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['SaleorPositiveDecimal']['output'];
  /** Type of the discount: fixed or percent */
  valueType: SaleorDiscountValueTypeEnum;
};

/**
 * Adds discount to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountAdd = {
  __typename?: 'SaleorOrderDiscountAdd';
  errors: Array<SaleorOrderError>;
  /** Order which has been discounted. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderDiscountCommonInput = {
  /** Explanation for the applied discount. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['SaleorPositiveDecimal']['input'];
  /** Type of the discount: fixed or percent */
  valueType: SaleorDiscountValueTypeEnum;
};

/**
 * Remove discount from the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountDelete = {
  __typename?: 'SaleorOrderDiscountDelete';
  errors: Array<SaleorOrderError>;
  /** Order which has removed discount. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** An enumeration. */
export type SaleorOrderDiscountType =
  | 'MANUAL'
  | 'VOUCHER';

/**
 * Update discount for the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderDiscountUpdate = {
  __typename?: 'SaleorOrderDiscountUpdate';
  errors: Array<SaleorOrderError>;
  /** Order which has been discounted. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderDraftFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderError = {
  __typename?: 'SaleorOrderError';
  /** A type of address that causes the error. */
  addressType?: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorOrderErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of order line IDs that cause the error. */
  orderLines?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of product variants that are associated with the error */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
  /** Warehouse ID which causes the error. */
  warehouse?: Maybe<Scalars['ID']['output']>;
};

/** An enumeration. */
export type SaleorOrderErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CANNOT_CANCEL_FULFILLMENT'
  | 'CANNOT_CANCEL_ORDER'
  | 'CANNOT_DELETE'
  | 'CANNOT_DISCOUNT'
  | 'CANNOT_FULFILL_UNPAID_ORDER'
  | 'CANNOT_REFUND'
  | 'CAPTURE_INACTIVE_PAYMENT'
  | 'CHANNEL_INACTIVE'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FULFILL_ORDER_LINE'
  | 'GIFT_CARD_LINE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_QUANTITY'
  | 'NOT_AVAILABLE_IN_CHANNEL'
  | 'NOT_EDITABLE'
  | 'NOT_FOUND'
  | 'ORDER_NO_SHIPPING_ADDRESS'
  | 'PAYMENT_ERROR'
  | 'PAYMENT_MISSING'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'REQUIRED'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_REQUIRED'
  | 'TAX_ERROR'
  | 'TRANSACTION_ERROR'
  | 'UNIQUE'
  | 'VOID_INACTIVE_PAYMENT'
  | 'ZERO_QUANTITY';

/** History log of the order. */
export type SaleorOrderEvent = SaleorNode & {
  __typename?: 'SaleorOrderEvent';
  /** Amount of money. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** App that performed the action. Requires of of the following permissions: MANAGE_APPS, MANAGE_ORDERS, OWNER. */
  app?: Maybe<SaleorApp>;
  /** Composed ID of the Fulfillment. */
  composedId?: Maybe<Scalars['String']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The discount applied to the order. */
  discount?: Maybe<SaleorOrderEventDiscountObject>;
  /** Email of the customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** Type of an email sent to the customer. */
  emailType?: Maybe<SaleorOrderEventsEmailsEnum>;
  /** The lines fulfilled. */
  fulfilledItems?: Maybe<Array<SaleorFulfillmentLine>>;
  id: Scalars['ID']['output'];
  /** Number of an invoice related to the order. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The concerned lines. */
  lines?: Maybe<Array<SaleorOrderEventOrderLineObject>>;
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** User-friendly number of an order. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** List of oversold lines names. */
  oversoldItems?: Maybe<Array<Scalars['String']['output']>>;
  /** The payment gateway of the payment. */
  paymentGateway?: Maybe<Scalars['String']['output']>;
  /** The payment reference from the payment provider. */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The reference of payment's transaction. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The order which is related to this order. */
  relatedOrder?: Maybe<SaleorOrder>;
  /** Define if shipping costs were included to the refund. */
  shippingCostsIncluded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The status of payment's transaction.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature).Use `TransactionEvent` to track the status of `TransactionItem`.
   */
  status?: Maybe<SaleorTransactionStatus>;
  /** The transaction reference of captured payment. */
  transactionReference?: Maybe<Scalars['String']['output']>;
  /** Order event type. */
  type?: Maybe<SaleorOrderEventsEnum>;
  /** User who performed the action. */
  user?: Maybe<SaleorUser>;
  /** The warehouse were items were restocked. */
  warehouse?: Maybe<SaleorWarehouse>;
};

export type SaleorOrderEventCountableConnection = {
  __typename?: 'SaleorOrderEventCountableConnection';
  edges: Array<SaleorOrderEventCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorOrderEventCountableEdge = {
  __typename?: 'SaleorOrderEventCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorOrderEvent;
};

export type SaleorOrderEventDiscountObject = {
  __typename?: 'SaleorOrderEventDiscountObject';
  /** Returns amount of discount. */
  amount?: Maybe<SaleorMoney>;
  /** Returns amount of discount. */
  oldAmount?: Maybe<SaleorMoney>;
  /** Value of the discount. Can store fixed value or percent value. */
  oldValue?: Maybe<Scalars['SaleorPositiveDecimal']['output']>;
  /** Type of the discount: fixed or percent. */
  oldValueType?: Maybe<SaleorDiscountValueTypeEnum>;
  /** Explanation for the applied discount. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Value of the discount. Can store fixed value or percent value. */
  value: Scalars['SaleorPositiveDecimal']['output'];
  /** Type of the discount: fixed or percent. */
  valueType: SaleorDiscountValueTypeEnum;
};

export type SaleorOrderEventOrderLineObject = {
  __typename?: 'SaleorOrderEventOrderLineObject';
  /** The discount applied to the order line. */
  discount?: Maybe<SaleorOrderEventDiscountObject>;
  /** The variant name. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** The order line. */
  orderLine?: Maybe<SaleorOrderLine>;
  /** The variant quantity. */
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export type SaleorOrderEventsEmailsEnum =
  | 'CONFIRMED'
  | 'DIGITAL_LINKS'
  | 'FULFILLMENT_CONFIRMATION'
  | 'ORDER_CANCEL'
  | 'ORDER_CONFIRMATION'
  | 'ORDER_REFUND'
  | 'PAYMENT_CONFIRMATION'
  | 'SHIPPING_CONFIRMATION'
  | 'TRACKING_UPDATED';

/** The different order event types.  */
export type SaleorOrderEventsEnum =
  | 'ADDED_PRODUCTS'
  | 'CANCELED'
  | 'CONFIRMED'
  | 'DRAFT_CREATED'
  | 'DRAFT_CREATED_FROM_REPLACE'
  | 'EMAIL_SENT'
  | 'EXPIRED'
  | 'EXTERNAL_SERVICE_NOTIFICATION'
  | 'FULFILLMENT_AWAITS_APPROVAL'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_FULFILLED_ITEMS'
  | 'FULFILLMENT_REFUNDED'
  | 'FULFILLMENT_REPLACED'
  | 'FULFILLMENT_RESTOCKED_ITEMS'
  | 'FULFILLMENT_RETURNED'
  | 'INVOICE_GENERATED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'INVOICE_UPDATED'
  | 'NOTE_ADDED'
  | 'ORDER_DISCOUNT_ADDED'
  | 'ORDER_DISCOUNT_AUTOMATICALLY_UPDATED'
  | 'ORDER_DISCOUNT_DELETED'
  | 'ORDER_DISCOUNT_UPDATED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_LINE_DISCOUNT_REMOVED'
  | 'ORDER_LINE_DISCOUNT_UPDATED'
  | 'ORDER_LINE_PRODUCT_DELETED'
  | 'ORDER_LINE_VARIANT_DELETED'
  | 'ORDER_MARKED_AS_PAID'
  | 'ORDER_REPLACEMENT_CREATED'
  | 'OTHER'
  | 'OVERSOLD_ITEMS'
  | 'PAYMENT_AUTHORIZED'
  | 'PAYMENT_CAPTURED'
  | 'PAYMENT_FAILED'
  | 'PAYMENT_REFUNDED'
  | 'PAYMENT_VOIDED'
  | 'PLACED'
  | 'PLACED_FROM_DRAFT'
  | 'REMOVED_PRODUCTS'
  | 'TRACKING_UPDATED'
  | 'TRANSACTION_CANCEL_REQUESTED'
  /** This field will be removed in Saleor 3.14 (Preview Feature). Use `TRANSACTION_CHARGE_REQUESTED` instead. */
  | 'TRANSACTION_CAPTURE_REQUESTED'
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_EVENT'
  | 'TRANSACTION_MARK_AS_PAID_FAILED'
  | 'TRANSACTION_REFUND_REQUESTED'
  /** This field will be removed in Saleor 3.14 (Preview Feature). Use `TRANSACTION_CANCEL_REQUESTED` instead. */
  | 'TRANSACTION_VOID_REQUESTED'
  | 'UPDATED_ADDRESS';

/**
 * Event sent when order becomes expired.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorOrderExpired = SaleorEvent & {
  __typename?: 'SaleorOrderExpired';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderFilterInput = {
  authorizeStatus?: InputMaybe<Array<SaleorOrderAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<SaleorOrderChargeStatusEnum>>;
  checkoutIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  created?: InputMaybe<SaleorDateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  giftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentStatus?: InputMaybe<Array<SaleorPaymentChargeStatusEnum>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SaleorOrderStatusFilter>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

/**
 * Filter shipping methods for order.
 *
 * Added in Saleor 3.6.
 */
export type SaleorOrderFilterShippingMethods = SaleorEvent & {
  __typename?: 'SaleorOrderFilterShippingMethods';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Added in Saleor 3.6.
   */
  shippingMethods?: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates new fulfillments for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderFulfill = {
  __typename?: 'SaleorOrderFulfill';
  errors: Array<SaleorOrderError>;
  /** List of created fulfillments. */
  fulfillments?: Maybe<Array<SaleorFulfillment>>;
  /** Fulfilled order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderFulfillInput = {
  /** If true, then allow proceed fulfillment when stock is exceeded. */
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of items informing how to fulfill the order. */
  lines: Array<SaleorOrderFulfillLineInput>;
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fulfillment tracking number.
   *
   * Added in Saleor 3.6.
   */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorOrderFulfillLineInput = {
  /** The ID of the order line. */
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  /** List of stock items to create. */
  stocks: Array<SaleorOrderFulfillStockInput>;
};

export type SaleorOrderFulfillStockInput = {
  /** The number of line items to be fulfilled from given warehouse. */
  quantity: Scalars['Int']['input'];
  /** ID of the warehouse from which the item will be fulfilled. */
  warehouse: Scalars['ID']['input'];
};

/**
 * Event sent when order is fulfilled.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderFulfilled = SaleorEvent & {
  __typename?: 'SaleorOrderFulfilled';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when order is fully paid.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderFullyPaid = SaleorEvent & {
  __typename?: 'SaleorOrderFullyPaid';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Adds granted refund to the order.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderGrantRefundCreate = {
  __typename?: 'SaleorOrderGrantRefundCreate';
  errors: Array<SaleorOrderGrantRefundCreateError>;
  /** Created granted refund. */
  grantedRefund?: Maybe<SaleorOrderGrantedRefund>;
  /** Order which has assigned new grant refund. */
  order?: Maybe<SaleorOrder>;
};

export type SaleorOrderGrantRefundCreateError = {
  __typename?: 'SaleorOrderGrantRefundCreateError';
  /** The error code. */
  code: SaleorOrderGrantRefundCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorOrderGrantRefundCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND';

export type SaleorOrderGrantRefundCreateInput = {
  /** Amount of the granted refund. */
  amount: Scalars['SaleorDecimal']['input'];
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates granted refund.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderGrantRefundUpdate = {
  __typename?: 'SaleorOrderGrantRefundUpdate';
  errors: Array<SaleorOrderGrantRefundUpdateError>;
  /** Created granted refund. */
  grantedRefund?: Maybe<SaleorOrderGrantedRefund>;
  /** Order which has assigned updated grant refund. */
  order?: Maybe<SaleorOrder>;
  orderGrantedRefund?: Maybe<SaleorOrderGrantedRefund>;
};

export type SaleorOrderGrantRefundUpdateError = {
  __typename?: 'SaleorOrderGrantRefundUpdateError';
  /** The error code. */
  code: SaleorOrderGrantRefundUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorOrderGrantRefundUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorOrderGrantRefundUpdateInput = {
  /** Amount of the granted refund. */
  amount?: InputMaybe<Scalars['SaleorDecimal']['input']>;
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The details of granted refund.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorOrderGrantedRefund = {
  __typename?: 'SaleorOrderGrantedRefund';
  /** Refund amount. */
  amount: SaleorMoney;
  /** App that performed the action. */
  app?: Maybe<SaleorApp>;
  /** Time of creation. */
  createdAt: Scalars['SaleorDateTime']['output'];
  id: Scalars['ID']['output'];
  /** Reason of the refund. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Time of last update. */
  updatedAt: Scalars['SaleorDateTime']['output'];
  /** User who performed the action. Requires of of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user?: Maybe<SaleorUser>;
};

/** Represents order line of particular order. */
export type SaleorOrderLine = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorOrderLine';
  /**
   * List of allocations across warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  allocations?: Maybe<Array<SaleorAllocation>>;
  digitalContentUrl?: Maybe<SaleorDigitalContentUrl>;
  id: Scalars['ID']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  /**
   * List of public metadata items. Can be accessed without permissions.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * List of private metadata items. Requires staff permissions to access.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.5.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  productName: Scalars['String']['output'];
  productSku?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  quantityFulfilled: Scalars['Int']['output'];
  /**
   * A quantity of items remaining to be fulfilled.
   *
   * Added in Saleor 3.1.
   */
  quantityToFulfill: Scalars['Int']['output'];
  /**
   * Denormalized tax class of the product in this order line.
   *
   * Added in Saleor 3.9.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<SaleorTaxClass>;
  /**
   * Denormalized public metadata of the tax class.
   *
   * Added in Saleor 3.9.
   */
  taxClassMetadata: Array<SaleorMetadataItem>;
  /**
   * Denormalized name of the tax class.
   *
   * Added in Saleor 3.9.
   */
  taxClassName?: Maybe<Scalars['String']['output']>;
  /**
   * Denormalized private metadata of the tax class. Requires staff permissions to access.
   *
   * Added in Saleor 3.9.
   */
  taxClassPrivateMetadata: Array<SaleorMetadataItem>;
  taxRate: Scalars['Float']['output'];
  thumbnail?: Maybe<SaleorImage>;
  /** Price of the order line. */
  totalPrice: SaleorTaxedMoney;
  /** Product name in the customer's language */
  translatedProductName: Scalars['String']['output'];
  /** Variant name in the customer's language */
  translatedVariantName: Scalars['String']['output'];
  /** Price of the single item in the order line without applied an order line discount. */
  undiscountedUnitPrice: SaleorTaxedMoney;
  /** The discount applied to the single order line. */
  unitDiscount: SaleorMoney;
  unitDiscountReason?: Maybe<Scalars['String']['output']>;
  /** Type of the discount: fixed or percent */
  unitDiscountType?: Maybe<SaleorDiscountValueTypeEnum>;
  /** Value of the discount. Can store fixed value or percent value */
  unitDiscountValue: Scalars['SaleorPositiveDecimal']['output'];
  /** Price of the single item in the order line. */
  unitPrice: SaleorTaxedMoney;
  /** A purchased product variant. Note: this field may be null if the variant has been removed from stock at all. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  variant?: Maybe<SaleorProductVariant>;
  variantName: Scalars['String']['output'];
};


/** Represents order line of particular order. */
export type SaleorOrderLinemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type SaleorOrderLinemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type SaleorOrderLineprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type SaleorOrderLineprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type SaleorOrderLinethumbnailArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorOrderLineCreateInput = {
  /**
   * Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.
   *
   * Added in Saleor 3.6.
   */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
  /** Product variant ID. */
  variantId: Scalars['ID']['input'];
};

/**
 * Deletes an order line from an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDelete = {
  __typename?: 'SaleorOrderLineDelete';
  errors: Array<SaleorOrderError>;
  /** A related order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** An order line that was deleted. */
  orderLine?: Maybe<SaleorOrderLine>;
};

/**
 * Remove discount applied to the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDiscountRemove = {
  __typename?: 'SaleorOrderLineDiscountRemove';
  errors: Array<SaleorOrderError>;
  /** Order which is related to line which has removed discount. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** Order line which has removed discount. */
  orderLine?: Maybe<SaleorOrderLine>;
};

/**
 * Update discount for the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineDiscountUpdate = {
  __typename?: 'SaleorOrderLineDiscountUpdate';
  errors: Array<SaleorOrderError>;
  /** Order which is related to the discounted line. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** Order line which has been discounted. */
  orderLine?: Maybe<SaleorOrderLine>;
};

export type SaleorOrderLineInput = {
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
};

/**
 * Updates an order line of an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLineUpdate = {
  __typename?: 'SaleorOrderLineUpdate';
  errors: Array<SaleorOrderError>;
  /** Related order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  orderLine?: Maybe<SaleorOrderLine>;
};

/**
 * Create order lines for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderLinesCreate = {
  __typename?: 'SaleorOrderLinesCreate';
  errors: Array<SaleorOrderError>;
  /** Related order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
  /** List of added order lines. */
  orderLines?: Maybe<Array<SaleorOrderLine>>;
};

/**
 * Mark order as manually paid.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderMarkAsPaid = {
  __typename?: 'SaleorOrderMarkAsPaid';
  errors: Array<SaleorOrderError>;
  /** Order marked as paid. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/**
 * Event sent when order metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorOrderMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorOrderMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorOrderOrCheckout = SaleorCheckout | SaleorOrder;

/** An enumeration. */
export type SaleorOrderOriginEnum =
  | 'CHECKOUT'
  | 'DRAFT'
  | 'REISSUE';

/**
 * Refund an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderRefund = {
  __typename?: 'SaleorOrderRefund';
  errors: Array<SaleorOrderError>;
  /** A refunded order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderRefundFulfillmentLineInput = {
  /** The ID of the fulfillment line to refund. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type SaleorOrderRefundLineInput = {
  /** The ID of the order line to refund. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type SaleorOrderRefundProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** List of fulfilled lines to refund. */
  fulfillmentLines?: InputMaybe<Array<SaleorOrderRefundFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to refund. */
  orderLines?: InputMaybe<Array<SaleorOrderRefundLineInput>>;
};

export type SaleorOrderReturnFulfillmentLineInput = {
  /** The ID of the fulfillment line to return. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderReturnLineInput = {
  /** The ID of the order line to return. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderReturnProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** List of fulfilled lines to return. */
  fulfillmentLines?: InputMaybe<Array<SaleorOrderReturnFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to return. */
  orderLines?: InputMaybe<Array<SaleorOrderReturnLineInput>>;
  /** If true, Saleor will call refund action for all lines. */
  refund?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the channel-specific order settings. */
export type SaleorOrderSettings = {
  __typename?: 'SaleorOrderSettings';
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. */
  automaticallyConfirmAllNewOrders: Scalars['Boolean']['output'];
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. */
  automaticallyFulfillNonShippableGiftCard: Scalars['Boolean']['output'];
  /**
   * Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  defaultTransactionFlowStrategy: SaleorTransactionFlowStrategyEnum;
  /**
   * Expiration time in minutes. Default null - means do not expire any orders.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  expireOrdersAfter?: Maybe<Scalars['SaleorMinute']['output']>;
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  markAsPaidStrategy: SaleorMarkAsPaidStrategyEnum;
};

export type SaleorOrderSettingsError = {
  __typename?: 'SaleorOrderSettingsError';
  /** The error code. */
  code: SaleorOrderSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorOrderSettingsErrorCode =
  | 'INVALID';

export type SaleorOrderSettingsInput = {
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By defualt set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  defaultTransactionFlowStrategy?: InputMaybe<SaleorTransactionFlowStrategyEnum>;
  /**
   * Expiration time in minutes. Default null - means do not expire any orders. Enter 0 or null to disable.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  expireOrdersAfter?: InputMaybe<Scalars['SaleorMinute']['input']>;
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  markAsPaidStrategy?: InputMaybe<SaleorMarkAsPaidStrategyEnum>;
};

/**
 * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderSettingsUpdate = {
  __typename?: 'SaleorOrderSettingsUpdate';
  errors: Array<SaleorOrderSettingsError>;
  /** Order settings. */
  orderSettings?: Maybe<SaleorOrderSettings>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderSettingsErrors: Array<SaleorOrderSettingsError>;
};

export type SaleorOrderSettingsUpdateInput = {
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By defualt set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorOrderSortField =
  /**
   * Sort orders by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'CREATED_AT'
  /**
   * Sort orders by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'CREATION_DATE'
  /** Sort orders by customer. */
  | 'CUSTOMER'
  /** Sort orders by fulfillment status. */
  | 'FULFILLMENT_STATUS'
  /** Sort orders by last modified at. */
  | 'LAST_MODIFIED_AT'
  /** Sort orders by number. */
  | 'NUMBER'
  /** Sort orders by payment. */
  | 'PAYMENT'
  /** Sort orders by rank. Note: This option is available only with the `search` filter. */
  | 'RANK';

export type SaleorOrderSortingInput = {
  /** Specifies the direction in which to sort orders. */
  direction: SaleorOrderDirection;
  /** Sort orders by the selected field. */
  field: SaleorOrderSortField;
};

/** An enumeration. */
export type SaleorOrderStatus =
  | 'CANCELED'
  | 'DRAFT'
  | 'EXPIRED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'PARTIALLY_RETURNED'
  | 'RETURNED'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

export type SaleorOrderStatusFilter =
  | 'CANCELED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'READY_TO_CAPTURE'
  | 'READY_TO_FULFILL'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

/**
 * Updates an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderUpdate = {
  __typename?: 'SaleorOrderUpdate';
  errors: Array<SaleorOrderError>;
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderUpdateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<SaleorAddressInput>;
  /**
   * External ID of this order.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<SaleorAddressInput>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderUpdateShipping = {
  __typename?: 'SaleorOrderUpdateShipping';
  errors: Array<SaleorOrderError>;
  /** Order with updated shipping method. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

export type SaleorOrderUpdateShippingInput = {
  /** ID of the selected shipping method, pass null to remove currently assigned shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Event sent when order is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorOrderUpdated = SaleorEvent & {
  __typename?: 'SaleorOrderUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<SaleorOrder>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Void an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorOrderVoid = {
  __typename?: 'SaleorOrderVoid';
  errors: Array<SaleorOrderError>;
  /** A voided order. */
  order?: Maybe<SaleorOrder>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  orderErrors: Array<SaleorOrderError>;
};

/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPage = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorPage';
  /** List of attributes assigned to this product. */
  attributes: Array<SaleorSelectedAttribute>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `content` field instead.
   */
  contentJson: Scalars['SaleorJSONString']['output'];
  created: Scalars['SaleorDateTime']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  pageType: SaleorPageType;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** @deprecated This field will be removed in Saleor 4.0. Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['SaleorDate']['output']>;
  /**
   * The page publication date.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation?: Maybe<SaleorPageTranslation>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPagemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPagemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPageprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type SaleorPagetranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Assign attributes to a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageAttributeAssign = {
  __typename?: 'SaleorPageAttributeAssign';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** The updated page type. */
  pageType?: Maybe<SaleorPageType>;
};

/**
 * Unassign attributes from a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageAttributeUnassign = {
  __typename?: 'SaleorPageAttributeUnassign';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** The updated page type. */
  pageType?: Maybe<SaleorPageType>;
};

/**
 * Deletes pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageBulkDelete = {
  __typename?: 'SaleorPageBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/**
 * Publish pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageBulkPublish = {
  __typename?: 'SaleorPageBulkPublish';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageCountableConnection = {
  __typename?: 'SaleorPageCountableConnection';
  edges: Array<SaleorPageCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorPageCountableEdge = {
  __typename?: 'SaleorPageCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPage;
};

/**
 * Creates a new page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageCreate = {
  __typename?: 'SaleorPageCreate';
  errors: Array<SaleorPageError>;
  page?: Maybe<SaleorPage>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the page type that page belongs to. */
  pageType: Scalars['ID']['input'];
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Publication date time. ISO 8601 standard.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new page is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorPageCreated = SaleorEvent & {
  __typename?: 'SaleorPageCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageDelete = {
  __typename?: 'SaleorPageDelete';
  errors: Array<SaleorPageError>;
  page?: Maybe<SaleorPage>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/**
 * Event sent when page is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorPageDeleted = SaleorEvent & {
  __typename?: 'SaleorPageDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorPageError = {
  __typename?: 'SaleorPageError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorPageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorPageErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPageFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  pageTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type SaleorPageInfo = {
  __typename?: 'SaleorPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type SaleorPageInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Publication date time. ISO 8601 standard.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Reorder page attribute values.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageReorderAttributeValues = {
  __typename?: 'SaleorPageReorderAttributeValues';
  errors: Array<SaleorPageError>;
  /** Page from which attribute values are reordered. */
  page?: Maybe<SaleorPage>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageSortField =
  /**
   * Sort pages by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'CREATED_AT'
  /**
   * Sort pages by creation date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'CREATION_DATE'
  /**
   * Sort pages by publication date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort pages by publication date.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.
   */
  | 'PUBLISHED_AT'
  /** Sort pages by slug. */
  | 'SLUG'
  /** Sort pages by title. */
  | 'TITLE'
  /** Sort pages by visibility. */
  | 'VISIBILITY';

export type SaleorPageSortingInput = {
  /** Specifies the direction in which to sort pages. */
  direction: SaleorOrderDirection;
  /** Sort pages by the selected field. */
  field: SaleorPageSortField;
};

export type SaleorPageTranslatableContent = SaleorNode & {
  __typename?: 'SaleorPageTranslatableContent';
  /** List of page content attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `content` field instead.
   */
  contentJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /**
   * A static page that can be manually added by a shop operator through the dashboard.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  page?: Maybe<SaleorPage>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation?: Maybe<SaleorPageTranslation>;
};


export type SaleorPageTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a page.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorPageTranslate = {
  __typename?: 'SaleorPageTranslate';
  errors: Array<SaleorTranslationError>;
  page?: Maybe<SaleorPageTranslatableContent>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorPageTranslation = SaleorNode & {
  __typename?: 'SaleorPageTranslation';
  /**
   * Translated content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Translated description of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `content` field instead.
   */
  contentJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SaleorPageTranslationInput = {
  /**
   * Translated page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorPageType';
  /** Page attributes of that page type. */
  attributes?: Maybe<Array<SaleorAttribute>>;
  /**
   * Attributes that can be assigned to the page type.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  availableAttributes?: Maybe<SaleorAttributeCountableConnection>;
  /**
   * Whether page type has pages assigned.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  hasPages?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  slug: Scalars['String']['output'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeavailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type SaleorPageTypeprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Delete page types.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeBulkDelete = {
  __typename?: 'SaleorPageTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

export type SaleorPageTypeCountableConnection = {
  __typename?: 'SaleorPageTypeCountableConnection';
  edges: Array<SaleorPageTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorPageTypeCountableEdge = {
  __typename?: 'SaleorPageTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPageType;
};

/**
 * Create a new page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeCreate = {
  __typename?: 'SaleorPageTypeCreate';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType?: Maybe<SaleorPageType>;
};

export type SaleorPageTypeCreateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new page type is created.
 *
 * Added in Saleor 3.5.
 */
export type SaleorPageTypeCreated = SaleorEvent & {
  __typename?: 'SaleorPageTypeCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Delete a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeDelete = {
  __typename?: 'SaleorPageTypeDelete';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType?: Maybe<SaleorPageType>;
};

/**
 * Event sent when page type is deleted.
 *
 * Added in Saleor 3.5.
 */
export type SaleorPageTypeDeleted = SaleorEvent & {
  __typename?: 'SaleorPageTypeDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorPageTypeFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Reorder the attributes of a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeReorderAttributes = {
  __typename?: 'SaleorPageTypeReorderAttributes';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  /** Page type from which attributes are reordered. */
  pageType?: Maybe<SaleorPageType>;
};

export type SaleorPageTypeSortField =
  /** Sort page types by name. */
  | 'NAME'
  /** Sort page types by slug. */
  | 'SLUG';

export type SaleorPageTypeSortingInput = {
  /** Specifies the direction in which to sort page types. */
  direction: SaleorOrderDirection;
  /** Sort page types by the selected field. */
  field: SaleorPageTypeSortField;
};

/**
 * Update page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type SaleorPageTypeUpdate = {
  __typename?: 'SaleorPageTypeUpdate';
  errors: Array<SaleorPageError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
  pageType?: Maybe<SaleorPageType>;
};

export type SaleorPageTypeUpdateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attribute IDs to be assigned to the page type. */
  removeAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when page type is updated.
 *
 * Added in Saleor 3.5.
 */
export type SaleorPageTypeUpdated = SaleorEvent & {
  __typename?: 'SaleorPageTypeUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<SaleorPageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type SaleorPageUpdate = {
  __typename?: 'SaleorPageUpdate';
  errors: Array<SaleorPageError>;
  page?: Maybe<SaleorPage>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pageErrors: Array<SaleorPageError>;
};

/**
 * Event sent when page is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorPageUpdated = SaleorEvent & {
  __typename?: 'SaleorPageUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<SaleorPage>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Change the password of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorPasswordChange = {
  __typename?: 'SaleorPasswordChange';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance with a new password. */
  user?: Maybe<SaleorUser>;
};

/** Represents a payment of a given type. */
export type SaleorPayment = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorPayment';
  /**
   * List of actions that can be performed in the current state of a payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  actions: Array<SaleorOrderAction>;
  /**
   * Maximum amount of money that can be captured.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableCaptureAmount?: Maybe<SaleorMoney>;
  /**
   * Maximum amount of money that can be refunded.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableRefundAmount?: Maybe<SaleorMoney>;
  /** Total amount captured for this payment. */
  capturedAmount?: Maybe<SaleorMoney>;
  /** Internal payment status. */
  chargeStatus: SaleorPaymentChargeStatusEnum;
  checkout?: Maybe<SaleorCheckout>;
  created: Scalars['SaleorDateTime']['output'];
  /** The details of the card used for this payment. */
  creditCard?: Maybe<SaleorCreditCard>;
  /**
   * IP address of the user who created the payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  customerIpAddress?: Maybe<Scalars['String']['output']>;
  gateway: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  modified: Scalars['SaleorDateTime']['output'];
  order?: Maybe<SaleorOrder>;
  paymentMethodType: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  token: Scalars['String']['output'];
  /** Total amount of the payment. */
  total?: Maybe<SaleorMoney>;
  /**
   * List of all transactions within this payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  transactions?: Maybe<Array<SaleorTransaction>>;
};


/** Represents a payment of a given type. */
export type SaleorPaymentmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment of a given type. */
export type SaleorPaymentmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a payment of a given type. */
export type SaleorPaymentprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment of a given type. */
export type SaleorPaymentprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Authorize payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentAuthorize = SaleorEvent & {
  __typename?: 'SaleorPaymentAuthorize';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Captures the authorized payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentCapture = {
  __typename?: 'SaleorPaymentCapture';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment?: Maybe<SaleorPayment>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Capture payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentCaptureEvent = SaleorEvent & {
  __typename?: 'SaleorPaymentCaptureEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorPaymentChargeStatusEnum =
  | 'CANCELLED'
  | 'FULLY_CHARGED'
  | 'FULLY_REFUNDED'
  | 'NOT_CHARGED'
  | 'PARTIALLY_CHARGED'
  | 'PARTIALLY_REFUNDED'
  | 'PENDING'
  | 'REFUSED';

/** Check payment balance. */
export type SaleorPaymentCheckBalance = {
  __typename?: 'SaleorPaymentCheckBalance';
  /** Response from the gateway. */
  data?: Maybe<Scalars['SaleorJSONString']['output']>;
  errors: Array<SaleorPaymentError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

export type SaleorPaymentCheckBalanceInput = {
  /** Information about card. */
  card: SaleorCardInput;
  /** Slug of a channel for which the data should be returned. */
  channel: Scalars['String']['input'];
  /** An ID of a payment gateway to check. */
  gatewayId: Scalars['String']['input'];
  /** Payment method name. */
  method: Scalars['String']['input'];
};

/**
 * Confirm payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentConfirmEvent = SaleorEvent & {
  __typename?: 'SaleorPaymentConfirmEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentCountableConnection = {
  __typename?: 'SaleorPaymentCountableConnection';
  edges: Array<SaleorPaymentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorPaymentCountableEdge = {
  __typename?: 'SaleorPaymentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPayment;
};

export type SaleorPaymentError = {
  __typename?: 'SaleorPaymentError';
  /** The error code. */
  code: SaleorPaymentErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorPaymentErrorCode =
  | 'BALANCE_CHECK_ERROR'
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_EMAIL_NOT_SET'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'NOT_FOUND'
  | 'NOT_SUPPORTED_GATEWAY'
  | 'NO_CHECKOUT_LINES'
  | 'PARTIAL_PAYMENT_NOT_ALLOWED'
  | 'PAYMENT_ERROR'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE';

export type SaleorPaymentFilterInput = {
  checkouts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by ids.
   *
   * Added in Saleor 3.8.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Available payment gateway backend with configuration necessary to setup client. */
export type SaleorPaymentGateway = {
  __typename?: 'SaleorPaymentGateway';
  /** Payment gateway client configuration. */
  config: Array<SaleorGatewayConfigLine>;
  /** Payment gateway supported currencies. */
  currencies: Array<Scalars['String']['output']>;
  /** Payment gateway ID. */
  id: Scalars['ID']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

export type SaleorPaymentGatewayConfig = {
  __typename?: 'SaleorPaymentGatewayConfig';
  /** The JSON data required to initialize the payment gateway. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  errors?: Maybe<Array<SaleorPaymentGatewayConfigError>>;
  /** The app identifier. */
  id: Scalars['String']['output'];
};

export type SaleorPaymentGatewayConfigError = {
  __typename?: 'SaleorPaymentGatewayConfigError';
  /** The error code. */
  code: SaleorPaymentGatewayConfigErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorPaymentGatewayConfigErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorPaymentGatewayInitialize = {
  __typename?: 'SaleorPaymentGatewayInitialize';
  errors: Array<SaleorPaymentGatewayInitializeError>;
  gatewayConfigs?: Maybe<Array<SaleorPaymentGatewayConfig>>;
};

export type SaleorPaymentGatewayInitializeError = {
  __typename?: 'SaleorPaymentGatewayInitializeError';
  /** The error code. */
  code: SaleorPaymentGatewayInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorPaymentGatewayInitializeErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Event sent when user wants to initialize the payment gateway.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorPaymentGatewayInitializeSession = SaleorEvent & {
  __typename?: 'SaleorPaymentGatewayInitializeSession';
  /** Amount requested for initializing the payment gateway. */
  amount?: Maybe<Scalars['SaleorPositiveDecimal']['output']>;
  /** Payment gateway data in JSON format, recieved from storefront. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorPaymentGatewayToInitialize = {
  /** The data that will be passed to the payment gateway. */
  data?: InputMaybe<Scalars['SaleorJSON']['input']>;
  /** The identifier of the payment gateway app to initialize. */
  id: Scalars['String']['input'];
};

/** Initializes payment process when it is required by gateway. */
export type SaleorPaymentInitialize = {
  __typename?: 'SaleorPaymentInitialize';
  errors: Array<SaleorPaymentError>;
  initializedPayment?: Maybe<SaleorPaymentInitialized>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/** Server-side data generated by a payment gateway. Optional step when the payment provider requires an additional action to initialize payment session. */
export type SaleorPaymentInitialized = {
  __typename?: 'SaleorPaymentInitialized';
  /** Initialized data by gateway. */
  data?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** ID of a payment gateway. */
  gateway: Scalars['String']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

export type SaleorPaymentInput = {
  /** Total amount of the transaction, including all taxes and discounts. If no amount is provided, the checkout total will be used. */
  amount?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** A gateway to use with that payment. */
  gateway: Scalars['String']['input'];
  /**
   * User public metadata.
   *
   * Added in Saleor 3.1.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** URL of a storefront view where user should be redirected after requiring additional actions. Payment with additional actions will not be finished if this field is not provided. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment store type.
   *
   * Added in Saleor 3.1.
   */
  storePaymentMethod?: InputMaybe<SaleorStorePaymentMethodEnum>;
  /** Client-side generated payment token, representing customer's billing data in a secure manner. */
  token?: InputMaybe<Scalars['String']['input']>;
};

/**
 * List payment gateways.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentListGateways = SaleorEvent & {
  __typename?: 'SaleorPaymentListGateways';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Process payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentProcessEvent = SaleorEvent & {
  __typename?: 'SaleorPaymentProcessEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Refunds the captured payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentRefund = {
  __typename?: 'SaleorPaymentRefund';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment?: Maybe<SaleorPayment>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Refund payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentRefundEvent = SaleorEvent & {
  __typename?: 'SaleorPaymentRefundEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a payment source stored for user in payment gateway, such as credit card. */
export type SaleorPaymentSource = {
  __typename?: 'SaleorPaymentSource';
  /** Stored credit card details if available. */
  creditCardInfo?: Maybe<SaleorCreditCard>;
  /** Payment gateway name. */
  gateway: Scalars['String']['output'];
  /**
   * List of public metadata items.
   *
   * Added in Saleor 3.1.
   *
   * Can be accessed without permissions.
   */
  metadata: Array<SaleorMetadataItem>;
  /** ID of stored payment method. */
  paymentMethodId?: Maybe<Scalars['String']['output']>;
};

/**
 * Voids the authorized payment.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type SaleorPaymentVoid = {
  __typename?: 'SaleorPaymentVoid';
  errors: Array<SaleorPaymentError>;
  /** Updated payment. */
  payment?: Maybe<SaleorPayment>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  paymentErrors: Array<SaleorPaymentError>;
};

/**
 * Void payment.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPaymentVoidEvent = SaleorEvent & {
  __typename?: 'SaleorPaymentVoidEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<SaleorPayment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a permission object in a friendly form. */
export type SaleorPermission = {
  __typename?: 'SaleorPermission';
  /** Internal code for permission. */
  code: SaleorPermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
};

/** An enumeration. */
export type SaleorPermissionEnum =
  | 'HANDLE_CHECKOUTS'
  | 'HANDLE_PAYMENTS'
  | 'HANDLE_TAXES'
  | 'IMPERSONATE_USER'
  | 'MANAGE_APPS'
  | 'MANAGE_CHANNELS'
  | 'MANAGE_CHECKOUTS'
  | 'MANAGE_DISCOUNTS'
  | 'MANAGE_GIFT_CARD'
  | 'MANAGE_MENUS'
  | 'MANAGE_OBSERVABILITY'
  | 'MANAGE_ORDERS'
  | 'MANAGE_PAGES'
  | 'MANAGE_PAGE_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_PLUGINS'
  | 'MANAGE_PRODUCTS'
  | 'MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_SETTINGS'
  | 'MANAGE_SHIPPING'
  | 'MANAGE_STAFF'
  | 'MANAGE_TAXES'
  | 'MANAGE_TRANSLATIONS'
  | 'MANAGE_USERS';

/**
 * Create new permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorPermissionGroupCreate = {
  __typename?: 'SaleorPermissionGroupCreate';
  errors: Array<SaleorPermissionGroupError>;
  group?: Maybe<SaleorGroup>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

export type SaleorPermissionGroupCreateInput = {
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name: Scalars['String']['input'];
};

/**
 * Event sent when new permission group is created.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPermissionGroupCreated = SaleorEvent & {
  __typename?: 'SaleorPermissionGroupCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Delete permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorPermissionGroupDelete = {
  __typename?: 'SaleorPermissionGroupDelete';
  errors: Array<SaleorPermissionGroupError>;
  group?: Maybe<SaleorGroup>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

/**
 * Event sent when permission group is deleted.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPermissionGroupDeleted = SaleorEvent & {
  __typename?: 'SaleorPermissionGroupDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorPermissionGroupError = {
  __typename?: 'SaleorPermissionGroupError';
  /** The error code. */
  code: SaleorPermissionGroupErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<SaleorPermissionEnum>>;
  /** List of user IDs which causes the error. */
  users?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorPermissionGroupErrorCode =
  | 'ASSIGN_NON_STAFF_MEMBER'
  | 'CANNOT_REMOVE_FROM_LAST_GROUP'
  | 'DUPLICATED_INPUT_ITEM'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPermissionGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sorting options for permission groups. */
export type SaleorPermissionGroupSortField =
  /** Sort permission group accounts by name. */
  | 'NAME';

export type SaleorPermissionGroupSortingInput = {
  /** Specifies the direction in which to sort permission group. */
  direction: SaleorOrderDirection;
  /** Sort permission group by the selected field. */
  field: SaleorPermissionGroupSortField;
};

/**
 * Update permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorPermissionGroupUpdate = {
  __typename?: 'SaleorPermissionGroupUpdate';
  errors: Array<SaleorPermissionGroupError>;
  group?: Maybe<SaleorGroup>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  permissionGroupErrors: Array<SaleorPermissionGroupError>;
};

export type SaleorPermissionGroupUpdateInput = {
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to unassign from this group. */
  removePermissions?: InputMaybe<Array<SaleorPermissionEnum>>;
  /** List of users to unassign from this group. */
  removeUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Event sent when permission group is updated.
 *
 * Added in Saleor 3.6.
 */
export type SaleorPermissionGroupUpdated = SaleorEvent & {
  __typename?: 'SaleorPermissionGroupUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<SaleorGroup>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Plugin. */
export type SaleorPlugin = {
  __typename?: 'SaleorPlugin';
  /** Channel-specific plugin configuration. */
  channelConfigurations: Array<SaleorPluginConfiguration>;
  /** Description of the plugin. */
  description: Scalars['String']['output'];
  /** Global configuration of the plugin (not channel-specific). */
  globalConfiguration?: Maybe<SaleorPluginConfiguration>;
  /** Identifier of the plugin. */
  id: Scalars['ID']['output'];
  /** Name of the plugin. */
  name: Scalars['String']['output'];
};

/** Stores information about a configuration of plugin. */
export type SaleorPluginConfiguration = {
  __typename?: 'SaleorPluginConfiguration';
  /** Determines if plugin is active or not. */
  active: Scalars['Boolean']['output'];
  /** The channel to which the plugin configuration is assigned to. */
  channel?: Maybe<SaleorChannel>;
  /** Configuration of the plugin. */
  configuration?: Maybe<Array<SaleorConfigurationItem>>;
};

export type SaleorPluginConfigurationType =
  | 'GLOBAL'
  | 'PER_CHANNEL';

export type SaleorPluginCountableConnection = {
  __typename?: 'SaleorPluginCountableConnection';
  edges: Array<SaleorPluginCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorPluginCountableEdge = {
  __typename?: 'SaleorPluginCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorPlugin;
};

export type SaleorPluginError = {
  __typename?: 'SaleorPluginError';
  /** The error code. */
  code: SaleorPluginErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorPluginErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'PLUGIN_MISCONFIGURED'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorPluginFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  statusInChannels?: InputMaybe<SaleorPluginStatusInChannelsInput>;
  type?: InputMaybe<SaleorPluginConfigurationType>;
};

export type SaleorPluginSortField =
  | 'IS_ACTIVE'
  | 'NAME';

export type SaleorPluginSortingInput = {
  /** Specifies the direction in which to sort plugins. */
  direction: SaleorOrderDirection;
  /** Sort plugins by the selected field. */
  field: SaleorPluginSortField;
};

export type SaleorPluginStatusInChannelsInput = {
  active: Scalars['Boolean']['input'];
  channels: Array<Scalars['ID']['input']>;
};

/**
 * Update plugin configuration.
 *
 * Requires one of the following permissions: MANAGE_PLUGINS.
 */
export type SaleorPluginUpdate = {
  __typename?: 'SaleorPluginUpdate';
  errors: Array<SaleorPluginError>;
  plugin?: Maybe<SaleorPlugin>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  pluginsErrors: Array<SaleorPluginError>;
};

export type SaleorPluginUpdateInput = {
  /** Indicates whether the plugin should be enabled. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of the plugin. */
  configuration?: InputMaybe<Array<SaleorConfigurationItemInput>>;
};

/** An enumeration. */
export type SaleorPostalCodeRuleInclusionTypeEnum =
  | 'EXCLUDE'
  | 'INCLUDE';

/** Represents preorder settings for product variant. */
export type SaleorPreorderData = {
  __typename?: 'SaleorPreorderData';
  /** Preorder end date. */
  endDate?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * Total number of sold product variant during preorder.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalSoldUnits: Scalars['Int']['output'];
  /**
   * The global preorder threshold for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalThreshold?: Maybe<Scalars['Int']['output']>;
};

export type SaleorPreorderSettingsInput = {
  /** The end date for preorder. */
  endDate?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** The global threshold for preorder variant. */
  globalThreshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents preorder variant data for channel. */
export type SaleorPreorderThreshold = {
  __typename?: 'SaleorPreorderThreshold';
  /** Preorder threshold for product variant in this channel. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Number of sold product variant in this channel. */
  soldUnits: Scalars['Int']['output'];
};

export type SaleorPriceInput = {
  /** Amount of money. */
  amount: Scalars['SaleorPositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

export type SaleorPriceRangeInput = {
  /** Price greater than or equal to. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Price less than or equal to. */
  lte?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents an individual item for sale in the storefront. */
export type SaleorProduct = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorProduct';
  /**
   * Get a single attribute attached to product by attribute slug.
   *
   * Added in Saleor 3.9.
   */
  attribute?: Maybe<SaleorSelectedAttribute>;
  /** List of attributes assigned to this product. */
  attributes: Array<SaleorSelectedAttribute>;
  /**
   * Date when product is available for purchase.
   * @deprecated This field will be removed in Saleor 4.0. Use the `availableForPurchaseAt` field to fetch the available for purchase date.
   */
  availableForPurchase?: Maybe<Scalars['SaleorDate']['output']>;
  /** Date when product is available for purchase. */
  availableForPurchaseAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  category?: Maybe<SaleorCategory>;
  /** Channel given to retrieve this product. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of availability in channels for the product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings?: Maybe<Array<SaleorProductChannelListing>>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `Channel.taxConfiguration` field to determine whether tax collection is enabled. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of collections for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collections?: Maybe<Array<SaleorCollection>>;
  created: Scalars['SaleorDateTime']['output'];
  defaultVariant?: Maybe<SaleorProductVariant>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * External ID of this product.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Get a single product image by ID.
   * @deprecated This field will be removed in Saleor 4.0. Use the `mediaById` field instead.
   */
  imageById?: Maybe<SaleorProductImage>;
  /**
   * List of images for the product.
   * @deprecated This field will be removed in Saleor 4.0. Use the `media` field instead.
   */
  images?: Maybe<Array<SaleorProductImage>>;
  /** Whether the product is in stock and visible or not. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the product is available for purchase. */
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  /** List of media for the product. */
  media?: Maybe<Array<SaleorProductMedia>>;
  /** Get a single product media by ID. */
  mediaById?: Maybe<SaleorProductMedia>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<SaleorProductPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  productType: SaleorProductType;
  rating?: Maybe<Scalars['Float']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<SaleorTaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated This field will be removed in Saleor 4.0. Use `taxClass` field instead.
   */
  taxType?: Maybe<SaleorTaxType>;
  thumbnail?: Maybe<SaleorImage>;
  /** Returns translated product fields for the given language code. */
  translation?: Maybe<SaleorProductTranslation>;
  updatedAt: Scalars['SaleorDateTime']['output'];
  /**
   * Get a single variant by SKU or ID.
   *
   * Added in Saleor 3.9.
   * @deprecated This field will be removed in Saleor 4.0. Use top-level `variant` query.
   */
  variant?: Maybe<SaleorProductVariant>;
  /** List of variants for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  variants?: Maybe<Array<SaleorProductVariant>>;
  weight?: Maybe<SaleorWeight>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductattributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductimageByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductisAvailableArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductmediaArgs = {
  sortBy?: InputMaybe<SaleorMediaSortingInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductmediaByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductpricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductthumbnailArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProducttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/** Represents an individual item for sale in the storefront. */
export type SaleorProductvariantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Assign attributes to a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeAssign = {
  __typename?: 'SaleorProductAttributeAssign';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType?: Maybe<SaleorProductType>;
};

export type SaleorProductAttributeAssignInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /** The attribute type to be assigned as. */
  type: SaleorProductAttributeType;
  /**
   * Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric'].
   *
   * Added in Saleor 3.1.
   */
  variantSelection?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Update attributes assigned to product variant for given product type.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeAssignmentUpdate = {
  __typename?: 'SaleorProductAttributeAssignmentUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType?: Maybe<SaleorProductType>;
};

export type SaleorProductAttributeAssignmentUpdateInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /**
   * Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric'].
   *
   * Added in Saleor 3.1.
   */
  variantSelection: Scalars['Boolean']['input'];
};

export type SaleorProductAttributeType =
  | 'PRODUCT'
  | 'VARIANT';

/**
 * Un-assign attributes from a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductAttributeUnassign = {
  __typename?: 'SaleorProductAttributeUnassign';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** The updated product type. */
  productType?: Maybe<SaleorProductType>;
};

/**
 * Creates products.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductBulkCreate = {
  __typename?: 'SaleorProductBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductBulkCreateError>;
  /** List of the created products. */
  results: Array<SaleorProductBulkResult>;
};

export type SaleorProductBulkCreateError = {
  __typename?: 'SaleorProductBulkCreateError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductBulkCreateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorProductBulkCreateErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER';

export type SaleorProductBulkCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** List of channels in which the product is available. */
  channelListings?: InputMaybe<Array<SaleorProductChannelListingCreateInput>>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** List of media inputs associated with the product. */
  media?: InputMaybe<Array<SaleorMediaInput>>;
  /** Fields required to update the product metadata. */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Fields required to update the product private metadata. */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Input list of product variants to create. */
  variants?: InputMaybe<Array<SaleorProductVariantBulkCreateInput>>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/**
 * Deletes products.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductBulkDelete = {
  __typename?: 'SaleorProductBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductBulkResult = {
  __typename?: 'SaleorProductBulkResult';
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<SaleorProductBulkCreateError>>;
  /** Product data. */
  product?: Maybe<SaleorProduct>;
};

/** Represents product channel listing. */
export type SaleorProductChannelListing = SaleorNode & {
  __typename?: 'SaleorProductChannelListing';
  /** @deprecated This field will be removed in Saleor 4.0. Use the `availableForPurchaseAt` field to fetch the available for purchase date. */
  availableForPurchase?: Maybe<Scalars['SaleorDate']['output']>;
  /**
   * The product available for purchase date time.
   *
   * Added in Saleor 3.3.
   */
  availableForPurchaseAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  channel: SaleorChannel;
  /** The price of the cheapest variant (including discounts). */
  discountedPrice?: Maybe<SaleorMoney>;
  id: Scalars['ID']['output'];
  /** Whether the product is available for purchase. */
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  isPublished: Scalars['Boolean']['output'];
  /**
   * Range of margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin?: Maybe<SaleorMargin>;
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<SaleorProductPricingInfo>;
  /** @deprecated This field will be removed in Saleor 4.0. Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['SaleorDate']['output']>;
  /**
   * The product publication date time.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /**
   * Purchase cost of product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  purchaseCost?: Maybe<SaleorMoneyRange>;
  visibleInListings: Scalars['Boolean']['output'];
};


/** Represents product channel listing. */
export type SaleorProductChannelListingpricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};

export type SaleorProductChannelListingAddInput = {
  /** List of variants to which the channel should be assigned. */
  addVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed.
   *
   * Added in Saleor 3.3.
   */
  availableForPurchaseAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /**
   * A start date from which a product will be available for purchase. When not set and isAvailable is set to True, the current day is assumed.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `availableForPurchaseAt` field instead.
   */
  availableForPurchaseDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determine if product should be available for purchase. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * Publication date time. ISO 8601 standard.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** List of variants from which the channel should be unassigned. */
  removeVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorProductChannelListingCreateInput = {
  /** A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed. */
  availableForPurchaseAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determine if product should be available for purchase. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaleorProductChannelListingError = {
  __typename?: 'SaleorProductChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of variants IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage product's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductChannelListingUpdate = {
  __typename?: 'SaleorProductChannelListingUpdate';
  errors: Array<SaleorProductChannelListingError>;
  /** An updated product instance. */
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productChannelListingErrors: Array<SaleorProductChannelListingError>;
};

export type SaleorProductChannelListingUpdateInput = {
  /** List of channels from which the product should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels to which the product should be assigned or updated. */
  updateChannels?: InputMaybe<Array<SaleorProductChannelListingAddInput>>;
};

export type SaleorProductCountableConnection = {
  __typename?: 'SaleorProductCountableConnection';
  edges: Array<SaleorProductCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductCountableEdge = {
  __typename?: 'SaleorProductCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProduct;
};

/**
 * Creates a new product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductCreate = {
  __typename?: 'SaleorProductCreate';
  errors: Array<SaleorProductError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * External ID of this product.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/**
 * Event sent when new product is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductCreated = SaleorEvent & {
  __typename?: 'SaleorProductCreated';
  /** The category of the product. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new product is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductCreatedproductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductDelete = {
  __typename?: 'SaleorProductDelete';
  errors: Array<SaleorProductError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when product is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductDeleted = SaleorEvent & {
  __typename?: 'SaleorProductDeleted';
  /** The category of the product. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductDeletedproductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductError = {
  __typename?: 'SaleorProductError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorProductErrorCode =
  | 'ALREADY_EXISTS'
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'MEDIA_ALREADY_ASSIGNED'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_IMAGE'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PREORDER_VARIANT_CANNOT_BE_DEACTIVATED'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER'
  | 'VARIANT_NO_DIGITAL_CONTENT';

export type SaleorProductFieldEnum =
  | 'CATEGORY'
  | 'CHARGE_TAXES'
  | 'COLLECTIONS'
  | 'DESCRIPTION'
  | 'NAME'
  | 'PRODUCT_MEDIA'
  | 'PRODUCT_TYPE'
  | 'PRODUCT_WEIGHT'
  | 'VARIANT_ID'
  | 'VARIANT_MEDIA'
  | 'VARIANT_SKU'
  | 'VARIANT_WEIGHT';

export type SaleorProductFilterInput = {
  attributes?: InputMaybe<Array<SaleorAttributeInput>>;
  /**
   * Filter by the date of availability for purchase.
   *
   * Added in Saleor 3.8.
   */
  availableFrom?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on whether product is a gift card or not. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreorderedVariants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by availability for purchase.
   *
   * Added in Saleor 3.8.
   */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by visibility in product listings.
   *
   * Added in Saleor 3.8.
   */
  isVisibleInListing?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  /** Filter by the lowest variant price after discounts. */
  minimalPrice?: InputMaybe<SaleorPriceRangeInput>;
  price?: InputMaybe<SaleorPriceRangeInput>;
  productTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filter by the publication date.
   *
   * Added in Saleor 3.8.
   */
  publishedFrom?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by variants having specific stock status. */
  stockAvailability?: InputMaybe<SaleorStockAvailability>;
  stocks?: InputMaybe<SaleorProductStockFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

/** Represents a product image. */
export type SaleorProductImage = {
  __typename?: 'SaleorProductImage';
  /** The alt text of the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The ID of the image. */
  id: Scalars['ID']['output'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};


/** Represents a product image. */
export type SaleorProductImageurlArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorProductInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * External ID of this product.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SaleorSeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/** Represents a product media. */
export type SaleorProductMedia = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorProductMedia';
  alt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * List of public metadata items. Can be accessed without permissions.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  oembedData: Scalars['SaleorJSONString']['output'];
  /**
   * List of private metadata items. Requires staff permissions to access.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * Product id the media refers to.
   *
   * Added in Saleor 3.12.
   */
  productId?: Maybe<Scalars['ID']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  type: SaleorProductMediaType;
  url: Scalars['String']['output'];
};


/** Represents a product media. */
export type SaleorProductMediametafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type SaleorProductMediametafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type SaleorProductMediaprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type SaleorProductMediaprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type SaleorProductMediaurlArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Deletes product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaBulkDelete = {
  __typename?: 'SaleorProductMediaBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaCreate = {
  __typename?: 'SaleorProductMediaCreate';
  errors: Array<SaleorProductError>;
  media?: Maybe<SaleorProductMedia>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductMediaCreateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['SaleorUpload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of an product. */
  product: Scalars['ID']['input'];
};

/**
 * Event sent when new product media is created.
 *
 * Added in Saleor 3.12.
 */
export type SaleorProductMediaCreated = SaleorEvent & {
  __typename?: 'SaleorProductMediaCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaDelete = {
  __typename?: 'SaleorProductMediaDelete';
  errors: Array<SaleorProductError>;
  media?: Maybe<SaleorProductMedia>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when product media is deleted.
 *
 * Added in Saleor 3.12.
 */
export type SaleorProductMediaDeleted = SaleorEvent & {
  __typename?: 'SaleorProductMediaDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Changes ordering of the product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaReorder = {
  __typename?: 'SaleorProductMediaReorder';
  errors: Array<SaleorProductError>;
  media?: Maybe<Array<SaleorProductMedia>>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/** An enumeration. */
export type SaleorProductMediaType =
  | 'IMAGE'
  | 'VIDEO';

/**
 * Updates a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductMediaUpdate = {
  __typename?: 'SaleorProductMediaUpdate';
  errors: Array<SaleorProductError>;
  media?: Maybe<SaleorProductMedia>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductMediaUpdateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when product media is updated.
 *
 * Added in Saleor 3.12.
 */
export type SaleorProductMediaUpdated = SaleorEvent & {
  __typename?: 'SaleorProductMediaUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<SaleorProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when product metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorProductMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorProductMetadataUpdated';
  /** The category of the product. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorProductMetadataUpdatedproductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductOrder = {
  /**
   * Sort product by the selected attribute's values.
   * Note: this doesn't take translations into account yet.
   */
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort products. */
  direction: SaleorOrderDirection;
  /** Sort products by the selected field. */
  field?: InputMaybe<SaleorProductOrderField>;
};

export type SaleorProductOrderField =
  /**
   * Sort products by collection. Note: This option is available only for the `Collection.products` query.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'COLLECTION'
  /**
   * Sort products by creation date.
   *
   * Added in Saleor 3.8.
   */
  | 'CREATED_AT'
  /** Sort products by update date. */
  | 'DATE'
  /** Sort products by update date. */
  | 'LAST_MODIFIED'
  /** Sort products by update date. */
  | 'LAST_MODIFIED_AT'
  /**
   * Sort products by a minimal price of a product's variant.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMAL_PRICE'
  /** Sort products by name. */
  | 'NAME'
  /**
   * Sort products by price.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PRICE'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort products by publication status.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT'
  /** Sort products by rank. Note: This option is available only with the `search` filter. */
  | 'RANK'
  /** Sort products by rating. */
  | 'RATING'
  /** Sort products by type. */
  | 'TYPE';

/** Represents availability of a product in the storefront. */
export type SaleorProductPricingInfo = {
  __typename?: 'SaleorProductPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount?: Maybe<SaleorTaxedMoney>;
  /** The discount amount in the local currency. */
  discountLocalCurrency?: Maybe<SaleorTaxedMoney>;
  /**
   * Determines whether this product's price displayed in a storefront should include taxes.
   *
   * Added in Saleor 3.9.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Whether it is in sale or not. */
  onSale?: Maybe<Scalars['Boolean']['output']>;
  /** The discounted price range of the product variants. */
  priceRange?: Maybe<SaleorTaxedMoneyRange>;
  /** The discounted price range of the product variants in the local currency. */
  priceRangeLocalCurrency?: Maybe<SaleorTaxedMoneyRange>;
  /** The undiscounted price range of the product variants. */
  priceRangeUndiscounted?: Maybe<SaleorTaxedMoneyRange>;
};

/**
 * Reorder product attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductReorderAttributeValues = {
  __typename?: 'SaleorProductReorderAttributeValues';
  errors: Array<SaleorProductError>;
  /** Product from which attribute values are reordered. */
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductStockFilterInput = {
  quantity?: InputMaybe<SaleorIntRangeInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SaleorProductTranslatableContent = SaleorNode & {
  __typename?: 'SaleorProductTranslatableContent';
  /** List of product attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Represents an individual item for sale in the storefront.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  product?: Maybe<SaleorProduct>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Returns translated product fields for the given language code. */
  translation?: Maybe<SaleorProductTranslation>;
};


export type SaleorProductTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a product.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorProductTranslate = {
  __typename?: 'SaleorProductTranslate';
  errors: Array<SaleorTranslationError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorProductTranslation = SaleorNode & {
  __typename?: 'SaleorProductTranslation';
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated This field will be removed in Saleor 4.0. Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
};

/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorProductType';
  /**
   * Variant attributes of that product type with attached variant selection.
   *
   * Added in Saleor 3.1.
   */
  assignedVariantAttributes?: Maybe<Array<SaleorAssignedVariantAttribute>>;
  /**
   * List of attributes which can be assigned to this product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  availableAttributes?: Maybe<SaleorAttributeCountableConnection>;
  hasVariants: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDigital: Scalars['Boolean']['output'];
  isShippingRequired: Scalars['Boolean']['output'];
  /** The product type kind. */
  kind: SaleorProductTypeKindEnum;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Product attributes of that product type. */
  productAttributes?: Maybe<Array<SaleorAttribute>>;
  /**
   * List of products of this type.
   * @deprecated This field will be removed in Saleor 4.0. Use the top-level `products` query with the `productTypes` filter.
   */
  products?: Maybe<SaleorProductCountableConnection>;
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<SaleorTaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated This field will be removed in Saleor 4.0. Use `taxClass` field instead.
   */
  taxType?: Maybe<SaleorTaxType>;
  /**
   * Variant attributes of that product type.
   * @deprecated This field will be removed in Saleor 4.0. Use `assignedVariantAttributes` instead.
   */
  variantAttributes?: Maybe<Array<SaleorAttribute>>;
  weight?: Maybe<SaleorWeight>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeassignedVariantAttributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeavailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorAttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SaleorAttributeWhereInput>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypeproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type SaleorProductTypevariantAttributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};

/**
 * Deletes product types.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeBulkDelete = {
  __typename?: 'SaleorProductTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductTypeConfigurable =
  | 'CONFIGURABLE'
  | 'SIMPLE';

export type SaleorProductTypeCountableConnection = {
  __typename?: 'SaleorProductTypeCountableConnection';
  edges: Array<SaleorProductTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductTypeCountableEdge = {
  __typename?: 'SaleorProductTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProductType;
};

/**
 * Creates a new product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeCreate = {
  __typename?: 'SaleorProductTypeCreate';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType?: Maybe<SaleorProductType>;
};

/**
 * Deletes a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeDelete = {
  __typename?: 'SaleorProductTypeDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType?: Maybe<SaleorProductType>;
};

export type SaleorProductTypeEnum =
  | 'DIGITAL'
  | 'SHIPPABLE';

export type SaleorProductTypeFilterInput = {
  configurable?: InputMaybe<SaleorProductTypeConfigurable>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<SaleorProductTypeKindEnum>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  productType?: InputMaybe<SaleorProductTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorProductTypeInput = {
  /** Determines if product of this type has multiple variants. This option mainly simplifies product management in the dashboard. There is always at least one variant created under the hood. */
  hasVariants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if products are digital. */
  isDigital?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if shipping is required for products of this variant. */
  isShippingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The product type kind. */
  kind?: InputMaybe<SaleorProductTypeKindEnum>;
  /** Name of the product type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes shared among all product variants. */
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product type. All products of this product type would use this tax class, unless it's overridden in the `Product` type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0.. Use tax classes to control the tax calculation for a product type. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes used to distinguish between different variants of a product. */
  variantAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Weight of the ProductType items. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/** An enumeration. */
export type SaleorProductTypeKindEnum =
  | 'GIFT_CARD'
  | 'NORMAL';

/**
 * Reorder the attributes of a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeReorderAttributes = {
  __typename?: 'SaleorProductTypeReorderAttributes';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** Product type from which attributes are reordered. */
  productType?: Maybe<SaleorProductType>;
};

export type SaleorProductTypeSortField =
  /** Sort products by type. */
  | 'DIGITAL'
  /** Sort products by name. */
  | 'NAME'
  /** Sort products by shipping. */
  | 'SHIPPING_REQUIRED';

export type SaleorProductTypeSortingInput = {
  /** Specifies the direction in which to sort product types. */
  direction: SaleorOrderDirection;
  /** Sort product types by the selected field. */
  field: SaleorProductTypeSortField;
};

/**
 * Updates an existing product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type SaleorProductTypeUpdate = {
  __typename?: 'SaleorProductTypeUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productType?: Maybe<SaleorProductType>;
};

/**
 * Updates an existing product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductUpdate = {
  __typename?: 'SaleorProductUpdate';
  errors: Array<SaleorProductError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Event sent when product is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductUpdated = SaleorEvent & {
  __typename?: 'SaleorProductUpdated';
  /** The category of the product. */
  category?: Maybe<SaleorCategory>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<SaleorProduct>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductUpdatedproductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a version of a product such as different size or color. */
export type SaleorProductVariant = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorProductVariant';
  /** List of attributes assigned to this variant. */
  attributes: Array<SaleorSelectedAttribute>;
  /** Channel given to retrieve this product variant. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of price information in channels for the product.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channelListings?: Maybe<Array<SaleorProductVariantChannelListing>>;
  created: Scalars['SaleorDateTime']['output'];
  /**
   * Digital content for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  digitalContent?: Maybe<SaleorDigitalContent>;
  /**
   * External ID of this product.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * List of images for the product variant.
   * @deprecated This field will be removed in Saleor 4.0. Use the `media` field instead.
   */
  images?: Maybe<Array<SaleorProductImage>>;
  /** Gross margin percentage value. */
  margin?: Maybe<Scalars['Int']['output']>;
  /** List of media for the product variant. */
  media?: Maybe<Array<SaleorProductMedia>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /**
   * Preorder data for product variant.
   *
   * Added in Saleor 3.1.
   */
  preorder?: Maybe<SaleorPreorderData>;
  /** Lists the storefront variant's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<SaleorVariantPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  product: SaleorProduct;
  /** Quantity of a product available for sale in one checkout. Field value will be `null` when no `limitQuantityPerCheckout` in global settings has been set, and `productVariant` stocks are not tracked. */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  quantityLimitPerCustomer?: Maybe<Scalars['Int']['output']>;
  /**
   * Total quantity ordered.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  quantityOrdered?: Maybe<Scalars['Int']['output']>;
  /**
   * Total revenue generated by a variant in given period of time. Note: this field should be queried using `reportProductSales` query as it uses optimizations suitable for such calculations.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  revenue?: Maybe<SaleorTaxedMoney>;
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * Stocks for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  stocks?: Maybe<Array<SaleorStock>>;
  trackInventory: Scalars['Boolean']['output'];
  /** Returns translated product variant fields for the given language code. */
  translation?: Maybe<SaleorProductVariantTranslation>;
  updatedAt: Scalars['SaleorDateTime']['output'];
  weight?: Maybe<SaleorWeight>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantattributesArgs = {
  variantSelection?: InputMaybe<SaleorVariantAttributeScope>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantpricingArgs = {
  address?: InputMaybe<SaleorAddressInput>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantquantityAvailableArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  countryCode?: InputMaybe<SaleorCountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantrevenueArgs = {
  period?: InputMaybe<SaleorReportingPeriod>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVariantstocksArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  countryCode?: InputMaybe<SaleorCountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type SaleorProductVarianttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Event sent when product variant is back in stock.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantBackInStock = SaleorEvent & {
  __typename?: 'SaleorProductVariantBackInStock';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<SaleorWarehouse>;
};


/**
 * Event sent when product variant is back in stock.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantBackInStockproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates product variants for a given product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkCreate = {
  __typename?: 'SaleorProductVariantBulkCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  bulkProductErrors: Array<SaleorBulkProductError>;
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorBulkProductError>;
  /** List of the created variants.This field will be removed in Saleor 4.0. */
  productVariants: Array<SaleorProductVariant>;
  /**
   * List of the created variants.
   *
   * Added in Saleor 3.11.
   */
  results: Array<SaleorProductVariantBulkResult>;
};

export type SaleorProductVariantBulkCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<SaleorBulkAttributeValueInput>;
  /** List of prices assigned to channels. */
  channelListings?: InputMaybe<Array<SaleorProductVariantChannelListingAddInput>>;
  /**
   * External ID of this product variant.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determines if variant is in preorder.
   *
   * Added in Saleor 3.1.
   */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout.
   *
   * Added in Saleor 3.1.
   */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<SaleorStockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/**
 * Deletes product variants.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkDelete = {
  __typename?: 'SaleorProductVariantBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductVariantBulkError = {
  __typename?: 'SaleorProductVariantBulkError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel listings IDs which causes the error. */
  channelListings?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * List of channel IDs which causes the error.
   *
   * Added in Saleor 3.12.
   */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorProductVariantBulkErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * List of stocks IDs which causes the error.
   *
   * Added in Saleor 3.12.
   */
  stocks?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorProductVariantBulkErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorProductVariantBulkResult = {
  __typename?: 'SaleorProductVariantBulkResult';
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<SaleorProductVariantBulkError>>;
  /** Product variant data. */
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Update multiple product variants.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantBulkUpdate = {
  __typename?: 'SaleorProductVariantBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorProductVariantBulkError>;
  /** List of the updated variants. */
  results: Array<SaleorProductVariantBulkResult>;
};

/**
 * Input fields to update product variants.
 *
 * Added in Saleor 3.11.
 */
export type SaleorProductVariantBulkUpdateInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<SaleorBulkAttributeValueInput>>;
  /**
   * Channel listings input.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  channelListings?: InputMaybe<SaleorProductVariantChannelListingUpdateInput>;
  /**
   * External ID of this product variant.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product variant to update. */
  id: Scalars['ID']['input'];
  /**
   * Fields required to update the product variant metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determines if variant is in preorder.
   *
   * Added in Saleor 3.1.
   */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout.
   *
   * Added in Saleor 3.1.
   */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stocks input.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  stocks?: InputMaybe<SaleorProductVariantStocksUpdateInput>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/** Represents product varaint channel listing. */
export type SaleorProductVariantChannelListing = SaleorNode & {
  __typename?: 'SaleorProductVariantChannelListing';
  channel: SaleorChannel;
  /** Cost price of the variant. */
  costPrice?: Maybe<SaleorMoney>;
  id: Scalars['ID']['output'];
  /**
   * Gross margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin?: Maybe<Scalars['Int']['output']>;
  /**
   * Preorder variant data.
   *
   * Added in Saleor 3.1.
   */
  preorderThreshold?: Maybe<SaleorPreorderThreshold>;
  price?: Maybe<SaleorMoney>;
};

export type SaleorProductVariantChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /**
   * The threshold for preorder variant in channel.
   *
   * Added in Saleor 3.1.
   */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price: Scalars['SaleorPositiveDecimal']['input'];
};

/**
 * Manage product variant prices in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantChannelListingUpdate = {
  __typename?: 'SaleorProductVariantChannelListingUpdate';
  errors: Array<SaleorProductChannelListingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productChannelListingErrors: Array<SaleorProductChannelListingError>;
  /** An updated product variant instance. */
  variant?: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantChannelListingUpdateInput = {
  /** List of channels to create variant channel listings. */
  create?: InputMaybe<Array<SaleorProductVariantChannelListingAddInput>>;
  /** List of channel listings to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channel listings to update. */
  update?: InputMaybe<Array<SaleorChannelListingUpdateInput>>;
};

export type SaleorProductVariantCountableConnection = {
  __typename?: 'SaleorProductVariantCountableConnection';
  edges: Array<SaleorProductVariantCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorProductVariantCountableEdge = {
  __typename?: 'SaleorProductVariantCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorProductVariant;
};

/**
 * Creates a new variant for a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantCreate = {
  __typename?: 'SaleorProductVariantCreate';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant?: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<SaleorAttributeValueInput>;
  /**
   * External ID of this product variant.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determines if variant is in preorder.
   *
   * Added in Saleor 3.1.
   */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Product ID of which type is the variant. */
  product: Scalars['ID']['input'];
  /**
   * Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout.
   *
   * Added in Saleor 3.1.
   */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<SaleorStockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/**
 * Event sent when new product variant is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantCreated = SaleorEvent & {
  __typename?: 'SaleorProductVariantCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new product variant is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantCreatedproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantDelete = {
  __typename?: 'SaleorProductVariantDelete';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Event sent when product variant is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantDeleted = SaleorEvent & {
  __typename?: 'SaleorProductVariantDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product variant is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantDeletedproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorProductVariantFilterInput = {
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorProductVariantInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<SaleorAttributeValueInput>>;
  /**
   * External ID of this product variant.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata.
   *
   * Added in Saleor 3.8.
   */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determines if variant is in preorder.
   *
   * Added in Saleor 3.1.
   */
  preorder?: InputMaybe<SaleorPreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata.
   *
   * Added in Saleor 3.8.
   */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout.
   *
   * Added in Saleor 3.1.
   */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
};

/**
 * Event sent when product variant metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorProductVariantMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorProductVariantMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product variant metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorProductVariantMetadataUpdatedproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when product variant is out of stock.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantOutOfStock = SaleorEvent & {
  __typename?: 'SaleorProductVariantOutOfStock';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<SaleorWarehouse>;
};


/**
 * Event sent when product variant is out of stock.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantOutOfStockproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
 *
 * Added in Saleor 3.1.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantPreorderDeactivate = {
  __typename?: 'SaleorProductVariantPreorderDeactivate';
  errors: Array<SaleorProductError>;
  /** Product variant with ended preorder. */
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantReorder = {
  __typename?: 'SaleorProductVariantReorder';
  errors: Array<SaleorProductError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

/**
 * Reorder product variant attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantReorderAttributeValues = {
  __typename?: 'SaleorProductVariantReorderAttributeValues';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  /** Product variant from which attribute values are reordered. */
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantSetDefault = {
  __typename?: 'SaleorProductVariantSetDefault';
  errors: Array<SaleorProductError>;
  product?: Maybe<SaleorProduct>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
};

export type SaleorProductVariantSortField =
  /** Sort products variants by last modified at. */
  | 'LAST_MODIFIED_AT';

export type SaleorProductVariantSortingInput = {
  /** Specifies the direction in which to sort productVariants. */
  direction: SaleorOrderDirection;
  /** Sort productVariants by the selected field. */
  field: SaleorProductVariantSortField;
};

/**
 * Event sent when product variant stock is updated.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorProductVariantStockUpdated = SaleorEvent & {
  __typename?: 'SaleorProductVariantStockUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<SaleorWarehouse>;
};


/**
 * Event sent when product variant stock is updated.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorProductVariantStockUpdatedproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksCreate = {
  __typename?: 'SaleorProductVariantStocksCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  bulkStockErrors: Array<SaleorBulkStockError>;
  errors: Array<SaleorBulkStockError>;
  /** Updated product variant. */
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Delete stocks from product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksDelete = {
  __typename?: 'SaleorProductVariantStocksDelete';
  errors: Array<SaleorStockError>;
  /** Updated product variant. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  stockErrors: Array<SaleorStockError>;
};

/**
 * Update stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantStocksUpdate = {
  __typename?: 'SaleorProductVariantStocksUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  bulkStockErrors: Array<SaleorBulkStockError>;
  errors: Array<SaleorBulkStockError>;
  /** Updated product variant. */
  productVariant?: Maybe<SaleorProductVariant>;
};

export type SaleorProductVariantStocksUpdateInput = {
  /** List of warehouses to create stocks. */
  create?: InputMaybe<Array<SaleorStockInput>>;
  /** List of stocks to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of stocks to update. */
  update?: InputMaybe<Array<SaleorStockUpdateInput>>;
};

export type SaleorProductVariantTranslatableContent = SaleorNode & {
  __typename?: 'SaleorProductVariantTranslatableContent';
  /** List of product variant attribute values that can be translated. */
  attributeValues: Array<SaleorAttributeValueTranslatableContent>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Represents a version of a product such as different size or color.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  productVariant?: Maybe<SaleorProductVariant>;
  /** Returns translated product variant fields for the given language code. */
  translation?: Maybe<SaleorProductVariantTranslation>;
};


export type SaleorProductVariantTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a product variant.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorProductVariantTranslate = {
  __typename?: 'SaleorProductVariantTranslate';
  errors: Array<SaleorTranslationError>;
  productVariant?: Maybe<SaleorProductVariant>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorProductVariantTranslation = SaleorNode & {
  __typename?: 'SaleorProductVariantTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name: Scalars['String']['output'];
};

/**
 * Updates an existing variant for product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorProductVariantUpdate = {
  __typename?: 'SaleorProductVariantUpdate';
  errors: Array<SaleorProductError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Event sent when product variant is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantUpdated = SaleorEvent & {
  __typename?: 'SaleorProductVariantUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<SaleorProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when product variant is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorProductVariantUpdatedproductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorPublishableChannelListingInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['SaleorDate']['input']>;
  /**
   * Publication date time. ISO 8601 standard.
   *
   * Added in Saleor 3.3.
   */
  publishedAt?: InputMaybe<Scalars['SaleorDateTime']['input']>;
};

/** Represents a reduced VAT rate for a particular type of goods. */
export type SaleorReducedRate = {
  __typename?: 'SaleorReducedRate';
  /** Reduced VAT rate in percent. */
  rate: Scalars['Float']['output'];
  /** A type of goods. */
  rateType: Scalars['String']['output'];
};

/** Refresh JWT token. Mutation tries to take refreshToken from the input.If it fails it will try to take refreshToken from the http-only cookie -refreshToken. csrfToken is required when refreshToken is provided as a cookie. */
export type SaleorRefreshToken = {
  __typename?: 'SaleorRefreshToken';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

export type SaleorReorderInput = {
  /** The ID of the item to move. */
  id: Scalars['ID']['input'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type SaleorReportingPeriod =
  | 'THIS_MONTH'
  | 'TODAY';

/**
 * Request email change of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type SaleorRequestEmailChange = {
  __typename?: 'SaleorRequestEmailChange';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

/** Sends an email with the account password modification link. */
export type SaleorRequestPasswordReset = {
  __typename?: 'SaleorRequestPasswordReset';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
};

/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSale = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorSale';
  /** List of categories this sale applies to. */
  categories?: Maybe<SaleorCategoryCountableConnection>;
  /**
   * List of channels available for the sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings?: Maybe<Array<SaleorSaleChannelListing>>;
  /**
   * List of collections this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections?: Maybe<SaleorCollectionCountableConnection>;
  created: Scalars['SaleorDateTime']['output'];
  /** Currency code for sale. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Sale value. */
  discountValue?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['SaleorDateTime']['output']>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * List of products this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products?: Maybe<SaleorProductCountableConnection>;
  startDate: Scalars['SaleorDateTime']['output'];
  /** Returns translated sale fields for the given language code. */
  translation?: Maybe<SaleorSaleTranslation>;
  type: SaleorSaleType;
  updatedAt: Scalars['SaleorDateTime']['output'];
  /**
   * List of product variants this sale applies to.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants?: Maybe<SaleorProductVariantCountableConnection>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSalecategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSalecollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSalemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSalemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSaleprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSaleprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSaleproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSaletranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/** Sales allow creating discounts for categories, collections or products and are visible to all the customers. */
export type SaleorSalevariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleAddCatalogues = {
  __typename?: 'SaleorSaleAddCatalogues';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale?: Maybe<SaleorSale>;
};

/**
 * Deletes sales.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleBulkDelete = {
  __typename?: 'SaleorSaleBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
};

/** Represents sale channel listing. */
export type SaleorSaleChannelListing = SaleorNode & {
  __typename?: 'SaleorSaleChannelListing';
  channel: SaleorChannel;
  currency: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
};

export type SaleorSaleChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** The value of the discount. */
  discountValue: Scalars['SaleorPositiveDecimal']['input'];
};

export type SaleorSaleChannelListingInput = {
  /** List of channels to which the sale should be assigned. */
  addChannels?: InputMaybe<Array<SaleorSaleChannelListingAddInput>>;
  /** List of channels from which the sale should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage sale's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleChannelListingUpdate = {
  __typename?: 'SaleorSaleChannelListingUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** An updated sale instance. */
  sale?: Maybe<SaleorSale>;
};

export type SaleorSaleCountableConnection = {
  __typename?: 'SaleorSaleCountableConnection';
  edges: Array<SaleorSaleCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorSaleCountableEdge = {
  __typename?: 'SaleorSaleCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorSale;
};

/**
 * Creates a new sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleCreate = {
  __typename?: 'SaleorSaleCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale?: Maybe<SaleorSale>;
};

/**
 * Event sent when new sale is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleCreated = SaleorEvent & {
  __typename?: 'SaleorSaleCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale?: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new sale is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleCreatedsaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleDelete = {
  __typename?: 'SaleorSaleDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale?: Maybe<SaleorSale>;
};

/**
 * Event sent when sale is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleDeleted = SaleorEvent & {
  __typename?: 'SaleorSaleDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale?: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleDeletedsaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorSaleFilterInput = {
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  saleType?: InputMaybe<SaleorDiscountValueTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<Array<SaleorDiscountStatusEnum>>;
  updatedAt?: InputMaybe<SaleorDateTimeRangeInput>;
};

export type SaleorSaleInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Fixed or percentage. */
  type?: InputMaybe<SaleorDiscountValueTypeEnum>;
  /** Value of the voucher. */
  value?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Removes products, categories, collections from a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleRemoveCatalogues = {
  __typename?: 'SaleorSaleRemoveCatalogues';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale?: Maybe<SaleorSale>;
};

export type SaleorSaleSortField =
  /** Sort sales by created at. */
  | 'CREATED_AT'
  /** Sort sales by end date. */
  | 'END_DATE'
  /** Sort sales by last modified at. */
  | 'LAST_MODIFIED_AT'
  /** Sort sales by name. */
  | 'NAME'
  /** Sort sales by start date. */
  | 'START_DATE'
  /** Sort sales by type. */
  | 'TYPE'
  /**
   * Sort sales by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type SaleorSaleSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort sales. */
  direction: SaleorOrderDirection;
  /** Sort sales by the selected field. */
  field: SaleorSaleSortField;
};

/**
 * The event informs about the start or end of the sale.
 *
 * Added in Saleor 3.5.
 */
export type SaleorSaleToggle = SaleorEvent & {
  __typename?: 'SaleorSaleToggle';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /**
   * The sale the event relates to.
   *
   * Added in Saleor 3.5.
   */
  sale?: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * The event informs about the start or end of the sale.
 *
 * Added in Saleor 3.5.
 */
export type SaleorSaleTogglesaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorSaleTranslatableContent = SaleorNode & {
  __typename?: 'SaleorSaleTranslatableContent';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  sale?: Maybe<SaleorSale>;
  /** Returns translated sale fields for the given language code. */
  translation?: Maybe<SaleorSaleTranslation>;
};


export type SaleorSaleTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a sale.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorSaleTranslate = {
  __typename?: 'SaleorSaleTranslate';
  errors: Array<SaleorTranslationError>;
  sale?: Maybe<SaleorSale>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorSaleTranslation = SaleorNode & {
  __typename?: 'SaleorSaleTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
};

export type SaleorSaleType =
  | 'FIXED'
  | 'PERCENTAGE';

/**
 * Updates a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorSaleUpdate = {
  __typename?: 'SaleorSaleUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  sale?: Maybe<SaleorSale>;
};

/**
 * Event sent when sale is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleUpdated = SaleorEvent & {
  __typename?: 'SaleorSaleUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The sale the event relates to. */
  sale?: Maybe<SaleorSale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorSaleUpdatedsaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a custom attribute. */
export type SaleorSelectedAttribute = {
  __typename?: 'SaleorSelectedAttribute';
  /** Name of an attribute displayed in the interface. */
  attribute: SaleorAttribute;
  /** Values of an attribute. */
  values: Array<SaleorAttributeValue>;
};

export type SaleorSeoInput = {
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** SEO title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
export type SaleorSetPassword = {
  __typename?: 'SaleorSetPassword';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<SaleorAccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<SaleorUser>;
};

export type SaleorShippingError = {
  __typename?: 'SaleorShippingError';
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: SaleorShippingErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorShippingErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LESS_THAN_MIN'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/**
 * List shipping methods for checkout.
 *
 * Added in Saleor 3.6.
 */
export type SaleorShippingListMethodsForCheckout = SaleorEvent & {
  __typename?: 'SaleorShippingListMethodsForCheckout';
  /** The checkout the event relates to. */
  checkout?: Maybe<SaleorCheckout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Added in Saleor 3.6.
   */
  shippingMethods?: Maybe<Array<SaleorShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethod = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorShippingMethod';
  /** Describes if this shipping method is active and can be selected. */
  active: Scalars['Boolean']['output'];
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** Unique ID of ShippingMethod available for Order. */
  id: Scalars['ID']['output'];
  /** Maximum delivery days for this shipping method. */
  maximumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Maximum order price for this shipping method. */
  maximumOrderPrice?: Maybe<SaleorMoney>;
  /**
   * Maximum order weight for this shipping method.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  maximumOrderWeight?: Maybe<SaleorWeight>;
  /** Message connected to this shipping method. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Minimum delivery days for this shipping method. */
  minimumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Minimal order price for this shipping method. */
  minimumOrderPrice?: Maybe<SaleorMoney>;
  /**
   * Minimum order weight for this shipping method.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  minimumOrderWeight?: Maybe<SaleorWeight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** The price of selected shipping method. */
  price: SaleorMoney;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<SaleorShippingMethodTranslation>;
  /**
   * Type of the shipping method.
   * @deprecated This field will be removed in Saleor 4.0.
   */
  type?: Maybe<SaleorShippingMethodTypeEnum>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodmetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type SaleorShippingMethodtranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** Represents shipping method channel listing. */
export type SaleorShippingMethodChannelListing = SaleorNode & {
  __typename?: 'SaleorShippingMethodChannelListing';
  channel: SaleorChannel;
  id: Scalars['ID']['output'];
  maximumOrderPrice?: Maybe<SaleorMoney>;
  minimumOrderPrice?: Maybe<SaleorMoney>;
  price?: Maybe<SaleorMoney>;
};

export type SaleorShippingMethodChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Maximum order price to use this shipping method. */
  maximumOrderPrice?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** Minimum order price to use this shipping method. */
  minimumOrderPrice?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** Shipping price of the shipping method in this channel. */
  price?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
};

export type SaleorShippingMethodChannelListingInput = {
  /** List of channels to which the shipping method should be assigned. */
  addChannels?: InputMaybe<Array<SaleorShippingMethodChannelListingAddInput>>;
  /** List of channels from which the shipping method should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage shipping method's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingMethodChannelListingUpdate = {
  __typename?: 'SaleorShippingMethodChannelListingUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** An updated shipping method instance. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
};

/** Represents shipping method postal code rule. */
export type SaleorShippingMethodPostalCodeRule = SaleorNode & {
  __typename?: 'SaleorShippingMethodPostalCodeRule';
  /** End address range. */
  end?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Inclusion type of the postal code rule. */
  inclusionType?: Maybe<SaleorPostalCodeRuleInclusionTypeEnum>;
  /** Start address range. */
  start?: Maybe<Scalars['String']['output']>;
};

export type SaleorShippingMethodTranslatableContent = SaleorNode & {
  __typename?: 'SaleorShippingMethodTranslatableContent';
  /**
   * Description of the shipping method.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Shipping method are the methods you'll use to get customer's orders  to them. They are directly exposed to the customers.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<SaleorShippingMethodTranslation>;
};


export type SaleorShippingMethodTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

export type SaleorShippingMethodTranslation = SaleorNode & {
  __typename?: 'SaleorShippingMethodTranslation';
  /**
   * Translated description of the shipping method.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
};

/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodType = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorShippingMethodType';
  /**
   * List of channels available for the method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  channelListings?: Maybe<Array<SaleorShippingMethodChannelListing>>;
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['SaleorJSONString']['output']>;
  /**
   * List of excluded products for the shipping method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  excludedProducts?: Maybe<SaleorProductCountableConnection>;
  /** Shipping method ID. */
  id: Scalars['ID']['output'];
  /** Maximum number of days for delivery. */
  maximumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  maximumOrderPrice?: Maybe<SaleorMoney>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight?: Maybe<SaleorWeight>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  minimumOrderPrice?: Maybe<SaleorMoney>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight?: Maybe<SaleorWeight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** Postal code ranges rule of exclusion or inclusion of the shipping method. */
  postalCodeRules?: Maybe<Array<SaleorShippingMethodPostalCodeRule>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * Tax class assigned to this shipping method.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<SaleorTaxClass>;
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<SaleorShippingMethodTranslation>;
  /** Type of the shipping method. */
  type?: Maybe<SaleorShippingMethodTypeEnum>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeexcludedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypeprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type SaleorShippingMethodTypetranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/** An enumeration. */
export type SaleorShippingMethodTypeEnum =
  | 'PRICE'
  | 'WEIGHT';

/**
 * List of shipping methods available for the country.
 *
 * Added in Saleor 3.6.
 */
export type SaleorShippingMethodsPerCountry = {
  __typename?: 'SaleorShippingMethodsPerCountry';
  /** The country code. */
  countryCode: SaleorCountryCode;
  /** List of available shipping methods. */
  shippingMethods?: Maybe<Array<SaleorShippingMethod>>;
};

export type SaleorShippingPostalCodeRulesCreateInputRange = {
  /** End range of the postal code. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start range of the postal code. */
  start: Scalars['String']['input'];
};

/**
 * Deletes shipping prices.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceBulkDelete = {
  __typename?: 'SaleorShippingPriceBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
};

/**
 * Creates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceCreate = {
  __typename?: 'SaleorShippingPriceCreate';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<SaleorShippingZone>;
};

/**
 * Event sent when new shipping price is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceCreated = SaleorEvent & {
  __typename?: 'SaleorShippingPriceCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new shipping price is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceCreatedshippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Event sent when new shipping price is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceCreatedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceDelete = {
  __typename?: 'SaleorShippingPriceDelete';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method to delete. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<SaleorShippingZone>;
};

/**
 * Event sent when shipping price is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceDeleted = SaleorEvent & {
  __typename?: 'SaleorShippingPriceDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when shipping price is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceDeletedshippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Event sent when shipping price is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceDeletedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Exclude products from shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceExcludeProducts = {
  __typename?: 'SaleorShippingPriceExcludeProducts';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
};

export type SaleorShippingPriceExcludeProductsInput = {
  /** List of products which will be excluded. */
  products: Array<Scalars['ID']['input']>;
};

export type SaleorShippingPriceInput = {
  /** Postal code rules to add. */
  addPostalCodeRules?: InputMaybe<Array<SaleorShippingPostalCodeRulesCreateInputRange>>;
  /** Postal code rules to delete. */
  deletePostalCodeRules?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Shipping method description. */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /** Inclusion type for currently assigned postal code rules. */
  inclusionType?: InputMaybe<SaleorPostalCodeRuleInclusionTypeEnum>;
  /** Maximum number of days for delivery. */
  maximumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight?: InputMaybe<Scalars['SaleorWeightScalar']['input']>;
  /** Name of the shipping method. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone this method belongs to. */
  shippingZone?: InputMaybe<Scalars['ID']['input']>;
  /** ID of a tax class to assign to this shipping method. If not provided, the default tax class will be used. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /** Shipping type: price or weight based. */
  type?: InputMaybe<SaleorShippingMethodTypeEnum>;
};

/**
 * Remove product from excluded list for shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceRemoveProductFromExclude = {
  __typename?: 'SaleorShippingPriceRemoveProductFromExclude';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
};

/**
 * Creates/updates translations for a shipping method.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorShippingPriceTranslate = {
  __typename?: 'SaleorShippingPriceTranslate';
  errors: Array<SaleorTranslationError>;
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorShippingPriceTranslationInput = {
  /**
   * Translated shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingPriceUpdate = {
  __typename?: 'SaleorShippingPriceUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<SaleorShippingZone>;
};

/**
 * Event sent when shipping price is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceUpdated = SaleorEvent & {
  __typename?: 'SaleorShippingPriceUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<SaleorShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when shipping price is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceUpdatedshippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Event sent when shipping price is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingPriceUpdatedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZone = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorShippingZone';
  /** List of channels for shipping zone. */
  channels: Array<SaleorChannel>;
  /** List of countries available for the method. */
  countries: Array<SaleorCountryDisplay>;
  default: Scalars['Boolean']['output'];
  /** Description of a shipping zone. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** Lowest and highest prices for the shipping. */
  priceRange?: Maybe<SaleorMoneyRange>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of shipping methods available for orders shipped to countries within this shipping zone. */
  shippingMethods?: Maybe<Array<SaleorShippingMethodType>>;
  /** List of warehouses for shipping zone. */
  warehouses: Array<SaleorWarehouse>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZonemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZonemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZoneprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type SaleorShippingZoneprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes shipping zones.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneBulkDelete = {
  __typename?: 'SaleorShippingZoneBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
};

export type SaleorShippingZoneCountableConnection = {
  __typename?: 'SaleorShippingZoneCountableConnection';
  edges: Array<SaleorShippingZoneCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorShippingZoneCountableEdge = {
  __typename?: 'SaleorShippingZoneCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorShippingZone;
};

/**
 * Creates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneCreate = {
  __typename?: 'SaleorShippingZoneCreate';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone?: Maybe<SaleorShippingZone>;
};

export type SaleorShippingZoneCreateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new shipping zone is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneCreated = SaleorEvent & {
  __typename?: 'SaleorShippingZoneCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new shipping zone is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneCreatedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneDelete = {
  __typename?: 'SaleorShippingZoneDelete';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone?: Maybe<SaleorShippingZone>;
};

/**
 * Event sent when shipping zone is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneDeleted = SaleorEvent & {
  __typename?: 'SaleorShippingZoneDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when shipping zone is deleted.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneDeletedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorShippingZoneFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when shipping zone metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorShippingZoneMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorShippingZoneMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when shipping zone metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorShippingZoneMetadataUpdatedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type SaleorShippingZoneUpdate = {
  __typename?: 'SaleorShippingZoneUpdate';
  errors: Array<SaleorShippingError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shippingErrors: Array<SaleorShippingError>;
  shippingZone?: Maybe<SaleorShippingZone>;
};

export type SaleorShippingZoneUpdateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of channels to unassign from the shipping zone. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to unassign from a shipping zone */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Event sent when shipping zone is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneUpdated = SaleorEvent & {
  __typename?: 'SaleorShippingZoneUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<SaleorShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when shipping zone is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorShippingZoneUpdatedshippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShop = {
  __typename?: 'SaleorShop';
  /**
   * Enable automatic fulfillment for all digital products.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  automaticFulfillmentDigitalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** List of available external authentications. */
  availableExternalAuthentications: Array<SaleorExternalAuthentication>;
  /** List of available payment gateways. */
  availablePaymentGateways: Array<SaleorPaymentGateway>;
  /** Shipping methods that are available for the shop. */
  availableShippingMethods?: Maybe<Array<SaleorShippingMethod>>;
  /**
   * List of all currencies supported by shop's channels.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  channelCurrencies: Array<Scalars['String']['output']>;
  /**
   * Charge taxes on shipping.
   * @deprecated This field will be removed in Saleor 4.0. Use `ShippingMethodType.taxClass` to determine whether taxes are calculated for shipping methods; if a tax class is set, the taxes will be calculated, otherwise no tax rate will be applied.
   */
  chargeTaxesOnShipping: Scalars['Boolean']['output'];
  /** Company address. */
  companyAddress?: Maybe<SaleorAddress>;
  /** List of countries available in the shop. */
  countries: Array<SaleorCountryDisplay>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: Maybe<Scalars['String']['output']>;
  /** Shop's default country. */
  defaultCountry?: Maybe<SaleorCountryDisplay>;
  /**
   * Default number of max downloads per digital content URL.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalMaxDownloads?: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of days which digital content URL will be valid.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalUrlValidDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Default shop's email sender's address.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderAddress?: Maybe<Scalars['String']['output']>;
  /**
   * Default shop's email sender's name.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderName?: Maybe<Scalars['String']['output']>;
  /** Default weight unit. */
  defaultWeightUnit?: Maybe<SaleorWeightUnitsEnum>;
  /** Shop's description. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Display prices with tax in store.
   * @deprecated This field will be removed in Saleor 4.0. Use `Channel.taxConfiguration` to determine whether to display gross or net prices.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Shop's domain data. */
  domain: SaleorDomain;
  /**
   * Allow to approve fulfillments which are unpaid.
   *
   * Added in Saleor 3.1.
   */
  fulfillmentAllowUnpaid: Scalars['Boolean']['output'];
  /**
   * Automatically approve all new fulfillments.
   *
   * Added in Saleor 3.1.
   */
  fulfillmentAutoApprove: Scalars['Boolean']['output'];
  /** Header text. */
  headerText?: Maybe<Scalars['String']['output']>;
  /**
   * Include taxes in prices.
   * @deprecated This field will be removed in Saleor 4.0. Use `Channel.taxConfiguration.pricesEnteredWithTax` to determine whether prices are entered with tax.
   */
  includeTaxesInPrices: Scalars['Boolean']['output'];
  /** List of the shops's supported languages. */
  languages: Array<SaleorLanguageDisplay>;
  /**
   * Default number of maximum line quantity in single checkout (per single checkout line).
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  limitQuantityPerCheckout?: Maybe<Scalars['Int']['output']>;
  /**
   * Resource limitations and current usage if any set for a shop
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  limits: SaleorLimitInfo;
  /** Shop's name. */
  name: Scalars['String']['output'];
  /** List of available permissions. */
  permissions: Array<SaleorPermission>;
  /** List of possible phone prefixes. */
  phonePrefixes: Array<Scalars['String']['output']>;
  /**
   * Default number of minutes stock will be reserved for anonymous checkout or null when stock reservation is disabled.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAnonymousUser?: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of minutes stock will be reserved for authenticated checkout or null when stock reservation is disabled.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAuthenticatedUser?: Maybe<Scalars['Int']['output']>;
  /**
   * Minor Saleor API version.
   *
   * Added in Saleor 3.5.
   */
  schemaVersion: Scalars['String']['output'];
  /**
   * List of staff notification recipients.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipients?: Maybe<Array<SaleorStaffNotificationRecipient>>;
  /** Enable inventory tracking. */
  trackInventoryByDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Returns translated shop fields for the given language code. */
  translation?: Maybe<SaleorShopTranslation>;
  /**
   * Saleor API version.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  version: Scalars['String']['output'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopavailablePaymentGatewaysArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopavailableShippingMethodsArgs = {
  address?: InputMaybe<SaleorAddressInput>;
  channel: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShopcountriesArgs = {
  filter?: InputMaybe<SaleorCountryFilterInput>;
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type SaleorShoptranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopAddressUpdate = {
  __typename?: 'SaleorShopAddressUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop?: Maybe<SaleorShop>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

/**
 * Updates site domain of the shop.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopDomainUpdate = {
  __typename?: 'SaleorShopDomainUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop?: Maybe<SaleorShop>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

export type SaleorShopError = {
  __typename?: 'SaleorShopError';
  /** The error code. */
  code: SaleorShopErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorShopErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_FETCH_TAX_RATES'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/**
 * Fetch tax rates.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopFetchTaxRates = {
  __typename?: 'SaleorShopFetchTaxRates';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop?: Maybe<SaleorShop>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

export type SaleorShopSettingsInput = {
  /** Enable automatic fulfillment for all digital products. */
  automaticFulfillmentDigitalProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Charge taxes on shipping.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. To enable taxes for a shipping method, assign a tax class to the shipping method with `shippingPriceCreate` or `shippingPriceUpdate` mutations.
   */
  chargeTaxesOnShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: InputMaybe<Scalars['String']['input']>;
  /** Default number of max downloads per digital content URL. */
  defaultDigitalMaxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of days which digital content URL will be valid. */
  defaultDigitalUrlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default email sender's address. */
  defaultMailSenderAddress?: InputMaybe<Scalars['String']['input']>;
  /** Default email sender's name. */
  defaultMailSenderName?: InputMaybe<Scalars['String']['input']>;
  /** Default weight unit. */
  defaultWeightUnit?: InputMaybe<SaleorWeightUnitsEnum>;
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Display prices with tax in store.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Enable ability to approve fulfillments which are unpaid.
   *
   * Added in Saleor 3.1.
   */
  fulfillmentAllowUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Enable automatic approval of all new fulfillments.
   *
   * Added in Saleor 3.1.
   */
  fulfillmentAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  /** Header text. */
  headerText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Include taxes in prices.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  includeTaxesInPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Default number of maximum line quantity in single checkout. Minimum possible value is 1, default value is 50.
   *
   * Added in Saleor 3.1.
   */
  limitQuantityPerCheckout?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Default number of minutes stock will be reserved for anonymous checkout. Enter 0 or null to disable.
   *
   * Added in Saleor 3.1.
   */
  reserveStockDurationAnonymousUser?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Default number of minutes stock will be reserved for authenticated checkout. Enter 0 or null to disable.
   *
   * Added in Saleor 3.1.
   */
  reserveStockDurationAuthenticatedUser?: InputMaybe<Scalars['Int']['input']>;
  /** Enable inventory tracking. */
  trackInventoryByDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Creates/updates translations for shop settings.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorShopSettingsTranslate = {
  __typename?: 'SaleorShopSettingsTranslate';
  errors: Array<SaleorTranslationError>;
  /** Updated shop settings. */
  shop?: Maybe<SaleorShop>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
};

export type SaleorShopSettingsTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates shop settings.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorShopSettingsUpdate = {
  __typename?: 'SaleorShopSettingsUpdate';
  errors: Array<SaleorShopError>;
  /** Updated shop. */
  shop?: Maybe<SaleorShop>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
};

export type SaleorShopTranslation = SaleorNode & {
  __typename?: 'SaleorShopTranslation';
  description: Scalars['String']['output'];
  headerText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
};

export type SaleorSiteDomainInput = {
  /** Domain name for shop. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Shop site name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes staff users. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorStaffBulkDelete = {
  __typename?: 'SaleorStaffBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorStaffError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
};

/**
 * Creates a new staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorStaffCreate = {
  __typename?: 'SaleorStaffCreate';
  errors: Array<SaleorStaffError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user?: Maybe<SaleorUser>;
};

/** Fields required to create a staff user. */
export type SaleorStaffCreateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new staff user is created.
 *
 * Added in Saleor 3.5.
 */
export type SaleorStaffCreated = SaleorEvent & {
  __typename?: 'SaleorStaffCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorStaffDelete = {
  __typename?: 'SaleorStaffDelete';
  errors: Array<SaleorStaffError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user?: Maybe<SaleorUser>;
};

/**
 * Event sent when staff user is deleted.
 *
 * Added in Saleor 3.5.
 */
export type SaleorStaffDeleted = SaleorEvent & {
  __typename?: 'SaleorStaffDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorStaffError = {
  __typename?: 'SaleorStaffError';
  /** A type of address that causes the error. */
  addressType?: Maybe<SaleorAddressTypeEnum>;
  /** The error code. */
  code: SaleorAccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of permission group IDs which cause the error. */
  groups?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<SaleorPermissionEnum>>;
  /** List of user IDs which causes the error. */
  users?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Represents status of a staff account. */
export type SaleorStaffMemberStatus =
  /** User account has been activated. */
  | 'ACTIVE'
  /** User account has not been activated yet. */
  | 'DEACTIVATED';

/** Represents a recipient of email notifications send by Saleor, such as notifications about new orders. Notifications can be assigned to staff users or arbitrary email addresses. */
export type SaleorStaffNotificationRecipient = SaleorNode & {
  __typename?: 'SaleorStaffNotificationRecipient';
  /** Determines if a notification active. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Returns email address of a user subscribed to email notifications. */
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Returns a user subscribed to email notifications. */
  user?: Maybe<SaleorUser>;
};

/**
 * Creates a new staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientCreate = {
  __typename?: 'SaleorStaffNotificationRecipientCreate';
  errors: Array<SaleorShopError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient?: Maybe<SaleorStaffNotificationRecipient>;
};

/**
 * Delete staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientDelete = {
  __typename?: 'SaleorStaffNotificationRecipientDelete';
  errors: Array<SaleorShopError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient?: Maybe<SaleorStaffNotificationRecipient>;
};

export type SaleorStaffNotificationRecipientInput = {
  /** Determines if a notification active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email address of a user subscribed to email notifications. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user subscribed to email notifications.. */
  user?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Updates a staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type SaleorStaffNotificationRecipientUpdate = {
  __typename?: 'SaleorStaffNotificationRecipientUpdate';
  errors: Array<SaleorShopError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  shopErrors: Array<SaleorShopError>;
  staffNotificationRecipient?: Maybe<SaleorStaffNotificationRecipient>;
};

/**
 * Updates an existing staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 */
export type SaleorStaffUpdate = {
  __typename?: 'SaleorStaffUpdate';
  errors: Array<SaleorStaffError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  staffErrors: Array<SaleorStaffError>;
  user?: Maybe<SaleorUser>;
};

/** Fields required to update a staff user. */
export type SaleorStaffUpdateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** List of permission group IDs from which user should be unassigned. */
  removeGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Event sent when staff user is updated.
 *
 * Added in Saleor 3.5.
 */
export type SaleorStaffUpdated = SaleorEvent & {
  __typename?: 'SaleorStaffUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The user the event relates to. */
  user?: Maybe<SaleorUser>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorStaffUserInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SaleorStaffMemberStatus>;
};

/** Represents stock. */
export type SaleorStock = SaleorNode & {
  __typename?: 'SaleorStock';
  id: Scalars['ID']['output'];
  productVariant: SaleorProductVariant;
  /**
   * Quantity of a product in the warehouse's possession, including the allocated stock that is waiting for shipment.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityAllocated: Scalars['Int']['output'];
  /**
   * Quantity reserved for checkouts.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityReserved: Scalars['Int']['output'];
  warehouse: SaleorWarehouse;
};

export type SaleorStockAvailability =
  | 'IN_STOCK'
  | 'OUT_OF_STOCK';

export type SaleorStockBulkResult = {
  __typename?: 'SaleorStockBulkResult';
  /** List of errors occurred on create or update attempt. */
  errors?: Maybe<Array<SaleorStockBulkUpdateError>>;
  /** Stock data. */
  stock?: Maybe<SaleorStock>;
};

/**
 * Updates stocks for a given variant and warehouse.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorStockBulkUpdate = {
  __typename?: 'SaleorStockBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorStockBulkUpdateError>;
  /** List of the updated stocks. */
  results: Array<SaleorStockBulkResult>;
};

export type SaleorStockBulkUpdateError = {
  __typename?: 'SaleorStockBulkUpdateError';
  /** The error code. */
  code: SaleorStockBulkUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorStockBulkUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorStockBulkUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Variant external reference. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Variant ID. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** Warehouse external reference. */
  warehouseExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse ID. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorStockCountableConnection = {
  __typename?: 'SaleorStockCountableConnection';
  edges: Array<SaleorStockCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorStockCountableEdge = {
  __typename?: 'SaleorStockCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorStock;
};

export type SaleorStockError = {
  __typename?: 'SaleorStockError';
  /** The error code. */
  code: SaleorStockErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorStockErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorStockFilterInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorStockInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Warehouse in which stock is located. */
  warehouse: Scalars['ID']['input'];
};

/**
 * Represents the channel stock settings.
 *
 * Added in Saleor 3.7.
 */
export type SaleorStockSettings = {
  __typename?: 'SaleorStockSettings';
  /** Allocation strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: SaleorAllocationStrategyEnum;
};

export type SaleorStockSettingsInput = {
  /** Allocation strategy options. Strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: SaleorAllocationStrategyEnum;
};

export type SaleorStockUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Stock. */
  stock: Scalars['ID']['input'];
};

/** Enum representing the type of a payment storage in a gateway. */
export type SaleorStorePaymentMethodEnum =
  /** Storage is disabled. The payment is not stored. */
  | 'NONE'
  /** Off session storage type. The payment is stored to be reused even if the customer is absent. */
  | 'OFF_SESSION'
  /** On session storage type. The payment is stored only to be reused when the customer is present in the checkout flow. */
  | 'ON_SESSION';

/**
 * Define the filtering options for string fields.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorStringFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxCalculationStrategy =
  | 'FLAT_RATES'
  | 'TAX_APP';

/**
 * Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClass = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorTaxClass';
  /** Country-specific tax rates for this tax class. */
  countries: Array<SaleorTaxClassCountryRate>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Name of the tax class. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
};


/**
 * Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClassmetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClassmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClassprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClassprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxClassCountableConnection = {
  __typename?: 'SaleorTaxClassCountableConnection';
  edges: Array<SaleorTaxClassCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorTaxClassCountableEdge = {
  __typename?: 'SaleorTaxClassCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTaxClass;
};

/**
 * Tax rate for a country. When tax class is null, it represents the default tax rate for that country; otherwise it's a country tax rate specific to the given tax class.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxClassCountryRate = {
  __typename?: 'SaleorTaxClassCountryRate';
  /** Country in which this tax rate applies. */
  country: SaleorCountryDisplay;
  /** Tax rate value. */
  rate: Scalars['Float']['output'];
  /** Related tax class. */
  taxClass?: Maybe<SaleorTaxClass>;
};

/**
 * Create a tax class.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassCreate = {
  __typename?: 'SaleorTaxClassCreate';
  errors: Array<SaleorTaxClassCreateError>;
  taxClass?: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassCreateError = {
  __typename?: 'SaleorTaxClassCreateError';
  /** The error code. */
  code: SaleorTaxClassCreateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxClassCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassCreateInput = {
  /** List of country-specific tax rates to create for this tax class. */
  createCountryRates?: InputMaybe<Array<SaleorCountryRateInput>>;
  /** Name of the tax class. */
  name: Scalars['String']['input'];
};

/**
 * Delete a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassDelete = {
  __typename?: 'SaleorTaxClassDelete';
  errors: Array<SaleorTaxClassDeleteError>;
  taxClass?: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassDeleteError = {
  __typename?: 'SaleorTaxClassDeleteError';
  /** The error code. */
  code: SaleorTaxClassDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxClassDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassFilterInput = {
  countries?: InputMaybe<Array<SaleorCountryCode>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

export type SaleorTaxClassRateInput = {
  /** Tax rate value. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** ID of a tax class for which to update the tax rate */
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaleorTaxClassSortField =
  /** Sort tax classes by name. */
  | 'NAME';

export type SaleorTaxClassSortingInput = {
  /** Specifies the direction in which to sort tax classes. */
  direction: SaleorOrderDirection;
  /** Sort tax classes by the selected field. */
  field: SaleorTaxClassSortField;
};

/**
 * Update a tax class.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxClassUpdate = {
  __typename?: 'SaleorTaxClassUpdate';
  errors: Array<SaleorTaxClassUpdateError>;
  taxClass?: Maybe<SaleorTaxClass>;
};

export type SaleorTaxClassUpdateError = {
  __typename?: 'SaleorTaxClassUpdateError';
  /** The error code. */
  code: SaleorTaxClassUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxClassUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxClassUpdateInput = {
  /** Name of the tax class. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of country codes for which to remove the tax class rates. Note: It removes all rates for given country code. */
  removeCountryRates?: InputMaybe<Array<SaleorCountryCode>>;
  /** List of country-specific tax rates to create or update for this tax class. */
  updateCountryRates?: InputMaybe<Array<SaleorCountryRateUpdateInput>>;
};

/**
 * Channel-specific tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfiguration = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorTaxConfiguration';
  /** A channel to which the tax configuration applies to. */
  channel: SaleorChannel;
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of country-specific exceptions in tax configuration. */
  countries: Array<SaleorTaxConfigurationPerCountry>;
  /** Determines whether prices displayed in a storefront should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy?: Maybe<SaleorTaxCalculationStrategy>;
};


/**
 * Channel-specific tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfigurationmetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Channel-specific tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfigurationmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Channel-specific tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfigurationprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Channel-specific tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfigurationprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaleorTaxConfigurationCountableConnection = {
  __typename?: 'SaleorTaxConfigurationCountableConnection';
  edges: Array<SaleorTaxConfigurationCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorTaxConfigurationCountableEdge = {
  __typename?: 'SaleorTaxConfigurationCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTaxConfiguration;
};

export type SaleorTaxConfigurationFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
};

/**
 * Country-specific exceptions of a channel's tax configuration.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxConfigurationPerCountry = {
  __typename?: 'SaleorTaxConfigurationPerCountry';
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** Country in which this configuration applies. */
  country: SaleorCountryDisplay;
  /** Determines whether prices displayed in a storefront should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy?: Maybe<SaleorTaxCalculationStrategy>;
};

export type SaleorTaxConfigurationPerCountryInput = {
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['input'];
  /** Country in which this configuration applies. */
  countryCode: SaleorCountryCode;
  /** Determines whether prices displayed in a storefront should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['input'];
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy?: InputMaybe<SaleorTaxCalculationStrategy>;
};

/**
 * Update tax configuration for a channel.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxConfigurationUpdate = {
  __typename?: 'SaleorTaxConfigurationUpdate';
  errors: Array<SaleorTaxConfigurationUpdateError>;
  taxConfiguration?: Maybe<SaleorTaxConfiguration>;
};

export type SaleorTaxConfigurationUpdateError = {
  __typename?: 'SaleorTaxConfigurationUpdateError';
  /** The error code. */
  code: SaleorTaxConfigurationUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxConfigurationUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type SaleorTaxConfigurationUpdateInput = {
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether prices displayed in a storefront should include taxes. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of country codes for which to remove the tax configuration. */
  removeCountriesConfiguration?: InputMaybe<Array<SaleorCountryCode>>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy?: InputMaybe<SaleorTaxCalculationStrategy>;
  /** List of tax country configurations to create or update (identified by a country code). */
  updateCountriesConfiguration?: InputMaybe<Array<SaleorTaxConfigurationPerCountryInput>>;
};

/**
 * Tax class rates grouped by country.
 *
 * Added in Saleor 3.9.
 */
export type SaleorTaxCountryConfiguration = {
  __typename?: 'SaleorTaxCountryConfiguration';
  /** A country for which tax class rates are grouped. */
  country: SaleorCountryDisplay;
  /** List of tax class rates. */
  taxClassCountryRates: Array<SaleorTaxClassCountryRate>;
};

/**
 * Remove all tax class rates for a specific country.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxCountryConfigurationDelete = {
  __typename?: 'SaleorTaxCountryConfigurationDelete';
  errors: Array<SaleorTaxCountryConfigurationDeleteError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration?: Maybe<SaleorTaxCountryConfiguration>;
};

export type SaleorTaxCountryConfigurationDeleteError = {
  __typename?: 'SaleorTaxCountryConfigurationDeleteError';
  /** The error code. */
  code: SaleorTaxCountryConfigurationDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxCountryConfigurationDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Update tax class rates for a specific country.
 *
 * Added in Saleor 3.9.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxCountryConfigurationUpdate = {
  __typename?: 'SaleorTaxCountryConfigurationUpdate';
  errors: Array<SaleorTaxCountryConfigurationUpdateError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration?: Maybe<SaleorTaxCountryConfiguration>;
};

export type SaleorTaxCountryConfigurationUpdateError = {
  __typename?: 'SaleorTaxCountryConfigurationUpdateError';
  /** The error code. */
  code: SaleorTaxCountryConfigurationUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of tax class IDs for which the update failed. */
  taxClassIds: Array<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxCountryConfigurationUpdateErrorCode =
  | 'CANNOT_CREATE_NEGATIVE_RATE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'ONLY_ONE_DEFAULT_COUNTRY_RATE_ALLOWED';

/**
 * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
 *
 * Added in Saleor 3.8.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type SaleorTaxExemptionManage = {
  __typename?: 'SaleorTaxExemptionManage';
  errors: Array<SaleorTaxExemptionManageError>;
  taxableObject?: Maybe<SaleorTaxSourceObject>;
};

export type SaleorTaxExemptionManageError = {
  __typename?: 'SaleorTaxExemptionManageError';
  /** The error code. */
  code: SaleorTaxExemptionManageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTaxExemptionManageErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_EDITABLE_ORDER'
  | 'NOT_FOUND';

export type SaleorTaxSourceLine = SaleorCheckoutLine | SaleorOrderLine;

export type SaleorTaxSourceObject = SaleorCheckout | SaleorOrder;

/** Representation of tax types fetched from tax gateway. */
export type SaleorTaxType = {
  __typename?: 'SaleorTaxType';
  /** Description of the tax type. */
  description?: Maybe<Scalars['String']['output']>;
  /** External tax code used to identify given tax group. */
  taxCode?: Maybe<Scalars['String']['output']>;
};

/** Taxable object. */
export type SaleorTaxableObject = {
  __typename?: 'SaleorTaxableObject';
  /** The address data. */
  address?: Maybe<SaleorAddress>;
  channel: SaleorChannel;
  /** The currency of the object. */
  currency: Scalars['String']['output'];
  /** List of discounts. */
  discounts: Array<SaleorTaxableObjectDiscount>;
  /** List of lines assigned to the object. */
  lines: Array<SaleorTaxableObjectLine>;
  /** Determines if prices contain entered tax.. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** The price of shipping method. */
  shippingPrice: SaleorMoney;
  /** The source object related to this tax object. */
  sourceObject: SaleorTaxSourceObject;
};

/** Taxable object discount. */
export type SaleorTaxableObjectDiscount = {
  __typename?: 'SaleorTaxableObjectDiscount';
  /** The amount of the discount. */
  amount: SaleorMoney;
  /** The name of the discount. */
  name?: Maybe<Scalars['String']['output']>;
};

export type SaleorTaxableObjectLine = {
  __typename?: 'SaleorTaxableObjectLine';
  /** Determines if taxes are being charged for the product. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** The product name. */
  productName: Scalars['String']['output'];
  /** The product sku. */
  productSku?: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity: Scalars['Int']['output'];
  /** The source line related to this tax line. */
  sourceLine: SaleorTaxSourceLine;
  /** Price of the order line. */
  totalPrice: SaleorMoney;
  /** Price of the single item in the order line. */
  unitPrice: SaleorMoney;
  /** The variant name. */
  variantName: Scalars['String']['output'];
};

/** Represents a monetary value with taxes. In cases where taxes were not applied, net and gross values will be equal. */
export type SaleorTaxedMoney = {
  __typename?: 'SaleorTaxedMoney';
  /** Currency code. */
  currency: Scalars['String']['output'];
  /** Amount of money including taxes. */
  gross: SaleorMoney;
  /** Amount of money without taxes. */
  net: SaleorMoney;
  /** Amount of taxes. */
  tax: SaleorMoney;
};

/** Represents a range of monetary values. */
export type SaleorTaxedMoneyRange = {
  __typename?: 'SaleorTaxedMoneyRange';
  /** Lower bound of a price range. */
  start?: Maybe<SaleorTaxedMoney>;
  /** Upper bound of a price range. */
  stop?: Maybe<SaleorTaxedMoney>;
};

/**
 * Event sent when thumbnail is created.
 *
 * Added in Saleor 3.12.
 */
export type SaleorThumbnailCreated = SaleorEvent & {
  __typename?: 'SaleorThumbnailCreated';
  /**
   * Thumbnail id.
   *
   * Added in Saleor 3.12.
   */
  id?: Maybe<Scalars['ID']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /**
   * Original media url.
   *
   * Added in Saleor 3.12.
   */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Object the thumbnail refers to.
   *
   * Added in Saleor 3.12.
   */
  objectId?: Maybe<Scalars['ID']['output']>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /**
   * Thumbnail url.
   *
   * Added in Saleor 3.12.
   */
  url?: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorThumbnailFormatEnum =
  | 'AVIF'
  | 'ORIGINAL'
  | 'WEBP';

export type SaleorTimePeriod = {
  __typename?: 'SaleorTimePeriod';
  /** The length of the period. */
  amount: Scalars['Int']['output'];
  /** The type of the period. */
  type: SaleorTimePeriodTypeEnum;
};

export type SaleorTimePeriodInputType = {
  /** The length of the period. */
  amount: Scalars['Int']['input'];
  /** The type of the period. */
  type: SaleorTimePeriodTypeEnum;
};

/** An enumeration. */
export type SaleorTimePeriodTypeEnum =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

/** An object representing a single payment. */
export type SaleorTransaction = SaleorNode & {
  __typename?: 'SaleorTransaction';
  /** Total amount of the transaction. */
  amount?: Maybe<SaleorMoney>;
  created: Scalars['SaleorDateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  gatewayResponse: Scalars['SaleorJSONString']['output'];
  id: Scalars['ID']['output'];
  isSuccess: Scalars['Boolean']['output'];
  kind: SaleorTransactionKind;
  payment: SaleorPayment;
  token: Scalars['String']['output'];
};

export type SaleorTransactionAction = {
  __typename?: 'SaleorTransactionAction';
  /** Determines the action type. */
  actionType: SaleorTransactionActionEnum;
  /** Transaction request amount. Null when action type is VOID. */
  amount?: Maybe<Scalars['SaleorPositiveDecimal']['output']>;
};

/**
 * Represents possible actions on payment transaction.
 *
 *     The following actions are possible:
 *     CHARGE - Represents the charge action.
 *     REFUND - Represents a refund action.
 *     VOID - Represents a void action. This field will be removed
 *     in Saleor 3.14 (Preview Feature). Use `CANCEL` instead.
 *     CANCEL - Represents a cancel action. Added in Saleor 3.12.
 *
 */
export type SaleorTransactionActionEnum =
  | 'CANCEL'
  | 'CHARGE'
  | 'REFUND'
  | 'VOID';

/**
 * Event sent when transaction action is requested.
 *
 * Added in Saleor 3.4.
 *
 * DEPRECATED: this subscription will be removed in Saleor 3.14 (Preview Feature). Use `TransactionChargeRequested`, `TransactionRefundRequested`, `TransactionCancelationRequested` instead.
 */
export type SaleorTransactionActionRequest = SaleorEvent & {
  __typename?: 'SaleorTransactionActionRequest';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when transaction cancelation is requested.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionCancelationRequested = SaleorEvent & {
  __typename?: 'SaleorTransactionCancelationRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when transaction charge is requested.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionChargeRequested = SaleorEvent & {
  __typename?: 'SaleorTransactionChargeRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Create transaction for checkout or order.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type SaleorTransactionCreate = {
  __typename?: 'SaleorTransactionCreate';
  errors: Array<SaleorTransactionCreateError>;
  transaction?: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionCreateError = {
  __typename?: 'SaleorTransactionCreateError';
  /** The error code. */
  code: SaleorTransactionCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type SaleorTransactionCreateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<SaleorMoneyInput>;
  /**
   * Amount canceled by this transaction.
   *
   * Added in Saleor 3.13.
   */
  amountCanceled?: InputMaybe<SaleorMoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<SaleorMoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<SaleorMoneyInput>;
  /**
   * Amount voided by this transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `amountCanceled` instead.
   */
  amountVoided?: InputMaybe<SaleorMoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  /**
   * The url that will allow to redirect user to payment provider page with transaction event details.
   *
   * Added in Saleor 3.13.
   */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The message of the transaction.
   *
   * Added in Saleor 3.13.
   */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Payment public metadata. */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Payment name of the transaction.
   *
   * Added in Saleor 3.13.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Payment private metadata. */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * PSP Reference of the transaction.
   *
   * Added in Saleor 3.13.
   */
  pspReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `pspReference` instead.
   */
  reference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Status of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). The `status` is not needed. The amounts can be used to define the current status of transactions.
   */
  status?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment type used for this transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `name` and `message` instead.
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Represents transaction's event. */
export type SaleorTransactionEvent = SaleorNode & {
  __typename?: 'SaleorTransactionEvent';
  /**
   * The amount related to this event.
   *
   * Added in Saleor 3.13.
   */
  amount: SaleorMoney;
  createdAt: Scalars['SaleorDateTime']['output'];
  /**
   * User or App that created the transaction event.
   *
   * Added in Saleor 3.13.
   */
  createdBy?: Maybe<SaleorUserOrApp>;
  /**
   * The url that will allow to redirect user to payment provider page with transaction details.
   *
   * Added in Saleor 3.13.
   */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /**
   * Message related to the transaction's event.
   *
   * Added in Saleor 3.13.
   */
  message: Scalars['String']['output'];
  /**
   * Name of the transaction's event.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature). Use `message` instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * PSP reference of transaction.
   *
   * Added in Saleor 3.13.
   */
  pspReference: Scalars['String']['output'];
  /**
   * Reference of transaction's event.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature).Use `pspReference` instead.
   */
  reference: Scalars['String']['output'];
  /**
   * Status of transaction's event.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature). Use `type` instead.
   */
  status?: Maybe<SaleorTransactionStatus>;
  /**
   * The type of action related to this event.
   *
   * Added in Saleor 3.13.
   */
  type?: Maybe<SaleorTransactionEventTypeEnum>;
};

export type SaleorTransactionEventInput = {
  /**
   * The message related to the event.
   *
   * Added in Saleor 3.13.
   */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Name of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `message` instead. `name` field will be added to `message`.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * PSP Reference related to this action.
   *
   * Added in Saleor 3.13.
   */
  pspReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `pspReference` instead.
   */
  reference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Current status of the payment transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Status will be calculated by Saleor.
   */
  status?: InputMaybe<SaleorTransactionStatus>;
};

/**
 * Report the event for the transaction.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS.
 */
export type SaleorTransactionEventReport = {
  __typename?: 'SaleorTransactionEventReport';
  /** Defines if the reported event hasn't been processed earlier. */
  alreadyProcessed?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<SaleorTransactionEventReportError>;
  /** The transaction related to the reported event. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** The event assigned to this report. if `alreadyProcessed` is set to `true`, the previously processed event will be returned. */
  transactionEvent?: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionEventReportError = {
  __typename?: 'SaleorTransactionEventReportError';
  /** The error code. */
  code: SaleorTransactionEventReportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionEventReportErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_DETAILS'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Represents possible event types.
 *
 *     Added in Saleor 3.12.
 *
 *     The following types are possible:
 *     AUTHORIZATION_SUCCESS - represents success authorization.
 *     AUTHORIZATION_FAILURE - represents failure authorization.
 *     AUTHORIZATION_ADJUSTMENT - represents authorization adjustment.
 *     AUTHORIZATION_REQUEST - represents authorization request.
 *     AUTHORIZATION_ACTION_REQUIRED - represents authorization that needs
 *     additional actions from the customer.
 *     CHARGE_ACTION_REQUIRED - represents charge that needs
 *     additional actions from the customer.
 *     CHARGE_SUCCESS - represents success charge.
 *     CHARGE_FAILURE - represents failure charge.
 *     CHARGE_BACK - represents chargeback.
 *     CHARGE_REQUEST - represents charge request.
 *     REFUND_SUCCESS - represents success refund.
 *     REFUND_FAILURE - represents failure refund.
 *     REFUND_REVERSE - represents reverse refund.
 *     REFUND_REQUEST - represents refund request.
 *     CANCEL_SUCCESS - represents success cancel.
 *     CANCEL_FAILURE - represents failure cancel.
 *     CANCEL_REQUEST - represents cancel request.
 *     INFO - represents info event.
 *
 */
export type SaleorTransactionEventTypeEnum =
  | 'AUTHORIZATION_ACTION_REQUIRED'
  | 'AUTHORIZATION_ADJUSTMENT'
  | 'AUTHORIZATION_FAILURE'
  | 'AUTHORIZATION_REQUEST'
  | 'AUTHORIZATION_SUCCESS'
  | 'CANCEL_FAILURE'
  | 'CANCEL_REQUEST'
  | 'CANCEL_SUCCESS'
  | 'CHARGE_ACTION_REQUIRED'
  | 'CHARGE_BACK'
  | 'CHARGE_FAILURE'
  | 'CHARGE_REQUEST'
  | 'CHARGE_SUCCESS'
  | 'INFO'
  | 'REFUND_FAILURE'
  | 'REFUND_REQUEST'
  | 'REFUND_REVERSE'
  | 'REFUND_SUCCESS';

/**
 * Determine the transaction flow strategy.
 *
 *     AUTHORIZATION - the processed transaction should be only authorized
 *     CHARGE - the processed transaction should be charged.
 *
 */
export type SaleorTransactionFlowStrategyEnum =
  | 'AUTHORIZATION'
  | 'CHARGE';

/**
 * Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionInitialize = {
  __typename?: 'SaleorTransactionInitialize';
  /** The JSON data required to finalize the payment. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  errors: Array<SaleorTransactionInitializeError>;
  /** The initialized transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** The event created for the initialized transaction. */
  transactionEvent?: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionInitializeError = {
  __typename?: 'SaleorTransactionInitializeError';
  /** The error code. */
  code: SaleorTransactionInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionInitializeErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Event sent when user starts processing the payment.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionInitializeSession = SaleorEvent & {
  __typename?: 'SaleorTransactionInitializeSession';
  /** Action to proceed for the transaction */
  action: SaleorTransactionProcessAction;
  /** Payment gateway data in JSON format, recieved from storefront. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Look up a transaction. */
  transaction: SaleorTransactionItem;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionItem = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorTransactionItem';
  /** List of actions that can be performed in the current state of a payment. */
  actions: Array<SaleorTransactionActionEnum>;
  /**
   * Total amount of ongoing authorization requests for the transaction.
   *
   * Added in Saleor 3.13.
   */
  authorizePendingAmount: SaleorMoney;
  /** Total amount authorized for this payment. */
  authorizedAmount: SaleorMoney;
  /**
   * Total amount of ongoing cancel requests for the transaction.
   *
   * Added in Saleor 3.13.
   */
  cancelPendingAmount: SaleorMoney;
  /**
   * Total amount canceled for this payment.
   *
   * Added in Saleor 3.13.
   */
  canceledAmount: SaleorMoney;
  /**
   * Total amount of ongoing charge requests for the transaction.
   *
   * Added in Saleor 3.13.
   */
  chargePendingAmount: SaleorMoney;
  /** Total amount charged for this payment. */
  chargedAmount: SaleorMoney;
  createdAt: Scalars['SaleorDateTime']['output'];
  /**
   * User or App that created the transaction.
   *
   * Added in Saleor 3.13.
   */
  createdBy?: Maybe<SaleorUserOrApp>;
  /** List of all transaction's events. */
  events: Array<SaleorTransactionEvent>;
  /**
   * The url that will allow to redirect user to payment provider page with transaction details.
   *
   * Added in Saleor 3.13.
   */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /**
   * Message related to the transaction.
   *
   * Added in Saleor 3.13.
   */
  message: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  modifiedAt: Scalars['SaleorDateTime']['output'];
  /**
   * Name of the transaction.
   *
   * Added in Saleor 3.13.
   */
  name: Scalars['String']['output'];
  /**
   * The related order.
   *
   * Added in Saleor 3.6.
   */
  order?: Maybe<SaleorOrder>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * PSP reference of transaction.
   *
   * Added in Saleor 3.13.
   */
  pspReference: Scalars['String']['output'];
  /**
   * Reference of transaction.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature).Use `pspReference` instead.
   */
  reference: Scalars['String']['output'];
  /**
   * Total amount of ongoing refund requests for the transaction.
   *
   * Added in Saleor 3.13.
   */
  refundPendingAmount: SaleorMoney;
  /** Total amount refunded for this payment. */
  refundedAmount: SaleorMoney;
  /**
   * Status of transaction.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature). The `status` is not needed. The amounts can be used to define the current status of transactions.
   */
  status: Scalars['String']['output'];
  /**
   * Type of transaction.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature). Use `name` or `message` instead.
   */
  type: Scalars['String']['output'];
  /**
   * Total amount voided for this payment.
   * @deprecated This field will be removed in Saleor 3.14 (Preview Feature).Use `canceledAmount` instead.
   */
  voidedAmount: SaleorMoney;
};


/**
 * Represents a payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionItemmetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Represents a payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionItemmetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Represents a payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionItemprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Represents a payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionItemprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Event sent when transaction item metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorTransactionItemMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorTransactionItemMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionKind =
  | 'ACTION_TO_CONFIRM'
  | 'AUTH'
  | 'CANCEL'
  | 'CAPTURE'
  | 'CONFIRM'
  | 'EXTERNAL'
  | 'PENDING'
  | 'REFUND'
  | 'REFUND_ONGOING'
  | 'VOID';

/**
 * Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionProcess = {
  __typename?: 'SaleorTransactionProcess';
  /** The json data required to finalize the payment. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  errors: Array<SaleorTransactionProcessError>;
  /** The processed transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** The event created for the processed transaction. */
  transactionEvent?: Maybe<SaleorTransactionEvent>;
};

export type SaleorTransactionProcessAction = {
  __typename?: 'SaleorTransactionProcessAction';
  actionType: SaleorTransactionFlowStrategyEnum;
  /** Transaction amount to process. */
  amount: Scalars['SaleorPositiveDecimal']['output'];
  /** Currency of the amount. */
  currency: Scalars['String']['output'];
};

export type SaleorTransactionProcessError = {
  __typename?: 'SaleorTransactionProcessError';
  /** The error code. */
  code: SaleorTransactionProcessErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionProcessErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_PAYMENT_APP'
  | 'MISSING_PAYMENT_APP_RELATION'
  | 'NOT_FOUND'
  | 'TRANSACTION_ALREADY_PROCESSED';

/**
 * Event sent when user has additional payment action to process.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionProcessSession = SaleorEvent & {
  __typename?: 'SaleorTransactionProcessSession';
  /** Action to proceed for the transaction */
  action: SaleorTransactionProcessAction;
  /** Payment gateway data in JSON format, recieved from storefront. */
  data?: Maybe<Scalars['SaleorJSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Checkout or order */
  sourceObject: SaleorOrderOrCheckout;
  /** Look up a transaction. */
  transaction: SaleorTransactionItem;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when transaction refund is requested.
 *
 * Added in Saleor 3.13.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type SaleorTransactionRefundRequested = SaleorEvent & {
  __typename?: 'SaleorTransactionRefundRequested';
  /** Requested action data. */
  action: SaleorTransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Look up a transaction. */
  transaction?: Maybe<SaleorTransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Request an action for payment transaction.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type SaleorTransactionRequestAction = {
  __typename?: 'SaleorTransactionRequestAction';
  errors: Array<SaleorTransactionRequestActionError>;
  transaction?: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionRequestActionError = {
  __typename?: 'SaleorTransactionRequestActionError';
  /** The error code. */
  code: SaleorTransactionRequestActionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionRequestActionErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_TRANSACTION_ACTION_REQUEST_WEBHOOK'
  | 'NOT_FOUND';

/**
 * Represents a status of payment transaction.
 *
 *     The following statuses are possible:
 *     SUCCESS - Represents a sucess action.
 *     FAILURE - Represents a failure action.
 *     PENDING - Represents a pending action.
 *
 */
export type SaleorTransactionStatus =
  | 'FAILURE'
  | 'PENDING'
  | 'SUCCESS';

/**
 * Create transaction for checkout or order.
 *
 * Added in Saleor 3.4.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS.
 */
export type SaleorTransactionUpdate = {
  __typename?: 'SaleorTransactionUpdate';
  errors: Array<SaleorTransactionUpdateError>;
  transaction?: Maybe<SaleorTransactionItem>;
};

export type SaleorTransactionUpdateError = {
  __typename?: 'SaleorTransactionUpdateError';
  /** The error code. */
  code: SaleorTransactionUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTransactionUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type SaleorTransactionUpdateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<SaleorMoneyInput>;
  /**
   * Amount canceled by this transaction.
   *
   * Added in Saleor 3.13.
   */
  amountCanceled?: InputMaybe<SaleorMoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<SaleorMoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<SaleorMoneyInput>;
  /**
   * Amount voided by this transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `amountCanceled` instead.
   */
  amountVoided?: InputMaybe<SaleorMoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<SaleorTransactionActionEnum>>;
  /**
   * The url that will allow to redirect user to payment provider page with transaction event details.
   *
   * Added in Saleor 3.13.
   */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The message of the transaction.
   *
   * Added in Saleor 3.13.
   */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Payment public metadata. */
  metadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * Payment name of the transaction.
   *
   * Added in Saleor 3.13.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Payment private metadata. */
  privateMetadata?: InputMaybe<Array<SaleorMetadataInput>>;
  /**
   * PSP Reference of the transaction.
   *
   * Added in Saleor 3.13.
   */
  pspReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `pspReference` instead.
   */
  reference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Status of the transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). The `status` is not needed. The amounts can be used to define the current status of transactions.
   */
  status?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment type used for this transaction.
   *
   * DEPRECATED: this field will be removed in Saleor 3.14 (Preview Feature). Use `name` and `message` instead.
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorTranslatableItem = SaleorAttributeTranslatableContent | SaleorAttributeValueTranslatableContent | SaleorCategoryTranslatableContent | SaleorCollectionTranslatableContent | SaleorMenuItemTranslatableContent | SaleorPageTranslatableContent | SaleorProductTranslatableContent | SaleorProductVariantTranslatableContent | SaleorSaleTranslatableContent | SaleorShippingMethodTranslatableContent | SaleorVoucherTranslatableContent;

export type SaleorTranslatableItemConnection = {
  __typename?: 'SaleorTranslatableItemConnection';
  edges: Array<SaleorTranslatableItemEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorTranslatableItemEdge = {
  __typename?: 'SaleorTranslatableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorTranslatableItem;
};

export type SaleorTranslatableKinds =
  | 'ATTRIBUTE'
  | 'ATTRIBUTE_VALUE'
  | 'CATEGORY'
  | 'COLLECTION'
  | 'MENU_ITEM'
  | 'PAGE'
  | 'PRODUCT'
  | 'SALE'
  | 'SHIPPING_METHOD'
  | 'VARIANT'
  | 'VOUCHER';

/**
 * Event sent when new translation is created.
 *
 * Added in Saleor 3.2.
 */
export type SaleorTranslationCreated = SaleorEvent & {
  __typename?: 'SaleorTranslationCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The translation the event relates to. */
  translation?: Maybe<SaleorTranslationTypes>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorTranslationError = {
  __typename?: 'SaleorTranslationError';
  /** The error code. */
  code: SaleorTranslationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorTranslationErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type SaleorTranslationInput = {
  /**
   * Translated description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorTranslationTypes = SaleorAttributeTranslation | SaleorAttributeValueTranslation | SaleorCategoryTranslation | SaleorCollectionTranslation | SaleorMenuItemTranslation | SaleorPageTranslation | SaleorProductTranslation | SaleorProductVariantTranslation | SaleorSaleTranslation | SaleorShippingMethodTranslation | SaleorVoucherTranslation;

/**
 * Event sent when translation is updated.
 *
 * Added in Saleor 3.2.
 */
export type SaleorTranslationUpdated = SaleorEvent & {
  __typename?: 'SaleorTranslationUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** The translation the event relates to. */
  translation?: Maybe<SaleorTranslationTypes>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type SaleorUpdateInvoiceInput = {
  /** Invoice number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** URL of an invoice to download. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Updates metadata of an object. To use it, you need to have access to the modified object. */
export type SaleorUpdateMetadata = {
  __typename?: 'SaleorUpdateMetadata';
  errors: Array<SaleorMetadataError>;
  item?: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

/** Updates private metadata of an object. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
export type SaleorUpdatePrivateMetadata = {
  __typename?: 'SaleorUpdatePrivateMetadata';
  errors: Array<SaleorMetadataError>;
  item?: Maybe<SaleorObjectWithMetadata>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  metadataErrors: Array<SaleorMetadataError>;
};

export type SaleorUploadError = {
  __typename?: 'SaleorUploadError';
  /** The error code. */
  code: SaleorUploadErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorUploadErrorCode =
  | 'GRAPHQL_ERROR';

/** Represents user data. */
export type SaleorUser = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorUser';
  /** List of all user's addresses. */
  addresses: Array<SaleorAddress>;
  avatar?: Maybe<SaleorImage>;
  /**
   * Returns the last open checkout of this user.
   * @deprecated This field will be removed in Saleor 4.0. Use the `checkoutTokens` field to fetch the user checkouts.
   */
  checkout?: Maybe<SaleorCheckout>;
  /** Returns the checkout ID's assigned to this user. */
  checkoutIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Returns the checkout UUID's assigned to this user.
   * @deprecated This field will be removed in Saleor 4.0. Use `checkoutIds` instead.
   */
  checkoutTokens?: Maybe<Array<Scalars['SaleorUUID']['output']>>;
  /**
   * Returns checkouts assigned to this user.
   *
   * Added in Saleor 3.8.
   */
  checkouts?: Maybe<SaleorCheckoutCountableConnection>;
  dateJoined: Scalars['SaleorDateTime']['output'];
  defaultBillingAddress?: Maybe<SaleorAddress>;
  defaultShippingAddress?: Maybe<SaleorAddress>;
  /** List of user's permission groups which user can manage. */
  editableGroups?: Maybe<Array<SaleorGroup>>;
  email: Scalars['String']['output'];
  /**
   * List of events associated with the user.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  events?: Maybe<Array<SaleorCustomerEvent>>;
  /**
   * External ID of this user.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  /** List of the user gift cards. */
  giftCards?: Maybe<SaleorGiftCardCountableConnection>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  /** User language code. */
  languageCode: SaleorLanguageCodeEnum;
  lastLogin?: Maybe<Scalars['SaleorDateTime']['output']>;
  lastName: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * A note about the customer.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** List of user's orders. Requires one of the following permissions: MANAGE_STAFF, OWNER. */
  orders?: Maybe<SaleorOrderCountableConnection>;
  /** List of user's permission groups. */
  permissionGroups?: Maybe<Array<SaleorGroup>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /** List of stored payment sources. */
  storedPaymentSources?: Maybe<Array<SaleorPaymentSource>>;
  updatedAt: Scalars['SaleorDateTime']['output'];
  /** List of user's permissions. */
  userPermissions?: Maybe<Array<SaleorUserPermission>>;
};


/** Represents user data. */
export type SaleorUseravatarArgs = {
  format?: InputMaybe<SaleorThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUsercheckoutIdsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type SaleorUsercheckoutTokensArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type SaleorUsercheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUsergiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUsermetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type SaleorUsermetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type SaleorUserordersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type SaleorUserprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type SaleorUserprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type SaleorUserstoredPaymentSourcesArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a user avatar. Only for staff members.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorUserAvatarDelete = {
  __typename?: 'SaleorUserAvatarDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user?: Maybe<SaleorUser>;
};

/**
 * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorUserAvatarUpdate = {
  __typename?: 'SaleorUserAvatarUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** An updated user instance. */
  user?: Maybe<SaleorUser>;
};

/**
 * Activate or deactivate users.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type SaleorUserBulkSetActive = {
  __typename?: 'SaleorUserBulkSetActive';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<SaleorAccountError>;
};

export type SaleorUserCountableConnection = {
  __typename?: 'SaleorUserCountableConnection';
  edges: Array<SaleorUserCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorUserCountableEdge = {
  __typename?: 'SaleorUserCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorUser;
};

export type SaleorUserCreateInput = {
  /** Slug of a channel which will be used for notify user. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<SaleorAddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<SaleorAddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of the customer.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<SaleorLanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorUserOrApp = SaleorApp | SaleorUser;

/** Represents user's permissions. */
export type SaleorUserPermission = {
  __typename?: 'SaleorUserPermission';
  /** Internal code for permission. */
  code: SaleorPermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
  /** List of user permission groups which contains this permission. */
  sourcePermissionGroups?: Maybe<Array<SaleorGroup>>;
};


/** Represents user's permissions. */
export type SaleorUserPermissionsourcePermissionGroupsArgs = {
  userId: Scalars['ID']['input'];
};

export type SaleorUserSortField =
  /** Sort users by created at. */
  | 'CREATED_AT'
  /** Sort users by email. */
  | 'EMAIL'
  /** Sort users by first name. */
  | 'FIRST_NAME'
  /** Sort users by last modified at. */
  | 'LAST_MODIFIED_AT'
  /** Sort users by last name. */
  | 'LAST_NAME'
  /** Sort users by order count. */
  | 'ORDER_COUNT';

export type SaleorUserSortingInput = {
  /** Specifies the direction in which to sort users. */
  direction: SaleorOrderDirection;
  /** Sort users by the selected field. */
  field: SaleorUserSortField;
};

/** Represents a VAT rate for a country. */
export type SaleorVAT = {
  __typename?: 'SaleorVAT';
  /** Country code. */
  countryCode: Scalars['String']['output'];
  /** Country's VAT rate exceptions for specific types of goods. */
  reducedRates: Array<SaleorReducedRate>;
  /** Standard VAT rate in percent. */
  standardRate?: Maybe<Scalars['Float']['output']>;
};

export type SaleorVariantAttributeScope =
  | 'ALL'
  | 'NOT_VARIANT_SELECTION'
  | 'VARIANT_SELECTION';

/**
 * Assign an media to a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorVariantMediaAssign = {
  __typename?: 'SaleorVariantMediaAssign';
  errors: Array<SaleorProductError>;
  media?: Maybe<SaleorProductMedia>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant?: Maybe<SaleorProductVariant>;
};

/**
 * Unassign an media from a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorVariantMediaUnassign = {
  __typename?: 'SaleorVariantMediaUnassign';
  errors: Array<SaleorProductError>;
  media?: Maybe<SaleorProductMedia>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  productErrors: Array<SaleorProductError>;
  productVariant?: Maybe<SaleorProductVariant>;
};

/** Represents availability of a variant in the storefront. */
export type SaleorVariantPricingInfo = {
  __typename?: 'SaleorVariantPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount?: Maybe<SaleorTaxedMoney>;
  /** The discount amount in the local currency. */
  discountLocalCurrency?: Maybe<SaleorTaxedMoney>;
  /** Whether it is in sale or not. */
  onSale?: Maybe<Scalars['Boolean']['output']>;
  /** The price, with any discount subtracted. */
  price?: Maybe<SaleorTaxedMoney>;
  /** The discounted price in the local currency. */
  priceLocalCurrency?: Maybe<SaleorTaxedMoney>;
  /** The price without any discount. */
  priceUndiscounted?: Maybe<SaleorTaxedMoney>;
};

/** Verify JWT token. */
export type SaleorVerifyToken = {
  __typename?: 'SaleorVerifyToken';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  accountErrors: Array<SaleorAccountError>;
  errors: Array<SaleorAccountError>;
  /** Determine if token is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** JWT payload. */
  payload?: Maybe<Scalars['SaleorGenericScalar']['output']>;
  /** User assigned to token. */
  user?: Maybe<SaleorUser>;
};

/** An enumeration. */
export type SaleorVolumeUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'FL_OZ'
  | 'LITER'
  | 'PINT'
  | 'QT';

/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucher = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorVoucher';
  applyOncePerCustomer: Scalars['Boolean']['output'];
  applyOncePerOrder: Scalars['Boolean']['output'];
  /** List of categories this voucher applies to. */
  categories?: Maybe<SaleorCategoryCountableConnection>;
  /**
   * List of availability in channels for the voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings?: Maybe<Array<SaleorVoucherChannelListing>>;
  code: Scalars['String']['output'];
  /**
   * List of collections this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections?: Maybe<SaleorCollectionCountableConnection>;
  /** List of countries available for the shipping voucher. */
  countries?: Maybe<Array<SaleorCountryDisplay>>;
  /** Currency code for voucher. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Voucher value. */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** Determines a type of discount for voucher - value or percentage */
  discountValueType: SaleorDiscountValueTypeEnum;
  endDate?: Maybe<Scalars['SaleorDateTime']['output']>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  minCheckoutItemsQuantity?: Maybe<Scalars['Int']['output']>;
  /** Minimum order value to apply voucher. */
  minSpent?: Maybe<SaleorMoney>;
  name?: Maybe<Scalars['String']['output']>;
  onlyForStaff: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  /**
   * List of products this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products?: Maybe<SaleorProductCountableConnection>;
  startDate: Scalars['SaleorDateTime']['output'];
  /** Returns translated voucher fields for the given language code. */
  translation?: Maybe<SaleorVoucherTranslation>;
  /** Determines a type of voucher. */
  type: SaleorVoucherTypeEnum;
  usageLimit?: Maybe<Scalars['Int']['output']>;
  used: Scalars['Int']['output'];
  /**
   * List of product variants this voucher applies to.
   *
   * Added in Saleor 3.1.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants?: Maybe<SaleorProductVariantCountableConnection>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchercategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchercollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchermetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchermetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVoucherproductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchertranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type SaleorVouchervariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherAddCatalogues = {
  __typename?: 'SaleorVoucherAddCatalogues';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher?: Maybe<SaleorVoucher>;
};

/**
 * Deletes vouchers.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherBulkDelete = {
  __typename?: 'SaleorVoucherBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
};

/** Represents voucher channel listing. */
export type SaleorVoucherChannelListing = SaleorNode & {
  __typename?: 'SaleorVoucherChannelListing';
  channel: SaleorChannel;
  currency: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  minSpent?: Maybe<SaleorMoney>;
};

export type SaleorVoucherChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Value of the voucher. */
  discountValue?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
  /** Min purchase amount required to apply the voucher. */
  minAmountSpent?: InputMaybe<Scalars['SaleorPositiveDecimal']['input']>;
};

export type SaleorVoucherChannelListingInput = {
  /** List of channels to which the voucher should be assigned. */
  addChannels?: InputMaybe<Array<SaleorVoucherChannelListingAddInput>>;
  /** List of channels from which the voucher should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage voucher's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherChannelListingUpdate = {
  __typename?: 'SaleorVoucherChannelListingUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** An updated voucher instance. */
  voucher?: Maybe<SaleorVoucher>;
};

export type SaleorVoucherCountableConnection = {
  __typename?: 'SaleorVoucherCountableConnection';
  edges: Array<SaleorVoucherCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorVoucherCountableEdge = {
  __typename?: 'SaleorVoucherCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorVoucher;
};

/**
 * Creates a new voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherCreate = {
  __typename?: 'SaleorVoucherCreate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher?: Maybe<SaleorVoucher>;
};

/**
 * Event sent when new voucher is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherCreated = SaleorEvent & {
  __typename?: 'SaleorVoucherCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<SaleorVoucher>;
};


/**
 * Event sent when new voucher is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherCreatedvoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherDelete = {
  __typename?: 'SaleorVoucherDelete';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher?: Maybe<SaleorVoucher>;
};

/**
 * Event sent when voucher is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherDeleted = SaleorEvent & {
  __typename?: 'SaleorVoucherDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<SaleorVoucher>;
};


/**
 * Event sent when voucher is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherDeletedvoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleorVoucherDiscountType =
  | 'FIXED'
  | 'PERCENTAGE'
  | 'SHIPPING';

export type SaleorVoucherFilterInput = {
  discountType?: InputMaybe<Array<SaleorVoucherDiscountType>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<SaleorMetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<SaleorDateTimeRangeInput>;
  status?: InputMaybe<Array<SaleorDiscountStatusEnum>>;
  timesUsed?: InputMaybe<SaleorIntRangeInput>;
};

export type SaleorVoucherInput = {
  /** Voucher should be applied once per customer. */
  applyOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Voucher should be applied to the cheapest item or entire order. */
  applyOncePerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Categories discounted by the voucher. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Code to use the voucher. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Collections discounted by the voucher. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Country codes that can be used with the shipping voucher. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Choices: fixed or percentage. */
  discountValueType?: InputMaybe<SaleorDiscountValueTypeEnum>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Minimal quantity of checkout items required to apply the voucher. */
  minCheckoutItemsQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Voucher can be used only by staff user. */
  onlyForStaff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Products discounted by the voucher. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['SaleorDateTime']['input']>;
  /** Voucher type: PRODUCT, CATEGORY SHIPPING or ENTIRE_ORDER. */
  type?: InputMaybe<SaleorVoucherTypeEnum>;
  /** Limit number of times this voucher can be used in total. */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Variants discounted by the voucher.
   *
   * Added in Saleor 3.1.
   */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Event sent when voucher metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorVoucherMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorVoucherMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<SaleorVoucher>;
};


/**
 * Event sent when voucher metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorVoucherMetadataUpdatedvoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Removes products, categories, collections from a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherRemoveCatalogues = {
  __typename?: 'SaleorVoucherRemoveCatalogues';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher?: Maybe<SaleorVoucher>;
};

export type SaleorVoucherSortField =
  /** Sort vouchers by code. */
  | 'CODE'
  /** Sort vouchers by end date. */
  | 'END_DATE'
  /**
   * Sort vouchers by minimum spent amount.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMUM_SPENT_AMOUNT'
  /** Sort vouchers by start date. */
  | 'START_DATE'
  /** Sort vouchers by type. */
  | 'TYPE'
  /** Sort vouchers by usage limit. */
  | 'USAGE_LIMIT'
  /**
   * Sort vouchers by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type SaleorVoucherSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort vouchers. */
  direction: SaleorOrderDirection;
  /** Sort vouchers by the selected field. */
  field: SaleorVoucherSortField;
};

export type SaleorVoucherTranslatableContent = SaleorNode & {
  __typename?: 'SaleorVoucherTranslatableContent';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Returns translated voucher fields for the given language code. */
  translation?: Maybe<SaleorVoucherTranslation>;
  /**
   * Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated This field will be removed in Saleor 4.0. Get model fields from the root level queries.
   */
  voucher?: Maybe<SaleorVoucher>;
};


export type SaleorVoucherTranslatableContenttranslationArgs = {
  languageCode: SaleorLanguageCodeEnum;
};

/**
 * Creates/updates translations for a voucher.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleorVoucherTranslate = {
  __typename?: 'SaleorVoucherTranslate';
  errors: Array<SaleorTranslationError>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  translationErrors: Array<SaleorTranslationError>;
  voucher?: Maybe<SaleorVoucher>;
};

export type SaleorVoucherTranslation = SaleorNode & {
  __typename?: 'SaleorVoucherTranslation';
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: SaleorLanguageDisplay;
  name?: Maybe<Scalars['String']['output']>;
};

export type SaleorVoucherTypeEnum =
  | 'ENTIRE_ORDER'
  | 'SHIPPING'
  | 'SPECIFIC_PRODUCT';

/**
 * Updates a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleorVoucherUpdate = {
  __typename?: 'SaleorVoucherUpdate';
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  discountErrors: Array<SaleorDiscountError>;
  errors: Array<SaleorDiscountError>;
  voucher?: Maybe<SaleorVoucher>;
};

/**
 * Event sent when voucher is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherUpdated = SaleorEvent & {
  __typename?: 'SaleorVoucherUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<SaleorVoucher>;
};


/**
 * Event sent when voucher is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorVoucherUpdatedvoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents warehouse. */
export type SaleorWarehouse = SaleorNode & SaleorObjectWithMetadata & {
  __typename?: 'SaleorWarehouse';
  address: SaleorAddress;
  /**
   * Click and collect options: local, all or disabled.
   *
   * Added in Saleor 3.1.
   */
  clickAndCollectOption: SaleorWarehouseClickAndCollectOptionEnum;
  /**
   * Warehouse company name.
   * @deprecated This field will be removed in Saleor 4.0. Use `Address.companyName` instead.
   */
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /**
   * External ID of this warehouse.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<SaleorMetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /**
   * Public metadata. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  metafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<SaleorMetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /**
   * Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything.
   *
   * Added in Saleor 3.3.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  privateMetafields?: Maybe<Scalars['SaleorMetadata']['output']>;
  shippingZones: SaleorShippingZoneCountableConnection;
  slug: Scalars['String']['output'];
};


/** Represents warehouse. */
export type SaleorWarehousemetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type SaleorWarehousemetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type SaleorWarehouseprivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type SaleorWarehouseprivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type SaleorWarehouseshippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export type SaleorWarehouseClickAndCollectOptionEnum =
  | 'ALL'
  | 'DISABLED'
  | 'LOCAL';

export type SaleorWarehouseCountableConnection = {
  __typename?: 'SaleorWarehouseCountableConnection';
  edges: Array<SaleorWarehouseCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: SaleorPageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleorWarehouseCountableEdge = {
  __typename?: 'SaleorWarehouseCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SaleorWarehouse;
};

/**
 * Creates new warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseCreate = {
  __typename?: 'SaleorWarehouseCreate';
  errors: Array<SaleorWarehouseError>;
  warehouse?: Maybe<SaleorWarehouse>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseCreateInput = {
  /** Address of the warehouse. */
  address: SaleorAddressInput;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of the warehouse.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name. */
  name: Scalars['String']['input'];
  /**
   * Shipping zones supported by the warehouse.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Providing the zone ids will raise a ValidationError.
   */
  shippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when new warehouse is created.
 *
 * Added in Saleor 3.4.
 */
export type SaleorWarehouseCreated = SaleorEvent & {
  __typename?: 'SaleorWarehouseCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<SaleorWarehouse>;
};

/**
 * Deletes selected warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseDelete = {
  __typename?: 'SaleorWarehouseDelete';
  errors: Array<SaleorWarehouseError>;
  warehouse?: Maybe<SaleorWarehouse>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

/**
 * Event sent when warehouse is deleted.
 *
 * Added in Saleor 3.4.
 */
export type SaleorWarehouseDeleted = SaleorEvent & {
  __typename?: 'SaleorWarehouseDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<SaleorWarehouse>;
};

export type SaleorWarehouseError = {
  __typename?: 'SaleorWarehouseError';
  /** The error code. */
  code: SaleorWarehouseErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of shipping zones IDs which causes the error. */
  shippingZones?: Maybe<Array<Scalars['ID']['output']>>;
};

/** An enumeration. */
export type SaleorWarehouseErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type SaleorWarehouseFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  clickAndCollectOption?: InputMaybe<SaleorWarehouseClickAndCollectOptionEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Event sent when warehouse metadata is updated.
 *
 * Added in Saleor 3.8.
 */
export type SaleorWarehouseMetadataUpdated = SaleorEvent & {
  __typename?: 'SaleorWarehouseMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<SaleorWarehouse>;
};

/**
 * Add shipping zone to given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseShippingZoneAssign = {
  __typename?: 'SaleorWarehouseShippingZoneAssign';
  errors: Array<SaleorWarehouseError>;
  warehouse?: Maybe<SaleorWarehouse>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

/**
 * Remove shipping zone from given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseShippingZoneUnassign = {
  __typename?: 'SaleorWarehouseShippingZoneUnassign';
  errors: Array<SaleorWarehouseError>;
  warehouse?: Maybe<SaleorWarehouse>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseSortField =
  /** Sort warehouses by name. */
  | 'NAME';

export type SaleorWarehouseSortingInput = {
  /** Specifies the direction in which to sort warehouses. */
  direction: SaleorOrderDirection;
  /** Sort warehouses by the selected field. */
  field: SaleorWarehouseSortField;
};

/**
 * Updates given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type SaleorWarehouseUpdate = {
  __typename?: 'SaleorWarehouseUpdate';
  errors: Array<SaleorWarehouseError>;
  warehouse?: Maybe<SaleorWarehouse>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  warehouseErrors: Array<SaleorWarehouseError>;
};

export type SaleorWarehouseUpdateInput = {
  /** Address of the warehouse. */
  address?: InputMaybe<SaleorAddressInput>;
  /**
   * Click and collect options: local, all or disabled.
   *
   * Added in Saleor 3.1.
   */
  clickAndCollectOption?: InputMaybe<SaleorWarehouseClickAndCollectOptionEnum>;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * External ID of the warehouse.
   *
   * Added in Saleor 3.10.
   */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Visibility of warehouse stocks.
   *
   * Added in Saleor 3.1.
   */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when warehouse is updated.
 *
 * Added in Saleor 3.4.
 */
export type SaleorWarehouseUpdated = SaleorEvent & {
  __typename?: 'SaleorWarehouseUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['SaleorDateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<SaleorIssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<SaleorApp>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<SaleorWarehouse>;
};

/** Webhook. */
export type SaleorWebhook = SaleorNode & {
  __typename?: 'SaleorWebhook';
  app: SaleorApp;
  /** List of asynchronous webhook events. */
  asyncEvents: Array<SaleorWebhookEventAsync>;
  /**
   * Custom headers, which will be added to HTTP request.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  customHeaders?: Maybe<Scalars['SaleorJSONString']['output']>;
  /** Event deliveries. */
  eventDeliveries?: Maybe<SaleorEventDeliveryCountableConnection>;
  /**
   * List of webhook events.
   * @deprecated This field will be removed in Saleor 4.0. Use `asyncEvents` or `syncEvents` instead.
   */
  events: Array<SaleorWebhookEvent>;
  id: Scalars['ID']['output'];
  /** Informs if webhook is activated. */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /**
   * Used to create a hash signature for each payload.
   * @deprecated This field will be removed in Saleor 4.0. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Used to define payloads for specific events. */
  subscriptionQuery?: Maybe<Scalars['String']['output']>;
  /** List of synchronous webhook events. */
  syncEvents: Array<SaleorWebhookEventSync>;
  /** Target URL for webhook. */
  targetUrl: Scalars['String']['output'];
};


/** Webhook. */
export type SaleorWebhookeventDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleorEventDeliveryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SaleorEventDeliverySortingInput>;
};

/**
 * Creates a new webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorWebhookCreate = {
  __typename?: 'SaleorWebhookCreate';
  errors: Array<SaleorWebhookError>;
  webhook?: Maybe<SaleorWebhook>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

export type SaleorWebhookCreateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /**
   * Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only "X-*" and "Authorization*" keys are allowed.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  customHeaders?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<SaleorWebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Subscription query used to define a webhook payload.
   *
   * Added in Saleor 3.2.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * The secret key used to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Delete a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type SaleorWebhookDelete = {
  __typename?: 'SaleorWebhookDelete';
  errors: Array<SaleorWebhookError>;
  webhook?: Maybe<SaleorWebhook>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

/**
 * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorWebhookDryRun = {
  __typename?: 'SaleorWebhookDryRun';
  errors: Array<SaleorWebhookDryRunError>;
  /** JSON payload, that would be sent out to webhook's target URL. */
  payload?: Maybe<Scalars['SaleorJSONString']['output']>;
};

export type SaleorWebhookDryRunError = {
  __typename?: 'SaleorWebhookDryRunError';
  /** The error code. */
  code: SaleorWebhookDryRunErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorWebhookDryRunErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

export type SaleorWebhookError = {
  __typename?: 'SaleorWebhookError';
  /** The error code. */
  code: SaleorWebhookErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorWebhookErrorCode =
  | 'DELETE_FAILED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'MISSING_EVENT'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SYNTAX'
  | 'UNABLE_TO_PARSE'
  | 'UNIQUE';

/** Webhook event. */
export type SaleorWebhookEvent = {
  __typename?: 'SaleorWebhookEvent';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Asynchronous webhook event. */
export type SaleorWebhookEventAsync = {
  __typename?: 'SaleorWebhookEventAsync';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeAsyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Synchronous webhook event. */
export type SaleorWebhookEventSync = {
  __typename?: 'SaleorWebhookEventSync';
  /** Internal name of the event type. */
  eventType: SaleorWebhookEventTypeSyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeAsyncEnum =
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  | 'CHECKOUT_FULLY_PAID'
  /**
   * A checkout metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /**
   * A collection metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /**
   * A customer account metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /**
   * A fulfillment metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'FULFILLMENT_METADATA_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /**
   * A gift card metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'GIFT_CARD_METADATA_UPDATED'
  /**
   * A gift card has been sent.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /**
   * An order metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'ORDER_METADATA_UPDATED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /**
   * A new product media is created.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_CREATED'
  /**
   * A product media is deleted.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_DELETED'
  /**
   * A product media is updated.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_UPDATED'
  /**
   * A product metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. */
  | 'PRODUCT_VARIANT_DELETED'
  /**
   * A product variant metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /**
   * A shipping zone metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  /**
   * A thumbnail is created.
   *
   * Added in Saleor 3.12.
   */
  | 'THUMBNAIL_CREATED'
  /**
   * An action requested for transaction.
   *
   * DEPRECATED: this subscription will be removed in Saleor 3.14 (Preview Feature). Use `TRANSACTION_CHARGE_REQUESTED`, `TRANSACTION_REFUND_REQUESTED`, `TRANSACTION_CANCELATION_REQUESTED` instead.
   */
  | 'TRANSACTION_ACTION_REQUEST'
  /**
   * Transaction item metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /**
   * A voucher metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /**
   * A warehouse metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeEnum =
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /**
   * Event called for checkout tax calculation.
   *
   * Added in Saleor 3.6.
   */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  | 'CHECKOUT_FULLY_PAID'
  /**
   * A checkout metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /**
   * A collection metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /**
   * A customer account metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /**
   * A fulfillment metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'FULFILLMENT_METADATA_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /**
   * A gift card metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'GIFT_CARD_METADATA_UPDATED'
  /**
   * A gift card has been sent.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /**
   * Event called for order tax calculation.
   *
   * Added in Saleor 3.6.
   */
  | 'ORDER_CALCULATE_TAXES'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /**
   * An order metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'ORDER_METADATA_UPDATED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /**
   * A new product media is created.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_CREATED'
  /**
   * A product media is deleted.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_DELETED'
  /**
   * A product media is updated.
   *
   * Added in Saleor 3.12.
   */
  | 'PRODUCT_MEDIA_UPDATED'
  /**
   * A product metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. */
  | 'PRODUCT_VARIANT_DELETED'
  /**
   * A product variant metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /**
   * A shipping zone metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  /**
   * A thumbnail is created.
   *
   * Added in Saleor 3.12.
   */
  | 'THUMBNAIL_CREATED'
  /**
   * An action requested for transaction.
   *
   * DEPRECATED: this subscription will be removed in Saleor 3.14 (Preview Feature). Use `TRANSACTION_CHARGE_REQUESTED`, `TRANSACTION_REFUND_REQUESTED`, `TRANSACTION_CANCELATION_REQUESTED` instead.
   */
  | 'TRANSACTION_ACTION_REQUEST'
  /**
   * Event called when cancel has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /**
   * Event called when charge has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  /**
   * Transaction item metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSACTION_PROCESS_SESSION'
  /**
   * Event called when refund has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_REFUND_REQUESTED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /**
   * A voucher metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /**
   * A warehouse metadata is updated.
   *
   * Added in Saleor 3.8.
   */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type SaleorWebhookEventTypeSyncEnum =
  /**
   * Event called for checkout tax calculation.
   *
   * Added in Saleor 3.6.
   */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  /**
   * Event called for order tax calculation.
   *
   * Added in Saleor 3.6.
   */
  | 'ORDER_CALCULATE_TAXES'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  /**
   * Event called when cancel has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /**
   * Event called when charge has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  | 'TRANSACTION_PROCESS_SESSION'
  /**
   * Event called when refund has been requested for transaction.
   *
   * Added in Saleor 3.13.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  | 'TRANSACTION_REFUND_REQUESTED';

/** An enumeration. */
export type SaleorWebhookSampleEventTypeEnum =
  | 'ADDRESS_CREATED'
  | 'ADDRESS_DELETED'
  | 'ADDRESS_UPDATED'
  | 'APP_DELETED'
  | 'APP_INSTALLED'
  | 'APP_STATUS_CHANGED'
  | 'APP_UPDATED'
  | 'ATTRIBUTE_CREATED'
  | 'ATTRIBUTE_DELETED'
  | 'ATTRIBUTE_UPDATED'
  | 'ATTRIBUTE_VALUE_CREATED'
  | 'ATTRIBUTE_VALUE_DELETED'
  | 'ATTRIBUTE_VALUE_UPDATED'
  | 'CATEGORY_CREATED'
  | 'CATEGORY_DELETED'
  | 'CATEGORY_UPDATED'
  | 'CHANNEL_CREATED'
  | 'CHANNEL_DELETED'
  | 'CHANNEL_STATUS_CHANGED'
  | 'CHANNEL_UPDATED'
  | 'CHECKOUT_CREATED'
  | 'CHECKOUT_FULLY_PAID'
  | 'CHECKOUT_METADATA_UPDATED'
  | 'CHECKOUT_UPDATED'
  | 'COLLECTION_CREATED'
  | 'COLLECTION_DELETED'
  | 'COLLECTION_METADATA_UPDATED'
  | 'COLLECTION_UPDATED'
  | 'CUSTOMER_CREATED'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_METADATA_UPDATED'
  | 'CUSTOMER_UPDATED'
  | 'DRAFT_ORDER_CREATED'
  | 'DRAFT_ORDER_DELETED'
  | 'DRAFT_ORDER_UPDATED'
  | 'FULFILLMENT_APPROVED'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_CREATED'
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'GIFT_CARD_CREATED'
  | 'GIFT_CARD_DELETED'
  | 'GIFT_CARD_METADATA_UPDATED'
  | 'GIFT_CARD_SENT'
  | 'GIFT_CARD_STATUS_CHANGED'
  | 'GIFT_CARD_UPDATED'
  | 'INVOICE_DELETED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'MENU_CREATED'
  | 'MENU_DELETED'
  | 'MENU_ITEM_CREATED'
  | 'MENU_ITEM_DELETED'
  | 'MENU_ITEM_UPDATED'
  | 'MENU_UPDATED'
  | 'NOTIFY_USER'
  | 'OBSERVABILITY'
  | 'ORDER_CANCELLED'
  | 'ORDER_CONFIRMED'
  | 'ORDER_CREATED'
  | 'ORDER_EXPIRED'
  | 'ORDER_FULFILLED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_METADATA_UPDATED'
  | 'ORDER_UPDATED'
  | 'PAGE_CREATED'
  | 'PAGE_DELETED'
  | 'PAGE_TYPE_CREATED'
  | 'PAGE_TYPE_DELETED'
  | 'PAGE_TYPE_UPDATED'
  | 'PAGE_UPDATED'
  | 'PERMISSION_GROUP_CREATED'
  | 'PERMISSION_GROUP_DELETED'
  | 'PERMISSION_GROUP_UPDATED'
  | 'PRODUCT_CREATED'
  | 'PRODUCT_DELETED'
  | 'PRODUCT_MEDIA_CREATED'
  | 'PRODUCT_MEDIA_DELETED'
  | 'PRODUCT_MEDIA_UPDATED'
  | 'PRODUCT_METADATA_UPDATED'
  | 'PRODUCT_UPDATED'
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  | 'PRODUCT_VARIANT_CREATED'
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  | 'PRODUCT_VARIANT_UPDATED'
  | 'SALE_CREATED'
  | 'SALE_DELETED'
  | 'SALE_TOGGLE'
  | 'SALE_UPDATED'
  | 'SHIPPING_PRICE_CREATED'
  | 'SHIPPING_PRICE_DELETED'
  | 'SHIPPING_PRICE_UPDATED'
  | 'SHIPPING_ZONE_CREATED'
  | 'SHIPPING_ZONE_DELETED'
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  | 'SHIPPING_ZONE_UPDATED'
  | 'STAFF_CREATED'
  | 'STAFF_DELETED'
  | 'STAFF_UPDATED'
  | 'THUMBNAIL_CREATED'
  | 'TRANSACTION_ACTION_REQUEST'
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSLATION_CREATED'
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CREATED'
  | 'VOUCHER_DELETED'
  | 'VOUCHER_METADATA_UPDATED'
  | 'VOUCHER_UPDATED'
  | 'WAREHOUSE_CREATED'
  | 'WAREHOUSE_DELETED'
  | 'WAREHOUSE_METADATA_UPDATED'
  | 'WAREHOUSE_UPDATED';

/**
 * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
 *
 * Added in Saleor 3.11.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type SaleorWebhookTrigger = {
  __typename?: 'SaleorWebhookTrigger';
  delivery?: Maybe<SaleorEventDelivery>;
  errors: Array<SaleorWebhookTriggerError>;
};

export type SaleorWebhookTriggerError = {
  __typename?: 'SaleorWebhookTriggerError';
  /** The error code. */
  code: SaleorWebhookTriggerErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type SaleorWebhookTriggerErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_QUERY'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

/**
 * Updates a webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type SaleorWebhookUpdate = {
  __typename?: 'SaleorWebhookUpdate';
  errors: Array<SaleorWebhookError>;
  webhook?: Maybe<SaleorWebhook>;
  /** @deprecated This field will be removed in Saleor 4.0. Use `errors` field instead. */
  webhookErrors: Array<SaleorWebhookError>;
};

export type SaleorWebhookUpdateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<SaleorWebhookEventTypeAsyncEnum>>;
  /**
   * Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only "X-*" and "Authorization*" keys are allowed.
   *
   * Added in Saleor 3.12.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  customHeaders?: InputMaybe<Scalars['SaleorJSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<SaleorWebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Subscription query used to define a webhook payload.
   *
   * Added in Saleor 3.2.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed in Saleor 4.0. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<SaleorWebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Represents weight value in a specific weight unit. */
export type SaleorWeight = {
  __typename?: 'SaleorWeight';
  /** Weight unit. */
  unit: SaleorWeightUnitsEnum;
  /** Weight value. */
  value: Scalars['Float']['output'];
};

/** An enumeration. */
export type SaleorWeightUnitsEnum =
  | 'G'
  | 'KG'
  | 'LB'
  | 'OZ'
  | 'TONNE';

/** _Entity union as defined by Federation spec. */
export type Saleor_Entity = SaleorAddress | SaleorApp | SaleorCategory | SaleorCollection | SaleorGroup | SaleorOrder | SaleorPageType | SaleorProduct | SaleorProductMedia | SaleorProductType | SaleorProductVariant | SaleorUser;

/** _Service manifest as defined by Federation spec. */
export type Saleor_Service = {
  __typename?: 'Saleor_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type StrapiArticle = {
  __typename?: 'StrapiArticle';
  article_symptom?: Maybe<StrapiArticleSymptomEntityResponse>;
  article_tag?: Maybe<StrapiArticleTagEntityResponse>;
  blocks?: Maybe<Array<Maybe<StrapiArticleBlocksDynamicZone>>>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureImage?: Maybe<StrapiUploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiArticleRelationResponseCollection>;
  metaSeo?: Maybe<StrapiComponentSeoMetaSeo>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  readingTime: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiArticlelocalizationsArgs = {
  filters?: InputMaybe<StrapiArticleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiArticleBlocksDynamicZone = StrapiComponentArticleBlocksContent | StrapiComponentArticleBlocksImage | StrapiComponentArticleBlocksImageBanner | StrapiComponentArticleBlocksTextBanner | StrapiError;

export type StrapiArticleEntity = {
  __typename?: 'StrapiArticleEntity';
  attributes?: Maybe<StrapiArticle>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiArticleEntityResponse = {
  __typename?: 'StrapiArticleEntityResponse';
  data?: Maybe<StrapiArticleEntity>;
};

export type StrapiArticleEntityResponseCollection = {
  __typename?: 'StrapiArticleEntityResponseCollection';
  data: Array<StrapiArticleEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiArticleFiltersInput>>>;
  article_symptom?: InputMaybe<StrapiArticleSymptomFiltersInput>;
  article_tag?: InputMaybe<StrapiArticleTagFiltersInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiArticleFiltersInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  not?: InputMaybe<StrapiArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiArticleFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  readingTime?: InputMaybe<StrapiIntFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiArticleInput = {
  article_symptom?: InputMaybe<Scalars['ID']['input']>;
  article_tag?: InputMaybe<Scalars['ID']['input']>;
  blocks?: InputMaybe<Array<Scalars['StrapiArticleBlocksDynamicZoneInput']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureImage?: InputMaybe<Scalars['ID']['input']>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  readingTime?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiArticleRelationResponseCollection = {
  __typename?: 'StrapiArticleRelationResponseCollection';
  data: Array<StrapiArticleEntity>;
};

export type StrapiArticleSymptom = {
  __typename?: 'StrapiArticleSymptom';
  articles?: Maybe<StrapiArticleRelationResponseCollection>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiArticleSymptomarticlesArgs = {
  filters?: InputMaybe<StrapiArticleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiArticleSymptomEntity = {
  __typename?: 'StrapiArticleSymptomEntity';
  attributes?: Maybe<StrapiArticleSymptom>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiArticleSymptomEntityResponse = {
  __typename?: 'StrapiArticleSymptomEntityResponse';
  data?: Maybe<StrapiArticleSymptomEntity>;
};

export type StrapiArticleSymptomEntityResponseCollection = {
  __typename?: 'StrapiArticleSymptomEntityResponseCollection';
  data: Array<StrapiArticleSymptomEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiArticleSymptomFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiArticleSymptomFiltersInput>>>;
  articles?: InputMaybe<StrapiArticleFiltersInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiArticleSymptomFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiArticleSymptomFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiArticleSymptomInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiArticleSymptomRelationResponseCollection = {
  __typename?: 'StrapiArticleSymptomRelationResponseCollection';
  data: Array<StrapiArticleSymptomEntity>;
};

export type StrapiArticleTag = {
  __typename?: 'StrapiArticleTag';
  articles?: Maybe<StrapiArticleRelationResponseCollection>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiArticleTagarticlesArgs = {
  filters?: InputMaybe<StrapiArticleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiArticleTagEntity = {
  __typename?: 'StrapiArticleTagEntity';
  attributes?: Maybe<StrapiArticleTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiArticleTagEntityResponse = {
  __typename?: 'StrapiArticleTagEntityResponse';
  data?: Maybe<StrapiArticleTagEntity>;
};

export type StrapiArticleTagEntityResponseCollection = {
  __typename?: 'StrapiArticleTagEntityResponseCollection';
  data: Array<StrapiArticleTagEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiArticleTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiArticleTagFiltersInput>>>;
  articles?: InputMaybe<StrapiArticleFiltersInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiArticleTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiArticleTagFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiArticleTagInput = {
  articles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiBooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<StrapiBooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StrapiClinicsCity = {
  __typename?: 'StrapiClinicsCity';
  TopBanner: StrapiComponentBlocksHeroImage;
  city: Scalars['String']['output'];
  clinics_streets?: Maybe<StrapiClinicsStreetRelationResponseCollection>;
  common_city: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  isGhost: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiClinicsCityRelationResponseCollection>;
  mapCityClinics: StrapiComponentClinicsMapCityBanner;
  metaSeo: StrapiComponentSeoMetaSeo;
  priority: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  seoSectionCityGhost?: Maybe<StrapiComponentSeoSeoSectionCityGhost>;
  seoSectionCityLive?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiClinicsCityclinics_streetsArgs = {
  filters?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiClinicsCitylocalizationsArgs = {
  filters?: InputMaybe<StrapiClinicsCityFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiClinicsCityEntity = {
  __typename?: 'StrapiClinicsCityEntity';
  attributes?: Maybe<StrapiClinicsCity>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiClinicsCityEntityResponse = {
  __typename?: 'StrapiClinicsCityEntityResponse';
  data?: Maybe<StrapiClinicsCityEntity>;
};

export type StrapiClinicsCityEntityResponseCollection = {
  __typename?: 'StrapiClinicsCityEntityResponseCollection';
  data: Array<StrapiClinicsCityEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiClinicsCityFiltersInput = {
  TopBanner?: InputMaybe<StrapiComponentBlocksHeroImageFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiClinicsCityFiltersInput>>>;
  city?: InputMaybe<StrapiStringFilterInput>;
  clinics_streets?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  common_city?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  isGhost?: InputMaybe<StrapiBooleanFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiClinicsCityFiltersInput>;
  mapCityClinics?: InputMaybe<StrapiComponentClinicsMapCityBannerFiltersInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  not?: InputMaybe<StrapiClinicsCityFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiClinicsCityFiltersInput>>>;
  priority?: InputMaybe<StrapiIntFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  seoSectionCityGhost?: InputMaybe<StrapiComponentSeoSeoSectionCityGhostFiltersInput>;
  seoSectionCityLive?: InputMaybe<StrapiStringFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiClinicsCityInput = {
  TopBanner?: InputMaybe<StrapiComponentBlocksHeroImageInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  clinics_streets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  common_city?: InputMaybe<Scalars['String']['input']>;
  isGhost?: InputMaybe<Scalars['Boolean']['input']>;
  mapCityClinics?: InputMaybe<StrapiComponentClinicsMapCityBannerInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  seoSectionCityGhost?: InputMaybe<StrapiComponentSeoSeoSectionCityGhostInput>;
  seoSectionCityLive?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiClinicsCityRelationResponseCollection = {
  __typename?: 'StrapiClinicsCityRelationResponseCollection';
  data: Array<StrapiClinicsCityEntity>;
};

export type StrapiClinicsStreet = {
  __typename?: 'StrapiClinicsStreet';
  TopBanner: StrapiComponentBlocksHeroImage;
  address: StrapiComponentClinicsAddress;
  clinicImageCard: StrapiUploadFileEntityResponse;
  clinics_city?: Maybe<StrapiClinicsCityEntityResponse>;
  common_clinic: Scalars['String']['output'];
  contact: StrapiComponentClinicsContactInfo;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  facilities: StrapiComponentClinicsFacilities;
  faqSection?: Maybe<StrapiComponentDynamicblocksFaqSection>;
  googleMap: Scalars['String']['output'];
  isVaccinationSchedule: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['String']['output']>;
  lng: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiClinicsStreetRelationResponseCollection>;
  metaSeo: StrapiComponentSeoMetaSeo;
  openingList: StrapiComponentClinicsOpeningList;
  priority?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  registrationClinicID: Scalars['String']['output'];
  registrationStepImages: StrapiUploadFileRelationResponseCollection;
  services: StrapiComponentClinicsServices;
  sliderWithGallery: StrapiComponentBlocksSliderWithGallery;
  slug: Scalars['String']['output'];
  street: Scalars['String']['output'];
  streetDescription: Scalars['String']['output'];
  streetDescriptionTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  vaccinationScheduleUrl?: Maybe<Scalars['String']['output']>;
  vaccination_types?: Maybe<StrapiVaccinationTypeRelationResponseCollection>;
};


export type StrapiClinicsStreetlocalizationsArgs = {
  filters?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiClinicsStreetregistrationStepImagesArgs = {
  filters?: InputMaybe<StrapiUploadFileFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiClinicsStreetvaccination_typesArgs = {
  filters?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiClinicsStreetEntity = {
  __typename?: 'StrapiClinicsStreetEntity';
  attributes?: Maybe<StrapiClinicsStreet>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiClinicsStreetEntityResponse = {
  __typename?: 'StrapiClinicsStreetEntityResponse';
  data?: Maybe<StrapiClinicsStreetEntity>;
};

export type StrapiClinicsStreetEntityResponseCollection = {
  __typename?: 'StrapiClinicsStreetEntityResponseCollection';
  data: Array<StrapiClinicsStreetEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiClinicsStreetFiltersInput = {
  TopBanner?: InputMaybe<StrapiComponentBlocksHeroImageFiltersInput>;
  address?: InputMaybe<StrapiComponentClinicsAddressFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiClinicsStreetFiltersInput>>>;
  clinics_city?: InputMaybe<StrapiClinicsCityFiltersInput>;
  common_clinic?: InputMaybe<StrapiStringFilterInput>;
  contact?: InputMaybe<StrapiComponentClinicsContactInfoFiltersInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  facilities?: InputMaybe<StrapiComponentClinicsFacilitiesFiltersInput>;
  faqSection?: InputMaybe<StrapiComponentDynamicblocksFaqSectionFiltersInput>;
  googleMap?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  isVaccinationSchedule?: InputMaybe<StrapiBooleanFilterInput>;
  lat?: InputMaybe<StrapiStringFilterInput>;
  lng?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  not?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  openingList?: InputMaybe<StrapiComponentClinicsOpeningListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiClinicsStreetFiltersInput>>>;
  priority?: InputMaybe<StrapiIntFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  registrationClinicID?: InputMaybe<StrapiStringFilterInput>;
  services?: InputMaybe<StrapiComponentClinicsServicesFiltersInput>;
  sliderWithGallery?: InputMaybe<StrapiComponentBlocksSliderWithGalleryFiltersInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  street?: InputMaybe<StrapiStringFilterInput>;
  streetDescription?: InputMaybe<StrapiStringFilterInput>;
  streetDescriptionTitle?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  vaccinationScheduleUrl?: InputMaybe<StrapiStringFilterInput>;
  vaccination_types?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
};

export type StrapiClinicsStreetInput = {
  TopBanner?: InputMaybe<StrapiComponentBlocksHeroImageInput>;
  address?: InputMaybe<StrapiComponentClinicsAddressInput>;
  clinicImageCard?: InputMaybe<Scalars['ID']['input']>;
  clinics_city?: InputMaybe<Scalars['ID']['input']>;
  common_clinic?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<StrapiComponentClinicsContactInfoInput>;
  facilities?: InputMaybe<StrapiComponentClinicsFacilitiesInput>;
  faqSection?: InputMaybe<StrapiComponentDynamicblocksFaqSectionInput>;
  googleMap?: InputMaybe<Scalars['String']['input']>;
  isVaccinationSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  openingList?: InputMaybe<StrapiComponentClinicsOpeningListInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  registrationClinicID?: InputMaybe<Scalars['String']['input']>;
  registrationStepImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  services?: InputMaybe<StrapiComponentClinicsServicesInput>;
  sliderWithGallery?: InputMaybe<StrapiComponentBlocksSliderWithGalleryInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetDescriptionTitle?: InputMaybe<Scalars['String']['input']>;
  vaccinationScheduleUrl?: InputMaybe<Scalars['String']['input']>;
  vaccination_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type StrapiClinicsStreetRelationResponseCollection = {
  __typename?: 'StrapiClinicsStreetRelationResponseCollection';
  data: Array<StrapiClinicsStreetEntity>;
};

export type StrapiCompanyOpinion = {
  __typename?: 'StrapiCompanyOpinion';
  author: Scalars['String']['output'];
  companyLogo: StrapiUploadFileEntityResponse;
  companyWebLink: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiCompanyOpinionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiCompanyOpinionlocalizationsArgs = {
  filters?: InputMaybe<StrapiCompanyOpinionFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiCompanyOpinionEntity = {
  __typename?: 'StrapiCompanyOpinionEntity';
  attributes?: Maybe<StrapiCompanyOpinion>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiCompanyOpinionEntityResponse = {
  __typename?: 'StrapiCompanyOpinionEntityResponse';
  data?: Maybe<StrapiCompanyOpinionEntity>;
};

export type StrapiCompanyOpinionEntityResponseCollection = {
  __typename?: 'StrapiCompanyOpinionEntityResponseCollection';
  data: Array<StrapiCompanyOpinionEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiCompanyOpinionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiCompanyOpinionFiltersInput>>>;
  author?: InputMaybe<StrapiStringFilterInput>;
  companyWebLink?: InputMaybe<StrapiStringFilterInput>;
  content?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiCompanyOpinionFiltersInput>;
  not?: InputMaybe<StrapiCompanyOpinionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiCompanyOpinionFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiCompanyOpinionInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  companyLogo?: InputMaybe<Scalars['ID']['input']>;
  companyWebLink?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiCompanyOpinionRelationResponseCollection = {
  __typename?: 'StrapiCompanyOpinionRelationResponseCollection';
  data: Array<StrapiCompanyOpinionEntity>;
};

export type StrapiComponentArticleBlocksContent = {
  __typename?: 'StrapiComponentArticleBlocksContent';
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  withPadding?: Maybe<Scalars['Boolean']['output']>;
};

export type StrapiComponentArticleBlocksImage = {
  __typename?: 'StrapiComponentArticleBlocksImage';
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
};

export type StrapiComponentArticleBlocksImageBanner = {
  __typename?: 'StrapiComponentArticleBlocksImageBanner';
  button?: Maybe<StrapiComponentSharedButton>;
  componentBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  componentVariant?: Maybe<StrapiENUM_COMPONENTARTICLEBLOCKSIMAGEBANNER_COMPONENTVARIANT>;
  iconVariant?: Maybe<StrapiENUM_COMPONENTARTICLEBLOCKSIMAGEBANNER_ICONVARIANT>;
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
  text?: Maybe<Scalars['String']['output']>;
  vectorBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  vectorDotsColor?: Maybe<StrapiComponentEnumsColorVariants>;
  withNfz?: Maybe<Scalars['Boolean']['output']>;
};

export type StrapiComponentArticleBlocksTextBanner = {
  __typename?: 'StrapiComponentArticleBlocksTextBanner';
  button?: Maybe<StrapiComponentSharedButton>;
  componentBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  iconVariant?: Maybe<StrapiENUM_COMPONENTARTICLEBLOCKSTEXTBANNER_ICONVARIANT>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  variant: StrapiENUM_COMPONENTARTICLEBLOCKSTEXTBANNER_VARIANT;
};

export type StrapiComponentBlocksCtaBanner = {
  __typename?: 'StrapiComponentBlocksCtaBanner';
  buttonLink: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentBlocksCtaBannerInput = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksHero = {
  __typename?: 'StrapiComponentBlocksHero';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentBlocksHeroImage = {
  __typename?: 'StrapiComponentBlocksHeroImage';
  CTAText: Scalars['String']['output'];
  CTATextTwo?: Maybe<Scalars['String']['output']>;
  CTAUrl?: Maybe<Scalars['String']['output']>;
  CTAUrlTwo?: Maybe<Scalars['String']['output']>;
  Image: StrapiUploadFileEntityResponse;
  buttonLink: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRight?: Maybe<Scalars['Boolean']['output']>;
  subtitle: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentBlocksHeroImageFiltersInput = {
  CTAText?: InputMaybe<StrapiStringFilterInput>;
  CTATextTwo?: InputMaybe<StrapiStringFilterInput>;
  CTAUrl?: InputMaybe<StrapiStringFilterInput>;
  CTAUrlTwo?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksHeroImageFiltersInput>>>;
  buttonLink?: InputMaybe<StrapiStringFilterInput>;
  buttonText?: InputMaybe<StrapiStringFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  isRight?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentBlocksHeroImageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksHeroImageFiltersInput>>>;
  subtitle?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentBlocksHeroImageInput = {
  CTAText?: InputMaybe<Scalars['String']['input']>;
  CTATextTwo?: InputMaybe<Scalars['String']['input']>;
  CTAUrl?: InputMaybe<Scalars['String']['input']>;
  CTAUrlTwo?: InputMaybe<Scalars['String']['input']>;
  Image?: InputMaybe<Scalars['ID']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRight?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksHeroInput = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksLinkText = {
  __typename?: 'StrapiComponentBlocksLinkText';
  id: Scalars['ID']['output'];
  linkHref: Scalars['String']['output'];
  linkText: Scalars['String']['output'];
};

export type StrapiComponentBlocksLinkTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksLinkTextFiltersInput>>>;
  linkHref?: InputMaybe<StrapiStringFilterInput>;
  linkText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentBlocksLinkTextFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksLinkTextFiltersInput>>>;
};

export type StrapiComponentBlocksLinkTextInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linkHref?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksNfzBanner = {
  __typename?: 'StrapiComponentBlocksNfzBanner';
  buttonText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentBlocksNfzBannerInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksPhoneMessageItem = {
  __typename?: 'StrapiComponentBlocksPhoneMessageItem';
  authorName: Scalars['String']['output'];
  avatar: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  messageContent: Scalars['String']['output'];
  messageDate: Scalars['String']['output'];
  messageType: StrapiENUM_COMPONENTBLOCKSPHONEMESSAGEITEM_MESSAGETYPE;
};

export type StrapiComponentBlocksPhoneMessageItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksPhoneMessageItemFiltersInput>>>;
  authorName?: InputMaybe<StrapiStringFilterInput>;
  messageContent?: InputMaybe<StrapiStringFilterInput>;
  messageDate?: InputMaybe<StrapiStringFilterInput>;
  messageType?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentBlocksPhoneMessageItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksPhoneMessageItemFiltersInput>>>;
};

export type StrapiComponentBlocksSliderWithGallery = {
  __typename?: 'StrapiComponentBlocksSliderWithGallery';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaSliderImages?: Maybe<StrapiUploadFileRelationResponseCollection>;
  mediaSliderVideo?: Maybe<StrapiComponentBlocksVideoSlider>;
  title?: Maybe<Scalars['String']['output']>;
  videoPreviewImage?: Maybe<StrapiUploadFileEntityResponse>;
};


export type StrapiComponentBlocksSliderWithGallerymediaSliderImagesArgs = {
  filters?: InputMaybe<StrapiUploadFileFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentBlocksSliderWithGalleryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksSliderWithGalleryFiltersInput>>>;
  description?: InputMaybe<StrapiStringFilterInput>;
  mediaSliderVideo?: InputMaybe<StrapiComponentBlocksVideoSliderFiltersInput>;
  not?: InputMaybe<StrapiComponentBlocksSliderWithGalleryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksSliderWithGalleryFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentBlocksSliderWithGalleryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mediaSliderImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mediaSliderVideo?: InputMaybe<StrapiComponentBlocksVideoSliderInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoPreviewImage?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentBlocksTextWithIcon = {
  __typename?: 'StrapiComponentBlocksTextWithIcon';
  id: Scalars['ID']['output'];
  itemIcon?: Maybe<StrapiUploadFileEntityResponse>;
  itemText: Scalars['String']['output'];
};

export type StrapiComponentBlocksTextWithIconFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksTextWithIconFiltersInput>>>;
  itemText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentBlocksTextWithIconFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksTextWithIconFiltersInput>>>;
};

export type StrapiComponentBlocksTextWithIconInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemIcon?: InputMaybe<Scalars['ID']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksThreeIconBanner = {
  __typename?: 'StrapiComponentBlocksThreeIconBanner';
  id: Scalars['ID']['output'];
  threeIconItems: Array<Maybe<StrapiComponentBlocksThreeIconsBannerItem>>;
};


export type StrapiComponentBlocksThreeIconBannerthreeIconItemsArgs = {
  filters?: InputMaybe<StrapiComponentBlocksThreeIconsBannerItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentBlocksThreeIconBannerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  threeIconItems?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksThreeIconsBannerItemInput>>>;
};

export type StrapiComponentBlocksThreeIconsBannerItem = {
  __typename?: 'StrapiComponentBlocksThreeIconsBannerItem';
  ctaButton: Scalars['Boolean']['output'];
  ctaButtonLink?: Maybe<Scalars['String']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  icon: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  line: Scalars['Boolean']['output'];
  mobileLine?: Maybe<Scalars['Boolean']['output']>;
  size: StrapiENUM_COMPONENTBLOCKSTHREEICONSBANNERITEM_SIZE;
  title: Scalars['String']['output'];
};

export type StrapiComponentBlocksThreeIconsBannerItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksThreeIconsBannerItemFiltersInput>>>;
  ctaButton?: InputMaybe<StrapiBooleanFilterInput>;
  ctaButtonLink?: InputMaybe<StrapiStringFilterInput>;
  ctaButtonText?: InputMaybe<StrapiStringFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  line?: InputMaybe<StrapiBooleanFilterInput>;
  mobileLine?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentBlocksThreeIconsBannerItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksThreeIconsBannerItemFiltersInput>>>;
  size?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentBlocksThreeIconsBannerItemInput = {
  ctaButton?: InputMaybe<Scalars['Boolean']['input']>;
  ctaButtonLink?: InputMaybe<Scalars['String']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  line?: InputMaybe<Scalars['Boolean']['input']>;
  mobileLine?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<StrapiENUM_COMPONENTBLOCKSTHREEICONSBANNERITEM_SIZE>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksVideoBanner = {
  __typename?: 'StrapiComponentBlocksVideoBanner';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  videoLink?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentBlocksVideoBannerInput = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksVideoHero = {
  __typename?: 'StrapiComponentBlocksVideoHero';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentBlocksVideoHeroInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentBlocksVideoSlider = {
  __typename?: 'StrapiComponentBlocksVideoSlider';
  id: Scalars['ID']['output'];
  previewImage?: Maybe<StrapiUploadFileEntityResponse>;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoLInk?: Maybe<Scalars['String']['output']>;
  videoTitle?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentBlocksVideoSliderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksVideoSliderFiltersInput>>>;
  not?: InputMaybe<StrapiComponentBlocksVideoSliderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksVideoSliderFiltersInput>>>;
  videoAlt?: InputMaybe<StrapiStringFilterInput>;
  videoLInk?: InputMaybe<StrapiStringFilterInput>;
  videoTitle?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentBlocksVideoSliderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  previewImage?: InputMaybe<Scalars['ID']['input']>;
  videoAlt?: InputMaybe<Scalars['String']['input']>;
  videoLInk?: InputMaybe<Scalars['String']['input']>;
  videoTitle?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsAddress = {
  __typename?: 'StrapiComponentClinicsAddress';
  additionalInformation: Scalars['String']['output'];
  city: Scalars['String']['output'];
  googleMap?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  postCode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentClinicsAddressFiltersInput = {
  additionalInformation?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsAddressFiltersInput>>>;
  city?: InputMaybe<StrapiStringFilterInput>;
  googleMap?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentClinicsAddressFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsAddressFiltersInput>>>;
  postCode?: InputMaybe<StrapiStringFilterInput>;
  street?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsAddressInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  googleMap?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsCitiesListLinks = {
  __typename?: 'StrapiComponentClinicsCitiesListLinks';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentClinicsCitiesListLinksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsCityCommonInfo = {
  __typename?: 'StrapiComponentClinicsCityCommonInfo';
  city: Scalars['String']['output'];
  common_city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type StrapiComponentClinicsClinicsBigCards = {
  __typename?: 'StrapiComponentClinicsClinicsBigCards';
  buttonText: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentClinicsClinicsBigCardsInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsClinicsSmallCards = {
  __typename?: 'StrapiComponentClinicsClinicsSmallCards';
  allClinicsText: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentClinicsClinicsSmallCardsInput = {
  allClinicsText?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsContactInfo = {
  __typename?: 'StrapiComponentClinicsContactInfo';
  id: Scalars['ID']['output'];
  mail: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentClinicsContactInfoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsContactInfoFiltersInput>>>;
  mail?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentClinicsContactInfoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsContactInfoFiltersInput>>>;
  phone?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsContactInfoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsDoctorsSliderBanner = {
  __typename?: 'StrapiComponentClinicsDoctorsSliderBanner';
  description?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<StrapiDoctorRelationResponseCollection>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentClinicsDoctorsSliderBannerdoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentClinicsDoctorsSliderBannerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  doctors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsFacilities = {
  __typename?: 'StrapiComponentClinicsFacilities';
  facilityItem: Array<Maybe<StrapiComponentBlocksTextWithIcon>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};


export type StrapiComponentClinicsFacilitiesfacilityItemArgs = {
  filters?: InputMaybe<StrapiComponentBlocksTextWithIconFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentClinicsFacilitiesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsFacilitiesFiltersInput>>>;
  facilityItem?: InputMaybe<StrapiComponentBlocksTextWithIconFiltersInput>;
  not?: InputMaybe<StrapiComponentClinicsFacilitiesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsFacilitiesFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsFacilitiesInput = {
  facilityItem?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksTextWithIconInput>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsMapCityBanner = {
  __typename?: 'StrapiComponentClinicsMapCityBanner';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  textLeft?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentClinicsMapCityBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsMapCityBannerFiltersInput>>>;
  description?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentClinicsMapCityBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsMapCityBannerFiltersInput>>>;
  textLeft?: InputMaybe<StrapiBooleanFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsMapCityBannerInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  textLeft?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsOpeningInformation = {
  __typename?: 'StrapiComponentClinicsOpeningInformation';
  dzien?: Maybe<StrapiENUM_COMPONENTCLINICSOPENINGINFORMATION_DZIEN>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentClinicsOpeningItem = {
  __typename?: 'StrapiComponentClinicsOpeningItem';
  id: Scalars['ID']['output'];
  openingDate: Scalars['String']['output'];
  openingDateTwo?: Maybe<Scalars['String']['output']>;
  openingTitle: Scalars['String']['output'];
};

export type StrapiComponentClinicsOpeningItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsOpeningItemFiltersInput>>>;
  not?: InputMaybe<StrapiComponentClinicsOpeningItemFiltersInput>;
  openingDate?: InputMaybe<StrapiStringFilterInput>;
  openingDateTwo?: InputMaybe<StrapiStringFilterInput>;
  openingTitle?: InputMaybe<StrapiStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsOpeningItemFiltersInput>>>;
};

export type StrapiComponentClinicsOpeningItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  openingDate?: InputMaybe<Scalars['String']['input']>;
  openingDateTwo?: InputMaybe<Scalars['String']['input']>;
  openingTitle?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsOpeningList = {
  __typename?: 'StrapiComponentClinicsOpeningList';
  id: Scalars['ID']['output'];
  openingSection: Array<Maybe<StrapiComponentClinicsOpeningItem>>;
  title: Scalars['String']['output'];
};


export type StrapiComponentClinicsOpeningListopeningSectionArgs = {
  filters?: InputMaybe<StrapiComponentClinicsOpeningItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentClinicsOpeningListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsOpeningListFiltersInput>>>;
  not?: InputMaybe<StrapiComponentClinicsOpeningListFiltersInput>;
  openingSection?: InputMaybe<StrapiComponentClinicsOpeningItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsOpeningListFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsOpeningListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  openingSection?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsOpeningItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsOpeningSection = {
  __typename?: 'StrapiComponentClinicsOpeningSection';
  id: Scalars['ID']['output'];
  openingDate: Scalars['String']['output'];
  openingDateTwo?: Maybe<Scalars['String']['output']>;
  openingTitle: Scalars['String']['output'];
};

export type StrapiComponentClinicsServices = {
  __typename?: 'StrapiComponentClinicsServices';
  id: Scalars['ID']['output'];
  linkText: Array<Maybe<StrapiComponentBlocksLinkText>>;
  title: Scalars['String']['output'];
};


export type StrapiComponentClinicsServiceslinkTextArgs = {
  filters?: InputMaybe<StrapiComponentBlocksLinkTextFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentClinicsServicesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsServicesFiltersInput>>>;
  linkText?: InputMaybe<StrapiComponentBlocksLinkTextFiltersInput>;
  not?: InputMaybe<StrapiComponentClinicsServicesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentClinicsServicesFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentClinicsServicesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Array<InputMaybe<StrapiComponentBlocksLinkTextInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentClinicsTitle = {
  __typename?: 'StrapiComponentClinicsTitle';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksAboutAppPhoneBanner = {
  __typename?: 'StrapiComponentDynamicblocksAboutAppPhoneBanner';
  aboutAppBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  bgColor: StrapiComponentEnumsColor;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneMessages: Array<Maybe<StrapiComponentBlocksPhoneMessageItem>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksAboutAppPhoneBannerphoneMessagesArgs = {
  filters?: InputMaybe<StrapiComponentBlocksPhoneMessageItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksAnimatedDoubleCircles = {
  __typename?: 'StrapiComponentDynamicblocksAnimatedDoubleCircles';
  animatedSize: Scalars['Int']['output'];
  animationText: Scalars['String']['output'];
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  bgColor: StrapiComponentEnumsColor;
  gradientBottomColor: StrapiComponentEnumsColor;
  gradientTopColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  startSize: Scalars['Int']['output'];
};

export type StrapiComponentDynamicblocksAnimatedDoughnutChart = {
  __typename?: 'StrapiComponentDynamicblocksAnimatedDoughnutChart';
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  id: Scalars['ID']['output'];
  primaryColor: StrapiComponentEnumsColor;
  primaryLegendText?: Maybe<Scalars['String']['output']>;
  primaryStrokeDashoffset?: Maybe<Scalars['Int']['output']>;
  secondaryColor: StrapiComponentEnumsColor;
  secondaryLegendText?: Maybe<Scalars['String']['output']>;
  secondaryStrokeDashoffset?: Maybe<Scalars['Int']['output']>;
  sectionBackgroundColor: StrapiComponentEnumsColor;
  svgBackgroundColor: StrapiComponentEnumsColor;
  svgSecondaryText?: Maybe<Scalars['String']['output']>;
  svgText?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksAnimatedEnlargingText = {
  __typename?: 'StrapiComponentDynamicblocksAnimatedEnlargingText';
  animationSize: StrapiENUM_COMPONENTDYNAMICBLOCKSANIMATEDENLARGINGTEXT_ANIMATIONSIZE;
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  enlargingTextColor: StrapiComponentEnumsColor;
  firstTextLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  secondTextLine?: Maybe<Scalars['String']['output']>;
  sectionBackgroundColor: StrapiComponentEnumsColor;
};

export type StrapiComponentDynamicblocksAnimatedPeopleSvg = {
  __typename?: 'StrapiComponentDynamicblocksAnimatedPeopleSvg';
  animatedPeople: Array<Maybe<StrapiComponentSharedSingleAnimatedPersonSvg>>;
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  id: Scalars['ID']['output'];
  sectionBackgroundColor: StrapiComponentEnumsColor;
};


export type StrapiComponentDynamicblocksAnimatedPeopleSvganimatedPeopleArgs = {
  filters?: InputMaybe<StrapiComponentSharedSingleAnimatedPersonSvgFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksAnimatedTextGradient = {
  __typename?: 'StrapiComponentDynamicblocksAnimatedTextGradient';
  animatedText: Scalars['String']['output'];
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  bgColor: StrapiComponentEnumsColor;
  gradientBottomColor: StrapiComponentEnumsColor;
  gradientTopColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  percentageFillDesktop?: Maybe<Scalars['Int']['output']>;
  percentageFillMobile?: Maybe<Scalars['Int']['output']>;
};

export type StrapiComponentDynamicblocksAppRating = {
  __typename?: 'StrapiComponentDynamicblocksAppRating';
  appRatingVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSAPPRATING_APPRATINGVARIANT>;
  bgFitColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  publicationState: StrapiComponentSharedPublicationState;
  ratingItems: Array<Maybe<StrapiComponentSharedAppRatingItem>>;
  ratingNumbersSet: StrapiENUM_COMPONENTDYNAMICBLOCKSAPPRATING_RATINGNUMBERSSET;
  reviews?: Maybe<Array<Maybe<StrapiComponentSharedReview>>>;
  showSvgMobile?: Maybe<Scalars['Boolean']['output']>;
};


export type StrapiComponentDynamicblocksAppRatingratingItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedAppRatingItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentDynamicblocksAppRatingreviewsArgs = {
  filters?: InputMaybe<StrapiComponentSharedReviewFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksCheckedList = {
  __typename?: 'StrapiComponentDynamicblocksCheckedList';
  id: Scalars['ID']['output'];
  isVector: Scalars['Boolean']['output'];
  leftItems: Array<Maybe<StrapiComponentSharedCheckedListITems>>;
  rightItems: Array<Maybe<StrapiComponentSharedCheckedListITems>>;
  roundedVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSCHECKEDLIST_ROUNDEDVARIANT>;
};


export type StrapiComponentDynamicblocksCheckedListleftItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentDynamicblocksCheckedListrightItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksCheckedListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isVector?: InputMaybe<Scalars['Boolean']['input']>;
  leftItems?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckedListITemsInput>>>;
  rightItems?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckedListITemsInput>>>;
  roundedVariant?: InputMaybe<StrapiENUM_COMPONENTDYNAMICBLOCKSCHECKEDLIST_ROUNDEDVARIANT>;
};

export type StrapiComponentDynamicblocksCircleImageWithText = {
  __typename?: 'StrapiComponentDynamicblocksCircleImageWithText';
  backgroundColor: StrapiComponentEnumsColor;
  bottomTitleColor: StrapiComponentEnumsColor;
  closeIconColor: StrapiComponentEnumsColor;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<StrapiUploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  imagePosition: StrapiComponentEnumsPositionX;
  imagePreview: StrapiUploadFileEntityResponse;
  isTitleCentered: Scalars['Boolean']['output'];
  popupBackgroundColor: StrapiComponentEnumsColor;
  titleBottom?: Maybe<Scalars['String']['output']>;
  titleTop?: Maybe<Scalars['String']['output']>;
  topTitleColor: StrapiComponentEnumsColor;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoSrc?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksCirclePhotoBanner = {
  __typename?: 'StrapiComponentDynamicblocksCirclePhotoBanner';
  bgColor: StrapiComponentEnumsColor;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
  link?: Maybe<StrapiComponentSharedLink>;
  title?: Maybe<Scalars['String']['output']>;
  variant: StrapiENUM_COMPONENTDYNAMICBLOCKSCIRCLEPHOTOBANNER_VARIANT;
};

export type StrapiComponentDynamicblocksCitationBanner = {
  __typename?: 'StrapiComponentDynamicblocksCitationBanner';
  backgroundColor: StrapiComponentEnumsColor;
  citition: Scalars['String']['output'];
  closeIconColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  imagePosition: StrapiComponentEnumsPositionX;
  imagePreview: StrapiUploadFileEntityResponse;
  isVector: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  popupBackgroundColor: StrapiComponentEnumsColor;
  position: Scalars['String']['output'];
  theme: StrapiENUM_COMPONENTDYNAMICBLOCKSCITATIONBANNER_THEME;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoLink?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksClinicsMapEcommerce = {
  __typename?: 'StrapiComponentDynamicblocksClinicsMapEcommerce';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksClinicsMapSmall = {
  __typename?: 'StrapiComponentDynamicblocksClinicsMapSmall';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksClinicsSmallSlider = {
  __typename?: 'StrapiComponentDynamicblocksClinicsSmallSlider';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksCompaniesSlider = {
  __typename?: 'StrapiComponentDynamicblocksCompaniesSlider';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksCtaBaseBanner = {
  __typename?: 'StrapiComponentDynamicblocksCtaBaseBanner';
  actionButtons?: Maybe<Array<Maybe<StrapiComponentSharedActions>>>;
  id: Scalars['ID']['output'];
  imagePosition: StrapiComponentEnumsPositionX;
  imagePositionMobile: StrapiComponentEnumsPositionY;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksCtaBaseBanneractionButtonsArgs = {
  filters?: InputMaybe<StrapiComponentSharedActionsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksCtaBigBanner = {
  __typename?: 'StrapiComponentDynamicblocksCtaBigBanner';
  appStoreButtons: StrapiComponentSharedAppStoreButtons;
  componentColor: StrapiComponentEnumsComponentColor;
  contentText?: Maybe<Scalars['String']['output']>;
  ctaButtons?: Maybe<Array<Maybe<StrapiComponentSharedLink>>>;
  ctaImage: StrapiUploadFileEntityResponse;
  descriptionItem?: Maybe<Array<Maybe<StrapiComponentSharedCheckedListITems>>>;
  fullHeightDesktop: Scalars['Boolean']['output'];
  fullHeightMobile: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imagePosition: StrapiComponentEnumsPositionX;
  imagePositionMobile: StrapiComponentEnumsPositionY;
  isTopComponent: Scalars['Boolean']['output'];
  subheading?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksCtaBigBannerctaButtonsArgs = {
  filters?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentDynamicblocksCtaBigBannerdescriptionItemArgs = {
  filters?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksCtaBigBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksCtaBigBannerFiltersInput>>>;
  appStoreButtons?: InputMaybe<StrapiComponentSharedAppStoreButtonsFiltersInput>;
  componentColor?: InputMaybe<StrapiComponentEnumsComponentColorFiltersInput>;
  contentText?: InputMaybe<StrapiStringFilterInput>;
  ctaButtons?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  descriptionItem?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  fullHeightDesktop?: InputMaybe<StrapiBooleanFilterInput>;
  fullHeightMobile?: InputMaybe<StrapiBooleanFilterInput>;
  imagePosition?: InputMaybe<StrapiComponentEnumsPositionXFiltersInput>;
  imagePositionMobile?: InputMaybe<StrapiComponentEnumsPositionYFiltersInput>;
  isTopComponent?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentDynamicblocksCtaBigBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksCtaBigBannerFiltersInput>>>;
  subheading?: InputMaybe<StrapiStringFilterInput>;
  subtitle?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentDynamicblocksCtaBigBannerSlider = {
  __typename?: 'StrapiComponentDynamicblocksCtaBigBannerSlider';
  ctaSliders: Array<Maybe<StrapiComponentDynamicblocksCtaBigBanner>>;
  id: Scalars['ID']['output'];
  isTopComponent: Scalars['Boolean']['output'];
  withAnimation: Scalars['Boolean']['output'];
};


export type StrapiComponentDynamicblocksCtaBigBannerSliderctaSlidersArgs = {
  filters?: InputMaybe<StrapiComponentDynamicblocksCtaBigBannerFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksCtaButtonLink = {
  __typename?: 'StrapiComponentDynamicblocksCtaButtonLink';
  action?: Maybe<StrapiComponentEnumsActions>;
  background?: Maybe<StrapiComponentEnumsOptionalColor>;
  buttonData: StrapiComponentSharedButton;
  buttonPosition: StrapiComponentEnumsJustify;
  customSpacing?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxWidth: StrapiComponentEnumsMaxWidth;
  visability: StrapiComponentSharedVisability;
  withAction?: Maybe<Scalars['Boolean']['output']>;
};

export type StrapiComponentDynamicblocksCtaGraphicBanner = {
  __typename?: 'StrapiComponentDynamicblocksCtaGraphicBanner';
  componentColor: StrapiComponentEnumsComponentColor;
  contentText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  moreText?: Maybe<Scalars['String']['output']>;
  subheading?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vectorsFirstColor: StrapiComponentEnumsColor;
  vectorsSecondColor: StrapiComponentEnumsColor;
};

export type StrapiComponentDynamicblocksCtaRegisterBanner = {
  __typename?: 'StrapiComponentDynamicblocksCtaRegisterBanner';
  backgroundImage: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  linkButton?: Maybe<StrapiComponentSharedButton>;
  servicesList?: Maybe<Array<Maybe<StrapiComponentSharedCtaRegisterItem>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  textNote?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksCtaRegisterBannerservicesListArgs = {
  filters?: InputMaybe<StrapiComponentSharedCtaRegisterItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksDoctorsSlider = {
  __typename?: 'StrapiComponentDynamicblocksDoctorsSlider';
  customDoctors?: Maybe<StrapiDoctorRelationResponseCollection>;
  id: Scalars['ID']['output'];
  sliderVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSDOCTORSSLIDER_SLIDERVARIANT>;
  withAnimation: Scalars['Boolean']['output'];
};


export type StrapiComponentDynamicblocksDoctorsSlidercustomDoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksDownloadAppBanner = {
  __typename?: 'StrapiComponentDynamicblocksDownloadAppBanner';
  checkoutItem?: Maybe<Array<Maybe<StrapiComponentSharedCheckedListITems>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneMockImage: StrapiUploadFileEntityResponse;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksDownloadAppBannercheckoutItemArgs = {
  filters?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksFaqSection = {
  __typename?: 'StrapiComponentDynamicblocksFaqSection';
  faqVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSFAQSECTION_FAQVARIANT>;
  faq_pages_new?: Maybe<StrapiFaqPagesNewEntityResponse>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksFaqSectionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksFaqSectionFiltersInput>>>;
  faqVariant?: InputMaybe<StrapiStringFilterInput>;
  faq_pages_new?: InputMaybe<StrapiFaqPagesNewFiltersInput>;
  not?: InputMaybe<StrapiComponentDynamicblocksFaqSectionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksFaqSectionFiltersInput>>>;
};

export type StrapiComponentDynamicblocksFaqSectionInput = {
  faqVariant?: InputMaybe<StrapiENUM_COMPONENTDYNAMICBLOCKSFAQSECTION_FAQVARIANT>;
  faq_pages_new?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentDynamicblocksFaqWithSlider = {
  __typename?: 'StrapiComponentDynamicblocksFaqWithSlider';
  faqSliders: Array<Maybe<StrapiComponentSharedFaqSliderItem>>;
  faq_pages_new?: Maybe<StrapiFaqPagesNewEntityResponse>;
  id: Scalars['ID']['output'];
};


export type StrapiComponentDynamicblocksFaqWithSliderfaqSlidersArgs = {
  filters?: InputMaybe<StrapiComponentSharedFaqSliderItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksHeaderSection = {
  __typename?: 'StrapiComponentDynamicblocksHeaderSection';
  background?: Maybe<StrapiComponentEnumsOptionalColor>;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  innerWidth?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<StrapiComponentSharedLink>;
  maxWidth: StrapiComponentEnumsMaxWidth;
  textPosition: StrapiComponentEnumsJustify;
  visability: StrapiComponentSharedVisability;
};

export type StrapiComponentDynamicblocksHeaderSectionInput = {
  background?: InputMaybe<StrapiComponentEnumsOptionalColorInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  innerWidth?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<StrapiComponentSharedLinkInput>;
  maxWidth?: InputMaybe<StrapiComponentEnumsMaxWidthInput>;
  textPosition?: InputMaybe<StrapiComponentEnumsJustifyInput>;
  visability?: InputMaybe<StrapiComponentSharedVisabilityInput>;
};

export type StrapiComponentDynamicblocksHeaderWithAdditions = {
  __typename?: 'StrapiComponentDynamicblocksHeaderWithAdditions';
  backgroundColor: StrapiComponentEnumsColor;
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  innerWidth?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<StrapiComponentSharedLink>;
  linkButton?: Maybe<StrapiComponentSharedButton>;
  maxWidth: StrapiComponentEnumsMaxWidth;
  textColor: StrapiComponentEnumsColor;
  textPosition: StrapiComponentEnumsJustify;
  vectorImage?: Maybe<StrapiUploadFileEntityResponse>;
  visability: StrapiComponentSharedVisability;
  withBackground: Scalars['Boolean']['output'];
};

export type StrapiComponentDynamicblocksHorizontalPhotoParallex = {
  __typename?: 'StrapiComponentDynamicblocksHorizontalPhotoParallex';
  desktopImageHeight: StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALPHOTOPARALLEX_DESKTOPIMAGEHEIGHT;
  id: Scalars['ID']['output'];
  imageDesktop: StrapiUploadFileEntityResponse;
  imageMobile: StrapiUploadFileEntityResponse;
};

export type StrapiComponentDynamicblocksHorizontalVideoBanner = {
  __typename?: 'StrapiComponentDynamicblocksHorizontalVideoBanner';
  backgroundGlowColor: StrapiComponentEnumsColor;
  backgroundVideo?: Maybe<StrapiUploadFileEntityResponse>;
  extraLinkButton?: Maybe<StrapiComponentSharedButton>;
  headingImage?: Maybe<StrapiUploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  isTopComponent: Scalars['Boolean']['output'];
  linkButton?: Maybe<StrapiComponentSharedButton>;
  linkButtonsVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_LINKBUTTONSVARIANT>;
  opacityGlow?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_OPACITYGLOW>;
  popupVideoAlt?: Maybe<Scalars['String']['output']>;
  popupVideoUrl?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoBannerVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_VIDEOBANNERVARIANT>;
};

export type StrapiComponentDynamicblocksInfluencerSlider = {
  __typename?: 'StrapiComponentDynamicblocksInfluencerSlider';
  activeSliderBgColor?: Maybe<StrapiComponentEnumsColorSlider>;
  id: Scalars['ID']['output'];
  influencers?: Maybe<StrapiInfluencerRelationResponseCollection>;
  isDesktopVectorVisable: Scalars['Boolean']['output'];
  nonActiveSliderBgColor?: Maybe<StrapiComponentEnumsColorSlider>;
  opinionHeaderText?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksInfluencerSliderinfluencersArgs = {
  filters?: InputMaybe<StrapiInfluencerFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksInfluencerSliderInput = {
  activeSliderBgColor?: InputMaybe<StrapiComponentEnumsColorSliderInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  influencers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isDesktopVectorVisable?: InputMaybe<Scalars['Boolean']['input']>;
  nonActiveSliderBgColor?: InputMaybe<StrapiComponentEnumsColorSliderInput>;
  opinionHeaderText?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentDynamicblocksMedicalTeamPresentation = {
  __typename?: 'StrapiComponentDynamicblocksMedicalTeamPresentation';
  id: Scalars['ID']['output'];
};

export type StrapiComponentDynamicblocksNewsletter = {
  __typename?: 'StrapiComponentDynamicblocksNewsletter';
  customButtonText?: Maybe<Scalars['String']['output']>;
  customDescription?: Maybe<Scalars['String']['output']>;
  customTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newsletterSize: StrapiENUM_COMPONENTDYNAMICBLOCKSNEWSLETTER_NEWSLETTERSIZE;
};

export type StrapiComponentDynamicblocksNfzBanner = {
  __typename?: 'StrapiComponentDynamicblocksNfzBanner';
  buttonText?: Maybe<Scalars['String']['output']>;
  componentBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nfzBannerVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSNFZBANNER_NFZBANNERVARIANT>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksPacketTileSection = {
  __typename?: 'StrapiComponentDynamicblocksPacketTileSection';
  id: Scalars['ID']['output'];
  packetTileItems: Array<Maybe<StrapiComponentSharedPacketTileItem>>;
};


export type StrapiComponentDynamicblocksPacketTileSectionpacketTileItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedPacketTileItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksPatientRating = {
  __typename?: 'StrapiComponentDynamicblocksPatientRating';
  author?: Maybe<Scalars['String']['output']>;
  bgFitColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  opinion?: Maybe<Scalars['String']['output']>;
  publicationState: StrapiComponentSharedPublicationState;
  ratingItems: Array<Maybe<StrapiComponentSharedRatingItem>>;
};


export type StrapiComponentDynamicblocksPatientRatingratingItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedRatingItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksPatientRatingInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  bgFitColor?: InputMaybe<StrapiComponentEnumsColorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  opinion?: InputMaybe<Scalars['String']['input']>;
  publicationState?: InputMaybe<StrapiComponentSharedPublicationStateInput>;
  ratingItems?: InputMaybe<Array<InputMaybe<StrapiComponentSharedRatingItemInput>>>;
};

export type StrapiComponentDynamicblocksPresentationList = {
  __typename?: 'StrapiComponentDynamicblocksPresentationList';
  id: Scalars['ID']['output'];
  presentationItems: Array<Maybe<StrapiComponentSharedPresentationItem>>;
};


export type StrapiComponentDynamicblocksPresentationListpresentationItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedPresentationItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksProductPacketsSlider = {
  __typename?: 'StrapiComponentDynamicblocksProductPacketsSlider';
  id: Scalars['ID']['output'];
  packets?: Maybe<StrapiPacketRelationResponseCollection>;
};


export type StrapiComponentDynamicblocksProductPacketsSliderpacketsArgs = {
  filters?: InputMaybe<StrapiPacketFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksReceptomatSection = {
  __typename?: 'StrapiComponentDynamicblocksReceptomatSection';
  background?: Maybe<StrapiComponentEnumsOptionalColor>;
  description?: Maybe<Scalars['String']['output']>;
  diseasesList?: Maybe<StrapiComponentSharedDiseasesList>;
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
  linkButton?: Maybe<StrapiComponentSharedButton>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksSeoShowMoreContent = {
  __typename?: 'StrapiComponentDynamicblocksSeoShowMoreContent';
  id: Scalars['ID']['output'];
  seoItems?: Maybe<Array<Maybe<StrapiComponentSharedSeoShowMoreItem>>>;
};


export type StrapiComponentDynamicblocksSeoShowMoreContentseoItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedSeoShowMoreItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksServiceSection = {
  __typename?: 'StrapiComponentDynamicblocksServiceSection';
  id: Scalars['ID']['output'];
  service_page?: Maybe<StrapiServicePageEntityResponse>;
};

export type StrapiComponentDynamicblocksSideSectionTest = {
  __typename?: 'StrapiComponentDynamicblocksSideSectionTest';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<StrapiUploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  imagePreview: StrapiUploadFileEntityResponse;
  isTitleCentered: Scalars['Boolean']['output'];
  titleBottom?: Maybe<Scalars['String']['output']>;
  titleTop?: Maybe<Scalars['String']['output']>;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoSrc?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksSideSectionVideoPreview = {
  __typename?: 'StrapiComponentDynamicblocksSideSectionVideoPreview';
  bottomTitleColor: StrapiComponentEnumsColor;
  closeIconColor: StrapiComponentEnumsColor;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<StrapiUploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  imagePosition: StrapiComponentEnumsPositionX;
  imagePreview: StrapiUploadFileEntityResponse;
  isTitleCentered: Scalars['Boolean']['output'];
  popupBackgroundColor: StrapiComponentEnumsColor;
  titleBottom?: Maybe<Scalars['String']['output']>;
  titleTop?: Maybe<Scalars['String']['output']>;
  topTitleColor: StrapiComponentEnumsColor;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoSrc?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksSideVideoBanner = {
  __typename?: 'StrapiComponentDynamicblocksSideVideoBanner';
  backgroundDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<StrapiUploadFileEntityResponse>;
  videoPosition: StrapiComponentEnumsPositionX;
};

export type StrapiComponentDynamicblocksSixBgElements = {
  __typename?: 'StrapiComponentDynamicblocksSixBgElements';
  componentBackgroundColor?: Maybe<StrapiComponentEnumsColorVariants>;
  displayMoreMode?: Maybe<Scalars['Boolean']['output']>;
  hideDescriptionOnMobile?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  sixElements: Array<Maybe<StrapiComponentSharedBasicItem>>;
  sixElementsVariants?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSSIXBGELEMENTS_SIXELEMENTSVARIANTS>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksSixBgElementssixElementsArgs = {
  filters?: InputMaybe<StrapiComponentSharedBasicItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksSixIconsItems = {
  __typename?: 'StrapiComponentDynamicblocksSixIconsItems';
  animation: Scalars['Boolean']['output'];
  horizontalLine: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  sixIcons: Array<Maybe<StrapiComponentSharedIconItem>>;
};


export type StrapiComponentDynamicblocksSixIconsItemssixIconsArgs = {
  filters?: InputMaybe<StrapiComponentSharedIconItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksSocialEmbed = {
  __typename?: 'StrapiComponentDynamicblocksSocialEmbed';
  id: Scalars['ID']['output'];
  socialItems: Array<Maybe<StrapiComponentSharedSocial>>;
  test?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentDynamicblocksSocialEmbedsocialItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedSocialFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksSquareImageSlider = {
  __typename?: 'StrapiComponentDynamicblocksSquareImageSlider';
  id: Scalars['ID']['output'];
  squareImageSliders: Array<Maybe<StrapiComponentDynamicblocksSquareImageWithText>>;
};


export type StrapiComponentDynamicblocksSquareImageSlidersquareImageSlidersArgs = {
  filters?: InputMaybe<StrapiComponentDynamicblocksSquareImageWithTextFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksSquareImageWithText = {
  __typename?: 'StrapiComponentDynamicblocksSquareImageWithText';
  backgroundColor: StrapiComponentEnumsColor;
  checkbox?: Maybe<StrapiComponentSharedCheckbox>;
  componentId?: Maybe<Scalars['String']['output']>;
  countDownTimer?: Maybe<StrapiComponentSharedCountdownTimer>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionItems?: Maybe<Array<Maybe<StrapiComponentSharedCheckedListITems>>>;
  headingImage?: Maybe<StrapiUploadFileEntityResponse>;
  headingImageLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
  imagePosition: StrapiComponentEnumsPositionX;
  isVectorVisible?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<StrapiComponentSharedLink>;
  linkButton?: Maybe<StrapiComponentSharedButton>;
  mobileLInkText?: Maybe<Scalars['String']['output']>;
  subheading?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor: StrapiComponentEnumsColor;
  vectorColor?: Maybe<StrapiComponentEnumsColor>;
  vectorVariant: StrapiENUM_COMPONENTDYNAMICBLOCKSSQUAREIMAGEWITHTEXT_VECTORVARIANT;
};


export type StrapiComponentDynamicblocksSquareImageWithTextdescriptionItemsArgs = {
  filters?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksSquareImageWithTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksSquareImageWithTextFiltersInput>>>;
  backgroundColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  checkbox?: InputMaybe<StrapiComponentSharedCheckboxFiltersInput>;
  componentId?: InputMaybe<StrapiStringFilterInput>;
  countDownTimer?: InputMaybe<StrapiComponentSharedCountdownTimerFiltersInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  descriptionItems?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  headingImageLink?: InputMaybe<StrapiStringFilterInput>;
  imagePosition?: InputMaybe<StrapiComponentEnumsPositionXFiltersInput>;
  isVectorVisible?: InputMaybe<StrapiBooleanFilterInput>;
  link?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  linkButton?: InputMaybe<StrapiComponentSharedButtonFiltersInput>;
  mobileLInkText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentDynamicblocksSquareImageWithTextFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentDynamicblocksSquareImageWithTextFiltersInput>>>;
  subheading?: InputMaybe<StrapiStringFilterInput>;
  subtitle?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  titleColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  vectorColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  vectorVariant?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentDynamicblocksStatuteListSection = {
  __typename?: 'StrapiComponentDynamicblocksStatuteListSection';
  id: Scalars['ID']['output'];
  statuteItems?: Maybe<StrapiComponentListStatuteItems>;
  titleArchivedStatute?: Maybe<Scalars['String']['output']>;
  titleClinicsStatute?: Maybe<Scalars['String']['output']>;
  titleCurrentStatute?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksSymptoms = {
  __typename?: 'StrapiComponentDynamicblocksSymptoms';
  article_symptoms?: Maybe<StrapiArticleSymptomRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type StrapiComponentDynamicblocksSymptomsarticle_symptomsArgs = {
  filters?: InputMaybe<StrapiArticleSymptomFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksThreeIconsItems = {
  __typename?: 'StrapiComponentDynamicblocksThreeIconsItems';
  animation: Scalars['Boolean']['output'];
  background?: Maybe<StrapiComponentEnumsOptionalColor>;
  id: Scalars['ID']['output'];
  threeIcons: Array<Maybe<StrapiComponentSharedIconItem>>;
  widthVariant?: Maybe<StrapiENUM_COMPONENTDYNAMICBLOCKSTHREEICONSITEMS_WIDTHVARIANT>;
};


export type StrapiComponentDynamicblocksThreeIconsItemsthreeIconsArgs = {
  filters?: InputMaybe<StrapiComponentSharedIconItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentDynamicblocksThreeIconsItemsInput = {
  animation?: InputMaybe<Scalars['Boolean']['input']>;
  background?: InputMaybe<StrapiComponentEnumsOptionalColorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  threeIcons?: InputMaybe<Array<InputMaybe<StrapiComponentSharedIconItemInput>>>;
  widthVariant?: InputMaybe<StrapiENUM_COMPONENTDYNAMICBLOCKSTHREEICONSITEMS_WIDTHVARIANT>;
};

export type StrapiComponentDynamicblocksTwoColumnsTextSection = {
  __typename?: 'StrapiComponentDynamicblocksTwoColumnsTextSection';
  backgroundColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  leftDescription: Scalars['String']['output'];
  leftLink?: Maybe<StrapiComponentSharedLink>;
  noPaddings?: Maybe<Scalars['Boolean']['output']>;
  rightDescription: Scalars['String']['output'];
  rightLink?: Maybe<StrapiComponentSharedLink>;
  withDesktopVectors?: Maybe<Scalars['Boolean']['output']>;
};

export type StrapiComponentDynamicblocksVideoBanner = {
  __typename?: 'StrapiComponentDynamicblocksVideoBanner';
  bgColor: StrapiComponentEnumsColor;
  id: Scalars['ID']['output'];
  isVectorVisible?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  textColor: StrapiComponentEnumsColor;
  title?: Maybe<Scalars['String']['output']>;
  videoAlt?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentDynamicblocksWhiteSpace = {
  __typename?: 'StrapiComponentDynamicblocksWhiteSpace';
  bgColor: StrapiComponentEnumsColor;
  heightDesktop: Scalars['Int']['output'];
  heightMobile: Scalars['Int']['output'];
  heightTablet: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsActions = {
  __typename?: 'StrapiComponentEnumsActions';
  actions?: Maybe<StrapiENUM_COMPONENTENUMSACTIONS_ACTIONS>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsActionsFiltersInput = {
  actions?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsActionsFiltersInput>>>;
  not?: InputMaybe<StrapiComponentEnumsActionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsActionsFiltersInput>>>;
};

export type StrapiComponentEnumsActionsInput = {
  actions?: InputMaybe<StrapiENUM_COMPONENTENUMSACTIONS_ACTIONS>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentEnumsButtonSize = {
  __typename?: 'StrapiComponentEnumsButtonSize';
  buttonSize?: Maybe<StrapiENUM_COMPONENTENUMSBUTTONSIZE_BUTTONSIZE>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsButtonSizeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsButtonSizeFiltersInput>>>;
  buttonSize?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentEnumsButtonSizeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsButtonSizeFiltersInput>>>;
};

export type StrapiComponentEnumsColor = {
  __typename?: 'StrapiComponentEnumsColor';
  Color: StrapiENUM_COMPONENTENUMSCOLOR_COLOR;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsColorFiltersInput = {
  Color?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsColorFiltersInput>>>;
  not?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsColorFiltersInput>>>;
};

export type StrapiComponentEnumsColorInput = {
  Color?: InputMaybe<StrapiENUM_COMPONENTENUMSCOLOR_COLOR>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentEnumsColorSlider = {
  __typename?: 'StrapiComponentEnumsColorSlider';
  Colors?: Maybe<StrapiENUM_COMPONENTENUMSCOLORSLIDER_COLORS>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsColorSliderInput = {
  Colors?: InputMaybe<StrapiENUM_COMPONENTENUMSCOLORSLIDER_COLORS>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentEnumsColorVariants = {
  __typename?: 'StrapiComponentEnumsColorVariants';
  color?: Maybe<StrapiENUM_COMPONENTENUMSCOLORVARIANTS_COLOR>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsComponentColor = {
  __typename?: 'StrapiComponentEnumsComponentColor';
  Color: StrapiENUM_COMPONENTENUMSCOMPONENTCOLOR_COLOR;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsComponentColorFiltersInput = {
  Color?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsComponentColorFiltersInput>>>;
  not?: InputMaybe<StrapiComponentEnumsComponentColorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsComponentColorFiltersInput>>>;
};

export type StrapiComponentEnumsJustify = {
  __typename?: 'StrapiComponentEnumsJustify';
  id: Scalars['ID']['output'];
  justify: StrapiENUM_COMPONENTENUMSJUSTIFY_JUSTIFY;
};

export type StrapiComponentEnumsJustifyInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  justify?: InputMaybe<StrapiENUM_COMPONENTENUMSJUSTIFY_JUSTIFY>;
};

export type StrapiComponentEnumsMaxWidth = {
  __typename?: 'StrapiComponentEnumsMaxWidth';
  id: Scalars['ID']['output'];
  width: StrapiENUM_COMPONENTENUMSMAXWIDTH_WIDTH;
};

export type StrapiComponentEnumsMaxWidthInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  width?: InputMaybe<StrapiENUM_COMPONENTENUMSMAXWIDTH_WIDTH>;
};

export type StrapiComponentEnumsOptionalColor = {
  __typename?: 'StrapiComponentEnumsOptionalColor';
  Color?: Maybe<StrapiENUM_COMPONENTENUMSOPTIONALCOLOR_COLOR>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentEnumsOptionalColorInput = {
  Color?: InputMaybe<StrapiENUM_COMPONENTENUMSOPTIONALCOLOR_COLOR>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentEnumsPositionX = {
  __typename?: 'StrapiComponentEnumsPositionX';
  id: Scalars['ID']['output'];
  position: StrapiENUM_COMPONENTENUMSPOSITIONX_POSITION;
};

export type StrapiComponentEnumsPositionXFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsPositionXFiltersInput>>>;
  not?: InputMaybe<StrapiComponentEnumsPositionXFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsPositionXFiltersInput>>>;
  position?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentEnumsPositionY = {
  __typename?: 'StrapiComponentEnumsPositionY';
  id: Scalars['ID']['output'];
  position: StrapiENUM_COMPONENTENUMSPOSITIONY_POSITION;
};

export type StrapiComponentEnumsPositionYFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsPositionYFiltersInput>>>;
  not?: InputMaybe<StrapiComponentEnumsPositionYFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentEnumsPositionYFiltersInput>>>;
  position?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentFaqFaq = {
  __typename?: 'StrapiComponentFaqFaq';
  faq_post?: Maybe<StrapiFaqPostEntityResponse>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentFaqFaqItem = {
  __typename?: 'StrapiComponentFaqFaqItem';
  faq_post?: Maybe<StrapiFaqPostEntityResponse>;
  id: Scalars['ID']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type StrapiComponentFaqFaqSectionNew = {
  __typename?: 'StrapiComponentFaqFaqSectionNew';
  color?: Maybe<Scalars['String']['output']>;
  faq_items_set?: Maybe<StrapiFaqItemsSetEntityResponse>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiComponentFaqTest = {
  __typename?: 'StrapiComponentFaqTest';
  id: Scalars['ID']['output'];
};

export type StrapiComponentListCheckList = {
  __typename?: 'StrapiComponentListCheckList';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leftItems: Array<Maybe<StrapiComponentListItem>>;
  rightItems: Array<Maybe<StrapiComponentListRightItemsX>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentListCheckListleftItemsArgs = {
  filters?: InputMaybe<StrapiComponentListItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentListCheckListrightItemsArgs = {
  filters?: InputMaybe<StrapiComponentListRightItemsXFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListCheckListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  leftItems?: InputMaybe<Array<InputMaybe<StrapiComponentListItemInput>>>;
  rightItems?: InputMaybe<Array<InputMaybe<StrapiComponentListRightItemsXInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentListItem = {
  __typename?: 'StrapiComponentListItem';
  id: Scalars['ID']['output'];
  itemText: Scalars['String']['output'];
  svgIcon?: Maybe<StrapiUploadFileEntityResponse>;
};

export type StrapiComponentListItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentListItemFiltersInput>>>;
  itemText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentListItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentListItemFiltersInput>>>;
};

export type StrapiComponentListItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  svgIcon?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentListLanguagesList = {
  __typename?: 'StrapiComponentListLanguagesList';
  id: Scalars['ID']['output'];
  language: StrapiENUM_COMPONENTLISTLANGUAGESLIST_LANGUAGE;
};

export type StrapiComponentListLanguagesListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentListLanguagesListFiltersInput>>>;
  language?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentListLanguagesListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentListLanguagesListFiltersInput>>>;
};

export type StrapiComponentListLanguagesListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<StrapiENUM_COMPONENTLISTLANGUAGESLIST_LANGUAGE>;
};

export type StrapiComponentListLeftListItems = {
  __typename?: 'StrapiComponentListLeftListItems';
  id: Scalars['ID']['output'];
};

export type StrapiComponentListListItems = {
  __typename?: 'StrapiComponentListListItems';
  id: Scalars['ID']['output'];
  textItem: Array<Maybe<StrapiComponentListItem>>;
};


export type StrapiComponentListListItemstextItemArgs = {
  filters?: InputMaybe<StrapiComponentListItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListListItemsRight = {
  __typename?: 'StrapiComponentListListItemsRight';
  id: Scalars['ID']['output'];
  textItem: Array<Maybe<StrapiComponentListItem>>;
};


export type StrapiComponentListListItemsRighttextItemArgs = {
  filters?: InputMaybe<StrapiComponentListItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListRightItemsNew = {
  __typename?: 'StrapiComponentListRightItemsNew';
  id: Scalars['ID']['output'];
  textItemRight: Array<Maybe<StrapiComponentListTextItemRight>>;
};


export type StrapiComponentListRightItemsNewtextItemRightArgs = {
  filters?: InputMaybe<StrapiComponentListTextItemRightFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListRightItemsX = {
  __typename?: 'StrapiComponentListRightItemsX';
  id: Scalars['ID']['output'];
  itemText: Scalars['String']['output'];
  svgIcon?: Maybe<StrapiUploadFileEntityResponse>;
};

export type StrapiComponentListRightItemsXFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentListRightItemsXFiltersInput>>>;
  itemText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentListRightItemsXFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentListRightItemsXFiltersInput>>>;
};

export type StrapiComponentListRightItemsXInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  svgIcon?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentListStatuteAttachmentList = {
  __typename?: 'StrapiComponentListStatuteAttachmentList';
  id: Scalars['ID']['output'];
  statuteList?: Maybe<Array<Maybe<StrapiComponentListStatuteList>>>;
};


export type StrapiComponentListStatuteAttachmentListstatuteListArgs = {
  filters?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListStatuteItems = {
  __typename?: 'StrapiComponentListStatuteItems';
  archivedStatutes?: Maybe<StrapiStatuteRelationResponseCollection>;
  clinicsStatutes?: Maybe<StrapiStatuteClinicRelationResponseCollection>;
  currentStatutes?: Maybe<StrapiStatuteRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type StrapiComponentListStatuteItemsarchivedStatutesArgs = {
  filters?: InputMaybe<StrapiStatuteFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentListStatuteItemsclinicsStatutesArgs = {
  filters?: InputMaybe<StrapiStatuteClinicFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiComponentListStatuteItemscurrentStatutesArgs = {
  filters?: InputMaybe<StrapiStatuteFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentListStatuteList = {
  __typename?: 'StrapiComponentListStatuteList';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentListStatuteListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentListStatuteListFiltersInput>>>;
  link?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentListStatuteListFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentListStatuteListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentListTextItemRight = {
  __typename?: 'StrapiComponentListTextItemRight';
  id: Scalars['ID']['output'];
  textRight: Scalars['String']['output'];
};

export type StrapiComponentListTextItemRightFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentListTextItemRightFiltersInput>>>;
  not?: InputMaybe<StrapiComponentListTextItemRightFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentListTextItemRightFiltersInput>>>;
  textRight?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentMediaPromoClip = {
  __typename?: 'StrapiComponentMediaPromoClip';
  bgColor: StrapiComponentTextMapBgColor;
  id: Scalars['ID']['output'];
  isVectorVisible?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  textColor: StrapiComponentTextMapTextColor;
  title?: Maybe<Scalars['String']['output']>;
  videoUrl: Scalars['String']['output'];
};

export type StrapiComponentMediaPromoClipInput = {
  bgColor?: InputMaybe<StrapiComponentTextMapBgColorInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isVectorVisible?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<StrapiComponentTextMapTextColorInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentMedicalDoctorTypeList = {
  __typename?: 'StrapiComponentMedicalDoctorTypeList';
  id: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentMobileArticleBlocksContent = {
  __typename?: 'StrapiComponentMobileArticleBlocksContent';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type StrapiComponentRegistrationTelemedicineTypeImages = {
  __typename?: 'StrapiComponentRegistrationTelemedicineTypeImages';
  Images?: Maybe<StrapiUploadFileRelationResponseCollection>;
  id: Scalars['ID']['output'];
};


export type StrapiComponentRegistrationTelemedicineTypeImagesImagesArgs = {
  filters?: InputMaybe<StrapiUploadFileFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentRegistrationTelemedicineTypeImagesInput = {
  Images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentSeoMetaSeo = {
  __typename?: 'StrapiComponentSeoMetaSeo';
  active?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  metaUrl: Scalars['String']['output'];
  noFollow?: Maybe<Scalars['Boolean']['output']>;
  noIndex?: Maybe<Scalars['Boolean']['output']>;
  ogImage?: Maybe<StrapiUploadFileEntityResponse>;
};

export type StrapiComponentSeoMetaSeoFiltersInput = {
  active?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>>>;
  metaDescription?: InputMaybe<StrapiStringFilterInput>;
  metaTitle?: InputMaybe<StrapiStringFilterInput>;
  metaUrl?: InputMaybe<StrapiStringFilterInput>;
  noFollow?: InputMaybe<StrapiBooleanFilterInput>;
  noIndex?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>>>;
};

export type StrapiComponentSeoMetaSeoInput = {
  active?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  metaUrl?: InputMaybe<Scalars['String']['input']>;
  noFollow?: InputMaybe<Scalars['Boolean']['input']>;
  noIndex?: InputMaybe<Scalars['Boolean']['input']>;
  ogImage?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentSeoRedirects = {
  __typename?: 'StrapiComponentSeoRedirects';
  id: Scalars['ID']['output'];
  source: Scalars['String']['output'];
};

export type StrapiComponentSeoRedirectsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSeoRedirectsFiltersInput>>>;
  not?: InputMaybe<StrapiComponentSeoRedirectsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSeoRedirectsFiltersInput>>>;
  source?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSeoRedirectsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSeoSeoGhostContent = {
  __typename?: 'StrapiComponentSeoSeoGhostContent';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seoImage?: Maybe<StrapiUploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSeoSeoGhostContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSeoSeoGhostContentFiltersInput>>>;
  content?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSeoSeoGhostContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSeoSeoGhostContentFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSeoSeoGhostContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  seoImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSeoSeoSectionCityGhost = {
  __typename?: 'StrapiComponentSeoSeoSectionCityGhost';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seoGhostContent?: Maybe<Array<Maybe<StrapiComponentSeoSeoGhostContent>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentSeoSeoSectionCityGhostseoGhostContentArgs = {
  filters?: InputMaybe<StrapiComponentSeoSeoGhostContentFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentSeoSeoSectionCityGhostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSeoSeoSectionCityGhostFiltersInput>>>;
  description?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSeoSeoSectionCityGhostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSeoSeoSectionCityGhostFiltersInput>>>;
  seoGhostContent?: InputMaybe<StrapiComponentSeoSeoGhostContentFiltersInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSeoSeoSectionCityGhostInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  seoGhostContent?: InputMaybe<Array<InputMaybe<StrapiComponentSeoSeoGhostContentInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSharedActions = {
  __typename?: 'StrapiComponentSharedActions';
  action?: Maybe<StrapiComponentEnumsActions>;
  buttonColor?: Maybe<StrapiENUM_COMPONENTSHAREDACTIONS_BUTTONCOLOR>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedActionsFiltersInput = {
  action?: InputMaybe<StrapiComponentEnumsActionsFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedActionsFiltersInput>>>;
  buttonColor?: InputMaybe<StrapiStringFilterInput>;
  label?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedActionsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedActionsFiltersInput>>>;
};

export type StrapiComponentSharedAnimatedPieChart = {
  __typename?: 'StrapiComponentSharedAnimatedPieChart';
  animatedStrokeSize: Scalars['Int']['output'];
  animationTextBlock?: Maybe<StrapiComponentSharedAnimationTextBlock>;
  bgColor: StrapiComponentEnumsColor;
  bgSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  primaryColor: StrapiComponentEnumsColor;
  primarySVGText?: Maybe<Scalars['String']['output']>;
  secondaryColor: StrapiComponentEnumsColor;
  secondarySVGText?: Maybe<Scalars['String']['output']>;
  svgBgColor: StrapiComponentEnumsColor;
};

export type StrapiComponentSharedAnimationTextBlock = {
  __typename?: 'StrapiComponentSharedAnimationTextBlock';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedAppRatingItem = {
  __typename?: 'StrapiComponentSharedAppRatingItem';
  icon: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  isModalVisable?: Maybe<Scalars['Boolean']['output']>;
  modalActionText?: Maybe<Scalars['String']['output']>;
  modalContent?: Maybe<Scalars['String']['output']>;
  modalTitle?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedAppRatingItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedAppRatingItemFiltersInput>>>;
  isModalVisable?: InputMaybe<StrapiBooleanFilterInput>;
  modalActionText?: InputMaybe<StrapiStringFilterInput>;
  modalContent?: InputMaybe<StrapiStringFilterInput>;
  modalTitle?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedAppRatingItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedAppRatingItemFiltersInput>>>;
  rating?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedAppStoreButtons = {
  __typename?: 'StrapiComponentSharedAppStoreButtons';
  id: Scalars['ID']['output'];
  isAppStore: Scalars['Boolean']['output'];
  isAppStoreDescription: Scalars['Boolean']['output'];
  isGooglePlay: Scalars['Boolean']['output'];
  isGooglePlayDescription: Scalars['Boolean']['output'];
};

export type StrapiComponentSharedAppStoreButtonsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedAppStoreButtonsFiltersInput>>>;
  isAppStore?: InputMaybe<StrapiBooleanFilterInput>;
  isAppStoreDescription?: InputMaybe<StrapiBooleanFilterInput>;
  isGooglePlay?: InputMaybe<StrapiBooleanFilterInput>;
  isGooglePlayDescription?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentSharedAppStoreButtonsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedAppStoreButtonsFiltersInput>>>;
};

export type StrapiComponentSharedBasicItem = {
  __typename?: 'StrapiComponentSharedBasicItem';
  description?: Maybe<Scalars['String']['output']>;
  icon: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedBasicItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedBasicItemFiltersInput>>>;
  description?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedBasicItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedBasicItemFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedButton = {
  __typename?: 'StrapiComponentSharedButton';
  color: StrapiComponentEnumsComponentColor;
  icon?: Maybe<StrapiUploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  link: StrapiComponentSharedLink;
  size?: Maybe<StrapiComponentEnumsButtonSize>;
};

export type StrapiComponentSharedButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedButtonFiltersInput>>>;
  color?: InputMaybe<StrapiComponentEnumsComponentColorFiltersInput>;
  link?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  not?: InputMaybe<StrapiComponentSharedButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedButtonFiltersInput>>>;
  size?: InputMaybe<StrapiComponentEnumsButtonSizeFiltersInput>;
};

export type StrapiComponentSharedCheckbox = {
  __typename?: 'StrapiComponentSharedCheckbox';
  id: Scalars['ID']['output'];
  linkButton?: Maybe<StrapiComponentSharedButton>;
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textSize: StrapiENUM_COMPONENTSHAREDCHECKBOX_TEXTSIZE;
  variant: StrapiENUM_COMPONENTSHAREDCHECKBOX_VARIANT;
};

export type StrapiComponentSharedCheckboxFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckboxFiltersInput>>>;
  linkButton?: InputMaybe<StrapiComponentSharedButtonFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedCheckboxFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckboxFiltersInput>>>;
  text?: InputMaybe<StrapiStringFilterInput>;
  textSize?: InputMaybe<StrapiStringFilterInput>;
  variant?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedCheckedListITems = {
  __typename?: 'StrapiComponentSharedCheckedListITems';
  id: Scalars['ID']['output'];
  itemText: Scalars['String']['output'];
  itemTitle?: Maybe<Scalars['String']['output']>;
  svgIcon?: Maybe<StrapiUploadFileEntityResponse>;
};

export type StrapiComponentSharedCheckedListITemsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>>>;
  itemText?: InputMaybe<StrapiStringFilterInput>;
  itemTitle?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCheckedListITemsFiltersInput>>>;
};

export type StrapiComponentSharedCheckedListITemsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  itemText?: InputMaybe<Scalars['String']['input']>;
  itemTitle?: InputMaybe<Scalars['String']['input']>;
  svgIcon?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentSharedCountdownTimer = {
  __typename?: 'StrapiComponentSharedCountdownTimer';
  deadline: Scalars['StrapiDateTime']['output'];
  id: Scalars['ID']['output'];
  timerColor?: Maybe<StrapiComponentEnumsColor>;
  timerCtaButton?: Maybe<StrapiComponentSharedButton>;
};

export type StrapiComponentSharedCountdownTimerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCountdownTimerFiltersInput>>>;
  deadline?: InputMaybe<StrapiDateTimeFilterInput>;
  not?: InputMaybe<StrapiComponentSharedCountdownTimerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCountdownTimerFiltersInput>>>;
  timerColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  timerCtaButton?: InputMaybe<StrapiComponentSharedButtonFiltersInput>;
};

export type StrapiComponentSharedCtaRegisterItem = {
  __typename?: 'StrapiComponentSharedCtaRegisterItem';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedCtaRegisterItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCtaRegisterItemFiltersInput>>>;
  not?: InputMaybe<StrapiComponentSharedCtaRegisterItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedCtaRegisterItemFiltersInput>>>;
  text?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedDiseasesList = {
  __typename?: 'StrapiComponentSharedDiseasesList';
  diseases?: Maybe<StrapiDiseaseRelationResponseCollection>;
  dropDowntext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type StrapiComponentSharedDiseasesListdiseasesArgs = {
  filters?: InputMaybe<StrapiDiseaseFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiComponentSharedFaqSliderItem = {
  __typename?: 'StrapiComponentSharedFaqSliderItem';
  bgColor: StrapiComponentEnumsColor;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: StrapiUploadFileEntityResponse;
  link?: Maybe<StrapiComponentSharedLink>;
  title: Scalars['String']['output'];
};

export type StrapiComponentSharedFaqSliderItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedFaqSliderItemFiltersInput>>>;
  bgColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  link?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  not?: InputMaybe<StrapiComponentSharedFaqSliderItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedFaqSliderItemFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedIconItem = {
  __typename?: 'StrapiComponentSharedIconItem';
  action?: Maybe<StrapiComponentEnumsActions>;
  ctaButton: Scalars['Boolean']['output'];
  ctaButtonLink?: Maybe<Scalars['String']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  line: Scalars['Boolean']['output'];
  mobileLine: Scalars['Boolean']['output'];
  size: StrapiENUM_COMPONENTSHAREDICONITEM_SIZE;
  title?: Maybe<Scalars['String']['output']>;
  withAction?: Maybe<Scalars['Boolean']['output']>;
};

export type StrapiComponentSharedIconItemFiltersInput = {
  action?: InputMaybe<StrapiComponentEnumsActionsFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedIconItemFiltersInput>>>;
  ctaButton?: InputMaybe<StrapiBooleanFilterInput>;
  ctaButtonLink?: InputMaybe<StrapiStringFilterInput>;
  ctaButtonText?: InputMaybe<StrapiStringFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  line?: InputMaybe<StrapiBooleanFilterInput>;
  mobileLine?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentSharedIconItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedIconItemFiltersInput>>>;
  size?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  withAction?: InputMaybe<StrapiBooleanFilterInput>;
};

export type StrapiComponentSharedIconItemInput = {
  action?: InputMaybe<StrapiComponentEnumsActionsInput>;
  ctaButton?: InputMaybe<Scalars['Boolean']['input']>;
  ctaButtonLink?: InputMaybe<Scalars['String']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  line?: InputMaybe<Scalars['Boolean']['input']>;
  mobileLine?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<StrapiENUM_COMPONENTSHAREDICONITEM_SIZE>;
  title?: InputMaybe<Scalars['String']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StrapiComponentSharedLink = {
  __typename?: 'StrapiComponentSharedLink';
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  linkColor?: Maybe<StrapiComponentEnumsColor>;
};

export type StrapiComponentSharedLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedLinkFiltersInput>>>;
  href?: InputMaybe<StrapiStringFilterInput>;
  label?: InputMaybe<StrapiStringFilterInput>;
  linkColor?: InputMaybe<StrapiComponentEnumsColorFiltersInput>;
  not?: InputMaybe<StrapiComponentSharedLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedLinkFiltersInput>>>;
};

export type StrapiComponentSharedLinkInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  linkColor?: InputMaybe<StrapiComponentEnumsColorInput>;
};

export type StrapiComponentSharedPacketTileItem = {
  __typename?: 'StrapiComponentSharedPacketTileItem';
  columnSpan: StrapiENUM_COMPONENTSHAREDPACKETTILEITEM_COLUMNSPAN;
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  photo: StrapiUploadFileEntityResponse;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiComponentSharedPacketTileItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedPacketTileItemFiltersInput>>>;
  columnSpan?: InputMaybe<StrapiStringFilterInput>;
  linkText?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedPacketTileItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedPacketTileItemFiltersInput>>>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedPacketTileItemInput = {
  columnSpan?: InputMaybe<StrapiENUM_COMPONENTSHAREDPACKETTILEITEM_COLUMNSPAN>;
  id?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSharedPresentationItem = {
  __typename?: 'StrapiComponentSharedPresentationItem';
  id: Scalars['ID']['output'];
  presentationText: Scalars['String']['output'];
  previewImage: StrapiUploadFileEntityResponse;
  previewImageLink?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedPresentationItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedPresentationItemFiltersInput>>>;
  not?: InputMaybe<StrapiComponentSharedPresentationItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedPresentationItemFiltersInput>>>;
  presentationText?: InputMaybe<StrapiStringFilterInput>;
  previewImageLink?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedPublicationState = {
  __typename?: 'StrapiComponentSharedPublicationState';
  id: Scalars['ID']['output'];
  public: Scalars['Boolean']['output'];
};

export type StrapiComponentSharedPublicationStateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StrapiComponentSharedRatingItem = {
  __typename?: 'StrapiComponentSharedRatingItem';
  icon: StrapiUploadFileEntityResponse;
  id: Scalars['ID']['output'];
  rating?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedRatingItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedRatingItemFiltersInput>>>;
  not?: InputMaybe<StrapiComponentSharedRatingItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedRatingItemFiltersInput>>>;
  rating?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedRatingItemInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSharedReview = {
  __typename?: 'StrapiComponentSharedReview';
  author: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  opinion: Scalars['String']['output'];
};

export type StrapiComponentSharedReviewFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedReviewFiltersInput>>>;
  author?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedReviewFiltersInput>;
  opinion?: InputMaybe<StrapiStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedReviewFiltersInput>>>;
};

export type StrapiComponentSharedSeoShowMoreItem = {
  __typename?: 'StrapiComponentSharedSeoShowMoreItem';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiUploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StrapiComponentSharedSeoShowMoreItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSeoShowMoreItemFiltersInput>>>;
  content?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedSeoShowMoreItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSeoShowMoreItemFiltersInput>>>;
  title?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedService = {
  __typename?: 'StrapiComponentSharedService';
  id: Scalars['ID']['output'];
  service_item?: Maybe<StrapiServiceItemEntityResponse>;
};

export type StrapiComponentSharedServiceSet = {
  __typename?: 'StrapiComponentSharedServiceSet';
  id: Scalars['ID']['output'];
  service_items_set?: Maybe<StrapiServiceItemsSetEntityResponse>;
  title: Scalars['String']['output'];
};

export type StrapiComponentSharedSingleAnimatedPersonSvg = {
  __typename?: 'StrapiComponentSharedSingleAnimatedPersonSvg';
  animatedFill: StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_ANIMATEDFILL;
  animatedStroke: StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_ANIMATEDSTROKE;
  gender: StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_GENDER;
  id: Scalars['ID']['output'];
  initialFill: StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_INITIALFILL;
  inititalStroke: StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_INITITALSTROKE;
};

export type StrapiComponentSharedSingleAnimatedPersonSvgFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSingleAnimatedPersonSvgFiltersInput>>>;
  animatedFill?: InputMaybe<StrapiStringFilterInput>;
  animatedStroke?: InputMaybe<StrapiStringFilterInput>;
  gender?: InputMaybe<StrapiStringFilterInput>;
  initialFill?: InputMaybe<StrapiStringFilterInput>;
  inititalStroke?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiComponentSharedSingleAnimatedPersonSvgFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSingleAnimatedPersonSvgFiltersInput>>>;
};

export type StrapiComponentSharedSocial = {
  __typename?: 'StrapiComponentSharedSocial';
  captioned: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  placeholderDisabled: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StrapiComponentSharedSocialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSocialFiltersInput>>>;
  captioned?: InputMaybe<StrapiBooleanFilterInput>;
  not?: InputMaybe<StrapiComponentSharedSocialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedSocialFiltersInput>>>;
  placeholderDisabled?: InputMaybe<StrapiBooleanFilterInput>;
  url?: InputMaybe<StrapiStringFilterInput>;
  width?: InputMaybe<StrapiIntFilterInput>;
};

export type StrapiComponentSharedStepList = {
  __typename?: 'StrapiComponentSharedStepList';
  id: Scalars['ID']['output'];
  stepText: Scalars['String']['output'];
};

export type StrapiComponentSharedStepListFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiComponentSharedStepListFiltersInput>>>;
  not?: InputMaybe<StrapiComponentSharedStepListFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiComponentSharedStepListFiltersInput>>>;
  stepText?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiComponentSharedStepListInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  stepText?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiComponentSharedVisability = {
  __typename?: 'StrapiComponentSharedVisability';
  hideOnDesktop: Scalars['Boolean']['output'];
  hideOnMobile: Scalars['Boolean']['output'];
  hideOnTablet: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiComponentSharedVisabilityInput = {
  hideOnDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  hideOnTablet?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentTextMapBgColor = {
  __typename?: 'StrapiComponentTextMapBgColor';
  bgColor: StrapiENUM_COMPONENTTEXTMAPBGCOLOR_BGCOLOR;
  id: Scalars['ID']['output'];
};

export type StrapiComponentTextMapBgColorInput = {
  bgColor?: InputMaybe<StrapiENUM_COMPONENTTEXTMAPBGCOLOR_BGCOLOR>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiComponentTextMapTextColor = {
  __typename?: 'StrapiComponentTextMapTextColor';
  id: Scalars['ID']['output'];
  textColor: StrapiENUM_COMPONENTTEXTMAPTEXTCOLOR_TEXTCOLOR;
};

export type StrapiComponentTextMapTextColorInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textColor?: InputMaybe<StrapiENUM_COMPONENTTEXTMAPTEXTCOLOR_TEXTCOLOR>;
};

export type StrapiDateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['StrapiDateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['StrapiDateTime']['input']>>>;
  contains?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  containsi?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  endsWith?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  eq?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  eqi?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  gt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  gte?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['StrapiDateTime']['input']>>>;
  lt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  lte?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  ne?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  not?: InputMaybe<StrapiDateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['StrapiDateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['StrapiDateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiDisease = {
  __typename?: 'StrapiDisease';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiDiseaseRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiDiseaselocalizationsArgs = {
  filters?: InputMaybe<StrapiDiseaseFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiDiseaseEntity = {
  __typename?: 'StrapiDiseaseEntity';
  attributes?: Maybe<StrapiDisease>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiDiseaseEntityResponse = {
  __typename?: 'StrapiDiseaseEntityResponse';
  data?: Maybe<StrapiDiseaseEntity>;
};

export type StrapiDiseaseEntityResponseCollection = {
  __typename?: 'StrapiDiseaseEntityResponseCollection';
  data: Array<StrapiDiseaseEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiDiseaseFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiDiseaseFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiDiseaseFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiDiseaseFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiDiseaseFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiDiseaseInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiDiseaseRelationResponseCollection = {
  __typename?: 'StrapiDiseaseRelationResponseCollection';
  data: Array<StrapiDiseaseEntity>;
};

export type StrapiDoctor = {
  __typename?: 'StrapiDoctor';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  doctorBiography: Scalars['String']['output'];
  doctorImage?: Maybe<StrapiUploadFileEntityResponse>;
  doctor_groups?: Maybe<StrapiDoctorGroupRelationResponseCollection>;
  doctor_type?: Maybe<StrapiDoctorTypeEntityResponse>;
  firstName: Scalars['String']['output'];
  languages: Array<Maybe<StrapiComponentListLanguagesList>>;
  lastName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiDoctorRelationResponseCollection>;
  patient_reviews?: Maybe<StrapiPatientReviewRelationResponseCollection>;
  priority?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  videoLink?: Maybe<Scalars['String']['output']>;
};


export type StrapiDoctordoctor_groupsArgs = {
  filters?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorlanguagesArgs = {
  filters?: InputMaybe<StrapiComponentListLanguagesListFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorlocalizationsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorpatient_reviewsArgs = {
  filters?: InputMaybe<StrapiPatientReviewFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiDoctorEntity = {
  __typename?: 'StrapiDoctorEntity';
  attributes?: Maybe<StrapiDoctor>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiDoctorEntityResponse = {
  __typename?: 'StrapiDoctorEntityResponse';
  data?: Maybe<StrapiDoctorEntity>;
};

export type StrapiDoctorEntityResponseCollection = {
  __typename?: 'StrapiDoctorEntityResponseCollection';
  data: Array<StrapiDoctorEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiDoctorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiDoctorFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  doctorBiography?: InputMaybe<StrapiStringFilterInput>;
  doctor_groups?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  doctor_type?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  firstName?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  languages?: InputMaybe<StrapiComponentListLanguagesListFiltersInput>;
  lastName?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiDoctorFiltersInput>;
  not?: InputMaybe<StrapiDoctorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiDoctorFiltersInput>>>;
  patient_reviews?: InputMaybe<StrapiPatientReviewFiltersInput>;
  priority?: InputMaybe<StrapiIntFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  videoLink?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiDoctorGroup = {
  __typename?: 'StrapiDoctorGroup';
  common_group: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  doctor_types?: Maybe<StrapiDoctorTypeRelationResponseCollection>;
  doctors?: Maybe<StrapiDoctorRelationResponseCollection>;
  group?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiDoctorGroupRelationResponseCollection>;
  priority: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiDoctorGroupdoctor_typesArgs = {
  filters?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorGroupdoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorGrouplocalizationsArgs = {
  filters?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiDoctorGroupEntity = {
  __typename?: 'StrapiDoctorGroupEntity';
  attributes?: Maybe<StrapiDoctorGroup>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiDoctorGroupEntityResponse = {
  __typename?: 'StrapiDoctorGroupEntityResponse';
  data?: Maybe<StrapiDoctorGroupEntity>;
};

export type StrapiDoctorGroupEntityResponseCollection = {
  __typename?: 'StrapiDoctorGroupEntityResponseCollection';
  data: Array<StrapiDoctorGroupEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiDoctorGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiDoctorGroupFiltersInput>>>;
  common_group?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  doctor_types?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  doctors?: InputMaybe<StrapiDoctorFiltersInput>;
  group?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  not?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiDoctorGroupFiltersInput>>>;
  priority?: InputMaybe<StrapiIntFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiDoctorGroupInput = {
  common_group?: InputMaybe<Scalars['String']['input']>;
  doctor_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  doctors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  group?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiDoctorGroupRelationResponseCollection = {
  __typename?: 'StrapiDoctorGroupRelationResponseCollection';
  data: Array<StrapiDoctorGroupEntity>;
};

export type StrapiDoctorInput = {
  doctorBiography?: InputMaybe<Scalars['String']['input']>;
  doctorImage?: InputMaybe<Scalars['ID']['input']>;
  doctor_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  doctor_type?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<Array<InputMaybe<StrapiComponentListLanguagesListInput>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patient_reviews?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  videoLink?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiDoctorRelationResponseCollection = {
  __typename?: 'StrapiDoctorRelationResponseCollection';
  data: Array<StrapiDoctorEntity>;
};

export type StrapiDoctorType = {
  __typename?: 'StrapiDoctorType';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  doctor_group?: Maybe<StrapiDoctorGroupEntityResponse>;
  doctors?: Maybe<StrapiDoctorRelationResponseCollection>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiDoctorTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiDoctorTypedoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiDoctorTypelocalizationsArgs = {
  filters?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiDoctorTypeEntity = {
  __typename?: 'StrapiDoctorTypeEntity';
  attributes?: Maybe<StrapiDoctorType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiDoctorTypeEntityResponse = {
  __typename?: 'StrapiDoctorTypeEntityResponse';
  data?: Maybe<StrapiDoctorTypeEntity>;
};

export type StrapiDoctorTypeEntityResponseCollection = {
  __typename?: 'StrapiDoctorTypeEntityResponseCollection';
  data: Array<StrapiDoctorTypeEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiDoctorTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiDoctorTypeFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  doctor_group?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  doctors?: InputMaybe<StrapiDoctorFiltersInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  not?: InputMaybe<StrapiDoctorTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiDoctorTypeFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  type?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiDoctorTypeInput = {
  doctor_group?: InputMaybe<Scalars['ID']['input']>;
  doctors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiDoctorTypeRelationResponseCollection = {
  __typename?: 'StrapiDoctorTypeRelationResponseCollection';
  data: Array<StrapiDoctorTypeEntity>;
};

export type StrapiENUM_COMPONENTARTICLEBLOCKSIMAGEBANNER_COMPONENTVARIANT =
  | 'gray'
  | 'lightBlue'
  | 'rose';

export type StrapiENUM_COMPONENTARTICLEBLOCKSIMAGEBANNER_ICONVARIANT =
  | 'cart';

export type StrapiENUM_COMPONENTARTICLEBLOCKSTEXTBANNER_ICONVARIANT =
  | 'cart';

export type StrapiENUM_COMPONENTARTICLEBLOCKSTEXTBANNER_VARIANT =
  | 'blockQuote'
  | 'ctaBanner'
  | 'list'
  | 'text';

export type StrapiENUM_COMPONENTBLOCKSPHONEMESSAGEITEM_MESSAGETYPE =
  | 'doctor'
  | 'initial'
  | 'user';

export type StrapiENUM_COMPONENTBLOCKSTHREEICONSBANNERITEM_SIZE =
  | 'large'
  | 'medium';

export type StrapiENUM_COMPONENTCLINICSOPENINGINFORMATION_DZIEN =
  | 'czw'
  | 'niedz'
  | 'pia'
  | 'pon'
  | 'sob'
  | 'sro'
  | 'wto';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSANIMATEDENLARGINGTEXT_ANIMATIONSIZE =
  | 'large'
  | 'normal'
  | 'spaced';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSAPPRATING_APPRATINGVARIANT =
  | 'normal'
  | 'sticky';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSAPPRATING_RATINGNUMBERSSET =
  | 'homePage'
  | 'specialist';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSCHECKEDLIST_ROUNDEDVARIANT =
  | 'normal'
  | 'rounded';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSCIRCLEPHOTOBANNER_VARIANT =
  | 'variant_1'
  | 'variant_2'
  | 'variant_3';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSCITATIONBANNER_THEME =
  | 'variant1'
  | 'variant2'
  | 'variant3'
  | 'variant4';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSDOCTORSSLIDER_SLIDERVARIANT =
  | 'default'
  | 'small';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSFAQSECTION_FAQVARIANT =
  | 'default'
  | 'homePage'
  | 'receptomat'
  | 'vaccinations';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALPHOTOPARALLEX_DESKTOPIMAGEHEIGHT =
  | 'big'
  | 'medium';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_LINKBUTTONSVARIANT =
  | 'primary'
  | 'secondary';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_OPACITYGLOW =
  | 'opacity_10'
  | 'opacity_20'
  | 'opacity_30'
  | 'opacity_40';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSHORIZONTALVIDEOBANNER_VIDEOBANNERVARIANT =
  | 'narrow'
  | 'wide';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSNEWSLETTER_NEWSLETTERSIZE =
  | 'big'
  | 'small';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSNFZBANNER_NFZBANNERVARIANT =
  | 'narrow'
  | 'wide';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSSIXBGELEMENTS_SIXELEMENTSVARIANTS =
  | 'new'
  | 'old';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSSQUAREIMAGEWITHTEXT_VECTORVARIANT =
  | 'vector01'
  | 'vector02'
  | 'vector03';

export type StrapiENUM_COMPONENTDYNAMICBLOCKSTHREEICONSITEMS_WIDTHVARIANT =
  | 'normal'
  | 'wide';

export type StrapiENUM_COMPONENTENUMSACTIONS_ACTIONS =
  | 'openModal';

export type StrapiENUM_COMPONENTENUMSBUTTONSIZE_BUTTONSIZE =
  | 'normal'
  | 'small';

export type StrapiENUM_COMPONENTENUMSCOLORSLIDER_COLORS =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTENUMSCOLORVARIANTS_COLOR =
  | 'jutro_new_blue_50'
  | 'jutro_new_blue_100'
  | 'jutro_new_blue_200'
  | 'jutro_new_blue_300'
  | 'jutro_new_blue_400'
  | 'jutro_new_blue_500'
  | 'jutro_new_blue_600'
  | 'jutro_new_blue_700'
  | 'jutro_new_blue_800'
  | 'jutro_new_blue_900'
  | 'jutro_new_gray_50'
  | 'jutro_new_gray_100'
  | 'jutro_new_gray_200'
  | 'jutro_new_gray_300'
  | 'jutro_new_gray_400'
  | 'jutro_new_gray_500'
  | 'jutro_new_gray_600'
  | 'jutro_new_gray_700'
  | 'jutro_new_gray_800'
  | 'jutro_new_gray_900'
  | 'jutro_new_green_50'
  | 'jutro_new_green_100'
  | 'jutro_new_green_200'
  | 'jutro_new_green_300'
  | 'jutro_new_green_400'
  | 'jutro_new_green_500'
  | 'jutro_new_green_600'
  | 'jutro_new_green_700'
  | 'jutro_new_green_800'
  | 'jutro_new_green_900'
  | 'jutro_new_rose_50'
  | 'jutro_new_rose_100'
  | 'jutro_new_rose_200'
  | 'jutro_new_rose_300'
  | 'jutro_new_rose_400'
  | 'jutro_new_rose_500'
  | 'jutro_new_rose_600'
  | 'jutro_new_rose_700'
  | 'jutro_new_rose_800'
  | 'jutro_new_rose_900';

export type StrapiENUM_COMPONENTENUMSCOLOR_COLOR =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'pink'
  | 'white';

export type StrapiENUM_COMPONENTENUMSCOMPONENTCOLOR_COLOR =
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGrayGreen';

export type StrapiENUM_COMPONENTENUMSJUSTIFY_JUSTIFY =
  | 'center'
  | 'left'
  | 'right';

export type StrapiENUM_COMPONENTENUMSMAXWIDTH_WIDTH =
  | 'FULL_full'
  | 'LG_512'
  | 'MD_448'
  | 'SM_384'
  | 'XL2_672'
  | 'XL3_768'
  | 'XL4_896'
  | 'XL5_1024'
  | 'XL6_1152'
  | 'XL7_1280'
  | 'XL_576'
  | 'XS_320';

export type StrapiENUM_COMPONENTENUMSOPTIONALCOLOR_COLOR =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'pink'
  | 'white';

export type StrapiENUM_COMPONENTENUMSPOSITIONX_POSITION =
  | 'left'
  | 'right';

export type StrapiENUM_COMPONENTENUMSPOSITIONY_POSITION =
  | 'bottom'
  | 'top';

export type StrapiENUM_COMPONENTLISTLANGUAGESLIST_LANGUAGE =
  | 'EN'
  | 'PL'
  | 'UK';

export type StrapiENUM_COMPONENTSHAREDACTIONS_BUTTONCOLOR =
  | 'blue'
  | 'lightBlue';

export type StrapiENUM_COMPONENTSHAREDCHECKBOX_TEXTSIZE =
  | 'normal'
  | 'small';

export type StrapiENUM_COMPONENTSHAREDCHECKBOX_VARIANT =
  | 'blue'
  | 'green';

export type StrapiENUM_COMPONENTSHAREDICONITEM_SIZE =
  | 'large'
  | 'left'
  | 'medium';

export type StrapiENUM_COMPONENTSHAREDPACKETTILEITEM_COLUMNSPAN =
  | 'ONE'
  | 'TWO';

export type StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_ANIMATEDFILL =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_ANIMATEDSTROKE =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_GENDER =
  | 'famale'
  | 'male';

export type StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_INITIALFILL =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTSHAREDSINGLEANIMATEDPERSONSVG_INITITALSTROKE =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTTEXTMAPBGCOLOR_BGCOLOR =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_COMPONENTTEXTMAPTEXTCOLOR_TEXTCOLOR =
  | 'black'
  | 'blue'
  | 'gray'
  | 'green'
  | 'lightBlue'
  | 'lightGray'
  | 'lightGreen'
  | 'lightPurple'
  | 'lightSea'
  | 'white';

export type StrapiENUM_REGISTRATIONDATASTEP_NAME =
  | 'PZStep'
  | 'addressStep'
  | 'contactDataStep'
  | 'medicStep'
  | 'personalDataStep'
  | 'typeStep';

export type StrapiENUM_STEPSLAYOUTCONTENT_NAME =
  | 'PZStep'
  | 'addressStep'
  | 'contactDataStep'
  | 'inviteParentScreen'
  | 'loginScreen'
  | 'medicStep'
  | 'personalDataStep'
  | 'successScreen'
  | 'typeStep'
  | 'waitingListScreen';

export type StrapiEcommercePartnership = {
  __typename?: 'StrapiEcommercePartnership';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiEcommercePartnershipRelationResponseCollection>;
  logo: StrapiUploadFileEntityResponse;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  url: Scalars['String']['output'];
};


export type StrapiEcommercePartnershiplocalizationsArgs = {
  filters?: InputMaybe<StrapiEcommercePartnershipFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiEcommercePartnershipEntity = {
  __typename?: 'StrapiEcommercePartnershipEntity';
  attributes?: Maybe<StrapiEcommercePartnership>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiEcommercePartnershipEntityResponse = {
  __typename?: 'StrapiEcommercePartnershipEntityResponse';
  data?: Maybe<StrapiEcommercePartnershipEntity>;
};

export type StrapiEcommercePartnershipEntityResponseCollection = {
  __typename?: 'StrapiEcommercePartnershipEntityResponseCollection';
  data: Array<StrapiEcommercePartnershipEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiEcommercePartnershipFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiEcommercePartnershipFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiEcommercePartnershipFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiEcommercePartnershipFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiEcommercePartnershipFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  url?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiEcommercePartnershipInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiEcommercePartnershipRelationResponseCollection = {
  __typename?: 'StrapiEcommercePartnershipRelationResponseCollection';
  data: Array<StrapiEcommercePartnershipEntity>;
};

export type StrapiEcommercePromoBar = {
  __typename?: 'StrapiEcommercePromoBar';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiEcommercePromoBarRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiEcommercePromoBarlocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiEcommercePromoBarEntity = {
  __typename?: 'StrapiEcommercePromoBarEntity';
  attributes?: Maybe<StrapiEcommercePromoBar>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiEcommercePromoBarEntityResponse = {
  __typename?: 'StrapiEcommercePromoBarEntityResponse';
  data?: Maybe<StrapiEcommercePromoBarEntity>;
};

export type StrapiEcommercePromoBarInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiEcommercePromoBarRelationResponseCollection = {
  __typename?: 'StrapiEcommercePromoBarRelationResponseCollection';
  data: Array<StrapiEcommercePromoBarEntity>;
};

export type StrapiEcommercePromoModal = {
  __typename?: 'StrapiEcommercePromoModal';
  actionTextBar: Scalars['String']['output'];
  actionTextBox: Scalars['String']['output'];
  actionTextCheckout: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};

export type StrapiEcommercePromoModalEntity = {
  __typename?: 'StrapiEcommercePromoModalEntity';
  attributes?: Maybe<StrapiEcommercePromoModal>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiEcommercePromoModalEntityResponse = {
  __typename?: 'StrapiEcommercePromoModalEntityResponse';
  data?: Maybe<StrapiEcommercePromoModalEntity>;
};

export type StrapiEcommercePromoModalInput = {
  actionTextBar?: InputMaybe<Scalars['String']['input']>;
  actionTextBox?: InputMaybe<Scalars['String']['input']>;
  actionTextCheckout?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiEcommercePromoSection = {
  __typename?: 'StrapiEcommercePromoSection';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  ctaLinkHref?: Maybe<Scalars['String']['output']>;
  ctaLinkText?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiEcommercePromoSectionRelationResponseCollection>;
  promo?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiEcommercePromoSectionlocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiEcommercePromoSectionEntity = {
  __typename?: 'StrapiEcommercePromoSectionEntity';
  attributes?: Maybe<StrapiEcommercePromoSection>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiEcommercePromoSectionEntityResponse = {
  __typename?: 'StrapiEcommercePromoSectionEntityResponse';
  data?: Maybe<StrapiEcommercePromoSectionEntity>;
};

export type StrapiEcommercePromoSectionInput = {
  ctaLinkHref?: InputMaybe<Scalars['String']['input']>;
  ctaLinkText?: InputMaybe<Scalars['String']['input']>;
  ctaText?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiEcommercePromoSectionRelationResponseCollection = {
  __typename?: 'StrapiEcommercePromoSectionRelationResponseCollection';
  data: Array<StrapiEcommercePromoSectionEntity>;
};

export type StrapiEcommerceSectionTile = {
  __typename?: 'StrapiEcommerceSectionTile';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  packetsTileSection: Array<Maybe<StrapiComponentSharedPacketTileItem>>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiEcommerceSectionTilepacketsTileSectionArgs = {
  filters?: InputMaybe<StrapiComponentSharedPacketTileItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiEcommerceSectionTileEntity = {
  __typename?: 'StrapiEcommerceSectionTileEntity';
  attributes?: Maybe<StrapiEcommerceSectionTile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiEcommerceSectionTileEntityResponse = {
  __typename?: 'StrapiEcommerceSectionTileEntityResponse';
  data?: Maybe<StrapiEcommerceSectionTileEntity>;
};

export type StrapiEcommerceSectionTileInput = {
  packetsTileSection?: InputMaybe<Array<InputMaybe<StrapiComponentSharedPacketTileItemInput>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiError = {
  __typename?: 'StrapiError';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type StrapiFaqItemsSet = {
  __typename?: 'StrapiFaqItemsSet';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  faqSet: Array<Maybe<StrapiFaqItemsSetFaqSetDynamicZone>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiFaqItemsSetRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiFaqItemsSetlocalizationsArgs = {
  filters?: InputMaybe<StrapiFaqItemsSetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiFaqItemsSetEntity = {
  __typename?: 'StrapiFaqItemsSetEntity';
  attributes?: Maybe<StrapiFaqItemsSet>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiFaqItemsSetEntityResponse = {
  __typename?: 'StrapiFaqItemsSetEntityResponse';
  data?: Maybe<StrapiFaqItemsSetEntity>;
};

export type StrapiFaqItemsSetEntityResponseCollection = {
  __typename?: 'StrapiFaqItemsSetEntityResponseCollection';
  data: Array<StrapiFaqItemsSetEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiFaqItemsSetFaqSetDynamicZone = StrapiComponentFaqFaq | StrapiError;

export type StrapiFaqItemsSetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiFaqItemsSetFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiFaqItemsSetFiltersInput>;
  not?: InputMaybe<StrapiFaqItemsSetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiFaqItemsSetFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiFaqItemsSetInput = {
  faqSet?: InputMaybe<Array<Scalars['StrapiFaqItemsSetFaqSetDynamicZoneInput']['input']>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiFaqItemsSetRelationResponseCollection = {
  __typename?: 'StrapiFaqItemsSetRelationResponseCollection';
  data: Array<StrapiFaqItemsSetEntity>;
};

export type StrapiFaqPagesNew = {
  __typename?: 'StrapiFaqPagesNew';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  faq?: Maybe<Array<Maybe<StrapiFaqPagesNewFaqDynamicZone>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiFaqPagesNewRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiFaqPagesNewlocalizationsArgs = {
  filters?: InputMaybe<StrapiFaqPagesNewFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiFaqPagesNewEntity = {
  __typename?: 'StrapiFaqPagesNewEntity';
  attributes?: Maybe<StrapiFaqPagesNew>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiFaqPagesNewEntityResponse = {
  __typename?: 'StrapiFaqPagesNewEntityResponse';
  data?: Maybe<StrapiFaqPagesNewEntity>;
};

export type StrapiFaqPagesNewEntityResponseCollection = {
  __typename?: 'StrapiFaqPagesNewEntityResponseCollection';
  data: Array<StrapiFaqPagesNewEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiFaqPagesNewFaqDynamicZone = StrapiComponentFaqFaqSectionNew | StrapiError;

export type StrapiFaqPagesNewFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiFaqPagesNewFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiFaqPagesNewFiltersInput>;
  not?: InputMaybe<StrapiFaqPagesNewFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiFaqPagesNewFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiFaqPagesNewInput = {
  faq?: InputMaybe<Array<Scalars['StrapiFaqPagesNewFaqDynamicZoneInput']['input']>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiFaqPagesNewRelationResponseCollection = {
  __typename?: 'StrapiFaqPagesNewRelationResponseCollection';
  data: Array<StrapiFaqPagesNewEntity>;
};

export type StrapiFaqPost = {
  __typename?: 'StrapiFaqPost';
  common_id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiFaqPostRelationResponseCollection>;
  post: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  showOnlyWithHash?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiFaqPostlocalizationsArgs = {
  filters?: InputMaybe<StrapiFaqPostFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiFaqPostEntity = {
  __typename?: 'StrapiFaqPostEntity';
  attributes?: Maybe<StrapiFaqPost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiFaqPostEntityResponse = {
  __typename?: 'StrapiFaqPostEntityResponse';
  data?: Maybe<StrapiFaqPostEntity>;
};

export type StrapiFaqPostEntityResponseCollection = {
  __typename?: 'StrapiFaqPostEntityResponseCollection';
  data: Array<StrapiFaqPostEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiFaqPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiFaqPostFiltersInput>>>;
  common_id?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiFaqPostFiltersInput>;
  not?: InputMaybe<StrapiFaqPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiFaqPostFiltersInput>>>;
  post?: InputMaybe<StrapiStringFilterInput>;
  priority?: InputMaybe<StrapiIntFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  showOnlyWithHash?: InputMaybe<StrapiBooleanFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiFaqPostInput = {
  common_id?: InputMaybe<Scalars['String']['input']>;
  post?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  showOnlyWithHash?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiFaqPostRelationResponseCollection = {
  __typename?: 'StrapiFaqPostRelationResponseCollection';
  data: Array<StrapiFaqPostEntity>;
};

export type StrapiFileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiFloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<StrapiFloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type StrapiGenericMorph = StrapiArticle | StrapiArticleSymptom | StrapiArticleTag | StrapiClinicsCity | StrapiClinicsStreet | StrapiCompanyOpinion | StrapiComponentArticleBlocksContent | StrapiComponentArticleBlocksImage | StrapiComponentArticleBlocksImageBanner | StrapiComponentArticleBlocksTextBanner | StrapiComponentBlocksCtaBanner | StrapiComponentBlocksHero | StrapiComponentBlocksHeroImage | StrapiComponentBlocksLinkText | StrapiComponentBlocksNfzBanner | StrapiComponentBlocksPhoneMessageItem | StrapiComponentBlocksSliderWithGallery | StrapiComponentBlocksTextWithIcon | StrapiComponentBlocksThreeIconBanner | StrapiComponentBlocksThreeIconsBannerItem | StrapiComponentBlocksVideoBanner | StrapiComponentBlocksVideoHero | StrapiComponentBlocksVideoSlider | StrapiComponentClinicsAddress | StrapiComponentClinicsCitiesListLinks | StrapiComponentClinicsCityCommonInfo | StrapiComponentClinicsClinicsBigCards | StrapiComponentClinicsClinicsSmallCards | StrapiComponentClinicsContactInfo | StrapiComponentClinicsDoctorsSliderBanner | StrapiComponentClinicsFacilities | StrapiComponentClinicsMapCityBanner | StrapiComponentClinicsOpeningInformation | StrapiComponentClinicsOpeningItem | StrapiComponentClinicsOpeningList | StrapiComponentClinicsOpeningSection | StrapiComponentClinicsServices | StrapiComponentClinicsTitle | StrapiComponentDynamicblocksAboutAppPhoneBanner | StrapiComponentDynamicblocksAnimatedDoubleCircles | StrapiComponentDynamicblocksAnimatedDoughnutChart | StrapiComponentDynamicblocksAnimatedEnlargingText | StrapiComponentDynamicblocksAnimatedPeopleSvg | StrapiComponentDynamicblocksAnimatedTextGradient | StrapiComponentDynamicblocksAppRating | StrapiComponentDynamicblocksCheckedList | StrapiComponentDynamicblocksCircleImageWithText | StrapiComponentDynamicblocksCirclePhotoBanner | StrapiComponentDynamicblocksCitationBanner | StrapiComponentDynamicblocksClinicsMapEcommerce | StrapiComponentDynamicblocksClinicsMapSmall | StrapiComponentDynamicblocksClinicsSmallSlider | StrapiComponentDynamicblocksCompaniesSlider | StrapiComponentDynamicblocksCtaBaseBanner | StrapiComponentDynamicblocksCtaBigBanner | StrapiComponentDynamicblocksCtaBigBannerSlider | StrapiComponentDynamicblocksCtaButtonLink | StrapiComponentDynamicblocksCtaGraphicBanner | StrapiComponentDynamicblocksCtaRegisterBanner | StrapiComponentDynamicblocksDoctorsSlider | StrapiComponentDynamicblocksDownloadAppBanner | StrapiComponentDynamicblocksFaqSection | StrapiComponentDynamicblocksFaqWithSlider | StrapiComponentDynamicblocksHeaderSection | StrapiComponentDynamicblocksHeaderWithAdditions | StrapiComponentDynamicblocksHorizontalPhotoParallex | StrapiComponentDynamicblocksHorizontalVideoBanner | StrapiComponentDynamicblocksInfluencerSlider | StrapiComponentDynamicblocksMedicalTeamPresentation | StrapiComponentDynamicblocksNewsletter | StrapiComponentDynamicblocksNfzBanner | StrapiComponentDynamicblocksPacketTileSection | StrapiComponentDynamicblocksPatientRating | StrapiComponentDynamicblocksPresentationList | StrapiComponentDynamicblocksProductPacketsSlider | StrapiComponentDynamicblocksReceptomatSection | StrapiComponentDynamicblocksSeoShowMoreContent | StrapiComponentDynamicblocksServiceSection | StrapiComponentDynamicblocksSideSectionTest | StrapiComponentDynamicblocksSideSectionVideoPreview | StrapiComponentDynamicblocksSideVideoBanner | StrapiComponentDynamicblocksSixBgElements | StrapiComponentDynamicblocksSixIconsItems | StrapiComponentDynamicblocksSocialEmbed | StrapiComponentDynamicblocksSquareImageSlider | StrapiComponentDynamicblocksSquareImageWithText | StrapiComponentDynamicblocksStatuteListSection | StrapiComponentDynamicblocksSymptoms | StrapiComponentDynamicblocksThreeIconsItems | StrapiComponentDynamicblocksTwoColumnsTextSection | StrapiComponentDynamicblocksVideoBanner | StrapiComponentDynamicblocksWhiteSpace | StrapiComponentEnumsActions | StrapiComponentEnumsButtonSize | StrapiComponentEnumsColor | StrapiComponentEnumsColorSlider | StrapiComponentEnumsColorVariants | StrapiComponentEnumsComponentColor | StrapiComponentEnumsJustify | StrapiComponentEnumsMaxWidth | StrapiComponentEnumsOptionalColor | StrapiComponentEnumsPositionX | StrapiComponentEnumsPositionY | StrapiComponentFaqFaq | StrapiComponentFaqFaqItem | StrapiComponentFaqFaqSectionNew | StrapiComponentFaqTest | StrapiComponentListCheckList | StrapiComponentListItem | StrapiComponentListLanguagesList | StrapiComponentListLeftListItems | StrapiComponentListListItems | StrapiComponentListListItemsRight | StrapiComponentListRightItemsNew | StrapiComponentListRightItemsX | StrapiComponentListStatuteAttachmentList | StrapiComponentListStatuteItems | StrapiComponentListStatuteList | StrapiComponentListTextItemRight | StrapiComponentMediaPromoClip | StrapiComponentMedicalDoctorTypeList | StrapiComponentMobileArticleBlocksContent | StrapiComponentRegistrationTelemedicineTypeImages | StrapiComponentSeoMetaSeo | StrapiComponentSeoRedirects | StrapiComponentSeoSeoGhostContent | StrapiComponentSeoSeoSectionCityGhost | StrapiComponentSharedActions | StrapiComponentSharedAnimatedPieChart | StrapiComponentSharedAnimationTextBlock | StrapiComponentSharedAppRatingItem | StrapiComponentSharedAppStoreButtons | StrapiComponentSharedBasicItem | StrapiComponentSharedButton | StrapiComponentSharedCheckbox | StrapiComponentSharedCheckedListITems | StrapiComponentSharedCountdownTimer | StrapiComponentSharedCtaRegisterItem | StrapiComponentSharedDiseasesList | StrapiComponentSharedFaqSliderItem | StrapiComponentSharedIconItem | StrapiComponentSharedLink | StrapiComponentSharedPacketTileItem | StrapiComponentSharedPresentationItem | StrapiComponentSharedPublicationState | StrapiComponentSharedRatingItem | StrapiComponentSharedReview | StrapiComponentSharedSeoShowMoreItem | StrapiComponentSharedService | StrapiComponentSharedServiceSet | StrapiComponentSharedSingleAnimatedPersonSvg | StrapiComponentSharedSocial | StrapiComponentSharedStepList | StrapiComponentSharedVisability | StrapiComponentTextMapBgColor | StrapiComponentTextMapTextColor | StrapiDisease | StrapiDoctor | StrapiDoctorGroup | StrapiDoctorType | StrapiEcommercePartnership | StrapiEcommercePromoBar | StrapiEcommercePromoModal | StrapiEcommercePromoSection | StrapiEcommerceSectionTile | StrapiFaqItemsSet | StrapiFaqPagesNew | StrapiFaqPost | StrapiHint | StrapiI18NLocale | StrapiInfluencer | StrapiKarieraMed | StrapiLanding | StrapiMobileArticle | StrapiPacket | StrapiPatientReview | StrapiPomocDlaUchodzcow | StrapiPost | StrapiPostTag | StrapiPrzychodniaGhost | StrapiPrzychodniaLive | StrapiPrzychodniaStreet | StrapiPrzychodnie | StrapiRegistrationDataStep | StrapiRegistrationStep | StrapiRegistrationStepsType | StrapiRejestracja | StrapiServiceItem | StrapiServiceItemsSet | StrapiServicePage | StrapiStatute | StrapiStatuteClinic | StrapiStepsLayoutContent | StrapiSzczepienia | StrapiTranslationPacket | StrapiUploadFile | StrapiUploadFolder | StrapiUsersPermissionsPermission | StrapiUsersPermissionsRole | StrapiUsersPermissionsUser | StrapiVaccinationType | StrapiZespolMedyczny;

export type StrapiHint = {
  __typename?: 'StrapiHint';
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  image: StrapiUploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiHintRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiHintlocalizationsArgs = {
  filters?: InputMaybe<StrapiHintFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiHintEntity = {
  __typename?: 'StrapiHintEntity';
  attributes?: Maybe<StrapiHint>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiHintEntityResponse = {
  __typename?: 'StrapiHintEntityResponse';
  data?: Maybe<StrapiHintEntity>;
};

export type StrapiHintEntityResponseCollection = {
  __typename?: 'StrapiHintEntityResponseCollection';
  data: Array<StrapiHintEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiHintFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiHintFiltersInput>>>;
  content?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiHintFiltersInput>;
  not?: InputMaybe<StrapiHintFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiHintFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiHintInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiHintRelationResponseCollection = {
  __typename?: 'StrapiHintRelationResponseCollection';
  data: Array<StrapiHintEntity>;
};

export type StrapiI18NLocale = {
  __typename?: 'StrapiI18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};

export type StrapiI18NLocaleEntity = {
  __typename?: 'StrapiI18NLocaleEntity';
  attributes?: Maybe<StrapiI18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiI18NLocaleEntityResponse = {
  __typename?: 'StrapiI18NLocaleEntityResponse';
  data?: Maybe<StrapiI18NLocaleEntity>;
};

export type StrapiI18NLocaleEntityResponseCollection = {
  __typename?: 'StrapiI18NLocaleEntityResponseCollection';
  data: Array<StrapiI18NLocaleEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiI18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiI18NLocaleFiltersInput>>>;
  code?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiI18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiI18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiIDFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<StrapiIDFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiInfluencer = {
  __typename?: 'StrapiInfluencer';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  hideOnMobile: Scalars['Boolean']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiInfluencerRelationResponseCollection>;
  name: Scalars['String']['output'];
  nick: Scalars['String']['output'];
  profileImage: StrapiUploadFileEntityResponse;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  surname: Scalars['String']['output'];
  testimonialsContent: Scalars['String']['output'];
  tiktokLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiInfluencerlocalizationsArgs = {
  filters?: InputMaybe<StrapiInfluencerFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiInfluencerEntity = {
  __typename?: 'StrapiInfluencerEntity';
  attributes?: Maybe<StrapiInfluencer>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiInfluencerEntityResponse = {
  __typename?: 'StrapiInfluencerEntityResponse';
  data?: Maybe<StrapiInfluencerEntity>;
};

export type StrapiInfluencerEntityResponseCollection = {
  __typename?: 'StrapiInfluencerEntityResponseCollection';
  data: Array<StrapiInfluencerEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiInfluencerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiInfluencerFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  facebookLink?: InputMaybe<StrapiStringFilterInput>;
  hideOnMobile?: InputMaybe<StrapiBooleanFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  instagramLink?: InputMaybe<StrapiStringFilterInput>;
  linkedinLink?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiInfluencerFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  nick?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiInfluencerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiInfluencerFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  surname?: InputMaybe<StrapiStringFilterInput>;
  testimonialsContent?: InputMaybe<StrapiStringFilterInput>;
  tiktokLink?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiInfluencerInput = {
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  hideOnMobile?: InputMaybe<Scalars['Boolean']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nick?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  testimonialsContent?: InputMaybe<Scalars['String']['input']>;
  tiktokLink?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiInfluencerRelationResponseCollection = {
  __typename?: 'StrapiInfluencerRelationResponseCollection';
  data: Array<StrapiInfluencerEntity>;
};

export type StrapiIntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<StrapiIntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type StrapiJSONFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['StrapiJSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['StrapiJSON']['input']>>>;
  contains?: InputMaybe<Scalars['StrapiJSON']['input']>;
  containsi?: InputMaybe<Scalars['StrapiJSON']['input']>;
  endsWith?: InputMaybe<Scalars['StrapiJSON']['input']>;
  eq?: InputMaybe<Scalars['StrapiJSON']['input']>;
  eqi?: InputMaybe<Scalars['StrapiJSON']['input']>;
  gt?: InputMaybe<Scalars['StrapiJSON']['input']>;
  gte?: InputMaybe<Scalars['StrapiJSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['StrapiJSON']['input']>>>;
  lt?: InputMaybe<Scalars['StrapiJSON']['input']>;
  lte?: InputMaybe<Scalars['StrapiJSON']['input']>;
  ne?: InputMaybe<Scalars['StrapiJSON']['input']>;
  not?: InputMaybe<StrapiJSONFilterInput>;
  notContains?: InputMaybe<Scalars['StrapiJSON']['input']>;
  notContainsi?: InputMaybe<Scalars['StrapiJSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['StrapiJSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['StrapiJSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['StrapiJSON']['input']>;
};

export type StrapiKarieraMed = {
  __typename?: 'StrapiKarieraMed';
  InfluencerSlider: StrapiComponentDynamicblocksInfluencerSlider;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};

export type StrapiKarieraMedEntity = {
  __typename?: 'StrapiKarieraMedEntity';
  attributes?: Maybe<StrapiKarieraMed>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiKarieraMedEntityResponse = {
  __typename?: 'StrapiKarieraMedEntityResponse';
  data?: Maybe<StrapiKarieraMedEntity>;
};

export type StrapiKarieraMedInput = {
  InfluencerSlider?: InputMaybe<StrapiComponentDynamicblocksInfluencerSliderInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiLanding = {
  __typename?: 'StrapiLanding';
  blocks: Array<Maybe<StrapiLandingBlocksDynamicZone>>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiLandingRelationResponseCollection>;
  metaSeo?: Maybe<StrapiComponentSeoMetaSeo>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiLandinglocalizationsArgs = {
  filters?: InputMaybe<StrapiLandingFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiLandingBlocksDynamicZone = StrapiComponentDynamicblocksAboutAppPhoneBanner | StrapiComponentDynamicblocksAnimatedDoubleCircles | StrapiComponentDynamicblocksAnimatedDoughnutChart | StrapiComponentDynamicblocksAnimatedEnlargingText | StrapiComponentDynamicblocksAnimatedPeopleSvg | StrapiComponentDynamicblocksAnimatedTextGradient | StrapiComponentDynamicblocksAppRating | StrapiComponentDynamicblocksCheckedList | StrapiComponentDynamicblocksCircleImageWithText | StrapiComponentDynamicblocksCirclePhotoBanner | StrapiComponentDynamicblocksCitationBanner | StrapiComponentDynamicblocksClinicsMapEcommerce | StrapiComponentDynamicblocksClinicsMapSmall | StrapiComponentDynamicblocksClinicsSmallSlider | StrapiComponentDynamicblocksCompaniesSlider | StrapiComponentDynamicblocksCtaBaseBanner | StrapiComponentDynamicblocksCtaBigBanner | StrapiComponentDynamicblocksCtaBigBannerSlider | StrapiComponentDynamicblocksCtaButtonLink | StrapiComponentDynamicblocksCtaGraphicBanner | StrapiComponentDynamicblocksCtaRegisterBanner | StrapiComponentDynamicblocksDoctorsSlider | StrapiComponentDynamicblocksDownloadAppBanner | StrapiComponentDynamicblocksFaqSection | StrapiComponentDynamicblocksFaqWithSlider | StrapiComponentDynamicblocksHeaderSection | StrapiComponentDynamicblocksHeaderWithAdditions | StrapiComponentDynamicblocksHorizontalPhotoParallex | StrapiComponentDynamicblocksHorizontalVideoBanner | StrapiComponentDynamicblocksInfluencerSlider | StrapiComponentDynamicblocksMedicalTeamPresentation | StrapiComponentDynamicblocksNewsletter | StrapiComponentDynamicblocksNfzBanner | StrapiComponentDynamicblocksPatientRating | StrapiComponentDynamicblocksPresentationList | StrapiComponentDynamicblocksProductPacketsSlider | StrapiComponentDynamicblocksReceptomatSection | StrapiComponentDynamicblocksSeoShowMoreContent | StrapiComponentDynamicblocksServiceSection | StrapiComponentDynamicblocksSideSectionVideoPreview | StrapiComponentDynamicblocksSideVideoBanner | StrapiComponentDynamicblocksSixBgElements | StrapiComponentDynamicblocksSixIconsItems | StrapiComponentDynamicblocksSocialEmbed | StrapiComponentDynamicblocksSquareImageSlider | StrapiComponentDynamicblocksSquareImageWithText | StrapiComponentDynamicblocksStatuteListSection | StrapiComponentDynamicblocksSymptoms | StrapiComponentDynamicblocksThreeIconsItems | StrapiComponentDynamicblocksTwoColumnsTextSection | StrapiComponentDynamicblocksVideoBanner | StrapiComponentDynamicblocksWhiteSpace | StrapiComponentSharedAnimatedPieChart | StrapiError;

export type StrapiLandingEntity = {
  __typename?: 'StrapiLandingEntity';
  attributes?: Maybe<StrapiLanding>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiLandingEntityResponse = {
  __typename?: 'StrapiLandingEntityResponse';
  data?: Maybe<StrapiLandingEntity>;
};

export type StrapiLandingEntityResponseCollection = {
  __typename?: 'StrapiLandingEntityResponseCollection';
  data: Array<StrapiLandingEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiLandingFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiLandingFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiLandingFiltersInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  not?: InputMaybe<StrapiLandingFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiLandingFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiLandingInput = {
  blocks?: InputMaybe<Array<Scalars['StrapiLandingBlocksDynamicZoneInput']['input']>>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiLandingRelationResponseCollection = {
  __typename?: 'StrapiLandingRelationResponseCollection';
  data: Array<StrapiLandingEntity>;
};

export type StrapiMobileArticle = {
  __typename?: 'StrapiMobileArticle';
  articleImage?: Maybe<StrapiUploadFileEntityResponse>;
  blocks?: Maybe<Array<Maybe<StrapiMobileArticleBlocksDynamicZone>>>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiMobileArticleRelationResponseCollection>;
  metaSeo?: Maybe<StrapiComponentSeoMetaSeo>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiMobileArticlelocalizationsArgs = {
  filters?: InputMaybe<StrapiMobileArticleFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiMobileArticleBlocksDynamicZone = StrapiComponentDynamicblocksProductPacketsSlider | StrapiComponentMobileArticleBlocksContent | StrapiError;

export type StrapiMobileArticleEntity = {
  __typename?: 'StrapiMobileArticleEntity';
  attributes?: Maybe<StrapiMobileArticle>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiMobileArticleEntityResponse = {
  __typename?: 'StrapiMobileArticleEntityResponse';
  data?: Maybe<StrapiMobileArticleEntity>;
};

export type StrapiMobileArticleEntityResponseCollection = {
  __typename?: 'StrapiMobileArticleEntityResponseCollection';
  data: Array<StrapiMobileArticleEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiMobileArticleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiMobileArticleFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiMobileArticleFiltersInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoFiltersInput>;
  not?: InputMaybe<StrapiMobileArticleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiMobileArticleFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiMobileArticleInput = {
  articleImage?: InputMaybe<Scalars['ID']['input']>;
  blocks?: InputMaybe<Array<Scalars['StrapiMobileArticleBlocksDynamicZoneInput']['input']>>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiMobileArticleRelationResponseCollection = {
  __typename?: 'StrapiMobileArticleRelationResponseCollection';
  data: Array<StrapiMobileArticleEntity>;
};

export type StrapiPacket = {
  __typename?: 'StrapiPacket';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redirects?: Maybe<Array<Maybe<StrapiComponentSeoRedirects>>>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPacketredirectsArgs = {
  filters?: InputMaybe<StrapiComponentSeoRedirectsFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiPacketEntity = {
  __typename?: 'StrapiPacketEntity';
  attributes?: Maybe<StrapiPacket>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPacketEntityResponse = {
  __typename?: 'StrapiPacketEntityResponse';
  data?: Maybe<StrapiPacketEntity>;
};

export type StrapiPacketEntityResponseCollection = {
  __typename?: 'StrapiPacketEntityResponseCollection';
  data: Array<StrapiPacketEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiPacketFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiPacketFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiPacketFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiPacketFiltersInput>>>;
  redirects?: InputMaybe<StrapiComponentSeoRedirectsFiltersInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiPacketInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  redirects?: InputMaybe<Array<InputMaybe<StrapiComponentSeoRedirectsInput>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiPacketRelationResponseCollection = {
  __typename?: 'StrapiPacketRelationResponseCollection';
  data: Array<StrapiPacketEntity>;
};

export type StrapiPagination = {
  __typename?: 'StrapiPagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type StrapiPaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type StrapiPatientReview = {
  __typename?: 'StrapiPatientReview';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  doctor?: Maybe<StrapiDoctorEntityResponse>;
  isReceptomatReview?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPatientReviewRelationResponseCollection>;
  patientName?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  reviewRating?: Maybe<Scalars['Int']['output']>;
  reviewText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  verificationDate: Scalars['String']['output'];
};


export type StrapiPatientReviewlocalizationsArgs = {
  filters?: InputMaybe<StrapiPatientReviewFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiPatientReviewEntity = {
  __typename?: 'StrapiPatientReviewEntity';
  attributes?: Maybe<StrapiPatientReview>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPatientReviewEntityResponse = {
  __typename?: 'StrapiPatientReviewEntityResponse';
  data?: Maybe<StrapiPatientReviewEntity>;
};

export type StrapiPatientReviewEntityResponseCollection = {
  __typename?: 'StrapiPatientReviewEntityResponseCollection';
  data: Array<StrapiPatientReviewEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiPatientReviewFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiPatientReviewFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  doctor?: InputMaybe<StrapiDoctorFiltersInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  isReceptomatReview?: InputMaybe<StrapiBooleanFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiPatientReviewFiltersInput>;
  not?: InputMaybe<StrapiPatientReviewFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiPatientReviewFiltersInput>>>;
  patientName?: InputMaybe<StrapiStringFilterInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  reviewRating?: InputMaybe<StrapiIntFilterInput>;
  reviewText?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  verificationDate?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiPatientReviewInput = {
  doctor?: InputMaybe<Scalars['ID']['input']>;
  isReceptomatReview?: InputMaybe<Scalars['Boolean']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  reviewRating?: InputMaybe<Scalars['Int']['input']>;
  reviewText?: InputMaybe<Scalars['String']['input']>;
  verificationDate?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiPatientReviewRelationResponseCollection = {
  __typename?: 'StrapiPatientReviewRelationResponseCollection';
  data: Array<StrapiPatientReviewEntity>;
};

export type StrapiPomocDlaUchodzcow = {
  __typename?: 'StrapiPomocDlaUchodzcow';
  clinics_streets?: Maybe<StrapiClinicsStreetRelationResponseCollection>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPomocDlaUchodzcowRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPomocDlaUchodzcowclinics_streetsArgs = {
  filters?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiPomocDlaUchodzcowlocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiPomocDlaUchodzcowEntity = {
  __typename?: 'StrapiPomocDlaUchodzcowEntity';
  attributes?: Maybe<StrapiPomocDlaUchodzcow>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPomocDlaUchodzcowEntityResponse = {
  __typename?: 'StrapiPomocDlaUchodzcowEntityResponse';
  data?: Maybe<StrapiPomocDlaUchodzcowEntity>;
};

export type StrapiPomocDlaUchodzcowInput = {
  clinics_streets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiPomocDlaUchodzcowRelationResponseCollection = {
  __typename?: 'StrapiPomocDlaUchodzcowRelationResponseCollection';
  data: Array<StrapiPomocDlaUchodzcowEntity>;
};

export type StrapiPost = {
  __typename?: 'StrapiPost';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  excerpt: Scalars['String']['output'];
  html: Scalars['String']['output'];
  post_tags?: Maybe<StrapiPostTagRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPostpost_tagsArgs = {
  filters?: InputMaybe<StrapiPostTagFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiPostEntity = {
  __typename?: 'StrapiPostEntity';
  attributes?: Maybe<StrapiPost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPostEntityResponse = {
  __typename?: 'StrapiPostEntityResponse';
  data?: Maybe<StrapiPostEntity>;
};

export type StrapiPostEntityResponseCollection = {
  __typename?: 'StrapiPostEntityResponseCollection';
  data: Array<StrapiPostEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiPostFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiPostFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  excerpt?: InputMaybe<StrapiStringFilterInput>;
  html?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  not?: InputMaybe<StrapiPostFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiPostFiltersInput>>>;
  post_tags?: InputMaybe<StrapiPostTagFiltersInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  slug?: InputMaybe<StrapiStringFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiPostInput = {
  excerpt?: InputMaybe<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  post_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiPostRelationResponseCollection = {
  __typename?: 'StrapiPostRelationResponseCollection';
  data: Array<StrapiPostEntity>;
};

export type StrapiPostTag = {
  __typename?: 'StrapiPostTag';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  genre: Scalars['String']['output'];
  posts?: Maybe<StrapiPostRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPostTagpostsArgs = {
  filters?: InputMaybe<StrapiPostFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiPostTagEntity = {
  __typename?: 'StrapiPostTagEntity';
  attributes?: Maybe<StrapiPostTag>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPostTagEntityResponse = {
  __typename?: 'StrapiPostTagEntityResponse';
  data?: Maybe<StrapiPostTagEntity>;
};

export type StrapiPostTagEntityResponseCollection = {
  __typename?: 'StrapiPostTagEntityResponseCollection';
  data: Array<StrapiPostTagEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiPostTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiPostTagFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  genre?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  not?: InputMaybe<StrapiPostTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiPostTagFiltersInput>>>;
  posts?: InputMaybe<StrapiPostFiltersInput>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiPostTagInput = {
  genre?: InputMaybe<Scalars['String']['input']>;
  posts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiPostTagRelationResponseCollection = {
  __typename?: 'StrapiPostTagRelationResponseCollection';
  data: Array<StrapiPostTagEntity>;
};

export type StrapiPrzychodniaGhost = {
  __typename?: 'StrapiPrzychodniaGhost';
  TopBanner: StrapiComponentBlocksCtaBanner;
  checkedListHeaderSection: StrapiComponentDynamicblocksHeaderSection;
  checkedListItems: StrapiComponentDynamicblocksCheckedList;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPrzychodniaGhostRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  threeIconsBanner: StrapiComponentDynamicblocksThreeIconsItems;
  threeIconsHeaderSection: StrapiComponentDynamicblocksHeaderSection;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPrzychodniaGhostlocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiPrzychodniaGhostEntity = {
  __typename?: 'StrapiPrzychodniaGhostEntity';
  attributes?: Maybe<StrapiPrzychodniaGhost>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPrzychodniaGhostEntityResponse = {
  __typename?: 'StrapiPrzychodniaGhostEntityResponse';
  data?: Maybe<StrapiPrzychodniaGhostEntity>;
};

export type StrapiPrzychodniaGhostInput = {
  TopBanner?: InputMaybe<StrapiComponentBlocksCtaBannerInput>;
  checkedListHeaderSection?: InputMaybe<StrapiComponentDynamicblocksHeaderSectionInput>;
  checkedListItems?: InputMaybe<StrapiComponentDynamicblocksCheckedListInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  threeIconsBanner?: InputMaybe<StrapiComponentDynamicblocksThreeIconsItemsInput>;
  threeIconsHeaderSection?: InputMaybe<StrapiComponentDynamicblocksHeaderSectionInput>;
};

export type StrapiPrzychodniaGhostRelationResponseCollection = {
  __typename?: 'StrapiPrzychodniaGhostRelationResponseCollection';
  data: Array<StrapiPrzychodniaGhostEntity>;
};

export type StrapiPrzychodniaLive = {
  __typename?: 'StrapiPrzychodniaLive';
  clinicsCards: StrapiComponentClinicsClinicsBigCards;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPrzychodniaLiveRelationResponseCollection>;
  nfzBanner: StrapiComponentBlocksNfzBanner;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPrzychodniaLivelocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiPrzychodniaLiveEntity = {
  __typename?: 'StrapiPrzychodniaLiveEntity';
  attributes?: Maybe<StrapiPrzychodniaLive>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPrzychodniaLiveEntityResponse = {
  __typename?: 'StrapiPrzychodniaLiveEntityResponse';
  data?: Maybe<StrapiPrzychodniaLiveEntity>;
};

export type StrapiPrzychodniaLiveInput = {
  clinicsCards?: InputMaybe<StrapiComponentClinicsClinicsBigCardsInput>;
  nfzBanner?: InputMaybe<StrapiComponentBlocksNfzBannerInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiPrzychodniaLiveRelationResponseCollection = {
  __typename?: 'StrapiPrzychodniaLiveRelationResponseCollection';
  data: Array<StrapiPrzychodniaLiveEntity>;
};

export type StrapiPrzychodniaStreet = {
  __typename?: 'StrapiPrzychodniaStreet';
  clinicsCardBanner: StrapiComponentClinicsClinicsSmallCards;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  doctorsBanner: StrapiComponentClinicsDoctorsSliderBanner;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPrzychodniaStreetRelationResponseCollection>;
  mapCityBanner: StrapiComponentClinicsMapCityBanner;
  nfzBanner: StrapiComponentBlocksNfzBanner;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  sliderWithGallery?: Maybe<StrapiComponentBlocksSliderWithGallery>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPrzychodniaStreetlocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiPrzychodniaStreetEntity = {
  __typename?: 'StrapiPrzychodniaStreetEntity';
  attributes?: Maybe<StrapiPrzychodniaStreet>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPrzychodniaStreetEntityResponse = {
  __typename?: 'StrapiPrzychodniaStreetEntityResponse';
  data?: Maybe<StrapiPrzychodniaStreetEntity>;
};

export type StrapiPrzychodniaStreetInput = {
  clinicsCardBanner?: InputMaybe<StrapiComponentClinicsClinicsSmallCardsInput>;
  doctorsBanner?: InputMaybe<StrapiComponentClinicsDoctorsSliderBannerInput>;
  mapCityBanner?: InputMaybe<StrapiComponentClinicsMapCityBannerInput>;
  nfzBanner?: InputMaybe<StrapiComponentBlocksNfzBannerInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  sliderWithGallery?: InputMaybe<StrapiComponentBlocksSliderWithGalleryInput>;
};

export type StrapiPrzychodniaStreetRelationResponseCollection = {
  __typename?: 'StrapiPrzychodniaStreetRelationResponseCollection';
  data: Array<StrapiPrzychodniaStreetEntity>;
};

export type StrapiPrzychodnie = {
  __typename?: 'StrapiPrzychodnie';
  citiesListLinks: StrapiComponentClinicsCitiesListLinks;
  clinicsCards: StrapiComponentClinicsClinicsBigCards;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiPrzychodnieRelationResponseCollection>;
  mapCityClinics: StrapiComponentClinicsMapCityBanner;
  metaSeo?: Maybe<StrapiComponentSeoMetaSeo>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  threeIconsBanner: StrapiComponentDynamicblocksThreeIconsItems;
  threeIconsHeaderSection: StrapiComponentDynamicblocksHeaderSection;
  topBanner: StrapiComponentBlocksHero;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiPrzychodnielocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiPrzychodnieEntity = {
  __typename?: 'StrapiPrzychodnieEntity';
  attributes?: Maybe<StrapiPrzychodnie>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiPrzychodnieEntityResponse = {
  __typename?: 'StrapiPrzychodnieEntityResponse';
  data?: Maybe<StrapiPrzychodnieEntity>;
};

export type StrapiPrzychodnieInput = {
  citiesListLinks?: InputMaybe<StrapiComponentClinicsCitiesListLinksInput>;
  clinicsCards?: InputMaybe<StrapiComponentClinicsClinicsBigCardsInput>;
  mapCityClinics?: InputMaybe<StrapiComponentClinicsMapCityBannerInput>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  threeIconsBanner?: InputMaybe<StrapiComponentDynamicblocksThreeIconsItemsInput>;
  threeIconsHeaderSection?: InputMaybe<StrapiComponentDynamicblocksHeaderSectionInput>;
  topBanner?: InputMaybe<StrapiComponentBlocksHeroInput>;
};

export type StrapiPrzychodnieRelationResponseCollection = {
  __typename?: 'StrapiPrzychodnieRelationResponseCollection';
  data: Array<StrapiPrzychodnieEntity>;
};

export type StrapiPublicationState =
  | 'LIVE'
  | 'PREVIEW';

export type StrapiRegistrationDataStep = {
  __typename?: 'StrapiRegistrationDataStep';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  image: StrapiUploadFileEntityResponse;
  isPediatrics: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiRegistrationDataStepRelationResponseCollection>;
  name: StrapiENUM_REGISTRATIONDATASTEP_NAME;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  socialProof?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiRegistrationDataSteplocalizationsArgs = {
  filters?: InputMaybe<StrapiRegistrationDataStepFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiRegistrationDataStepEntity = {
  __typename?: 'StrapiRegistrationDataStepEntity';
  attributes?: Maybe<StrapiRegistrationDataStep>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiRegistrationDataStepEntityResponse = {
  __typename?: 'StrapiRegistrationDataStepEntityResponse';
  data?: Maybe<StrapiRegistrationDataStepEntity>;
};

export type StrapiRegistrationDataStepEntityResponseCollection = {
  __typename?: 'StrapiRegistrationDataStepEntityResponseCollection';
  data: Array<StrapiRegistrationDataStepEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiRegistrationDataStepFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiRegistrationDataStepFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  isPediatrics?: InputMaybe<StrapiBooleanFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiRegistrationDataStepFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiRegistrationDataStepFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiRegistrationDataStepFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  socialProof?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiRegistrationDataStepInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  isPediatrics?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StrapiENUM_REGISTRATIONDATASTEP_NAME>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  socialProof?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiRegistrationDataStepRelationResponseCollection = {
  __typename?: 'StrapiRegistrationDataStepRelationResponseCollection';
  data: Array<StrapiRegistrationDataStepEntity>;
};

export type StrapiRegistrationStep = {
  __typename?: 'StrapiRegistrationStep';
  SocialProof: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiRegistrationStepRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  registration_steps_type?: Maybe<StrapiRegistrationStepsTypeEntityResponse>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiRegistrationSteplocalizationsArgs = {
  filters?: InputMaybe<StrapiRegistrationStepFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiRegistrationStepEntity = {
  __typename?: 'StrapiRegistrationStepEntity';
  attributes?: Maybe<StrapiRegistrationStep>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiRegistrationStepEntityResponse = {
  __typename?: 'StrapiRegistrationStepEntityResponse';
  data?: Maybe<StrapiRegistrationStepEntity>;
};

export type StrapiRegistrationStepEntityResponseCollection = {
  __typename?: 'StrapiRegistrationStepEntityResponseCollection';
  data: Array<StrapiRegistrationStepEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiRegistrationStepFiltersInput = {
  SocialProof?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiRegistrationStepFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiRegistrationStepFiltersInput>;
  not?: InputMaybe<StrapiRegistrationStepFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiRegistrationStepFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  registration_steps_type?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiRegistrationStepInput = {
  SocialProof?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  registration_steps_type?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiRegistrationStepRelationResponseCollection = {
  __typename?: 'StrapiRegistrationStepRelationResponseCollection';
  data: Array<StrapiRegistrationStepEntity>;
};

export type StrapiRegistrationStepsType = {
  __typename?: 'StrapiRegistrationStepsType';
  Type?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiRegistrationStepsTypeRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  registration_step?: Maybe<StrapiRegistrationStepEntityResponse>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiRegistrationStepsTypelocalizationsArgs = {
  filters?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiRegistrationStepsTypeEntity = {
  __typename?: 'StrapiRegistrationStepsTypeEntity';
  attributes?: Maybe<StrapiRegistrationStepsType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiRegistrationStepsTypeEntityResponse = {
  __typename?: 'StrapiRegistrationStepsTypeEntityResponse';
  data?: Maybe<StrapiRegistrationStepsTypeEntity>;
};

export type StrapiRegistrationStepsTypeEntityResponseCollection = {
  __typename?: 'StrapiRegistrationStepsTypeEntityResponseCollection';
  data: Array<StrapiRegistrationStepsTypeEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiRegistrationStepsTypeFiltersInput = {
  Type?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiRegistrationStepsTypeFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  not?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiRegistrationStepsTypeFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  registration_step?: InputMaybe<StrapiRegistrationStepFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiRegistrationStepsTypeInput = {
  Type?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  registration_step?: InputMaybe<Scalars['ID']['input']>;
};

export type StrapiRegistrationStepsTypeRelationResponseCollection = {
  __typename?: 'StrapiRegistrationStepsTypeRelationResponseCollection';
  data: Array<StrapiRegistrationStepsTypeEntity>;
};

export type StrapiRejestracja = {
  __typename?: 'StrapiRejestracja';
  clinics_streets?: Maybe<StrapiClinicsStreetRelationResponseCollection>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  registration_steps_types?: Maybe<StrapiRegistrationStepsTypeRelationResponseCollection>;
  telemedicineTypeImages: StrapiComponentRegistrationTelemedicineTypeImages;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiRejestracjaclinics_streetsArgs = {
  filters?: InputMaybe<StrapiClinicsStreetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiRejestracjaregistration_steps_typesArgs = {
  filters?: InputMaybe<StrapiRegistrationStepsTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiRejestracjaEntity = {
  __typename?: 'StrapiRejestracjaEntity';
  attributes?: Maybe<StrapiRejestracja>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiRejestracjaEntityResponse = {
  __typename?: 'StrapiRejestracjaEntityResponse';
  data?: Maybe<StrapiRejestracjaEntity>;
};

export type StrapiRejestracjaInput = {
  clinics_streets?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  registration_steps_types?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  telemedicineTypeImages?: InputMaybe<StrapiComponentRegistrationTelemedicineTypeImagesInput>;
};

export type StrapiResponseCollectionMeta = {
  __typename?: 'StrapiResponseCollectionMeta';
  pagination: StrapiPagination;
};

export type StrapiServiceItem = {
  __typename?: 'StrapiServiceItem';
  common_id: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiServiceItemRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  title: Scalars['String']['output'];
  title_id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiServiceItemlocalizationsArgs = {
  filters?: InputMaybe<StrapiServiceItemFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiServiceItemEntity = {
  __typename?: 'StrapiServiceItemEntity';
  attributes?: Maybe<StrapiServiceItem>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiServiceItemEntityResponse = {
  __typename?: 'StrapiServiceItemEntityResponse';
  data?: Maybe<StrapiServiceItemEntity>;
};

export type StrapiServiceItemEntityResponseCollection = {
  __typename?: 'StrapiServiceItemEntityResponseCollection';
  data: Array<StrapiServiceItemEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiServiceItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiServiceItemFiltersInput>>>;
  common_id?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  link?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiServiceItemFiltersInput>;
  not?: InputMaybe<StrapiServiceItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiServiceItemFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  title_id?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiServiceItemInput = {
  common_id?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_id?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiServiceItemRelationResponseCollection = {
  __typename?: 'StrapiServiceItemRelationResponseCollection';
  data: Array<StrapiServiceItemEntity>;
};

export type StrapiServiceItemsSet = {
  __typename?: 'StrapiServiceItemsSet';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  imageSet: StrapiUploadFileEntityResponse;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiServiceItemsSetRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  serviceSet: Array<Maybe<StrapiServiceItemsSetServiceSetDynamicZone>>;
  title_id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiServiceItemsSetlocalizationsArgs = {
  filters?: InputMaybe<StrapiServiceItemsSetFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiServiceItemsSetEntity = {
  __typename?: 'StrapiServiceItemsSetEntity';
  attributes?: Maybe<StrapiServiceItemsSet>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiServiceItemsSetEntityResponse = {
  __typename?: 'StrapiServiceItemsSetEntityResponse';
  data?: Maybe<StrapiServiceItemsSetEntity>;
};

export type StrapiServiceItemsSetEntityResponseCollection = {
  __typename?: 'StrapiServiceItemsSetEntityResponseCollection';
  data: Array<StrapiServiceItemsSetEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiServiceItemsSetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiServiceItemsSetFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiServiceItemsSetFiltersInput>;
  not?: InputMaybe<StrapiServiceItemsSetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiServiceItemsSetFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  title_id?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiServiceItemsSetInput = {
  imageSet?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  serviceSet?: InputMaybe<Array<Scalars['StrapiServiceItemsSetServiceSetDynamicZoneInput']['input']>>;
  title_id?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiServiceItemsSetRelationResponseCollection = {
  __typename?: 'StrapiServiceItemsSetRelationResponseCollection';
  data: Array<StrapiServiceItemsSetEntity>;
};

export type StrapiServiceItemsSetServiceSetDynamicZone = StrapiComponentSharedService | StrapiError;

export type StrapiServicePage = {
  __typename?: 'StrapiServicePage';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiServicePageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  serviceSet: Array<Maybe<StrapiServicePageServiceSetDynamicZone>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiServicePagelocalizationsArgs = {
  filters?: InputMaybe<StrapiServicePageFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiServicePageEntity = {
  __typename?: 'StrapiServicePageEntity';
  attributes?: Maybe<StrapiServicePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiServicePageEntityResponse = {
  __typename?: 'StrapiServicePageEntityResponse';
  data?: Maybe<StrapiServicePageEntity>;
};

export type StrapiServicePageEntityResponseCollection = {
  __typename?: 'StrapiServicePageEntityResponseCollection';
  data: Array<StrapiServicePageEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiServicePageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiServicePageFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiServicePageFiltersInput>;
  not?: InputMaybe<StrapiServicePageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiServicePageFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  title?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiServicePageInput = {
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  serviceSet?: InputMaybe<Array<Scalars['StrapiServicePageServiceSetDynamicZoneInput']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiServicePageRelationResponseCollection = {
  __typename?: 'StrapiServicePageRelationResponseCollection';
  data: Array<StrapiServicePageEntity>;
};

export type StrapiServicePageServiceSetDynamicZone = StrapiComponentSharedServiceSet | StrapiError;

export type StrapiStatute = {
  __typename?: 'StrapiStatute';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  link: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiStatuteRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  subStatute?: Maybe<Array<Maybe<StrapiComponentListStatuteList>>>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiStatutelocalizationsArgs = {
  filters?: InputMaybe<StrapiStatuteFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiStatutesubStatuteArgs = {
  filters?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiStatuteClinic = {
  __typename?: 'StrapiStatuteClinic';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  link: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiStatuteClinicRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  subStatute?: Maybe<Array<Maybe<StrapiComponentListStatuteList>>>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiStatuteCliniclocalizationsArgs = {
  filters?: InputMaybe<StrapiStatuteClinicFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiStatuteClinicsubStatuteArgs = {
  filters?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiStatuteClinicEntity = {
  __typename?: 'StrapiStatuteClinicEntity';
  attributes?: Maybe<StrapiStatuteClinic>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiStatuteClinicEntityResponse = {
  __typename?: 'StrapiStatuteClinicEntityResponse';
  data?: Maybe<StrapiStatuteClinicEntity>;
};

export type StrapiStatuteClinicEntityResponseCollection = {
  __typename?: 'StrapiStatuteClinicEntityResponseCollection';
  data: Array<StrapiStatuteClinicEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiStatuteClinicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiStatuteClinicFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  link?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiStatuteClinicFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiStatuteClinicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiStatuteClinicFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  subStatute?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiStatuteClinicInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  subStatute?: InputMaybe<Array<InputMaybe<StrapiComponentListStatuteListInput>>>;
};

export type StrapiStatuteClinicRelationResponseCollection = {
  __typename?: 'StrapiStatuteClinicRelationResponseCollection';
  data: Array<StrapiStatuteClinicEntity>;
};

export type StrapiStatuteEntity = {
  __typename?: 'StrapiStatuteEntity';
  attributes?: Maybe<StrapiStatute>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiStatuteEntityResponse = {
  __typename?: 'StrapiStatuteEntityResponse';
  data?: Maybe<StrapiStatuteEntity>;
};

export type StrapiStatuteEntityResponseCollection = {
  __typename?: 'StrapiStatuteEntityResponseCollection';
  data: Array<StrapiStatuteEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiStatuteFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiStatuteFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  link?: InputMaybe<StrapiStringFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiStatuteFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiStatuteFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiStatuteFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  subStatute?: InputMaybe<StrapiComponentListStatuteListFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiStatuteInput = {
  link?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  subStatute?: InputMaybe<Array<InputMaybe<StrapiComponentListStatuteListInput>>>;
};

export type StrapiStatuteRelationResponseCollection = {
  __typename?: 'StrapiStatuteRelationResponseCollection';
  data: Array<StrapiStatuteEntity>;
};

export type StrapiStepsLayoutContent = {
  __typename?: 'StrapiStepsLayoutContent';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  image: StrapiUploadFileEntityResponse;
  isPediatrics: Scalars['Boolean']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiStepsLayoutContentRelationResponseCollection>;
  name: StrapiENUM_STEPSLAYOUTCONTENT_NAME;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  socialProof?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiStepsLayoutContentlocalizationsArgs = {
  filters?: InputMaybe<StrapiStepsLayoutContentFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiStepsLayoutContentEntity = {
  __typename?: 'StrapiStepsLayoutContentEntity';
  attributes?: Maybe<StrapiStepsLayoutContent>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiStepsLayoutContentEntityResponse = {
  __typename?: 'StrapiStepsLayoutContentEntityResponse';
  data?: Maybe<StrapiStepsLayoutContentEntity>;
};

export type StrapiStepsLayoutContentEntityResponseCollection = {
  __typename?: 'StrapiStepsLayoutContentEntityResponseCollection';
  data: Array<StrapiStepsLayoutContentEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiStepsLayoutContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiStepsLayoutContentFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  isPediatrics?: InputMaybe<StrapiBooleanFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiStepsLayoutContentFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiStepsLayoutContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiStepsLayoutContentFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  socialProof?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiStepsLayoutContentInput = {
  image?: InputMaybe<Scalars['ID']['input']>;
  isPediatrics?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StrapiENUM_STEPSLAYOUTCONTENT_NAME>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  socialProof?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiStepsLayoutContentRelationResponseCollection = {
  __typename?: 'StrapiStepsLayoutContentRelationResponseCollection';
  data: Array<StrapiStepsLayoutContentEntity>;
};

export type StrapiStringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StrapiStringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiSzczepienia = {
  __typename?: 'StrapiSzczepienia';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  footerStatistics: StrapiComponentDynamicblocksPatientRating;
  indexDescription?: Maybe<Scalars['String']['output']>;
  indexTitle: Scalars['String']['output'];
  metaSeo: StrapiComponentSeoMetaSeo;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  registerStepList?: Maybe<Array<Maybe<StrapiComponentSharedStepList>>>;
  slugClinicTitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiSzczepieniaregisterStepListArgs = {
  filters?: InputMaybe<StrapiComponentSharedStepListFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiSzczepieniaEntity = {
  __typename?: 'StrapiSzczepieniaEntity';
  attributes?: Maybe<StrapiSzczepienia>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiSzczepieniaEntityResponse = {
  __typename?: 'StrapiSzczepieniaEntityResponse';
  data?: Maybe<StrapiSzczepieniaEntity>;
};

export type StrapiSzczepieniaInput = {
  footerStatistics?: InputMaybe<StrapiComponentDynamicblocksPatientRatingInput>;
  indexDescription?: InputMaybe<Scalars['String']['input']>;
  indexTitle?: InputMaybe<Scalars['String']['input']>;
  metaSeo?: InputMaybe<StrapiComponentSeoMetaSeoInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  registerStepList?: InputMaybe<Array<InputMaybe<StrapiComponentSharedStepListInput>>>;
  slugClinicTitle?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiTranslationPacket = {
  __typename?: 'StrapiTranslationPacket';
  content?: Maybe<Scalars['StrapiJSON']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type StrapiTranslationPacketEntity = {
  __typename?: 'StrapiTranslationPacketEntity';
  attributes?: Maybe<StrapiTranslationPacket>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiTranslationPacketEntityResponse = {
  __typename?: 'StrapiTranslationPacketEntityResponse';
  data?: Maybe<StrapiTranslationPacketEntity>;
};

export type StrapiTranslationPacketEntityResponseCollection = {
  __typename?: 'StrapiTranslationPacketEntityResponseCollection';
  data: Array<StrapiTranslationPacketEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiTranslationPacketFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiTranslationPacketFiltersInput>>>;
  content?: InputMaybe<StrapiJSONFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiTranslationPacketFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiTranslationPacketFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  target?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  version?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiTranslationPacketInput = {
  content?: InputMaybe<Scalars['StrapiJSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiUploadFile = {
  __typename?: 'StrapiUploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['StrapiJSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['StrapiJSON']['output']>;
  related?: Maybe<Array<Maybe<StrapiGenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type StrapiUploadFileEntity = {
  __typename?: 'StrapiUploadFileEntity';
  attributes?: Maybe<StrapiUploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiUploadFileEntityResponse = {
  __typename?: 'StrapiUploadFileEntityResponse';
  data?: Maybe<StrapiUploadFileEntity>;
};

export type StrapiUploadFileEntityResponseCollection = {
  __typename?: 'StrapiUploadFileEntityResponseCollection';
  data: Array<StrapiUploadFileEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiUploadFileFiltersInput = {
  alternativeText?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiUploadFileFiltersInput>>>;
  caption?: InputMaybe<StrapiStringFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  ext?: InputMaybe<StrapiStringFilterInput>;
  folder?: InputMaybe<StrapiUploadFolderFiltersInput>;
  folderPath?: InputMaybe<StrapiStringFilterInput>;
  formats?: InputMaybe<StrapiJSONFilterInput>;
  hash?: InputMaybe<StrapiStringFilterInput>;
  height?: InputMaybe<StrapiIntFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  mime?: InputMaybe<StrapiStringFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiUploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiUploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StrapiStringFilterInput>;
  provider?: InputMaybe<StrapiStringFilterInput>;
  provider_metadata?: InputMaybe<StrapiJSONFilterInput>;
  size?: InputMaybe<StrapiFloatFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  url?: InputMaybe<StrapiStringFilterInput>;
  width?: InputMaybe<StrapiIntFilterInput>;
};

export type StrapiUploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['StrapiJSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['StrapiJSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type StrapiUploadFileRelationResponseCollection = {
  __typename?: 'StrapiUploadFileRelationResponseCollection';
  data: Array<StrapiUploadFileEntity>;
};

export type StrapiUploadFolder = {
  __typename?: 'StrapiUploadFolder';
  children?: Maybe<StrapiUploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  files?: Maybe<StrapiUploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<StrapiUploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiUploadFolderchildrenArgs = {
  filters?: InputMaybe<StrapiUploadFolderFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiUploadFolderfilesArgs = {
  filters?: InputMaybe<StrapiUploadFileFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiUploadFolderEntity = {
  __typename?: 'StrapiUploadFolderEntity';
  attributes?: Maybe<StrapiUploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiUploadFolderEntityResponse = {
  __typename?: 'StrapiUploadFolderEntityResponse';
  data?: Maybe<StrapiUploadFolderEntity>;
};

export type StrapiUploadFolderEntityResponseCollection = {
  __typename?: 'StrapiUploadFolderEntityResponseCollection';
  data: Array<StrapiUploadFolderEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiUploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiUploadFolderFiltersInput>>>;
  children?: InputMaybe<StrapiUploadFolderFiltersInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  files?: InputMaybe<StrapiUploadFileFiltersInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiUploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiUploadFolderFiltersInput>>>;
  parent?: InputMaybe<StrapiUploadFolderFiltersInput>;
  path?: InputMaybe<StrapiStringFilterInput>;
  pathId?: InputMaybe<StrapiIntFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiUploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type StrapiUploadFolderRelationResponseCollection = {
  __typename?: 'StrapiUploadFolderRelationResponseCollection';
  data: Array<StrapiUploadFolderEntity>;
};

export type StrapiUsersPermissionsCreateRolePayload = {
  __typename?: 'StrapiUsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type StrapiUsersPermissionsDeleteRolePayload = {
  __typename?: 'StrapiUsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type StrapiUsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type StrapiUsersPermissionsLoginPayload = {
  __typename?: 'StrapiUsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: StrapiUsersPermissionsMe;
};

export type StrapiUsersPermissionsMe = {
  __typename?: 'StrapiUsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<StrapiUsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type StrapiUsersPermissionsMeRole = {
  __typename?: 'StrapiUsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type StrapiUsersPermissionsPasswordPayload = {
  __typename?: 'StrapiUsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type StrapiUsersPermissionsPermission = {
  __typename?: 'StrapiUsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  role?: Maybe<StrapiUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};

export type StrapiUsersPermissionsPermissionEntity = {
  __typename?: 'StrapiUsersPermissionsPermissionEntity';
  attributes?: Maybe<StrapiUsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiUsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StrapiStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  not?: InputMaybe<StrapiUsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<StrapiUsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiUsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'StrapiUsersPermissionsPermissionRelationResponseCollection';
  data: Array<StrapiUsersPermissionsPermissionEntity>;
};

export type StrapiUsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type StrapiUsersPermissionsRole = {
  __typename?: 'StrapiUsersPermissionsRole';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<StrapiUsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  users?: Maybe<StrapiUsersPermissionsUserRelationResponseCollection>;
};


export type StrapiUsersPermissionsRolepermissionsArgs = {
  filters?: InputMaybe<StrapiUsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiUsersPermissionsRoleusersArgs = {
  filters?: InputMaybe<StrapiUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiUsersPermissionsRoleEntity = {
  __typename?: 'StrapiUsersPermissionsRoleEntity';
  attributes?: Maybe<StrapiUsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiUsersPermissionsRoleEntityResponse = {
  __typename?: 'StrapiUsersPermissionsRoleEntityResponse';
  data?: Maybe<StrapiUsersPermissionsRoleEntity>;
};

export type StrapiUsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'StrapiUsersPermissionsRoleEntityResponseCollection';
  data: Array<StrapiUsersPermissionsRoleEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiUsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  description?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiUsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<StrapiUsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StrapiStringFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  users?: InputMaybe<StrapiUsersPermissionsUserFiltersInput>;
};

export type StrapiUsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type StrapiUsersPermissionsUpdateRolePayload = {
  __typename?: 'StrapiUsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type StrapiUsersPermissionsUser = {
  __typename?: 'StrapiUsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<StrapiUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  username: Scalars['String']['output'];
};

export type StrapiUsersPermissionsUserEntity = {
  __typename?: 'StrapiUsersPermissionsUserEntity';
  attributes?: Maybe<StrapiUsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiUsersPermissionsUserEntityResponse = {
  __typename?: 'StrapiUsersPermissionsUserEntityResponse';
  data?: Maybe<StrapiUsersPermissionsUserEntity>;
};

export type StrapiUsersPermissionsUserEntityResponseCollection = {
  __typename?: 'StrapiUsersPermissionsUserEntityResponseCollection';
  data: Array<StrapiUsersPermissionsUserEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiUsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<StrapiBooleanFilterInput>;
  confirmationToken?: InputMaybe<StrapiStringFilterInput>;
  confirmed?: InputMaybe<StrapiBooleanFilterInput>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  email?: InputMaybe<StrapiStringFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  not?: InputMaybe<StrapiUsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiUsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StrapiStringFilterInput>;
  provider?: InputMaybe<StrapiStringFilterInput>;
  resetPasswordToken?: InputMaybe<StrapiStringFilterInput>;
  role?: InputMaybe<StrapiUsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  username?: InputMaybe<StrapiStringFilterInput>;
};

export type StrapiUsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type StrapiUsersPermissionsUserRelationResponseCollection = {
  __typename?: 'StrapiUsersPermissionsUserRelationResponseCollection';
  data: Array<StrapiUsersPermissionsUserEntity>;
};

export type StrapiVaccinationType = {
  __typename?: 'StrapiVaccinationType';
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiVaccinationTypeRelationResponseCollection>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
};


export type StrapiVaccinationTypelocalizationsArgs = {
  filters?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StrapiVaccinationTypeEntity = {
  __typename?: 'StrapiVaccinationTypeEntity';
  attributes?: Maybe<StrapiVaccinationType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiVaccinationTypeEntityResponse = {
  __typename?: 'StrapiVaccinationTypeEntityResponse';
  data?: Maybe<StrapiVaccinationTypeEntity>;
};

export type StrapiVaccinationTypeEntityResponseCollection = {
  __typename?: 'StrapiVaccinationTypeEntityResponseCollection';
  data: Array<StrapiVaccinationTypeEntity>;
  meta: StrapiResponseCollectionMeta;
};

export type StrapiVaccinationTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<StrapiVaccinationTypeFiltersInput>>>;
  createdAt?: InputMaybe<StrapiDateTimeFilterInput>;
  id?: InputMaybe<StrapiIDFilterInput>;
  locale?: InputMaybe<StrapiStringFilterInput>;
  localizations?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
  name?: InputMaybe<StrapiStringFilterInput>;
  not?: InputMaybe<StrapiVaccinationTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<StrapiVaccinationTypeFiltersInput>>>;
  publishedAt?: InputMaybe<StrapiDateTimeFilterInput>;
  updatedAt?: InputMaybe<StrapiDateTimeFilterInput>;
};

export type StrapiVaccinationTypeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
};

export type StrapiVaccinationTypeRelationResponseCollection = {
  __typename?: 'StrapiVaccinationTypeRelationResponseCollection';
  data: Array<StrapiVaccinationTypeEntity>;
};

export type StrapiZespolMedyczny = {
  __typename?: 'StrapiZespolMedyczny';
  checkListItems: StrapiComponentListCheckList;
  checkedListHeaderSection: StrapiComponentDynamicblocksHeaderSection;
  checkedListItems: StrapiComponentDynamicblocksCheckedList;
  createdAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  ctaBanner?: Maybe<StrapiComponentBlocksCtaBanner>;
  default_doctor_group?: Maybe<StrapiDoctorGroupEntityResponse>;
  doctorOpinionTitle?: Maybe<Scalars['String']['output']>;
  doctorTeamTitle?: Maybe<Scalars['String']['output']>;
  doctorVideoHero?: Maybe<StrapiComponentBlocksVideoHero>;
  doctor_groups?: Maybe<StrapiDoctorGroupRelationResponseCollection>;
  doctors?: Maybe<StrapiDoctorRelationResponseCollection>;
  heroImageBanner?: Maybe<StrapiComponentBlocksHeroImage>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<StrapiZespolMedycznyRelationResponseCollection>;
  promoClip: StrapiComponentMediaPromoClip;
  publishedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  threeIconBanner: StrapiComponentBlocksThreeIconBanner;
  threeIconBannerTitle: Scalars['String']['output'];
  threeIconsBanner: StrapiComponentDynamicblocksThreeIconsItems;
  threeIconsHeaderSection: StrapiComponentDynamicblocksHeaderSection;
  updatedAt?: Maybe<Scalars['StrapiDateTime']['output']>;
  videoBanner?: Maybe<StrapiComponentBlocksVideoBanner>;
};


export type StrapiZespolMedycznydoctor_groupsArgs = {
  filters?: InputMaybe<StrapiDoctorGroupFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiZespolMedycznydoctorsArgs = {
  filters?: InputMaybe<StrapiDoctorFiltersInput>;
  pagination?: InputMaybe<StrapiPaginationArg>;
  publicationState?: InputMaybe<StrapiPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type StrapiZespolMedycznylocalizationsArgs = {
  publicationState?: InputMaybe<StrapiPublicationState>;
};

export type StrapiZespolMedycznyEntity = {
  __typename?: 'StrapiZespolMedycznyEntity';
  attributes?: Maybe<StrapiZespolMedyczny>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type StrapiZespolMedycznyEntityResponse = {
  __typename?: 'StrapiZespolMedycznyEntityResponse';
  data?: Maybe<StrapiZespolMedycznyEntity>;
};

export type StrapiZespolMedycznyInput = {
  checkListItems?: InputMaybe<StrapiComponentListCheckListInput>;
  checkedListHeaderSection?: InputMaybe<StrapiComponentDynamicblocksHeaderSectionInput>;
  checkedListItems?: InputMaybe<StrapiComponentDynamicblocksCheckedListInput>;
  ctaBanner?: InputMaybe<StrapiComponentBlocksCtaBannerInput>;
  default_doctor_group?: InputMaybe<Scalars['ID']['input']>;
  doctorOpinionTitle?: InputMaybe<Scalars['String']['input']>;
  doctorTeamTitle?: InputMaybe<Scalars['String']['input']>;
  doctorVideoHero?: InputMaybe<StrapiComponentBlocksVideoHeroInput>;
  doctor_groups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  doctors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  heroImageBanner?: InputMaybe<StrapiComponentBlocksHeroImageInput>;
  promoClip?: InputMaybe<StrapiComponentMediaPromoClipInput>;
  publishedAt?: InputMaybe<Scalars['StrapiDateTime']['input']>;
  threeIconBanner?: InputMaybe<StrapiComponentBlocksThreeIconBannerInput>;
  threeIconBannerTitle?: InputMaybe<Scalars['String']['input']>;
  threeIconsBanner?: InputMaybe<StrapiComponentDynamicblocksThreeIconsItemsInput>;
  threeIconsHeaderSection?: InputMaybe<StrapiComponentDynamicblocksHeaderSectionInput>;
  videoBanner?: InputMaybe<StrapiComponentBlocksVideoBannerInput>;
};

export type StrapiZespolMedycznyRelationResponseCollection = {
  __typename?: 'StrapiZespolMedycznyRelationResponseCollection';
  data: Array<StrapiZespolMedycznyEntity>;
};

export type Subscription = {
  __typename?: 'Subscription';
  doctorHandleMessagesUpdates: DoctorMSChatMessagesUpdateEvent;
  patientHandleMessagesUpdates: PatientMSChatMessagesUpdateEvent;
  /**
   * Look up subscription event.
   *
   * Added in Saleor 3.2.
   */
  saleorEvent?: Maybe<SaleorEvent>;
};


export type SubscriptiondoctorHandleMessagesUpdatesArgs = {
  patientId: Scalars['String']['input'];
};


export type SubscriptionpatientHandleMessagesUpdatesArgs = {
  patientId: Scalars['String']['input'];
};

export type ZusGetPayerDataResponse = {
  __typename?: 'ZusGetPayerDataResponse';
  payerData: ZusPayerData;
  result: ZusZusResult;
};

export type ZusPayerData = {
  __typename?: 'ZusPayerData';
  firstName?: Maybe<Scalars['String']['output']>;
  hasPueProfile: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ZusZusResult = {
  __typename?: 'ZusZusResult';
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

export type DoctorRequestedDrugFragment = { __typename: 'DoctorMSRequestedDrugDto', ean: string, quantity: number, resolvedInPrescriptions?: Array<{ __typename?: 'DoctorMSPrescription', id: string }> | null, regularDrugSourceTag?: { __typename?: 'DoctorMSPatientTagEntity', id: string, data: any, type: DoctorMSPatientTagType, createdAt: string, patientId: string, updatedAt: any, confirmationType?: DoctorMSConfirmationType | null, expirationAt?: any | null } | null, details: { __typename?: 'DoctorMSDrugDetails', name: string, box: string, ean: string, form: string, dosage: string, productCharacteristics?: string | null, use?: string | null, composition?: string | null, effect?: string | null, indications?: string | null, contraindications?: string | null, comments?: string | null, precautions?: string | null, interactions?: string | null, pregnantWomenInstructions?: string | null, hasPsychoSubstances: boolean, isCustom: boolean, additionalRefunds: Array<DoctorMSAdditionalRefundRight>, pregnacyDetails: { __typename?: 'DoctorMSPregnacyDetails', entirePregnacy: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, firstTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, secondTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, thirdTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, lactation: { __typename?: 'DoctorMSKeyValue', key: string, value: string } }, activeSubstances: Array<{ __typename?: 'DoctorMSActiveSubstanceOfDrug', unitCode?: string | null, amountPerItem?: string | null, amountPerPackage?: string | null, name?: string | null, substanceId?: string | null }>, paymentLevels: Array<{ __typename?: 'DoctorMSPaymentDetails', value: string, price: string, description: string, detailedDescription: string, type: string, paymentKey: string }> } };

export type DoctorSourceTagFragment = { __typename?: 'DoctorMSPatientTagEntity', id: string, data: any, type: DoctorMSPatientTagType, createdAt: string, patientId: string, updatedAt: any, confirmationType?: DoctorMSConfirmationType | null, expirationAt?: any | null };

export type DoctorPatientGuardiansFragment = { __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null };

export type DoctorTemplateOfLabExamFragment = { __typename: 'DoctorMSLabExamTemplate', assignment: { __typename?: 'DoctorMSAssignmentEntity', name: string, foreignServiceId: string }, params?: Array<{ __typename: 'DoctorMSVitalParam', name: string, value: string, min: string, max: string, unit: string, text: string, icd9: string }> | null };

export type DoctorTemplateParamsFragment = { __typename: 'DoctorMSVitalParam', name: string, value: string, min: string, max: string, unit: string, text: string, icd9: string };

type DoctorInsuranceStatusFragment_DoctorMSInsuranceStatusEvent_Fragment = { __typename?: 'DoctorMSInsuranceStatusEvent', createdAt: any, status: { __typename?: 'DoctorMSEwusCheckEvent', createdAt: any, event: { __typename: 'DoctorMSEwusGreenEvent', createdAt: any, id: string } | { __typename: 'DoctorMSEwusRedEvent', createdAt: any, id: string } } | { __typename: 'DoctorMSInsuranceContributionCertificateEvent', createdAt: any, id: string } | { __typename: 'DoctorMSPatientInsuranceStatementEvent', createdAt: any, id: string, reason?: string | null } };

type DoctorInsuranceStatusFragment_DoctorMSUnknownEvent_Fragment = { __typename: 'DoctorMSUnknownEvent', createdAt: any, id: string };

export type DoctorInsuranceStatusFragmentFragment = DoctorInsuranceStatusFragment_DoctorMSInsuranceStatusEvent_Fragment | DoctorInsuranceStatusFragment_DoctorMSUnknownEvent_Fragment;

export type DoctorPatientWardsFragment = { __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null };

export type DoctorDeclarationSubmittedFragment = { __typename: 'DoctorMSDeclarationSubmittedEvent', id: string, createdAt: any, vojevodship: DoctorMSOrganizationIdVojevodship, source: DoctorMSDeclarationSource, marketingSource: DoctorMSDeclarationMarketingSource, comment: string, date: any, files: Array<string>, filename: string, signature: string, isElectronicallySigned: boolean, declarationUploadStaff?: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null } | null, declarationGenerationParams: { __typename?: 'DoctorMSDeclarationGenerationParams', frequentFacilityChangeReason?: DoctorMSFrequentFacilityChangeReason | null, anotherProviderReason?: string | null }, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, isDeclarable?: boolean | null, adultDeclarable: boolean, childrenDeclarable: boolean, genre: DoctorMSUserGenre, npwz?: string | null } };

export type EdmMedicalAppShiftWithoutVisitFragment = { __typename: 'EdmMedicalAppShift', id: string, organizationId: string, day: any, startFrom: any, endedAt: any, comment?: string | null, state: EdmMedicalAppShiftState, status: EdmMedicalAppShiftStatus, workPlace: EdmMedicalAppShiftWorkPlace, visitTypes: Array<EdmMedicalAppVisitType>, confirmed: boolean, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, acceptAdults: boolean, acceptChildren: boolean, adultDeclarable: boolean, childrenDeclarable: boolean }, createdBy: { __typename?: 'EdmMedicalPerson', name?: string | null }, durationTimeMap: { __typename?: 'EdmDurationTimeMap', IN_PERSON: number, TELEMEDICAL: number, DOCTOR_TELEMEDICAL_INFECTION: number, NURSE_IN_PERSON_INFECTION: number, PROCEDURE: number, COLLECTION: number, RADIOLOGY_APPOINTMENT: number, SPECIALIST: number, SICK_CHILDREN: number, PRESCRIPTION_APPOINTMENT: number, EXPRESS_APPOINTMENT: number, DOCTOR_HOUSE_CALL: number, NURSE_HOUSE_CALL: number, MIDWIFE_HOUSE_CALL: number, MIDWIFE_IN_PERSON: number, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE: number, HEALTHY_CHILDREN_CHECKUP: number, HEALTHY_CHILDREN_VACCINE: number, HEALTHY_CHILDREN_PATRONAGE: number, NURSE_IN_PERSON: number, NURSE_HEALTHY_CHILDREN?: number | null } };

export type DoctorUpdatePatientMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSPatientInput;
}>;


export type DoctorUpdatePatientMutation = { __typename?: 'Mutation', doctorUpdatePatient: string };

export type DoctorDeletePatientMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type DoctorDeletePatientMutation = { __typename?: 'Mutation', doctorDeletePatient: string };

export type DoctorUpdateVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSVisitInput;
}>;


export type DoctorUpdateVisitMutation = { __typename?: 'Mutation', doctorUpdateVisit: string };

export type DoctorCreateDocumentMutationVariables = Exact<{
  input: DoctorMSCreateDocumentInput;
}>;


export type DoctorCreateDocumentMutation = { __typename?: 'Mutation', doctorCreateDocument: { __typename?: 'DoctorMSMedicalRecordEntity', id: string } };

export type DoctorUpdateDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSUpdateDocumentInput;
}>;


export type DoctorUpdateDocumentMutation = { __typename?: 'Mutation', doctorUpdateDocument: string };

export type DoctorArchiveDocumentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorArchiveDocumentMutation = { __typename?: 'Mutation', doctorArchiveDocument: string };

export type DoctorChangePasswordMutationVariables = Exact<{
  input: DoctorMSChangePasswordInput;
}>;


export type DoctorChangePasswordMutation = { __typename?: 'Mutation', doctorChangePassword: string };

export type DoctorMarkPostsAsSeenMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DoctorMarkPostsAsSeenMutation = { __typename?: 'Mutation', doctorMarkPostsAsSeen: Array<string> };

export type DoctorUpdateMeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSDoctorInput;
}>;


export type DoctorUpdateMeMutation = { __typename?: 'Mutation', doctorUpdateMe: string };

export type DoctorShowSnippetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  doctorId: Scalars['String']['input'];
}>;


export type DoctorShowSnippetMutation = { __typename?: 'Mutation', doctorShowSnippet: { __typename?: 'DoctorMSDoctor', id: string } };

export type DoctorIssueReferralMutationVariables = Exact<{
  input: DoctorMSIssueReferralInput;
}>;


export type DoctorIssueReferralMutation = { __typename?: 'Mutation', doctorIssueReferral: string };

export type DoctorUpdateVitalMutationVariables = Exact<{
  id: Scalars['String']['input'];
  specificInput: Scalars['DoctorMSJSON']['input'];
}>;


export type DoctorUpdateVitalMutation = { __typename?: 'Mutation', doctorUpdateVital: string };

export type DoctorCreateChatMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSChatMessageInput;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DoctorCreateChatMessageMutation = { __typename?: 'Mutation', doctorCreateChatMessage: string };

export type DoctorDeleteChatMessageMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeleteChatMessageMutation = { __typename?: 'Mutation', doctorDeleteChatMessage: string };

export type DoctorGetContentFromImageMutationVariables = Exact<{
  input: DoctorMSOCRImageInput;
}>;


export type DoctorGetContentFromImageMutation = { __typename?: 'Mutation', doctorGetContentFromImage: string };

export type DoctorCreateSurveyMutationVariables = Exact<{
  input: DoctorMSSurveyProposalInput;
}>;


export type DoctorCreateSurveyMutation = { __typename?: 'Mutation', doctorCreateSurvey: string };

export type DoctorIssuePrescriptionMutationVariables = Exact<{
  input: DoctorMSIssuePrescriptionInput;
}>;


export type DoctorIssuePrescriptionMutation = { __typename?: 'Mutation', doctorIssuePrescription: { __typename?: 'DoctorMSIssuePrescriptionWithOperationResult', operationIsSafe: boolean, prescriptions: Array<{ __typename?: 'DoctorMSPrescriptionResult', messageId: string, prescriptionCode: string }> } };

export type DoctorIssueNursePrescriptionMutationVariables = Exact<{
  input: DoctorMSIssuePrescriptionInput;
}>;


export type DoctorIssueNursePrescriptionMutation = { __typename?: 'Mutation', doctorIssueNursePrescription: { __typename?: 'DoctorMSIssuePrescriptionWithOperationResult', operationIsSafe: boolean, prescriptions: Array<{ __typename?: 'DoctorMSPrescriptionResult', messageId: string, prescriptionCode: string }> } };

export type DoctorGenerateTestimonialMutationVariables = Exact<{
  request: DoctorMSTestimonialGenerationInput;
}>;


export type DoctorGenerateTestimonialMutation = { __typename?: 'Mutation', doctorGenerateTestimonial: { __typename?: 'DoctorMSDocumentGenerationResult', documentId: string, fileUrl: string } };

export type DoctorCreateVisitMutationVariables = Exact<{
  input: DoctorMSNewVisitInput;
}>;


export type DoctorCreateVisitMutation = { __typename?: 'Mutation', doctorCreateVisit: string };

export type DoctorCreateVisitSlotMutationVariables = Exact<{
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  shiftVisitType: DoctorMSPShiftVisitType;
  shiftsSlot: Array<DoctorMSShiftsSlot> | DoctorMSShiftsSlot;
  patientId: Scalars['String']['input'];
}>;


export type DoctorCreateVisitSlotMutation = { __typename?: 'Mutation', doctorCreateVisitSlot2: string };

export type DoctorHideSnippetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSDoctorInput;
}>;


export type DoctorHideSnippetMutation = { __typename?: 'Mutation', doctorUpdateMe: string };

export type DoctorUpdateSnippetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSSnippetInput;
}>;


export type DoctorUpdateSnippetMutation = { __typename?: 'Mutation', doctorUpdateSnippet: { __typename?: 'DoctorMSSnippet', id: string } };

export type DoctorDeleteSnippetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeleteSnippetMutation = { __typename?: 'Mutation', doctorDeleteSnippet: { __typename?: 'DoctorMSSnippet', id: string } };

export type DoctorCreateSnippetMutationVariables = Exact<{
  input: DoctorMSSnippetInput;
}>;


export type DoctorCreateSnippetMutation = { __typename?: 'Mutation', doctorCreateSnippet: { __typename?: 'DoctorMSSnippet', id: string } };

export type DoctorCreateAssignmentMutationVariables = Exact<{
  input: DoctorMSPrescriptionInput;
}>;


export type DoctorCreateAssignmentMutation = { __typename?: 'Mutation', doctorCreateAssignment: string };

export type DoctorCreateIpomAssignmentMutationVariables = Exact<{
  input: DoctorMSIpomProcedureAssignmentInput;
}>;


export type DoctorCreateIpomAssignmentMutation = { __typename?: 'Mutation', doctorCreateIpomAssignment: string };

export type DoctorCreatePatientTagMutationVariables = Exact<{
  input: DoctorMSPatientTagInput;
  fileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DoctorCreatePatientTagMutation = { __typename?: 'Mutation', doctorCreatePatientTag: string };

export type DoctorUpdatePatientTagMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSPatientTagInput;
  fileIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DoctorUpdatePatientTagMutation = { __typename?: 'Mutation', doctorUpdatePatientTag: string };

export type DoctorDeletePatientTagMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeletePatientTagMutation = { __typename?: 'Mutation', doctorDeletePatientTag: string };

export type DoctorCreateProcedureMutationVariables = Exact<{
  data: DoctorMSCreateProcedureInput;
  dataInput: Scalars['DoctorMSJSONObject']['input'];
}>;


export type DoctorCreateProcedureMutation = { __typename?: 'Mutation', doctorCreateProcedureNew: { __typename?: 'DoctorMSProcedureEntity', id: string } };

export type DoctorUpdateProcedureMutationVariables = Exact<{
  procedureId: Scalars['String']['input'];
  data?: InputMaybe<DoctorMSUpdateProcedureInput>;
  dataInput: Scalars['DoctorMSJSONObject']['input'];
}>;


export type DoctorUpdateProcedureMutation = { __typename?: 'Mutation', doctorUpdateProcedureNew: string };

export type DoctorUpdateLaboratoryExaminationMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  data: DoctorMSLaboratoryExaminationUpdateDataInput;
}>;


export type DoctorUpdateLaboratoryExaminationMutation = { __typename?: 'Mutation', doctorUpdateLaboratoryExaminations: Array<string> };

export type DoctorCreateLaboratoryExaminationsMutationVariables = Exact<{
  data: Array<DoctorMSLaboratoryExaminationCreationInput> | DoctorMSLaboratoryExaminationCreationInput;
  createMessageOnChat?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DoctorCreateLaboratoryExaminationsMutation = { __typename?: 'Mutation', doctorCreateLaboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', id: string }> };

export type DoctorUnpinProcedureMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorUnpinProcedureMutation = { __typename?: 'Mutation', doctorUnpinProcedure: { __typename?: 'DoctorMSProcedureEntity', id: string } };

export type DoctorDeleteVitalMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeleteVitalMutation = { __typename?: 'Mutation', doctorDeleteVital: string };

export type DoctorSendInvitationForAVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type: DoctorMSVisitType;
}>;


export type DoctorSendInvitationForAVisitMutation = { __typename?: 'Mutation', doctorSendInvitationForVisit: string };

export type DoctorCloseVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorCloseVisitMutation = { __typename?: 'Mutation', doctorCloseVisit: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorUnpinPatientMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorUnpinPatientMutation = { __typename?: 'Mutation', doctorUnpinPatient: { __typename?: 'DoctorMSPatient', id: string } };

export type DoctorClosePatientMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorClosePatientMutation = { __typename?: 'Mutation', doctorClosePatient: { __typename?: 'DoctorMSPatient', id: string } };

export type DoctorWaitingForPatientMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorWaitingForPatientMutation = { __typename?: 'Mutation', doctorWaitingForPatient: { __typename?: 'DoctorMSPatient', id: string } };

export type DoctorDeleteVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeleteVisitMutation = { __typename?: 'Mutation', doctorDeleteVisit2: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorStartVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorStartVisitMutation = { __typename?: 'Mutation', doctorStartVisit: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorPatientLeftVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorPatientLeftVisitMutation = { __typename?: 'Mutation', doctorPatientLeftVisit: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorUnpinAllPatientsMutationVariables = Exact<{ [key: string]: never; }>;


export type DoctorUnpinAllPatientsMutation = { __typename?: 'Mutation', doctorUnpinAllPatients: number };

export type DoctorCreatePatientMutationVariables = Exact<{
  phone: Scalars['String']['input'];
  pesel: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  address: DoctorMSPlacematicAddressInput;
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  languages: Array<DoctorMSSupportedLanguage> | DoctorMSSupportedLanguage;
}>;


export type DoctorCreatePatientMutation = { __typename?: 'Mutation', doctorCreatePatient: string };

export type DoctorRevokeAssignmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorRevokeAssignmentMutation = { __typename?: 'Mutation', doctorRevokeAssignment: string };

export type DoctorCreateVitalMutationVariables = Exact<{
  input: DoctorMSVitalInput;
  specificInput: Scalars['DoctorMSJSON']['input'];
}>;


export type DoctorCreateVitalMutation = { __typename?: 'Mutation', doctorCreateVital: string };

export type DoctorUpdateVisitSlotMutationVariables = Exact<{
  id: Scalars['String']['input'];
  visitType: DoctorMSPShiftVisitType;
  shiftsSlot: Array<DoctorMSShiftsSlot> | DoctorMSShiftsSlot;
}>;


export type DoctorUpdateVisitSlotMutation = { __typename?: 'Mutation', doctorUpdateVisitSlot2ForMedicalApp: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorForceEditVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: DoctorMSForceVisitInput2;
}>;


export type DoctorForceEditVisitMutation = { __typename?: 'Mutation', doctorForceVisit2: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorForceCreateVisitMutationVariables = Exact<{
  patientId: Scalars['String']['input'];
  input: DoctorMSForceVisitInput2;
}>;


export type DoctorForceCreateVisitMutation = { __typename?: 'Mutation', doctorForceCreateVisit2: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorPatientShowedUpForAVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorPatientShowedUpForAVisitMutation = { __typename?: 'Mutation', doctorPatientShowedUpForAVisit: { __typename?: 'DoctorMSVisit', id: string } };

export type DoctorUpdateUserAddressMutationVariables = Exact<{
  flatNumber?: InputMaybe<Scalars['String']['input']>;
  address: DoctorMSPlacematicAddressInput;
  id: Scalars['String']['input'];
}>;


export type DoctorUpdateUserAddressMutation = { __typename?: 'Mutation', doctorUpdateUserAddress: { __typename?: 'DoctorMSPatient', id: string } };

export type DoctorReopenVisitMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorReopenVisitMutation = { __typename?: 'Mutation', doctorReopenVisit: string };

export type DoctorSaveHealthInsuranceStatementMutationVariables = Exact<{
  patientId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  data: DoctorMSNFZEventData;
  executionDate?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
}>;


export type DoctorSaveHealthInsuranceStatementMutation = { __typename?: 'Mutation', doctorSaveHealthInsuranceStatement: string };

export type DoctorCreateNFZEventMutationVariables = Exact<{
  input: DoctorMSNFZEventInput;
}>;


export type DoctorCreateNFZEventMutation = { __typename?: 'Mutation', doctorCreateNFZEvent: string };

export type DoctorDeleteNFZEventMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorDeleteNFZEventMutation = { __typename?: 'Mutation', doctorDeleteNFZEvent: string };

export type DoctorSendRecommendationMutationVariables = Exact<{
  visitId: Scalars['String']['input'];
}>;


export type DoctorSendRecommendationMutation = { __typename?: 'Mutation', doctorSendRecommendation: { __typename?: 'DoctorMSChatMessageEntity', id: string, content: string } };

export type DoctorCheckPatientEwusStatusMutationVariables = Exact<{
  patientId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type DoctorCheckPatientEwusStatusMutation = { __typename?: 'Mutation', doctorCheckPatientEwusStatus: string };

export type DoctorRefreshTokenMutationVariables = Exact<{
  data: DoctorMSRTPayload;
}>;


export type DoctorRefreshTokenMutation = { __typename?: 'Mutation', doctorRefreshToken: { __typename?: 'DoctorMSTokensPayload', jwt?: string | null, refreshToken?: string | null } };

export type DoctorGenerateDeclarationPdfMutationVariables = Exact<{
  input: DoctorMSNfzDeclarationInputDoctor;
  representativeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGenerateDeclarationPdfMutation = { __typename?: 'Mutation', doctorGenerateDeclaration: { __typename?: 'DoctorMSDocumentGenerationResult', documentId: string, fileUrl: string } };

export type DoctorPublishTestingExaminationResultsMutationVariables = Exact<{
  labExam: DoctorMSLabExamInput;
  visitId: Scalars['String']['input'];
}>;


export type DoctorPublishTestingExaminationResultsMutation = { __typename?: 'Mutation', doctorSimulateLabExamUpload: boolean };

export type DoctorAddDeclarationScanToNFZEventMutationVariables = Exact<{
  declarationScanFileId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type DoctorAddDeclarationScanToNFZEventMutation = { __typename?: 'Mutation', doctorAddDeclarationScanToNFZEvent: string, doctorUpdateDeclarationNFZEventComment: string };

export type DoctorGenerateUsgResultsDocumentMutationVariables = Exact<{
  procedureId: Scalars['String']['input'];
}>;


export type DoctorGenerateUsgResultsDocumentMutation = { __typename?: 'Mutation', doctorGenerateUsgResultsDocument: { __typename?: 'DoctorMSDocumentGenerationResult', fileUrl: string } };

export type DoctorLogPaymentMutationVariables = Exact<{
  paidIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  paymentMethod: DoctorMSPaymentLogEntryInput;
}>;


export type DoctorLogPaymentMutation = { __typename?: 'Mutation', doctorLogPayment: string };

export type LoadUMXMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  umxContent: Scalars['String']['input'];
}>;


export type LoadUMXMutation = { __typename?: 'Mutation', doctorLoadUMX: string };

export type ReportPrepareMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  declarationGenre: Scalars['String']['input'];
  realRun: Scalars['Boolean']['input'];
}>;


export type ReportPrepareMutation = { __typename?: 'Mutation', doctorReportPrepare: string };

export type SwiadPrepareMutationVariables = Exact<{
  realRun: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type SwiadPrepareMutation = { __typename?: 'Mutation', doctorSwiadPrepare: string };

export type ReportCleanMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type ReportCleanMutation = { __typename?: 'Mutation', doctorCleanReports: string };

export type DoctorUpsertSingleProcedureMutationVariables = Exact<{
  visitId: Scalars['String']['input'];
  data: Scalars['String']['input'];
  procedureType?: InputMaybe<DoctorMSProcedureType>;
}>;


export type DoctorUpsertSingleProcedureMutation = { __typename?: 'Mutation', doctorUpsertSingleProcedure: string };

export type DoctorCreateIpomMutationVariables = Exact<{
  input: DoctorMSCreateIpomInput;
}>;


export type DoctorCreateIpomMutation = { __typename?: 'Mutation', doctorCreateIPOM: { __typename?: 'DoctorMSCreateIPOMWithOperationResult', ipomCode: string } };

export type DoctorGenerateIpomPdfDocumentMutationVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorGenerateIpomPdfDocumentMutation = { __typename?: 'Mutation', doctorGenerateIpomPdfDocument: { __typename?: 'DoctorMSDocumentGenerationResult', fileUrl: string, documentId: string } };

export type EdmUpdateSnippetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: EdmUpdateSnippetInput;
}>;


export type EdmUpdateSnippetMutation = { __typename?: 'Mutation', edmUpdateSnippet: { __typename?: 'EdmSnippet', id: string } };

export type EdmCreateSnippetMutationVariables = Exact<{
  input: EdmCreateSnippetInput;
}>;


export type EdmCreateSnippetMutation = { __typename?: 'Mutation', edmCreateSnippet: { __typename?: 'EdmSnippet', id: string } };

export type EdmDeleteSnippetByIdMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EdmDeleteSnippetByIdMutation = { __typename?: 'Mutation', edmDeleteSnippetById: { __typename?: 'EdmResultResponse', success: boolean } };

export type EdmIncreaseSnippetCounterMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EdmIncreaseSnippetCounterMutation = { __typename?: 'Mutation', edmIncreaseSnippetCounter: { __typename?: 'EdmResultResponse', success: boolean } };

export type DoctorIssueMedicalLeaveMutationVariables = Exact<{
  input: DoctorMSMedicalLeaveInput;
  id: Scalars['String']['input'];
}>;


export type DoctorIssueMedicalLeaveMutation = { __typename?: 'Mutation', doctorIssueMedicalLeave: string };

export type DoctorIssueMedicalLeave2MutationVariables = Exact<{
  input: DoctorMSMedicalLeaveInputNew;
}>;


export type DoctorIssueMedicalLeave2Mutation = { __typename?: 'Mutation', doctorIssueMedicalLeaveNew: { __typename?: 'DoctorMSIssueMedicalOrCareLeaveResult', messageId: string, leaves: Array<{ __typename?: 'DoctorMSLeavesResult', seriesNumber: string, ids: Array<string> }> } };

export type DoctorIssueMedicalCareLeaveMutationVariables = Exact<{
  input: DoctorMSCareLeaveInput;
}>;


export type DoctorIssueMedicalCareLeaveMutation = { __typename?: 'Mutation', doctorIssueCareLeave: { __typename?: 'DoctorMSIssueMedicalOrCareLeaveResult', messageId: string, leaves: Array<{ __typename?: 'DoctorMSLeavesResult', seriesNumber: string, ids: Array<string> }> } };

export type EdmCreateShiftMutationVariables = Exact<{
  input: EdmCreateShiftInput;
}>;


export type EdmCreateShiftMutation = { __typename?: 'Mutation', edmCreateShift: { __typename?: 'EdmMedicalAppShift', id: string, organizationId: string, day: any, startFrom: any, endedAt: any, comment?: string | null, staff: { __typename?: 'EdmMedicalPerson', id: string } } };

export type EdmCreateShiftsBulkMutationVariables = Exact<{
  input: EdmCreateShiftBulkInput;
}>;


export type EdmCreateShiftsBulkMutation = { __typename?: 'Mutation', edmCreateShiftsBulk: { __typename?: 'EdmShiftBulk', erroredDays: Array<any>, shifts: Array<{ __typename?: 'EdmMedicalAppShift', id: string, organizationId: string, day: any, startFrom: any, endedAt: any, comment?: string | null, staff: { __typename?: 'EdmMedicalPerson', id: string } }> } };

export type EdmCreateNonWorkingPeriodMutationVariables = Exact<{
  input: EdmCreateNonWorkingPeriodInput;
}>;


export type EdmCreateNonWorkingPeriodMutation = { __typename?: 'Mutation', edmCreateNonWorkingPeriod: { __typename?: 'EdmNonWorkingPeriod', id: string, day: any, startFrom: any, endedAt: any, leaveType: EdmLeaveType, comment?: string | null, staff: { __typename?: 'EdmMedicalPerson', id: string } } };

export type EdmDefineWorkingHoursMutationVariables = Exact<{
  input: EdmDefineWorkingHoursInput;
}>;


export type EdmDefineWorkingHoursMutation = { __typename?: 'Mutation', edmDefineWorkingHours: { __typename?: 'EdmWorkingHours', staffId: string, month: any, expectedWorkingHours: { __typename?: 'EdmExpectedWorkingHours', hours: number, minutes: number } } };

export type EdmDeleteShiftMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EdmDeleteShiftMutation = { __typename?: 'Mutation', edmDeleteShift: { __typename?: 'EdmMedicalAppShift', id: string } };

export type EdmDeleteNonWorkingPeriodMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EdmDeleteNonWorkingPeriodMutation = { __typename?: 'Mutation', edmDeleteNonWorkingPeriod: { __typename?: 'EdmResultResponse', success: boolean } };

export type EdmDeleteWorkingHoursMutationVariables = Exact<{
  input: EdmDeleteWorkingHoursInput;
}>;


export type EdmDeleteWorkingHoursMutation = { __typename?: 'Mutation', edmDeleteWorkingHours: { __typename?: 'EdmResultResponse', success: boolean } };

export type EdmRestoreShiftMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EdmRestoreShiftMutation = { __typename?: 'Mutation', edmPublishShift: { __typename?: 'EdmMedicalAppShift', id: string } };

export type EdmPublishShiftsMutationVariables = Exact<{
  input: EdmPublishShiftsInput;
}>;


export type EdmPublishShiftsMutation = { __typename?: 'Mutation', edmPublishShifts: Array<{ __typename: 'EdmMedicalAppShift', id: string, organizationId: string, day: any, startFrom: any, endedAt: any, comment?: string | null, state: EdmMedicalAppShiftState, status: EdmMedicalAppShiftStatus, workPlace: EdmMedicalAppShiftWorkPlace, visitTypes: Array<EdmMedicalAppVisitType>, confirmed: boolean, visits: Array<{ __typename: 'EdmClinicManagerVisit', id: string, referenceOldVisitId: string, shiftId?: string | null, state: string, type: string, patientId: string, staffId: string, estimatedDurationTime: number, createdAt: any, scheduledOn: any, organizationId: string, cancelledAt?: any | null, cancelledReason?: string | null, startedAt?: any | null, closedAt?: any | null, patientLeftAt?: any | null, cancellationComment?: string | null, patient: { __typename?: 'EdmPatient', id: string, firstName: string, lastName: string, patientCardNumber: string, pesel: string, phone?: string | null }, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, acceptAdults: boolean, acceptChildren: boolean, adultDeclarable: boolean, childrenDeclarable: boolean } }>, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, acceptAdults: boolean, acceptChildren: boolean, adultDeclarable: boolean, childrenDeclarable: boolean }, createdBy: { __typename?: 'EdmMedicalPerson', name?: string | null }, durationTimeMap: { __typename?: 'EdmDurationTimeMap', IN_PERSON: number, TELEMEDICAL: number, DOCTOR_TELEMEDICAL_INFECTION: number, NURSE_IN_PERSON_INFECTION: number, PROCEDURE: number, COLLECTION: number, RADIOLOGY_APPOINTMENT: number, SPECIALIST: number, SICK_CHILDREN: number, PRESCRIPTION_APPOINTMENT: number, EXPRESS_APPOINTMENT: number, DOCTOR_HOUSE_CALL: number, NURSE_HOUSE_CALL: number, MIDWIFE_HOUSE_CALL: number, MIDWIFE_IN_PERSON: number, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE: number, HEALTHY_CHILDREN_CHECKUP: number, HEALTHY_CHILDREN_VACCINE: number, HEALTHY_CHILDREN_PATRONAGE: number, NURSE_IN_PERSON: number, NURSE_HEALTHY_CHILDREN?: number | null } }> };

export type EdmConfirmShiftsMutationVariables = Exact<{
  input: EdmShiftsConfirmationInput;
}>;


export type EdmConfirmShiftsMutation = { __typename?: 'Mutation', edmConfirmShifts: Array<{ __typename?: 'EdmMedicalAppShift', id: string }> };

export type EdmCancelShiftsConfirmationMutationVariables = Exact<{
  input: EdmShiftsConfirmationInput;
}>;


export type EdmCancelShiftsConfirmationMutation = { __typename?: 'Mutation', edmCancelShiftsConfirmation: Array<{ __typename?: 'EdmMedicalAppShift', id: string }> };

export type EdmUpdateStaffVisitDurationMutationVariables = Exact<{
  staffId: Scalars['String']['input'];
  input: EdmUpdateStaffVisitDurationInput;
}>;


export type EdmUpdateStaffVisitDurationMutation = { __typename?: 'Mutation', edmUpdateStaffVisitDuration: { __typename?: 'EdmVisitTimeDuration', IN_PERSON?: number | null, TELEMEDICAL?: number | null, DOCTOR_TELEMEDICAL_INFECTION?: number | null, NURSE_IN_PERSON_INFECTION?: number | null, PROCEDURE?: number | null, COLLECTION?: number | null, RADIOLOGY_APPOINTMENT?: number | null, SPECIALIST?: number | null, PRESCRIPTION_APPOINTMENT?: number | null, EXPRESS_APPOINTMENT?: number | null, DOCTOR_HOUSE_CALL?: number | null, NURSE_HOUSE_CALL?: number | null, MIDWIFE_HOUSE_CALL?: number | null, MIDWIFE_IN_PERSON?: number | null, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE?: number | null, HEALTHY_CHILDREN_CHECKUP?: number | null, HEALTHY_CHILDREN_VACCINE?: number | null, HEALTHY_CHILDREN_PATRONAGE?: number | null, NURSE_IN_PERSON?: number | null, NURSE_HEALTHY_CHILDREN?: number | null } };

export type EdmUpdateDeclarationsMutationVariables = Exact<{
  staffId: Scalars['String']['input'];
  input: EdmUpdateDeclarationInput;
}>;


export type EdmUpdateDeclarationsMutation = { __typename?: 'Mutation', edmUpdateDeclarations: { __typename?: 'EdmResultResponse', success: boolean } };

export type EdmUpdatePreferencesMutationVariables = Exact<{
  staffId: Scalars['String']['input'];
  input: EdmUpdatePreferencesInput;
}>;


export type EdmUpdatePreferencesMutation = { __typename?: 'Mutation', edmUpdatePreferences: { __typename?: 'EdmResultResponse', success: boolean } };

export type DoctorGetPatientsQueryVariables = Exact<{
  fullText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DoctorGetPatientsQuery = { __typename?: 'Query', doctorPatients: Array<{ __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, pesel?: string | null, phone: string, assistantId?: string | null, patientCardNumber: string, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string }, address?: { __typename?: 'DoctorMSFullAddress', street: string, city: string, zipCode: string, houseNumber: string, flatNumber?: string | null } | null }> };

export type DoctorGetPatientQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetPatientQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, pesel?: string | null, phone: string, smokeLevel?: number | null, weight?: number | null, height?: number | null, assistantId?: string | null, patientCardNumber: string, actionRequired?: string | null, locale: string, immunizationStatus: number, nfzStatus: { __typename?: 'DoctorMSObjectedNFZStatus', textStatus?: string | null, declaredIn?: string | null, wasDeclared: boolean, canUsePublicVisits: boolean, whereCanDeclare?: string | null, canDeclare: boolean, comment?: string | null, chosenDoctor?: string | null, chosenNurse?: string | null, chosenMidwife?: string | null }, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, lastPatientMessageBlock?: { __typename?: 'DoctorMSTime', iso: string } | null, messages: Array<{ __typename?: 'DoctorMSAssignment', type: DoctorMSMessageType, paid?: boolean | null, id: string, status?: DoctorMSAssignmentStatus | null, assignmentType: string, data?: any | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, positions?: Array<{ __typename?: 'DoctorMSPosition', serviceId?: string | null, serviceName?: string | null } | null> | null, patient: { __typename?: 'DoctorMSPatient', firstName?: string | null, lastName?: string | null, id: string, pesel?: string | null, assistantId?: string | null, patientCardNumber: string } } | { __typename?: 'DoctorMSCareleave' } | { __typename?: 'DoctorMSIpom' } | { __typename?: 'DoctorMSLeave' } | { __typename?: 'DoctorMSPrescription' } | { __typename?: 'DoctorMSReferral' } | { __typename?: 'DoctorMSTestimonial' }>, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string }, visits: Array<{ __typename?: 'DoctorMSVisit', id: string, type?: DoctorMSVisitType | null, status: DoctorMSVisitStatus, duration?: number | null, createdBy?: string | null, recommendationsMessageId?: string | null, plannedPlace?: string | null, showOn?: string | null, recommendationsMessage?: { __typename?: 'DoctorMSChatMessageEntity', id: string } | null, invitationSentAt?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null }>, address?: { __typename?: 'DoctorMSFullAddress', city: string, street: string, zipCode: string, flatNumber?: string | null, houseNumber: string, latitude?: number | null, longitude?: number | null } | null } | null };

export type DoctorGetDoctorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorGetDoctorQuery = { __typename?: 'Query', doctorDoctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, npwz?: string | null, isDeclarable?: boolean | null } | null };

export type DoctorGetDoctorsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  showBlocked?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DoctorGetDoctorsQuery = { __typename?: 'Query', doctorDoctors: Array<{ __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, npwz?: string | null, isDeclarable?: boolean | null, adultDeclarable: boolean, childrenDeclarable: boolean, declaringToOrganizationId?: string | null, childrenAvailable?: boolean | null }> };

export type DoctorVisitQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorVisitQuery = { __typename?: 'Query', doctorVisit: { __typename?: 'DoctorMSVisit', id: string, availableImaginingOrganizationId: string, status: DoctorMSVisitStatus, snapshotAt?: string | null, snapshotBy?: string | null, doctorId?: string | null, weight?: number | null, height?: number | null, smokeLevel?: number | null, type?: DoctorMSVisitType | null, slotType?: string | null, additionalMedicalService?: Array<string> | null, primaryMedicalService?: DoctorMSPrimaryMedicalService | null, memo?: string | null, prescriptionRequestId?: string | null, determineIpomEligibility: boolean, recommendationsMessageId?: string | null, isPublicVisit: boolean, leftOn?: string | null, organizationId?: string | null, doctorInterview?: string | null, physicalExamination?: string | null, innatePriority: DoctorMSVisitPriority, recommendation?: string | null, comment?: string | null, closedByBot?: boolean | null, startOn?: string | null, showOn?: string | null, createdBy?: string | null, duration?: number | null, preInterview?: Array<{ __typename?: 'DoctorMSLlmChatMessage', content: string, role: string }> | null, prescriptionRequest?: { __typename?: 'DoctorMSPrescriptionRequestDto', id: string, solvedOn?: any | null, recommendations?: string | null, requestedDrugs: Array<{ __typename: 'DoctorMSRequestedDrugDto', ean: string, quantity: number, resolvedInPrescriptions?: Array<{ __typename?: 'DoctorMSPrescription', id: string }> | null, regularDrugSourceTag?: { __typename?: 'DoctorMSPatientTagEntity', id: string, data: any, type: DoctorMSPatientTagType, createdAt: string, patientId: string, updatedAt: any, confirmationType?: DoctorMSConfirmationType | null, expirationAt?: any | null } | null, details: { __typename?: 'DoctorMSDrugDetails', name: string, box: string, ean: string, form: string, dosage: string, productCharacteristics?: string | null, use?: string | null, composition?: string | null, effect?: string | null, indications?: string | null, contraindications?: string | null, comments?: string | null, precautions?: string | null, interactions?: string | null, pregnantWomenInstructions?: string | null, hasPsychoSubstances: boolean, isCustom: boolean, additionalRefunds: Array<DoctorMSAdditionalRefundRight>, pregnacyDetails: { __typename?: 'DoctorMSPregnacyDetails', entirePregnacy: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, firstTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, secondTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, thirdTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, lactation: { __typename?: 'DoctorMSKeyValue', key: string, value: string } }, activeSubstances: Array<{ __typename?: 'DoctorMSActiveSubstanceOfDrug', unitCode?: string | null, amountPerItem?: string | null, amountPerPackage?: string | null, name?: string | null, substanceId?: string | null }>, paymentLevels: Array<{ __typename?: 'DoctorMSPaymentDetails', value: string, price: string, description: string, detailedDescription: string, type: string, paymentKey: string }> } }> } | null, recommendationsMessage?: { __typename?: 'DoctorMSChatMessageEntity', id: string } | null, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, laboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', id: string }>, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', id: string, type: DoctorMSProcedureType }>, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, avatar: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, patient?: { __typename?: 'DoctorMSPatient', visitRecordingAndAnalysisAgreement?: boolean | null, id: string, firstName?: string | null, lastName?: string | null, phone: string, avatar: string, pesel?: string | null, smokeLevel?: number | null, weight?: number | null, height?: number | null, assistantId?: string | null, patientCardNumber: string, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, guardians: Array<{ __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null }>, address?: { __typename?: 'DoctorMSFullAddress', flatNumber?: string | null, houseNumber: string, city: string, street: string, zipCode: string } | null, secretData?: { __typename?: 'DoctorMSSecretData', nice?: boolean | null, notnice?: boolean | null, physicallydisabled?: boolean | null, hearingdisabled?: boolean | null, pregnant?: boolean | null, breastfeeding?: boolean | null, description?: string | null } | null, tags: Array<{ __typename?: 'DoctorMSPatientTag', id: string, type: string, data: any, expirationAt?: any | null, confirmationType?: DoctorMSConfirmationType | null, history?: Array<{ __typename?: 'DoctorMSHistory', user: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }, when: { __typename?: 'DoctorMSTime', iso: string } }> | null }>, survey?: { __typename?: 'DoctorMSSurvey', weight: string, height: string, risks: Array<{ __typename?: 'DoctorMSAnswer', choice_id: string, id: string }> } | null, vitals: Array<{ __typename?: 'DoctorMSAnalysis', id: string, type: DoctorMSVitalType, analysisType: string, group?: string | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, message?: { __typename?: 'DoctorMSAssignment', id: string } | { __typename?: 'DoctorMSCareleave', id: string } | { __typename?: 'DoctorMSIpom', id: string } | { __typename?: 'DoctorMSLeave', id: string } | { __typename?: 'DoctorMSPrescription', id: string } | { __typename?: 'DoctorMSReferral', id: string } | { __typename?: 'DoctorMSTestimonial', id: string } | null, params: Array<{ __typename?: 'DoctorMSBloodParam', name?: string | null, value?: string | null, unit?: string | null, min?: string | null, max?: string | null }> } | { __typename?: 'DoctorMSCt', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, message?: { __typename?: 'DoctorMSAssignment', id: string } | { __typename?: 'DoctorMSCareleave', id: string } | { __typename?: 'DoctorMSIpom', id: string } | { __typename?: 'DoctorMSLeave', id: string } | { __typename?: 'DoctorMSPrescription', id: string } | { __typename?: 'DoctorMSReferral', id: string } | { __typename?: 'DoctorMSTestimonial', id: string } | null } | { __typename?: 'DoctorMSEcommerce', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSEkg', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, message?: { __typename?: 'DoctorMSAssignment', id: string } | { __typename?: 'DoctorMSCareleave', id: string } | { __typename?: 'DoctorMSIpom', id: string } | { __typename?: 'DoctorMSLeave', id: string } | { __typename?: 'DoctorMSPrescription', id: string } | { __typename?: 'DoctorMSReferral', id: string } | { __typename?: 'DoctorMSTestimonial', id: string } | null } | { __typename?: 'DoctorMSHeartrate', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, message?: { __typename?: 'DoctorMSAssignment', id: string } | { __typename?: 'DoctorMSCareleave', id: string } | { __typename?: 'DoctorMSIpom', id: string } | { __typename?: 'DoctorMSLeave', id: string } | { __typename?: 'DoctorMSPrescription', id: string } | { __typename?: 'DoctorMSReferral', id: string } | { __typename?: 'DoctorMSTestimonial', id: string } | null } | { __typename?: 'DoctorMSInjection', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, message?: { __typename?: 'DoctorMSAssignment', id: string } | { __typename?: 'DoctorMSCareleave', id: string } | { __typename?: 'DoctorMSIpom', id: string } | { __typename?: 'DoctorMSLeave', id: string } | { __typename?: 'DoctorMSPrescription', id: string } | { __typename?: 'DoctorMSReferral', id: string } | { __typename?: 'DoctorMSTestimonial', id: string } | null } | { __typename?: 'DoctorMSOperation', id: string, type: DoctorMSVitalType, operationType: string, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSOther', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSPressure', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSRtg', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSSpiro', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSUsg', id: string, type: DoctorMSVitalType, measured?: { __typename?: 'DoctorMSTime', iso: string } | null }> } | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentAt?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentBy?: { __typename?: 'DoctorMSDoctor', id: string } | null } };

export type DoctorPatientsQueryVariables = Exact<{
  fullText: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take: Scalars['Int']['input'];
}>;


export type DoctorPatientsQuery = { __typename?: 'Query', doctorPatients: Array<{ __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, pesel?: string | null, patientCardNumber: string, assistantId?: string | null, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, lastPatientMessageBlock?: { __typename?: 'DoctorMSTime', iso: string } | null, messages: Array<{ __typename?: 'DoctorMSAssignment', type: DoctorMSMessageType, paid?: boolean | null, id: string, status?: DoctorMSAssignmentStatus | null, assignmentType: string, data?: any | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, positions?: Array<{ __typename?: 'DoctorMSPosition', serviceId?: string | null, serviceName?: string | null } | null> | null, patient: { __typename?: 'DoctorMSPatient', firstName?: string | null, lastName?: string | null, id: string, pesel?: string | null, assistantId?: string | null, patientCardNumber: string } } | { __typename?: 'DoctorMSCareleave' } | { __typename?: 'DoctorMSIpom' } | { __typename?: 'DoctorMSLeave' } | { __typename?: 'DoctorMSPrescription' } | { __typename?: 'DoctorMSReferral' } | { __typename?: 'DoctorMSTestimonial' }> }> };

export type DoctorGetPatientDataWithPayersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetPatientDataWithPayersQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', id: string, payers: Array<{ __typename?: 'DoctorMSPayer', name: string, firstName: string, lastName: string, passportNumber: string, pesel: string, nip: string, pueProfile: string }> } | null };

export type DoctorGetPatientStayAddressesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetPatientStayAddressesQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', id: string, stayAddresses: Array<{ __typename?: 'DoctorMSAddress', zipCode: string, city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null }> } | null };

export type DoctorGetLeaveHistoryQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorGetLeaveHistoryQuery = { __typename?: 'Query', doctorLeaves: Array<{ __typename?: 'DoctorMSLeave', leaveType?: string | null, inabilitySince?: string | null, careSince?: string | null, inabilityUntil?: string | null, careUntil?: string | null, icd10Main: { __typename?: 'DoctorMSICD10Main', name: string, icd10: string }, underCarePerson?: { __typename?: 'DoctorMSUnderCarePerson', firstName: string, lastName: string, birthDate: string, type: string } | null }> };

export type DoctorGetPatientDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetPatientDataQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', stayAddresses: Array<{ __typename?: 'DoctorMSAddress', zipCode: string, city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null }> } | null };

export type DoctorGetDocumentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetDocumentsQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', documents: Array<{ __typename?: 'DoctorMSMedicalRecordEntity', id: string, name: string, createdAt: any, tagId?: string | null, starred: boolean, source: DoctorMSMedicalDocumentSource, fileId: string, patientId: string, archived: boolean, tidy_status?: string | null, tidyDocumentationResult?: { __typename?: 'DoctorMSTidyDocumentationResultEntity', id: string, name?: string | null, type?: string | null, summary?: any | null, issuedAt?: any | null, rawText?: string | null, createdAt: any } | null }> } | null };

export type DoctorMeQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorMeQuery = { __typename?: 'Query', doctorMe: { __typename?: 'DoctorMSDoctorWithSecrets', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, phone: string, email?: string | null, avatar: string, signature?: string | null, medicalPushToken?: any | null, sipNumber?: string | null, sipUserId?: string | null, sipUserPassword?: string | null, sipNumberRecording?: string | null, sipUserIdRecording?: string | null, sipUserPasswordRecording?: string | null, referralCommissionSum: number } };

export type DoctorPatientProfileVisitQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorPatientProfileVisitQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, avatar: string, phone: string, email?: string | null, citizenship?: string | null, pesel?: string | null, patientCardNumber: string, immunizationCardStatus: string, immunizationCardComment?: string | null, ipomCode?: string | null, actionRequired?: string | null, passportCountry?: string | null, passportNumber?: string | null, izolacja?: string | null, kwarantanna?: string | null, statusUbezpieczenia?: number | null, oneTimeSurvey?: any | null, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, oneTimeSurveyUpdatedAt?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, nfzStatus: { __typename?: 'DoctorMSObjectedNFZStatus', declaredIn?: string | null, wasDeclared: boolean, canUsePublicVisits: boolean, whereCanDeclare?: string | null, canDeclare: boolean, comment?: string | null, chosenDoctor?: string | null, chosenNurse?: string | null }, visits: Array<{ __typename?: 'DoctorMSVisit', id: string, type?: DoctorMSVisitType | null, status: DoctorMSVisitStatus, showOn?: string | null, duration?: number | null, startOn?: string | null, deletedAt?: string | null, plannedPlace?: string | null, recommendationsMessageId?: string | null, recommendationsMessage?: { __typename?: 'DoctorMSChatMessageEntity', id: string } | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null }>, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null, secretData?: { __typename?: 'DoctorMSSecretData', nice?: boolean | null, notnice?: boolean | null, physicallydisabled?: boolean | null, hearingdisabled?: boolean | null, pregnant?: boolean | null, breastfeeding?: boolean | null, description?: string | null } | null, guardians: Array<{ __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null }>, wards: Array<{ __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null }>, tags: Array<{ __typename?: 'DoctorMSPatientTag', id: string, type: string, expirationAt?: any | null, confirmationType?: DoctorMSConfirmationType | null, data: any, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string }, createdBy?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string } } | null, history?: Array<{ __typename?: 'DoctorMSHistory', user: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }, when: { __typename?: 'DoctorMSTime', iso: string } }> | null }>, survey?: { __typename?: 'DoctorMSSurvey', weight: string, height: string, risks: Array<{ __typename?: 'DoctorMSAnswer', choice_id: string, id: string }> } | null, vitals: Array<{ __typename?: 'DoctorMSAnalysis', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, analysisType: string, group?: string | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null, params: Array<{ __typename?: 'DoctorMSBloodParam', name?: string | null, value?: string | null, unit?: string | null, min?: string | null, max?: string | null, text?: string | null }> } | { __typename?: 'DoctorMSCt', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null } | { __typename?: 'DoctorMSEcommerce', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSEkg', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null } | { __typename?: 'DoctorMSHeartrate', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null } | { __typename?: 'DoctorMSInjection', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null } | { __typename?: 'DoctorMSOperation', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, operationType: string, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSOther', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, customName?: string | null, customComment?: string | null, group?: string | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null, customDate?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSPressure', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSRtg', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSSpiro', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null } | { __typename?: 'DoctorMSUsg', id: string, type: DoctorMSVitalType, overrideFiles?: Array<string> | null, measured?: { __typename?: 'DoctorMSTime', iso: string } | null }>, messages: Array<{ __typename?: 'DoctorMSAssignment', id: string, type: DoctorMSMessageType, assignmentType: string, status?: DoctorMSAssignmentStatus | null, paid?: boolean | null, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename?: 'DoctorMSCareleave', id: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename?: 'DoctorMSIpom', id: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename?: 'DoctorMSLeave', id: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename?: 'DoctorMSPrescription', id: string, type: DoctorMSMessageType, resourceCancelationInCezDate?: any | null, resourceIsCompatibleWithCez?: boolean | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre }, writeup: { __typename?: 'DoctorMSTime', iso: string }, startsToWork?: { __typename?: 'DoctorMSTime', iso: string } | null, endsToWork?: { __typename?: 'DoctorMSTime', iso: string } | null, options?: { __typename?: 'DoctorMSPrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, drugs: Array<{ __typename?: 'DoctorMSDrug', drug: string, dose: string, form: string, quantity?: string | null, boxAmount?: number | null, cost: string, drugAmount?: number | null, interval?: string | null, psychoSubstances?: boolean | null, hourInterval?: number | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, activeSubstances?: Array<{ __typename?: 'DoctorMSActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> } | { __typename?: 'DoctorMSReferral', id: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename?: 'DoctorMSTestimonial', id: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } }> } | null };

export type DoctorPatientProfileDiagQueryVariables = Exact<{
  search: Scalars['String']['input'];
  type: DoctorMSAssignmentType;
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorPatientProfileDiagQuery = { __typename?: 'Query', doctorDiag: Array<{ __typename?: 'DoctorMSDiag', id: string, name: string, price: number, isAvailableAsNFZ: boolean, isAvailableAsNFZForNurse: boolean, orgIds?: Array<string> | null, commission?: number | null, type: string }> };

export type DoctorPersonalIDNumbersQueryVariables = Exact<{
  pesel?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorPersonalIDNumbersQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', pesel?: string | null } | null };

export type DoctorGetMySeenPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorGetMySeenPostsQuery = { __typename?: 'Query', doctorMe: { __typename?: 'DoctorMSDoctorWithSecrets', id: string, seenPosts: Array<string> } };

export type DoctorScheduledVisitsQueryVariables = Exact<{
  forDay: Scalars['DoctorMSDateTime']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  doctorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DoctorScheduledVisitsQuery = { __typename?: 'Query', doctorScheduledVisits: Array<{ __typename?: 'DoctorMSVisit', id: string, status: DoctorMSVisitStatus, slotType?: string | null, type?: DoctorMSVisitType | null, doctorId?: string | null, createdBy?: string | null, leftOn?: string | null, plannedPlace?: string | null, duration?: number | null, startOn?: string | null, showOn?: string | null, appointmentStatus: string, snapshotAt?: string | null, snapshotBy?: string | null, organizationId?: string | null, ecommerceOrderIds: Array<string>, sentNoShowNotifications?: { __typename?: 'DoctorMSSentNoShowNotifications', notifications: { __typename?: 'DoctorMSSentNotifications', warnings: Array<string | null>, cancelled?: string | null }, answer?: { __typename?: 'DoctorMSNoShowNotificationAnswer', value: boolean, when: string } | null } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string, genre: DoctorMSUserGenre } | null, patient?: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, avatar: string, pesel?: string | null, phone: string, patientCardNumber: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentAt?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentBy?: { __typename?: 'DoctorMSDoctor', id: string } | null, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', type: DoctorMSProcedureType }>, laboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', assignment: any }> }> };

export type DoctorICD10QueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type DoctorICD10Query = { __typename?: 'Query', doctorICD10: Array<string> };

export type DoctorPackagesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DoctorPackagesQuery = { __typename?: 'Query', doctorPackages: Array<{ __typename?: 'DoctorMSPackage', ean: string, name: string, box: string, form: string, dosage: string }> };

export type DoctorGetDrugDetailsQueryVariables = Exact<{
  ean: Scalars['String']['input'];
}>;


export type DoctorGetDrugDetailsQuery = { __typename?: 'Query', doctorGetDrugDetails: { __typename?: 'DoctorMSDrugDetails', effect?: string | null, indications?: string | null, contraindications?: string | null, comments?: string | null, precautions?: string | null, interactions?: string | null, pregnantWomenInstructions?: string | null, hasPsychoSubstances: boolean, name: string, box: string, ean: string, form: string, dosage: string, dosageDescription?: string | null, productCharacteristics?: string | null, use?: string | null, composition?: string | null, activeSubstances: Array<{ __typename?: 'DoctorMSActiveSubstanceOfDrug', name?: string | null, unitCode?: string | null, amountPerItem?: string | null, amountPerPackage?: string | null, substanceId?: string | null }>, paymentLevels: Array<{ __typename?: 'DoctorMSPaymentDetails', value: string, price: string, description: string, detailedDescription: string, type: string, paymentKey: string }> } };

export type DoctorGetClinicsQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorGetClinicsQuery = { __typename?: 'Query', doctorClinics: Array<{ __typename?: 'DoctorMSClinic', id: number, name: string, type: number, code: string }> };

export type DoctorPatientMessagesQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorPatientMessagesQuery = { __typename?: 'Query', doctorGetMessagesForPatient: Array<{ __typename: 'DoctorMSAssignment', id: string, type: DoctorMSMessageType, assignmentType: string, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, doctor: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null }, positions?: Array<{ __typename?: 'DoctorMSPosition', serviceId?: string | null, serviceName?: string | null, isNFZ?: boolean | null, price?: number | null, sampleId?: string | null, cancelled?: boolean | null } | null> | null } | { __typename: 'DoctorMSCareleave', id: string, type: DoctorMSMessageType, insuredIn?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'DoctorMSDoctor', id: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, icd10Main: { __typename?: 'DoctorMSICD10Main', name: string, icd10: string }, payer?: { __typename?: 'DoctorMSPayer', id?: string | null } | null, underCarePerson?: { __typename?: 'DoctorMSUnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'DoctorMSLeaveDetails', seriesNumber: string }> | null } | { __typename: 'DoctorMSIpom', id: string, assignmentType: string, data: any, visitId: string, type: DoctorMSMessageType, createdAt: { __typename?: 'DoctorMSTime', iso: string } } | { __typename: 'DoctorMSLeave', id: string, type: DoctorMSMessageType, reason?: string | null, leaveType?: string | null, insuredIn?: string | null, inabilitySince?: string | null, inabilityUntil?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'DoctorMSDoctor', id: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, icd10Main: { __typename?: 'DoctorMSICD10Main', name: string, icd10: string }, codes?: { __typename?: 'DoctorMSCodes', A: boolean, B: boolean, C: boolean, D: boolean, E: boolean } | null, payer?: { __typename?: 'DoctorMSPayer', id?: string | null } | null, underCarePerson?: { __typename?: 'DoctorMSUnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'DoctorMSLeaveDetails', seriesNumber: string }> | null } | { __typename: 'DoctorMSPrescription', id: string, type: DoctorMSMessageType, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, drugs: Array<{ __typename?: 'DoctorMSDrug', ean?: string | null, cost: string, drug: string, boxAmount?: number | null, dose: string, form: string, drugAmount?: number | null, interval?: string | null, psychoSubstances?: boolean | null, hourInterval?: number | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, quantity?: string | null, activeSubstances?: Array<{ __typename?: 'DoctorMSActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> } | { __typename: 'DoctorMSReferral', id: string, type: DoctorMSMessageType, referralType: string, urgent?: boolean | null, comment?: string | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, icd10?: { __typename?: 'DoctorMSICD10Main', icd10: string, name: string } | null, icd9?: { __typename?: 'DoctorMSICD9Main', name: string, icd9: string } | null, clinic?: { __typename?: 'DoctorMSClinicDetails', name: string } | null, referralDetails: { __typename?: 'DoctorMSReferralDetails', code?: string | null } } | { __typename: 'DoctorMSTestimonial', id: string, type: DoctorMSMessageType, testimonialType: string, data: any, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string } }> };

export type DoctorMedicineSubtitlesTagsQueryVariables = Exact<{
  type: DoctorMSPatientTagType;
}>;


export type DoctorMedicineSubtitlesTagsQuery = { __typename?: 'Query', doctorMedicineSubtitles: Array<{ __typename?: 'DoctorMSMedicineSubtitle', subtitle: string, type: string }> };

export type DoctorChatMessagesQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
  createdAtGt?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  createdAtLt?: InputMaybe<Scalars['DoctorMSDateTime']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DoctorChatMessagesQuery = { __typename?: 'Query', doctorChatMessages: Array<{ __typename?: 'DoctorMSChatMessageEntity', id: string, content: string, authorId?: string | null, patientId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, author?: { __typename?: 'DoctorMSDoctor', id: string, genre: DoctorMSUserGenre, firstName?: string | null, lastName?: string | null } | { __typename?: 'DoctorMSPatient', id: string, genre: DoctorMSUserGenre, firstName?: string | null, lastName?: string | null, guardians: Array<{ __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }> } | null, visit?: { __typename?: 'DoctorMSVisit', id: string, status: DoctorMSVisitStatus, doctorInterview?: string | null, duration?: number | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string } | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null } | null, survey?: { __typename?: 'DoctorMSSurveyProposalEntity', formId: string, data?: any | null, isFilled: string } | null, prescription?: { __typename?: 'DoctorMSPrescription', id: string, type: DoctorMSMessageType, resourceCancelationInCezDate?: any | null, resourceIsCompatibleWithCez?: boolean | null, insuredIn: string, code: string, number: string, prescriptionId?: string | null, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, writeup: { __typename?: 'DoctorMSTime', iso: string }, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string }, patient: { __typename?: 'DoctorMSPatient', firstName?: string | null, lastName?: string | null, pesel?: string | null }, startsToWork?: { __typename?: 'DoctorMSTime', iso: string } | null, endsToWork?: { __typename?: 'DoctorMSTime', iso: string } | null, options?: { __typename?: 'DoctorMSPrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, drugs: Array<{ __typename?: 'DoctorMSDrug', cost: string, drug: string, boxAmount?: number | null, dose: string, form: string, interval?: string | null, hourInterval?: number | null, drugAmount?: number | null, quantity?: string | null, package?: string | null, psychoSubstances?: boolean | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, activeSubstances?: Array<{ __typename?: 'DoctorMSActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> } | null, leave?: { __typename: 'DoctorMSLeave', id: string, type: DoctorMSMessageType, reason?: string | null, leaveType?: string | null, insuredIn?: string | null, inabilitySince?: string | null, inabilityUntil?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'DoctorMSDoctor', id: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, icd10Main: { __typename?: 'DoctorMSICD10Main', name: string, icd10: string }, codes?: { __typename?: 'DoctorMSCodes', A: boolean, B: boolean, C: boolean, D: boolean, E: boolean } | null, payer?: { __typename?: 'DoctorMSPayer', id?: string | null } | null, payers?: Array<{ __typename?: 'DoctorMSPayer', id?: string | null, name: string, firstName: string, lastName: string, nip: string, pesel: string, passportNumber: string, doNotSendPayerInfo?: boolean | null }> | null, underCarePerson?: { __typename?: 'DoctorMSUnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'DoctorMSLeaveDetails', seriesNumber: string, address?: { __typename?: 'DoctorMSLeaveAddress', city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null, zipCode: string, notes?: string | null } | null, guardian?: { __typename?: 'DoctorMSLeaveGuardian', firstName: string, lastName: string, pesel: string } | null }> | null } | null, careleave?: { __typename: 'DoctorMSCareleave', id: string, insuredIn?: string | null, careSince?: string | null, careUntil?: string | null, doNotSendPayerInfo?: boolean | null, recommendation?: string | null, doctor: { __typename?: 'DoctorMSDoctor', id: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, createdAt: { __typename?: 'DoctorMSTime', iso: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, icd10Main: { __typename?: 'DoctorMSICD10Main', name: string, icd10: string }, payer?: { __typename?: 'DoctorMSPayer', id?: string | null } | null, payers?: Array<{ __typename?: 'DoctorMSPayer', id?: string | null, name: string, firstName: string, lastName: string, nip: string, pesel: string, passportNumber: string, doNotSendPayerInfo?: boolean | null }> | null, underCarePerson?: { __typename?: 'DoctorMSUnderCarePerson', firstName: string } | null, leaves?: Array<{ __typename?: 'DoctorMSLeaveDetails', seriesNumber: string, address?: { __typename?: 'DoctorMSLeaveAddress', city: string, country?: string | null, street: string, houseNumber: string, flatNumber?: string | null, zipCode: string, notes?: string | null } | null, guardian?: { __typename?: 'DoctorMSLeaveGuardian', firstName: string, lastName: string, pesel: string } | null }> | null } | null, testimonial?: { __typename?: 'DoctorMSTestimonial', id: string, type: DoctorMSMessageType, testimonialType: string, data: any, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string } } | null, referral?: { __typename?: 'DoctorMSReferral', id: string, type: DoctorMSMessageType, referralType: string, urgent?: boolean | null, comment?: string | null, adviceGoal?: string | null, examinationType?: string | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, icd10?: { __typename?: 'DoctorMSICD10Main', icd10: string, name: string } | null, icd9?: { __typename?: 'DoctorMSICD9Main', icd9: string, name: string } | null, clinic?: { __typename?: 'DoctorMSClinicDetails', name: string } | null, referralDetails: { __typename?: 'DoctorMSReferralDetails', code?: string | null } } | null, assignment?: { __typename?: 'DoctorMSAssignment', id: string, type: DoctorMSMessageType, assignmentType: string, paid?: boolean | null, data?: any | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, visit: { __typename?: 'DoctorMSVisit', id: string }, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, doctor: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null }, positions?: Array<{ __typename?: 'DoctorMSPosition', serviceId?: string | null, serviceName?: string | null, isNFZ?: boolean | null, price?: number | null, sampleId?: string | null, cancelled?: boolean | null } | null> | null } | null }> };

export type DoctorNextPatientsQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorNextPatientsQuery = { __typename?: 'Query', doctorNextPatients: Array<{ __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, assistantId?: string | null, patientCardNumber: string, patientPublicSince?: { __typename?: 'DoctorMSTime', iso: string } | null, lastChatMessage?: { __typename?: 'DoctorMSChatMessageEntity', authorId?: string | null, content: string } | null, lastPatientMessageBlock?: { __typename?: 'DoctorMSTime', iso: string } | null, currentVirtualVisit?: { __typename?: 'DoctorMSVisit', innatePriority: DoctorMSVisitPriority } | null }> };

export type DoctorNextPatientQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorNextPatientQuery = { __typename?: 'Query', doctorNextPatient: string };

export type DoctorChatMessagesContentQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorChatMessagesContentQuery = { __typename?: 'Query', doctorChatMessages: Array<{ __typename?: 'DoctorMSChatMessageEntity', id: string, content: string }> };

export type DoctorProceduresQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorProceduresQuery = { __typename?: 'Query', doctorProcedures: Array<{ __typename?: 'DoctorMSProcedureEntity', id: string, patientId: string, visitId?: string | null, createdAt: any, updatedAt: any, type: DoctorMSProcedureType, createdOnVisitId?: string | null, data?: any | null, files?: Array<string> | null, createdBy?: string | null, observations: string, cancelled: boolean, chukEducation?: { __typename?: 'DoctorMSProcedureChukEducation', cholesterol?: number | null, cholesterolLDL?: number | null, cholesterolHDL?: number | null, cholesterolNonHDL?: number | null, triglycerides?: number | null, glucose?: number | null, riskScore?: number | null, recommendations?: string | null, simpFiles?: Array<string> | null, comment?: string | null } | null, chukMeasurements?: { __typename?: 'DoctorMSProcedureChukMeasurements', comment?: string | null, pressureMeasurements?: Array<{ __typename?: 'DoctorMSChukPressureMeasurement', systolicPressure?: number | null, diastolicPressure?: number | null, pulse?: number | null }> | null, bodyMeasurements?: { __typename?: 'DoctorMSChukBodyMeasurements', weight?: number | null, height?: number | null, waist?: number | null } | null } | null, disinfectants: Array<{ __typename?: 'DoctorMSProcedureDisinfectant', name?: string | null, productSeries?: string | null, expirationDate?: string | null, used?: string | null }>, tools: Array<{ __typename?: 'DoctorMSProcedureTool', name?: string | null, productSeries?: string | null, expirationDate?: string | null, used?: string | null }>, drugs: Array<{ __typename?: 'DoctorMSProcedureDrug', name?: string | null, productSeries?: string | null, expirationDate?: string | null, used?: string | null }>, bandages: Array<{ __typename?: 'DoctorMSProcedureBandage', name?: string | null, productSeries?: string | null, expirationDate?: string | null, used?: string | null }>, measurements: Array<{ __typename?: 'DoctorMSProcedureMeasurement', systolicPressure?: string | null, diastolicPressure?: string | null, pulse?: string | null, resultType?: string | null }>, vaccines: Array<{ __typename?: 'DoctorMSProcedureVaccine', name?: string | null, productSeries?: string | null, expirationDate?: string | null, dose?: string | null }>, medicalAct?: { __typename?: 'DoctorMSProcedureMedicalAct', weight?: string | null, height?: string | null, pulse?: string | null, temperature?: string | null, glycemia?: string | null, systolicPressure?: string | null, diastolicPressure?: string | null, comment?: string | null } | null, creator: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }, patient: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }, dressingChange?: { __typename?: 'DoctorMSProcedureDressingChange', place?: string | null, type?: string | null, secretion?: DoctorMSSecretionType | null, woundClassification?: Array<string> | null, woundHealingStatus?: DoctorMSWoundHealingStatus | null } | null, stitch?: { __typename?: 'DoctorMSProcedureStitch', place?: string | null, woundHealingStatus?: DoctorMSWoundHealingStatus | null } | null, foreignBody?: { __typename?: 'DoctorMSProcedureForeignBody', type?: string | null, comment?: string | null } | null, medication?: { __typename?: 'DoctorMSProcedureMedication', name?: string | null, dosing?: string | null, injection?: boolean | null, cito?: boolean | null } | null, ekg?: { __typename?: 'DoctorMSProcedureEKG', comment?: string | null, cito?: boolean | null } | null, education?: { __typename?: 'DoctorMSProcedureEducation', comment?: string | null } | null, vaccineData?: { __typename?: 'DoctorMSProcedureVaccineBasicData', name?: string | null, comment?: string | null } | null, spirometry?: { __typename?: 'DoctorMSProcedureSpirometry', diastolicTest?: boolean | null, comments?: string | null, examinationComments?: string | null } | null, usg?: { __typename?: 'DoctorMSProcedureUsg', referralId?: string | null, description?: string | null, comment?: string | null, attachments?: Array<string> | null, service?: { __typename?: 'DoctorMSAssignmentEntity', foreignServiceId: string, name: string, type: DoctorMSAssignmentType } | null, referral?: { __typename?: 'DoctorMSProcedureUsgReferralInfo', mainDiagnosis: string, procedureName: string, comment: string } | null } | null, tuberculosisEducation?: { __typename?: 'DoctorMSProcedureTuberculosisEducation', score?: number | null, riskGroup?: DoctorMSTuberculosisRiskLevel | null, telemedicalConsultation?: boolean | null, patientEducated?: boolean | null } | null, patronageVisit?: { __typename?: 'DoctorMSProcedureParonageVisit', summary?: string | null, type?: string | null } | null, midwifeEducationalVisit?: { __typename?: 'DoctorMSProcedureMidwifeEducationalVisit', summary?: string | null, visitTopics?: Array<string> | null, pregnacyWeek?: string | null } | null, answers: Array<{ __typename?: 'DoctorMSProcedureAnswer', answer?: string | null, question?: string | null, comment?: string | null }> }> };

export type DoctorLaboratoryExaminationsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorLaboratoryExaminationsQuery = { __typename?: 'Query', doctorLaboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', id: string, patientId: string, visitId?: string | null, serviceId: string, sampleId?: string | null, diagIdPosition: number, createdAt: any, updatedAt: any, createdOnVisitId?: string | null, comment?: string | null, assignment: any, cito: boolean, executionLimit: string, payment: DoctorMSLabExaminationPayment, displayPayment: string, createdBy?: string | null, cancelled: boolean, groupId?: string | null, sourceInfo?: { __typename?: 'DoctorMSLabExamSourceInfo', source: DoctorMSLabExamSource, ecommerce?: { __typename?: 'DoctorMSLabExamEcommerceSource', orderId: string, saleorProductId?: string | null, packetInfo?: { __typename?: 'DoctorMSLabExamPacketInfo', saleorProductId: string, name: string, price?: number | null, discount?: number | null, totalPrice?: number | null } | null } | null } | null, creator: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null }, patient: { __typename?: 'DoctorMSUserEntity', id: string, firstName?: string | null, lastName?: string | null }, paymentLog?: { __typename?: 'DoctorMSPaymentLogEntity', id: string, createdAt: any, createdBy: string, info: { __typename?: 'DoctorMSPaymentLogEntry', posPayment?: { __typename?: 'DoctorMSPosPaymentInfo', paymentNumber: string } | null, bankTransferPayment?: { __typename?: 'DoctorMSBankTransferPaymentInfo', moneyTransferProofFiles: Array<string> } | null, customerComplaint?: { __typename?: 'DoctorMSCustomerComplaintPaymentInfo', comment: string } | null, employeeBenefit?: { __typename?: 'DoctorMSEmployeeBenefitPaymentMethodInfo', benefit: string } | null, anotherPaymentMethod?: { __typename?: 'DoctorMSAnotherPaymentMethodInfo', comment: string } | null }, creator: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null } } | null }> };

export type DoctorLaboratoryExaminationDragInfoQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorLaboratoryExaminationDragInfoQuery = { __typename?: 'Query', doctorLaboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', groupId?: string | null, payment: DoctorMSLabExaminationPayment, diagIdPosition: number, assignment: any }> };

export type DoctorLaboratoryExaminationSampleQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorLaboratoryExaminationSampleQuery = { __typename?: 'Query', doctorLaboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', sampleId?: string | null, assignment: any }> };

export type DoctorChatMessagesGroupedByPatientIdQueryVariables = Exact<{
  authorId: Scalars['String']['input'];
  forDay: Scalars['DoctorMSDateTime']['input'];
}>;


export type DoctorChatMessagesGroupedByPatientIdQuery = { __typename?: 'Query', doctorGroupByChatMessage: Array<{ __typename?: 'DoctorMSChatMessageEntity', patientId: string, patient: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, pesel?: string | null, patientCardNumber: string } }> };

export type DoctorVisitsForPatientsQueryVariables = Exact<{
  forDay: Scalars['DoctorMSDateTime']['input'];
  patientIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DoctorVisitsForPatientsQuery = { __typename?: 'Query', doctorVisitsForPatients: Array<{ __typename?: 'DoctorMSVisit', id: string, patientId: string, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null }> };

export type DoctorGetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorGetEmployeesQuery = { __typename?: 'Query', doctorDoctors: Array<{ __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, type: DoctorMSUserGenre }> };

export type DoctorFindAddressQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type DoctorFindAddressQuery = { __typename?: 'Query', doctorFindAddress: Array<{ __typename?: 'DoctorMSPlacematicAddress', city: string, state?: string | null, street?: string | null, zipCode?: string | null, teryt?: string | null, latitude?: number | null, longitude?: number | null, houseNumber?: string | null, municipality?: string | null }> };

export type DoctorOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorOrganizationsQuery = { __typename?: 'Query', doctorOrganizations: Array<{ __typename?: 'DoctorMSOrganizationEntity', id: string, name: string, displayName: string, placeData?: { __typename?: 'DoctorMSPlaceData', city: string, latitude?: number | null, longtitude?: number | null } | null }> };

export type DoctorPatientTagsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  pesel?: InputMaybe<Scalars['String']['input']>;
  patientCardNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorPatientTagsQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', tags: Array<{ __typename?: 'DoctorMSPatientTag', id: string, type: string, data: any }> } | null };

export type DoctorHistoryVisitsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DoctorHistoryVisitsQuery = { __typename?: 'Query', doctorHistoryVisits: Array<{ __typename?: 'DoctorMSVisit', id: string, status: DoctorMSVisitStatus, memo?: string | null, isPublicVisit: boolean, ecommerceOrderIds: Array<string>, type?: DoctorMSVisitType | null, organizationId?: string | null, innatePriority: DoctorMSVisitPriority, doctorId?: string | null, doctorInterview?: string | null, physicalExamination?: string | null, recommendation?: string | null, comment?: string | null, snapshotAt?: string | null, snapshotBy?: string | null, deletedAt?: string | null, startOn?: string | null, showOn?: string | null, createdBy?: string | null, leftOn?: string | null, plannedPlace?: string | null, duration?: number | null, appointmentStatus: string, closedByBot?: boolean | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string, genre: DoctorMSUserGenre } | null, patient?: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, avatar: string, pesel?: string | null, phone: string, patientCardNumber: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string }, plannedStart?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, laboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', visitId?: string | null, assignment: any, id: string }>, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', id: string, type: DoctorMSProcedureType, displayName: string, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null }>, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, invitationSentAt?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentBy?: { __typename?: 'DoctorMSDoctor', id: string } | null }> };

export type DoctorUpcomingVisitsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorUpcomingVisitsQuery = { __typename?: 'Query', doctorUpcomingVisits: Array<{ __typename?: 'DoctorMSVisit', id: string, slotType?: string | null, type?: DoctorMSVisitType | null, showOn?: string | null, snapshotAt?: string | null, startOn?: string | null, status: DoctorMSVisitStatus, organizationId?: string | null, createdBy?: string | null, duration?: number | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, patient?: { __typename?: 'DoctorMSPatient', id: string, patientCardNumber: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, npwz?: string | null } | null, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', id: string, type: DoctorMSProcedureType }> }> };

export type DoctorGetVisitDataForEditFormQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorGetVisitDataForEditFormQuery = { __typename?: 'Query', doctorVisit: { __typename?: 'DoctorMSVisit', id: string, slotType?: string | null, type?: DoctorMSVisitType | null, showOn?: string | null, snapshotAt?: string | null, startOn?: string | null, status: DoctorMSVisitStatus, organizationId?: string | null, createdBy?: string | null, duration?: number | null, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', id: string, type: DoctorMSProcedureType }>, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string }, patient?: { __typename?: 'DoctorMSPatient', id: string, patientCardNumber: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre, npwz?: string | null } | null } };

export type DoctorDraftVisitsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DoctorDraftVisitsQuery = { __typename?: 'Query', doctorDraftVisits: Array<{ __typename?: 'DoctorMSVisit', id: string, status: DoctorMSVisitStatus, memo?: string | null, isPublicVisit: boolean, type?: DoctorMSVisitType | null, organizationId?: string | null, innatePriority: DoctorMSVisitPriority, doctorId?: string | null, doctorInterview?: string | null, physicalExamination?: string | null, recommendation?: string | null, comment?: string | null, snapshotAt?: string | null, snapshotBy?: string | null, deletedAt?: string | null, startOn?: string | null, showOn?: string | null, createdBy?: string | null, leftOn?: string | null, plannedPlace?: string | null, duration?: number | null, appointmentStatus: string, closedByBot?: boolean | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string, genre: DoctorMSUserGenre } | null, patient?: { __typename?: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, avatar: string, pesel?: string | null, phone: string, patientCardNumber: string } | null, createdAt: { __typename?: 'DoctorMSTime', iso: string, local: string }, plannedStart?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, invitationSentAt?: { __typename?: 'DoctorMSTime', iso: string } | null, invitationSentBy?: { __typename?: 'DoctorMSDoctor', id: string } | null }> };

export type DoctorPrescriptionsHistoryQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorPrescriptionsHistoryQuery = { __typename?: 'Query', doctorGetPrescriptionsForPatient: Array<{ __typename?: 'DoctorMSPrescription', id: string, resourceCancelationInCezDate?: any | null, resourceIsCompatibleWithCez?: boolean | null, startsToWork?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, visit: { __typename?: 'DoctorMSVisit', id: string, plannedPlace?: string | null }, endsToWork?: { __typename?: 'DoctorMSTime', iso: string, local: string } | null, options?: { __typename?: 'DoctorMSPrescriptionOptions', in365days?: boolean | null, cito?: boolean | null, dontChange?: boolean | null } | null, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, avatar: string, genre: DoctorMSUserGenre }, writeup: { __typename?: 'DoctorMSTime', iso: string }, drugs: Array<{ __typename?: 'DoctorMSDrug', ean?: string | null, drug: string, form: string, boxAmount?: number | null, drugAmount?: number | null, dose: string, interval?: string | null, quantity?: string | null, package?: string | null, cost: string, psychoSubstances?: boolean | null, hourInterval?: number | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, recipeId?: number | null, quantityDescription?: string | null, additionalPermission?: string | null, activeSubstances?: Array<{ __typename?: 'DoctorMSActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> }> };

export type DoctorGetPatientDocsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorGetPatientDocsQuery = { __typename?: 'Query', doctorGetPatientDocs: string };

export type DoctorCheckAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type DoctorCheckAuthStatusQuery = { __typename?: 'Query', doctorValidateToken: string };

export type DoctorGetDoctorFullNameQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorGetDoctorFullNameQuery = { __typename?: 'Query', doctorDoctor?: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null } | null };

export type DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorLaboratoryExaminationDiagsWithPacketsQuery = { __typename?: 'Query', doctorLaboratoryExaminationDiagsWithPackets: Array<{ __typename: 'DoctorMSDiag', id: string, name: string, price: number, isAvailableAsNFZ: boolean, isAvailableAsNFZForNurse: boolean, type: string, commission?: number | null, orgIds?: Array<string> | null } | { __typename: 'DoctorMSDiagPacket', name: string, price: number, items: Array<{ __typename?: 'DoctorMSDiag', id: string, name: string, price: number, isAvailableAsNFZ: boolean, isAvailableAsNFZForNurse: boolean, type: string, commission?: number | null, orgIds?: Array<string> | null }> }> };

export type DoctorNfzHistoryQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorNfzHistoryQuery = { __typename?: 'Query', doctorNfzHistory: Array<{ __typename: 'DoctorMSDeclarationAcceptedEvent', id: string, createdAt: any, vojevodship: DoctorMSOrganizationIdVojevodship } | { __typename: 'DoctorMSDeclarationNoLongerValidEvent', vojevodship: DoctorMSOrganizationIdVojevodship, id: string, createdAt: any, reason: { __typename: 'DoctorMSFacilityChangeEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any, info: { __typename: 'DoctorMSFacilityChangeInVoivodeshipEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any, nfzComment: string } | { __typename: 'DoctorMSFacilityChangeOutsideVoivodeshipEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any, insuranceProviderInfo: string, insuranceProviderInfoUrl: string, nfzComment: string } } | { __typename: 'DoctorMSIncorrectDeclarationEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any, reason: string } | { __typename: 'DoctorMSPatientDiedEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any } } | { __typename: 'DoctorMSDeclarationRejectedEvent', id: string, vojevodship: DoctorMSOrganizationIdVojevodship, createdAt: any, rejectionReason: DoctorMSDeclarationRejectionReason, exactRejectionReason: string, nfzComment: string } | { __typename: 'DoctorMSDeclarationSubmittedEvent', id: string, createdAt: any, vojevodship: DoctorMSOrganizationIdVojevodship, source: DoctorMSDeclarationSource, marketingSource: DoctorMSDeclarationMarketingSource, comment: string, date: any, files: Array<string>, filename: string, signature: string, isElectronicallySigned: boolean, declarationUploadStaff?: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null } | null, declarationGenerationParams: { __typename?: 'DoctorMSDeclarationGenerationParams', frequentFacilityChangeReason?: DoctorMSFrequentFacilityChangeReason | null, anotherProviderReason?: string | null }, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, isDeclarable?: boolean | null, adultDeclarable: boolean, childrenDeclarable: boolean, genre: DoctorMSUserGenre, npwz?: string | null } } | { __typename: 'DoctorMSInsuranceStatusEvent', id: string, createdAt: any, status: { __typename: 'DoctorMSEwusCheckEvent', id: string, createdAt: any, event: { __typename: 'DoctorMSEwusGreenEvent', id: string, createdAt: any } | { __typename: 'DoctorMSEwusRedEvent', id: string, createdAt: any } } | { __typename: 'DoctorMSInsuranceContributionCertificateEvent', id: string, createdAt: any } | { __typename: 'DoctorMSPatientInsuranceStatementEvent', id: string, createdAt: any, reason?: string | null } } | { __typename: 'DoctorMSUnknownEvent', id: string, createdAt: any, organizationId: string, type: string, data?: any | null, error?: string | null }> };

export type DoctorPatientInsuranceStatusQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorPatientInsuranceStatusQuery = { __typename?: 'Query', doctorPatientInsuranceStatus: { __typename?: 'DoctorMSPatientInsuranceInfo', current?: { __typename?: 'DoctorMSInsuranceStatusEvent', createdAt: any, status: { __typename?: 'DoctorMSEwusCheckEvent', createdAt: any, event: { __typename: 'DoctorMSEwusGreenEvent', createdAt: any, id: string } | { __typename: 'DoctorMSEwusRedEvent', createdAt: any, id: string } } | { __typename: 'DoctorMSInsuranceContributionCertificateEvent', createdAt: any, id: string } | { __typename: 'DoctorMSPatientInsuranceStatementEvent', createdAt: any, id: string, reason?: string | null } } | { __typename: 'DoctorMSUnknownEvent', createdAt: any, id: string } | null, latestPositive?: { __typename?: 'DoctorMSInsuranceStatusEvent', createdAt: any, status: { __typename?: 'DoctorMSEwusCheckEvent', createdAt: any, event: { __typename: 'DoctorMSEwusGreenEvent', createdAt: any, id: string } | { __typename: 'DoctorMSEwusRedEvent', createdAt: any, id: string } } | { __typename: 'DoctorMSInsuranceContributionCertificateEvent', createdAt: any, id: string } | { __typename: 'DoctorMSPatientInsuranceStatementEvent', createdAt: any, id: string, reason?: string | null } } | { __typename: 'DoctorMSUnknownEvent', createdAt: any, id: string } | null } };

export type DoctorPatientDeclarationHistoryQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorPatientDeclarationHistoryQuery = { __typename?: 'Query', doctorPatientDeclarationHistory: Array<{ __typename: 'DoctorMSDeclarationSubmittedEvent', id: string, createdAt: any, vojevodship: DoctorMSOrganizationIdVojevodship, source: DoctorMSDeclarationSource, marketingSource: DoctorMSDeclarationMarketingSource, comment: string, date: any, files: Array<string>, filename: string, signature: string, isElectronicallySigned: boolean, declarationUploadStaff?: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null } | null, declarationGenerationParams: { __typename?: 'DoctorMSDeclarationGenerationParams', frequentFacilityChangeReason?: DoctorMSFrequentFacilityChangeReason | null, anotherProviderReason?: string | null }, doctor: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, isDeclarable?: boolean | null, adultDeclarable: boolean, childrenDeclarable: boolean, genre: DoctorMSUserGenre, npwz?: string | null } } | { __typename: 'DoctorMSUnknownEvent', error?: string | null, data?: any | null }> };

export type DoctorIsPatientQualifiedForChukQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DoctorIsPatientQualifiedForChukQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', isQualifiedToCHUK: boolean } | null };

export type DoctorSendMfaSmsCodeQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type DoctorSendMfaSmsCodeQuery = { __typename?: 'Query', doctorSendMfaSmsCode: boolean };

export type DoctorAuthorizeMfaQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  mfaCode: Scalars['String']['input'];
}>;


export type DoctorAuthorizeMfaQuery = { __typename?: 'Query', doctorAuthorizeMFA: { __typename?: 'DoctorMSTokensPayload', jwt?: string | null, refreshToken?: string | null } };

export type DoctorPopularLaboratoryExaminationPacketsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DoctorPopularLaboratoryExaminationPacketsQuery = { __typename?: 'Query', doctorPopularLaboratoryExaminationPackets: Array<{ __typename?: 'DoctorMSDiagPacket', name: string, price: number, items: Array<{ __typename?: 'DoctorMSDiag', id: string, name: string, price: number, isAvailableAsNFZ: boolean, isAvailableAsNFZForNurse: boolean, type: string, commission?: number | null, orgIds?: Array<string> | null }> }> };

export type DoctorTodayComboTestQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorTodayComboTestQuery = { __typename?: 'Query', doctorTodayComboTest: boolean };

export type DoctorICD9QueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type DoctorICD9Query = { __typename?: 'Query', doctorICD9: Array<string> };

export type DoctorDiagnosticExaminationTemplateQueryVariables = Exact<{
  visitId: Scalars['String']['input'];
}>;


export type DoctorDiagnosticExaminationTemplateQuery = { __typename?: 'Query', doctorGetTemplatesForVisit: Array<{ __typename: 'DoctorMSLabExamTemplate', assignment: { __typename?: 'DoctorMSAssignmentEntity', name: string, foreignServiceId: string }, params?: Array<{ __typename: 'DoctorMSVitalParam', name: string, value: string, min: string, max: string, unit: string, text: string, icd9: string }> | null }> };

export type DoctorCheckPatientExistsQueryVariables = Exact<{
  pesel: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type DoctorCheckPatientExistsQuery = { __typename?: 'Query', isPeselUsed: boolean, isPhoneUsed: boolean };

export type DoctorGetP1PrescriptionsQueryVariables = Exact<{
  visitId?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetP1PrescriptionsQuery = { __typename?: 'Query', doctorGetP1Prescriptions: { __typename?: 'DoctorMSP1PrescriptionsReturn', lastChecked?: string | null, prescriptions: Array<{ __typename?: 'DoctorMSP1Prescription', drugName?: string | null, issueDate?: any | null, realizationDateFrom?: any | null, packageId?: string | null, prescriptionKey?: string | null, typeOfDrug?: string | null, prescriptionIssueStatus?: string | null, prescriptionStatus: DoctorMSPrescriptionStatus, packageSize?: string | null, prescriptionRepaymentLevel?: string | null }> } };

export type DoctorCheckPrescriptionsCEZQueryVariables = Exact<{
  visitId: Scalars['String']['input'];
}>;


export type DoctorCheckPrescriptionsCEZQuery = { __typename?: 'Query', doctorCheckCEZ: string };

export type DoctorGetProcedureRenderQueryVariables = Exact<{
  type: DoctorMSProcedureType;
  visitId: Scalars['String']['input'];
  procedureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetProcedureRenderQuery = { __typename?: 'Query', doctorProcedureRender: { __typename?: 'DoctorMSRenderedProcedure', create?: string | null, edit?: string | null, data: any, context: any, view?: string | null, schema: { __typename?: 'DoctorMSProcedureSchema', create: any, edit: any } } };

export type DoctorGetManyProcedureQueryVariables = Exact<{
  visitId?: InputMaybe<Scalars['String']['input']>;
  procedureIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DoctorGetManyProcedureQuery = { __typename?: 'Query', doctorManyProceduresRender: Array<{ __typename?: 'DoctorMSRenderedProcedure', view?: string | null, context: any, data: any, edit?: string | null, create?: string | null, schema: { __typename?: 'DoctorMSProcedureSchema', create: any, edit: any } }> };

export type DoctorGenerateDeclarationPdfQueryQueryVariables = Exact<{
  representativeId?: InputMaybe<Scalars['String']['input']>;
  request: Array<DoctorMSNfzDeclarationInputPatientMultiple> | DoctorMSNfzDeclarationInputPatientMultiple;
}>;


export type DoctorGenerateDeclarationPdfQueryQuery = { __typename?: 'Query', doctorDoctorGeneratePdf: string };

export type DoctorLaboratoryExaminationReportQueryVariables = Exact<{
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
  organizationCode: Scalars['String']['input'];
}>;


export type DoctorLaboratoryExaminationReportQuery = { __typename?: 'Query', doctorLaboratoryExaminationReport: string };

export type PerDayVisitsQueryVariables = Exact<{
  doctorId?: InputMaybe<Scalars['String']['input']>;
  forDay: Scalars['DoctorMSDateTime']['input'];
}>;


export type PerDayVisitsQuery = { __typename?: 'Query', doctorGetVisitsPerDayForDoctor: Array<{ __typename?: 'DoctorMSVisit', id: string, type?: DoctorMSVisitType | null, status: DoctorMSVisitStatus, innatePriority: DoctorMSVisitPriority, plannedPlace?: string | null, isPublicVisit: boolean, snapshotBy?: string | null, snapshotAt?: string | null, startOn?: string | null, showOn?: string | null, prescriptionRequestId?: string | null, determineIpomEligibility: boolean, procedures: Array<{ __typename?: 'DoctorMSProcedureEntity', type: DoctorMSProcedureType, medication?: { __typename?: 'DoctorMSProcedureMedication', cito?: boolean | null } | null, ekg?: { __typename?: 'DoctorMSProcedureEKG', comment?: string | null } | null, education?: { __typename?: 'DoctorMSProcedureEducation', comment?: string | null } | null, chukMeasurements?: { __typename?: 'DoctorMSProcedureChukMeasurements', comment?: string | null } | null, chukEducation?: { __typename?: 'DoctorMSProcedureChukEducation', comment?: string | null } | null, usg?: { __typename?: 'DoctorMSProcedureUsg', referral?: { __typename?: 'DoctorMSProcedureUsgReferralInfo', procedureName: string } | null } | null }>, laboratoryExaminations: Array<{ __typename?: 'DoctorMSLaboratoryExaminationEntity', assignment: any }>, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string } | null, patient?: { __typename?: 'DoctorMSPatient', visitRecordingAndAnalysisAgreement?: boolean | null, id: string, patientCardNumber: string, firstName?: string | null, lastName?: string | null, phone: string, pesel?: string | null, ipomCode?: string | null, avatar: string, guardians: Array<{ __typename: 'DoctorMSPatient', id: string, firstName?: string | null, lastName?: string | null, patientCardNumber: string, pesel?: string | null, phone: string, email?: string | null, address?: { __typename?: 'DoctorMSFullAddress', city: string, state?: string | null, teryt?: string | null, street: string, zipCode: string, latitude?: number | null, longitude?: number | null, flatNumber?: string | null, houseNumber: string, municipality?: string | null } | null }>, lastChatMessage?: { __typename?: 'DoctorMSChatMessageEntity', author?: { __typename: 'DoctorMSDoctor' } | { __typename: 'DoctorMSPatient' } | null } | null } | null }> };

export type DoctorsSelectQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorsSelectQuery = { __typename?: 'Query', doctorDoctors: Array<{ __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null, genre: DoctorMSUserGenre }> };

export type GetAdditionalRefundRightsWithExplanationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdditionalRefundRightsWithExplanationQuery = { __typename?: 'Query', doctorGetAdditionalRefundRightsWithExplanation: any };

export type DoctorRegularDrugsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorRegularDrugsQuery = { __typename?: 'Query', doctorRegularDrugs: Array<{ __typename?: 'DoctorMSRegularDrug', sourceTag: { __typename?: 'DoctorMSPatientTagEntity', id: string, data: any, type: DoctorMSPatientTagType, createdAt: string, patientId: string, updatedAt: any, confirmationType?: DoctorMSConfirmationType | null, expirationAt?: any | null }, drugDetails?: { __typename?: 'DoctorMSDrugDetails', name: string, box: string, ean: string, form: string, dosage: string, productCharacteristics?: string | null, use?: string | null, composition?: string | null, effect?: string | null, indications?: string | null, contraindications?: string | null, comments?: string | null, precautions?: string | null, interactions?: string | null, pregnantWomenInstructions?: string | null, hasPsychoSubstances: boolean, isCustom: boolean, additionalRefunds: Array<DoctorMSAdditionalRefundRight>, pregnacyDetails: { __typename?: 'DoctorMSPregnacyDetails', entirePregnacy: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, firstTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, secondTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, thirdTrimester: { __typename?: 'DoctorMSKeyValue', key: string, value: string }, lactation: { __typename?: 'DoctorMSKeyValue', key: string, value: string } }, activeSubstances: Array<{ __typename?: 'DoctorMSActiveSubstanceOfDrug', unitCode?: string | null, amountPerItem?: string | null, amountPerPackage?: string | null, name?: string | null, substanceId?: string | null }>, paymentLevels: Array<{ __typename?: 'DoctorMSPaymentDetails', value: string, price: string, description: string, detailedDescription: string, type: string, paymentKey: string }> } | null }> };

export type RecentPrescriptionsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type RecentPrescriptionsQuery = { __typename?: 'Query', doctorGetPrescriptionsForPatient: Array<{ __typename?: 'DoctorMSPrescription', id: string, doctor: { __typename?: 'DoctorMSDoctor', firstName?: string | null, lastName?: string | null, id: string }, writeup: { __typename?: 'DoctorMSTime', iso: string, local: string }, drugs: Array<{ __typename?: 'DoctorMSDrug', drug: string, ean?: string | null, form: string, boxAmount?: number | null, drugAmount?: number | null, dose: string, interval?: string | null, quantity?: string | null, cost: string, package?: string | null, psychoSubstances?: boolean | null, hourInterval?: number | null, morePatientInfo?: string | null, morePharmacistInfo?: string | null, recipeId?: number | null, quantityDescription?: string | null, additionalPermission?: string | null, activeSubstances?: Array<{ __typename?: 'DoctorMSActiveSubstance', activeSubstanceDose?: number | null, activeSubstanceDoseInWords?: Array<string> | null, activeSubstanceDoseUnit?: string | null } | null> | null }> }> };

export type StrapiGetPostsQueryVariables = Exact<{
  filters?: InputMaybe<StrapiPostFiltersInput>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type StrapiGetPostsQuery = { __typename?: 'Query', strapiPosts?: { __typename?: 'StrapiPostEntityResponseCollection', data: Array<{ __typename?: 'StrapiPostEntity', id?: string | null, attributes?: { __typename?: 'StrapiPost', slug: string, title: string, excerpt: string, html: string, createdAt?: any | null, publishedAt?: any | null, updatedAt?: any | null } | null }> } | null };

export type EventSearchQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  type: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventSearchQuery = { __typename?: 'Query', doctorReports: Array<{ __typename?: 'DoctorMSReportingEventEntity', sourceId: string, version: string }> };

export type EventSingleQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  type: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type EventSingleQuery = { __typename?: 'Query', doctorReports: Array<{ __typename?: 'DoctorMSReportingEventEntity', data?: any | null }> };

export type ReportGenerateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type ReportGenerateQuery = { __typename?: 'Query', doctorReportGenerate: string };

export type SwiadGenerateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  periodSymbol: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type SwiadGenerateQuery = { __typename?: 'Query', doctorSwiadGenerate: string };

export type DoctorGetIpomQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorGetIpomQuery = { __typename?: 'Query', doctorGetIpom?: { __typename?: 'DoctorMSPatientIpom', patientId: string, ipomCode: string, date: any, levelStratification: DoctorMSLevelStratification, summary: string, otherAdvice?: string | null, specialistVisits?: Array<DoctorMSJmIpomVisitType> | null, observations?: Array<{ __typename?: 'DoctorMSObservationIpom', name: string, value: string }> | null, medicines?: Array<{ __typename?: 'DoctorMSMedicineIpom', ean: string, name: string, dosage: string, form?: string | null, quantity?: string | null, dose?: string | null, time?: string | null }> | null, diet?: Array<{ __typename?: 'DoctorMSDietIpom', type: string }> | null, nurse?: Array<{ __typename?: 'DoctorMSNurseIpom', type: string }> | null, scheduledDiagnosticTests?: Array<{ __typename?: 'DoctorMSScheduledDiagnosticTestIpom', name: string, type: string, time: DoctorMSIpomTimeType, timeValue?: string | null, timeUnit?: DoctorMSIpomTimeUnit | null, timeName?: string | null, icd9?: string | null }> | null, controlVisits?: Array<{ __typename?: 'DoctorMSControlVisitIpom', time: DoctorMSIpomTimeType, timeValue?: string | null, timeUnit?: DoctorMSIpomTimeUnit | null }> | null } | null };

export type DoctorGetIpomCodesQueryVariables = Exact<{
  patientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetIpomCodesQuery = { __typename?: 'Query', doctorGetIpomCodes: Array<string> };

export type DoctorGetIpomSpecialistsQueryVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type DoctorGetIpomSpecialistsQuery = { __typename?: 'Query', doctorGetIpomSpecialists: Array<string> };

export type GetNumberOfPrescriptionRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNumberOfPrescriptionRequestsQuery = { __typename?: 'Query', doctorNumberOfPrescriptionRequests: number };

export type DoctorAdditionalMedicalServicesQueryVariables = Exact<{
  visitId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorAdditionalMedicalServicesQuery = { __typename?: 'Query', doctorAdditionalMedicalServices: Array<string> };

export type DoctorGetPatientCardNumberQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DoctorGetPatientCardNumberQuery = { __typename?: 'Query', doctorPatient?: { __typename?: 'DoctorMSPatient', id: string, patientCardNumber: string } | null };

export type EdmGetAllShiftsQueryVariables = Exact<{
  input: EdmGetAllShiftsInput;
}>;


export type EdmGetAllShiftsQuery = { __typename?: 'Query', edmGetAllShifts: Array<{ __typename: 'EdmMedicalAppShift', id: string, organizationId: string, day: any, startFrom: any, endedAt: any, comment?: string | null, state: EdmMedicalAppShiftState, status: EdmMedicalAppShiftStatus, workPlace: EdmMedicalAppShiftWorkPlace, visitTypes: Array<EdmMedicalAppVisitType>, confirmed: boolean, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, acceptAdults: boolean, acceptChildren: boolean, adultDeclarable: boolean, childrenDeclarable: boolean }, createdBy: { __typename?: 'EdmMedicalPerson', name?: string | null }, durationTimeMap: { __typename?: 'EdmDurationTimeMap', IN_PERSON: number, TELEMEDICAL: number, DOCTOR_TELEMEDICAL_INFECTION: number, NURSE_IN_PERSON_INFECTION: number, PROCEDURE: number, COLLECTION: number, RADIOLOGY_APPOINTMENT: number, SPECIALIST: number, SICK_CHILDREN: number, PRESCRIPTION_APPOINTMENT: number, EXPRESS_APPOINTMENT: number, DOCTOR_HOUSE_CALL: number, NURSE_HOUSE_CALL: number, MIDWIFE_HOUSE_CALL: number, MIDWIFE_IN_PERSON: number, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE: number, HEALTHY_CHILDREN_CHECKUP: number, HEALTHY_CHILDREN_VACCINE: number, HEALTHY_CHILDREN_PATRONAGE: number, NURSE_IN_PERSON: number, NURSE_HEALTHY_CHILDREN?: number | null } }> };

export type EdmGetAllDoctorsFromShiftsQueryVariables = Exact<{
  input: EdmGetAllDoctorsFromShiftsInput;
}>;


export type EdmGetAllDoctorsFromShiftsQuery = { __typename?: 'Query', edmGetAllDoctorsFromShiftsWithPreviousMonthResolver: Array<{ __typename?: 'EdmMedicalPerson', id: string, gender: EdmGender, genre: EdmGenreType }> };

export type EdmGetVisitTypesByGenreQueryVariables = Exact<{
  input: EdmGetVisitTypesByGenreInput;
}>;


export type EdmGetVisitTypesByGenreQuery = { __typename?: 'Query', edmGetVisitTypesByGenre: Array<EdmMedicalAppVisitType> };

export type EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables = Exact<{
  input: EdmGetAllStaffWithGenreAndWorkingHoursInput;
}>;


export type EdmGetAllStaffWithGenreAndWorkingHoursQuery = { __typename?: 'Query', edmGetAllStaffWithGenreAndWorkingHours: Array<{ __typename?: 'EdmStaffWorkingHours', medicalPerson: { __typename?: 'EdmMedicalPerson', id: string, name?: string | null, firstname?: string | null, lastname?: string | null, avatarUrl?: string | null, genre: EdmGenreType, gender: EdmGender, npwz?: string | null, acceptChildren: boolean, acceptAdults: boolean, childrenDeclarable: boolean, adultDeclarable: boolean, languages?: Array<string> | null, preferences?: { __typename?: 'EdmPreferences', minAllowedChildAge?: number | null } | null }, workedHours?: { __typename?: 'EdmWorkedHours', expectedWorkingHours?: string | null, alreadyWorkedHours: string, hoursToWorkLeft?: string | null } | null }> };

export type EdmGetAllNonWorkingPeriodsQueryVariables = Exact<{
  input: EdmGetAllNonWorkingPeriodsInput;
}>;


export type EdmGetAllNonWorkingPeriodsQuery = { __typename?: 'Query', edmGetAllNonWorkingPeriods: Array<{ __typename: 'EdmNonWorkingPeriod', id: string, day: any, startFrom: any, endedAt: any, leaveType: EdmLeaveType, comment?: string | null, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, childrenDeclarable: boolean, adultDeclarable: boolean, acceptChildren: boolean, acceptAdults: boolean } }> };

export type EdmGetAllVisitsForDeletedShiftsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type EdmGetAllVisitsForDeletedShiftsQuery = { __typename?: 'Query', edmGetAllVisitsForDeletedShifts: Array<{ __typename: 'EdmClinicManagerVisit', id: string, referenceOldVisitId: string, shiftId?: string | null, state: string, type: string, patientId: string, staffId: string, estimatedDurationTime: number, createdAt: any, scheduledOn: any, organizationId: string, cancelledAt?: any | null, cancelledReason?: string | null, startedAt?: any | null, closedAt?: any | null, patientLeftAt?: any | null, cancellationComment?: string | null, patient: { __typename?: 'EdmPatient', id: string, firstName: string, lastName: string, patientCardNumber: string, pesel: string, phone?: string | null }, staff: { __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, gender: EdmGender, genre: EdmGenreType, npwz?: string | null, childrenDeclarable: boolean, adultDeclarable: boolean, acceptAdults: boolean, acceptChildren: boolean } }> };

export type DoctorArchivedVisitListQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  filters?: InputMaybe<DoctorMSVisitFilterInput>;
}>;


export type DoctorArchivedVisitListQuery = { __typename?: 'Query', doctorArchivedVisitList: { __typename?: 'DoctorMSPaginatedVisitResponse', totalPages: number, currentPage: number, visits: Array<{ __typename?: 'DoctorMSVisit', id: string, status: DoctorMSVisitStatus, primaryMedicalService?: DoctorMSPrimaryMedicalService | null, additionalMedicalService?: Array<string> | null, doctorDiagnosis?: Array<{ __typename?: 'DoctorMSDiagnosis', code?: string | null, grade?: DoctorMSDiagnosisGrade | null } | null> | null, plannedStart?: { __typename?: 'DoctorMSTime', iso: string } | null, updatedAt: { __typename?: 'DoctorMSTime', iso: string }, patient?: { __typename?: 'DoctorMSPatient', patientCardNumber: string, pesel?: string | null } | null, doctor?: { __typename?: 'DoctorMSDoctor', id: string, firstName?: string | null, lastName?: string | null } | null }> } };

export type EdmGetAllSnippetsQueryVariables = Exact<{
  showAllFilter?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EdmGetAllSnippetsQuery = { __typename?: 'Query', edmGetAllSnippets: Array<{ __typename?: 'EdmSnippet', id: string, category?: string | null, content: string, counter: number, name: string, createdBy: string, createdAt: any, updatedAt?: any | null, type: EdmSnippetType, visibility: EdmSnippetVisibility, tags: Array<{ __typename?: 'EdmSnippetTag', id: string, name: string }> }> };

export type EdmGetAllSnippetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type EdmGetAllSnippetTagsQuery = { __typename?: 'Query', edmGetAllSnippetTags: Array<{ __typename?: 'EdmSnippetTag', id: string, name: string }> };

export type DoctorGetPatientLeaveHistoryByPeselQueryVariables = Exact<{
  input: DoctorMSGetMedicalLeavesInput;
}>;


export type DoctorGetPatientLeaveHistoryByPeselQuery = { __typename?: 'Query', doctorGetZusMedicalLeaves: Array<{ __typename?: 'DoctorMSZusMedicalLeave', id: string, insuredPersonPesel: string, insuredPersonFirstName: string, insuredPersonLastName: string, incapacityStartDate: string, incapacityEndDate: string, hospitalizationDaysCount: string, payerIdentifier: string, payerIdentifierType: string, statisticalDiseaseNumber: string, doctorNpwz: string, doctorFirstName: string, doctorLastName: string, leaveStatus: string, leaveIssueDate: string, leaveSeries: string, leaveNumber: string, relationshipCode?: string | null }> };

export type DoctorGetPatientPayersByPeselQueryVariables = Exact<{
  input: DoctorMSGetZusPayersInput;
}>;


export type DoctorGetPatientPayersByPeselQuery = { __typename?: 'Query', doctorGetZusPayers: Array<{ __typename?: 'DoctorMSZusPayer', id: string, name: string, firstName: string, lastName: string, nip: string, pesel: string, passportNumber: string, pueProfile: boolean }> };

export type ZusGetPayerDataQueryVariables = Exact<{
  nip: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
}>;


export type ZusGetPayerDataQuery = { __typename?: 'Query', zusGetPayerData: { __typename?: 'ZusGetPayerDataResponse', result: { __typename?: 'ZusZusResult', errorCode: string, errorMessage: string }, payerData: { __typename?: 'ZusPayerData', name?: string | null, firstName?: string | null, lastName?: string | null, hasPueProfile: boolean } } };

export type EdmSearchAvailabilityQueryVariables = Exact<{
  input: EdmShiftSearchAvailabilityInput;
}>;


export type EdmSearchAvailabilityQuery = { __typename?: 'Query', edmSearchAvailability: { __typename?: 'EdmCalendarAvailability', dates: Array<string>, medicalPeople: Array<{ __typename?: 'EdmMedicalPerson', id: string, firstname?: string | null, lastname?: string | null, languages?: Array<string> | null }> } };

export type EdmSearchAvailabilityForDayQueryVariables = Exact<{
  input: EdmShiftSearchAvailabilityForDayInput;
}>;


export type EdmSearchAvailabilityForDayQuery = { __typename?: 'Query', edmSearchAvailabilityForDay: Array<{ __typename?: 'EdmSlot', from: any, to: any, shifts: Array<{ __typename?: 'EdmShift', id: string, version: number, staffId: string }> }> };

export type EdmGetStaffVisitDurationQueryVariables = Exact<{
  staffId: Scalars['String']['input'];
}>;


export type EdmGetStaffVisitDurationQuery = { __typename?: 'Query', edmGetStaffVisitDuration: { __typename?: 'EdmVisitTimeDuration', IN_PERSON?: number | null, TELEMEDICAL?: number | null, DOCTOR_TELEMEDICAL_INFECTION?: number | null, NURSE_IN_PERSON_INFECTION?: number | null, PROCEDURE?: number | null, COLLECTION?: number | null, RADIOLOGY_APPOINTMENT?: number | null, SPECIALIST?: number | null, PRESCRIPTION_APPOINTMENT?: number | null, EXPRESS_APPOINTMENT?: number | null, DOCTOR_HOUSE_CALL?: number | null, NURSE_HOUSE_CALL?: number | null, MIDWIFE_HOUSE_CALL?: number | null, MIDWIFE_IN_PERSON?: number | null, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE?: number | null, HEALTHY_CHILDREN_CHECKUP?: number | null, HEALTHY_CHILDREN_VACCINE?: number | null, HEALTHY_CHILDREN_PATRONAGE?: number | null, NURSE_IN_PERSON?: number | null, NURSE_HEALTHY_CHILDREN?: number | null } };

export type EdmGetDefaultVisitDurationQueryVariables = Exact<{ [key: string]: never; }>;


export type EdmGetDefaultVisitDurationQuery = { __typename?: 'Query', edmGetDefaultVisitDuration: { __typename?: 'EdmVisitTimeDuration', IN_PERSON?: number | null, TELEMEDICAL?: number | null, DOCTOR_TELEMEDICAL_INFECTION?: number | null, NURSE_IN_PERSON_INFECTION?: number | null, PROCEDURE?: number | null, COLLECTION?: number | null, RADIOLOGY_APPOINTMENT?: number | null, SPECIALIST?: number | null, PRESCRIPTION_APPOINTMENT?: number | null, EXPRESS_APPOINTMENT?: number | null, DOCTOR_HOUSE_CALL?: number | null, NURSE_HOUSE_CALL?: number | null, MIDWIFE_HOUSE_CALL?: number | null, MIDWIFE_IN_PERSON?: number | null, HEALTHY_CHILDREN_CHECKUP_AND_VACCINE?: number | null, HEALTHY_CHILDREN_CHECKUP?: number | null, HEALTHY_CHILDREN_VACCINE?: number | null, HEALTHY_CHILDREN_PATRONAGE?: number | null, NURSE_IN_PERSON?: number | null, NURSE_HEALTHY_CHILDREN?: number | null } };

export const DoctorRequestedDrugFragmentDoc = gql`
    fragment DoctorRequestedDrug on DoctorMSRequestedDrugDto {
  ean
  quantity
  resolvedInPrescriptions {
    id
  }
  regularDrugSourceTag {
    id
    data
    type
    createdAt
    patientId
    updatedAt
    confirmationType
    expirationAt
  }
  details {
    name
    box
    ean
    form
    dosage
    productCharacteristics
    use
    composition
    effect
    indications
    contraindications
    comments
    precautions
    interactions
    pregnantWomenInstructions
    hasPsychoSubstances
    isCustom
    pregnacyDetails {
      entirePregnacy {
        key
        value
      }
      firstTrimester {
        key
        value
      }
      secondTrimester {
        key
        value
      }
      thirdTrimester {
        key
        value
      }
      lactation {
        key
        value
      }
    }
    activeSubstances {
      unitCode
      amountPerItem
      amountPerPackage
      name
      substanceId
    }
    paymentLevels {
      value
      price
      description
      detailedDescription
      type
      paymentKey
    }
    additionalRefunds
  }
  __typename
}
    `;
export const DoctorSourceTagFragmentDoc = gql`
    fragment DoctorSourceTag on DoctorMSPatientTagEntity {
  id
  data
  type
  createdAt
  patientId
  updatedAt
  confirmationType
  expirationAt
}
    `;
export const DoctorPatientGuardiansFragmentDoc = gql`
    fragment DoctorPatientGuardians on DoctorMSPatient {
  id
  firstName
  lastName
  patientCardNumber
  pesel
  address {
    city
    state
    teryt
    street
    zipCode
    latitude
    longitude
    flatNumber
    houseNumber
    municipality
  }
  phone
  email
  __typename
}
    `;
export const DoctorTemplateParamsFragmentDoc = gql`
    fragment DoctorTemplateParams on DoctorMSVitalParam {
  __typename
  name
  value
  min
  max
  unit
  text
  icd9
}
    `;
export const DoctorTemplateOfLabExamFragmentDoc = gql`
    fragment DoctorTemplateOfLabExam on DoctorMSLabExamTemplate {
  __typename
  assignment {
    name
    foreignServiceId
  }
  params {
    ...DoctorTemplateParams
  }
}
    ${DoctorTemplateParamsFragmentDoc}`;
export const DoctorInsuranceStatusFragmentFragmentDoc = gql`
    fragment DoctorInsuranceStatusFragment on DoctorMSPatientInsuranceStatusEvent {
  ... on DoctorMSInsuranceStatusEvent {
    createdAt
    status {
      ... on DoctorMSEwusCheckEvent {
        createdAt
        event {
          ... on DoctorMSEwusGreenEvent {
            createdAt
            __typename
            id
          }
          ... on DoctorMSEwusRedEvent {
            createdAt
            __typename
            id
          }
        }
      }
      ... on DoctorMSInsuranceContributionCertificateEvent {
        createdAt
        __typename
        id
      }
      ... on DoctorMSPatientInsuranceStatementEvent {
        createdAt
        __typename
        id
        reason
      }
    }
  }
  ... on DoctorMSUnknownEvent {
    createdAt
    __typename
    id
  }
}
    `;
export const DoctorPatientWardsFragmentDoc = gql`
    fragment DoctorPatientWards on DoctorMSPatient {
  id
  firstName
  lastName
  patientCardNumber
  pesel
  address {
    city
    state
    teryt
    street
    zipCode
    latitude
    longitude
    flatNumber
    houseNumber
    municipality
  }
  phone
  email
  __typename
}
    `;
export const DoctorDeclarationSubmittedFragmentDoc = gql`
    fragment DoctorDeclarationSubmitted on DoctorMSDeclarationSubmittedEvent {
  __typename
  id
  createdAt
  vojevodship
  source
  marketingSource
  comment
  date
  files
  filename
  signature
  isElectronicallySigned
  declarationUploadStaff {
    firstName
    lastName
  }
  declarationGenerationParams {
    frequentFacilityChangeReason
    anotherProviderReason
  }
  doctor {
    id
    firstName
    lastName
    isDeclarable
    adultDeclarable
    childrenDeclarable
    genre
    npwz
  }
}
    `;
export const EdmMedicalAppShiftWithoutVisitFragmentDoc = gql`
    fragment EdmMedicalAppShiftWithoutVisit on EdmMedicalAppShift {
  __typename
  id
  organizationId
  staff {
    id
    firstname
    lastname
    gender
    genre
    npwz
    acceptAdults
    acceptChildren
    adultDeclarable
    childrenDeclarable
  }
  day
  startFrom
  endedAt
  comment
  state
  status
  workPlace
  visitTypes
  confirmed
  createdBy {
    name
  }
  durationTimeMap {
    IN_PERSON
    TELEMEDICAL
    DOCTOR_TELEMEDICAL_INFECTION
    NURSE_IN_PERSON_INFECTION
    PROCEDURE
    COLLECTION
    RADIOLOGY_APPOINTMENT
    SPECIALIST
    SICK_CHILDREN
    PRESCRIPTION_APPOINTMENT
    EXPRESS_APPOINTMENT
    DOCTOR_HOUSE_CALL
    NURSE_HOUSE_CALL
    MIDWIFE_HOUSE_CALL
    MIDWIFE_IN_PERSON
    HEALTHY_CHILDREN_CHECKUP_AND_VACCINE
    HEALTHY_CHILDREN_CHECKUP
    HEALTHY_CHILDREN_VACCINE
    HEALTHY_CHILDREN_PATRONAGE
    NURSE_IN_PERSON
    NURSE_HEALTHY_CHILDREN
  }
}
    `;
export const DoctorUpdatePatientDocument = gql`
    mutation DoctorUpdatePatient($id: String!, $input: DoctorMSPatientInput!) {
  doctorUpdatePatient(id: $id, input: $input)
}
    `;
export type DoctorUpdatePatientMutationFn = Apollo.MutationFunction<DoctorUpdatePatientMutation, DoctorUpdatePatientMutationVariables>;

/**
 * __useDoctorUpdatePatientMutation__
 *
 * To run a mutation, you first call `useDoctorUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdatePatientMutation, { data, loading, error }] = useDoctorUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdatePatientMutation, DoctorUpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdatePatientMutation, DoctorUpdatePatientMutationVariables>(DoctorUpdatePatientDocument, options);
      }
export type DoctorUpdatePatientMutationHookResult = ReturnType<typeof useDoctorUpdatePatientMutation>;
export type DoctorUpdatePatientMutationResult = Apollo.MutationResult<DoctorUpdatePatientMutation>;
export type DoctorUpdatePatientMutationOptions = Apollo.BaseMutationOptions<DoctorUpdatePatientMutation, DoctorUpdatePatientMutationVariables>;
export const DoctorDeletePatientDocument = gql`
    mutation DoctorDeletePatient($phone: String!) {
  doctorDeletePatient(phone: $phone)
}
    `;
export type DoctorDeletePatientMutationFn = Apollo.MutationFunction<DoctorDeletePatientMutation, DoctorDeletePatientMutationVariables>;

/**
 * __useDoctorDeletePatientMutation__
 *
 * To run a mutation, you first call `useDoctorDeletePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeletePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeletePatientMutation, { data, loading, error }] = useDoctorDeletePatientMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useDoctorDeletePatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeletePatientMutation, DoctorDeletePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeletePatientMutation, DoctorDeletePatientMutationVariables>(DoctorDeletePatientDocument, options);
      }
export type DoctorDeletePatientMutationHookResult = ReturnType<typeof useDoctorDeletePatientMutation>;
export type DoctorDeletePatientMutationResult = Apollo.MutationResult<DoctorDeletePatientMutation>;
export type DoctorDeletePatientMutationOptions = Apollo.BaseMutationOptions<DoctorDeletePatientMutation, DoctorDeletePatientMutationVariables>;
export const DoctorUpdateVisitDocument = gql`
    mutation DoctorUpdateVisit($id: String!, $input: DoctorMSVisitInput!) {
  doctorUpdateVisit(id: $id, input: $input)
}
    `;
export type DoctorUpdateVisitMutationFn = Apollo.MutationFunction<DoctorUpdateVisitMutation, DoctorUpdateVisitMutationVariables>;

/**
 * __useDoctorUpdateVisitMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateVisitMutation, { data, loading, error }] = useDoctorUpdateVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorUpdateVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateVisitMutation, DoctorUpdateVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateVisitMutation, DoctorUpdateVisitMutationVariables>(DoctorUpdateVisitDocument, options);
      }
export type DoctorUpdateVisitMutationHookResult = ReturnType<typeof useDoctorUpdateVisitMutation>;
export type DoctorUpdateVisitMutationResult = Apollo.MutationResult<DoctorUpdateVisitMutation>;
export type DoctorUpdateVisitMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateVisitMutation, DoctorUpdateVisitMutationVariables>;
export const DoctorCreateDocumentDocument = gql`
    mutation DoctorCreateDocument($input: DoctorMSCreateDocumentInput!) {
  doctorCreateDocument(input: $input) {
    id
  }
}
    `;
export type DoctorCreateDocumentMutationFn = Apollo.MutationFunction<DoctorCreateDocumentMutation, DoctorCreateDocumentMutationVariables>;

/**
 * __useDoctorCreateDocumentMutation__
 *
 * To run a mutation, you first call `useDoctorCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateDocumentMutation, { data, loading, error }] = useDoctorCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateDocumentMutation, DoctorCreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateDocumentMutation, DoctorCreateDocumentMutationVariables>(DoctorCreateDocumentDocument, options);
      }
export type DoctorCreateDocumentMutationHookResult = ReturnType<typeof useDoctorCreateDocumentMutation>;
export type DoctorCreateDocumentMutationResult = Apollo.MutationResult<DoctorCreateDocumentMutation>;
export type DoctorCreateDocumentMutationOptions = Apollo.BaseMutationOptions<DoctorCreateDocumentMutation, DoctorCreateDocumentMutationVariables>;
export const DoctorUpdateDocumentDocument = gql`
    mutation DoctorUpdateDocument($id: String!, $input: DoctorMSUpdateDocumentInput!) {
  doctorUpdateDocument(id: $id, input: $input)
}
    `;
export type DoctorUpdateDocumentMutationFn = Apollo.MutationFunction<DoctorUpdateDocumentMutation, DoctorUpdateDocumentMutationVariables>;

/**
 * __useDoctorUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateDocumentMutation, { data, loading, error }] = useDoctorUpdateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateDocumentMutation, DoctorUpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateDocumentMutation, DoctorUpdateDocumentMutationVariables>(DoctorUpdateDocumentDocument, options);
      }
export type DoctorUpdateDocumentMutationHookResult = ReturnType<typeof useDoctorUpdateDocumentMutation>;
export type DoctorUpdateDocumentMutationResult = Apollo.MutationResult<DoctorUpdateDocumentMutation>;
export type DoctorUpdateDocumentMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateDocumentMutation, DoctorUpdateDocumentMutationVariables>;
export const DoctorArchiveDocumentDocument = gql`
    mutation DoctorArchiveDocument($id: String!) {
  doctorArchiveDocument(id: $id)
}
    `;
export type DoctorArchiveDocumentMutationFn = Apollo.MutationFunction<DoctorArchiveDocumentMutation, DoctorArchiveDocumentMutationVariables>;

/**
 * __useDoctorArchiveDocumentMutation__
 *
 * To run a mutation, you first call `useDoctorArchiveDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorArchiveDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorArchiveDocumentMutation, { data, loading, error }] = useDoctorArchiveDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorArchiveDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorArchiveDocumentMutation, DoctorArchiveDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorArchiveDocumentMutation, DoctorArchiveDocumentMutationVariables>(DoctorArchiveDocumentDocument, options);
      }
export type DoctorArchiveDocumentMutationHookResult = ReturnType<typeof useDoctorArchiveDocumentMutation>;
export type DoctorArchiveDocumentMutationResult = Apollo.MutationResult<DoctorArchiveDocumentMutation>;
export type DoctorArchiveDocumentMutationOptions = Apollo.BaseMutationOptions<DoctorArchiveDocumentMutation, DoctorArchiveDocumentMutationVariables>;
export const DoctorChangePasswordDocument = gql`
    mutation DoctorChangePassword($input: DoctorMSChangePasswordInput!) {
  doctorChangePassword(input: $input)
}
    `;
export type DoctorChangePasswordMutationFn = Apollo.MutationFunction<DoctorChangePasswordMutation, DoctorChangePasswordMutationVariables>;

/**
 * __useDoctorChangePasswordMutation__
 *
 * To run a mutation, you first call `useDoctorChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorChangePasswordMutation, { data, loading, error }] = useDoctorChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<DoctorChangePasswordMutation, DoctorChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorChangePasswordMutation, DoctorChangePasswordMutationVariables>(DoctorChangePasswordDocument, options);
      }
export type DoctorChangePasswordMutationHookResult = ReturnType<typeof useDoctorChangePasswordMutation>;
export type DoctorChangePasswordMutationResult = Apollo.MutationResult<DoctorChangePasswordMutation>;
export type DoctorChangePasswordMutationOptions = Apollo.BaseMutationOptions<DoctorChangePasswordMutation, DoctorChangePasswordMutationVariables>;
export const DoctorMarkPostsAsSeenDocument = gql`
    mutation DoctorMarkPostsAsSeen($ids: [String!]!) {
  doctorMarkPostsAsSeen(ids: $ids)
}
    `;
export type DoctorMarkPostsAsSeenMutationFn = Apollo.MutationFunction<DoctorMarkPostsAsSeenMutation, DoctorMarkPostsAsSeenMutationVariables>;

/**
 * __useDoctorMarkPostsAsSeenMutation__
 *
 * To run a mutation, you first call `useDoctorMarkPostsAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorMarkPostsAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorMarkPostsAsSeenMutation, { data, loading, error }] = useDoctorMarkPostsAsSeenMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDoctorMarkPostsAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<DoctorMarkPostsAsSeenMutation, DoctorMarkPostsAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorMarkPostsAsSeenMutation, DoctorMarkPostsAsSeenMutationVariables>(DoctorMarkPostsAsSeenDocument, options);
      }
export type DoctorMarkPostsAsSeenMutationHookResult = ReturnType<typeof useDoctorMarkPostsAsSeenMutation>;
export type DoctorMarkPostsAsSeenMutationResult = Apollo.MutationResult<DoctorMarkPostsAsSeenMutation>;
export type DoctorMarkPostsAsSeenMutationOptions = Apollo.BaseMutationOptions<DoctorMarkPostsAsSeenMutation, DoctorMarkPostsAsSeenMutationVariables>;
export const DoctorUpdateMeDocument = gql`
    mutation DoctorUpdateMe($id: String!, $input: DoctorMSDoctorInput!) {
  doctorUpdateMe(id: $id, input: $input)
}
    `;
export type DoctorUpdateMeMutationFn = Apollo.MutationFunction<DoctorUpdateMeMutation, DoctorUpdateMeMutationVariables>;

/**
 * __useDoctorUpdateMeMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateMeMutation, { data, loading, error }] = useDoctorUpdateMeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateMeMutation, DoctorUpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateMeMutation, DoctorUpdateMeMutationVariables>(DoctorUpdateMeDocument, options);
      }
export type DoctorUpdateMeMutationHookResult = ReturnType<typeof useDoctorUpdateMeMutation>;
export type DoctorUpdateMeMutationResult = Apollo.MutationResult<DoctorUpdateMeMutation>;
export type DoctorUpdateMeMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateMeMutation, DoctorUpdateMeMutationVariables>;
export const DoctorShowSnippetDocument = gql`
    mutation DoctorShowSnippet($id: String!, $doctorId: String!) {
  doctorShowSnippet(id: $id, doctorId: $doctorId) {
    id
  }
}
    `;
export type DoctorShowSnippetMutationFn = Apollo.MutationFunction<DoctorShowSnippetMutation, DoctorShowSnippetMutationVariables>;

/**
 * __useDoctorShowSnippetMutation__
 *
 * To run a mutation, you first call `useDoctorShowSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorShowSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorShowSnippetMutation, { data, loading, error }] = useDoctorShowSnippetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      doctorId: // value for 'doctorId'
 *   },
 * });
 */
export function useDoctorShowSnippetMutation(baseOptions?: Apollo.MutationHookOptions<DoctorShowSnippetMutation, DoctorShowSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorShowSnippetMutation, DoctorShowSnippetMutationVariables>(DoctorShowSnippetDocument, options);
      }
export type DoctorShowSnippetMutationHookResult = ReturnType<typeof useDoctorShowSnippetMutation>;
export type DoctorShowSnippetMutationResult = Apollo.MutationResult<DoctorShowSnippetMutation>;
export type DoctorShowSnippetMutationOptions = Apollo.BaseMutationOptions<DoctorShowSnippetMutation, DoctorShowSnippetMutationVariables>;
export const DoctorIssueReferralDocument = gql`
    mutation DoctorIssueReferral($input: DoctorMSIssueReferralInput!) {
  doctorIssueReferral(input: $input)
}
    `;
export type DoctorIssueReferralMutationFn = Apollo.MutationFunction<DoctorIssueReferralMutation, DoctorIssueReferralMutationVariables>;

/**
 * __useDoctorIssueReferralMutation__
 *
 * To run a mutation, you first call `useDoctorIssueReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssueReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssueReferralMutation, { data, loading, error }] = useDoctorIssueReferralMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorIssueReferralMutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssueReferralMutation, DoctorIssueReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssueReferralMutation, DoctorIssueReferralMutationVariables>(DoctorIssueReferralDocument, options);
      }
export type DoctorIssueReferralMutationHookResult = ReturnType<typeof useDoctorIssueReferralMutation>;
export type DoctorIssueReferralMutationResult = Apollo.MutationResult<DoctorIssueReferralMutation>;
export type DoctorIssueReferralMutationOptions = Apollo.BaseMutationOptions<DoctorIssueReferralMutation, DoctorIssueReferralMutationVariables>;
export const DoctorUpdateVitalDocument = gql`
    mutation DoctorUpdateVital($id: String!, $specificInput: DoctorMSJSON!) {
  doctorUpdateVital(id: $id, specificInput: $specificInput)
}
    `;
export type DoctorUpdateVitalMutationFn = Apollo.MutationFunction<DoctorUpdateVitalMutation, DoctorUpdateVitalMutationVariables>;

/**
 * __useDoctorUpdateVitalMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateVitalMutation, { data, loading, error }] = useDoctorUpdateVitalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      specificInput: // value for 'specificInput'
 *   },
 * });
 */
export function useDoctorUpdateVitalMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateVitalMutation, DoctorUpdateVitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateVitalMutation, DoctorUpdateVitalMutationVariables>(DoctorUpdateVitalDocument, options);
      }
export type DoctorUpdateVitalMutationHookResult = ReturnType<typeof useDoctorUpdateVitalMutation>;
export type DoctorUpdateVitalMutationResult = Apollo.MutationResult<DoctorUpdateVitalMutation>;
export type DoctorUpdateVitalMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateVitalMutation, DoctorUpdateVitalMutationVariables>;
export const DoctorCreateChatMessageDocument = gql`
    mutation DoctorCreateChatMessage($id: String!, $input: DoctorMSChatMessageInput!, $isSystem: Boolean) {
  doctorCreateChatMessage(id: $id, input: $input, isSystem: $isSystem)
}
    `;
export type DoctorCreateChatMessageMutationFn = Apollo.MutationFunction<DoctorCreateChatMessageMutation, DoctorCreateChatMessageMutationVariables>;

/**
 * __useDoctorCreateChatMessageMutation__
 *
 * To run a mutation, you first call `useDoctorCreateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateChatMessageMutation, { data, loading, error }] = useDoctorCreateChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      isSystem: // value for 'isSystem'
 *   },
 * });
 */
export function useDoctorCreateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateChatMessageMutation, DoctorCreateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateChatMessageMutation, DoctorCreateChatMessageMutationVariables>(DoctorCreateChatMessageDocument, options);
      }
export type DoctorCreateChatMessageMutationHookResult = ReturnType<typeof useDoctorCreateChatMessageMutation>;
export type DoctorCreateChatMessageMutationResult = Apollo.MutationResult<DoctorCreateChatMessageMutation>;
export type DoctorCreateChatMessageMutationOptions = Apollo.BaseMutationOptions<DoctorCreateChatMessageMutation, DoctorCreateChatMessageMutationVariables>;
export const DoctorDeleteChatMessageDocument = gql`
    mutation DoctorDeleteChatMessage($id: String!) {
  doctorDeleteChatMessage(id: $id)
}
    `;
export type DoctorDeleteChatMessageMutationFn = Apollo.MutationFunction<DoctorDeleteChatMessageMutation, DoctorDeleteChatMessageMutationVariables>;

/**
 * __useDoctorDeleteChatMessageMutation__
 *
 * To run a mutation, you first call `useDoctorDeleteChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeleteChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeleteChatMessageMutation, { data, loading, error }] = useDoctorDeleteChatMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeleteChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeleteChatMessageMutation, DoctorDeleteChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeleteChatMessageMutation, DoctorDeleteChatMessageMutationVariables>(DoctorDeleteChatMessageDocument, options);
      }
export type DoctorDeleteChatMessageMutationHookResult = ReturnType<typeof useDoctorDeleteChatMessageMutation>;
export type DoctorDeleteChatMessageMutationResult = Apollo.MutationResult<DoctorDeleteChatMessageMutation>;
export type DoctorDeleteChatMessageMutationOptions = Apollo.BaseMutationOptions<DoctorDeleteChatMessageMutation, DoctorDeleteChatMessageMutationVariables>;
export const DoctorGetContentFromImageDocument = gql`
    mutation DoctorGetContentFromImage($input: DoctorMSOCRImageInput!) {
  doctorGetContentFromImage(input: $input)
}
    `;
export type DoctorGetContentFromImageMutationFn = Apollo.MutationFunction<DoctorGetContentFromImageMutation, DoctorGetContentFromImageMutationVariables>;

/**
 * __useDoctorGetContentFromImageMutation__
 *
 * To run a mutation, you first call `useDoctorGetContentFromImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetContentFromImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorGetContentFromImageMutation, { data, loading, error }] = useDoctorGetContentFromImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorGetContentFromImageMutation(baseOptions?: Apollo.MutationHookOptions<DoctorGetContentFromImageMutation, DoctorGetContentFromImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorGetContentFromImageMutation, DoctorGetContentFromImageMutationVariables>(DoctorGetContentFromImageDocument, options);
      }
export type DoctorGetContentFromImageMutationHookResult = ReturnType<typeof useDoctorGetContentFromImageMutation>;
export type DoctorGetContentFromImageMutationResult = Apollo.MutationResult<DoctorGetContentFromImageMutation>;
export type DoctorGetContentFromImageMutationOptions = Apollo.BaseMutationOptions<DoctorGetContentFromImageMutation, DoctorGetContentFromImageMutationVariables>;
export const DoctorCreateSurveyDocument = gql`
    mutation DoctorCreateSurvey($input: DoctorMSSurveyProposalInput!) {
  doctorCreateSurvey(input: $input)
}
    `;
export type DoctorCreateSurveyMutationFn = Apollo.MutationFunction<DoctorCreateSurveyMutation, DoctorCreateSurveyMutationVariables>;

/**
 * __useDoctorCreateSurveyMutation__
 *
 * To run a mutation, you first call `useDoctorCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateSurveyMutation, { data, loading, error }] = useDoctorCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateSurveyMutation, DoctorCreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateSurveyMutation, DoctorCreateSurveyMutationVariables>(DoctorCreateSurveyDocument, options);
      }
export type DoctorCreateSurveyMutationHookResult = ReturnType<typeof useDoctorCreateSurveyMutation>;
export type DoctorCreateSurveyMutationResult = Apollo.MutationResult<DoctorCreateSurveyMutation>;
export type DoctorCreateSurveyMutationOptions = Apollo.BaseMutationOptions<DoctorCreateSurveyMutation, DoctorCreateSurveyMutationVariables>;
export const DoctorIssuePrescriptionDocument = gql`
    mutation DoctorIssuePrescription($input: DoctorMSIssuePrescriptionInput!) {
  doctorIssuePrescription(input: $input) {
    prescriptions {
      messageId
      prescriptionCode
    }
    operationIsSafe
  }
}
    `;
export type DoctorIssuePrescriptionMutationFn = Apollo.MutationFunction<DoctorIssuePrescriptionMutation, DoctorIssuePrescriptionMutationVariables>;

/**
 * __useDoctorIssuePrescriptionMutation__
 *
 * To run a mutation, you first call `useDoctorIssuePrescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssuePrescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssuePrescriptionMutation, { data, loading, error }] = useDoctorIssuePrescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorIssuePrescriptionMutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssuePrescriptionMutation, DoctorIssuePrescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssuePrescriptionMutation, DoctorIssuePrescriptionMutationVariables>(DoctorIssuePrescriptionDocument, options);
      }
export type DoctorIssuePrescriptionMutationHookResult = ReturnType<typeof useDoctorIssuePrescriptionMutation>;
export type DoctorIssuePrescriptionMutationResult = Apollo.MutationResult<DoctorIssuePrescriptionMutation>;
export type DoctorIssuePrescriptionMutationOptions = Apollo.BaseMutationOptions<DoctorIssuePrescriptionMutation, DoctorIssuePrescriptionMutationVariables>;
export const DoctorIssueNursePrescriptionDocument = gql`
    mutation DoctorIssueNursePrescription($input: DoctorMSIssuePrescriptionInput!) {
  doctorIssueNursePrescription(input: $input) {
    prescriptions {
      messageId
      prescriptionCode
    }
    operationIsSafe
  }
}
    `;
export type DoctorIssueNursePrescriptionMutationFn = Apollo.MutationFunction<DoctorIssueNursePrescriptionMutation, DoctorIssueNursePrescriptionMutationVariables>;

/**
 * __useDoctorIssueNursePrescriptionMutation__
 *
 * To run a mutation, you first call `useDoctorIssueNursePrescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssueNursePrescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssueNursePrescriptionMutation, { data, loading, error }] = useDoctorIssueNursePrescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorIssueNursePrescriptionMutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssueNursePrescriptionMutation, DoctorIssueNursePrescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssueNursePrescriptionMutation, DoctorIssueNursePrescriptionMutationVariables>(DoctorIssueNursePrescriptionDocument, options);
      }
export type DoctorIssueNursePrescriptionMutationHookResult = ReturnType<typeof useDoctorIssueNursePrescriptionMutation>;
export type DoctorIssueNursePrescriptionMutationResult = Apollo.MutationResult<DoctorIssueNursePrescriptionMutation>;
export type DoctorIssueNursePrescriptionMutationOptions = Apollo.BaseMutationOptions<DoctorIssueNursePrescriptionMutation, DoctorIssueNursePrescriptionMutationVariables>;
export const DoctorGenerateTestimonialDocument = gql`
    mutation DoctorGenerateTestimonial($request: DoctorMSTestimonialGenerationInput!) {
  doctorGenerateTestimonial(request: $request) {
    documentId
    fileUrl
  }
}
    `;
export type DoctorGenerateTestimonialMutationFn = Apollo.MutationFunction<DoctorGenerateTestimonialMutation, DoctorGenerateTestimonialMutationVariables>;

/**
 * __useDoctorGenerateTestimonialMutation__
 *
 * To run a mutation, you first call `useDoctorGenerateTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorGenerateTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorGenerateTestimonialMutation, { data, loading, error }] = useDoctorGenerateTestimonialMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useDoctorGenerateTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<DoctorGenerateTestimonialMutation, DoctorGenerateTestimonialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorGenerateTestimonialMutation, DoctorGenerateTestimonialMutationVariables>(DoctorGenerateTestimonialDocument, options);
      }
export type DoctorGenerateTestimonialMutationHookResult = ReturnType<typeof useDoctorGenerateTestimonialMutation>;
export type DoctorGenerateTestimonialMutationResult = Apollo.MutationResult<DoctorGenerateTestimonialMutation>;
export type DoctorGenerateTestimonialMutationOptions = Apollo.BaseMutationOptions<DoctorGenerateTestimonialMutation, DoctorGenerateTestimonialMutationVariables>;
export const DoctorCreateVisitDocument = gql`
    mutation DoctorCreateVisit($input: DoctorMSNewVisitInput!) {
  doctorCreateVisit(input: $input)
}
    `;
export type DoctorCreateVisitMutationFn = Apollo.MutationFunction<DoctorCreateVisitMutation, DoctorCreateVisitMutationVariables>;

/**
 * __useDoctorCreateVisitMutation__
 *
 * To run a mutation, you first call `useDoctorCreateVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateVisitMutation, { data, loading, error }] = useDoctorCreateVisitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateVisitMutation, DoctorCreateVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateVisitMutation, DoctorCreateVisitMutationVariables>(DoctorCreateVisitDocument, options);
      }
export type DoctorCreateVisitMutationHookResult = ReturnType<typeof useDoctorCreateVisitMutation>;
export type DoctorCreateVisitMutationResult = Apollo.MutationResult<DoctorCreateVisitMutation>;
export type DoctorCreateVisitMutationOptions = Apollo.BaseMutationOptions<DoctorCreateVisitMutation, DoctorCreateVisitMutationVariables>;
export const DoctorCreateVisitSlotDocument = gql`
    mutation DoctorCreateVisitSlot($serviceCode: String, $shiftVisitType: DoctorMSPShiftVisitType!, $shiftsSlot: [DoctorMSShiftsSlot!]!, $patientId: String!) {
  doctorCreateVisitSlot2(
    serviceCode: $serviceCode
    shiftVisitType: $shiftVisitType
    shiftsSlot: $shiftsSlot
    patientId: $patientId
  )
}
    `;
export type DoctorCreateVisitSlotMutationFn = Apollo.MutationFunction<DoctorCreateVisitSlotMutation, DoctorCreateVisitSlotMutationVariables>;

/**
 * __useDoctorCreateVisitSlotMutation__
 *
 * To run a mutation, you first call `useDoctorCreateVisitSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateVisitSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateVisitSlotMutation, { data, loading, error }] = useDoctorCreateVisitSlotMutation({
 *   variables: {
 *      serviceCode: // value for 'serviceCode'
 *      shiftVisitType: // value for 'shiftVisitType'
 *      shiftsSlot: // value for 'shiftsSlot'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorCreateVisitSlotMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateVisitSlotMutation, DoctorCreateVisitSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateVisitSlotMutation, DoctorCreateVisitSlotMutationVariables>(DoctorCreateVisitSlotDocument, options);
      }
export type DoctorCreateVisitSlotMutationHookResult = ReturnType<typeof useDoctorCreateVisitSlotMutation>;
export type DoctorCreateVisitSlotMutationResult = Apollo.MutationResult<DoctorCreateVisitSlotMutation>;
export type DoctorCreateVisitSlotMutationOptions = Apollo.BaseMutationOptions<DoctorCreateVisitSlotMutation, DoctorCreateVisitSlotMutationVariables>;
export const DoctorHideSnippetDocument = gql`
    mutation DoctorHideSnippet($id: String!, $input: DoctorMSDoctorInput!) {
  doctorUpdateMe(id: $id, input: $input)
}
    `;
export type DoctorHideSnippetMutationFn = Apollo.MutationFunction<DoctorHideSnippetMutation, DoctorHideSnippetMutationVariables>;

/**
 * __useDoctorHideSnippetMutation__
 *
 * To run a mutation, you first call `useDoctorHideSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorHideSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorHideSnippetMutation, { data, loading, error }] = useDoctorHideSnippetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorHideSnippetMutation(baseOptions?: Apollo.MutationHookOptions<DoctorHideSnippetMutation, DoctorHideSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorHideSnippetMutation, DoctorHideSnippetMutationVariables>(DoctorHideSnippetDocument, options);
      }
export type DoctorHideSnippetMutationHookResult = ReturnType<typeof useDoctorHideSnippetMutation>;
export type DoctorHideSnippetMutationResult = Apollo.MutationResult<DoctorHideSnippetMutation>;
export type DoctorHideSnippetMutationOptions = Apollo.BaseMutationOptions<DoctorHideSnippetMutation, DoctorHideSnippetMutationVariables>;
export const DoctorUpdateSnippetDocument = gql`
    mutation DoctorUpdateSnippet($id: String!, $input: DoctorMSSnippetInput!) {
  doctorUpdateSnippet(id: $id, input: $input) {
    id
  }
}
    `;
export type DoctorUpdateSnippetMutationFn = Apollo.MutationFunction<DoctorUpdateSnippetMutation, DoctorUpdateSnippetMutationVariables>;

/**
 * __useDoctorUpdateSnippetMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateSnippetMutation, { data, loading, error }] = useDoctorUpdateSnippetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorUpdateSnippetMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateSnippetMutation, DoctorUpdateSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateSnippetMutation, DoctorUpdateSnippetMutationVariables>(DoctorUpdateSnippetDocument, options);
      }
export type DoctorUpdateSnippetMutationHookResult = ReturnType<typeof useDoctorUpdateSnippetMutation>;
export type DoctorUpdateSnippetMutationResult = Apollo.MutationResult<DoctorUpdateSnippetMutation>;
export type DoctorUpdateSnippetMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateSnippetMutation, DoctorUpdateSnippetMutationVariables>;
export const DoctorDeleteSnippetDocument = gql`
    mutation DoctorDeleteSnippet($id: String!) {
  doctorDeleteSnippet(id: $id) {
    id
  }
}
    `;
export type DoctorDeleteSnippetMutationFn = Apollo.MutationFunction<DoctorDeleteSnippetMutation, DoctorDeleteSnippetMutationVariables>;

/**
 * __useDoctorDeleteSnippetMutation__
 *
 * To run a mutation, you first call `useDoctorDeleteSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeleteSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeleteSnippetMutation, { data, loading, error }] = useDoctorDeleteSnippetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeleteSnippetMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeleteSnippetMutation, DoctorDeleteSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeleteSnippetMutation, DoctorDeleteSnippetMutationVariables>(DoctorDeleteSnippetDocument, options);
      }
export type DoctorDeleteSnippetMutationHookResult = ReturnType<typeof useDoctorDeleteSnippetMutation>;
export type DoctorDeleteSnippetMutationResult = Apollo.MutationResult<DoctorDeleteSnippetMutation>;
export type DoctorDeleteSnippetMutationOptions = Apollo.BaseMutationOptions<DoctorDeleteSnippetMutation, DoctorDeleteSnippetMutationVariables>;
export const DoctorCreateSnippetDocument = gql`
    mutation DoctorCreateSnippet($input: DoctorMSSnippetInput!) {
  doctorCreateSnippet(input: $input) {
    id
  }
}
    `;
export type DoctorCreateSnippetMutationFn = Apollo.MutationFunction<DoctorCreateSnippetMutation, DoctorCreateSnippetMutationVariables>;

/**
 * __useDoctorCreateSnippetMutation__
 *
 * To run a mutation, you first call `useDoctorCreateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateSnippetMutation, { data, loading, error }] = useDoctorCreateSnippetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateSnippetMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateSnippetMutation, DoctorCreateSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateSnippetMutation, DoctorCreateSnippetMutationVariables>(DoctorCreateSnippetDocument, options);
      }
export type DoctorCreateSnippetMutationHookResult = ReturnType<typeof useDoctorCreateSnippetMutation>;
export type DoctorCreateSnippetMutationResult = Apollo.MutationResult<DoctorCreateSnippetMutation>;
export type DoctorCreateSnippetMutationOptions = Apollo.BaseMutationOptions<DoctorCreateSnippetMutation, DoctorCreateSnippetMutationVariables>;
export const DoctorCreateAssignmentDocument = gql`
    mutation DoctorCreateAssignment($input: DoctorMSPrescriptionInput!) {
  doctorCreateAssignment(input: $input)
}
    `;
export type DoctorCreateAssignmentMutationFn = Apollo.MutationFunction<DoctorCreateAssignmentMutation, DoctorCreateAssignmentMutationVariables>;

/**
 * __useDoctorCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useDoctorCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateAssignmentMutation, { data, loading, error }] = useDoctorCreateAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateAssignmentMutation, DoctorCreateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateAssignmentMutation, DoctorCreateAssignmentMutationVariables>(DoctorCreateAssignmentDocument, options);
      }
export type DoctorCreateAssignmentMutationHookResult = ReturnType<typeof useDoctorCreateAssignmentMutation>;
export type DoctorCreateAssignmentMutationResult = Apollo.MutationResult<DoctorCreateAssignmentMutation>;
export type DoctorCreateAssignmentMutationOptions = Apollo.BaseMutationOptions<DoctorCreateAssignmentMutation, DoctorCreateAssignmentMutationVariables>;
export const DoctorCreateIpomAssignmentDocument = gql`
    mutation DoctorCreateIpomAssignment($input: DoctorMSIpomProcedureAssignmentInput!) {
  doctorCreateIpomAssignment(input: $input)
}
    `;
export type DoctorCreateIpomAssignmentMutationFn = Apollo.MutationFunction<DoctorCreateIpomAssignmentMutation, DoctorCreateIpomAssignmentMutationVariables>;

/**
 * __useDoctorCreateIpomAssignmentMutation__
 *
 * To run a mutation, you first call `useDoctorCreateIpomAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateIpomAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateIpomAssignmentMutation, { data, loading, error }] = useDoctorCreateIpomAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateIpomAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateIpomAssignmentMutation, DoctorCreateIpomAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateIpomAssignmentMutation, DoctorCreateIpomAssignmentMutationVariables>(DoctorCreateIpomAssignmentDocument, options);
      }
export type DoctorCreateIpomAssignmentMutationHookResult = ReturnType<typeof useDoctorCreateIpomAssignmentMutation>;
export type DoctorCreateIpomAssignmentMutationResult = Apollo.MutationResult<DoctorCreateIpomAssignmentMutation>;
export type DoctorCreateIpomAssignmentMutationOptions = Apollo.BaseMutationOptions<DoctorCreateIpomAssignmentMutation, DoctorCreateIpomAssignmentMutationVariables>;
export const DoctorCreatePatientTagDocument = gql`
    mutation DoctorCreatePatientTag($input: DoctorMSPatientTagInput!, $fileIds: [String!]) {
  doctorCreatePatientTag(input: $input, fileIds: $fileIds)
}
    `;
export type DoctorCreatePatientTagMutationFn = Apollo.MutationFunction<DoctorCreatePatientTagMutation, DoctorCreatePatientTagMutationVariables>;

/**
 * __useDoctorCreatePatientTagMutation__
 *
 * To run a mutation, you first call `useDoctorCreatePatientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreatePatientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreatePatientTagMutation, { data, loading, error }] = useDoctorCreatePatientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDoctorCreatePatientTagMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreatePatientTagMutation, DoctorCreatePatientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreatePatientTagMutation, DoctorCreatePatientTagMutationVariables>(DoctorCreatePatientTagDocument, options);
      }
export type DoctorCreatePatientTagMutationHookResult = ReturnType<typeof useDoctorCreatePatientTagMutation>;
export type DoctorCreatePatientTagMutationResult = Apollo.MutationResult<DoctorCreatePatientTagMutation>;
export type DoctorCreatePatientTagMutationOptions = Apollo.BaseMutationOptions<DoctorCreatePatientTagMutation, DoctorCreatePatientTagMutationVariables>;
export const DoctorUpdatePatientTagDocument = gql`
    mutation DoctorUpdatePatientTag($id: String!, $input: DoctorMSPatientTagInput!, $fileIds: [String!]) {
  doctorUpdatePatientTag(id: $id, input: $input, fileIds: $fileIds)
}
    `;
export type DoctorUpdatePatientTagMutationFn = Apollo.MutationFunction<DoctorUpdatePatientTagMutation, DoctorUpdatePatientTagMutationVariables>;

/**
 * __useDoctorUpdatePatientTagMutation__
 *
 * To run a mutation, you first call `useDoctorUpdatePatientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdatePatientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdatePatientTagMutation, { data, loading, error }] = useDoctorUpdatePatientTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useDoctorUpdatePatientTagMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdatePatientTagMutation, DoctorUpdatePatientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdatePatientTagMutation, DoctorUpdatePatientTagMutationVariables>(DoctorUpdatePatientTagDocument, options);
      }
export type DoctorUpdatePatientTagMutationHookResult = ReturnType<typeof useDoctorUpdatePatientTagMutation>;
export type DoctorUpdatePatientTagMutationResult = Apollo.MutationResult<DoctorUpdatePatientTagMutation>;
export type DoctorUpdatePatientTagMutationOptions = Apollo.BaseMutationOptions<DoctorUpdatePatientTagMutation, DoctorUpdatePatientTagMutationVariables>;
export const DoctorDeletePatientTagDocument = gql`
    mutation DoctorDeletePatientTag($id: String!) {
  doctorDeletePatientTag(id: $id)
}
    `;
export type DoctorDeletePatientTagMutationFn = Apollo.MutationFunction<DoctorDeletePatientTagMutation, DoctorDeletePatientTagMutationVariables>;

/**
 * __useDoctorDeletePatientTagMutation__
 *
 * To run a mutation, you first call `useDoctorDeletePatientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeletePatientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeletePatientTagMutation, { data, loading, error }] = useDoctorDeletePatientTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeletePatientTagMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeletePatientTagMutation, DoctorDeletePatientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeletePatientTagMutation, DoctorDeletePatientTagMutationVariables>(DoctorDeletePatientTagDocument, options);
      }
export type DoctorDeletePatientTagMutationHookResult = ReturnType<typeof useDoctorDeletePatientTagMutation>;
export type DoctorDeletePatientTagMutationResult = Apollo.MutationResult<DoctorDeletePatientTagMutation>;
export type DoctorDeletePatientTagMutationOptions = Apollo.BaseMutationOptions<DoctorDeletePatientTagMutation, DoctorDeletePatientTagMutationVariables>;
export const DoctorCreateProcedureDocument = gql`
    mutation DoctorCreateProcedure($data: DoctorMSCreateProcedureInput!, $dataInput: DoctorMSJSONObject!) {
  doctorCreateProcedureNew(data: $data, dataInput: $dataInput) {
    id
  }
}
    `;
export type DoctorCreateProcedureMutationFn = Apollo.MutationFunction<DoctorCreateProcedureMutation, DoctorCreateProcedureMutationVariables>;

/**
 * __useDoctorCreateProcedureMutation__
 *
 * To run a mutation, you first call `useDoctorCreateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateProcedureMutation, { data, loading, error }] = useDoctorCreateProcedureMutation({
 *   variables: {
 *      data: // value for 'data'
 *      dataInput: // value for 'dataInput'
 *   },
 * });
 */
export function useDoctorCreateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateProcedureMutation, DoctorCreateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateProcedureMutation, DoctorCreateProcedureMutationVariables>(DoctorCreateProcedureDocument, options);
      }
export type DoctorCreateProcedureMutationHookResult = ReturnType<typeof useDoctorCreateProcedureMutation>;
export type DoctorCreateProcedureMutationResult = Apollo.MutationResult<DoctorCreateProcedureMutation>;
export type DoctorCreateProcedureMutationOptions = Apollo.BaseMutationOptions<DoctorCreateProcedureMutation, DoctorCreateProcedureMutationVariables>;
export const DoctorUpdateProcedureDocument = gql`
    mutation DoctorUpdateProcedure($procedureId: String!, $data: DoctorMSUpdateProcedureInput, $dataInput: DoctorMSJSONObject!) {
  doctorUpdateProcedureNew(
    procedureId: $procedureId
    data: $data
    dataInput: $dataInput
  )
}
    `;
export type DoctorUpdateProcedureMutationFn = Apollo.MutationFunction<DoctorUpdateProcedureMutation, DoctorUpdateProcedureMutationVariables>;

/**
 * __useDoctorUpdateProcedureMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateProcedureMutation, { data, loading, error }] = useDoctorUpdateProcedureMutation({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *      data: // value for 'data'
 *      dataInput: // value for 'dataInput'
 *   },
 * });
 */
export function useDoctorUpdateProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateProcedureMutation, DoctorUpdateProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateProcedureMutation, DoctorUpdateProcedureMutationVariables>(DoctorUpdateProcedureDocument, options);
      }
export type DoctorUpdateProcedureMutationHookResult = ReturnType<typeof useDoctorUpdateProcedureMutation>;
export type DoctorUpdateProcedureMutationResult = Apollo.MutationResult<DoctorUpdateProcedureMutation>;
export type DoctorUpdateProcedureMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateProcedureMutation, DoctorUpdateProcedureMutationVariables>;
export const DoctorUpdateLaboratoryExaminationDocument = gql`
    mutation DoctorUpdateLaboratoryExamination($ids: [String!]!, $data: DoctorMSLaboratoryExaminationUpdateDataInput!) {
  doctorUpdateLaboratoryExaminations(ids: $ids, data: $data)
}
    `;
export type DoctorUpdateLaboratoryExaminationMutationFn = Apollo.MutationFunction<DoctorUpdateLaboratoryExaminationMutation, DoctorUpdateLaboratoryExaminationMutationVariables>;

/**
 * __useDoctorUpdateLaboratoryExaminationMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateLaboratoryExaminationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateLaboratoryExaminationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateLaboratoryExaminationMutation, { data, loading, error }] = useDoctorUpdateLaboratoryExaminationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDoctorUpdateLaboratoryExaminationMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateLaboratoryExaminationMutation, DoctorUpdateLaboratoryExaminationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateLaboratoryExaminationMutation, DoctorUpdateLaboratoryExaminationMutationVariables>(DoctorUpdateLaboratoryExaminationDocument, options);
      }
export type DoctorUpdateLaboratoryExaminationMutationHookResult = ReturnType<typeof useDoctorUpdateLaboratoryExaminationMutation>;
export type DoctorUpdateLaboratoryExaminationMutationResult = Apollo.MutationResult<DoctorUpdateLaboratoryExaminationMutation>;
export type DoctorUpdateLaboratoryExaminationMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateLaboratoryExaminationMutation, DoctorUpdateLaboratoryExaminationMutationVariables>;
export const DoctorCreateLaboratoryExaminationsDocument = gql`
    mutation DoctorCreateLaboratoryExaminations($data: [DoctorMSLaboratoryExaminationCreationInput!]!, $createMessageOnChat: Boolean) {
  doctorCreateLaboratoryExaminations(
    data: $data
    createMessageOnChat: $createMessageOnChat
  ) {
    id
  }
}
    `;
export type DoctorCreateLaboratoryExaminationsMutationFn = Apollo.MutationFunction<DoctorCreateLaboratoryExaminationsMutation, DoctorCreateLaboratoryExaminationsMutationVariables>;

/**
 * __useDoctorCreateLaboratoryExaminationsMutation__
 *
 * To run a mutation, you first call `useDoctorCreateLaboratoryExaminationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateLaboratoryExaminationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateLaboratoryExaminationsMutation, { data, loading, error }] = useDoctorCreateLaboratoryExaminationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      createMessageOnChat: // value for 'createMessageOnChat'
 *   },
 * });
 */
export function useDoctorCreateLaboratoryExaminationsMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateLaboratoryExaminationsMutation, DoctorCreateLaboratoryExaminationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateLaboratoryExaminationsMutation, DoctorCreateLaboratoryExaminationsMutationVariables>(DoctorCreateLaboratoryExaminationsDocument, options);
      }
export type DoctorCreateLaboratoryExaminationsMutationHookResult = ReturnType<typeof useDoctorCreateLaboratoryExaminationsMutation>;
export type DoctorCreateLaboratoryExaminationsMutationResult = Apollo.MutationResult<DoctorCreateLaboratoryExaminationsMutation>;
export type DoctorCreateLaboratoryExaminationsMutationOptions = Apollo.BaseMutationOptions<DoctorCreateLaboratoryExaminationsMutation, DoctorCreateLaboratoryExaminationsMutationVariables>;
export const DoctorUnpinProcedureDocument = gql`
    mutation DoctorUnpinProcedure($id: String!) {
  doctorUnpinProcedure(id: $id) {
    id
  }
}
    `;
export type DoctorUnpinProcedureMutationFn = Apollo.MutationFunction<DoctorUnpinProcedureMutation, DoctorUnpinProcedureMutationVariables>;

/**
 * __useDoctorUnpinProcedureMutation__
 *
 * To run a mutation, you first call `useDoctorUnpinProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUnpinProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUnpinProcedureMutation, { data, loading, error }] = useDoctorUnpinProcedureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorUnpinProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUnpinProcedureMutation, DoctorUnpinProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUnpinProcedureMutation, DoctorUnpinProcedureMutationVariables>(DoctorUnpinProcedureDocument, options);
      }
export type DoctorUnpinProcedureMutationHookResult = ReturnType<typeof useDoctorUnpinProcedureMutation>;
export type DoctorUnpinProcedureMutationResult = Apollo.MutationResult<DoctorUnpinProcedureMutation>;
export type DoctorUnpinProcedureMutationOptions = Apollo.BaseMutationOptions<DoctorUnpinProcedureMutation, DoctorUnpinProcedureMutationVariables>;
export const DoctorDeleteVitalDocument = gql`
    mutation DoctorDeleteVital($id: String!) {
  doctorDeleteVital(id: $id)
}
    `;
export type DoctorDeleteVitalMutationFn = Apollo.MutationFunction<DoctorDeleteVitalMutation, DoctorDeleteVitalMutationVariables>;

/**
 * __useDoctorDeleteVitalMutation__
 *
 * To run a mutation, you first call `useDoctorDeleteVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeleteVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeleteVitalMutation, { data, loading, error }] = useDoctorDeleteVitalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeleteVitalMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeleteVitalMutation, DoctorDeleteVitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeleteVitalMutation, DoctorDeleteVitalMutationVariables>(DoctorDeleteVitalDocument, options);
      }
export type DoctorDeleteVitalMutationHookResult = ReturnType<typeof useDoctorDeleteVitalMutation>;
export type DoctorDeleteVitalMutationResult = Apollo.MutationResult<DoctorDeleteVitalMutation>;
export type DoctorDeleteVitalMutationOptions = Apollo.BaseMutationOptions<DoctorDeleteVitalMutation, DoctorDeleteVitalMutationVariables>;
export const DoctorSendInvitationForAVisitDocument = gql`
    mutation DoctorSendInvitationForAVisit($id: String!, $type: DoctorMSVisitType!) {
  doctorSendInvitationForVisit(id: $id, type: $type)
}
    `;
export type DoctorSendInvitationForAVisitMutationFn = Apollo.MutationFunction<DoctorSendInvitationForAVisitMutation, DoctorSendInvitationForAVisitMutationVariables>;

/**
 * __useDoctorSendInvitationForAVisitMutation__
 *
 * To run a mutation, you first call `useDoctorSendInvitationForAVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorSendInvitationForAVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorSendInvitationForAVisitMutation, { data, loading, error }] = useDoctorSendInvitationForAVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDoctorSendInvitationForAVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorSendInvitationForAVisitMutation, DoctorSendInvitationForAVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorSendInvitationForAVisitMutation, DoctorSendInvitationForAVisitMutationVariables>(DoctorSendInvitationForAVisitDocument, options);
      }
export type DoctorSendInvitationForAVisitMutationHookResult = ReturnType<typeof useDoctorSendInvitationForAVisitMutation>;
export type DoctorSendInvitationForAVisitMutationResult = Apollo.MutationResult<DoctorSendInvitationForAVisitMutation>;
export type DoctorSendInvitationForAVisitMutationOptions = Apollo.BaseMutationOptions<DoctorSendInvitationForAVisitMutation, DoctorSendInvitationForAVisitMutationVariables>;
export const DoctorCloseVisitDocument = gql`
    mutation DoctorCloseVisit($id: String!) {
  doctorCloseVisit(id: $id) {
    id
  }
}
    `;
export type DoctorCloseVisitMutationFn = Apollo.MutationFunction<DoctorCloseVisitMutation, DoctorCloseVisitMutationVariables>;

/**
 * __useDoctorCloseVisitMutation__
 *
 * To run a mutation, you first call `useDoctorCloseVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCloseVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCloseVisitMutation, { data, loading, error }] = useDoctorCloseVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorCloseVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCloseVisitMutation, DoctorCloseVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCloseVisitMutation, DoctorCloseVisitMutationVariables>(DoctorCloseVisitDocument, options);
      }
export type DoctorCloseVisitMutationHookResult = ReturnType<typeof useDoctorCloseVisitMutation>;
export type DoctorCloseVisitMutationResult = Apollo.MutationResult<DoctorCloseVisitMutation>;
export type DoctorCloseVisitMutationOptions = Apollo.BaseMutationOptions<DoctorCloseVisitMutation, DoctorCloseVisitMutationVariables>;
export const DoctorUnpinPatientDocument = gql`
    mutation DoctorUnpinPatient($id: String!) {
  doctorUnpinPatient(id: $id) {
    id
  }
}
    `;
export type DoctorUnpinPatientMutationFn = Apollo.MutationFunction<DoctorUnpinPatientMutation, DoctorUnpinPatientMutationVariables>;

/**
 * __useDoctorUnpinPatientMutation__
 *
 * To run a mutation, you first call `useDoctorUnpinPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUnpinPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUnpinPatientMutation, { data, loading, error }] = useDoctorUnpinPatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorUnpinPatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUnpinPatientMutation, DoctorUnpinPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUnpinPatientMutation, DoctorUnpinPatientMutationVariables>(DoctorUnpinPatientDocument, options);
      }
export type DoctorUnpinPatientMutationHookResult = ReturnType<typeof useDoctorUnpinPatientMutation>;
export type DoctorUnpinPatientMutationResult = Apollo.MutationResult<DoctorUnpinPatientMutation>;
export type DoctorUnpinPatientMutationOptions = Apollo.BaseMutationOptions<DoctorUnpinPatientMutation, DoctorUnpinPatientMutationVariables>;
export const DoctorClosePatientDocument = gql`
    mutation DoctorClosePatient($id: String!) {
  doctorClosePatient(id: $id) {
    id
  }
}
    `;
export type DoctorClosePatientMutationFn = Apollo.MutationFunction<DoctorClosePatientMutation, DoctorClosePatientMutationVariables>;

/**
 * __useDoctorClosePatientMutation__
 *
 * To run a mutation, you first call `useDoctorClosePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorClosePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorClosePatientMutation, { data, loading, error }] = useDoctorClosePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorClosePatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorClosePatientMutation, DoctorClosePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorClosePatientMutation, DoctorClosePatientMutationVariables>(DoctorClosePatientDocument, options);
      }
export type DoctorClosePatientMutationHookResult = ReturnType<typeof useDoctorClosePatientMutation>;
export type DoctorClosePatientMutationResult = Apollo.MutationResult<DoctorClosePatientMutation>;
export type DoctorClosePatientMutationOptions = Apollo.BaseMutationOptions<DoctorClosePatientMutation, DoctorClosePatientMutationVariables>;
export const DoctorWaitingForPatientDocument = gql`
    mutation DoctorWaitingForPatient($id: String!) {
  doctorWaitingForPatient(id: $id) {
    id
  }
}
    `;
export type DoctorWaitingForPatientMutationFn = Apollo.MutationFunction<DoctorWaitingForPatientMutation, DoctorWaitingForPatientMutationVariables>;

/**
 * __useDoctorWaitingForPatientMutation__
 *
 * To run a mutation, you first call `useDoctorWaitingForPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorWaitingForPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorWaitingForPatientMutation, { data, loading, error }] = useDoctorWaitingForPatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorWaitingForPatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorWaitingForPatientMutation, DoctorWaitingForPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorWaitingForPatientMutation, DoctorWaitingForPatientMutationVariables>(DoctorWaitingForPatientDocument, options);
      }
export type DoctorWaitingForPatientMutationHookResult = ReturnType<typeof useDoctorWaitingForPatientMutation>;
export type DoctorWaitingForPatientMutationResult = Apollo.MutationResult<DoctorWaitingForPatientMutation>;
export type DoctorWaitingForPatientMutationOptions = Apollo.BaseMutationOptions<DoctorWaitingForPatientMutation, DoctorWaitingForPatientMutationVariables>;
export const DoctorDeleteVisitDocument = gql`
    mutation DoctorDeleteVisit($id: String!) {
  doctorDeleteVisit2(id: $id) {
    id
  }
}
    `;
export type DoctorDeleteVisitMutationFn = Apollo.MutationFunction<DoctorDeleteVisitMutation, DoctorDeleteVisitMutationVariables>;

/**
 * __useDoctorDeleteVisitMutation__
 *
 * To run a mutation, you first call `useDoctorDeleteVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeleteVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeleteVisitMutation, { data, loading, error }] = useDoctorDeleteVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeleteVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeleteVisitMutation, DoctorDeleteVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeleteVisitMutation, DoctorDeleteVisitMutationVariables>(DoctorDeleteVisitDocument, options);
      }
export type DoctorDeleteVisitMutationHookResult = ReturnType<typeof useDoctorDeleteVisitMutation>;
export type DoctorDeleteVisitMutationResult = Apollo.MutationResult<DoctorDeleteVisitMutation>;
export type DoctorDeleteVisitMutationOptions = Apollo.BaseMutationOptions<DoctorDeleteVisitMutation, DoctorDeleteVisitMutationVariables>;
export const DoctorStartVisitDocument = gql`
    mutation DoctorStartVisit($id: String!) {
  doctorStartVisit(id: $id) {
    id
  }
}
    `;
export type DoctorStartVisitMutationFn = Apollo.MutationFunction<DoctorStartVisitMutation, DoctorStartVisitMutationVariables>;

/**
 * __useDoctorStartVisitMutation__
 *
 * To run a mutation, you first call `useDoctorStartVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorStartVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorStartVisitMutation, { data, loading, error }] = useDoctorStartVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorStartVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorStartVisitMutation, DoctorStartVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorStartVisitMutation, DoctorStartVisitMutationVariables>(DoctorStartVisitDocument, options);
      }
export type DoctorStartVisitMutationHookResult = ReturnType<typeof useDoctorStartVisitMutation>;
export type DoctorStartVisitMutationResult = Apollo.MutationResult<DoctorStartVisitMutation>;
export type DoctorStartVisitMutationOptions = Apollo.BaseMutationOptions<DoctorStartVisitMutation, DoctorStartVisitMutationVariables>;
export const DoctorPatientLeftVisitDocument = gql`
    mutation DoctorPatientLeftVisit($id: String!) {
  doctorPatientLeftVisit(id: $id) {
    id
  }
}
    `;
export type DoctorPatientLeftVisitMutationFn = Apollo.MutationFunction<DoctorPatientLeftVisitMutation, DoctorPatientLeftVisitMutationVariables>;

/**
 * __useDoctorPatientLeftVisitMutation__
 *
 * To run a mutation, you first call `useDoctorPatientLeftVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientLeftVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorPatientLeftVisitMutation, { data, loading, error }] = useDoctorPatientLeftVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorPatientLeftVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorPatientLeftVisitMutation, DoctorPatientLeftVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorPatientLeftVisitMutation, DoctorPatientLeftVisitMutationVariables>(DoctorPatientLeftVisitDocument, options);
      }
export type DoctorPatientLeftVisitMutationHookResult = ReturnType<typeof useDoctorPatientLeftVisitMutation>;
export type DoctorPatientLeftVisitMutationResult = Apollo.MutationResult<DoctorPatientLeftVisitMutation>;
export type DoctorPatientLeftVisitMutationOptions = Apollo.BaseMutationOptions<DoctorPatientLeftVisitMutation, DoctorPatientLeftVisitMutationVariables>;
export const DoctorUnpinAllPatientsDocument = gql`
    mutation DoctorUnpinAllPatients {
  doctorUnpinAllPatients
}
    `;
export type DoctorUnpinAllPatientsMutationFn = Apollo.MutationFunction<DoctorUnpinAllPatientsMutation, DoctorUnpinAllPatientsMutationVariables>;

/**
 * __useDoctorUnpinAllPatientsMutation__
 *
 * To run a mutation, you first call `useDoctorUnpinAllPatientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUnpinAllPatientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUnpinAllPatientsMutation, { data, loading, error }] = useDoctorUnpinAllPatientsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDoctorUnpinAllPatientsMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUnpinAllPatientsMutation, DoctorUnpinAllPatientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUnpinAllPatientsMutation, DoctorUnpinAllPatientsMutationVariables>(DoctorUnpinAllPatientsDocument, options);
      }
export type DoctorUnpinAllPatientsMutationHookResult = ReturnType<typeof useDoctorUnpinAllPatientsMutation>;
export type DoctorUnpinAllPatientsMutationResult = Apollo.MutationResult<DoctorUnpinAllPatientsMutation>;
export type DoctorUnpinAllPatientsMutationOptions = Apollo.BaseMutationOptions<DoctorUnpinAllPatientsMutation, DoctorUnpinAllPatientsMutationVariables>;
export const DoctorCreatePatientDocument = gql`
    mutation DoctorCreatePatient($phone: String!, $pesel: String!, $firstName: String!, $lastName: String!, $address: DoctorMSPlacematicAddressInput!, $flatNumber: String, $email: String, $languages: [DoctorMSSupportedLanguage!]!) {
  doctorCreatePatient(
    phone: $phone
    pesel: $pesel
    firstName: $firstName
    lastName: $lastName
    address: $address
    flatNumber: $flatNumber
    email: $email
    languages: $languages
  )
}
    `;
export type DoctorCreatePatientMutationFn = Apollo.MutationFunction<DoctorCreatePatientMutation, DoctorCreatePatientMutationVariables>;

/**
 * __useDoctorCreatePatientMutation__
 *
 * To run a mutation, you first call `useDoctorCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreatePatientMutation, { data, loading, error }] = useDoctorCreatePatientMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      pesel: // value for 'pesel'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      flatNumber: // value for 'flatNumber'
 *      email: // value for 'email'
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useDoctorCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreatePatientMutation, DoctorCreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreatePatientMutation, DoctorCreatePatientMutationVariables>(DoctorCreatePatientDocument, options);
      }
export type DoctorCreatePatientMutationHookResult = ReturnType<typeof useDoctorCreatePatientMutation>;
export type DoctorCreatePatientMutationResult = Apollo.MutationResult<DoctorCreatePatientMutation>;
export type DoctorCreatePatientMutationOptions = Apollo.BaseMutationOptions<DoctorCreatePatientMutation, DoctorCreatePatientMutationVariables>;
export const DoctorRevokeAssignmentDocument = gql`
    mutation DoctorRevokeAssignment($id: String!) {
  doctorRevokeAssignment(id: $id)
}
    `;
export type DoctorRevokeAssignmentMutationFn = Apollo.MutationFunction<DoctorRevokeAssignmentMutation, DoctorRevokeAssignmentMutationVariables>;

/**
 * __useDoctorRevokeAssignmentMutation__
 *
 * To run a mutation, you first call `useDoctorRevokeAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorRevokeAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorRevokeAssignmentMutation, { data, loading, error }] = useDoctorRevokeAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorRevokeAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorRevokeAssignmentMutation, DoctorRevokeAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorRevokeAssignmentMutation, DoctorRevokeAssignmentMutationVariables>(DoctorRevokeAssignmentDocument, options);
      }
export type DoctorRevokeAssignmentMutationHookResult = ReturnType<typeof useDoctorRevokeAssignmentMutation>;
export type DoctorRevokeAssignmentMutationResult = Apollo.MutationResult<DoctorRevokeAssignmentMutation>;
export type DoctorRevokeAssignmentMutationOptions = Apollo.BaseMutationOptions<DoctorRevokeAssignmentMutation, DoctorRevokeAssignmentMutationVariables>;
export const DoctorCreateVitalDocument = gql`
    mutation DoctorCreateVital($input: DoctorMSVitalInput!, $specificInput: DoctorMSJSON!) {
  doctorCreateVital(input: $input, specificInput: $specificInput)
}
    `;
export type DoctorCreateVitalMutationFn = Apollo.MutationFunction<DoctorCreateVitalMutation, DoctorCreateVitalMutationVariables>;

/**
 * __useDoctorCreateVitalMutation__
 *
 * To run a mutation, you first call `useDoctorCreateVitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateVitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateVitalMutation, { data, loading, error }] = useDoctorCreateVitalMutation({
 *   variables: {
 *      input: // value for 'input'
 *      specificInput: // value for 'specificInput'
 *   },
 * });
 */
export function useDoctorCreateVitalMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateVitalMutation, DoctorCreateVitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateVitalMutation, DoctorCreateVitalMutationVariables>(DoctorCreateVitalDocument, options);
      }
export type DoctorCreateVitalMutationHookResult = ReturnType<typeof useDoctorCreateVitalMutation>;
export type DoctorCreateVitalMutationResult = Apollo.MutationResult<DoctorCreateVitalMutation>;
export type DoctorCreateVitalMutationOptions = Apollo.BaseMutationOptions<DoctorCreateVitalMutation, DoctorCreateVitalMutationVariables>;
export const DoctorUpdateVisitSlotDocument = gql`
    mutation DoctorUpdateVisitSlot($id: String!, $visitType: DoctorMSPShiftVisitType!, $shiftsSlot: [DoctorMSShiftsSlot!]!) {
  doctorUpdateVisitSlot2ForMedicalApp(
    id: $id
    shiftsSlot: $shiftsSlot
    visitType: $visitType
  ) {
    id
  }
}
    `;
export type DoctorUpdateVisitSlotMutationFn = Apollo.MutationFunction<DoctorUpdateVisitSlotMutation, DoctorUpdateVisitSlotMutationVariables>;

/**
 * __useDoctorUpdateVisitSlotMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateVisitSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateVisitSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateVisitSlotMutation, { data, loading, error }] = useDoctorUpdateVisitSlotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visitType: // value for 'visitType'
 *      shiftsSlot: // value for 'shiftsSlot'
 *   },
 * });
 */
export function useDoctorUpdateVisitSlotMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateVisitSlotMutation, DoctorUpdateVisitSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateVisitSlotMutation, DoctorUpdateVisitSlotMutationVariables>(DoctorUpdateVisitSlotDocument, options);
      }
export type DoctorUpdateVisitSlotMutationHookResult = ReturnType<typeof useDoctorUpdateVisitSlotMutation>;
export type DoctorUpdateVisitSlotMutationResult = Apollo.MutationResult<DoctorUpdateVisitSlotMutation>;
export type DoctorUpdateVisitSlotMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateVisitSlotMutation, DoctorUpdateVisitSlotMutationVariables>;
export const DoctorForceEditVisitDocument = gql`
    mutation DoctorForceEditVisit($id: String!, $input: DoctorMSForceVisitInput2!) {
  doctorForceVisit2(id: $id, input: $input) {
    id
  }
}
    `;
export type DoctorForceEditVisitMutationFn = Apollo.MutationFunction<DoctorForceEditVisitMutation, DoctorForceEditVisitMutationVariables>;

/**
 * __useDoctorForceEditVisitMutation__
 *
 * To run a mutation, you first call `useDoctorForceEditVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorForceEditVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorForceEditVisitMutation, { data, loading, error }] = useDoctorForceEditVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorForceEditVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorForceEditVisitMutation, DoctorForceEditVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorForceEditVisitMutation, DoctorForceEditVisitMutationVariables>(DoctorForceEditVisitDocument, options);
      }
export type DoctorForceEditVisitMutationHookResult = ReturnType<typeof useDoctorForceEditVisitMutation>;
export type DoctorForceEditVisitMutationResult = Apollo.MutationResult<DoctorForceEditVisitMutation>;
export type DoctorForceEditVisitMutationOptions = Apollo.BaseMutationOptions<DoctorForceEditVisitMutation, DoctorForceEditVisitMutationVariables>;
export const DoctorForceCreateVisitDocument = gql`
    mutation DoctorForceCreateVisit($patientId: String!, $input: DoctorMSForceVisitInput2!) {
  doctorForceCreateVisit2(patientId: $patientId, input: $input) {
    id
  }
}
    `;
export type DoctorForceCreateVisitMutationFn = Apollo.MutationFunction<DoctorForceCreateVisitMutation, DoctorForceCreateVisitMutationVariables>;

/**
 * __useDoctorForceCreateVisitMutation__
 *
 * To run a mutation, you first call `useDoctorForceCreateVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorForceCreateVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorForceCreateVisitMutation, { data, loading, error }] = useDoctorForceCreateVisitMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorForceCreateVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorForceCreateVisitMutation, DoctorForceCreateVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorForceCreateVisitMutation, DoctorForceCreateVisitMutationVariables>(DoctorForceCreateVisitDocument, options);
      }
export type DoctorForceCreateVisitMutationHookResult = ReturnType<typeof useDoctorForceCreateVisitMutation>;
export type DoctorForceCreateVisitMutationResult = Apollo.MutationResult<DoctorForceCreateVisitMutation>;
export type DoctorForceCreateVisitMutationOptions = Apollo.BaseMutationOptions<DoctorForceCreateVisitMutation, DoctorForceCreateVisitMutationVariables>;
export const DoctorPatientShowedUpForAVisitDocument = gql`
    mutation DoctorPatientShowedUpForAVisit($id: String!) {
  doctorPatientShowedUpForAVisit(id: $id) {
    id
  }
}
    `;
export type DoctorPatientShowedUpForAVisitMutationFn = Apollo.MutationFunction<DoctorPatientShowedUpForAVisitMutation, DoctorPatientShowedUpForAVisitMutationVariables>;

/**
 * __useDoctorPatientShowedUpForAVisitMutation__
 *
 * To run a mutation, you first call `useDoctorPatientShowedUpForAVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientShowedUpForAVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorPatientShowedUpForAVisitMutation, { data, loading, error }] = useDoctorPatientShowedUpForAVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorPatientShowedUpForAVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorPatientShowedUpForAVisitMutation, DoctorPatientShowedUpForAVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorPatientShowedUpForAVisitMutation, DoctorPatientShowedUpForAVisitMutationVariables>(DoctorPatientShowedUpForAVisitDocument, options);
      }
export type DoctorPatientShowedUpForAVisitMutationHookResult = ReturnType<typeof useDoctorPatientShowedUpForAVisitMutation>;
export type DoctorPatientShowedUpForAVisitMutationResult = Apollo.MutationResult<DoctorPatientShowedUpForAVisitMutation>;
export type DoctorPatientShowedUpForAVisitMutationOptions = Apollo.BaseMutationOptions<DoctorPatientShowedUpForAVisitMutation, DoctorPatientShowedUpForAVisitMutationVariables>;
export const DoctorUpdateUserAddressDocument = gql`
    mutation DoctorUpdateUserAddress($flatNumber: String, $address: DoctorMSPlacematicAddressInput!, $id: String!) {
  doctorUpdateUserAddress(id: $id, flatNumber: $flatNumber, address: $address) {
    id
  }
}
    `;
export type DoctorUpdateUserAddressMutationFn = Apollo.MutationFunction<DoctorUpdateUserAddressMutation, DoctorUpdateUserAddressMutationVariables>;

/**
 * __useDoctorUpdateUserAddressMutation__
 *
 * To run a mutation, you first call `useDoctorUpdateUserAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpdateUserAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpdateUserAddressMutation, { data, loading, error }] = useDoctorUpdateUserAddressMutation({
 *   variables: {
 *      flatNumber: // value for 'flatNumber'
 *      address: // value for 'address'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorUpdateUserAddressMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpdateUserAddressMutation, DoctorUpdateUserAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpdateUserAddressMutation, DoctorUpdateUserAddressMutationVariables>(DoctorUpdateUserAddressDocument, options);
      }
export type DoctorUpdateUserAddressMutationHookResult = ReturnType<typeof useDoctorUpdateUserAddressMutation>;
export type DoctorUpdateUserAddressMutationResult = Apollo.MutationResult<DoctorUpdateUserAddressMutation>;
export type DoctorUpdateUserAddressMutationOptions = Apollo.BaseMutationOptions<DoctorUpdateUserAddressMutation, DoctorUpdateUserAddressMutationVariables>;
export const DoctorReopenVisitDocument = gql`
    mutation DoctorReopenVisit($id: String!) {
  doctorReopenVisit(id: $id)
}
    `;
export type DoctorReopenVisitMutationFn = Apollo.MutationFunction<DoctorReopenVisitMutation, DoctorReopenVisitMutationVariables>;

/**
 * __useDoctorReopenVisitMutation__
 *
 * To run a mutation, you first call `useDoctorReopenVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorReopenVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorReopenVisitMutation, { data, loading, error }] = useDoctorReopenVisitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorReopenVisitMutation(baseOptions?: Apollo.MutationHookOptions<DoctorReopenVisitMutation, DoctorReopenVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorReopenVisitMutation, DoctorReopenVisitMutationVariables>(DoctorReopenVisitDocument, options);
      }
export type DoctorReopenVisitMutationHookResult = ReturnType<typeof useDoctorReopenVisitMutation>;
export type DoctorReopenVisitMutationResult = Apollo.MutationResult<DoctorReopenVisitMutation>;
export type DoctorReopenVisitMutationOptions = Apollo.BaseMutationOptions<DoctorReopenVisitMutation, DoctorReopenVisitMutationVariables>;
export const DoctorSaveHealthInsuranceStatementDocument = gql`
    mutation DoctorSaveHealthInsuranceStatement($patientId: String!, $organizationId: String!, $data: DoctorMSNFZEventData!, $executionDate: DoctorMSDateTime) {
  doctorSaveHealthInsuranceStatement(
    data: $data
    patientId: $patientId
    organizationId: $organizationId
    executionDate: $executionDate
  )
}
    `;
export type DoctorSaveHealthInsuranceStatementMutationFn = Apollo.MutationFunction<DoctorSaveHealthInsuranceStatementMutation, DoctorSaveHealthInsuranceStatementMutationVariables>;

/**
 * __useDoctorSaveHealthInsuranceStatementMutation__
 *
 * To run a mutation, you first call `useDoctorSaveHealthInsuranceStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorSaveHealthInsuranceStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorSaveHealthInsuranceStatementMutation, { data, loading, error }] = useDoctorSaveHealthInsuranceStatementMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      organizationId: // value for 'organizationId'
 *      data: // value for 'data'
 *      executionDate: // value for 'executionDate'
 *   },
 * });
 */
export function useDoctorSaveHealthInsuranceStatementMutation(baseOptions?: Apollo.MutationHookOptions<DoctorSaveHealthInsuranceStatementMutation, DoctorSaveHealthInsuranceStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorSaveHealthInsuranceStatementMutation, DoctorSaveHealthInsuranceStatementMutationVariables>(DoctorSaveHealthInsuranceStatementDocument, options);
      }
export type DoctorSaveHealthInsuranceStatementMutationHookResult = ReturnType<typeof useDoctorSaveHealthInsuranceStatementMutation>;
export type DoctorSaveHealthInsuranceStatementMutationResult = Apollo.MutationResult<DoctorSaveHealthInsuranceStatementMutation>;
export type DoctorSaveHealthInsuranceStatementMutationOptions = Apollo.BaseMutationOptions<DoctorSaveHealthInsuranceStatementMutation, DoctorSaveHealthInsuranceStatementMutationVariables>;
export const DoctorCreateNFZEventDocument = gql`
    mutation DoctorCreateNFZEvent($input: DoctorMSNFZEventInput!) {
  doctorCreateNFZEvent(input: $input)
}
    `;
export type DoctorCreateNFZEventMutationFn = Apollo.MutationFunction<DoctorCreateNFZEventMutation, DoctorCreateNFZEventMutationVariables>;

/**
 * __useDoctorCreateNFZEventMutation__
 *
 * To run a mutation, you first call `useDoctorCreateNFZEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateNFZEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateNfzEventMutation, { data, loading, error }] = useDoctorCreateNFZEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateNFZEventMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateNFZEventMutation, DoctorCreateNFZEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateNFZEventMutation, DoctorCreateNFZEventMutationVariables>(DoctorCreateNFZEventDocument, options);
      }
export type DoctorCreateNFZEventMutationHookResult = ReturnType<typeof useDoctorCreateNFZEventMutation>;
export type DoctorCreateNFZEventMutationResult = Apollo.MutationResult<DoctorCreateNFZEventMutation>;
export type DoctorCreateNFZEventMutationOptions = Apollo.BaseMutationOptions<DoctorCreateNFZEventMutation, DoctorCreateNFZEventMutationVariables>;
export const DoctorDeleteNFZEventDocument = gql`
    mutation DoctorDeleteNFZEvent($id: String!) {
  doctorDeleteNFZEvent(id: $id)
}
    `;
export type DoctorDeleteNFZEventMutationFn = Apollo.MutationFunction<DoctorDeleteNFZEventMutation, DoctorDeleteNFZEventMutationVariables>;

/**
 * __useDoctorDeleteNFZEventMutation__
 *
 * To run a mutation, you first call `useDoctorDeleteNFZEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorDeleteNFZEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorDeleteNfzEventMutation, { data, loading, error }] = useDoctorDeleteNFZEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorDeleteNFZEventMutation(baseOptions?: Apollo.MutationHookOptions<DoctorDeleteNFZEventMutation, DoctorDeleteNFZEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorDeleteNFZEventMutation, DoctorDeleteNFZEventMutationVariables>(DoctorDeleteNFZEventDocument, options);
      }
export type DoctorDeleteNFZEventMutationHookResult = ReturnType<typeof useDoctorDeleteNFZEventMutation>;
export type DoctorDeleteNFZEventMutationResult = Apollo.MutationResult<DoctorDeleteNFZEventMutation>;
export type DoctorDeleteNFZEventMutationOptions = Apollo.BaseMutationOptions<DoctorDeleteNFZEventMutation, DoctorDeleteNFZEventMutationVariables>;
export const DoctorSendRecommendationDocument = gql`
    mutation DoctorSendRecommendation($visitId: String!) {
  doctorSendRecommendation(visitId: $visitId) {
    id
    content
  }
}
    `;
export type DoctorSendRecommendationMutationFn = Apollo.MutationFunction<DoctorSendRecommendationMutation, DoctorSendRecommendationMutationVariables>;

/**
 * __useDoctorSendRecommendationMutation__
 *
 * To run a mutation, you first call `useDoctorSendRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorSendRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorSendRecommendationMutation, { data, loading, error }] = useDoctorSendRecommendationMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDoctorSendRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<DoctorSendRecommendationMutation, DoctorSendRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorSendRecommendationMutation, DoctorSendRecommendationMutationVariables>(DoctorSendRecommendationDocument, options);
      }
export type DoctorSendRecommendationMutationHookResult = ReturnType<typeof useDoctorSendRecommendationMutation>;
export type DoctorSendRecommendationMutationResult = Apollo.MutationResult<DoctorSendRecommendationMutation>;
export type DoctorSendRecommendationMutationOptions = Apollo.BaseMutationOptions<DoctorSendRecommendationMutation, DoctorSendRecommendationMutationVariables>;
export const DoctorCheckPatientEwusStatusDocument = gql`
    mutation DoctorCheckPatientEwusStatus($patientId: String!, $organizationId: String!) {
  doctorCheckPatientEwusStatus(
    patientId: $patientId
    organizationId: $organizationId
  )
}
    `;
export type DoctorCheckPatientEwusStatusMutationFn = Apollo.MutationFunction<DoctorCheckPatientEwusStatusMutation, DoctorCheckPatientEwusStatusMutationVariables>;

/**
 * __useDoctorCheckPatientEwusStatusMutation__
 *
 * To run a mutation, you first call `useDoctorCheckPatientEwusStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCheckPatientEwusStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCheckPatientEwusStatusMutation, { data, loading, error }] = useDoctorCheckPatientEwusStatusMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDoctorCheckPatientEwusStatusMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCheckPatientEwusStatusMutation, DoctorCheckPatientEwusStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCheckPatientEwusStatusMutation, DoctorCheckPatientEwusStatusMutationVariables>(DoctorCheckPatientEwusStatusDocument, options);
      }
export type DoctorCheckPatientEwusStatusMutationHookResult = ReturnType<typeof useDoctorCheckPatientEwusStatusMutation>;
export type DoctorCheckPatientEwusStatusMutationResult = Apollo.MutationResult<DoctorCheckPatientEwusStatusMutation>;
export type DoctorCheckPatientEwusStatusMutationOptions = Apollo.BaseMutationOptions<DoctorCheckPatientEwusStatusMutation, DoctorCheckPatientEwusStatusMutationVariables>;
export const DoctorRefreshTokenDocument = gql`
    mutation DoctorRefreshToken($data: DoctorMSRTPayload!) {
  doctorRefreshToken(data: $data) {
    jwt
    refreshToken
  }
}
    `;
export type DoctorRefreshTokenMutationFn = Apollo.MutationFunction<DoctorRefreshTokenMutation, DoctorRefreshTokenMutationVariables>;

/**
 * __useDoctorRefreshTokenMutation__
 *
 * To run a mutation, you first call `useDoctorRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorRefreshTokenMutation, { data, loading, error }] = useDoctorRefreshTokenMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDoctorRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<DoctorRefreshTokenMutation, DoctorRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorRefreshTokenMutation, DoctorRefreshTokenMutationVariables>(DoctorRefreshTokenDocument, options);
      }
export type DoctorRefreshTokenMutationHookResult = ReturnType<typeof useDoctorRefreshTokenMutation>;
export type DoctorRefreshTokenMutationResult = Apollo.MutationResult<DoctorRefreshTokenMutation>;
export type DoctorRefreshTokenMutationOptions = Apollo.BaseMutationOptions<DoctorRefreshTokenMutation, DoctorRefreshTokenMutationVariables>;
export const DoctorGenerateDeclarationPdfDocument = gql`
    mutation DoctorGenerateDeclarationPdf($input: DoctorMSNfzDeclarationInputDoctor!, $representativeId: String) {
  doctorGenerateDeclaration(request: $input, representativeId: $representativeId) {
    documentId
    fileUrl
  }
}
    `;
export type DoctorGenerateDeclarationPdfMutationFn = Apollo.MutationFunction<DoctorGenerateDeclarationPdfMutation, DoctorGenerateDeclarationPdfMutationVariables>;

/**
 * __useDoctorGenerateDeclarationPdfMutation__
 *
 * To run a mutation, you first call `useDoctorGenerateDeclarationPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorGenerateDeclarationPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorGenerateDeclarationPdfMutation, { data, loading, error }] = useDoctorGenerateDeclarationPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *      representativeId: // value for 'representativeId'
 *   },
 * });
 */
export function useDoctorGenerateDeclarationPdfMutation(baseOptions?: Apollo.MutationHookOptions<DoctorGenerateDeclarationPdfMutation, DoctorGenerateDeclarationPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorGenerateDeclarationPdfMutation, DoctorGenerateDeclarationPdfMutationVariables>(DoctorGenerateDeclarationPdfDocument, options);
      }
export type DoctorGenerateDeclarationPdfMutationHookResult = ReturnType<typeof useDoctorGenerateDeclarationPdfMutation>;
export type DoctorGenerateDeclarationPdfMutationResult = Apollo.MutationResult<DoctorGenerateDeclarationPdfMutation>;
export type DoctorGenerateDeclarationPdfMutationOptions = Apollo.BaseMutationOptions<DoctorGenerateDeclarationPdfMutation, DoctorGenerateDeclarationPdfMutationVariables>;
export const DoctorPublishTestingExaminationResultsDocument = gql`
    mutation DoctorPublishTestingExaminationResults($labExam: DoctorMSLabExamInput!, $visitId: String!) {
  doctorSimulateLabExamUpload(labExam: $labExam, visitId: $visitId)
}
    `;
export type DoctorPublishTestingExaminationResultsMutationFn = Apollo.MutationFunction<DoctorPublishTestingExaminationResultsMutation, DoctorPublishTestingExaminationResultsMutationVariables>;

/**
 * __useDoctorPublishTestingExaminationResultsMutation__
 *
 * To run a mutation, you first call `useDoctorPublishTestingExaminationResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorPublishTestingExaminationResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorPublishTestingExaminationResultsMutation, { data, loading, error }] = useDoctorPublishTestingExaminationResultsMutation({
 *   variables: {
 *      labExam: // value for 'labExam'
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDoctorPublishTestingExaminationResultsMutation(baseOptions?: Apollo.MutationHookOptions<DoctorPublishTestingExaminationResultsMutation, DoctorPublishTestingExaminationResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorPublishTestingExaminationResultsMutation, DoctorPublishTestingExaminationResultsMutationVariables>(DoctorPublishTestingExaminationResultsDocument, options);
      }
export type DoctorPublishTestingExaminationResultsMutationHookResult = ReturnType<typeof useDoctorPublishTestingExaminationResultsMutation>;
export type DoctorPublishTestingExaminationResultsMutationResult = Apollo.MutationResult<DoctorPublishTestingExaminationResultsMutation>;
export type DoctorPublishTestingExaminationResultsMutationOptions = Apollo.BaseMutationOptions<DoctorPublishTestingExaminationResultsMutation, DoctorPublishTestingExaminationResultsMutationVariables>;
export const DoctorAddDeclarationScanToNFZEventDocument = gql`
    mutation DoctorAddDeclarationScanToNFZEvent($declarationScanFileId: String!, $eventId: String!, $comment: String!) {
  doctorAddDeclarationScanToNFZEvent(
    declarationScanFileId: $declarationScanFileId
    eventId: $eventId
  )
  doctorUpdateDeclarationNFZEventComment(comment: $comment, eventId: $eventId)
}
    `;
export type DoctorAddDeclarationScanToNFZEventMutationFn = Apollo.MutationFunction<DoctorAddDeclarationScanToNFZEventMutation, DoctorAddDeclarationScanToNFZEventMutationVariables>;

/**
 * __useDoctorAddDeclarationScanToNFZEventMutation__
 *
 * To run a mutation, you first call `useDoctorAddDeclarationScanToNFZEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorAddDeclarationScanToNFZEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorAddDeclarationScanToNfzEventMutation, { data, loading, error }] = useDoctorAddDeclarationScanToNFZEventMutation({
 *   variables: {
 *      declarationScanFileId: // value for 'declarationScanFileId'
 *      eventId: // value for 'eventId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useDoctorAddDeclarationScanToNFZEventMutation(baseOptions?: Apollo.MutationHookOptions<DoctorAddDeclarationScanToNFZEventMutation, DoctorAddDeclarationScanToNFZEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorAddDeclarationScanToNFZEventMutation, DoctorAddDeclarationScanToNFZEventMutationVariables>(DoctorAddDeclarationScanToNFZEventDocument, options);
      }
export type DoctorAddDeclarationScanToNFZEventMutationHookResult = ReturnType<typeof useDoctorAddDeclarationScanToNFZEventMutation>;
export type DoctorAddDeclarationScanToNFZEventMutationResult = Apollo.MutationResult<DoctorAddDeclarationScanToNFZEventMutation>;
export type DoctorAddDeclarationScanToNFZEventMutationOptions = Apollo.BaseMutationOptions<DoctorAddDeclarationScanToNFZEventMutation, DoctorAddDeclarationScanToNFZEventMutationVariables>;
export const DoctorGenerateUsgResultsDocumentDocument = gql`
    mutation DoctorGenerateUsgResultsDocument($procedureId: String!) {
  doctorGenerateUsgResultsDocument(procedureId: $procedureId) {
    fileUrl
  }
}
    `;
export type DoctorGenerateUsgResultsDocumentMutationFn = Apollo.MutationFunction<DoctorGenerateUsgResultsDocumentMutation, DoctorGenerateUsgResultsDocumentMutationVariables>;

/**
 * __useDoctorGenerateUsgResultsDocumentMutation__
 *
 * To run a mutation, you first call `useDoctorGenerateUsgResultsDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorGenerateUsgResultsDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorGenerateUsgResultsDocumentMutation, { data, loading, error }] = useDoctorGenerateUsgResultsDocumentMutation({
 *   variables: {
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useDoctorGenerateUsgResultsDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorGenerateUsgResultsDocumentMutation, DoctorGenerateUsgResultsDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorGenerateUsgResultsDocumentMutation, DoctorGenerateUsgResultsDocumentMutationVariables>(DoctorGenerateUsgResultsDocumentDocument, options);
      }
export type DoctorGenerateUsgResultsDocumentMutationHookResult = ReturnType<typeof useDoctorGenerateUsgResultsDocumentMutation>;
export type DoctorGenerateUsgResultsDocumentMutationResult = Apollo.MutationResult<DoctorGenerateUsgResultsDocumentMutation>;
export type DoctorGenerateUsgResultsDocumentMutationOptions = Apollo.BaseMutationOptions<DoctorGenerateUsgResultsDocumentMutation, DoctorGenerateUsgResultsDocumentMutationVariables>;
export const DoctorLogPaymentDocument = gql`
    mutation DoctorLogPayment($paidIds: [String!]!, $paymentMethod: DoctorMSPaymentLogEntryInput!) {
  doctorLogPayment(paidIds: $paidIds, paymentMethod: $paymentMethod)
}
    `;
export type DoctorLogPaymentMutationFn = Apollo.MutationFunction<DoctorLogPaymentMutation, DoctorLogPaymentMutationVariables>;

/**
 * __useDoctorLogPaymentMutation__
 *
 * To run a mutation, you first call `useDoctorLogPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorLogPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorLogPaymentMutation, { data, loading, error }] = useDoctorLogPaymentMutation({
 *   variables: {
 *      paidIds: // value for 'paidIds'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useDoctorLogPaymentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorLogPaymentMutation, DoctorLogPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorLogPaymentMutation, DoctorLogPaymentMutationVariables>(DoctorLogPaymentDocument, options);
      }
export type DoctorLogPaymentMutationHookResult = ReturnType<typeof useDoctorLogPaymentMutation>;
export type DoctorLogPaymentMutationResult = Apollo.MutationResult<DoctorLogPaymentMutation>;
export type DoctorLogPaymentMutationOptions = Apollo.BaseMutationOptions<DoctorLogPaymentMutation, DoctorLogPaymentMutationVariables>;
export const LoadUMXDocument = gql`
    mutation LoadUMX($organizationId: String!, $umxContent: String!) {
  doctorLoadUMX(organizationId: $organizationId, umxContent: $umxContent)
}
    `;
export type LoadUMXMutationFn = Apollo.MutationFunction<LoadUMXMutation, LoadUMXMutationVariables>;

/**
 * __useLoadUMXMutation__
 *
 * To run a mutation, you first call `useLoadUMXMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoadUMXMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loadUmxMutation, { data, loading, error }] = useLoadUMXMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      umxContent: // value for 'umxContent'
 *   },
 * });
 */
export function useLoadUMXMutation(baseOptions?: Apollo.MutationHookOptions<LoadUMXMutation, LoadUMXMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoadUMXMutation, LoadUMXMutationVariables>(LoadUMXDocument, options);
      }
export type LoadUMXMutationHookResult = ReturnType<typeof useLoadUMXMutation>;
export type LoadUMXMutationResult = Apollo.MutationResult<LoadUMXMutation>;
export type LoadUMXMutationOptions = Apollo.BaseMutationOptions<LoadUMXMutation, LoadUMXMutationVariables>;
export const ReportPrepareDocument = gql`
    mutation ReportPrepare($organizationId: String!, $periodSymbol: String!, $declarationGenre: String!, $realRun: Boolean!) {
  doctorReportPrepare(
    organizationId: $organizationId
    periodSymbol: $periodSymbol
    declarationGenre: $declarationGenre
    realRun: $realRun
  )
}
    `;
export type ReportPrepareMutationFn = Apollo.MutationFunction<ReportPrepareMutation, ReportPrepareMutationVariables>;

/**
 * __useReportPrepareMutation__
 *
 * To run a mutation, you first call `useReportPrepareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPrepareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPrepareMutation, { data, loading, error }] = useReportPrepareMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      declarationGenre: // value for 'declarationGenre'
 *      realRun: // value for 'realRun'
 *   },
 * });
 */
export function useReportPrepareMutation(baseOptions?: Apollo.MutationHookOptions<ReportPrepareMutation, ReportPrepareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportPrepareMutation, ReportPrepareMutationVariables>(ReportPrepareDocument, options);
      }
export type ReportPrepareMutationHookResult = ReturnType<typeof useReportPrepareMutation>;
export type ReportPrepareMutationResult = Apollo.MutationResult<ReportPrepareMutation>;
export type ReportPrepareMutationOptions = Apollo.BaseMutationOptions<ReportPrepareMutation, ReportPrepareMutationVariables>;
export const SwiadPrepareDocument = gql`
    mutation SwiadPrepare($realRun: Boolean!, $version: String!, $periodSymbol: String!, $organizationId: String!) {
  doctorSwiadPrepare(
    realRun: $realRun
    version: $version
    periodSymbol: $periodSymbol
    organizationId: $organizationId
  )
}
    `;
export type SwiadPrepareMutationFn = Apollo.MutationFunction<SwiadPrepareMutation, SwiadPrepareMutationVariables>;

/**
 * __useSwiadPrepareMutation__
 *
 * To run a mutation, you first call `useSwiadPrepareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwiadPrepareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swiadPrepareMutation, { data, loading, error }] = useSwiadPrepareMutation({
 *   variables: {
 *      realRun: // value for 'realRun'
 *      version: // value for 'version'
 *      periodSymbol: // value for 'periodSymbol'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSwiadPrepareMutation(baseOptions?: Apollo.MutationHookOptions<SwiadPrepareMutation, SwiadPrepareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwiadPrepareMutation, SwiadPrepareMutationVariables>(SwiadPrepareDocument, options);
      }
export type SwiadPrepareMutationHookResult = ReturnType<typeof useSwiadPrepareMutation>;
export type SwiadPrepareMutationResult = Apollo.MutationResult<SwiadPrepareMutation>;
export type SwiadPrepareMutationOptions = Apollo.BaseMutationOptions<SwiadPrepareMutation, SwiadPrepareMutationVariables>;
export const ReportCleanDocument = gql`
    mutation ReportClean($organizationId: String!, $periodSymbol: String!, $type: String!) {
  doctorCleanReports(
    organizationId: $organizationId
    periodSymbol: $periodSymbol
    type: $type
  )
}
    `;
export type ReportCleanMutationFn = Apollo.MutationFunction<ReportCleanMutation, ReportCleanMutationVariables>;

/**
 * __useReportCleanMutation__
 *
 * To run a mutation, you first call `useReportCleanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCleanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCleanMutation, { data, loading, error }] = useReportCleanMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useReportCleanMutation(baseOptions?: Apollo.MutationHookOptions<ReportCleanMutation, ReportCleanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportCleanMutation, ReportCleanMutationVariables>(ReportCleanDocument, options);
      }
export type ReportCleanMutationHookResult = ReturnType<typeof useReportCleanMutation>;
export type ReportCleanMutationResult = Apollo.MutationResult<ReportCleanMutation>;
export type ReportCleanMutationOptions = Apollo.BaseMutationOptions<ReportCleanMutation, ReportCleanMutationVariables>;
export const DoctorUpsertSingleProcedureDocument = gql`
    mutation DoctorUpsertSingleProcedure($visitId: String!, $data: String!, $procedureType: DoctorMSProcedureType) {
  doctorUpsertSingleProcedure(
    visitId: $visitId
    data: $data
    procedureType: $procedureType
  )
}
    `;
export type DoctorUpsertSingleProcedureMutationFn = Apollo.MutationFunction<DoctorUpsertSingleProcedureMutation, DoctorUpsertSingleProcedureMutationVariables>;

/**
 * __useDoctorUpsertSingleProcedureMutation__
 *
 * To run a mutation, you first call `useDoctorUpsertSingleProcedureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpsertSingleProcedureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorUpsertSingleProcedureMutation, { data, loading, error }] = useDoctorUpsertSingleProcedureMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      data: // value for 'data'
 *      procedureType: // value for 'procedureType'
 *   },
 * });
 */
export function useDoctorUpsertSingleProcedureMutation(baseOptions?: Apollo.MutationHookOptions<DoctorUpsertSingleProcedureMutation, DoctorUpsertSingleProcedureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorUpsertSingleProcedureMutation, DoctorUpsertSingleProcedureMutationVariables>(DoctorUpsertSingleProcedureDocument, options);
      }
export type DoctorUpsertSingleProcedureMutationHookResult = ReturnType<typeof useDoctorUpsertSingleProcedureMutation>;
export type DoctorUpsertSingleProcedureMutationResult = Apollo.MutationResult<DoctorUpsertSingleProcedureMutation>;
export type DoctorUpsertSingleProcedureMutationOptions = Apollo.BaseMutationOptions<DoctorUpsertSingleProcedureMutation, DoctorUpsertSingleProcedureMutationVariables>;
export const DoctorCreateIpomDocument = gql`
    mutation DoctorCreateIpom($input: DoctorMSCreateIpomInput!) {
  doctorCreateIPOM(input: $input) {
    ipomCode
  }
}
    `;
export type DoctorCreateIpomMutationFn = Apollo.MutationFunction<DoctorCreateIpomMutation, DoctorCreateIpomMutationVariables>;

/**
 * __useDoctorCreateIpomMutation__
 *
 * To run a mutation, you first call `useDoctorCreateIpomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorCreateIpomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorCreateIpomMutation, { data, loading, error }] = useDoctorCreateIpomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorCreateIpomMutation(baseOptions?: Apollo.MutationHookOptions<DoctorCreateIpomMutation, DoctorCreateIpomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorCreateIpomMutation, DoctorCreateIpomMutationVariables>(DoctorCreateIpomDocument, options);
      }
export type DoctorCreateIpomMutationHookResult = ReturnType<typeof useDoctorCreateIpomMutation>;
export type DoctorCreateIpomMutationResult = Apollo.MutationResult<DoctorCreateIpomMutation>;
export type DoctorCreateIpomMutationOptions = Apollo.BaseMutationOptions<DoctorCreateIpomMutation, DoctorCreateIpomMutationVariables>;
export const DoctorGenerateIpomPdfDocumentDocument = gql`
    mutation DoctorGenerateIpomPdfDocument($patientId: String!) {
  doctorGenerateIpomPdfDocument(patientId: $patientId) {
    fileUrl
    documentId
  }
}
    `;
export type DoctorGenerateIpomPdfDocumentMutationFn = Apollo.MutationFunction<DoctorGenerateIpomPdfDocumentMutation, DoctorGenerateIpomPdfDocumentMutationVariables>;

/**
 * __useDoctorGenerateIpomPdfDocumentMutation__
 *
 * To run a mutation, you first call `useDoctorGenerateIpomPdfDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorGenerateIpomPdfDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorGenerateIpomPdfDocumentMutation, { data, loading, error }] = useDoctorGenerateIpomPdfDocumentMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGenerateIpomPdfDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DoctorGenerateIpomPdfDocumentMutation, DoctorGenerateIpomPdfDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorGenerateIpomPdfDocumentMutation, DoctorGenerateIpomPdfDocumentMutationVariables>(DoctorGenerateIpomPdfDocumentDocument, options);
      }
export type DoctorGenerateIpomPdfDocumentMutationHookResult = ReturnType<typeof useDoctorGenerateIpomPdfDocumentMutation>;
export type DoctorGenerateIpomPdfDocumentMutationResult = Apollo.MutationResult<DoctorGenerateIpomPdfDocumentMutation>;
export type DoctorGenerateIpomPdfDocumentMutationOptions = Apollo.BaseMutationOptions<DoctorGenerateIpomPdfDocumentMutation, DoctorGenerateIpomPdfDocumentMutationVariables>;
export const EdmUpdateSnippetDocument = gql`
    mutation EdmUpdateSnippet($id: String!, $input: EdmUpdateSnippetInput!) {
  edmUpdateSnippet(id: $id, input: $input) {
    id
  }
}
    `;
export type EdmUpdateSnippetMutationFn = Apollo.MutationFunction<EdmUpdateSnippetMutation, EdmUpdateSnippetMutationVariables>;

/**
 * __useEdmUpdateSnippetMutation__
 *
 * To run a mutation, you first call `useEdmUpdateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmUpdateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmUpdateSnippetMutation, { data, loading, error }] = useEdmUpdateSnippetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmUpdateSnippetMutation(baseOptions?: Apollo.MutationHookOptions<EdmUpdateSnippetMutation, EdmUpdateSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmUpdateSnippetMutation, EdmUpdateSnippetMutationVariables>(EdmUpdateSnippetDocument, options);
      }
export type EdmUpdateSnippetMutationHookResult = ReturnType<typeof useEdmUpdateSnippetMutation>;
export type EdmUpdateSnippetMutationResult = Apollo.MutationResult<EdmUpdateSnippetMutation>;
export type EdmUpdateSnippetMutationOptions = Apollo.BaseMutationOptions<EdmUpdateSnippetMutation, EdmUpdateSnippetMutationVariables>;
export const EdmCreateSnippetDocument = gql`
    mutation EdmCreateSnippet($input: EdmCreateSnippetInput!) {
  edmCreateSnippet(input: $input) {
    id
  }
}
    `;
export type EdmCreateSnippetMutationFn = Apollo.MutationFunction<EdmCreateSnippetMutation, EdmCreateSnippetMutationVariables>;

/**
 * __useEdmCreateSnippetMutation__
 *
 * To run a mutation, you first call `useEdmCreateSnippetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmCreateSnippetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmCreateSnippetMutation, { data, loading, error }] = useEdmCreateSnippetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmCreateSnippetMutation(baseOptions?: Apollo.MutationHookOptions<EdmCreateSnippetMutation, EdmCreateSnippetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmCreateSnippetMutation, EdmCreateSnippetMutationVariables>(EdmCreateSnippetDocument, options);
      }
export type EdmCreateSnippetMutationHookResult = ReturnType<typeof useEdmCreateSnippetMutation>;
export type EdmCreateSnippetMutationResult = Apollo.MutationResult<EdmCreateSnippetMutation>;
export type EdmCreateSnippetMutationOptions = Apollo.BaseMutationOptions<EdmCreateSnippetMutation, EdmCreateSnippetMutationVariables>;
export const EdmDeleteSnippetByIdDocument = gql`
    mutation EdmDeleteSnippetById($id: String!) {
  edmDeleteSnippetById(id: $id) {
    success
  }
}
    `;
export type EdmDeleteSnippetByIdMutationFn = Apollo.MutationFunction<EdmDeleteSnippetByIdMutation, EdmDeleteSnippetByIdMutationVariables>;

/**
 * __useEdmDeleteSnippetByIdMutation__
 *
 * To run a mutation, you first call `useEdmDeleteSnippetByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDeleteSnippetByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDeleteSnippetByIdMutation, { data, loading, error }] = useEdmDeleteSnippetByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDeleteSnippetByIdMutation(baseOptions?: Apollo.MutationHookOptions<EdmDeleteSnippetByIdMutation, EdmDeleteSnippetByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmDeleteSnippetByIdMutation, EdmDeleteSnippetByIdMutationVariables>(EdmDeleteSnippetByIdDocument, options);
      }
export type EdmDeleteSnippetByIdMutationHookResult = ReturnType<typeof useEdmDeleteSnippetByIdMutation>;
export type EdmDeleteSnippetByIdMutationResult = Apollo.MutationResult<EdmDeleteSnippetByIdMutation>;
export type EdmDeleteSnippetByIdMutationOptions = Apollo.BaseMutationOptions<EdmDeleteSnippetByIdMutation, EdmDeleteSnippetByIdMutationVariables>;
export const EdmIncreaseSnippetCounterDocument = gql`
    mutation EdmIncreaseSnippetCounter($id: String!) {
  edmIncreaseSnippetCounter(id: $id) {
    success
  }
}
    `;
export type EdmIncreaseSnippetCounterMutationFn = Apollo.MutationFunction<EdmIncreaseSnippetCounterMutation, EdmIncreaseSnippetCounterMutationVariables>;

/**
 * __useEdmIncreaseSnippetCounterMutation__
 *
 * To run a mutation, you first call `useEdmIncreaseSnippetCounterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmIncreaseSnippetCounterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmIncreaseSnippetCounterMutation, { data, loading, error }] = useEdmIncreaseSnippetCounterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmIncreaseSnippetCounterMutation(baseOptions?: Apollo.MutationHookOptions<EdmIncreaseSnippetCounterMutation, EdmIncreaseSnippetCounterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmIncreaseSnippetCounterMutation, EdmIncreaseSnippetCounterMutationVariables>(EdmIncreaseSnippetCounterDocument, options);
      }
export type EdmIncreaseSnippetCounterMutationHookResult = ReturnType<typeof useEdmIncreaseSnippetCounterMutation>;
export type EdmIncreaseSnippetCounterMutationResult = Apollo.MutationResult<EdmIncreaseSnippetCounterMutation>;
export type EdmIncreaseSnippetCounterMutationOptions = Apollo.BaseMutationOptions<EdmIncreaseSnippetCounterMutation, EdmIncreaseSnippetCounterMutationVariables>;
export const DoctorIssueMedicalLeaveDocument = gql`
    mutation DoctorIssueMedicalLeave($input: DoctorMSMedicalLeaveInput!, $id: String!) {
  doctorIssueMedicalLeave(input: $input, id: $id)
}
    `;
export type DoctorIssueMedicalLeaveMutationFn = Apollo.MutationFunction<DoctorIssueMedicalLeaveMutation, DoctorIssueMedicalLeaveMutationVariables>;

/**
 * __useDoctorIssueMedicalLeaveMutation__
 *
 * To run a mutation, you first call `useDoctorIssueMedicalLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssueMedicalLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssueMedicalLeaveMutation, { data, loading, error }] = useDoctorIssueMedicalLeaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorIssueMedicalLeaveMutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssueMedicalLeaveMutation, DoctorIssueMedicalLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssueMedicalLeaveMutation, DoctorIssueMedicalLeaveMutationVariables>(DoctorIssueMedicalLeaveDocument, options);
      }
export type DoctorIssueMedicalLeaveMutationHookResult = ReturnType<typeof useDoctorIssueMedicalLeaveMutation>;
export type DoctorIssueMedicalLeaveMutationResult = Apollo.MutationResult<DoctorIssueMedicalLeaveMutation>;
export type DoctorIssueMedicalLeaveMutationOptions = Apollo.BaseMutationOptions<DoctorIssueMedicalLeaveMutation, DoctorIssueMedicalLeaveMutationVariables>;
export const DoctorIssueMedicalLeave2Document = gql`
    mutation DoctorIssueMedicalLeave2($input: DoctorMSMedicalLeaveInputNew!) {
  doctorIssueMedicalLeaveNew(input: $input) {
    leaves {
      seriesNumber
      ids
    }
    messageId
  }
}
    `;
export type DoctorIssueMedicalLeave2MutationFn = Apollo.MutationFunction<DoctorIssueMedicalLeave2Mutation, DoctorIssueMedicalLeave2MutationVariables>;

/**
 * __useDoctorIssueMedicalLeave2Mutation__
 *
 * To run a mutation, you first call `useDoctorIssueMedicalLeave2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssueMedicalLeave2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssueMedicalLeave2Mutation, { data, loading, error }] = useDoctorIssueMedicalLeave2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorIssueMedicalLeave2Mutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssueMedicalLeave2Mutation, DoctorIssueMedicalLeave2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssueMedicalLeave2Mutation, DoctorIssueMedicalLeave2MutationVariables>(DoctorIssueMedicalLeave2Document, options);
      }
export type DoctorIssueMedicalLeave2MutationHookResult = ReturnType<typeof useDoctorIssueMedicalLeave2Mutation>;
export type DoctorIssueMedicalLeave2MutationResult = Apollo.MutationResult<DoctorIssueMedicalLeave2Mutation>;
export type DoctorIssueMedicalLeave2MutationOptions = Apollo.BaseMutationOptions<DoctorIssueMedicalLeave2Mutation, DoctorIssueMedicalLeave2MutationVariables>;
export const DoctorIssueMedicalCareLeaveDocument = gql`
    mutation DoctorIssueMedicalCareLeave($input: DoctorMSCareLeaveInput!) {
  doctorIssueCareLeave(input: $input) {
    leaves {
      seriesNumber
      ids
    }
    messageId
  }
}
    `;
export type DoctorIssueMedicalCareLeaveMutationFn = Apollo.MutationFunction<DoctorIssueMedicalCareLeaveMutation, DoctorIssueMedicalCareLeaveMutationVariables>;

/**
 * __useDoctorIssueMedicalCareLeaveMutation__
 *
 * To run a mutation, you first call `useDoctorIssueMedicalCareLeaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoctorIssueMedicalCareLeaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doctorIssueMedicalCareLeaveMutation, { data, loading, error }] = useDoctorIssueMedicalCareLeaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorIssueMedicalCareLeaveMutation(baseOptions?: Apollo.MutationHookOptions<DoctorIssueMedicalCareLeaveMutation, DoctorIssueMedicalCareLeaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoctorIssueMedicalCareLeaveMutation, DoctorIssueMedicalCareLeaveMutationVariables>(DoctorIssueMedicalCareLeaveDocument, options);
      }
export type DoctorIssueMedicalCareLeaveMutationHookResult = ReturnType<typeof useDoctorIssueMedicalCareLeaveMutation>;
export type DoctorIssueMedicalCareLeaveMutationResult = Apollo.MutationResult<DoctorIssueMedicalCareLeaveMutation>;
export type DoctorIssueMedicalCareLeaveMutationOptions = Apollo.BaseMutationOptions<DoctorIssueMedicalCareLeaveMutation, DoctorIssueMedicalCareLeaveMutationVariables>;
export const EdmCreateShiftDocument = gql`
    mutation EdmCreateShift($input: EdmCreateShiftInput!) {
  edmCreateShift(input: $input) {
    id
    organizationId
    staff {
      id
    }
    day
    startFrom
    endedAt
    comment
  }
}
    `;
export type EdmCreateShiftMutationFn = Apollo.MutationFunction<EdmCreateShiftMutation, EdmCreateShiftMutationVariables>;

/**
 * __useEdmCreateShiftMutation__
 *
 * To run a mutation, you first call `useEdmCreateShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmCreateShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmCreateShiftMutation, { data, loading, error }] = useEdmCreateShiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmCreateShiftMutation(baseOptions?: Apollo.MutationHookOptions<EdmCreateShiftMutation, EdmCreateShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmCreateShiftMutation, EdmCreateShiftMutationVariables>(EdmCreateShiftDocument, options);
      }
export type EdmCreateShiftMutationHookResult = ReturnType<typeof useEdmCreateShiftMutation>;
export type EdmCreateShiftMutationResult = Apollo.MutationResult<EdmCreateShiftMutation>;
export type EdmCreateShiftMutationOptions = Apollo.BaseMutationOptions<EdmCreateShiftMutation, EdmCreateShiftMutationVariables>;
export const EdmCreateShiftsBulkDocument = gql`
    mutation EdmCreateShiftsBulk($input: EdmCreateShiftBulkInput!) {
  edmCreateShiftsBulk(input: $input) {
    shifts {
      id
      organizationId
      staff {
        id
      }
      day
      startFrom
      endedAt
      comment
    }
    erroredDays
  }
}
    `;
export type EdmCreateShiftsBulkMutationFn = Apollo.MutationFunction<EdmCreateShiftsBulkMutation, EdmCreateShiftsBulkMutationVariables>;

/**
 * __useEdmCreateShiftsBulkMutation__
 *
 * To run a mutation, you first call `useEdmCreateShiftsBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmCreateShiftsBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmCreateShiftsBulkMutation, { data, loading, error }] = useEdmCreateShiftsBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmCreateShiftsBulkMutation(baseOptions?: Apollo.MutationHookOptions<EdmCreateShiftsBulkMutation, EdmCreateShiftsBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmCreateShiftsBulkMutation, EdmCreateShiftsBulkMutationVariables>(EdmCreateShiftsBulkDocument, options);
      }
export type EdmCreateShiftsBulkMutationHookResult = ReturnType<typeof useEdmCreateShiftsBulkMutation>;
export type EdmCreateShiftsBulkMutationResult = Apollo.MutationResult<EdmCreateShiftsBulkMutation>;
export type EdmCreateShiftsBulkMutationOptions = Apollo.BaseMutationOptions<EdmCreateShiftsBulkMutation, EdmCreateShiftsBulkMutationVariables>;
export const EdmCreateNonWorkingPeriodDocument = gql`
    mutation EdmCreateNonWorkingPeriod($input: EdmCreateNonWorkingPeriodInput!) {
  edmCreateNonWorkingPeriod(input: $input) {
    id
    staff {
      id
    }
    day
    startFrom
    endedAt
    leaveType
    comment
  }
}
    `;
export type EdmCreateNonWorkingPeriodMutationFn = Apollo.MutationFunction<EdmCreateNonWorkingPeriodMutation, EdmCreateNonWorkingPeriodMutationVariables>;

/**
 * __useEdmCreateNonWorkingPeriodMutation__
 *
 * To run a mutation, you first call `useEdmCreateNonWorkingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmCreateNonWorkingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmCreateNonWorkingPeriodMutation, { data, loading, error }] = useEdmCreateNonWorkingPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmCreateNonWorkingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<EdmCreateNonWorkingPeriodMutation, EdmCreateNonWorkingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmCreateNonWorkingPeriodMutation, EdmCreateNonWorkingPeriodMutationVariables>(EdmCreateNonWorkingPeriodDocument, options);
      }
export type EdmCreateNonWorkingPeriodMutationHookResult = ReturnType<typeof useEdmCreateNonWorkingPeriodMutation>;
export type EdmCreateNonWorkingPeriodMutationResult = Apollo.MutationResult<EdmCreateNonWorkingPeriodMutation>;
export type EdmCreateNonWorkingPeriodMutationOptions = Apollo.BaseMutationOptions<EdmCreateNonWorkingPeriodMutation, EdmCreateNonWorkingPeriodMutationVariables>;
export const EdmDefineWorkingHoursDocument = gql`
    mutation EdmDefineWorkingHours($input: EdmDefineWorkingHoursInput!) {
  edmDefineWorkingHours(input: $input) {
    staffId
    month
    expectedWorkingHours {
      hours
      minutes
    }
  }
}
    `;
export type EdmDefineWorkingHoursMutationFn = Apollo.MutationFunction<EdmDefineWorkingHoursMutation, EdmDefineWorkingHoursMutationVariables>;

/**
 * __useEdmDefineWorkingHoursMutation__
 *
 * To run a mutation, you first call `useEdmDefineWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDefineWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDefineWorkingHoursMutation, { data, loading, error }] = useEdmDefineWorkingHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmDefineWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<EdmDefineWorkingHoursMutation, EdmDefineWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmDefineWorkingHoursMutation, EdmDefineWorkingHoursMutationVariables>(EdmDefineWorkingHoursDocument, options);
      }
export type EdmDefineWorkingHoursMutationHookResult = ReturnType<typeof useEdmDefineWorkingHoursMutation>;
export type EdmDefineWorkingHoursMutationResult = Apollo.MutationResult<EdmDefineWorkingHoursMutation>;
export type EdmDefineWorkingHoursMutationOptions = Apollo.BaseMutationOptions<EdmDefineWorkingHoursMutation, EdmDefineWorkingHoursMutationVariables>;
export const EdmDeleteShiftDocument = gql`
    mutation EdmDeleteShift($id: String!) {
  edmDeleteShift(id: $id) {
    id
  }
}
    `;
export type EdmDeleteShiftMutationFn = Apollo.MutationFunction<EdmDeleteShiftMutation, EdmDeleteShiftMutationVariables>;

/**
 * __useEdmDeleteShiftMutation__
 *
 * To run a mutation, you first call `useEdmDeleteShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDeleteShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDeleteShiftMutation, { data, loading, error }] = useEdmDeleteShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDeleteShiftMutation(baseOptions?: Apollo.MutationHookOptions<EdmDeleteShiftMutation, EdmDeleteShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmDeleteShiftMutation, EdmDeleteShiftMutationVariables>(EdmDeleteShiftDocument, options);
      }
export type EdmDeleteShiftMutationHookResult = ReturnType<typeof useEdmDeleteShiftMutation>;
export type EdmDeleteShiftMutationResult = Apollo.MutationResult<EdmDeleteShiftMutation>;
export type EdmDeleteShiftMutationOptions = Apollo.BaseMutationOptions<EdmDeleteShiftMutation, EdmDeleteShiftMutationVariables>;
export const EdmDeleteNonWorkingPeriodDocument = gql`
    mutation EdmDeleteNonWorkingPeriod($id: String!) {
  edmDeleteNonWorkingPeriod(id: $id) {
    success
  }
}
    `;
export type EdmDeleteNonWorkingPeriodMutationFn = Apollo.MutationFunction<EdmDeleteNonWorkingPeriodMutation, EdmDeleteNonWorkingPeriodMutationVariables>;

/**
 * __useEdmDeleteNonWorkingPeriodMutation__
 *
 * To run a mutation, you first call `useEdmDeleteNonWorkingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDeleteNonWorkingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDeleteNonWorkingPeriodMutation, { data, loading, error }] = useEdmDeleteNonWorkingPeriodMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmDeleteNonWorkingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<EdmDeleteNonWorkingPeriodMutation, EdmDeleteNonWorkingPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmDeleteNonWorkingPeriodMutation, EdmDeleteNonWorkingPeriodMutationVariables>(EdmDeleteNonWorkingPeriodDocument, options);
      }
export type EdmDeleteNonWorkingPeriodMutationHookResult = ReturnType<typeof useEdmDeleteNonWorkingPeriodMutation>;
export type EdmDeleteNonWorkingPeriodMutationResult = Apollo.MutationResult<EdmDeleteNonWorkingPeriodMutation>;
export type EdmDeleteNonWorkingPeriodMutationOptions = Apollo.BaseMutationOptions<EdmDeleteNonWorkingPeriodMutation, EdmDeleteNonWorkingPeriodMutationVariables>;
export const EdmDeleteWorkingHoursDocument = gql`
    mutation EdmDeleteWorkingHours($input: EdmDeleteWorkingHoursInput!) {
  edmDeleteWorkingHours(input: $input) {
    success
  }
}
    `;
export type EdmDeleteWorkingHoursMutationFn = Apollo.MutationFunction<EdmDeleteWorkingHoursMutation, EdmDeleteWorkingHoursMutationVariables>;

/**
 * __useEdmDeleteWorkingHoursMutation__
 *
 * To run a mutation, you first call `useEdmDeleteWorkingHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmDeleteWorkingHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmDeleteWorkingHoursMutation, { data, loading, error }] = useEdmDeleteWorkingHoursMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmDeleteWorkingHoursMutation(baseOptions?: Apollo.MutationHookOptions<EdmDeleteWorkingHoursMutation, EdmDeleteWorkingHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmDeleteWorkingHoursMutation, EdmDeleteWorkingHoursMutationVariables>(EdmDeleteWorkingHoursDocument, options);
      }
export type EdmDeleteWorkingHoursMutationHookResult = ReturnType<typeof useEdmDeleteWorkingHoursMutation>;
export type EdmDeleteWorkingHoursMutationResult = Apollo.MutationResult<EdmDeleteWorkingHoursMutation>;
export type EdmDeleteWorkingHoursMutationOptions = Apollo.BaseMutationOptions<EdmDeleteWorkingHoursMutation, EdmDeleteWorkingHoursMutationVariables>;
export const EdmRestoreShiftDocument = gql`
    mutation EdmRestoreShift($id: String!) {
  edmPublishShift(id: $id) {
    id
  }
}
    `;
export type EdmRestoreShiftMutationFn = Apollo.MutationFunction<EdmRestoreShiftMutation, EdmRestoreShiftMutationVariables>;

/**
 * __useEdmRestoreShiftMutation__
 *
 * To run a mutation, you first call `useEdmRestoreShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmRestoreShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmRestoreShiftMutation, { data, loading, error }] = useEdmRestoreShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdmRestoreShiftMutation(baseOptions?: Apollo.MutationHookOptions<EdmRestoreShiftMutation, EdmRestoreShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmRestoreShiftMutation, EdmRestoreShiftMutationVariables>(EdmRestoreShiftDocument, options);
      }
export type EdmRestoreShiftMutationHookResult = ReturnType<typeof useEdmRestoreShiftMutation>;
export type EdmRestoreShiftMutationResult = Apollo.MutationResult<EdmRestoreShiftMutation>;
export type EdmRestoreShiftMutationOptions = Apollo.BaseMutationOptions<EdmRestoreShiftMutation, EdmRestoreShiftMutationVariables>;
export const EdmPublishShiftsDocument = gql`
    mutation EdmPublishShifts($input: EdmPublishShiftsInput!) {
  edmPublishShifts(input: $input) {
    ...EdmMedicalAppShiftWithoutVisit
    visits {
      __typename
      id
      referenceOldVisitId
      shiftId
      state
      type
      patientId
      patient {
        id
        firstName
        lastName
        patientCardNumber
        pesel
        phone
      }
      staffId
      staff {
        id
        firstname
        lastname
        gender
        genre
        npwz
        acceptAdults
        acceptChildren
        adultDeclarable
        childrenDeclarable
      }
      estimatedDurationTime
      createdAt
      scheduledOn
      organizationId
      cancelledAt
      cancelledReason
      startedAt
      closedAt
      patientLeftAt
      cancellationComment
    }
  }
}
    ${EdmMedicalAppShiftWithoutVisitFragmentDoc}`;
export type EdmPublishShiftsMutationFn = Apollo.MutationFunction<EdmPublishShiftsMutation, EdmPublishShiftsMutationVariables>;

/**
 * __useEdmPublishShiftsMutation__
 *
 * To run a mutation, you first call `useEdmPublishShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmPublishShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmPublishShiftsMutation, { data, loading, error }] = useEdmPublishShiftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmPublishShiftsMutation(baseOptions?: Apollo.MutationHookOptions<EdmPublishShiftsMutation, EdmPublishShiftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmPublishShiftsMutation, EdmPublishShiftsMutationVariables>(EdmPublishShiftsDocument, options);
      }
export type EdmPublishShiftsMutationHookResult = ReturnType<typeof useEdmPublishShiftsMutation>;
export type EdmPublishShiftsMutationResult = Apollo.MutationResult<EdmPublishShiftsMutation>;
export type EdmPublishShiftsMutationOptions = Apollo.BaseMutationOptions<EdmPublishShiftsMutation, EdmPublishShiftsMutationVariables>;
export const EdmConfirmShiftsDocument = gql`
    mutation EdmConfirmShifts($input: EdmShiftsConfirmationInput!) {
  edmConfirmShifts(input: $input) {
    id
  }
}
    `;
export type EdmConfirmShiftsMutationFn = Apollo.MutationFunction<EdmConfirmShiftsMutation, EdmConfirmShiftsMutationVariables>;

/**
 * __useEdmConfirmShiftsMutation__
 *
 * To run a mutation, you first call `useEdmConfirmShiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmConfirmShiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmConfirmShiftsMutation, { data, loading, error }] = useEdmConfirmShiftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmConfirmShiftsMutation(baseOptions?: Apollo.MutationHookOptions<EdmConfirmShiftsMutation, EdmConfirmShiftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmConfirmShiftsMutation, EdmConfirmShiftsMutationVariables>(EdmConfirmShiftsDocument, options);
      }
export type EdmConfirmShiftsMutationHookResult = ReturnType<typeof useEdmConfirmShiftsMutation>;
export type EdmConfirmShiftsMutationResult = Apollo.MutationResult<EdmConfirmShiftsMutation>;
export type EdmConfirmShiftsMutationOptions = Apollo.BaseMutationOptions<EdmConfirmShiftsMutation, EdmConfirmShiftsMutationVariables>;
export const EdmCancelShiftsConfirmationDocument = gql`
    mutation EdmCancelShiftsConfirmation($input: EdmShiftsConfirmationInput!) {
  edmCancelShiftsConfirmation(input: $input) {
    id
  }
}
    `;
export type EdmCancelShiftsConfirmationMutationFn = Apollo.MutationFunction<EdmCancelShiftsConfirmationMutation, EdmCancelShiftsConfirmationMutationVariables>;

/**
 * __useEdmCancelShiftsConfirmationMutation__
 *
 * To run a mutation, you first call `useEdmCancelShiftsConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmCancelShiftsConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmCancelShiftsConfirmationMutation, { data, loading, error }] = useEdmCancelShiftsConfirmationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmCancelShiftsConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<EdmCancelShiftsConfirmationMutation, EdmCancelShiftsConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmCancelShiftsConfirmationMutation, EdmCancelShiftsConfirmationMutationVariables>(EdmCancelShiftsConfirmationDocument, options);
      }
export type EdmCancelShiftsConfirmationMutationHookResult = ReturnType<typeof useEdmCancelShiftsConfirmationMutation>;
export type EdmCancelShiftsConfirmationMutationResult = Apollo.MutationResult<EdmCancelShiftsConfirmationMutation>;
export type EdmCancelShiftsConfirmationMutationOptions = Apollo.BaseMutationOptions<EdmCancelShiftsConfirmationMutation, EdmCancelShiftsConfirmationMutationVariables>;
export const EdmUpdateStaffVisitDurationDocument = gql`
    mutation EdmUpdateStaffVisitDuration($staffId: String!, $input: EdmUpdateStaffVisitDurationInput!) {
  edmUpdateStaffVisitDuration(staffId: $staffId, input: $input) {
    IN_PERSON
    TELEMEDICAL
    DOCTOR_TELEMEDICAL_INFECTION
    NURSE_IN_PERSON_INFECTION
    PROCEDURE
    COLLECTION
    RADIOLOGY_APPOINTMENT
    SPECIALIST
    PRESCRIPTION_APPOINTMENT
    EXPRESS_APPOINTMENT
    DOCTOR_HOUSE_CALL
    NURSE_HOUSE_CALL
    MIDWIFE_HOUSE_CALL
    MIDWIFE_IN_PERSON
    HEALTHY_CHILDREN_CHECKUP_AND_VACCINE
    HEALTHY_CHILDREN_CHECKUP
    HEALTHY_CHILDREN_VACCINE
    HEALTHY_CHILDREN_PATRONAGE
    NURSE_IN_PERSON
    NURSE_HEALTHY_CHILDREN
  }
}
    `;
export type EdmUpdateStaffVisitDurationMutationFn = Apollo.MutationFunction<EdmUpdateStaffVisitDurationMutation, EdmUpdateStaffVisitDurationMutationVariables>;

/**
 * __useEdmUpdateStaffVisitDurationMutation__
 *
 * To run a mutation, you first call `useEdmUpdateStaffVisitDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmUpdateStaffVisitDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmUpdateStaffVisitDurationMutation, { data, loading, error }] = useEdmUpdateStaffVisitDurationMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmUpdateStaffVisitDurationMutation(baseOptions?: Apollo.MutationHookOptions<EdmUpdateStaffVisitDurationMutation, EdmUpdateStaffVisitDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmUpdateStaffVisitDurationMutation, EdmUpdateStaffVisitDurationMutationVariables>(EdmUpdateStaffVisitDurationDocument, options);
      }
export type EdmUpdateStaffVisitDurationMutationHookResult = ReturnType<typeof useEdmUpdateStaffVisitDurationMutation>;
export type EdmUpdateStaffVisitDurationMutationResult = Apollo.MutationResult<EdmUpdateStaffVisitDurationMutation>;
export type EdmUpdateStaffVisitDurationMutationOptions = Apollo.BaseMutationOptions<EdmUpdateStaffVisitDurationMutation, EdmUpdateStaffVisitDurationMutationVariables>;
export const EdmUpdateDeclarationsDocument = gql`
    mutation EdmUpdateDeclarations($staffId: String!, $input: EdmUpdateDeclarationInput!) {
  edmUpdateDeclarations(staffId: $staffId, input: $input) {
    success
  }
}
    `;
export type EdmUpdateDeclarationsMutationFn = Apollo.MutationFunction<EdmUpdateDeclarationsMutation, EdmUpdateDeclarationsMutationVariables>;

/**
 * __useEdmUpdateDeclarationsMutation__
 *
 * To run a mutation, you first call `useEdmUpdateDeclarationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmUpdateDeclarationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmUpdateDeclarationsMutation, { data, loading, error }] = useEdmUpdateDeclarationsMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmUpdateDeclarationsMutation(baseOptions?: Apollo.MutationHookOptions<EdmUpdateDeclarationsMutation, EdmUpdateDeclarationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmUpdateDeclarationsMutation, EdmUpdateDeclarationsMutationVariables>(EdmUpdateDeclarationsDocument, options);
      }
export type EdmUpdateDeclarationsMutationHookResult = ReturnType<typeof useEdmUpdateDeclarationsMutation>;
export type EdmUpdateDeclarationsMutationResult = Apollo.MutationResult<EdmUpdateDeclarationsMutation>;
export type EdmUpdateDeclarationsMutationOptions = Apollo.BaseMutationOptions<EdmUpdateDeclarationsMutation, EdmUpdateDeclarationsMutationVariables>;
export const EdmUpdatePreferencesDocument = gql`
    mutation EdmUpdatePreferences($staffId: String!, $input: EdmUpdatePreferencesInput!) {
  edmUpdatePreferences(staffId: $staffId, input: $input) {
    success
  }
}
    `;
export type EdmUpdatePreferencesMutationFn = Apollo.MutationFunction<EdmUpdatePreferencesMutation, EdmUpdatePreferencesMutationVariables>;

/**
 * __useEdmUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useEdmUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEdmUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [edmUpdatePreferencesMutation, { data, loading, error }] = useEdmUpdatePreferencesMutation({
 *   variables: {
 *      staffId: // value for 'staffId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmUpdatePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<EdmUpdatePreferencesMutation, EdmUpdatePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EdmUpdatePreferencesMutation, EdmUpdatePreferencesMutationVariables>(EdmUpdatePreferencesDocument, options);
      }
export type EdmUpdatePreferencesMutationHookResult = ReturnType<typeof useEdmUpdatePreferencesMutation>;
export type EdmUpdatePreferencesMutationResult = Apollo.MutationResult<EdmUpdatePreferencesMutation>;
export type EdmUpdatePreferencesMutationOptions = Apollo.BaseMutationOptions<EdmUpdatePreferencesMutation, EdmUpdatePreferencesMutationVariables>;
export const DoctorGetPatientsDocument = gql`
    query DoctorGetPatients($fullText: String!, $skip: Int = 0, $take: Int!) {
  doctorPatients(fullText: $fullText, skip: $skip, take: $take) {
    id
    firstName
    lastName
    email
    pesel
    phone
    assistantId
    patientCardNumber
    patientPublicSince {
      iso
    }
    createdAt {
      iso
      local
    }
    address {
      street
      city
      zipCode
      houseNumber
      flatNumber
    }
  }
}
    `;

/**
 * __useDoctorGetPatientsQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientsQuery({
 *   variables: {
 *      fullText: // value for 'fullText'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useDoctorGetPatientsQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables> & ({ variables: DoctorGetPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>(DoctorGetPatientsDocument, options);
      }
export function useDoctorGetPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>(DoctorGetPatientsDocument, options);
        }
export function useDoctorGetPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>(DoctorGetPatientsDocument, options);
        }
export type DoctorGetPatientsQueryHookResult = ReturnType<typeof useDoctorGetPatientsQuery>;
export type DoctorGetPatientsLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientsLazyQuery>;
export type DoctorGetPatientsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientsSuspenseQuery>;
export type DoctorGetPatientsQueryResult = Apollo.QueryResult<DoctorGetPatientsQuery, DoctorGetPatientsQueryVariables>;
export const DoctorGetPatientDocument = gql`
    query DoctorGetPatient($id: String, $pesel: String, $patientCardNumber: String) {
  doctorPatient(id: $id, pesel: $pesel, patientCardNumber: $patientCardNumber) {
    id
    firstName
    lastName
    email
    pesel
    phone
    smokeLevel
    weight
    height
    assistantId
    patientCardNumber
    actionRequired
    locale
    immunizationStatus
    nfzStatus {
      textStatus
      declaredIn
      wasDeclared
      canUsePublicVisits
      whereCanDeclare
      canDeclare
      comment
      chosenDoctor
      chosenNurse
      chosenMidwife
    }
    patientPublicSince {
      iso
    }
    lastPatientMessageBlock {
      iso
    }
    messages {
      ... on DoctorMSAssignment {
        type
        createdAt {
          iso
        }
        paid
        id
        status
        assignmentType
        data
        positions {
          serviceId
          serviceName
        }
        patient {
          firstName
          lastName
          id
          pesel
          assistantId
          patientCardNumber
        }
      }
    }
    createdAt {
      iso
      local
    }
    visits {
      id
      type
      status
      type
      duration
      createdBy
      recommendationsMessageId
      recommendationsMessage {
        id
      }
      plannedPlace
      showOn
      invitationSentAt {
        iso
        local
      }
      plannedStart {
        iso
        local
      }
      doctor {
        id
        firstName
        lastName
      }
    }
    address {
      city
      street
      zipCode
      flatNumber
      houseNumber
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useDoctorGetPatientQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pesel: // value for 'pesel'
 *      patientCardNumber: // value for 'patientCardNumber'
 *   },
 * });
 */
export function useDoctorGetPatientQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>(DoctorGetPatientDocument, options);
      }
export function useDoctorGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>(DoctorGetPatientDocument, options);
        }
export function useDoctorGetPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>(DoctorGetPatientDocument, options);
        }
export type DoctorGetPatientQueryHookResult = ReturnType<typeof useDoctorGetPatientQuery>;
export type DoctorGetPatientLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientLazyQuery>;
export type DoctorGetPatientSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientSuspenseQuery>;
export type DoctorGetPatientQueryResult = Apollo.QueryResult<DoctorGetPatientQuery, DoctorGetPatientQueryVariables>;
export const DoctorGetDoctorDocument = gql`
    query DoctorGetDoctor($id: String!) {
  doctorDoctor(id: $id) {
    id
    firstName
    lastName
    genre
    npwz
    isDeclarable
  }
}
    `;

/**
 * __useDoctorGetDoctorQuery__
 *
 * To run a query within a React component, call `useDoctorGetDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetDoctorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetDoctorQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables> & ({ variables: DoctorGetDoctorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>(DoctorGetDoctorDocument, options);
      }
export function useDoctorGetDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>(DoctorGetDoctorDocument, options);
        }
export function useDoctorGetDoctorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>(DoctorGetDoctorDocument, options);
        }
export type DoctorGetDoctorQueryHookResult = ReturnType<typeof useDoctorGetDoctorQuery>;
export type DoctorGetDoctorLazyQueryHookResult = ReturnType<typeof useDoctorGetDoctorLazyQuery>;
export type DoctorGetDoctorSuspenseQueryHookResult = ReturnType<typeof useDoctorGetDoctorSuspenseQuery>;
export type DoctorGetDoctorQueryResult = Apollo.QueryResult<DoctorGetDoctorQuery, DoctorGetDoctorQueryVariables>;
export const DoctorGetDoctorsDocument = gql`
    query DoctorGetDoctors($id: String, $showBlocked: Boolean) {
  doctorDoctors(id: $id, showBlocked: $showBlocked) {
    id
    firstName
    lastName
    genre
    npwz
    isDeclarable
    adultDeclarable
    childrenDeclarable
    declaringToOrganizationId
    childrenAvailable
  }
}
    `;

/**
 * __useDoctorGetDoctorsQuery__
 *
 * To run a query within a React component, call `useDoctorGetDoctorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetDoctorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetDoctorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      showBlocked: // value for 'showBlocked'
 *   },
 * });
 */
export function useDoctorGetDoctorsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>(DoctorGetDoctorsDocument, options);
      }
export function useDoctorGetDoctorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>(DoctorGetDoctorsDocument, options);
        }
export function useDoctorGetDoctorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>(DoctorGetDoctorsDocument, options);
        }
export type DoctorGetDoctorsQueryHookResult = ReturnType<typeof useDoctorGetDoctorsQuery>;
export type DoctorGetDoctorsLazyQueryHookResult = ReturnType<typeof useDoctorGetDoctorsLazyQuery>;
export type DoctorGetDoctorsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetDoctorsSuspenseQuery>;
export type DoctorGetDoctorsQueryResult = Apollo.QueryResult<DoctorGetDoctorsQuery, DoctorGetDoctorsQueryVariables>;
export const DoctorVisitDocument = gql`
    query DoctorVisit($id: String!) {
  doctorVisit(id: $id) {
    id
    availableImaginingOrganizationId
    status
    snapshotAt
    snapshotBy
    doctorId
    weight
    height
    smokeLevel
    type
    slotType
    additionalMedicalService
    primaryMedicalService
    preInterview {
      content
      role
    }
    memo
    prescriptionRequestId
    determineIpomEligibility
    prescriptionRequest {
      id
      requestedDrugs {
        ...DoctorRequestedDrug
      }
      solvedOn
      recommendations
    }
    recommendationsMessageId
    recommendationsMessage {
      id
    }
    isPublicVisit
    leftOn
    doctorDiagnosis {
      code
      grade
    }
    organizationId
    laboratoryExaminations {
      id
    }
    procedures {
      id
      type
    }
    doctorInterview
    physicalExamination
    doctorId
    innatePriority
    doctorDiagnosis {
      code
      grade
    }
    recommendation
    comment
    closedByBot
    doctor {
      id
      firstName
      lastName
      genre
      avatar
    }
    startOn
    showOn
    createdAt {
      iso
    }
    createdBy
    patient {
      visitRecordingAndAnalysisAgreement
      patientPublicSince {
        iso
      }
      id
      firstName
      lastName
      phone
      avatar
      pesel
      smokeLevel
      weight
      height
      phone
      assistantId
      patientCardNumber
      guardians {
        ...DoctorPatientGuardians
      }
      address {
        flatNumber
        houseNumber
        city
        street
        zipCode
      }
      secretData {
        nice
        notnice
        physicallydisabled
        hearingdisabled
        pregnant
        breastfeeding
        description
      }
      tags {
        id
        type
        data
        expirationAt
        confirmationType
        history {
          user {
            ... on DoctorMSBaseUser {
              id
              firstName
              lastName
            }
          }
          when {
            iso
          }
        }
      }
      survey {
        weight
        height
        risks {
          choice_id
          id
        }
      }
      vitals {
        ... on DoctorMSBaseVital {
          id
          type
          measured {
            iso
          }
        }
        ... on DoctorMSCt {
          doctor {
            id
            firstName
            lastName
          }
          message {
            ... on DoctorMSBaseMessage {
              id
            }
          }
        }
        ... on DoctorMSEkg {
          doctor {
            id
            firstName
            lastName
          }
          message {
            ... on DoctorMSBaseMessage {
              id
            }
          }
        }
        ... on DoctorMSHeartrate {
          doctor {
            id
            firstName
            lastName
          }
          message {
            ... on DoctorMSBaseMessage {
              id
            }
          }
        }
        ... on DoctorMSInjection {
          doctor {
            id
            firstName
            lastName
          }
          message {
            ... on DoctorMSBaseMessage {
              id
            }
          }
        }
        ... on DoctorMSAnalysis {
          doctor {
            id
            firstName
            lastName
          }
          message {
            ... on DoctorMSBaseMessage {
              id
            }
          }
          analysisType
          group
          params {
            name
            value
            unit
            min
            max
          }
        }
        ... on DoctorMSOperation {
          operationType
        }
      }
    }
    duration
    plannedStart {
      iso
    }
    invitationSentAt {
      iso
    }
    invitationSentBy {
      id
    }
  }
}
    ${DoctorRequestedDrugFragmentDoc}
${DoctorPatientGuardiansFragmentDoc}`;

/**
 * __useDoctorVisitQuery__
 *
 * To run a query within a React component, call `useDoctorVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorVisitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorVisitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorVisitQuery(baseOptions: Apollo.QueryHookOptions<DoctorVisitQuery, DoctorVisitQueryVariables> & ({ variables: DoctorVisitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorVisitQuery, DoctorVisitQueryVariables>(DoctorVisitDocument, options);
      }
export function useDoctorVisitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorVisitQuery, DoctorVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorVisitQuery, DoctorVisitQueryVariables>(DoctorVisitDocument, options);
        }
export function useDoctorVisitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorVisitQuery, DoctorVisitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorVisitQuery, DoctorVisitQueryVariables>(DoctorVisitDocument, options);
        }
export type DoctorVisitQueryHookResult = ReturnType<typeof useDoctorVisitQuery>;
export type DoctorVisitLazyQueryHookResult = ReturnType<typeof useDoctorVisitLazyQuery>;
export type DoctorVisitSuspenseQueryHookResult = ReturnType<typeof useDoctorVisitSuspenseQuery>;
export type DoctorVisitQueryResult = Apollo.QueryResult<DoctorVisitQuery, DoctorVisitQueryVariables>;
export const DoctorPatientsDocument = gql`
    query DoctorPatients($fullText: String!, $skip: Int = 0, $take: Int!) {
  doctorPatients(fullText: $fullText, skip: $skip, take: $take) {
    id
    firstName
    lastName
    pesel
    patientCardNumber
    assistantId
    patientPublicSince {
      iso
    }
    lastPatientMessageBlock {
      iso
    }
    messages {
      ... on DoctorMSAssignment {
        type
        createdAt {
          iso
        }
        paid
        id
        status
        assignmentType
        data
        positions {
          serviceId
          serviceName
        }
        patient {
          firstName
          lastName
          id
          pesel
          assistantId
          patientCardNumber
        }
      }
    }
  }
}
    `;

/**
 * __useDoctorPatientsQuery__
 *
 * To run a query within a React component, call `useDoctorPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientsQuery({
 *   variables: {
 *      fullText: // value for 'fullText'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useDoctorPatientsQuery(baseOptions: Apollo.QueryHookOptions<DoctorPatientsQuery, DoctorPatientsQueryVariables> & ({ variables: DoctorPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientsQuery, DoctorPatientsQueryVariables>(DoctorPatientsDocument, options);
      }
export function useDoctorPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientsQuery, DoctorPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientsQuery, DoctorPatientsQueryVariables>(DoctorPatientsDocument, options);
        }
export function useDoctorPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientsQuery, DoctorPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientsQuery, DoctorPatientsQueryVariables>(DoctorPatientsDocument, options);
        }
export type DoctorPatientsQueryHookResult = ReturnType<typeof useDoctorPatientsQuery>;
export type DoctorPatientsLazyQueryHookResult = ReturnType<typeof useDoctorPatientsLazyQuery>;
export type DoctorPatientsSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientsSuspenseQuery>;
export type DoctorPatientsQueryResult = Apollo.QueryResult<DoctorPatientsQuery, DoctorPatientsQueryVariables>;
export const DoctorGetPatientDataWithPayersDocument = gql`
    query DoctorGetPatientDataWithPayers($id: String) {
  doctorPatient(id: $id) {
    id
    payers {
      name
      firstName
      lastName
      passportNumber
      pesel
      nip
      pueProfile
    }
  }
}
    `;

/**
 * __useDoctorGetPatientDataWithPayersQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientDataWithPayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientDataWithPayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientDataWithPayersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetPatientDataWithPayersQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>(DoctorGetPatientDataWithPayersDocument, options);
      }
export function useDoctorGetPatientDataWithPayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>(DoctorGetPatientDataWithPayersDocument, options);
        }
export function useDoctorGetPatientDataWithPayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>(DoctorGetPatientDataWithPayersDocument, options);
        }
export type DoctorGetPatientDataWithPayersQueryHookResult = ReturnType<typeof useDoctorGetPatientDataWithPayersQuery>;
export type DoctorGetPatientDataWithPayersLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientDataWithPayersLazyQuery>;
export type DoctorGetPatientDataWithPayersSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientDataWithPayersSuspenseQuery>;
export type DoctorGetPatientDataWithPayersQueryResult = Apollo.QueryResult<DoctorGetPatientDataWithPayersQuery, DoctorGetPatientDataWithPayersQueryVariables>;
export const DoctorGetPatientStayAddressesDocument = gql`
    query DoctorGetPatientStayAddresses($id: String) {
  doctorPatient(id: $id) {
    id
    stayAddresses {
      zipCode
      city
      country
      street
      houseNumber
      flatNumber
    }
  }
}
    `;

/**
 * __useDoctorGetPatientStayAddressesQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientStayAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientStayAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientStayAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetPatientStayAddressesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>(DoctorGetPatientStayAddressesDocument, options);
      }
export function useDoctorGetPatientStayAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>(DoctorGetPatientStayAddressesDocument, options);
        }
export function useDoctorGetPatientStayAddressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>(DoctorGetPatientStayAddressesDocument, options);
        }
export type DoctorGetPatientStayAddressesQueryHookResult = ReturnType<typeof useDoctorGetPatientStayAddressesQuery>;
export type DoctorGetPatientStayAddressesLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientStayAddressesLazyQuery>;
export type DoctorGetPatientStayAddressesSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientStayAddressesSuspenseQuery>;
export type DoctorGetPatientStayAddressesQueryResult = Apollo.QueryResult<DoctorGetPatientStayAddressesQuery, DoctorGetPatientStayAddressesQueryVariables>;
export const DoctorGetLeaveHistoryDocument = gql`
    query DoctorGetLeaveHistory($patientId: String!) {
  doctorLeaves(patientId: $patientId) {
    leaveType
    inabilitySince
    careSince
    inabilityUntil
    careUntil
    icd10Main {
      name
      icd10
    }
    underCarePerson {
      firstName
      lastName
      birthDate
      type
    }
  }
}
    `;

/**
 * __useDoctorGetLeaveHistoryQuery__
 *
 * To run a query within a React component, call `useDoctorGetLeaveHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetLeaveHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetLeaveHistoryQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetLeaveHistoryQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables> & ({ variables: DoctorGetLeaveHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>(DoctorGetLeaveHistoryDocument, options);
      }
export function useDoctorGetLeaveHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>(DoctorGetLeaveHistoryDocument, options);
        }
export function useDoctorGetLeaveHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>(DoctorGetLeaveHistoryDocument, options);
        }
export type DoctorGetLeaveHistoryQueryHookResult = ReturnType<typeof useDoctorGetLeaveHistoryQuery>;
export type DoctorGetLeaveHistoryLazyQueryHookResult = ReturnType<typeof useDoctorGetLeaveHistoryLazyQuery>;
export type DoctorGetLeaveHistorySuspenseQueryHookResult = ReturnType<typeof useDoctorGetLeaveHistorySuspenseQuery>;
export type DoctorGetLeaveHistoryQueryResult = Apollo.QueryResult<DoctorGetLeaveHistoryQuery, DoctorGetLeaveHistoryQueryVariables>;
export const DoctorGetPatientDataDocument = gql`
    query DoctorGetPatientData($id: String, $pesel: String, $patientCardNumber: String) {
  doctorPatient(id: $id, pesel: $pesel, patientCardNumber: $patientCardNumber) {
    stayAddresses {
      zipCode
      city
      country
      street
      houseNumber
      flatNumber
    }
  }
}
    `;

/**
 * __useDoctorGetPatientDataQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pesel: // value for 'pesel'
 *      patientCardNumber: // value for 'patientCardNumber'
 *   },
 * });
 */
export function useDoctorGetPatientDataQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>(DoctorGetPatientDataDocument, options);
      }
export function useDoctorGetPatientDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>(DoctorGetPatientDataDocument, options);
        }
export function useDoctorGetPatientDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>(DoctorGetPatientDataDocument, options);
        }
export type DoctorGetPatientDataQueryHookResult = ReturnType<typeof useDoctorGetPatientDataQuery>;
export type DoctorGetPatientDataLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientDataLazyQuery>;
export type DoctorGetPatientDataSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientDataSuspenseQuery>;
export type DoctorGetPatientDataQueryResult = Apollo.QueryResult<DoctorGetPatientDataQuery, DoctorGetPatientDataQueryVariables>;
export const DoctorGetDocumentsDocument = gql`
    query DoctorGetDocuments($id: String) {
  doctorPatient(id: $id) {
    documents {
      id
      name
      createdAt
      tagId
      starred
      source
      fileId
      patientId
      archived
      tidy_status
      tidyDocumentationResult {
        id
        name
        type
        summary
        issuedAt
        rawText
        createdAt
      }
    }
  }
}
    `;

/**
 * __useDoctorGetDocumentsQuery__
 *
 * To run a query within a React component, call `useDoctorGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>(DoctorGetDocumentsDocument, options);
      }
export function useDoctorGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>(DoctorGetDocumentsDocument, options);
        }
export function useDoctorGetDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>(DoctorGetDocumentsDocument, options);
        }
export type DoctorGetDocumentsQueryHookResult = ReturnType<typeof useDoctorGetDocumentsQuery>;
export type DoctorGetDocumentsLazyQueryHookResult = ReturnType<typeof useDoctorGetDocumentsLazyQuery>;
export type DoctorGetDocumentsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetDocumentsSuspenseQuery>;
export type DoctorGetDocumentsQueryResult = Apollo.QueryResult<DoctorGetDocumentsQuery, DoctorGetDocumentsQueryVariables>;
export const DoctorMeDocument = gql`
    query DoctorMe {
  doctorMe {
    id
    firstName
    lastName
    genre
    phone
    email
    avatar
    signature
    medicalPushToken
    sipNumber
    sipUserId
    sipUserPassword
    sipNumberRecording
    sipUserIdRecording
    sipUserPasswordRecording
    referralCommissionSum
  }
}
    `;

/**
 * __useDoctorMeQuery__
 *
 * To run a query within a React component, call `useDoctorMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorMeQuery(baseOptions?: Apollo.QueryHookOptions<DoctorMeQuery, DoctorMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorMeQuery, DoctorMeQueryVariables>(DoctorMeDocument, options);
      }
export function useDoctorMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorMeQuery, DoctorMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorMeQuery, DoctorMeQueryVariables>(DoctorMeDocument, options);
        }
export function useDoctorMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorMeQuery, DoctorMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorMeQuery, DoctorMeQueryVariables>(DoctorMeDocument, options);
        }
export type DoctorMeQueryHookResult = ReturnType<typeof useDoctorMeQuery>;
export type DoctorMeLazyQueryHookResult = ReturnType<typeof useDoctorMeLazyQuery>;
export type DoctorMeSuspenseQueryHookResult = ReturnType<typeof useDoctorMeSuspenseQuery>;
export type DoctorMeQueryResult = Apollo.QueryResult<DoctorMeQuery, DoctorMeQueryVariables>;
export const DoctorPatientProfileVisitDocument = gql`
    query DoctorPatientProfileVisit($id: String, $pesel: String, $patientCardNumber: String) {
  doctorPatient(id: $id, pesel: $pesel, patientCardNumber: $patientCardNumber) {
    id
    firstName
    lastName
    avatar
    phone
    email
    citizenship
    avatar
    pesel
    phone
    patientCardNumber
    immunizationCardStatus
    immunizationCardComment
    ipomCode
    patientPublicSince {
      iso
    }
    oneTimeSurveyUpdatedAt {
      iso
      local
    }
    nfzStatus {
      declaredIn
      wasDeclared
      canUsePublicVisits
      whereCanDeclare
      canDeclare
      comment
      chosenDoctor
      chosenNurse
    }
    actionRequired
    visits {
      id
      type
      status
      type
      showOn
      duration
      startOn
      deletedAt
      status
      plannedPlace
      recommendationsMessageId
      recommendationsMessage {
        id
      }
      plannedStart {
        iso
        local
      }
      doctor {
        id
        firstName
        lastName
      }
    }
    passportCountry
    passportNumber
    izolacja
    kwarantanna
    statusUbezpieczenia
    oneTimeSurvey
    address {
      city
      state
      teryt
      street
      zipCode
      latitude
      longitude
      flatNumber
      houseNumber
      municipality
    }
    secretData {
      nice
      notnice
      physicallydisabled
      hearingdisabled
      pregnant
      breastfeeding
      description
    }
    guardians {
      ...DoctorPatientGuardians
    }
    wards {
      ...DoctorPatientWards
    }
    tags {
      id
      type
      expirationAt
      confirmationType
      createdAt {
        iso
        local
      }
      data
      createdBy {
        id
        firstName
        createdAt {
          iso
          local
        }
        lastName
      }
      history {
        user {
          ... on DoctorMSBaseUser {
            id
            firstName
            lastName
          }
        }
        when {
          iso
        }
      }
    }
    survey {
      weight
      height
      risks {
        choice_id
        id
      }
    }
    vitals {
      ... on DoctorMSBaseVital {
        id
        type
        overrideFiles
        measured {
          iso
        }
      }
      ... on DoctorMSCt {
        doctor {
          id
          firstName
          lastName
        }
      }
      ... on DoctorMSEkg {
        doctor {
          id
          firstName
          lastName
        }
      }
      ... on DoctorMSHeartrate {
        doctor {
          id
          firstName
          lastName
        }
      }
      ... on DoctorMSInjection {
        doctor {
          id
          firstName
          lastName
        }
      }
      ... on DoctorMSAnalysis {
        doctor {
          id
          firstName
          lastName
        }
        analysisType
        group
        params {
          name
          value
          unit
          min
          max
          text
        }
      }
      ... on DoctorMSOperation {
        operationType
      }
      ... on DoctorMSOther {
        customName
        customComment
        customDate {
          iso
        }
        group
      }
    }
    messages {
      ... on DoctorMSBaseMessage {
        id
        type
        createdAt {
          iso
        }
      }
      ... on DoctorMSPrescription {
        doctor {
          id
          firstName
          lastName
          genre
        }
        resourceCancelationInCezDate
        resourceIsCompatibleWithCez
        writeup {
          iso
        }
        startsToWork {
          iso
        }
        endsToWork {
          iso
        }
        options {
          in365days
          cito
          dontChange
        }
        drugs {
          drug
          dose
          form
          quantity
          boxAmount
          cost
          drugAmount
          interval
          quantity
          psychoSubstances
          activeSubstances {
            activeSubstanceDose
            activeSubstanceDoseInWords
            activeSubstanceDoseUnit
          }
          hourInterval
          morePatientInfo
          morePharmacistInfo
        }
      }
      ... on DoctorMSAssignment {
        assignmentType
        status
        paid
      }
    }
  }
}
    ${DoctorPatientGuardiansFragmentDoc}
${DoctorPatientWardsFragmentDoc}`;

/**
 * __useDoctorPatientProfileVisitQuery__
 *
 * To run a query within a React component, call `useDoctorPatientProfileVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientProfileVisitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientProfileVisitQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pesel: // value for 'pesel'
 *      patientCardNumber: // value for 'patientCardNumber'
 *   },
 * });
 */
export function useDoctorPatientProfileVisitQuery(baseOptions?: Apollo.QueryHookOptions<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>(DoctorPatientProfileVisitDocument, options);
      }
export function useDoctorPatientProfileVisitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>(DoctorPatientProfileVisitDocument, options);
        }
export function useDoctorPatientProfileVisitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>(DoctorPatientProfileVisitDocument, options);
        }
export type DoctorPatientProfileVisitQueryHookResult = ReturnType<typeof useDoctorPatientProfileVisitQuery>;
export type DoctorPatientProfileVisitLazyQueryHookResult = ReturnType<typeof useDoctorPatientProfileVisitLazyQuery>;
export type DoctorPatientProfileVisitSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientProfileVisitSuspenseQuery>;
export type DoctorPatientProfileVisitQueryResult = Apollo.QueryResult<DoctorPatientProfileVisitQuery, DoctorPatientProfileVisitQueryVariables>;
export const DoctorPatientProfileDiagDocument = gql`
    query DoctorPatientProfileDiag($search: String!, $type: DoctorMSAssignmentType!, $organizationId: String) {
  doctorDiag(search: $search, type: $type, organizationId: $organizationId) {
    id
    name
    price
    isAvailableAsNFZ
    isAvailableAsNFZForNurse
    orgIds
    commission
    type
  }
}
    `;

/**
 * __useDoctorPatientProfileDiagQuery__
 *
 * To run a query within a React component, call `useDoctorPatientProfileDiagQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientProfileDiagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientProfileDiagQuery({
 *   variables: {
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDoctorPatientProfileDiagQuery(baseOptions: Apollo.QueryHookOptions<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables> & ({ variables: DoctorPatientProfileDiagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>(DoctorPatientProfileDiagDocument, options);
      }
export function useDoctorPatientProfileDiagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>(DoctorPatientProfileDiagDocument, options);
        }
export function useDoctorPatientProfileDiagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>(DoctorPatientProfileDiagDocument, options);
        }
export type DoctorPatientProfileDiagQueryHookResult = ReturnType<typeof useDoctorPatientProfileDiagQuery>;
export type DoctorPatientProfileDiagLazyQueryHookResult = ReturnType<typeof useDoctorPatientProfileDiagLazyQuery>;
export type DoctorPatientProfileDiagSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientProfileDiagSuspenseQuery>;
export type DoctorPatientProfileDiagQueryResult = Apollo.QueryResult<DoctorPatientProfileDiagQuery, DoctorPatientProfileDiagQueryVariables>;
export const DoctorPersonalIDNumbersDocument = gql`
    query DoctorPersonalIDNumbers($pesel: String) {
  doctorPatient(pesel: $pesel) {
    pesel
  }
}
    `;

/**
 * __useDoctorPersonalIDNumbersQuery__
 *
 * To run a query within a React component, call `useDoctorPersonalIDNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPersonalIDNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPersonalIDNumbersQuery({
 *   variables: {
 *      pesel: // value for 'pesel'
 *   },
 * });
 */
export function useDoctorPersonalIDNumbersQuery(baseOptions?: Apollo.QueryHookOptions<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>(DoctorPersonalIDNumbersDocument, options);
      }
export function useDoctorPersonalIDNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>(DoctorPersonalIDNumbersDocument, options);
        }
export function useDoctorPersonalIDNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>(DoctorPersonalIDNumbersDocument, options);
        }
export type DoctorPersonalIDNumbersQueryHookResult = ReturnType<typeof useDoctorPersonalIDNumbersQuery>;
export type DoctorPersonalIDNumbersLazyQueryHookResult = ReturnType<typeof useDoctorPersonalIDNumbersLazyQuery>;
export type DoctorPersonalIDNumbersSuspenseQueryHookResult = ReturnType<typeof useDoctorPersonalIDNumbersSuspenseQuery>;
export type DoctorPersonalIDNumbersQueryResult = Apollo.QueryResult<DoctorPersonalIDNumbersQuery, DoctorPersonalIDNumbersQueryVariables>;
export const DoctorGetMySeenPostsDocument = gql`
    query DoctorGetMySeenPosts {
  doctorMe {
    id
    seenPosts
  }
}
    `;

/**
 * __useDoctorGetMySeenPostsQuery__
 *
 * To run a query within a React component, call `useDoctorGetMySeenPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetMySeenPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetMySeenPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorGetMySeenPostsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>(DoctorGetMySeenPostsDocument, options);
      }
export function useDoctorGetMySeenPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>(DoctorGetMySeenPostsDocument, options);
        }
export function useDoctorGetMySeenPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>(DoctorGetMySeenPostsDocument, options);
        }
export type DoctorGetMySeenPostsQueryHookResult = ReturnType<typeof useDoctorGetMySeenPostsQuery>;
export type DoctorGetMySeenPostsLazyQueryHookResult = ReturnType<typeof useDoctorGetMySeenPostsLazyQuery>;
export type DoctorGetMySeenPostsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetMySeenPostsSuspenseQuery>;
export type DoctorGetMySeenPostsQueryResult = Apollo.QueryResult<DoctorGetMySeenPostsQuery, DoctorGetMySeenPostsQueryVariables>;
export const DoctorScheduledVisitsDocument = gql`
    query DoctorScheduledVisits($forDay: DoctorMSDateTime!, $organizationId: String, $doctorIds: [String!]) {
  doctorScheduledVisits(
    forDay: $forDay
    organizationId: $organizationId
    doctorIds: $doctorIds
  ) {
    id
    status
    slotType
    type
    doctorId
    createdBy
    leftOn
    plannedPlace
    duration
    startOn
    showOn
    appointmentStatus
    snapshotAt
    snapshotBy
    organizationId
    ecommerceOrderIds
    sentNoShowNotifications {
      notifications {
        warnings
        cancelled
      }
      answer {
        value
        when
      }
    }
    doctor {
      id
      firstName
      lastName
      avatar
      genre
    }
    patient {
      id
      firstName
      lastName
      avatar
      pesel
      phone
      patientCardNumber
    }
    createdAt {
      iso
    }
    plannedStart {
      iso
    }
    invitationSentAt {
      iso
    }
    invitationSentBy {
      id
    }
    procedures {
      type
    }
    laboratoryExaminations {
      assignment
    }
  }
}
    `;

/**
 * __useDoctorScheduledVisitsQuery__
 *
 * To run a query within a React component, call `useDoctorScheduledVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorScheduledVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorScheduledVisitsQuery({
 *   variables: {
 *      forDay: // value for 'forDay'
 *      organizationId: // value for 'organizationId'
 *      doctorIds: // value for 'doctorIds'
 *   },
 * });
 */
export function useDoctorScheduledVisitsQuery(baseOptions: Apollo.QueryHookOptions<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables> & ({ variables: DoctorScheduledVisitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>(DoctorScheduledVisitsDocument, options);
      }
export function useDoctorScheduledVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>(DoctorScheduledVisitsDocument, options);
        }
export function useDoctorScheduledVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>(DoctorScheduledVisitsDocument, options);
        }
export type DoctorScheduledVisitsQueryHookResult = ReturnType<typeof useDoctorScheduledVisitsQuery>;
export type DoctorScheduledVisitsLazyQueryHookResult = ReturnType<typeof useDoctorScheduledVisitsLazyQuery>;
export type DoctorScheduledVisitsSuspenseQueryHookResult = ReturnType<typeof useDoctorScheduledVisitsSuspenseQuery>;
export type DoctorScheduledVisitsQueryResult = Apollo.QueryResult<DoctorScheduledVisitsQuery, DoctorScheduledVisitsQueryVariables>;
export const DoctorICD10Document = gql`
    query DoctorICD10($search: String!) {
  doctorICD10(search: $search)
}
    `;

/**
 * __useDoctorICD10Query__
 *
 * To run a query within a React component, call `useDoctorICD10Query` and pass it any options that fit your needs.
 * When your component renders, `useDoctorICD10Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorICD10Query({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDoctorICD10Query(baseOptions: Apollo.QueryHookOptions<DoctorICD10Query, DoctorICD10QueryVariables> & ({ variables: DoctorICD10QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorICD10Query, DoctorICD10QueryVariables>(DoctorICD10Document, options);
      }
export function useDoctorICD10LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorICD10Query, DoctorICD10QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorICD10Query, DoctorICD10QueryVariables>(DoctorICD10Document, options);
        }
export function useDoctorICD10SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorICD10Query, DoctorICD10QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorICD10Query, DoctorICD10QueryVariables>(DoctorICD10Document, options);
        }
export type DoctorICD10QueryHookResult = ReturnType<typeof useDoctorICD10Query>;
export type DoctorICD10LazyQueryHookResult = ReturnType<typeof useDoctorICD10LazyQuery>;
export type DoctorICD10SuspenseQueryHookResult = ReturnType<typeof useDoctorICD10SuspenseQuery>;
export type DoctorICD10QueryResult = Apollo.QueryResult<DoctorICD10Query, DoctorICD10QueryVariables>;
export const DoctorPackagesDocument = gql`
    query DoctorPackages($name: String!) {
  doctorPackages(name: $name) {
    ean
    name
    box
    form
    dosage
  }
}
    `;

/**
 * __useDoctorPackagesQuery__
 *
 * To run a query within a React component, call `useDoctorPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPackagesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDoctorPackagesQuery(baseOptions: Apollo.QueryHookOptions<DoctorPackagesQuery, DoctorPackagesQueryVariables> & ({ variables: DoctorPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPackagesQuery, DoctorPackagesQueryVariables>(DoctorPackagesDocument, options);
      }
export function useDoctorPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPackagesQuery, DoctorPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPackagesQuery, DoctorPackagesQueryVariables>(DoctorPackagesDocument, options);
        }
export function useDoctorPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPackagesQuery, DoctorPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPackagesQuery, DoctorPackagesQueryVariables>(DoctorPackagesDocument, options);
        }
export type DoctorPackagesQueryHookResult = ReturnType<typeof useDoctorPackagesQuery>;
export type DoctorPackagesLazyQueryHookResult = ReturnType<typeof useDoctorPackagesLazyQuery>;
export type DoctorPackagesSuspenseQueryHookResult = ReturnType<typeof useDoctorPackagesSuspenseQuery>;
export type DoctorPackagesQueryResult = Apollo.QueryResult<DoctorPackagesQuery, DoctorPackagesQueryVariables>;
export const DoctorGetDrugDetailsDocument = gql`
    query DoctorGetDrugDetails($ean: String!) {
  doctorGetDrugDetails(ean: $ean) {
    effect
    indications
    contraindications
    comments
    precautions
    interactions
    pregnantWomenInstructions
    hasPsychoSubstances
    activeSubstances {
      name
      unitCode
      amountPerItem
      amountPerPackage
      substanceId
    }
    name
    paymentLevels {
      value
      price
      description
      detailedDescription
      type
      paymentKey
    }
    box
    ean
    form
    dosage
    dosageDescription
    productCharacteristics
    use
    composition
  }
}
    `;

/**
 * __useDoctorGetDrugDetailsQuery__
 *
 * To run a query within a React component, call `useDoctorGetDrugDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetDrugDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetDrugDetailsQuery({
 *   variables: {
 *      ean: // value for 'ean'
 *   },
 * });
 */
export function useDoctorGetDrugDetailsQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables> & ({ variables: DoctorGetDrugDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>(DoctorGetDrugDetailsDocument, options);
      }
export function useDoctorGetDrugDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>(DoctorGetDrugDetailsDocument, options);
        }
export function useDoctorGetDrugDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>(DoctorGetDrugDetailsDocument, options);
        }
export type DoctorGetDrugDetailsQueryHookResult = ReturnType<typeof useDoctorGetDrugDetailsQuery>;
export type DoctorGetDrugDetailsLazyQueryHookResult = ReturnType<typeof useDoctorGetDrugDetailsLazyQuery>;
export type DoctorGetDrugDetailsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetDrugDetailsSuspenseQuery>;
export type DoctorGetDrugDetailsQueryResult = Apollo.QueryResult<DoctorGetDrugDetailsQuery, DoctorGetDrugDetailsQueryVariables>;
export const DoctorGetClinicsDocument = gql`
    query DoctorGetClinics {
  doctorClinics {
    id
    name
    type
    code
  }
}
    `;

/**
 * __useDoctorGetClinicsQuery__
 *
 * To run a query within a React component, call `useDoctorGetClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetClinicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorGetClinicsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>(DoctorGetClinicsDocument, options);
      }
export function useDoctorGetClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>(DoctorGetClinicsDocument, options);
        }
export function useDoctorGetClinicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>(DoctorGetClinicsDocument, options);
        }
export type DoctorGetClinicsQueryHookResult = ReturnType<typeof useDoctorGetClinicsQuery>;
export type DoctorGetClinicsLazyQueryHookResult = ReturnType<typeof useDoctorGetClinicsLazyQuery>;
export type DoctorGetClinicsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetClinicsSuspenseQuery>;
export type DoctorGetClinicsQueryResult = Apollo.QueryResult<DoctorGetClinicsQuery, DoctorGetClinicsQueryVariables>;
export const DoctorPatientMessagesDocument = gql`
    query DoctorPatientMessages($patientId: String!) {
  doctorGetMessagesForPatient(patientId: $patientId) {
    __typename
    ... on DoctorMSPrescription {
      __typename
      id
      type
      visit {
        id
      }
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      drugs {
        ean
        cost
        drug
        boxAmount
        dose
        form
        drugAmount
        interval
        quantity: package
        psychoSubstances
        activeSubstances {
          activeSubstanceDose
          activeSubstanceDoseInWords
          activeSubstanceDoseUnit
        }
        hourInterval
        morePatientInfo
        morePharmacistInfo
      }
    }
    ... on DoctorMSLeave {
      __typename
      id
      doctor {
        id
      }
      visit {
        id
      }
      type
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      reason
      leaveType
      insuredIn
      icd10Main {
        name
        icd10
      }
      inabilitySince
      inabilityUntil
      careSince
      careUntil
      doNotSendPayerInfo
      recommendation
      codes {
        A
        B
        C
        D
        E
      }
      payer {
        id
      }
      underCarePerson {
        firstName
      }
      leaves {
        seriesNumber
      }
    }
    ... on DoctorMSCareleave {
      __typename
      id
      doctor {
        id
      }
      visit {
        id
      }
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      type
      insuredIn
      icd10Main {
        name
        icd10
      }
      careSince
      careUntil
      doNotSendPayerInfo
      recommendation
      payer {
        id
      }
      underCarePerson {
        firstName
      }
      leaves {
        seriesNumber
      }
    }
    ... on DoctorMSTestimonial {
      __typename
      id
      type
      testimonialType
      data
      createdAt {
        iso
      }
      visit {
        id
      }
    }
    ... on DoctorMSReferral {
      __typename
      id
      type
      referralType
      urgent
      comment
      createdAt {
        iso
      }
      visit {
        id
      }
      icd10 {
        icd10
        name
      }
      icd9 {
        name
        icd9
      }
      clinic {
        name
      }
      referralDetails {
        code
      }
    }
    ... on DoctorMSAssignment {
      __typename
      id
      type
      assignmentType
      createdAt {
        iso
      }
      visit {
        id
      }
      updatedAt {
        iso
      }
      doctor {
        firstName
        lastName
      }
      positions {
        serviceId
        serviceName
        isNFZ
        price
        sampleId
        cancelled
      }
      visit {
        id
      }
    }
    ... on DoctorMSIpom {
      __typename
      id
      assignmentType
      data
      visitId
      type
      createdAt {
        iso
      }
    }
    ... on DoctorMSCareleave {
      __typename
      type
    }
  }
}
    `;

/**
 * __useDoctorPatientMessagesQuery__
 *
 * To run a query within a React component, call `useDoctorPatientMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientMessagesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorPatientMessagesQuery(baseOptions: Apollo.QueryHookOptions<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables> & ({ variables: DoctorPatientMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>(DoctorPatientMessagesDocument, options);
      }
export function useDoctorPatientMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>(DoctorPatientMessagesDocument, options);
        }
export function useDoctorPatientMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>(DoctorPatientMessagesDocument, options);
        }
export type DoctorPatientMessagesQueryHookResult = ReturnType<typeof useDoctorPatientMessagesQuery>;
export type DoctorPatientMessagesLazyQueryHookResult = ReturnType<typeof useDoctorPatientMessagesLazyQuery>;
export type DoctorPatientMessagesSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientMessagesSuspenseQuery>;
export type DoctorPatientMessagesQueryResult = Apollo.QueryResult<DoctorPatientMessagesQuery, DoctorPatientMessagesQueryVariables>;
export const DoctorMedicineSubtitlesTagsDocument = gql`
    query DoctorMedicineSubtitlesTags($type: DoctorMSPatientTagType!) {
  doctorMedicineSubtitles(type: $type) {
    subtitle
    type
  }
}
    `;

/**
 * __useDoctorMedicineSubtitlesTagsQuery__
 *
 * To run a query within a React component, call `useDoctorMedicineSubtitlesTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorMedicineSubtitlesTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorMedicineSubtitlesTagsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDoctorMedicineSubtitlesTagsQuery(baseOptions: Apollo.QueryHookOptions<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables> & ({ variables: DoctorMedicineSubtitlesTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>(DoctorMedicineSubtitlesTagsDocument, options);
      }
export function useDoctorMedicineSubtitlesTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>(DoctorMedicineSubtitlesTagsDocument, options);
        }
export function useDoctorMedicineSubtitlesTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>(DoctorMedicineSubtitlesTagsDocument, options);
        }
export type DoctorMedicineSubtitlesTagsQueryHookResult = ReturnType<typeof useDoctorMedicineSubtitlesTagsQuery>;
export type DoctorMedicineSubtitlesTagsLazyQueryHookResult = ReturnType<typeof useDoctorMedicineSubtitlesTagsLazyQuery>;
export type DoctorMedicineSubtitlesTagsSuspenseQueryHookResult = ReturnType<typeof useDoctorMedicineSubtitlesTagsSuspenseQuery>;
export type DoctorMedicineSubtitlesTagsQueryResult = Apollo.QueryResult<DoctorMedicineSubtitlesTagsQuery, DoctorMedicineSubtitlesTagsQueryVariables>;
export const DoctorChatMessagesDocument = gql`
    query DoctorChatMessages($patientId: String!, $createdAtGt: DoctorMSDateTime, $createdAtLt: DoctorMSDateTime, $take: Int) {
  doctorChatMessages(
    patientId: $patientId
    createdAtGt: $createdAtGt
    createdAtLt: $createdAtLt
    take: $take
  ) {
    id
    content
    authorId
    patientId
    createdAt
    updatedAt
    deletedAt
    author {
      ... on DoctorMSBaseUser {
        id
        genre
        firstName
        lastName
      }
      ... on DoctorMSPatient {
        id
        genre
        firstName
        lastName
        guardians {
          id
          firstName
          lastName
        }
      }
    }
    visit {
      id
      doctor {
        id
        firstName
        lastName
        avatar
      }
      plannedStart {
        iso
      }
      status
      doctorInterview
      duration
    }
    survey {
      formId
      data
      isFilled
    }
    prescription {
      id
      type
      visit {
        id
      }
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      resourceCancelationInCezDate
      resourceIsCompatibleWithCez
      writeup {
        iso
      }
      doctor {
        id
        firstName
        lastName
        avatar
      }
      patient {
        firstName
        lastName
        pesel
      }
      startsToWork {
        iso
      }
      endsToWork {
        iso
      }
      insuredIn
      code
      number
      prescriptionId
      options {
        in365days
        cito
        dontChange
      }
      drugs {
        cost
        drug
        boxAmount
        dose
        form
        interval
        hourInterval
        drugAmount
        interval
        quantity
        package
        psychoSubstances
        psychoSubstances
        activeSubstances {
          activeSubstanceDose
          activeSubstanceDoseInWords
          activeSubstanceDoseUnit
        }
        hourInterval
        morePatientInfo
        morePharmacistInfo
        morePatientInfo
      }
    }
    leave {
      id
      doctor {
        id
      }
      visit {
        id
      }
      type
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      reason
      leaveType
      insuredIn
      icd10Main {
        name
        icd10
      }
      inabilitySince
      inabilityUntil
      careSince
      careUntil
      doNotSendPayerInfo
      recommendation
      codes {
        A
        B
        C
        D
        E
      }
      payer {
        id
      }
      payers {
        id
        name
        firstName
        lastName
        nip
        pesel
        passportNumber
        doNotSendPayerInfo
      }
      underCarePerson {
        firstName
      }
      leaves {
        seriesNumber
        address {
          city
          country
          street
          houseNumber
          flatNumber
          zipCode
          notes
        }
        guardian {
          firstName
          lastName
          pesel
        }
      }
      __typename
    }
    careleave {
      id
      doctor {
        id
      }
      visit {
        id
      }
      createdAt {
        iso
      }
      updatedAt {
        iso
      }
      insuredIn
      icd10Main {
        name
        icd10
      }
      careSince
      careUntil
      doNotSendPayerInfo
      recommendation
      payer {
        id
      }
      payers {
        id
        name
        firstName
        lastName
        nip
        pesel
        passportNumber
        doNotSendPayerInfo
      }
      underCarePerson {
        firstName
      }
      leaves {
        seriesNumber
        address {
          city
          country
          street
          houseNumber
          flatNumber
          zipCode
          notes
        }
        guardian {
          firstName
          lastName
          pesel
        }
      }
      __typename
    }
    testimonial {
      id
      type
      testimonialType
      data
      createdAt {
        iso
      }
      visit {
        id
      }
    }
    referral {
      id
      type
      referralType
      urgent
      comment
      adviceGoal
      examinationType
      createdAt {
        iso
      }
      visit {
        id
      }
      icd10 {
        icd10
        name
      }
      icd9 {
        icd9
        name
      }
      clinic {
        name
      }
      referralDetails {
        code
      }
    }
    assignment {
      id
      type
      assignmentType
      createdAt {
        iso
      }
      visit {
        id
      }
      updatedAt {
        iso
      }
      doctor {
        firstName
        lastName
      }
      paid
      positions {
        serviceId
        serviceName
        isNFZ
        price
        sampleId
        cancelled
      }
      data
    }
  }
}
    `;

/**
 * __useDoctorChatMessagesQuery__
 *
 * To run a query within a React component, call `useDoctorChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorChatMessagesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      createdAtGt: // value for 'createdAtGt'
 *      createdAtLt: // value for 'createdAtLt'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useDoctorChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables> & ({ variables: DoctorChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>(DoctorChatMessagesDocument, options);
      }
export function useDoctorChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>(DoctorChatMessagesDocument, options);
        }
export function useDoctorChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>(DoctorChatMessagesDocument, options);
        }
export type DoctorChatMessagesQueryHookResult = ReturnType<typeof useDoctorChatMessagesQuery>;
export type DoctorChatMessagesLazyQueryHookResult = ReturnType<typeof useDoctorChatMessagesLazyQuery>;
export type DoctorChatMessagesSuspenseQueryHookResult = ReturnType<typeof useDoctorChatMessagesSuspenseQuery>;
export type DoctorChatMessagesQueryResult = Apollo.QueryResult<DoctorChatMessagesQuery, DoctorChatMessagesQueryVariables>;
export const DoctorNextPatientsDocument = gql`
    query DoctorNextPatients {
  doctorNextPatients {
    id
    firstName
    lastName
    patientPublicSince {
      iso
    }
    assistantId
    patientCardNumber
    lastChatMessage {
      authorId
      content
    }
    lastPatientMessageBlock {
      iso
    }
    currentVirtualVisit {
      innatePriority
    }
  }
}
    `;

/**
 * __useDoctorNextPatientsQuery__
 *
 * To run a query within a React component, call `useDoctorNextPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorNextPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorNextPatientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorNextPatientsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>(DoctorNextPatientsDocument, options);
      }
export function useDoctorNextPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>(DoctorNextPatientsDocument, options);
        }
export function useDoctorNextPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>(DoctorNextPatientsDocument, options);
        }
export type DoctorNextPatientsQueryHookResult = ReturnType<typeof useDoctorNextPatientsQuery>;
export type DoctorNextPatientsLazyQueryHookResult = ReturnType<typeof useDoctorNextPatientsLazyQuery>;
export type DoctorNextPatientsSuspenseQueryHookResult = ReturnType<typeof useDoctorNextPatientsSuspenseQuery>;
export type DoctorNextPatientsQueryResult = Apollo.QueryResult<DoctorNextPatientsQuery, DoctorNextPatientsQueryVariables>;
export const DoctorNextPatientDocument = gql`
    query DoctorNextPatient {
  doctorNextPatient
}
    `;

/**
 * __useDoctorNextPatientQuery__
 *
 * To run a query within a React component, call `useDoctorNextPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorNextPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorNextPatientQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorNextPatientQuery(baseOptions?: Apollo.QueryHookOptions<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>(DoctorNextPatientDocument, options);
      }
export function useDoctorNextPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>(DoctorNextPatientDocument, options);
        }
export function useDoctorNextPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>(DoctorNextPatientDocument, options);
        }
export type DoctorNextPatientQueryHookResult = ReturnType<typeof useDoctorNextPatientQuery>;
export type DoctorNextPatientLazyQueryHookResult = ReturnType<typeof useDoctorNextPatientLazyQuery>;
export type DoctorNextPatientSuspenseQueryHookResult = ReturnType<typeof useDoctorNextPatientSuspenseQuery>;
export type DoctorNextPatientQueryResult = Apollo.QueryResult<DoctorNextPatientQuery, DoctorNextPatientQueryVariables>;
export const DoctorChatMessagesContentDocument = gql`
    query DoctorChatMessagesContent($patientId: String!) {
  doctorChatMessages(patientId: $patientId) {
    id
    content
  }
}
    `;

/**
 * __useDoctorChatMessagesContentQuery__
 *
 * To run a query within a React component, call `useDoctorChatMessagesContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorChatMessagesContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorChatMessagesContentQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorChatMessagesContentQuery(baseOptions: Apollo.QueryHookOptions<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables> & ({ variables: DoctorChatMessagesContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>(DoctorChatMessagesContentDocument, options);
      }
export function useDoctorChatMessagesContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>(DoctorChatMessagesContentDocument, options);
        }
export function useDoctorChatMessagesContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>(DoctorChatMessagesContentDocument, options);
        }
export type DoctorChatMessagesContentQueryHookResult = ReturnType<typeof useDoctorChatMessagesContentQuery>;
export type DoctorChatMessagesContentLazyQueryHookResult = ReturnType<typeof useDoctorChatMessagesContentLazyQuery>;
export type DoctorChatMessagesContentSuspenseQueryHookResult = ReturnType<typeof useDoctorChatMessagesContentSuspenseQuery>;
export type DoctorChatMessagesContentQueryResult = Apollo.QueryResult<DoctorChatMessagesContentQuery, DoctorChatMessagesContentQueryVariables>;
export const DoctorProceduresDocument = gql`
    query DoctorProcedures($id: String, $patientId: String) {
  doctorProcedures(id: $id, patientId: $patientId) {
    id
    patientId
    visitId
    createdAt
    updatedAt
    type
    createdOnVisitId
    data
    chukEducation {
      cholesterol
      cholesterolLDL
      cholesterolHDL
      cholesterolNonHDL
      triglycerides
      glucose
      riskScore
      recommendations
      simpFiles
      comment
    }
    chukMeasurements {
      pressureMeasurements {
        systolicPressure
        diastolicPressure
        pulse
      }
      bodyMeasurements {
        weight
        height
        waist
      }
      comment
    }
    disinfectants {
      name
      productSeries
      expirationDate
      used
    }
    tools {
      name
      productSeries
      expirationDate
      used
    }
    drugs {
      name
      productSeries
      expirationDate
      used
    }
    bandages {
      name
      productSeries
      expirationDate
      used
    }
    measurements {
      systolicPressure
      diastolicPressure
      pulse
      resultType
    }
    vaccines {
      name
      productSeries
      expirationDate
      dose
    }
    medicalAct {
      weight
      height
      pulse
      temperature
      glycemia
      systolicPressure
      diastolicPressure
      comment
    }
    files
    createdBy
    creator {
      ... on DoctorMSBaseUser {
        id
        firstName
        lastName
      }
    }
    patient {
      id
      firstName
      lastName
    }
    dressingChange {
      place
      type
      secretion
      woundClassification
      woundHealingStatus
    }
    stitch {
      place
      woundHealingStatus
    }
    foreignBody {
      type
      comment
    }
    medication {
      name
      dosing
      injection
      cito
    }
    ekg {
      comment
      cito
    }
    education {
      comment
    }
    vaccineData {
      name
      comment
    }
    spirometry {
      diastolicTest
      comments
      examinationComments
    }
    usg {
      referralId
      description
      comment
      attachments
      service {
        foreignServiceId
        name
        type
      }
      referral {
        mainDiagnosis
        procedureName
        comment
      }
    }
    tuberculosisEducation {
      score
      riskGroup
      telemedicalConsultation
      patientEducated
    }
    patronageVisit {
      summary
      type
    }
    midwifeEducationalVisit {
      summary
      visitTopics
      pregnacyWeek
    }
    observations
    files
    cancelled
    answers {
      answer
      question
      comment
    }
  }
}
    `;

/**
 * __useDoctorProceduresQuery__
 *
 * To run a query within a React component, call `useDoctorProceduresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorProceduresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorProceduresQuery({
 *   variables: {
 *      id: // value for 'id'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorProceduresQuery(baseOptions?: Apollo.QueryHookOptions<DoctorProceduresQuery, DoctorProceduresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorProceduresQuery, DoctorProceduresQueryVariables>(DoctorProceduresDocument, options);
      }
export function useDoctorProceduresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorProceduresQuery, DoctorProceduresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorProceduresQuery, DoctorProceduresQueryVariables>(DoctorProceduresDocument, options);
        }
export function useDoctorProceduresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorProceduresQuery, DoctorProceduresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorProceduresQuery, DoctorProceduresQueryVariables>(DoctorProceduresDocument, options);
        }
export type DoctorProceduresQueryHookResult = ReturnType<typeof useDoctorProceduresQuery>;
export type DoctorProceduresLazyQueryHookResult = ReturnType<typeof useDoctorProceduresLazyQuery>;
export type DoctorProceduresSuspenseQueryHookResult = ReturnType<typeof useDoctorProceduresSuspenseQuery>;
export type DoctorProceduresQueryResult = Apollo.QueryResult<DoctorProceduresQuery, DoctorProceduresQueryVariables>;
export const DoctorLaboratoryExaminationsDocument = gql`
    query DoctorLaboratoryExaminations($ids: [String!], $patientId: String) {
  doctorLaboratoryExaminations(ids: $ids, patientId: $patientId) {
    id
    patientId
    visitId
    serviceId
    sampleId
    diagIdPosition
    createdAt
    updatedAt
    createdOnVisitId
    comment
    assignment
    cito
    executionLimit
    payment
    displayPayment
    createdBy
    cancelled
    sourceInfo {
      source
      ecommerce {
        orderId
        saleorProductId
        packetInfo {
          saleorProductId
          name
          price
          discount
          totalPrice
        }
      }
    }
    creator {
      ... on DoctorMSBaseUser {
        id
        firstName
        lastName
      }
    }
    patient {
      id
      firstName
      lastName
    }
    groupId
    paymentLog {
      id
      createdAt
      createdBy
      info {
        posPayment {
          paymentNumber
        }
        bankTransferPayment {
          moneyTransferProofFiles
        }
        customerComplaint {
          comment
        }
        employeeBenefit {
          benefit
        }
        anotherPaymentMethod {
          comment
        }
      }
      creator {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useDoctorLaboratoryExaminationsQuery__
 *
 * To run a query within a React component, call `useDoctorLaboratoryExaminationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLaboratoryExaminationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLaboratoryExaminationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorLaboratoryExaminationsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>(DoctorLaboratoryExaminationsDocument, options);
      }
export function useDoctorLaboratoryExaminationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>(DoctorLaboratoryExaminationsDocument, options);
        }
export function useDoctorLaboratoryExaminationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>(DoctorLaboratoryExaminationsDocument, options);
        }
export type DoctorLaboratoryExaminationsQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationsQuery>;
export type DoctorLaboratoryExaminationsLazyQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationsLazyQuery>;
export type DoctorLaboratoryExaminationsSuspenseQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationsSuspenseQuery>;
export type DoctorLaboratoryExaminationsQueryResult = Apollo.QueryResult<DoctorLaboratoryExaminationsQuery, DoctorLaboratoryExaminationsQueryVariables>;
export const DoctorLaboratoryExaminationDragInfoDocument = gql`
    query DoctorLaboratoryExaminationDragInfo($ids: [String!], $patientId: String) {
  doctorLaboratoryExaminations(ids: $ids, patientId: $patientId) {
    groupId
    payment
    diagIdPosition
    assignment
  }
}
    `;

/**
 * __useDoctorLaboratoryExaminationDragInfoQuery__
 *
 * To run a query within a React component, call `useDoctorLaboratoryExaminationDragInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLaboratoryExaminationDragInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLaboratoryExaminationDragInfoQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorLaboratoryExaminationDragInfoQuery(baseOptions?: Apollo.QueryHookOptions<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>(DoctorLaboratoryExaminationDragInfoDocument, options);
      }
export function useDoctorLaboratoryExaminationDragInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>(DoctorLaboratoryExaminationDragInfoDocument, options);
        }
export function useDoctorLaboratoryExaminationDragInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>(DoctorLaboratoryExaminationDragInfoDocument, options);
        }
export type DoctorLaboratoryExaminationDragInfoQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDragInfoQuery>;
export type DoctorLaboratoryExaminationDragInfoLazyQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDragInfoLazyQuery>;
export type DoctorLaboratoryExaminationDragInfoSuspenseQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDragInfoSuspenseQuery>;
export type DoctorLaboratoryExaminationDragInfoQueryResult = Apollo.QueryResult<DoctorLaboratoryExaminationDragInfoQuery, DoctorLaboratoryExaminationDragInfoQueryVariables>;
export const DoctorLaboratoryExaminationSampleDocument = gql`
    query DoctorLaboratoryExaminationSample($groupId: String) {
  doctorLaboratoryExaminations(groupId: $groupId) {
    sampleId
    assignment
  }
}
    `;

/**
 * __useDoctorLaboratoryExaminationSampleQuery__
 *
 * To run a query within a React component, call `useDoctorLaboratoryExaminationSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLaboratoryExaminationSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLaboratoryExaminationSampleQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDoctorLaboratoryExaminationSampleQuery(baseOptions?: Apollo.QueryHookOptions<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>(DoctorLaboratoryExaminationSampleDocument, options);
      }
export function useDoctorLaboratoryExaminationSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>(DoctorLaboratoryExaminationSampleDocument, options);
        }
export function useDoctorLaboratoryExaminationSampleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>(DoctorLaboratoryExaminationSampleDocument, options);
        }
export type DoctorLaboratoryExaminationSampleQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationSampleQuery>;
export type DoctorLaboratoryExaminationSampleLazyQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationSampleLazyQuery>;
export type DoctorLaboratoryExaminationSampleSuspenseQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationSampleSuspenseQuery>;
export type DoctorLaboratoryExaminationSampleQueryResult = Apollo.QueryResult<DoctorLaboratoryExaminationSampleQuery, DoctorLaboratoryExaminationSampleQueryVariables>;
export const DoctorChatMessagesGroupedByPatientIdDocument = gql`
    query DoctorChatMessagesGroupedByPatientId($authorId: String!, $forDay: DoctorMSDateTime!) {
  doctorGroupByChatMessage(authorId: $authorId, forDay: $forDay) {
    patientId
    patient {
      id
      firstName
      lastName
      pesel
      patientCardNumber
    }
  }
}
    `;

/**
 * __useDoctorChatMessagesGroupedByPatientIdQuery__
 *
 * To run a query within a React component, call `useDoctorChatMessagesGroupedByPatientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorChatMessagesGroupedByPatientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorChatMessagesGroupedByPatientIdQuery({
 *   variables: {
 *      authorId: // value for 'authorId'
 *      forDay: // value for 'forDay'
 *   },
 * });
 */
export function useDoctorChatMessagesGroupedByPatientIdQuery(baseOptions: Apollo.QueryHookOptions<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables> & ({ variables: DoctorChatMessagesGroupedByPatientIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>(DoctorChatMessagesGroupedByPatientIdDocument, options);
      }
export function useDoctorChatMessagesGroupedByPatientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>(DoctorChatMessagesGroupedByPatientIdDocument, options);
        }
export function useDoctorChatMessagesGroupedByPatientIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>(DoctorChatMessagesGroupedByPatientIdDocument, options);
        }
export type DoctorChatMessagesGroupedByPatientIdQueryHookResult = ReturnType<typeof useDoctorChatMessagesGroupedByPatientIdQuery>;
export type DoctorChatMessagesGroupedByPatientIdLazyQueryHookResult = ReturnType<typeof useDoctorChatMessagesGroupedByPatientIdLazyQuery>;
export type DoctorChatMessagesGroupedByPatientIdSuspenseQueryHookResult = ReturnType<typeof useDoctorChatMessagesGroupedByPatientIdSuspenseQuery>;
export type DoctorChatMessagesGroupedByPatientIdQueryResult = Apollo.QueryResult<DoctorChatMessagesGroupedByPatientIdQuery, DoctorChatMessagesGroupedByPatientIdQueryVariables>;
export const DoctorVisitsForPatientsDocument = gql`
    query DoctorVisitsForPatients($forDay: DoctorMSDateTime!, $patientIds: [String!]!) {
  doctorVisitsForPatients(forDay: $forDay, patientIds: $patientIds) {
    id
    patientId
    doctorDiagnosis {
      code
      grade
    }
  }
}
    `;

/**
 * __useDoctorVisitsForPatientsQuery__
 *
 * To run a query within a React component, call `useDoctorVisitsForPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorVisitsForPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorVisitsForPatientsQuery({
 *   variables: {
 *      forDay: // value for 'forDay'
 *      patientIds: // value for 'patientIds'
 *   },
 * });
 */
export function useDoctorVisitsForPatientsQuery(baseOptions: Apollo.QueryHookOptions<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables> & ({ variables: DoctorVisitsForPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>(DoctorVisitsForPatientsDocument, options);
      }
export function useDoctorVisitsForPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>(DoctorVisitsForPatientsDocument, options);
        }
export function useDoctorVisitsForPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>(DoctorVisitsForPatientsDocument, options);
        }
export type DoctorVisitsForPatientsQueryHookResult = ReturnType<typeof useDoctorVisitsForPatientsQuery>;
export type DoctorVisitsForPatientsLazyQueryHookResult = ReturnType<typeof useDoctorVisitsForPatientsLazyQuery>;
export type DoctorVisitsForPatientsSuspenseQueryHookResult = ReturnType<typeof useDoctorVisitsForPatientsSuspenseQuery>;
export type DoctorVisitsForPatientsQueryResult = Apollo.QueryResult<DoctorVisitsForPatientsQuery, DoctorVisitsForPatientsQueryVariables>;
export const DoctorGetEmployeesDocument = gql`
    query DoctorGetEmployees {
  doctorDoctors {
    id
    type: genre
    firstName
    lastName
  }
}
    `;

/**
 * __useDoctorGetEmployeesQuery__
 *
 * To run a query within a React component, call `useDoctorGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>(DoctorGetEmployeesDocument, options);
      }
export function useDoctorGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>(DoctorGetEmployeesDocument, options);
        }
export function useDoctorGetEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>(DoctorGetEmployeesDocument, options);
        }
export type DoctorGetEmployeesQueryHookResult = ReturnType<typeof useDoctorGetEmployeesQuery>;
export type DoctorGetEmployeesLazyQueryHookResult = ReturnType<typeof useDoctorGetEmployeesLazyQuery>;
export type DoctorGetEmployeesSuspenseQueryHookResult = ReturnType<typeof useDoctorGetEmployeesSuspenseQuery>;
export type DoctorGetEmployeesQueryResult = Apollo.QueryResult<DoctorGetEmployeesQuery, DoctorGetEmployeesQueryVariables>;
export const DoctorFindAddressDocument = gql`
    query DoctorFindAddress($query: String!) {
  doctorFindAddress(query: $query) {
    city
    state
    street
    zipCode
    teryt
    latitude
    longitude
    houseNumber
    municipality
  }
}
    `;

/**
 * __useDoctorFindAddressQuery__
 *
 * To run a query within a React component, call `useDoctorFindAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorFindAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorFindAddressQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDoctorFindAddressQuery(baseOptions: Apollo.QueryHookOptions<DoctorFindAddressQuery, DoctorFindAddressQueryVariables> & ({ variables: DoctorFindAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>(DoctorFindAddressDocument, options);
      }
export function useDoctorFindAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>(DoctorFindAddressDocument, options);
        }
export function useDoctorFindAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>(DoctorFindAddressDocument, options);
        }
export type DoctorFindAddressQueryHookResult = ReturnType<typeof useDoctorFindAddressQuery>;
export type DoctorFindAddressLazyQueryHookResult = ReturnType<typeof useDoctorFindAddressLazyQuery>;
export type DoctorFindAddressSuspenseQueryHookResult = ReturnType<typeof useDoctorFindAddressSuspenseQuery>;
export type DoctorFindAddressQueryResult = Apollo.QueryResult<DoctorFindAddressQuery, DoctorFindAddressQueryVariables>;
export const DoctorOrganizationsDocument = gql`
    query DoctorOrganizations {
  doctorOrganizations {
    id
    name
    displayName
    placeData {
      city
      latitude
      longtitude
    }
  }
}
    `;

/**
 * __useDoctorOrganizationsQuery__
 *
 * To run a query within a React component, call `useDoctorOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>(DoctorOrganizationsDocument, options);
      }
export function useDoctorOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>(DoctorOrganizationsDocument, options);
        }
export function useDoctorOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>(DoctorOrganizationsDocument, options);
        }
export type DoctorOrganizationsQueryHookResult = ReturnType<typeof useDoctorOrganizationsQuery>;
export type DoctorOrganizationsLazyQueryHookResult = ReturnType<typeof useDoctorOrganizationsLazyQuery>;
export type DoctorOrganizationsSuspenseQueryHookResult = ReturnType<typeof useDoctorOrganizationsSuspenseQuery>;
export type DoctorOrganizationsQueryResult = Apollo.QueryResult<DoctorOrganizationsQuery, DoctorOrganizationsQueryVariables>;
export const DoctorPatientTagsDocument = gql`
    query DoctorPatientTags($id: String, $pesel: String, $patientCardNumber: String) {
  doctorPatient(id: $id, pesel: $pesel, patientCardNumber: $patientCardNumber) {
    tags {
      id
      type
      data
    }
  }
}
    `;

/**
 * __useDoctorPatientTagsQuery__
 *
 * To run a query within a React component, call `useDoctorPatientTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pesel: // value for 'pesel'
 *      patientCardNumber: // value for 'patientCardNumber'
 *   },
 * });
 */
export function useDoctorPatientTagsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>(DoctorPatientTagsDocument, options);
      }
export function useDoctorPatientTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>(DoctorPatientTagsDocument, options);
        }
export function useDoctorPatientTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>(DoctorPatientTagsDocument, options);
        }
export type DoctorPatientTagsQueryHookResult = ReturnType<typeof useDoctorPatientTagsQuery>;
export type DoctorPatientTagsLazyQueryHookResult = ReturnType<typeof useDoctorPatientTagsLazyQuery>;
export type DoctorPatientTagsSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientTagsSuspenseQuery>;
export type DoctorPatientTagsQueryResult = Apollo.QueryResult<DoctorPatientTagsQuery, DoctorPatientTagsQueryVariables>;
export const DoctorHistoryVisitsDocument = gql`
    query DoctorHistoryVisits($patientId: String!, $take: Int, $skip: Int) {
  doctorHistoryVisits(patientId: $patientId, take: $take, skip: $skip) {
    id
    status
    memo
    isPublicVisit
    ecommerceOrderIds
    type
    organizationId
    innatePriority
    doctorId
    doctorInterview
    physicalExamination
    recommendation
    comment
    snapshotAt
    snapshotBy
    deletedAt
    startOn
    showOn
    createdBy
    leftOn
    plannedPlace
    duration
    appointmentStatus
    closedByBot
    doctor {
      id
      firstName
      lastName
      avatar
      genre
    }
    patient {
      id
      firstName
      lastName
      avatar
      pesel
      phone
      patientCardNumber
    }
    createdAt {
      iso
      local
    }
    plannedStart {
      iso
      local
    }
    laboratoryExaminations {
      visitId
      assignment
      id
    }
    procedures {
      id
      type
      displayName
      doctorDiagnosis {
        code
        grade
      }
    }
    doctorDiagnosis {
      code
      grade
    }
    invitationSentAt {
      iso
    }
    invitationSentBy {
      id
    }
  }
}
    `;

/**
 * __useDoctorHistoryVisitsQuery__
 *
 * To run a query within a React component, call `useDoctorHistoryVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorHistoryVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorHistoryVisitsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDoctorHistoryVisitsQuery(baseOptions: Apollo.QueryHookOptions<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables> & ({ variables: DoctorHistoryVisitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>(DoctorHistoryVisitsDocument, options);
      }
export function useDoctorHistoryVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>(DoctorHistoryVisitsDocument, options);
        }
export function useDoctorHistoryVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>(DoctorHistoryVisitsDocument, options);
        }
export type DoctorHistoryVisitsQueryHookResult = ReturnType<typeof useDoctorHistoryVisitsQuery>;
export type DoctorHistoryVisitsLazyQueryHookResult = ReturnType<typeof useDoctorHistoryVisitsLazyQuery>;
export type DoctorHistoryVisitsSuspenseQueryHookResult = ReturnType<typeof useDoctorHistoryVisitsSuspenseQuery>;
export type DoctorHistoryVisitsQueryResult = Apollo.QueryResult<DoctorHistoryVisitsQuery, DoctorHistoryVisitsQueryVariables>;
export const DoctorUpcomingVisitsDocument = gql`
    query DoctorUpcomingVisits($patientId: String!) {
  doctorUpcomingVisits(patientId: $patientId) {
    id
    slotType
    type
    showOn
    snapshotAt
    startOn
    status
    plannedStart {
      iso
    }
    organizationId
    createdBy
    createdAt {
      iso
    }
    duration
    patient {
      id
      patientCardNumber
    }
    doctor {
      id
      firstName
      lastName
      genre
      npwz
    }
    doctorDiagnosis {
      code
      grade
    }
    procedures {
      id
      type
    }
  }
}
    `;

/**
 * __useDoctorUpcomingVisitsQuery__
 *
 * To run a query within a React component, call `useDoctorUpcomingVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorUpcomingVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorUpcomingVisitsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorUpcomingVisitsQuery(baseOptions: Apollo.QueryHookOptions<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables> & ({ variables: DoctorUpcomingVisitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>(DoctorUpcomingVisitsDocument, options);
      }
export function useDoctorUpcomingVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>(DoctorUpcomingVisitsDocument, options);
        }
export function useDoctorUpcomingVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>(DoctorUpcomingVisitsDocument, options);
        }
export type DoctorUpcomingVisitsQueryHookResult = ReturnType<typeof useDoctorUpcomingVisitsQuery>;
export type DoctorUpcomingVisitsLazyQueryHookResult = ReturnType<typeof useDoctorUpcomingVisitsLazyQuery>;
export type DoctorUpcomingVisitsSuspenseQueryHookResult = ReturnType<typeof useDoctorUpcomingVisitsSuspenseQuery>;
export type DoctorUpcomingVisitsQueryResult = Apollo.QueryResult<DoctorUpcomingVisitsQuery, DoctorUpcomingVisitsQueryVariables>;
export const DoctorGetVisitDataForEditFormDocument = gql`
    query DoctorGetVisitDataForEditForm($id: String!) {
  doctorVisit(id: $id) {
    id
    slotType
    type
    showOn
    snapshotAt
    startOn
    status
    doctorDiagnosis {
      code
      grade
    }
    procedures {
      id
      type
    }
    plannedStart {
      iso
    }
    organizationId
    createdBy
    createdAt {
      iso
    }
    duration
    patient {
      id
      patientCardNumber
    }
    doctor {
      id
      firstName
      lastName
      genre
      npwz
    }
  }
}
    `;

/**
 * __useDoctorGetVisitDataForEditFormQuery__
 *
 * To run a query within a React component, call `useDoctorGetVisitDataForEditFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetVisitDataForEditFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetVisitDataForEditFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetVisitDataForEditFormQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables> & ({ variables: DoctorGetVisitDataForEditFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>(DoctorGetVisitDataForEditFormDocument, options);
      }
export function useDoctorGetVisitDataForEditFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>(DoctorGetVisitDataForEditFormDocument, options);
        }
export function useDoctorGetVisitDataForEditFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>(DoctorGetVisitDataForEditFormDocument, options);
        }
export type DoctorGetVisitDataForEditFormQueryHookResult = ReturnType<typeof useDoctorGetVisitDataForEditFormQuery>;
export type DoctorGetVisitDataForEditFormLazyQueryHookResult = ReturnType<typeof useDoctorGetVisitDataForEditFormLazyQuery>;
export type DoctorGetVisitDataForEditFormSuspenseQueryHookResult = ReturnType<typeof useDoctorGetVisitDataForEditFormSuspenseQuery>;
export type DoctorGetVisitDataForEditFormQueryResult = Apollo.QueryResult<DoctorGetVisitDataForEditFormQuery, DoctorGetVisitDataForEditFormQueryVariables>;
export const DoctorDraftVisitsDocument = gql`
    query DoctorDraftVisits($patientId: String!, $take: Int, $skip: Int) {
  doctorDraftVisits(patientId: $patientId, take: $take, skip: $skip) {
    id
    status
    memo
    isPublicVisit
    type
    organizationId
    innatePriority
    doctorId
    doctorInterview
    physicalExamination
    recommendation
    comment
    snapshotAt
    snapshotBy
    deletedAt
    startOn
    showOn
    createdBy
    leftOn
    plannedPlace
    duration
    appointmentStatus
    closedByBot
    doctor {
      id
      firstName
      lastName
      avatar
      genre
    }
    patient {
      id
      firstName
      lastName
      avatar
      pesel
      phone
      patientCardNumber
    }
    createdAt {
      iso
      local
    }
    plannedStart {
      iso
      local
    }
    doctorDiagnosis {
      code
      grade
    }
    doctorDiagnosis {
      code
      grade
    }
    invitationSentAt {
      iso
    }
    invitationSentBy {
      id
    }
  }
}
    `;

/**
 * __useDoctorDraftVisitsQuery__
 *
 * To run a query within a React component, call `useDoctorDraftVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorDraftVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorDraftVisitsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDoctorDraftVisitsQuery(baseOptions: Apollo.QueryHookOptions<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables> & ({ variables: DoctorDraftVisitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>(DoctorDraftVisitsDocument, options);
      }
export function useDoctorDraftVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>(DoctorDraftVisitsDocument, options);
        }
export function useDoctorDraftVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>(DoctorDraftVisitsDocument, options);
        }
export type DoctorDraftVisitsQueryHookResult = ReturnType<typeof useDoctorDraftVisitsQuery>;
export type DoctorDraftVisitsLazyQueryHookResult = ReturnType<typeof useDoctorDraftVisitsLazyQuery>;
export type DoctorDraftVisitsSuspenseQueryHookResult = ReturnType<typeof useDoctorDraftVisitsSuspenseQuery>;
export type DoctorDraftVisitsQueryResult = Apollo.QueryResult<DoctorDraftVisitsQuery, DoctorDraftVisitsQueryVariables>;
export const DoctorPrescriptionsHistoryDocument = gql`
    query DoctorPrescriptionsHistory($patientId: String!) {
  doctorGetPrescriptionsForPatient(patientId: $patientId) {
    id
    resourceCancelationInCezDate
    resourceIsCompatibleWithCez
    startsToWork {
      iso
      local
    }
    visit {
      id
      plannedPlace
    }
    endsToWork {
      iso
      local
    }
    options {
      in365days
      cito
      dontChange
    }
    doctor {
      id
      firstName
      lastName
      avatar
      genre
    }
    writeup {
      iso
    }
    drugs {
      ean
      drug
      form
      boxAmount
      drugAmount
      dose
      interval
      quantity
      package
      cost
      psychoSubstances
      activeSubstances {
        activeSubstanceDose
        activeSubstanceDoseInWords
        activeSubstanceDoseUnit
      }
      hourInterval
      morePatientInfo
      morePharmacistInfo
      recipeId
      quantityDescription
      additionalPermission
    }
  }
}
    `;

/**
 * __useDoctorPrescriptionsHistoryQuery__
 *
 * To run a query within a React component, call `useDoctorPrescriptionsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPrescriptionsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPrescriptionsHistoryQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorPrescriptionsHistoryQuery(baseOptions: Apollo.QueryHookOptions<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables> & ({ variables: DoctorPrescriptionsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>(DoctorPrescriptionsHistoryDocument, options);
      }
export function useDoctorPrescriptionsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>(DoctorPrescriptionsHistoryDocument, options);
        }
export function useDoctorPrescriptionsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>(DoctorPrescriptionsHistoryDocument, options);
        }
export type DoctorPrescriptionsHistoryQueryHookResult = ReturnType<typeof useDoctorPrescriptionsHistoryQuery>;
export type DoctorPrescriptionsHistoryLazyQueryHookResult = ReturnType<typeof useDoctorPrescriptionsHistoryLazyQuery>;
export type DoctorPrescriptionsHistorySuspenseQueryHookResult = ReturnType<typeof useDoctorPrescriptionsHistorySuspenseQuery>;
export type DoctorPrescriptionsHistoryQueryResult = Apollo.QueryResult<DoctorPrescriptionsHistoryQuery, DoctorPrescriptionsHistoryQueryVariables>;
export const DoctorGetPatientDocsDocument = gql`
    query DoctorGetPatientDocs($patientId: String!) {
  doctorGetPatientDocs(patientId: $patientId)
}
    `;

/**
 * __useDoctorGetPatientDocsQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientDocsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientDocsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientDocsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetPatientDocsQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables> & ({ variables: DoctorGetPatientDocsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>(DoctorGetPatientDocsDocument, options);
      }
export function useDoctorGetPatientDocsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>(DoctorGetPatientDocsDocument, options);
        }
export function useDoctorGetPatientDocsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>(DoctorGetPatientDocsDocument, options);
        }
export type DoctorGetPatientDocsQueryHookResult = ReturnType<typeof useDoctorGetPatientDocsQuery>;
export type DoctorGetPatientDocsLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientDocsLazyQuery>;
export type DoctorGetPatientDocsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientDocsSuspenseQuery>;
export type DoctorGetPatientDocsQueryResult = Apollo.QueryResult<DoctorGetPatientDocsQuery, DoctorGetPatientDocsQueryVariables>;
export const DoctorCheckAuthStatusDocument = gql`
    query DoctorCheckAuthStatus {
  doctorValidateToken
}
    `;

/**
 * __useDoctorCheckAuthStatusQuery__
 *
 * To run a query within a React component, call `useDoctorCheckAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorCheckAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorCheckAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useDoctorCheckAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>(DoctorCheckAuthStatusDocument, options);
      }
export function useDoctorCheckAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>(DoctorCheckAuthStatusDocument, options);
        }
export function useDoctorCheckAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>(DoctorCheckAuthStatusDocument, options);
        }
export type DoctorCheckAuthStatusQueryHookResult = ReturnType<typeof useDoctorCheckAuthStatusQuery>;
export type DoctorCheckAuthStatusLazyQueryHookResult = ReturnType<typeof useDoctorCheckAuthStatusLazyQuery>;
export type DoctorCheckAuthStatusSuspenseQueryHookResult = ReturnType<typeof useDoctorCheckAuthStatusSuspenseQuery>;
export type DoctorCheckAuthStatusQueryResult = Apollo.QueryResult<DoctorCheckAuthStatusQuery, DoctorCheckAuthStatusQueryVariables>;
export const DoctorGetDoctorFullNameDocument = gql`
    query DoctorGetDoctorFullName($id: String!) {
  doctorDoctor(id: $id) {
    firstName
    lastName
  }
}
    `;

/**
 * __useDoctorGetDoctorFullNameQuery__
 *
 * To run a query within a React component, call `useDoctorGetDoctorFullNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetDoctorFullNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetDoctorFullNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetDoctorFullNameQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables> & ({ variables: DoctorGetDoctorFullNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>(DoctorGetDoctorFullNameDocument, options);
      }
export function useDoctorGetDoctorFullNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>(DoctorGetDoctorFullNameDocument, options);
        }
export function useDoctorGetDoctorFullNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>(DoctorGetDoctorFullNameDocument, options);
        }
export type DoctorGetDoctorFullNameQueryHookResult = ReturnType<typeof useDoctorGetDoctorFullNameQuery>;
export type DoctorGetDoctorFullNameLazyQueryHookResult = ReturnType<typeof useDoctorGetDoctorFullNameLazyQuery>;
export type DoctorGetDoctorFullNameSuspenseQueryHookResult = ReturnType<typeof useDoctorGetDoctorFullNameSuspenseQuery>;
export type DoctorGetDoctorFullNameQueryResult = Apollo.QueryResult<DoctorGetDoctorFullNameQuery, DoctorGetDoctorFullNameQueryVariables>;
export const DoctorLaboratoryExaminationDiagsWithPacketsDocument = gql`
    query DoctorLaboratoryExaminationDiagsWithPackets($search: String!, $organizationId: String) {
  doctorLaboratoryExaminationDiagsWithPackets(
    search: $search
    organizationId: $organizationId
  ) {
    __typename
    ... on DoctorMSDiag {
      id
      name
      price
      isAvailableAsNFZ
      isAvailableAsNFZForNurse
      type
      commission
      orgIds
    }
    ... on DoctorMSDiagPacket {
      name
      price
      items {
        id
        name
        price
        isAvailableAsNFZ
        isAvailableAsNFZForNurse
        type
        commission
        orgIds
      }
    }
  }
}
    `;

/**
 * __useDoctorLaboratoryExaminationDiagsWithPacketsQuery__
 *
 * To run a query within a React component, call `useDoctorLaboratoryExaminationDiagsWithPacketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLaboratoryExaminationDiagsWithPacketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLaboratoryExaminationDiagsWithPacketsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDoctorLaboratoryExaminationDiagsWithPacketsQuery(baseOptions: Apollo.QueryHookOptions<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables> & ({ variables: DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>(DoctorLaboratoryExaminationDiagsWithPacketsDocument, options);
      }
export function useDoctorLaboratoryExaminationDiagsWithPacketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>(DoctorLaboratoryExaminationDiagsWithPacketsDocument, options);
        }
export function useDoctorLaboratoryExaminationDiagsWithPacketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>(DoctorLaboratoryExaminationDiagsWithPacketsDocument, options);
        }
export type DoctorLaboratoryExaminationDiagsWithPacketsQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDiagsWithPacketsQuery>;
export type DoctorLaboratoryExaminationDiagsWithPacketsLazyQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDiagsWithPacketsLazyQuery>;
export type DoctorLaboratoryExaminationDiagsWithPacketsSuspenseQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationDiagsWithPacketsSuspenseQuery>;
export type DoctorLaboratoryExaminationDiagsWithPacketsQueryResult = Apollo.QueryResult<DoctorLaboratoryExaminationDiagsWithPacketsQuery, DoctorLaboratoryExaminationDiagsWithPacketsQueryVariables>;
export const DoctorNfzHistoryDocument = gql`
    query DoctorNfzHistory($patientId: String!) {
  doctorNfzHistory(patientId: $patientId) {
    ... on DoctorMSDeclarationAcceptedEvent {
      __typename
      id
      createdAt
      vojevodship
    }
    ... on DoctorMSDeclarationNoLongerValidEvent {
      __typename
      vojevodship
      id
      createdAt
      vojevodship
      reason {
        ... on DoctorMSFacilityChangeEvent {
          __typename
          id
          vojevodship
          createdAt
          vojevodship
          info {
            ... on DoctorMSFacilityChangeInVoivodeshipEvent {
              __typename
              id
              vojevodship
              createdAt
              nfzComment
              vojevodship
            }
            ... on DoctorMSFacilityChangeOutsideVoivodeshipEvent {
              __typename
              id
              vojevodship
              createdAt
              insuranceProviderInfo
              insuranceProviderInfoUrl
              nfzComment
              vojevodship
            }
          }
        }
        ... on DoctorMSIncorrectDeclarationEvent {
          __typename
          id
          vojevodship
          createdAt
          reason
          vojevodship
        }
        ... on DoctorMSPatientDiedEvent {
          __typename
          id
          vojevodship
          createdAt
          vojevodship
        }
      }
    }
    ... on DoctorMSDeclarationRejectedEvent {
      __typename
      id
      vojevodship
      createdAt
      rejectionReason
      exactRejectionReason
      nfzComment
      vojevodship
    }
    ...DoctorDeclarationSubmitted
    ... on DoctorMSInsuranceStatusEvent {
      __typename
      id
      createdAt
      status {
        ... on DoctorMSEwusCheckEvent {
          __typename
          id
          createdAt
          event {
            ... on DoctorMSEwusGreenEvent {
              __typename
              id
              createdAt
            }
            ... on DoctorMSEwusRedEvent {
              __typename
              id
              createdAt
            }
          }
        }
        ... on DoctorMSInsuranceContributionCertificateEvent {
          __typename
          id
          createdAt
        }
        ... on DoctorMSPatientInsuranceStatementEvent {
          __typename
          id
          createdAt
          reason
        }
      }
    }
    ... on DoctorMSUnknownEvent {
      __typename
      id
      createdAt
      organizationId
      type
      data
      error
      organizationId
    }
  }
}
    ${DoctorDeclarationSubmittedFragmentDoc}`;

/**
 * __useDoctorNfzHistoryQuery__
 *
 * To run a query within a React component, call `useDoctorNfzHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorNfzHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorNfzHistoryQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorNfzHistoryQuery(baseOptions: Apollo.QueryHookOptions<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables> & ({ variables: DoctorNfzHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>(DoctorNfzHistoryDocument, options);
      }
export function useDoctorNfzHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>(DoctorNfzHistoryDocument, options);
        }
export function useDoctorNfzHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>(DoctorNfzHistoryDocument, options);
        }
export type DoctorNfzHistoryQueryHookResult = ReturnType<typeof useDoctorNfzHistoryQuery>;
export type DoctorNfzHistoryLazyQueryHookResult = ReturnType<typeof useDoctorNfzHistoryLazyQuery>;
export type DoctorNfzHistorySuspenseQueryHookResult = ReturnType<typeof useDoctorNfzHistorySuspenseQuery>;
export type DoctorNfzHistoryQueryResult = Apollo.QueryResult<DoctorNfzHistoryQuery, DoctorNfzHistoryQueryVariables>;
export const DoctorPatientInsuranceStatusDocument = gql`
    query DoctorPatientInsuranceStatus($patientId: String!) {
  doctorPatientInsuranceStatus(patientId: $patientId) {
    current {
      ...DoctorInsuranceStatusFragment
    }
    latestPositive {
      ...DoctorInsuranceStatusFragment
    }
  }
}
    ${DoctorInsuranceStatusFragmentFragmentDoc}`;

/**
 * __useDoctorPatientInsuranceStatusQuery__
 *
 * To run a query within a React component, call `useDoctorPatientInsuranceStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientInsuranceStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientInsuranceStatusQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorPatientInsuranceStatusQuery(baseOptions: Apollo.QueryHookOptions<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables> & ({ variables: DoctorPatientInsuranceStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>(DoctorPatientInsuranceStatusDocument, options);
      }
export function useDoctorPatientInsuranceStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>(DoctorPatientInsuranceStatusDocument, options);
        }
export function useDoctorPatientInsuranceStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>(DoctorPatientInsuranceStatusDocument, options);
        }
export type DoctorPatientInsuranceStatusQueryHookResult = ReturnType<typeof useDoctorPatientInsuranceStatusQuery>;
export type DoctorPatientInsuranceStatusLazyQueryHookResult = ReturnType<typeof useDoctorPatientInsuranceStatusLazyQuery>;
export type DoctorPatientInsuranceStatusSuspenseQueryHookResult = ReturnType<typeof useDoctorPatientInsuranceStatusSuspenseQuery>;
export type DoctorPatientInsuranceStatusQueryResult = Apollo.QueryResult<DoctorPatientInsuranceStatusQuery, DoctorPatientInsuranceStatusQueryVariables>;
export const DoctorPatientDeclarationHistoryDocument = gql`
    query DoctorPatientDeclarationHistory($patientId: String!) {
  doctorPatientDeclarationHistory(patientId: $patientId) {
    __typename
    ...DoctorDeclarationSubmitted
    ... on DoctorMSUnknownEvent {
      error
      data
    }
  }
}
    ${DoctorDeclarationSubmittedFragmentDoc}`;

/**
 * __useDoctorPatientDeclarationHistoryQuery__
 *
 * To run a query within a React component, call `useDoctorPatientDeclarationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPatientDeclarationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPatientDeclarationHistoryQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorPatientDeclarationHistoryQuery(baseOptions: Apollo.QueryHookOptions<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables> & ({ variables: DoctorPatientDeclarationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>(DoctorPatientDeclarationHistoryDocument, options);
      }
export function useDoctorPatientDeclarationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>(DoctorPatientDeclarationHistoryDocument, options);
        }
export function useDoctorPatientDeclarationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>(DoctorPatientDeclarationHistoryDocument, options);
        }
export type DoctorPatientDeclarationHistoryQueryHookResult = ReturnType<typeof useDoctorPatientDeclarationHistoryQuery>;
export type DoctorPatientDeclarationHistoryLazyQueryHookResult = ReturnType<typeof useDoctorPatientDeclarationHistoryLazyQuery>;
export type DoctorPatientDeclarationHistorySuspenseQueryHookResult = ReturnType<typeof useDoctorPatientDeclarationHistorySuspenseQuery>;
export type DoctorPatientDeclarationHistoryQueryResult = Apollo.QueryResult<DoctorPatientDeclarationHistoryQuery, DoctorPatientDeclarationHistoryQueryVariables>;
export const DoctorIsPatientQualifiedForChukDocument = gql`
    query DoctorIsPatientQualifiedForChuk($id: String!) {
  doctorPatient(id: $id) {
    isQualifiedToCHUK
  }
}
    `;

/**
 * __useDoctorIsPatientQualifiedForChukQuery__
 *
 * To run a query within a React component, call `useDoctorIsPatientQualifiedForChukQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorIsPatientQualifiedForChukQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorIsPatientQualifiedForChukQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorIsPatientQualifiedForChukQuery(baseOptions: Apollo.QueryHookOptions<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables> & ({ variables: DoctorIsPatientQualifiedForChukQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>(DoctorIsPatientQualifiedForChukDocument, options);
      }
export function useDoctorIsPatientQualifiedForChukLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>(DoctorIsPatientQualifiedForChukDocument, options);
        }
export function useDoctorIsPatientQualifiedForChukSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>(DoctorIsPatientQualifiedForChukDocument, options);
        }
export type DoctorIsPatientQualifiedForChukQueryHookResult = ReturnType<typeof useDoctorIsPatientQualifiedForChukQuery>;
export type DoctorIsPatientQualifiedForChukLazyQueryHookResult = ReturnType<typeof useDoctorIsPatientQualifiedForChukLazyQuery>;
export type DoctorIsPatientQualifiedForChukSuspenseQueryHookResult = ReturnType<typeof useDoctorIsPatientQualifiedForChukSuspenseQuery>;
export type DoctorIsPatientQualifiedForChukQueryResult = Apollo.QueryResult<DoctorIsPatientQualifiedForChukQuery, DoctorIsPatientQualifiedForChukQueryVariables>;
export const DoctorSendMfaSmsCodeDocument = gql`
    query DoctorSendMfaSmsCode($phone: String!, $password: String!) {
  doctorSendMfaSmsCode(password: $password, phone: $phone)
}
    `;

/**
 * __useDoctorSendMfaSmsCodeQuery__
 *
 * To run a query within a React component, call `useDoctorSendMfaSmsCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorSendMfaSmsCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorSendMfaSmsCodeQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useDoctorSendMfaSmsCodeQuery(baseOptions: Apollo.QueryHookOptions<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables> & ({ variables: DoctorSendMfaSmsCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>(DoctorSendMfaSmsCodeDocument, options);
      }
export function useDoctorSendMfaSmsCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>(DoctorSendMfaSmsCodeDocument, options);
        }
export function useDoctorSendMfaSmsCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>(DoctorSendMfaSmsCodeDocument, options);
        }
export type DoctorSendMfaSmsCodeQueryHookResult = ReturnType<typeof useDoctorSendMfaSmsCodeQuery>;
export type DoctorSendMfaSmsCodeLazyQueryHookResult = ReturnType<typeof useDoctorSendMfaSmsCodeLazyQuery>;
export type DoctorSendMfaSmsCodeSuspenseQueryHookResult = ReturnType<typeof useDoctorSendMfaSmsCodeSuspenseQuery>;
export type DoctorSendMfaSmsCodeQueryResult = Apollo.QueryResult<DoctorSendMfaSmsCodeQuery, DoctorSendMfaSmsCodeQueryVariables>;
export const DoctorAuthorizeMfaDocument = gql`
    query DoctorAuthorizeMfa($phone: String!, $mfaCode: String!) {
  doctorAuthorizeMFA(mfaCode: $mfaCode, phone: $phone) {
    jwt
    refreshToken
  }
}
    `;

/**
 * __useDoctorAuthorizeMfaQuery__
 *
 * To run a query within a React component, call `useDoctorAuthorizeMfaQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAuthorizeMfaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAuthorizeMfaQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      mfaCode: // value for 'mfaCode'
 *   },
 * });
 */
export function useDoctorAuthorizeMfaQuery(baseOptions: Apollo.QueryHookOptions<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables> & ({ variables: DoctorAuthorizeMfaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>(DoctorAuthorizeMfaDocument, options);
      }
export function useDoctorAuthorizeMfaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>(DoctorAuthorizeMfaDocument, options);
        }
export function useDoctorAuthorizeMfaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>(DoctorAuthorizeMfaDocument, options);
        }
export type DoctorAuthorizeMfaQueryHookResult = ReturnType<typeof useDoctorAuthorizeMfaQuery>;
export type DoctorAuthorizeMfaLazyQueryHookResult = ReturnType<typeof useDoctorAuthorizeMfaLazyQuery>;
export type DoctorAuthorizeMfaSuspenseQueryHookResult = ReturnType<typeof useDoctorAuthorizeMfaSuspenseQuery>;
export type DoctorAuthorizeMfaQueryResult = Apollo.QueryResult<DoctorAuthorizeMfaQuery, DoctorAuthorizeMfaQueryVariables>;
export const DoctorPopularLaboratoryExaminationPacketsDocument = gql`
    query DoctorPopularLaboratoryExaminationPackets($organizationId: String!) {
  doctorPopularLaboratoryExaminationPackets(organizationId: $organizationId) {
    name
    price
    items {
      id
      name
      price
      isAvailableAsNFZ
      isAvailableAsNFZForNurse
      type
      commission
      orgIds
    }
  }
}
    `;

/**
 * __useDoctorPopularLaboratoryExaminationPacketsQuery__
 *
 * To run a query within a React component, call `useDoctorPopularLaboratoryExaminationPacketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorPopularLaboratoryExaminationPacketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorPopularLaboratoryExaminationPacketsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDoctorPopularLaboratoryExaminationPacketsQuery(baseOptions: Apollo.QueryHookOptions<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables> & ({ variables: DoctorPopularLaboratoryExaminationPacketsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>(DoctorPopularLaboratoryExaminationPacketsDocument, options);
      }
export function useDoctorPopularLaboratoryExaminationPacketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>(DoctorPopularLaboratoryExaminationPacketsDocument, options);
        }
export function useDoctorPopularLaboratoryExaminationPacketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>(DoctorPopularLaboratoryExaminationPacketsDocument, options);
        }
export type DoctorPopularLaboratoryExaminationPacketsQueryHookResult = ReturnType<typeof useDoctorPopularLaboratoryExaminationPacketsQuery>;
export type DoctorPopularLaboratoryExaminationPacketsLazyQueryHookResult = ReturnType<typeof useDoctorPopularLaboratoryExaminationPacketsLazyQuery>;
export type DoctorPopularLaboratoryExaminationPacketsSuspenseQueryHookResult = ReturnType<typeof useDoctorPopularLaboratoryExaminationPacketsSuspenseQuery>;
export type DoctorPopularLaboratoryExaminationPacketsQueryResult = Apollo.QueryResult<DoctorPopularLaboratoryExaminationPacketsQuery, DoctorPopularLaboratoryExaminationPacketsQueryVariables>;
export const DoctorTodayComboTestDocument = gql`
    query DoctorTodayComboTest($patientId: String!) {
  doctorTodayComboTest(patientId: $patientId)
}
    `;

/**
 * __useDoctorTodayComboTestQuery__
 *
 * To run a query within a React component, call `useDoctorTodayComboTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorTodayComboTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorTodayComboTestQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorTodayComboTestQuery(baseOptions: Apollo.QueryHookOptions<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables> & ({ variables: DoctorTodayComboTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>(DoctorTodayComboTestDocument, options);
      }
export function useDoctorTodayComboTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>(DoctorTodayComboTestDocument, options);
        }
export function useDoctorTodayComboTestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>(DoctorTodayComboTestDocument, options);
        }
export type DoctorTodayComboTestQueryHookResult = ReturnType<typeof useDoctorTodayComboTestQuery>;
export type DoctorTodayComboTestLazyQueryHookResult = ReturnType<typeof useDoctorTodayComboTestLazyQuery>;
export type DoctorTodayComboTestSuspenseQueryHookResult = ReturnType<typeof useDoctorTodayComboTestSuspenseQuery>;
export type DoctorTodayComboTestQueryResult = Apollo.QueryResult<DoctorTodayComboTestQuery, DoctorTodayComboTestQueryVariables>;
export const DoctorICD9Document = gql`
    query DoctorICD9($search: String!) {
  doctorICD9(search: $search)
}
    `;

/**
 * __useDoctorICD9Query__
 *
 * To run a query within a React component, call `useDoctorICD9Query` and pass it any options that fit your needs.
 * When your component renders, `useDoctorICD9Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorICD9Query({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useDoctorICD9Query(baseOptions: Apollo.QueryHookOptions<DoctorICD9Query, DoctorICD9QueryVariables> & ({ variables: DoctorICD9QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorICD9Query, DoctorICD9QueryVariables>(DoctorICD9Document, options);
      }
export function useDoctorICD9LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorICD9Query, DoctorICD9QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorICD9Query, DoctorICD9QueryVariables>(DoctorICD9Document, options);
        }
export function useDoctorICD9SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorICD9Query, DoctorICD9QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorICD9Query, DoctorICD9QueryVariables>(DoctorICD9Document, options);
        }
export type DoctorICD9QueryHookResult = ReturnType<typeof useDoctorICD9Query>;
export type DoctorICD9LazyQueryHookResult = ReturnType<typeof useDoctorICD9LazyQuery>;
export type DoctorICD9SuspenseQueryHookResult = ReturnType<typeof useDoctorICD9SuspenseQuery>;
export type DoctorICD9QueryResult = Apollo.QueryResult<DoctorICD9Query, DoctorICD9QueryVariables>;
export const DoctorDiagnosticExaminationTemplateDocument = gql`
    query DoctorDiagnosticExaminationTemplate($visitId: String!) {
  doctorGetTemplatesForVisit(visitId: $visitId) {
    ...DoctorTemplateOfLabExam
  }
}
    ${DoctorTemplateOfLabExamFragmentDoc}`;

/**
 * __useDoctorDiagnosticExaminationTemplateQuery__
 *
 * To run a query within a React component, call `useDoctorDiagnosticExaminationTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorDiagnosticExaminationTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorDiagnosticExaminationTemplateQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDoctorDiagnosticExaminationTemplateQuery(baseOptions: Apollo.QueryHookOptions<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables> & ({ variables: DoctorDiagnosticExaminationTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>(DoctorDiagnosticExaminationTemplateDocument, options);
      }
export function useDoctorDiagnosticExaminationTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>(DoctorDiagnosticExaminationTemplateDocument, options);
        }
export function useDoctorDiagnosticExaminationTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>(DoctorDiagnosticExaminationTemplateDocument, options);
        }
export type DoctorDiagnosticExaminationTemplateQueryHookResult = ReturnType<typeof useDoctorDiagnosticExaminationTemplateQuery>;
export type DoctorDiagnosticExaminationTemplateLazyQueryHookResult = ReturnType<typeof useDoctorDiagnosticExaminationTemplateLazyQuery>;
export type DoctorDiagnosticExaminationTemplateSuspenseQueryHookResult = ReturnType<typeof useDoctorDiagnosticExaminationTemplateSuspenseQuery>;
export type DoctorDiagnosticExaminationTemplateQueryResult = Apollo.QueryResult<DoctorDiagnosticExaminationTemplateQuery, DoctorDiagnosticExaminationTemplateQueryVariables>;
export const DoctorCheckPatientExistsDocument = gql`
    query DoctorCheckPatientExists($pesel: String!, $phone: String!) {
  isPeselUsed: doctorCheckPatientExists(pesel: $pesel)
  isPhoneUsed: doctorCheckPatientExists(phone: $phone)
}
    `;

/**
 * __useDoctorCheckPatientExistsQuery__
 *
 * To run a query within a React component, call `useDoctorCheckPatientExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorCheckPatientExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorCheckPatientExistsQuery({
 *   variables: {
 *      pesel: // value for 'pesel'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useDoctorCheckPatientExistsQuery(baseOptions: Apollo.QueryHookOptions<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables> & ({ variables: DoctorCheckPatientExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>(DoctorCheckPatientExistsDocument, options);
      }
export function useDoctorCheckPatientExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>(DoctorCheckPatientExistsDocument, options);
        }
export function useDoctorCheckPatientExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>(DoctorCheckPatientExistsDocument, options);
        }
export type DoctorCheckPatientExistsQueryHookResult = ReturnType<typeof useDoctorCheckPatientExistsQuery>;
export type DoctorCheckPatientExistsLazyQueryHookResult = ReturnType<typeof useDoctorCheckPatientExistsLazyQuery>;
export type DoctorCheckPatientExistsSuspenseQueryHookResult = ReturnType<typeof useDoctorCheckPatientExistsSuspenseQuery>;
export type DoctorCheckPatientExistsQueryResult = Apollo.QueryResult<DoctorCheckPatientExistsQuery, DoctorCheckPatientExistsQueryVariables>;
export const DoctorGetP1PrescriptionsDocument = gql`
    query DoctorGetP1Prescriptions($visitId: String, $patientId: String) {
  doctorGetP1Prescriptions(visitId: $visitId, patientId: $patientId) {
    lastChecked
    prescriptions {
      drugName
      issueDate
      realizationDateFrom
      packageId
      prescriptionKey
      typeOfDrug
      prescriptionIssueStatus
      prescriptionStatus
      packageSize
      prescriptionRepaymentLevel
    }
  }
}
    `;

/**
 * __useDoctorGetP1PrescriptionsQuery__
 *
 * To run a query within a React component, call `useDoctorGetP1PrescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetP1PrescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetP1PrescriptionsQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetP1PrescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>(DoctorGetP1PrescriptionsDocument, options);
      }
export function useDoctorGetP1PrescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>(DoctorGetP1PrescriptionsDocument, options);
        }
export function useDoctorGetP1PrescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>(DoctorGetP1PrescriptionsDocument, options);
        }
export type DoctorGetP1PrescriptionsQueryHookResult = ReturnType<typeof useDoctorGetP1PrescriptionsQuery>;
export type DoctorGetP1PrescriptionsLazyQueryHookResult = ReturnType<typeof useDoctorGetP1PrescriptionsLazyQuery>;
export type DoctorGetP1PrescriptionsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetP1PrescriptionsSuspenseQuery>;
export type DoctorGetP1PrescriptionsQueryResult = Apollo.QueryResult<DoctorGetP1PrescriptionsQuery, DoctorGetP1PrescriptionsQueryVariables>;
export const DoctorCheckPrescriptionsCEZDocument = gql`
    query DoctorCheckPrescriptionsCEZ($visitId: String!) {
  doctorCheckCEZ(visitId: $visitId)
}
    `;

/**
 * __useDoctorCheckPrescriptionsCEZQuery__
 *
 * To run a query within a React component, call `useDoctorCheckPrescriptionsCEZQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorCheckPrescriptionsCEZQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorCheckPrescriptionsCEZQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDoctorCheckPrescriptionsCEZQuery(baseOptions: Apollo.QueryHookOptions<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables> & ({ variables: DoctorCheckPrescriptionsCEZQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>(DoctorCheckPrescriptionsCEZDocument, options);
      }
export function useDoctorCheckPrescriptionsCEZLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>(DoctorCheckPrescriptionsCEZDocument, options);
        }
export function useDoctorCheckPrescriptionsCEZSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>(DoctorCheckPrescriptionsCEZDocument, options);
        }
export type DoctorCheckPrescriptionsCEZQueryHookResult = ReturnType<typeof useDoctorCheckPrescriptionsCEZQuery>;
export type DoctorCheckPrescriptionsCEZLazyQueryHookResult = ReturnType<typeof useDoctorCheckPrescriptionsCEZLazyQuery>;
export type DoctorCheckPrescriptionsCEZSuspenseQueryHookResult = ReturnType<typeof useDoctorCheckPrescriptionsCEZSuspenseQuery>;
export type DoctorCheckPrescriptionsCEZQueryResult = Apollo.QueryResult<DoctorCheckPrescriptionsCEZQuery, DoctorCheckPrescriptionsCEZQueryVariables>;
export const DoctorGetProcedureRenderDocument = gql`
    query DoctorGetProcedureRender($type: DoctorMSProcedureType!, $visitId: String!, $procedureId: String) {
  doctorProcedureRender(type: $type, visitId: $visitId, procedureId: $procedureId) {
    create
    edit
    data
    schema {
      create
      edit
    }
    context
    view
  }
}
    `;

/**
 * __useDoctorGetProcedureRenderQuery__
 *
 * To run a query within a React component, call `useDoctorGetProcedureRenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetProcedureRenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetProcedureRenderQuery({
 *   variables: {
 *      type: // value for 'type'
 *      visitId: // value for 'visitId'
 *      procedureId: // value for 'procedureId'
 *   },
 * });
 */
export function useDoctorGetProcedureRenderQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables> & ({ variables: DoctorGetProcedureRenderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>(DoctorGetProcedureRenderDocument, options);
      }
export function useDoctorGetProcedureRenderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>(DoctorGetProcedureRenderDocument, options);
        }
export function useDoctorGetProcedureRenderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>(DoctorGetProcedureRenderDocument, options);
        }
export type DoctorGetProcedureRenderQueryHookResult = ReturnType<typeof useDoctorGetProcedureRenderQuery>;
export type DoctorGetProcedureRenderLazyQueryHookResult = ReturnType<typeof useDoctorGetProcedureRenderLazyQuery>;
export type DoctorGetProcedureRenderSuspenseQueryHookResult = ReturnType<typeof useDoctorGetProcedureRenderSuspenseQuery>;
export type DoctorGetProcedureRenderQueryResult = Apollo.QueryResult<DoctorGetProcedureRenderQuery, DoctorGetProcedureRenderQueryVariables>;
export const DoctorGetManyProcedureDocument = gql`
    query DoctorGetManyProcedure($visitId: String, $procedureIds: [String!]!) {
  doctorManyProceduresRender(visitId: $visitId, procedureIds: $procedureIds) {
    view
    context
    data
    edit
    create
    schema {
      create
      edit
    }
  }
}
    `;

/**
 * __useDoctorGetManyProcedureQuery__
 *
 * To run a query within a React component, call `useDoctorGetManyProcedureQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetManyProcedureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetManyProcedureQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      procedureIds: // value for 'procedureIds'
 *   },
 * });
 */
export function useDoctorGetManyProcedureQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables> & ({ variables: DoctorGetManyProcedureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>(DoctorGetManyProcedureDocument, options);
      }
export function useDoctorGetManyProcedureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>(DoctorGetManyProcedureDocument, options);
        }
export function useDoctorGetManyProcedureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>(DoctorGetManyProcedureDocument, options);
        }
export type DoctorGetManyProcedureQueryHookResult = ReturnType<typeof useDoctorGetManyProcedureQuery>;
export type DoctorGetManyProcedureLazyQueryHookResult = ReturnType<typeof useDoctorGetManyProcedureLazyQuery>;
export type DoctorGetManyProcedureSuspenseQueryHookResult = ReturnType<typeof useDoctorGetManyProcedureSuspenseQuery>;
export type DoctorGetManyProcedureQueryResult = Apollo.QueryResult<DoctorGetManyProcedureQuery, DoctorGetManyProcedureQueryVariables>;
export const DoctorGenerateDeclarationPdfQueryDocument = gql`
    query DoctorGenerateDeclarationPdfQuery($representativeId: String, $request: [DoctorMSNfzDeclarationInputPatientMultiple!]!) {
  doctorDoctorGeneratePdf(representativeId: $representativeId, request: $request)
}
    `;

/**
 * __useDoctorGenerateDeclarationPdfQueryQuery__
 *
 * To run a query within a React component, call `useDoctorGenerateDeclarationPdfQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGenerateDeclarationPdfQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGenerateDeclarationPdfQueryQuery({
 *   variables: {
 *      representativeId: // value for 'representativeId'
 *      request: // value for 'request'
 *   },
 * });
 */
export function useDoctorGenerateDeclarationPdfQueryQuery(baseOptions: Apollo.QueryHookOptions<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables> & ({ variables: DoctorGenerateDeclarationPdfQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>(DoctorGenerateDeclarationPdfQueryDocument, options);
      }
export function useDoctorGenerateDeclarationPdfQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>(DoctorGenerateDeclarationPdfQueryDocument, options);
        }
export function useDoctorGenerateDeclarationPdfQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>(DoctorGenerateDeclarationPdfQueryDocument, options);
        }
export type DoctorGenerateDeclarationPdfQueryQueryHookResult = ReturnType<typeof useDoctorGenerateDeclarationPdfQueryQuery>;
export type DoctorGenerateDeclarationPdfQueryLazyQueryHookResult = ReturnType<typeof useDoctorGenerateDeclarationPdfQueryLazyQuery>;
export type DoctorGenerateDeclarationPdfQuerySuspenseQueryHookResult = ReturnType<typeof useDoctorGenerateDeclarationPdfQuerySuspenseQuery>;
export type DoctorGenerateDeclarationPdfQueryQueryResult = Apollo.QueryResult<DoctorGenerateDeclarationPdfQueryQuery, DoctorGenerateDeclarationPdfQueryQueryVariables>;
export const DoctorLaboratoryExaminationReportDocument = gql`
    query DoctorLaboratoryExaminationReport($start: String!, $end: String!, $organizationCode: String!) {
  doctorLaboratoryExaminationReport(
    start: $start
    end: $end
    organizationCode: $organizationCode
  )
}
    `;

/**
 * __useDoctorLaboratoryExaminationReportQuery__
 *
 * To run a query within a React component, call `useDoctorLaboratoryExaminationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorLaboratoryExaminationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorLaboratoryExaminationReportQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      organizationCode: // value for 'organizationCode'
 *   },
 * });
 */
export function useDoctorLaboratoryExaminationReportQuery(baseOptions: Apollo.QueryHookOptions<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables> & ({ variables: DoctorLaboratoryExaminationReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>(DoctorLaboratoryExaminationReportDocument, options);
      }
export function useDoctorLaboratoryExaminationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>(DoctorLaboratoryExaminationReportDocument, options);
        }
export function useDoctorLaboratoryExaminationReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>(DoctorLaboratoryExaminationReportDocument, options);
        }
export type DoctorLaboratoryExaminationReportQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationReportQuery>;
export type DoctorLaboratoryExaminationReportLazyQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationReportLazyQuery>;
export type DoctorLaboratoryExaminationReportSuspenseQueryHookResult = ReturnType<typeof useDoctorLaboratoryExaminationReportSuspenseQuery>;
export type DoctorLaboratoryExaminationReportQueryResult = Apollo.QueryResult<DoctorLaboratoryExaminationReportQuery, DoctorLaboratoryExaminationReportQueryVariables>;
export const PerDayVisitsDocument = gql`
    query PerDayVisits($doctorId: String, $forDay: DoctorMSDateTime!) {
  doctorGetVisitsPerDayForDoctor(doctorId: $doctorId, forDay: $forDay) {
    id
    type
    status
    innatePriority
    plannedPlace
    isPublicVisit
    snapshotBy
    snapshotAt
    startOn
    showOn
    prescriptionRequestId
    determineIpomEligibility
    procedures {
      type
      medication {
        cito
      }
      ekg {
        comment
      }
      education {
        comment
      }
      chukMeasurements {
        comment
      }
      chukEducation {
        comment
      }
      usg {
        referral {
          procedureName
        }
      }
    }
    laboratoryExaminations {
      assignment
    }
    plannedStart {
      iso
    }
    doctor {
      id
    }
    patient {
      visitRecordingAndAnalysisAgreement
      id
      patientCardNumber
      firstName
      lastName
      phone
      pesel
      ipomCode
      avatar
      guardians {
        ...DoctorPatientGuardians
      }
      lastChatMessage {
        author {
          __typename
        }
      }
    }
  }
}
    ${DoctorPatientGuardiansFragmentDoc}`;

/**
 * __usePerDayVisitsQuery__
 *
 * To run a query within a React component, call `usePerDayVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerDayVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerDayVisitsQuery({
 *   variables: {
 *      doctorId: // value for 'doctorId'
 *      forDay: // value for 'forDay'
 *   },
 * });
 */
export function usePerDayVisitsQuery(baseOptions: Apollo.QueryHookOptions<PerDayVisitsQuery, PerDayVisitsQueryVariables> & ({ variables: PerDayVisitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PerDayVisitsQuery, PerDayVisitsQueryVariables>(PerDayVisitsDocument, options);
      }
export function usePerDayVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PerDayVisitsQuery, PerDayVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PerDayVisitsQuery, PerDayVisitsQueryVariables>(PerDayVisitsDocument, options);
        }
export function usePerDayVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PerDayVisitsQuery, PerDayVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PerDayVisitsQuery, PerDayVisitsQueryVariables>(PerDayVisitsDocument, options);
        }
export type PerDayVisitsQueryHookResult = ReturnType<typeof usePerDayVisitsQuery>;
export type PerDayVisitsLazyQueryHookResult = ReturnType<typeof usePerDayVisitsLazyQuery>;
export type PerDayVisitsSuspenseQueryHookResult = ReturnType<typeof usePerDayVisitsSuspenseQuery>;
export type PerDayVisitsQueryResult = Apollo.QueryResult<PerDayVisitsQuery, PerDayVisitsQueryVariables>;
export const DoctorsSelectDocument = gql`
    query DoctorsSelect($id: String) {
  doctorDoctors(id: $id) {
    id
    firstName
    lastName
    genre
  }
}
    `;

/**
 * __useDoctorsSelectQuery__
 *
 * To run a query within a React component, call `useDoctorsSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorsSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorsSelectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorsSelectQuery(baseOptions?: Apollo.QueryHookOptions<DoctorsSelectQuery, DoctorsSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorsSelectQuery, DoctorsSelectQueryVariables>(DoctorsSelectDocument, options);
      }
export function useDoctorsSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorsSelectQuery, DoctorsSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorsSelectQuery, DoctorsSelectQueryVariables>(DoctorsSelectDocument, options);
        }
export function useDoctorsSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorsSelectQuery, DoctorsSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorsSelectQuery, DoctorsSelectQueryVariables>(DoctorsSelectDocument, options);
        }
export type DoctorsSelectQueryHookResult = ReturnType<typeof useDoctorsSelectQuery>;
export type DoctorsSelectLazyQueryHookResult = ReturnType<typeof useDoctorsSelectLazyQuery>;
export type DoctorsSelectSuspenseQueryHookResult = ReturnType<typeof useDoctorsSelectSuspenseQuery>;
export type DoctorsSelectQueryResult = Apollo.QueryResult<DoctorsSelectQuery, DoctorsSelectQueryVariables>;
export const GetAdditionalRefundRightsWithExplanationDocument = gql`
    query GetAdditionalRefundRightsWithExplanation {
  doctorGetAdditionalRefundRightsWithExplanation
}
    `;

/**
 * __useGetAdditionalRefundRightsWithExplanationQuery__
 *
 * To run a query within a React component, call `useGetAdditionalRefundRightsWithExplanationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalRefundRightsWithExplanationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalRefundRightsWithExplanationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdditionalRefundRightsWithExplanationQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>(GetAdditionalRefundRightsWithExplanationDocument, options);
      }
export function useGetAdditionalRefundRightsWithExplanationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>(GetAdditionalRefundRightsWithExplanationDocument, options);
        }
export function useGetAdditionalRefundRightsWithExplanationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>(GetAdditionalRefundRightsWithExplanationDocument, options);
        }
export type GetAdditionalRefundRightsWithExplanationQueryHookResult = ReturnType<typeof useGetAdditionalRefundRightsWithExplanationQuery>;
export type GetAdditionalRefundRightsWithExplanationLazyQueryHookResult = ReturnType<typeof useGetAdditionalRefundRightsWithExplanationLazyQuery>;
export type GetAdditionalRefundRightsWithExplanationSuspenseQueryHookResult = ReturnType<typeof useGetAdditionalRefundRightsWithExplanationSuspenseQuery>;
export type GetAdditionalRefundRightsWithExplanationQueryResult = Apollo.QueryResult<GetAdditionalRefundRightsWithExplanationQuery, GetAdditionalRefundRightsWithExplanationQueryVariables>;
export const DoctorRegularDrugsDocument = gql`
    query DoctorRegularDrugs($patientId: String!) {
  doctorRegularDrugs(patientId: $patientId) {
    sourceTag {
      ...DoctorSourceTag
    }
    drugDetails {
      name
      box
      ean
      form
      dosage
      productCharacteristics
      use
      composition
      effect
      indications
      contraindications
      comments
      precautions
      interactions
      pregnantWomenInstructions
      hasPsychoSubstances
      isCustom
      pregnacyDetails {
        entirePregnacy {
          key
          value
        }
        firstTrimester {
          key
          value
        }
        secondTrimester {
          key
          value
        }
        thirdTrimester {
          key
          value
        }
        lactation {
          key
          value
        }
      }
      activeSubstances {
        unitCode
        amountPerItem
        amountPerPackage
        name
        substanceId
      }
      paymentLevels {
        value
        price
        description
        detailedDescription
        type
        paymentKey
      }
      additionalRefunds
    }
  }
}
    ${DoctorSourceTagFragmentDoc}`;

/**
 * __useDoctorRegularDrugsQuery__
 *
 * To run a query within a React component, call `useDoctorRegularDrugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorRegularDrugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorRegularDrugsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorRegularDrugsQuery(baseOptions: Apollo.QueryHookOptions<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables> & ({ variables: DoctorRegularDrugsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>(DoctorRegularDrugsDocument, options);
      }
export function useDoctorRegularDrugsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>(DoctorRegularDrugsDocument, options);
        }
export function useDoctorRegularDrugsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>(DoctorRegularDrugsDocument, options);
        }
export type DoctorRegularDrugsQueryHookResult = ReturnType<typeof useDoctorRegularDrugsQuery>;
export type DoctorRegularDrugsLazyQueryHookResult = ReturnType<typeof useDoctorRegularDrugsLazyQuery>;
export type DoctorRegularDrugsSuspenseQueryHookResult = ReturnType<typeof useDoctorRegularDrugsSuspenseQuery>;
export type DoctorRegularDrugsQueryResult = Apollo.QueryResult<DoctorRegularDrugsQuery, DoctorRegularDrugsQueryVariables>;
export const RecentPrescriptionsDocument = gql`
    query RecentPrescriptions($patientId: String!) {
  doctorGetPrescriptionsForPatient(patientId: $patientId) {
    id
    doctor {
      firstName
      lastName
      id
    }
    writeup {
      iso
      local
    }
    drugs {
      drug
      ean
      form
      boxAmount
      drugAmount
      dose
      interval
      quantity
      cost
      package
      psychoSubstances
      activeSubstances {
        activeSubstanceDose
        activeSubstanceDoseInWords
        activeSubstanceDoseUnit
      }
      hourInterval
      morePatientInfo
      morePharmacistInfo
      recipeId
      quantityDescription
      additionalPermission
    }
  }
}
    `;

/**
 * __useRecentPrescriptionsQuery__
 *
 * To run a query within a React component, call `useRecentPrescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentPrescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentPrescriptionsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useRecentPrescriptionsQuery(baseOptions: Apollo.QueryHookOptions<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables> & ({ variables: RecentPrescriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>(RecentPrescriptionsDocument, options);
      }
export function useRecentPrescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>(RecentPrescriptionsDocument, options);
        }
export function useRecentPrescriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>(RecentPrescriptionsDocument, options);
        }
export type RecentPrescriptionsQueryHookResult = ReturnType<typeof useRecentPrescriptionsQuery>;
export type RecentPrescriptionsLazyQueryHookResult = ReturnType<typeof useRecentPrescriptionsLazyQuery>;
export type RecentPrescriptionsSuspenseQueryHookResult = ReturnType<typeof useRecentPrescriptionsSuspenseQuery>;
export type RecentPrescriptionsQueryResult = Apollo.QueryResult<RecentPrescriptionsQuery, RecentPrescriptionsQueryVariables>;
export const StrapiGetPostsDocument = gql`
    query StrapiGetPosts($filters: StrapiPostFiltersInput, $sort: [String]) {
  strapiPosts(filters: $filters, sort: $sort) {
    data {
      id
      attributes {
        slug
        title
        excerpt
        html
        createdAt
        publishedAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useStrapiGetPostsQuery__
 *
 * To run a query within a React component, call `useStrapiGetPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrapiGetPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrapiGetPostsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useStrapiGetPostsQuery(baseOptions?: Apollo.QueryHookOptions<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>(StrapiGetPostsDocument, options);
      }
export function useStrapiGetPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>(StrapiGetPostsDocument, options);
        }
export function useStrapiGetPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>(StrapiGetPostsDocument, options);
        }
export type StrapiGetPostsQueryHookResult = ReturnType<typeof useStrapiGetPostsQuery>;
export type StrapiGetPostsLazyQueryHookResult = ReturnType<typeof useStrapiGetPostsLazyQuery>;
export type StrapiGetPostsSuspenseQueryHookResult = ReturnType<typeof useStrapiGetPostsSuspenseQuery>;
export type StrapiGetPostsQueryResult = Apollo.QueryResult<StrapiGetPostsQuery, StrapiGetPostsQueryVariables>;
export const EventSearchDocument = gql`
    query EventSearch($organizationId: String!, $periodSymbol: String!, $type: String!, $search: String) {
  doctorReports(
    organizationId: $organizationId
    periodSymbol: $periodSymbol
    type: $type
    search: $search
  ) {
    sourceId
    version
  }
}
    `;

/**
 * __useEventSearchQuery__
 *
 * To run a query within a React component, call `useEventSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      type: // value for 'type'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEventSearchQuery(baseOptions: Apollo.QueryHookOptions<EventSearchQuery, EventSearchQueryVariables> & ({ variables: EventSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSearchQuery, EventSearchQueryVariables>(EventSearchDocument, options);
      }
export function useEventSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSearchQuery, EventSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSearchQuery, EventSearchQueryVariables>(EventSearchDocument, options);
        }
export function useEventSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSearchQuery, EventSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSearchQuery, EventSearchQueryVariables>(EventSearchDocument, options);
        }
export type EventSearchQueryHookResult = ReturnType<typeof useEventSearchQuery>;
export type EventSearchLazyQueryHookResult = ReturnType<typeof useEventSearchLazyQuery>;
export type EventSearchSuspenseQueryHookResult = ReturnType<typeof useEventSearchSuspenseQuery>;
export type EventSearchQueryResult = Apollo.QueryResult<EventSearchQuery, EventSearchQueryVariables>;
export const EventSingleDocument = gql`
    query EventSingle($organizationId: String!, $periodSymbol: String!, $type: String!, $sourceId: String!, $version: String!) {
  doctorReports(
    organizationId: $organizationId
    periodSymbol: $periodSymbol
    type: $type
    sourceId: $sourceId
    version: $version
  ) {
    data
  }
}
    `;

/**
 * __useEventSingleQuery__
 *
 * To run a query within a React component, call `useEventSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventSingleQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      type: // value for 'type'
 *      sourceId: // value for 'sourceId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useEventSingleQuery(baseOptions: Apollo.QueryHookOptions<EventSingleQuery, EventSingleQueryVariables> & ({ variables: EventSingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventSingleQuery, EventSingleQueryVariables>(EventSingleDocument, options);
      }
export function useEventSingleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventSingleQuery, EventSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventSingleQuery, EventSingleQueryVariables>(EventSingleDocument, options);
        }
export function useEventSingleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventSingleQuery, EventSingleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventSingleQuery, EventSingleQueryVariables>(EventSingleDocument, options);
        }
export type EventSingleQueryHookResult = ReturnType<typeof useEventSingleQuery>;
export type EventSingleLazyQueryHookResult = ReturnType<typeof useEventSingleLazyQuery>;
export type EventSingleSuspenseQueryHookResult = ReturnType<typeof useEventSingleSuspenseQuery>;
export type EventSingleQueryResult = Apollo.QueryResult<EventSingleQuery, EventSingleQueryVariables>;
export const ReportGenerateDocument = gql`
    query ReportGenerate($organizationId: String!, $periodSymbol: String!, $version: String!) {
  doctorReportGenerate(
    version: $version
    organizationId: $organizationId
    periodSymbol: $periodSymbol
  )
}
    `;

/**
 * __useReportGenerateQuery__
 *
 * To run a query within a React component, call `useReportGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportGenerateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useReportGenerateQuery(baseOptions: Apollo.QueryHookOptions<ReportGenerateQuery, ReportGenerateQueryVariables> & ({ variables: ReportGenerateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportGenerateQuery, ReportGenerateQueryVariables>(ReportGenerateDocument, options);
      }
export function useReportGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportGenerateQuery, ReportGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportGenerateQuery, ReportGenerateQueryVariables>(ReportGenerateDocument, options);
        }
export function useReportGenerateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportGenerateQuery, ReportGenerateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportGenerateQuery, ReportGenerateQueryVariables>(ReportGenerateDocument, options);
        }
export type ReportGenerateQueryHookResult = ReturnType<typeof useReportGenerateQuery>;
export type ReportGenerateLazyQueryHookResult = ReturnType<typeof useReportGenerateLazyQuery>;
export type ReportGenerateSuspenseQueryHookResult = ReturnType<typeof useReportGenerateSuspenseQuery>;
export type ReportGenerateQueryResult = Apollo.QueryResult<ReportGenerateQuery, ReportGenerateQueryVariables>;
export const SwiadGenerateDocument = gql`
    query SwiadGenerate($organizationId: String!, $periodSymbol: String!, $version: String!) {
  doctorSwiadGenerate(
    version: $version
    organizationId: $organizationId
    periodSymbol: $periodSymbol
  )
}
    `;

/**
 * __useSwiadGenerateQuery__
 *
 * To run a query within a React component, call `useSwiadGenerateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwiadGenerateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwiadGenerateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      periodSymbol: // value for 'periodSymbol'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSwiadGenerateQuery(baseOptions: Apollo.QueryHookOptions<SwiadGenerateQuery, SwiadGenerateQueryVariables> & ({ variables: SwiadGenerateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwiadGenerateQuery, SwiadGenerateQueryVariables>(SwiadGenerateDocument, options);
      }
export function useSwiadGenerateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwiadGenerateQuery, SwiadGenerateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwiadGenerateQuery, SwiadGenerateQueryVariables>(SwiadGenerateDocument, options);
        }
export function useSwiadGenerateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwiadGenerateQuery, SwiadGenerateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwiadGenerateQuery, SwiadGenerateQueryVariables>(SwiadGenerateDocument, options);
        }
export type SwiadGenerateQueryHookResult = ReturnType<typeof useSwiadGenerateQuery>;
export type SwiadGenerateLazyQueryHookResult = ReturnType<typeof useSwiadGenerateLazyQuery>;
export type SwiadGenerateSuspenseQueryHookResult = ReturnType<typeof useSwiadGenerateSuspenseQuery>;
export type SwiadGenerateQueryResult = Apollo.QueryResult<SwiadGenerateQuery, SwiadGenerateQueryVariables>;
export const DoctorGetIpomDocument = gql`
    query DoctorGetIpom($patientId: String!) {
  doctorGetIpom(patientId: $patientId) {
    patientId
    ipomCode
    date
    levelStratification
    summary
    observations {
      name
      value
    }
    medicines {
      ean
      name
      dosage
      form
      quantity
      dose
      time
    }
    diet {
      type
    }
    nurse {
      type
    }
    otherAdvice
    scheduledDiagnosticTests {
      name
      type
      time
      timeValue
      timeUnit
      timeName
      icd9
    }
    controlVisits {
      time
      timeValue
      timeUnit
    }
    specialistVisits
  }
}
    `;

/**
 * __useDoctorGetIpomQuery__
 *
 * To run a query within a React component, call `useDoctorGetIpomQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetIpomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetIpomQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetIpomQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetIpomQuery, DoctorGetIpomQueryVariables> & ({ variables: DoctorGetIpomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>(DoctorGetIpomDocument, options);
      }
export function useDoctorGetIpomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>(DoctorGetIpomDocument, options);
        }
export function useDoctorGetIpomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>(DoctorGetIpomDocument, options);
        }
export type DoctorGetIpomQueryHookResult = ReturnType<typeof useDoctorGetIpomQuery>;
export type DoctorGetIpomLazyQueryHookResult = ReturnType<typeof useDoctorGetIpomLazyQuery>;
export type DoctorGetIpomSuspenseQueryHookResult = ReturnType<typeof useDoctorGetIpomSuspenseQuery>;
export type DoctorGetIpomQueryResult = Apollo.QueryResult<DoctorGetIpomQuery, DoctorGetIpomQueryVariables>;
export const DoctorGetIpomCodesDocument = gql`
    query DoctorGetIpomCodes($patientId: String) {
  doctorGetIpomCodes(patientId: $patientId)
}
    `;

/**
 * __useDoctorGetIpomCodesQuery__
 *
 * To run a query within a React component, call `useDoctorGetIpomCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetIpomCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetIpomCodesQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetIpomCodesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>(DoctorGetIpomCodesDocument, options);
      }
export function useDoctorGetIpomCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>(DoctorGetIpomCodesDocument, options);
        }
export function useDoctorGetIpomCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>(DoctorGetIpomCodesDocument, options);
        }
export type DoctorGetIpomCodesQueryHookResult = ReturnType<typeof useDoctorGetIpomCodesQuery>;
export type DoctorGetIpomCodesLazyQueryHookResult = ReturnType<typeof useDoctorGetIpomCodesLazyQuery>;
export type DoctorGetIpomCodesSuspenseQueryHookResult = ReturnType<typeof useDoctorGetIpomCodesSuspenseQuery>;
export type DoctorGetIpomCodesQueryResult = Apollo.QueryResult<DoctorGetIpomCodesQuery, DoctorGetIpomCodesQueryVariables>;
export const DoctorGetIpomSpecialistsDocument = gql`
    query DoctorGetIpomSpecialists($patientId: String!) {
  doctorGetIpomSpecialists(patientId: $patientId)
}
    `;

/**
 * __useDoctorGetIpomSpecialistsQuery__
 *
 * To run a query within a React component, call `useDoctorGetIpomSpecialistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetIpomSpecialistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetIpomSpecialistsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDoctorGetIpomSpecialistsQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables> & ({ variables: DoctorGetIpomSpecialistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>(DoctorGetIpomSpecialistsDocument, options);
      }
export function useDoctorGetIpomSpecialistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>(DoctorGetIpomSpecialistsDocument, options);
        }
export function useDoctorGetIpomSpecialistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>(DoctorGetIpomSpecialistsDocument, options);
        }
export type DoctorGetIpomSpecialistsQueryHookResult = ReturnType<typeof useDoctorGetIpomSpecialistsQuery>;
export type DoctorGetIpomSpecialistsLazyQueryHookResult = ReturnType<typeof useDoctorGetIpomSpecialistsLazyQuery>;
export type DoctorGetIpomSpecialistsSuspenseQueryHookResult = ReturnType<typeof useDoctorGetIpomSpecialistsSuspenseQuery>;
export type DoctorGetIpomSpecialistsQueryResult = Apollo.QueryResult<DoctorGetIpomSpecialistsQuery, DoctorGetIpomSpecialistsQueryVariables>;
export const GetNumberOfPrescriptionRequestsDocument = gql`
    query GetNumberOfPrescriptionRequests {
  doctorNumberOfPrescriptionRequests
}
    `;

/**
 * __useGetNumberOfPrescriptionRequestsQuery__
 *
 * To run a query within a React component, call `useGetNumberOfPrescriptionRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfPrescriptionRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfPrescriptionRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNumberOfPrescriptionRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>(GetNumberOfPrescriptionRequestsDocument, options);
      }
export function useGetNumberOfPrescriptionRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>(GetNumberOfPrescriptionRequestsDocument, options);
        }
export function useGetNumberOfPrescriptionRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>(GetNumberOfPrescriptionRequestsDocument, options);
        }
export type GetNumberOfPrescriptionRequestsQueryHookResult = ReturnType<typeof useGetNumberOfPrescriptionRequestsQuery>;
export type GetNumberOfPrescriptionRequestsLazyQueryHookResult = ReturnType<typeof useGetNumberOfPrescriptionRequestsLazyQuery>;
export type GetNumberOfPrescriptionRequestsSuspenseQueryHookResult = ReturnType<typeof useGetNumberOfPrescriptionRequestsSuspenseQuery>;
export type GetNumberOfPrescriptionRequestsQueryResult = Apollo.QueryResult<GetNumberOfPrescriptionRequestsQuery, GetNumberOfPrescriptionRequestsQueryVariables>;
export const DoctorAdditionalMedicalServicesDocument = gql`
    query DoctorAdditionalMedicalServices($visitId: String) {
  doctorAdditionalMedicalServices(visitId: $visitId)
}
    `;

/**
 * __useDoctorAdditionalMedicalServicesQuery__
 *
 * To run a query within a React component, call `useDoctorAdditionalMedicalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorAdditionalMedicalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorAdditionalMedicalServicesQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDoctorAdditionalMedicalServicesQuery(baseOptions?: Apollo.QueryHookOptions<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>(DoctorAdditionalMedicalServicesDocument, options);
      }
export function useDoctorAdditionalMedicalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>(DoctorAdditionalMedicalServicesDocument, options);
        }
export function useDoctorAdditionalMedicalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>(DoctorAdditionalMedicalServicesDocument, options);
        }
export type DoctorAdditionalMedicalServicesQueryHookResult = ReturnType<typeof useDoctorAdditionalMedicalServicesQuery>;
export type DoctorAdditionalMedicalServicesLazyQueryHookResult = ReturnType<typeof useDoctorAdditionalMedicalServicesLazyQuery>;
export type DoctorAdditionalMedicalServicesSuspenseQueryHookResult = ReturnType<typeof useDoctorAdditionalMedicalServicesSuspenseQuery>;
export type DoctorAdditionalMedicalServicesQueryResult = Apollo.QueryResult<DoctorAdditionalMedicalServicesQuery, DoctorAdditionalMedicalServicesQueryVariables>;
export const DoctorGetPatientCardNumberDocument = gql`
    query DoctorGetPatientCardNumber($id: String) {
  doctorPatient(id: $id) {
    id
    patientCardNumber
  }
}
    `;

/**
 * __useDoctorGetPatientCardNumberQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientCardNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientCardNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientCardNumberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDoctorGetPatientCardNumberQuery(baseOptions?: Apollo.QueryHookOptions<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>(DoctorGetPatientCardNumberDocument, options);
      }
export function useDoctorGetPatientCardNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>(DoctorGetPatientCardNumberDocument, options);
        }
export function useDoctorGetPatientCardNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>(DoctorGetPatientCardNumberDocument, options);
        }
export type DoctorGetPatientCardNumberQueryHookResult = ReturnType<typeof useDoctorGetPatientCardNumberQuery>;
export type DoctorGetPatientCardNumberLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientCardNumberLazyQuery>;
export type DoctorGetPatientCardNumberSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientCardNumberSuspenseQuery>;
export type DoctorGetPatientCardNumberQueryResult = Apollo.QueryResult<DoctorGetPatientCardNumberQuery, DoctorGetPatientCardNumberQueryVariables>;
export const EdmGetAllShiftsDocument = gql`
    query EdmGetAllShifts($input: EdmGetAllShiftsInput!) {
  edmGetAllShifts(input: $input) {
    ...EdmMedicalAppShiftWithoutVisit
  }
}
    ${EdmMedicalAppShiftWithoutVisitFragmentDoc}`;

/**
 * __useEdmGetAllShiftsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllShiftsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmGetAllShiftsQuery(baseOptions: Apollo.QueryHookOptions<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables> & ({ variables: EdmGetAllShiftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>(EdmGetAllShiftsDocument, options);
      }
export function useEdmGetAllShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>(EdmGetAllShiftsDocument, options);
        }
export function useEdmGetAllShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>(EdmGetAllShiftsDocument, options);
        }
export type EdmGetAllShiftsQueryHookResult = ReturnType<typeof useEdmGetAllShiftsQuery>;
export type EdmGetAllShiftsLazyQueryHookResult = ReturnType<typeof useEdmGetAllShiftsLazyQuery>;
export type EdmGetAllShiftsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllShiftsSuspenseQuery>;
export type EdmGetAllShiftsQueryResult = Apollo.QueryResult<EdmGetAllShiftsQuery, EdmGetAllShiftsQueryVariables>;
export const EdmGetAllDoctorsFromShiftsDocument = gql`
    query EdmGetAllDoctorsFromShifts($input: EdmGetAllDoctorsFromShiftsInput!) {
  edmGetAllDoctorsFromShiftsWithPreviousMonthResolver(input: $input) {
    id
    gender
    genre
  }
}
    `;

/**
 * __useEdmGetAllDoctorsFromShiftsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllDoctorsFromShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllDoctorsFromShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllDoctorsFromShiftsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmGetAllDoctorsFromShiftsQuery(baseOptions: Apollo.QueryHookOptions<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables> & ({ variables: EdmGetAllDoctorsFromShiftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>(EdmGetAllDoctorsFromShiftsDocument, options);
      }
export function useEdmGetAllDoctorsFromShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>(EdmGetAllDoctorsFromShiftsDocument, options);
        }
export function useEdmGetAllDoctorsFromShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>(EdmGetAllDoctorsFromShiftsDocument, options);
        }
export type EdmGetAllDoctorsFromShiftsQueryHookResult = ReturnType<typeof useEdmGetAllDoctorsFromShiftsQuery>;
export type EdmGetAllDoctorsFromShiftsLazyQueryHookResult = ReturnType<typeof useEdmGetAllDoctorsFromShiftsLazyQuery>;
export type EdmGetAllDoctorsFromShiftsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllDoctorsFromShiftsSuspenseQuery>;
export type EdmGetAllDoctorsFromShiftsQueryResult = Apollo.QueryResult<EdmGetAllDoctorsFromShiftsQuery, EdmGetAllDoctorsFromShiftsQueryVariables>;
export const EdmGetVisitTypesByGenreDocument = gql`
    query EdmGetVisitTypesByGenre($input: EdmGetVisitTypesByGenreInput!) {
  edmGetVisitTypesByGenre(input: $input)
}
    `;

/**
 * __useEdmGetVisitTypesByGenreQuery__
 *
 * To run a query within a React component, call `useEdmGetVisitTypesByGenreQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetVisitTypesByGenreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetVisitTypesByGenreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmGetVisitTypesByGenreQuery(baseOptions: Apollo.QueryHookOptions<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables> & ({ variables: EdmGetVisitTypesByGenreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>(EdmGetVisitTypesByGenreDocument, options);
      }
export function useEdmGetVisitTypesByGenreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>(EdmGetVisitTypesByGenreDocument, options);
        }
export function useEdmGetVisitTypesByGenreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>(EdmGetVisitTypesByGenreDocument, options);
        }
export type EdmGetVisitTypesByGenreQueryHookResult = ReturnType<typeof useEdmGetVisitTypesByGenreQuery>;
export type EdmGetVisitTypesByGenreLazyQueryHookResult = ReturnType<typeof useEdmGetVisitTypesByGenreLazyQuery>;
export type EdmGetVisitTypesByGenreSuspenseQueryHookResult = ReturnType<typeof useEdmGetVisitTypesByGenreSuspenseQuery>;
export type EdmGetVisitTypesByGenreQueryResult = Apollo.QueryResult<EdmGetVisitTypesByGenreQuery, EdmGetVisitTypesByGenreQueryVariables>;
export const EdmGetAllStaffWithGenreAndWorkingHoursDocument = gql`
    query EdmGetAllStaffWithGenreAndWorkingHours($input: EdmGetAllStaffWithGenreAndWorkingHoursInput!) {
  edmGetAllStaffWithGenreAndWorkingHours(input: $input) {
    medicalPerson {
      id
      name
      firstname
      lastname
      avatarUrl
      genre
      gender
      npwz
      acceptChildren
      acceptAdults
      childrenDeclarable
      adultDeclarable
      languages
      preferences {
        minAllowedChildAge
      }
    }
    workedHours {
      expectedWorkingHours
      alreadyWorkedHours
      hoursToWorkLeft
    }
  }
}
    `;

/**
 * __useEdmGetAllStaffWithGenreAndWorkingHoursQuery__
 *
 * To run a query within a React component, call `useEdmGetAllStaffWithGenreAndWorkingHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllStaffWithGenreAndWorkingHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllStaffWithGenreAndWorkingHoursQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmGetAllStaffWithGenreAndWorkingHoursQuery(baseOptions: Apollo.QueryHookOptions<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables> & ({ variables: EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>(EdmGetAllStaffWithGenreAndWorkingHoursDocument, options);
      }
export function useEdmGetAllStaffWithGenreAndWorkingHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>(EdmGetAllStaffWithGenreAndWorkingHoursDocument, options);
        }
export function useEdmGetAllStaffWithGenreAndWorkingHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>(EdmGetAllStaffWithGenreAndWorkingHoursDocument, options);
        }
export type EdmGetAllStaffWithGenreAndWorkingHoursQueryHookResult = ReturnType<typeof useEdmGetAllStaffWithGenreAndWorkingHoursQuery>;
export type EdmGetAllStaffWithGenreAndWorkingHoursLazyQueryHookResult = ReturnType<typeof useEdmGetAllStaffWithGenreAndWorkingHoursLazyQuery>;
export type EdmGetAllStaffWithGenreAndWorkingHoursSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllStaffWithGenreAndWorkingHoursSuspenseQuery>;
export type EdmGetAllStaffWithGenreAndWorkingHoursQueryResult = Apollo.QueryResult<EdmGetAllStaffWithGenreAndWorkingHoursQuery, EdmGetAllStaffWithGenreAndWorkingHoursQueryVariables>;
export const EdmGetAllNonWorkingPeriodsDocument = gql`
    query EdmGetAllNonWorkingPeriods($input: EdmGetAllNonWorkingPeriodsInput!) {
  edmGetAllNonWorkingPeriods(input: $input) {
    id
    staff {
      id
      firstname
      lastname
      gender
      genre
      npwz
      childrenDeclarable
      adultDeclarable
      acceptChildren
      acceptAdults
      adultDeclarable
      childrenDeclarable
    }
    day
    startFrom
    endedAt
    leaveType
    comment
    __typename
  }
}
    `;

/**
 * __useEdmGetAllNonWorkingPeriodsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllNonWorkingPeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllNonWorkingPeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllNonWorkingPeriodsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmGetAllNonWorkingPeriodsQuery(baseOptions: Apollo.QueryHookOptions<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables> & ({ variables: EdmGetAllNonWorkingPeriodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>(EdmGetAllNonWorkingPeriodsDocument, options);
      }
export function useEdmGetAllNonWorkingPeriodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>(EdmGetAllNonWorkingPeriodsDocument, options);
        }
export function useEdmGetAllNonWorkingPeriodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>(EdmGetAllNonWorkingPeriodsDocument, options);
        }
export type EdmGetAllNonWorkingPeriodsQueryHookResult = ReturnType<typeof useEdmGetAllNonWorkingPeriodsQuery>;
export type EdmGetAllNonWorkingPeriodsLazyQueryHookResult = ReturnType<typeof useEdmGetAllNonWorkingPeriodsLazyQuery>;
export type EdmGetAllNonWorkingPeriodsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllNonWorkingPeriodsSuspenseQuery>;
export type EdmGetAllNonWorkingPeriodsQueryResult = Apollo.QueryResult<EdmGetAllNonWorkingPeriodsQuery, EdmGetAllNonWorkingPeriodsQueryVariables>;
export const EdmGetAllVisitsForDeletedShiftsDocument = gql`
    query EdmGetAllVisitsForDeletedShifts($organizationId: String!) {
  edmGetAllVisitsForDeletedShifts(organizationId: $organizationId) {
    __typename
    id
    referenceOldVisitId
    shiftId
    state
    type
    patientId
    patient {
      id
      firstName
      lastName
      patientCardNumber
      pesel
      phone
    }
    staffId
    staff {
      id
      firstname
      lastname
      gender
      genre
      npwz
      childrenDeclarable
      adultDeclarable
      acceptAdults
      acceptChildren
      adultDeclarable
      childrenDeclarable
    }
    estimatedDurationTime
    createdAt
    scheduledOn
    organizationId
    cancelledAt
    cancelledReason
    startedAt
    closedAt
    patientLeftAt
    cancellationComment
  }
}
    `;

/**
 * __useEdmGetAllVisitsForDeletedShiftsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllVisitsForDeletedShiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllVisitsForDeletedShiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllVisitsForDeletedShiftsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEdmGetAllVisitsForDeletedShiftsQuery(baseOptions: Apollo.QueryHookOptions<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables> & ({ variables: EdmGetAllVisitsForDeletedShiftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>(EdmGetAllVisitsForDeletedShiftsDocument, options);
      }
export function useEdmGetAllVisitsForDeletedShiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>(EdmGetAllVisitsForDeletedShiftsDocument, options);
        }
export function useEdmGetAllVisitsForDeletedShiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>(EdmGetAllVisitsForDeletedShiftsDocument, options);
        }
export type EdmGetAllVisitsForDeletedShiftsQueryHookResult = ReturnType<typeof useEdmGetAllVisitsForDeletedShiftsQuery>;
export type EdmGetAllVisitsForDeletedShiftsLazyQueryHookResult = ReturnType<typeof useEdmGetAllVisitsForDeletedShiftsLazyQuery>;
export type EdmGetAllVisitsForDeletedShiftsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllVisitsForDeletedShiftsSuspenseQuery>;
export type EdmGetAllVisitsForDeletedShiftsQueryResult = Apollo.QueryResult<EdmGetAllVisitsForDeletedShiftsQuery, EdmGetAllVisitsForDeletedShiftsQueryVariables>;
export const DoctorArchivedVisitListDocument = gql`
    query DoctorArchivedVisitList($pageSize: Int!, $page: Int!, $filters: DoctorMSVisitFilterInput) {
  doctorArchivedVisitList(pageSize: $pageSize, page: $page, filters: $filters) {
    totalPages
    currentPage
    visits {
      id
      status
      primaryMedicalService
      additionalMedicalService
      doctorDiagnosis {
        code
        grade
      }
      plannedStart {
        iso
      }
      updatedAt {
        iso
      }
      patient {
        patientCardNumber
        pesel
      }
      doctor {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useDoctorArchivedVisitListQuery__
 *
 * To run a query within a React component, call `useDoctorArchivedVisitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorArchivedVisitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorArchivedVisitListQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDoctorArchivedVisitListQuery(baseOptions: Apollo.QueryHookOptions<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables> & ({ variables: DoctorArchivedVisitListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>(DoctorArchivedVisitListDocument, options);
      }
export function useDoctorArchivedVisitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>(DoctorArchivedVisitListDocument, options);
        }
export function useDoctorArchivedVisitListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>(DoctorArchivedVisitListDocument, options);
        }
export type DoctorArchivedVisitListQueryHookResult = ReturnType<typeof useDoctorArchivedVisitListQuery>;
export type DoctorArchivedVisitListLazyQueryHookResult = ReturnType<typeof useDoctorArchivedVisitListLazyQuery>;
export type DoctorArchivedVisitListSuspenseQueryHookResult = ReturnType<typeof useDoctorArchivedVisitListSuspenseQuery>;
export type DoctorArchivedVisitListQueryResult = Apollo.QueryResult<DoctorArchivedVisitListQuery, DoctorArchivedVisitListQueryVariables>;
export const EdmGetAllSnippetsDocument = gql`
    query EdmGetAllSnippets($showAllFilter: Boolean) {
  edmGetAllSnippets(filters: {showAllFilter: $showAllFilter}) {
    id
    category
    content
    counter
    name
    createdBy
    createdAt
    updatedAt
    type
    visibility
    tags {
      id
      name
    }
  }
}
    `;

/**
 * __useEdmGetAllSnippetsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllSnippetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllSnippetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllSnippetsQuery({
 *   variables: {
 *      showAllFilter: // value for 'showAllFilter'
 *   },
 * });
 */
export function useEdmGetAllSnippetsQuery(baseOptions?: Apollo.QueryHookOptions<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>(EdmGetAllSnippetsDocument, options);
      }
export function useEdmGetAllSnippetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>(EdmGetAllSnippetsDocument, options);
        }
export function useEdmGetAllSnippetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>(EdmGetAllSnippetsDocument, options);
        }
export type EdmGetAllSnippetsQueryHookResult = ReturnType<typeof useEdmGetAllSnippetsQuery>;
export type EdmGetAllSnippetsLazyQueryHookResult = ReturnType<typeof useEdmGetAllSnippetsLazyQuery>;
export type EdmGetAllSnippetsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllSnippetsSuspenseQuery>;
export type EdmGetAllSnippetsQueryResult = Apollo.QueryResult<EdmGetAllSnippetsQuery, EdmGetAllSnippetsQueryVariables>;
export const EdmGetAllSnippetTagsDocument = gql`
    query EdmGetAllSnippetTags {
  edmGetAllSnippetTags {
    id
    name
  }
}
    `;

/**
 * __useEdmGetAllSnippetTagsQuery__
 *
 * To run a query within a React component, call `useEdmGetAllSnippetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetAllSnippetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetAllSnippetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEdmGetAllSnippetTagsQuery(baseOptions?: Apollo.QueryHookOptions<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>(EdmGetAllSnippetTagsDocument, options);
      }
export function useEdmGetAllSnippetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>(EdmGetAllSnippetTagsDocument, options);
        }
export function useEdmGetAllSnippetTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>(EdmGetAllSnippetTagsDocument, options);
        }
export type EdmGetAllSnippetTagsQueryHookResult = ReturnType<typeof useEdmGetAllSnippetTagsQuery>;
export type EdmGetAllSnippetTagsLazyQueryHookResult = ReturnType<typeof useEdmGetAllSnippetTagsLazyQuery>;
export type EdmGetAllSnippetTagsSuspenseQueryHookResult = ReturnType<typeof useEdmGetAllSnippetTagsSuspenseQuery>;
export type EdmGetAllSnippetTagsQueryResult = Apollo.QueryResult<EdmGetAllSnippetTagsQuery, EdmGetAllSnippetTagsQueryVariables>;
export const DoctorGetPatientLeaveHistoryByPeselDocument = gql`
    query DoctorGetPatientLeaveHistoryByPesel($input: DoctorMSGetMedicalLeavesInput!) {
  doctorGetZusMedicalLeaves(input: $input) {
    id
    insuredPersonPesel
    insuredPersonFirstName
    insuredPersonLastName
    incapacityStartDate
    incapacityEndDate
    hospitalizationDaysCount
    payerIdentifier
    payerIdentifierType
    statisticalDiseaseNumber
    doctorNpwz
    doctorFirstName
    doctorLastName
    leaveStatus
    leaveIssueDate
    leaveSeries
    leaveNumber
    relationshipCode
  }
}
    `;

/**
 * __useDoctorGetPatientLeaveHistoryByPeselQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientLeaveHistoryByPeselQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientLeaveHistoryByPeselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientLeaveHistoryByPeselQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorGetPatientLeaveHistoryByPeselQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables> & ({ variables: DoctorGetPatientLeaveHistoryByPeselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>(DoctorGetPatientLeaveHistoryByPeselDocument, options);
      }
export function useDoctorGetPatientLeaveHistoryByPeselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>(DoctorGetPatientLeaveHistoryByPeselDocument, options);
        }
export function useDoctorGetPatientLeaveHistoryByPeselSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>(DoctorGetPatientLeaveHistoryByPeselDocument, options);
        }
export type DoctorGetPatientLeaveHistoryByPeselQueryHookResult = ReturnType<typeof useDoctorGetPatientLeaveHistoryByPeselQuery>;
export type DoctorGetPatientLeaveHistoryByPeselLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientLeaveHistoryByPeselLazyQuery>;
export type DoctorGetPatientLeaveHistoryByPeselSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientLeaveHistoryByPeselSuspenseQuery>;
export type DoctorGetPatientLeaveHistoryByPeselQueryResult = Apollo.QueryResult<DoctorGetPatientLeaveHistoryByPeselQuery, DoctorGetPatientLeaveHistoryByPeselQueryVariables>;
export const DoctorGetPatientPayersByPeselDocument = gql`
    query DoctorGetPatientPayersByPesel($input: DoctorMSGetZusPayersInput!) {
  doctorGetZusPayers(input: $input) {
    id
    name
    firstName
    lastName
    nip
    pesel
    passportNumber
    pueProfile
  }
}
    `;

/**
 * __useDoctorGetPatientPayersByPeselQuery__
 *
 * To run a query within a React component, call `useDoctorGetPatientPayersByPeselQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoctorGetPatientPayersByPeselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoctorGetPatientPayersByPeselQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoctorGetPatientPayersByPeselQuery(baseOptions: Apollo.QueryHookOptions<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables> & ({ variables: DoctorGetPatientPayersByPeselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>(DoctorGetPatientPayersByPeselDocument, options);
      }
export function useDoctorGetPatientPayersByPeselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>(DoctorGetPatientPayersByPeselDocument, options);
        }
export function useDoctorGetPatientPayersByPeselSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>(DoctorGetPatientPayersByPeselDocument, options);
        }
export type DoctorGetPatientPayersByPeselQueryHookResult = ReturnType<typeof useDoctorGetPatientPayersByPeselQuery>;
export type DoctorGetPatientPayersByPeselLazyQueryHookResult = ReturnType<typeof useDoctorGetPatientPayersByPeselLazyQuery>;
export type DoctorGetPatientPayersByPeselSuspenseQueryHookResult = ReturnType<typeof useDoctorGetPatientPayersByPeselSuspenseQuery>;
export type DoctorGetPatientPayersByPeselQueryResult = Apollo.QueryResult<DoctorGetPatientPayersByPeselQuery, DoctorGetPatientPayersByPeselQueryVariables>;
export const ZusGetPayerDataDocument = gql`
    query ZusGetPayerData($nip: String!, $staffId: String!) {
  zusGetPayerData(nip: $nip, staffId: $staffId) {
    result {
      errorCode
      errorMessage
    }
    payerData {
      name
      firstName
      lastName
      hasPueProfile
    }
  }
}
    `;

/**
 * __useZusGetPayerDataQuery__
 *
 * To run a query within a React component, call `useZusGetPayerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useZusGetPayerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZusGetPayerDataQuery({
 *   variables: {
 *      nip: // value for 'nip'
 *      staffId: // value for 'staffId'
 *   },
 * });
 */
export function useZusGetPayerDataQuery(baseOptions: Apollo.QueryHookOptions<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables> & ({ variables: ZusGetPayerDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>(ZusGetPayerDataDocument, options);
      }
export function useZusGetPayerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>(ZusGetPayerDataDocument, options);
        }
export function useZusGetPayerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>(ZusGetPayerDataDocument, options);
        }
export type ZusGetPayerDataQueryHookResult = ReturnType<typeof useZusGetPayerDataQuery>;
export type ZusGetPayerDataLazyQueryHookResult = ReturnType<typeof useZusGetPayerDataLazyQuery>;
export type ZusGetPayerDataSuspenseQueryHookResult = ReturnType<typeof useZusGetPayerDataSuspenseQuery>;
export type ZusGetPayerDataQueryResult = Apollo.QueryResult<ZusGetPayerDataQuery, ZusGetPayerDataQueryVariables>;
export const EdmSearchAvailabilityDocument = gql`
    query EdmSearchAvailability($input: EdmShiftSearchAvailabilityInput!) {
  edmSearchAvailability(input: $input) {
    medicalPeople {
      id
      firstname
      lastname
      languages
    }
    dates
  }
}
    `;

/**
 * __useEdmSearchAvailabilityQuery__
 *
 * To run a query within a React component, call `useEdmSearchAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmSearchAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmSearchAvailabilityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmSearchAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables> & ({ variables: EdmSearchAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>(EdmSearchAvailabilityDocument, options);
      }
export function useEdmSearchAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>(EdmSearchAvailabilityDocument, options);
        }
export function useEdmSearchAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>(EdmSearchAvailabilityDocument, options);
        }
export type EdmSearchAvailabilityQueryHookResult = ReturnType<typeof useEdmSearchAvailabilityQuery>;
export type EdmSearchAvailabilityLazyQueryHookResult = ReturnType<typeof useEdmSearchAvailabilityLazyQuery>;
export type EdmSearchAvailabilitySuspenseQueryHookResult = ReturnType<typeof useEdmSearchAvailabilitySuspenseQuery>;
export type EdmSearchAvailabilityQueryResult = Apollo.QueryResult<EdmSearchAvailabilityQuery, EdmSearchAvailabilityQueryVariables>;
export const EdmSearchAvailabilityForDayDocument = gql`
    query EdmSearchAvailabilityForDay($input: EdmShiftSearchAvailabilityForDayInput!) {
  edmSearchAvailabilityForDay(input: $input) {
    shifts {
      id
      version
      staffId
    }
    from
    to
  }
}
    `;

/**
 * __useEdmSearchAvailabilityForDayQuery__
 *
 * To run a query within a React component, call `useEdmSearchAvailabilityForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmSearchAvailabilityForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmSearchAvailabilityForDayQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEdmSearchAvailabilityForDayQuery(baseOptions: Apollo.QueryHookOptions<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables> & ({ variables: EdmSearchAvailabilityForDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>(EdmSearchAvailabilityForDayDocument, options);
      }
export function useEdmSearchAvailabilityForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>(EdmSearchAvailabilityForDayDocument, options);
        }
export function useEdmSearchAvailabilityForDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>(EdmSearchAvailabilityForDayDocument, options);
        }
export type EdmSearchAvailabilityForDayQueryHookResult = ReturnType<typeof useEdmSearchAvailabilityForDayQuery>;
export type EdmSearchAvailabilityForDayLazyQueryHookResult = ReturnType<typeof useEdmSearchAvailabilityForDayLazyQuery>;
export type EdmSearchAvailabilityForDaySuspenseQueryHookResult = ReturnType<typeof useEdmSearchAvailabilityForDaySuspenseQuery>;
export type EdmSearchAvailabilityForDayQueryResult = Apollo.QueryResult<EdmSearchAvailabilityForDayQuery, EdmSearchAvailabilityForDayQueryVariables>;
export const EdmGetStaffVisitDurationDocument = gql`
    query EdmGetStaffVisitDuration($staffId: String!) {
  edmGetStaffVisitDuration(staffId: $staffId) {
    IN_PERSON
    TELEMEDICAL
    DOCTOR_TELEMEDICAL_INFECTION
    NURSE_IN_PERSON_INFECTION
    PROCEDURE
    COLLECTION
    RADIOLOGY_APPOINTMENT
    SPECIALIST
    PRESCRIPTION_APPOINTMENT
    EXPRESS_APPOINTMENT
    DOCTOR_HOUSE_CALL
    NURSE_HOUSE_CALL
    MIDWIFE_HOUSE_CALL
    MIDWIFE_IN_PERSON
    HEALTHY_CHILDREN_CHECKUP_AND_VACCINE
    HEALTHY_CHILDREN_CHECKUP
    HEALTHY_CHILDREN_VACCINE
    HEALTHY_CHILDREN_PATRONAGE
    NURSE_IN_PERSON
    NURSE_HEALTHY_CHILDREN
  }
}
    `;

/**
 * __useEdmGetStaffVisitDurationQuery__
 *
 * To run a query within a React component, call `useEdmGetStaffVisitDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetStaffVisitDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetStaffVisitDurationQuery({
 *   variables: {
 *      staffId: // value for 'staffId'
 *   },
 * });
 */
export function useEdmGetStaffVisitDurationQuery(baseOptions: Apollo.QueryHookOptions<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables> & ({ variables: EdmGetStaffVisitDurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>(EdmGetStaffVisitDurationDocument, options);
      }
export function useEdmGetStaffVisitDurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>(EdmGetStaffVisitDurationDocument, options);
        }
export function useEdmGetStaffVisitDurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>(EdmGetStaffVisitDurationDocument, options);
        }
export type EdmGetStaffVisitDurationQueryHookResult = ReturnType<typeof useEdmGetStaffVisitDurationQuery>;
export type EdmGetStaffVisitDurationLazyQueryHookResult = ReturnType<typeof useEdmGetStaffVisitDurationLazyQuery>;
export type EdmGetStaffVisitDurationSuspenseQueryHookResult = ReturnType<typeof useEdmGetStaffVisitDurationSuspenseQuery>;
export type EdmGetStaffVisitDurationQueryResult = Apollo.QueryResult<EdmGetStaffVisitDurationQuery, EdmGetStaffVisitDurationQueryVariables>;
export const EdmGetDefaultVisitDurationDocument = gql`
    query EdmGetDefaultVisitDuration {
  edmGetDefaultVisitDuration {
    IN_PERSON
    TELEMEDICAL
    DOCTOR_TELEMEDICAL_INFECTION
    NURSE_IN_PERSON_INFECTION
    PROCEDURE
    COLLECTION
    RADIOLOGY_APPOINTMENT
    SPECIALIST
    PRESCRIPTION_APPOINTMENT
    EXPRESS_APPOINTMENT
    DOCTOR_HOUSE_CALL
    NURSE_HOUSE_CALL
    MIDWIFE_HOUSE_CALL
    MIDWIFE_IN_PERSON
    HEALTHY_CHILDREN_CHECKUP_AND_VACCINE
    HEALTHY_CHILDREN_CHECKUP
    HEALTHY_CHILDREN_VACCINE
    HEALTHY_CHILDREN_PATRONAGE
    NURSE_IN_PERSON
    NURSE_HEALTHY_CHILDREN
  }
}
    `;

/**
 * __useEdmGetDefaultVisitDurationQuery__
 *
 * To run a query within a React component, call `useEdmGetDefaultVisitDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdmGetDefaultVisitDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdmGetDefaultVisitDurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEdmGetDefaultVisitDurationQuery(baseOptions?: Apollo.QueryHookOptions<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>(EdmGetDefaultVisitDurationDocument, options);
      }
export function useEdmGetDefaultVisitDurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>(EdmGetDefaultVisitDurationDocument, options);
        }
export function useEdmGetDefaultVisitDurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>(EdmGetDefaultVisitDurationDocument, options);
        }
export type EdmGetDefaultVisitDurationQueryHookResult = ReturnType<typeof useEdmGetDefaultVisitDurationQuery>;
export type EdmGetDefaultVisitDurationLazyQueryHookResult = ReturnType<typeof useEdmGetDefaultVisitDurationLazyQuery>;
export type EdmGetDefaultVisitDurationSuspenseQueryHookResult = ReturnType<typeof useEdmGetDefaultVisitDurationSuspenseQuery>;
export type EdmGetDefaultVisitDurationQueryResult = Apollo.QueryResult<EdmGetDefaultVisitDurationQuery, EdmGetDefaultVisitDurationQueryVariables>;